const prefix = "fass";
const fa0 = {
  prefix: 'fass',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z"]
};
const fa1 = {
  prefix: 'fass',
  iconName: '1',
  icon: [256, 512, [], "31", "M104 32l8 0 16 0 32 0 0 32 0 352 64 0 32 0 0 64-32 0-96 0-96 0L0 480l0-64 32 0 64 0 0-307.2L7.1 156.2 0 160 0 87.5 96.9 35.8 104 32z"]
};
const fa2 = {
  prefix: 'fass',
  iconName: '2',
  icon: [320, 512, [], "32", "M142.9 32C104.4 32 67.5 47.3 40.2 74.5L25.4 89.4 2.7 112 48 157.3l22.6-22.6 14.9-14.9C100.7 104.5 121.3 96 142.9 96c44.8 0 81.1 36.3 81.1 81.1c0 21.5-8.5 42.2-23.8 57.4L9.4 425.4 0 434.7 0 480l32 0 256 0 32 0 0-64-32 0-178.7 0L245.5 279.8c27.2-27.2 42.5-64.1 42.5-102.6C288 97 223 32 142.9 32z"]
};
const fa3 = {
  prefix: 'fass',
  iconName: '3',
  icon: [320, 512, [], "33", "M304 32l0 46.1-10.4 9.5L162.3 208l21.7 0c75.1 0 136 60.9 136 136s-60.9 136-136 136l-72.6 0C64.8 480 23 451 6.6 407.3L2 395.2 62 372.8l4.5 12.1c7 18.7 24.9 31.1 44.9 31.1l72.6 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L80 272l-32 0 0-46.1 10.4-9.5L189.7 96 32 96 0 96 0 32l32 0 240 0 32 0z"]
};
const fa4 = {
  prefix: 'fass',
  iconName: '4',
  icon: [384, 512, [], "34", "M209.8 32l-69.4 0L18.5 323.7-.1 368 48 368l208 0 0 80 0 32 64 0 0-32 0-80 32 0 32 0 0-64-32 0-32 0 0-144 0-32-64 0 0 32 0 144L96.1 304 205.5 42.3 209.8 32z"]
};
const fa5 = {
  prefix: 'fass',
  iconName: '5',
  icon: [320, 512, [], "35", "M36.4 32L64 32l192 0 32 0 0 64-32 0L91.6 96 74.9 208 184 208c75.1 0 136 60.9 136 136s-60.9 136-136 136l-78.1 0c-43.4 0-82.2-26.9-97.4-67.5L2 395.2 62 372.8 68.4 390c5.9 15.6 20.8 26 37.5 26l78.1 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L37.8 272 .6 272l5.5-36.7 26.2-176L36.4 32z"]
};
const fa6 = {
  prefix: 'fass',
  iconName: '6',
  icon: [320, 512, [], "36", "M160 416a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM253 32L156.5 160c1.2 0 2.3 0 3.5 0c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-38.1 12.4-75.2 35.3-105.6L172.8 32 253 32z"]
};
const fa7 = {
  prefix: 'fass',
  iconName: '7',
  icon: [320, 512, [], "37", "M320 32l0 39.9-3.7 7L104.6 480l-72.4 0L234.9 96 32 96 0 96 0 32l32 0 256 0 32 0z"]
};
const fa8 = {
  prefix: 'fass',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l15.9 0c0 0 .1 0 .1 0l32 0c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0l-32 0c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"]
};
const fa9 = {
  prefix: 'fass',
  iconName: '9',
  icon: [320, 512, [], "39", "M160 96a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM67 480l96.5-128c-1.2 0-2.3 0-3.5 0C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 38.1-12.4 75.2-35.3 105.6L147.2 480 67 480z"]
};
const faFillDrip = {
  prefix: 'fass',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M0 272l45.3 45.3L194.7 466.7 240 512l45.3-45.3L466.7 285.3 512 240l-45.3-45.3L317.3 45.3 272 0 226.7 45.3l-60.1 60.1-80-80L64 2.7 18.7 48 41.4 70.6l80 80L45.3 226.7 0 272zm185.4-57.4L208 237.3 253.3 192l-22.6-22.6-18.7-18.7L272 90.5 421.5 240l-48 48-267 0-16-16 76.1-76.1 18.7 18.7zM512 320l-55.7 97.4c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L512 320z"]
};
const faArrowsToCircle = {
  prefix: 'fass',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M48 2.7L70.6 25.4 160 114.7 160 96l0-32 64 0 0 32 0 96 0 32-32 0-96 0-32 0 0-64 32 0 18.7 0L25.4 70.6 2.7 48 48 2.7zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM96 288l96 0 32 0 0 32 0 96 0 32-64 0 0-32 0-18.7L70.6 486.6 48 509.3 2.7 464l22.6-22.6L114.7 352 96 352l-32 0 0-64 32 0zM637.3 48L614.6 70.6 525.3 160l18.7 0 32 0 0 64-32 0-96 0-32 0 0-32 0-96 0-32 64 0 0 32 0 18.7 89.4-89.4L592 2.7 637.3 48zM448 288l96 0 32 0 0 64-32 0-18.7 0 89.4 89.4L637.3 464 592 509.3l-22.6-22.6L480 397.3l0 18.7 0 32-64 0 0-32 0-96 0-32 32 0z"]
};
const faCircleChevronRight = {
  prefix: 'fass',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm345 17L241 377l-17 17L190.1 360l17-17 87-87-87-87-17-17L224 118.1l17 17L345 239l17 17-17 17z"]
};
const faChevronCircleRight = faCircleChevronRight;
const faWagonCovered = {
  prefix: 'fass',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M0 0L224 16l0 208L64 224 0 0zM384 16l0 208-128 0 0-208 128 0zM64 256l512 0 0 64-33.6 0c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l-66.3 0c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80L64 320l0-64zm96 160l-46 0c5.8 22.5 23.5 40.2 46 46l0-46zm0-32l0-46c-22.5 5.8-40.2 23.5-46 46l46 0zm32 78c22.5-5.8 40.2-23.5 46-46l-46 0 0 46zm0-124l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zM448 462l0-46-46 0c5.8 22.5 23.5 40.2 46 46zm-46-78l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm124 32l-46 0 0 46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46l0 46 46 0zM416 16L640 0 576 224l-160 0 0-208z"]
};
const faLineHeight = {
  prefix: 'fass',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M96 32L0 128l0 32 64 0 0 192L0 352l0 32 96 96 96-96 0-32-64 0 0-192 64 0 0-32L96 32zM576 64L256 64l0 64 320 0 0-64zm0 160l-320 0 0 64 320 0 0-64zM256 384l0 64 320 0 0-64-320 0z"]
};
const faBagel = {
  prefix: 'fass',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.7-10.8 10.6-22.1 14.6-33.8L478.8 352l56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4L554.5 119l-19-53.4L478.8 64 432 32 385.2 64l-56.7 1.6-9.2 25.7c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zM396.1 155c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM120 208l24 24 24-24-24-24-24 24zM80 296l24-24L80 248 56 272l24 24zm32 128l24-24-24-24L88 400l24 24zM304 264l24-24-24-24-24 24 24 24zM216 432l24 24 24-24-24-24-24 24zm88-8l24-24-24-24-24 24 24 24z"]
};
const faTransporter7 = {
  prefix: 'fass',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M464 32L448 64 416 80l32 16 16 32 16-32 32-16L480 64 464 32zM64 288L48 256 32 288 0 304l32 16 16 32 16-32 32-16L64 288zM296 512l120 0 0-64L96 448l0 64 120 0 80 0z"]
};
const faAt = {
  prefix: 'fass',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 64C150 64 64 150 64 256s86 192 192 192l32 0 0 64-32 0C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 96 0 32-32 0-40 0c-36 0-68.2-15.8-90.2-40.9C326.4 368.3 293 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c32.5 0 62.1 12.1 84.7 32l43.3 0 0 32 0 64 0 8c0 30.9 25.1 56 56 56l8 0 0-64c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faRectanglesMixed = {
  prefix: 'fass',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M0 32l320 0 0 224L0 256 0 32zm384 0l192 0 0 352-192 0 0-352zM336 304l0 176L64 480l0-176 272 0z"]
};
const faPhoneArrowUpRight = {
  prefix: 'fass',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M144 0L0 32 0 64C0 311.4 200.6 512 448 512l32 0 32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0zM303 175l-17 17L320 225.9l17-17 127-127 0 46.1 0 24 48 0 0-24 0-104 0-24L488 0 384 0 360 0l0 48 24 0 46.1 0L303 175z"]
};
const faPhoneArrowUp = faPhoneArrowUpRight;
const faPhoneOutgoing = faPhoneArrowUpRight;
const faTrashCan = {
  prefix: 'fass',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM32 128l384 0 0 384L32 512l0-384zm112 64l-32 0 0 16 0 224 0 16 32 0 0-16 0-224 0-16zm96 0l-32 0 0 16 0 224 0 16 32 0 0-16 0-224 0-16zm96 0l-32 0 0 16 0 224 0 16 32 0 0-16 0-224 0-16z"]
};
const faTrashAlt = faTrashCan;
const faCircleL = {
  prefix: 'fass',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152l0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24 48 0 0 24z"]
};
const faHeadSideGoggles = {
  prefix: 'fass',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M45.9 128C75.3 53.1 148.3 0 233.7 0L256 0c39.3 0 75.8 11.8 106.2 32L304 32c-61.9 0-112 50.1-112 112c0 17.2 3.9 33.5 10.8 48L32.2 192l-.2 0L0 192l0-64 32 0 13.9 0zM304 256l204.2 0 3.8 4.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0-160 0-32 0 0-32 0-130.7-4.9-4.9c-32.5-32.5-52.8-75-57.8-120.3l192.4 0c20.2 19.8 47.9 32 78.4 32zm0-192l112 0 0 160-112 0c-44.2 0-80-35.8-80-80s35.8-80 80-80zM512 224l-64 0 0-160 64 0 0 160z"]
};
const faHeadVr = faHeadSideGoggles;
const faTextHeight = {
  prefix: 'fass',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M32 32L0 32 0 64l0 64 0 32 64 0 0-32 0-32 64 0 0 320-32 0-32 0 0 64 32 0 128 0 32 0 0-64-32 0-32 0 0-320 64 0 0 32 0 32 64 0 0-32 0-64 0-32-32 0-96 0-64 0L32 32zm448 0l-96 96 0 32 64 0 0 192-64 0 0 32 96 96 96-96 0-32-64 0 0-192 64 0 0-32L480 32z"]
};
const faUserXmark = {
  prefix: 'fass',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zM633.9 160l-17 17-47 47 47 47 17 17L600 321.9l-17-17-47-47-47 47-17 17L438.1 288l17-17 47-47-47-47-17-17L472 126.1l17 17 47 47 47-47 17-17L633.9 160z"]
};
const faUserTimes = faUserXmark;
const faFaceHandYawn = {
  prefix: 'fass',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M336.9 498.9C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-82.4 0-32 32 0 17.6 0C169.9 257.8 209 224 256 224c25.5 0 48.7 10 65.9 26.2l6.1-6.1 22.6 22.6 22.6 22.6L395.9 312l-16 16 9.4 9.4L411.9 360l-22.6 22.6-9.4 9.4 9.4 9.4L411.9 424l-22.6 22.6-52.3 52.3zM214.5 114.5l-12.5 10-80 64-12.5 10-20-25 12.5-10 80-64 12.5-10 20 25zm95.5 10l-12.5-10 20-25 12.5 10 80 64 12.5 10-20 25-12.5-10-80-64zM302.6 296L280 273.4l-11.3 11.3L184 369.4l0-15 0-20-40 0 0 20 0 29.6 0 20 0 12.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l48.8-48.8L366.6 424 344 401.4l-11.3 11.3-24 24-9.4-9.4 56-56L366.6 360 344 337.4l-11.3 11.3-56 56-9.4-9.4 72-72L350.6 312 328 289.4l-11.3 11.3-72 72-9.4-9.4 56-56L302.6 296z"]
};
const faGaugeSimpleMin = {
  prefix: 'fass',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6 80.2 215 55 255.8l20.4 12.6 117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faTachometerSlowest = faGaugeSimpleMin;
const faStethoscope = {
  prefix: 'fass',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M119.3 1.2l15.5 62.1-31 7.8L96 73l0 119c0 53 43 96 96 96s96-43 96-96l0-119L280.2 71l-31-7.8L264.7 1.2l31 7.8 32 8L352 23l0 25 0 144c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112l0-70.7c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 70.7c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192L32 48l0-25L56.2 17l32-8 31-7.8zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCoffin = {
  prefix: 'fass',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M0 144L104 512H280L384 144 272 0H112L0 144z"]
};
const faMessage = {
  prefix: 'fass',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M512 0L0 0 0 416l160 0 0 96 144-96 208 0L512 0z"]
};
const faCommentAlt = faMessage;
const faSalad = {
  prefix: 'fass',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M416 96c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160s43 96 96 96l73.4 0L84.7 171.3 73.4 160 96 137.4l11.3 11.3L208 249.4 208 112l0-16 32 0 0 16 0 144 52 0c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128zm96 192L0 288l0 24c0 67 39.2 124.9 96 151.8L96 512l320 0 0-48.2c56.8-27 96-84.8 96-151.8l0-24zm0-64c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32l181.1 0c3.5-10 5.5-20.8 5.5-32z"]
};
const faBowlSalad = faSalad;
const faInfo = {
  prefix: 'fass',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M128 32l0 80-80 0 0-80 80 0zM0 192l32 0 64 0 32 0 0 32 0 224 32 0 32 0 0 64-32 0-32 0-64 0-32 0L0 512l0-64 32 0 32 0 0-192-32 0L0 256l0-64z"]
};
const faRobotAstromech = {
  prefix: 'fass',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M128 128l0 32 256 0 0-32C384 57.3 326.7 0 256 0S128 57.3 128 128zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 512l128 0 0-128 64 64 128 0 64-64 0 128 128 0 0-32-48-64 0-224L48 192l0 224L0 480l0 32zM208 256l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm0 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z"]
};
const faRingDiamond = {
  prefix: 'fass',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M128 0L96 72l35.8 65.6C55.2 162.9 0 235 0 320C0 426 86 512 192 512s192-86 192-192c0-85-55.2-157.1-131.8-182.4L288 72 256 0 128 0zM320 320A128 128 0 1 1 64 320a128 128 0 1 1 256 0z"]
};
const faFonduePot = {
  prefix: 'fass',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M392.9 172.4l-13.3-8.9-19 28.5-38.5 0 30.8-46.2-13.3-8.9L430.9 0l53.3 35.5L392.9 172.4zM231.5 192l9.2-36.8-15.5-3.9L263 0l62.1 15.5L287.3 166.8l-15.5-3.9L264.5 192l-33 0zM0 224l64 0 0 16 0 64 0 16 32 0 0-16 0-48 32 0 0 16 0 16 32 0 0-16 0-32 0-16 192 0 32 0 64 0 32 0 32 0 0 64-32 0-32 0 0 32c0 52.3-25.1 98.8-64 128l0 32 0 32-64 0 0-32 0-3.2c-10.3 2.1-21 3.2-32 3.2l-128 0c-11 0-21.7-1.1-32-3.2l0 3.2 0 32-64 0 0-32 0-32C25.1 418.8 0 372.3 0 320l0-96z"]
};
const faTheta = {
  prefix: 'fass',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256zM192 16C135.8 16 87.1 45.7 53.5 89.4C19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16zM128 224l-32 0 0 64 32 0 128 0 32 0 0-64-32 0-128 0z"]
};
const faFaceHandPeeking = {
  prefix: 'fass',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M552.4 363.5c-10.1 3.5-20.7 5.4-31.6 5.4l-8.8 0-24 0-8 0-24 0-8 0 0-32 8 0 24 0 0-8.9-24 0-8 0-8 0-16 0-16 0 0-32 34.6 0 5.4 0 32 0 0-8-27.6 0L408 288l0-32 58.6 0 7.4 0 6 0 2.7 0 8.7 0 0-12.2-12.1-8.7-4.9-3.5L414.7 189l18.6-26 40.1 27.5 24 16.4 19.5 13.4 17 11.6 11.6 8 0-19.6-8.2-8.2-22.6-22.6 5.6-5.6s0 0 0 0l17-17 5.7-5.7 22.6 22.6 .1 .1 22.4 22.4 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-10.2 10.2-22.4 17.8-35.7 22.5zm-31.6 37.4c3.5 0 7.1-.1 10.6-.4C485.3 467.8 407.8 512 320 512c-105.9 0-196.8-64.3-235.7-156c11.3 3.2 23 4.9 34.9 4.9l72.8 0 32 0 0-32 0-8.9 16 0 32 0 0-32 0-8 0-24 0-8 0-8 0-16 0-8 0-8 0-24 0-8 0-32-32 0-63.9 0 10.4-10.4L163.9 111 135.6 82.7l-2.1-2.1C180.2 31 246.5 0 320 0c92 0 172.6 48.5 217.7 121.3l-17.4 17.4-26.9 26.8-42.1-28.9-25.9-17.8-13.8 19.4c-6.3-1.4-12.9-2.2-19.7-2.2c-48.6 0-88 39.4-88 88c0 43.1 31 79 72 86.5l0 17.5 0 32 32 0 16 0 0 8.9 0 32 32 0 64.8 0zm-401.6-72c-17.1 0-33.7-4.6-48.2-13.1c-6.9-4.1-13.4-9-19.1-14.8c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3c0 0 0 0 0 0l5.6 5.6 17 17 5.7 5.7L130.8 144l-12.2 12.2-6.1 6.1L98.8 176l19.3 0 9.8 0 16.1 0 15.9 0 48 0 32 0s0 0 0 0l0 32s0 0 0 0l-32 0-16 0-32 0 0 8 32 0 16 0 32 0s0 0 0 0l0 8 0 16 0 8s0 0 0 0l-32 0-16 0-32 0 0 8 32 0 16 0 32 0s0 0 0 0l.3 32-.3 0-16 0-16 0-16 0s0 0 0 0l-32 0 0 8.9 32 0 0 23.1 0 8.9-32 0s0 0 0 0l-32 0-8.8 0zM384 400c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm32.4-176c0 6.1-2.3 11.8-6.1 16l-35.8 0c-3.8-4.2-6.1-9.9-6.1-16c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSquareUser = {
  prefix: 'fass',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M368 416l-32-96-224 0L80 416l288 0zM0 32l64 0 320 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
const faDownLeftAndUpRightToCenter = {
  prefix: 'fass',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M272 80l32-32 52 52L456 0l56 56L412 156l52 52-32 32-160 0 0-160zM240 432l-32 32-52-52L56 512 0 456 100 356 48 304l32-32 160 0 0 160z"]
};
const faCompressAlt = faDownLeftAndUpRightToCenter;
const faExplosion = {
  prefix: 'fass',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M144 368L0 320l82.3 96 115.2 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l115.2 0L576 320 432 368 544 0 336 296 312 128l-48 0L240 304 96 192l48 176zM312 0L264 0l0 24 0 48 0 24 48 0 0-24 0-48 0-24zM32 448L0 448l0 64 32 0 512 0 32 0 0-64-32 0L32 448z"]
};
const faFileLines = {
  prefix: 'fass',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM112 256l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faFileAlt = faFileLines;
const faFileText = faFileLines;
const faWaveSquare = {
  prefix: 'fass',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M128 32l32 0 160 0 32 0 0 32 0 352 96 0 0-160 0-32 32 0 128 0 32 0 0 64-32 0-96 0 0 160 0 32-32 0-160 0-32 0 0-32 0-352-96 0 0 160 0 32-32 0L32 288 0 288l0-64 32 0 96 0 0-160 0-32z"]
};
const faRing = {
  prefix: 'fass',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M64 184.3l0 51C106.8 212.1 170 192 256 192s149.2 20.1 192 43.3l0-51c-23.1-20-82.6-56.3-192-56.3s-168.9 36.3-192 56.3zM512 192l0 88.1 0 7.9 0 16 0 32 0 16c-21.3 32-102.4 96-256 96S21.3 384 0 352l0-16 0-32 0-16 0-7.9L0 192l0-32c21.3-32 102.4-96 256-96s234.7 64 256 96l0 32zM400.1 265.6C365.8 251.5 318.4 240 256 240s-109.8 11.5-144.1 25.6C150 278.8 197.8 288 256 288s106-9.2 144.1-22.4z"]
};
const faBuildingUn = {
  prefix: 'fass',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 64l0-64 64 0 0 64-64 0zM112 80l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16 32 0 0 16zM224 64l8 0 9.9 0 4.4 8.8L272 124.2 272 80l0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L240 131.8l0 44.2 0 16-32 0 0-16 0-96 0-16 16 0z"]
};
const faDiceThree = {
  prefix: 'fass',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M448 32L0 32 0 480l448 0 0-448zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faTirePressureWarning = {
  prefix: 'fass',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M384 32l0-32 64 0 0 32 0 22.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4c17.5 35.6 33.4 82.6 27.5 136.2c-5.3 48.6-28.1 99-76.8 148.7l0 50-64 0 0-24-32 0 0 24-64 0 0-24-32 0 0 24-64 0 0-24-32 0 0 24-64 0 0-50C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2c7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5L64 32 64 0l64 0 0 32 0 22.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5c-14.7 29.7-25.3 64-21.3 100.9c3.7 34 20.4 74.1 65.7 117.7l246.8 0c45.3-43.6 62-83.7 65.7-117.7c4.1-36.9-6.6-71.1-21.3-100.9c-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5L384 32zM280 120l0 112 0 24-48 0 0-24 0-112 0-24 48 0 0 24zm0 168l0 48-48 0 0-48 48 0z"]
};
const faWifiFair = {
  prefix: 'fass',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56l42.4-48C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72l42.4 48zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faWifi2 = faWifiFair;
const faCalendarDays = {
  prefix: 'fass',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM64 320l64 0 0-64-64 0 0 64zm128-64l0 64 64 0 0-64-64 0zm192 64l0-64-64 0 0 64 64 0zM64 448l64 0 0-64-64 0 0 64zm192-64l-64 0 0 64 64 0 0-64zm64 64l64 0 0-64-64 0 0 64z"]
};
const faCalendarAlt = faCalendarDays;
const faMp3Player = {
  prefix: 'fass',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M0 0L384 0l0 512L0 512 0 0zM192 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM320 64L64 64l0 128 256 0 0-128z"]
};
const faAnchorCircleCheck = {
  prefix: 'fass',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faTally4 = {
  prefix: 'fass',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M160 64l0-32L96 32l0 32 0 384 0 32 64 0 0-32 0-384zm128 0l0-32-64 0 0 32 0 384 0 32 64 0 0-32 0-384zM416 32l-64 0 0 32 0 384 0 32 64 0 0-32 0-384 0-32zM544 64l0-32-64 0 0 32 0 384 0 32 64 0 0-32 0-384z"]
};
const faRectangleHistory = {
  prefix: 'fass',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M512 512l0-352L0 160 0 512l512 0zM464 80L48 80l0 48 416 0 0-48zM416 0L96 0l0 48 320 0 0-48z"]
};
const faBuildingCircleArrowRight = {
  prefix: 'fass',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M0 0L384 0l0 232.2c-39.1 32.3-64 81.1-64 135.8s24.9 103.5 64 135.8l0 8.2-144 0 0-128-96 0 0 128L0 512 0 0zM128 224l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zM64 96l0 64 64 0 0-64L64 96zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm96 272a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-78.6L481.4 312l11.3 11.3L521.4 352 432 352l-16 0 0 32 16 0 89.4 0-28.7 28.7L481.4 424 504 446.6l11.3-11.3 56-56L582.6 368l-11.3-11.3-56-56L504 289.4z"]
};
const faVolleyball = {
  prefix: 'fass',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M0 256c0 49.6 14.1 96 38.6 135.2L55.8 286l.6-4 2.4-3.2L175.1 126.7 87 63.7C33.7 110.6 0 179.4 0 256zM143 485.8l11.2-114.6 .4-4.4 2.6-3.5L237.6 254l-43.5-99.4L86.7 295.1 65.2 426.7C87 451 113.4 471.2 143 485.8zm30.9 12.8c25.8 8.7 53.4 13.4 82.1 13.4c97.7 0 182.7-54.8 225.8-135.3l-99.7 37.7-3.7 1.4-4-.5L184.5 390.7 173.9 498.6zM499.3 335.9c8.2-25.1 12.7-52 12.7-79.9c0-5.7-.2-11.4-.6-17L406.6 286.6l-4 1.8-4.4-.5-134.8-15-64.3 87.4L374.5 383l124.8-47.2zM374.8 253.1l-68-163.3L203.5 5.4c-32.7 6.8-63.2 19.9-90 37.9l93.7 67 3.6 2.6 1.8 4 54.4 124.2 107.8 12zm132.3-47.3C483.7 88.4 380.2 0 256 0c-2.8 0-5.6 0-8.3 .1l82.5 67.5 3.1 2.5 1.5 3.7 73.6 176.8 98.7-44.8z"]
};
const faVolleyballBall = faVolleyball;
const faSunHaze = {
  prefix: 'fass',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M320 73.1L214 0 190.7 126.7 64 150l73.1 106s0 0 0 0l54.9 0s0 0 0 0c0-70.7 57.3-128 128-128s128 57.3 128 128c0 0 0 0 0 0l54.9 0s0 0 0 0L576 150 449.3 126.7 426 0 320 73.1zM224 256s0 0 0 0l192 0s0 0 0 0c0-53-43-96-96-96s-96 43-96 96zm392 32l-112 0-24 0 0 48 24 0 112 0 24 0 0-48-24 0zm-208 0L88 288l-24 0 0 48 24 0 320 0 24 0 0-48-24 0zm144 88L24 376 0 376l0 48 24 0 528 0 24 0 0-48-24 0zM64 464l0 48 24 0 112 0 24 0 0-48-24 0L88 464l-24 0zm208 0l0 48 24 0 320 0 24 0 0-48-24 0-320 0-24 0z"]
};
const faTextSize = {
  prefix: 'fass',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M32 32L0 32 0 64l0 64 0 32 64 0 0-32 0-32 96 0 0 320-32 0-32 0 0 64 32 0 128 0 32 0 0-64-32 0-32 0 0-320 96 0 0 32 0 32 64 0 0-32 0-64 0-32-32 0L224 32l-64 0L32 32zM352 224l-32 0 0 32 0 32 0 32 64 0 0-32 64 0 0 128-16 0-32 0 0 64 32 0 96 0 32 0 0-64-32 0-16 0 0-128 64 0 0 32 64 0 0-32 0-32 0-32-32 0-256 0z"]
};
const faUfo = {
  prefix: 'fass',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M320 112c59.2 0 109.6 37.9 128.3 90.7c5 14.2 7.7 29.4 7.7 45.3c0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3c18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64zm0 280l32 32-32 32-32-32 32-32zM96 328l32-32 32 32-32 32L96 328zm416-32l32 32-32 32-32-32 32-32z"]
};
const faFork = {
  prefix: 'fass',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M408 8l16 16L320 128l16 16L448 48l16 16L368 176l16 16L488 88l16 16L433.5 227.4C417.7 255 388.4 272 356.7 272c-19.4 0-38.1-6.4-53.4-18L70.6 486.6 48 509.3 2.7 464l22.6-22.6L258 208.8c-11.6-15.3-18-34-18-53.4c0-31.8 17-61.1 44.6-76.8L408 8z"]
};
const faUtensilFork = faFork;
const faArrowsUpToLine = {
  prefix: 'fass',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M32 96l512 0 32 0 0-64-32 0L32 32 0 32 0 96l32 0zM48 285.3l22.6-22.6L96 237.3 96 448l0 32 64 0 0-32 0-210.7 25.4 25.4L208 285.3 253.3 240l-22.6-22.6-80-80L128 114.7l-22.6 22.6-80 80L2.7 240 48 285.3zm320 0l22.6-22.6L416 237.3 416 448l0 32 64 0 0-32 0-210.7 25.4 25.4L528 285.3 573.3 240l-22.6-22.6-80-80L448 114.7l-22.6 22.6-80 80L322.7 240 368 285.3z"]
};
const faMobileSignal = {
  prefix: 'fass',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M64 64l224 0 0 242.5c18.8-20.4 40.3-38.3 64-53L352 64l0-64L288 0 64 0 0 0 0 64 0 448l0 64 64 0 144 0c0-22 2.3-43.4 6.7-64L64 448 64 64zM224 384l-16 0-64 0-16 0 0 32 16 0 64 0 15.5 0 .5-1.6 0-30.4zm288-80l0-48c-141.4 0-256 114.6-256 256l48 0c0-114.9 93.1-208 208-208zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 0c0-61.9 50.1-112 112-112l0-48c-88.4 0-160 71.6-160 160l48 0z"]
};
const faBarcodeScan = {
  prefix: 'fass',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M128 32L64 32l0 160 64 0 0-160zM64 480l64 0 0-160-64 0 0 160zm96 0l32 0 0-160-32 0 0 160zm64 0l64 0 0-160-64 0 0 160zm0-288l64 0 0-160-64 0 0 160zm96 288l64 0 0-160-64 0 0 160zm0-288l64 0 0-160-64 0 0 160zM448 480l32 0 0-160-32 0 0 160zm0-288l32 0 0-160-32 0 0 160zm64 288l64 0 0-160-64 0 0 160zm0-288l64 0 0-160-64 0 0 160zm-352 0l32 0 0-160-32 0 0 160zM0 232l0 48 640 0 0-48L0 232z"]
};
const faSortDown = {
  prefix: 'fass',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M0 336L160 480 320 336V288H0v48z"]
};
const faSortDesc = faSortDown;
const faFolderArrowDown = {
  prefix: 'fass',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM280 200l0-24-48 0 0 24 0 102.1-31-31-17-17L150.1 288l17 17 72 72 17 17 17-17 72-72 17-17L328 254.1l-17 17-31 31L280 200z"]
};
const faFolderDownload = faFolderArrowDown;
const faCircleMinus = {
  prefix: 'fass',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faMinusCircle = faCircleMinus;
const faFaceIcicles = {
  prefix: 'fass',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M512 256c0 10.7-.7 21.3-1.9 31.6L495.9 450.8 490.6 512l-53.1 0-5.3-61.2-.7-8.3c-7.5 7-15.4 13.6-23.7 19.8l-6.4 14.6L385.9 512l-27.9 0-7.8-17.9c-29.2 11.6-61 17.9-94.2 17.9c-66.4 0-126.9-25.3-172.4-66.8l-.5 2.8-54.2 0-4.5-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM56 415.8l0 .2 0-.2L80 272l-48 0L56 415.8zM344 400l28 64 28-64 0-40-56 0 0 40zm56-56l0-40-56 0 0 40 56 0zm-72 0l0-40-64 0 0 40 64 0zm0 56l0-40-64 0 0 40 32 48 32-48zm-80-96l-64 0 0 40 64 0 0-40zm0 56l-64 0 0 40 64 0 0-40zm-80-16l0-40-56 0 0 40 56 0zm0 56l0-40-56 0 0 40 56 0zm40.4-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM488 224l-48 0 24 224 24-224z"]
};
const faShovel = {
  prefix: 'fass',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M338.7 45.3L384 0l45.3 45.3 37.5 37.5L512 128l-45.3 45.3-24.2 24.2c-17 17-40 26.5-64 26.5c-13.3 0-25.9-2.9-37.3-8L238.6 318.6 304 384 176 512 0 512 0 336 128 208l65.4 65.4L296 170.7c-5.1-11.4-8-24-8-37.3c0-24 9.5-47 26.5-64l24.2-24.2zM421.5 128L384 90.5l-24.2 24.2c-5 5-7.8 11.7-7.8 18.7c0 14.6 11.9 26.5 26.5 26.5c7 0 13.8-2.8 18.7-7.8L421.5 128z"]
};
const faDoorOpen = {
  prefix: 'fass',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M320 0L64 64l0 384-32 0L0 448l0 64 32 0 32 0 256 0L320 0zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128l96 0 0 352 0 32 32 0 64 0 32 0 0-64-32 0-32 0 0-352 0-32-32 0L352 64l0 64z"]
};
const faFilms = {
  prefix: 'fass',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M576 32L96 32l0 352 480 0 0-352zM200 80l0 48-48 0 0-48 48 0zm272 0l48 0 0 48-48 0 0-48zM200 184l0 48-48 0 0-48 48 0zm272 0l48 0 0 48-48 0 0-48zM200 288l0 48-48 0 0-48 48 0zm272 0l48 0 0 48-48 0 0-48zM416 80l0 112-160 0 0-112 160 0zM256 224l160 0 0 112-160 0 0-112zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faRightFromBracket = {
  prefix: 'fass',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M352 96L512 256 352 416l-32 0 0-96-160 0 0-128 160 0 0-96 32 0zM160 96L64 96l0 320 96 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l32 0 128 0 32 0 0 64-32 0z"]
};
const faSignOutAlt = faRightFromBracket;
const faFaceGlasses = {
  prefix: 'fass',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64L48 192l0 96 0 16 16 0 160 0 16 0 0-16 0-96 32 0 0 96 0 16 16 0 160 0 16 0 0-16 0-96 39.9 0c5.3 20.5 8.1 41.9 8.1 64zM256 0C363.4 0 455.4 66.2 493.4 160L464 160l0-16 0-16-16 0-160 0-16 0 0 16 0 16-32 0 0-16 0-16-16 0L64 128l-16 0 0 16 0 16-29.4 0C56.6 66.2 148.6 0 256 0zM80 272l0-80 0-32 128 0 0 112L80 272zM256 416c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C344.9 346.3 312.4 384 256 384s-88.9-37.7-97.7-55.2l-28.6 14.3C142.3 368.3 184.4 416 256 416zm48-144l0-112 128 0 0 32 0 80-128 0zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faNfc = {
  prefix: 'fass',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M0 32l448 0 0 448L0 480 0 32zM64 96l0 16 0 288 0 16 16 0 288 0 16 0 0-16 0-288 0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 256L96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96z"]
};
const faAtom = {
  prefix: 'fass',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M256 328c9.4-4.8 19-10.2 28.8-16c12.1-7.3 23.6-14.8 34.2-22.4c.7-10.8 1-22 1-33.6s-.4-22.7-1-33.6c-10.6-7.6-22.1-15.1-34.2-22.4c-9.7-5.8-19.3-11.2-28.8-16c-9.4 4.8-19 10.2-28.8 16c-12.1 7.3-23.6 14.8-34.2 22.4c-.7 10.8-1 22-1 33.6s.4 22.7 1 33.6c10.6 7.6 22.1 15.1 34.2 22.4c9.7 5.8 19.3 11.2 28.8 16zm190-72c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zM256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM373.5 147.5c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM256 296l-40-40 40-40 40 40-40 40z"]
};
const faSoap = {
  prefix: 'fass',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 24.6-9.2 47-24.4 64l24.4 0 32 0 0 32 0 128 0 32-32 0L96 448l-32 0 0-32 0-128 0-32 32 0 152.4 0c-15.2-17-24.4-39.4-24.4-64L0 192 0 512l512 0 0-320-96 0zM96 416l320 0 0-128-96 0L96 288l0 128z"]
};
const faIcons = {
  prefix: 'fass',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M128 224L236.1 115.9c12.7-12.7 19.9-30 19.9-48C256 30.4 225.6 0 188.1 0c-18 0-35.3 7.2-48 19.9L128 32 115.9 19.9C103.2 7.2 85.9 0 67.9 0C30.4 0 0 30.4 0 67.9c0 18 7.2 35.3 19.9 48L128 224zm329.1 32L320 400l72.2 10.5L374.9 512 512 368l-72.2-10.5L457.1 256zM96 272L74.7 304 0 304 0 512l288 0 0-208-74.7 0L192 272l-96 0zm48 88a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM512 40l0-39L473.7 8.6l-160 32L288 45.8 288 72l0 88c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-109.8L448 79l0 49c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-136z"]
};
const faHeartMusicCameraBolt = faIcons;
const faMicrophoneLinesSlash = {
  prefix: 'fass',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M416 0L224 0l0 151.1L48.4 14.8 29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344c15-25.9 23.6-56 23.6-88l0-40 0-24-48 0 0 24 0 8 0 32c0 21-5 40.7-14 58.2l-18-14 0-44.2-56.9 0L320 225.7l0-1.7 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-96zM401.3 412.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7-48-37.8 0 6.5 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2z"]
};
const faMicrophoneAltSlash = faMicrophoneLinesSlash;
const faClosedCaptioningSlash = {
  prefix: 'fass',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10L608 32 70.5 32 48.4 14.8zM235.5 160.1c32.7 1.2 61.2 18.7 77.6 44.6L302 211.7l-66.5-51.6zm95.1 73.8c10-42.3 48-73.9 93.4-73.9c34.2 0 64.1 17.8 81.1 44.6l-40.5 25.7C456 216.9 441 208 424 208c-26.5 0-48 21.5-48 48c0 5.2 .8 10.3 2.4 15l-47.8-37.1zm90.2 70c1.1 .1 2.2 .1 3.2 .1c17 0 32-8.9 40.6-22.3l40.5 25.7c-9 14.1-21.6 25.8-36.5 33.6l-47.8-37.1zM32 480l455.4 0L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2 32 480zM184 256c0 26.5 21.5 48 48 48c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5z"]
};
const faCalculatorSimple = {
  prefix: 'fass',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M0 0L224 0l0 224L0 224 0 0zM288 0L512 0l0 224-224 0L288 0zM512 288l0 224-224 0 0-224 224 0zM0 288l224 0 0 224L0 512 0 288zM416 64l0-16-32 0 0 16 0 32-32 0-16 0 0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-32zM64 96L48 96l0 32 16 0 96 0 16 0 0-32-16 0L64 96zM83.3 348.7L72 337.4 49.4 360l11.3 11.3L89.4 400 60.7 428.7 49.4 440 72 462.6l11.3-11.3L112 422.6l28.7 28.7L152 462.6 174.6 440l-11.3-11.3L134.6 400l28.7-28.7L174.6 360 152 337.4l-11.3 11.3L112 377.4 83.3 348.7zM352 352l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm0 64l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0z"]
};
const faCalculatorAlt = faCalculatorSimple;
const faBridgeCircleCheck = {
  prefix: 'fass',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M64 32L32 32l0 64 32 0 40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0 32 0 0-64-32 0L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faSlidersUp = {
  prefix: 'fass',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M128 0l0 32 0 32 48 0 0 48 0 64 0 48-48 0 0 256 0 32-64 0 0-32 0-256-48 0 0-48 0-64 0-48 48 0 0-32L64 0l64 0zM288 0l0 32 0 256 48 0 0 48 0 64 0 48-48 0 0 32 0 32-64 0 0-32 0-32-48 0 0-48 0-64 0-48 48 0 0-256 0-32 64 0zM448 32l0 64 48 0 0 48 0 64 0 48-48 0 0 224 0 32-64 0 0-32 0-224-48 0 0-48 0-64 0-48 48 0 0-64 0-32 64 0 0 32zM64 112l0 64 64 0 0-64-64 0zM288 336l-64 0 0 64 64 0 0-64zm96-192l0 64 64 0 0-64-64 0z"]
};
const faSlidersV = faSlidersUp;
const faLocationMinus = {
  prefix: 'fass',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM120 168l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faMapMarkerMinus = faLocationMinus;
const faPumpMedical = {
  prefix: 'fass',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M128 0l0 128 128 0 0-32 82.7 0 38.6 38.6L400 157.3 445.3 112 422.6 89.4l-48-48L365.3 32 352 32l-96 0 0-32L128 0zM56 160L32 512l320 0L328 160 56 160zm160 96l0 24 0 32 32 0 24 0 0 48-24 0-32 0 0 32 0 24-48 0 0-24 0-32-32 0-24 0 0-48 24 0 32 0 0-32 0-24 48 0z"]
};
const faFingerprint = {
  prefix: 'fass',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5l15.6 18.2 36.4-31.3L450.2 89.2C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40 0 24 48 0 0-24 0-40zm458.5-52.9l-4.9-23.5-47 9.9 4.9 23.5c2.9 13.9 4.5 28.3 4.5 43.1l0 40 0 24 48 0 0-24 0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-34.2 0-66 9.7-93 26.6l31.7 37c18.2-9.9 39.1-15.6 61.3-15.6c70.7 0 128 57.3 128 128l0 24.9c0 34.6-2.8 69.1-8.4 103.1l48.6 0c5.2-34 7.8-68.5 7.8-103.1l0-24.9c0-97.2-78.8-176-176-176zM126.1 137.3C97.5 168.6 80 210.3 80 256l0 24.9c0 35-5.5 69.8-16.2 103.1l50.1 0c9.3-33.5 14.1-68.2 14.1-103.1l0-24.9c0-31.1 11.1-59.7 29.6-81.9l-31.6-36.8zM256 160c-53 0-96 43-96 96l0 24.9c0 46-7.6 91.6-22.5 135.1l46.3 0c13.4-43.7 20.3-89.2 20.3-135.1l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 45.6-5.5 91-16.4 135.1l45.2 0c10.1-44.2 15.2-89.5 15.2-135.1l0-24.9c0-53-43-96-96-96zm24 96l-48 0 0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3-3.3 8.6 51.4 0 2.6-6.7C267.9 411.9 280 346.7 280 280.9l0-24.9z"]
};
const faSkiBoot = {
  prefix: 'fass',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M48 272l111.7 0 48-240L96 32 48 272zm-6.4 32L0 512l512 0 0-64-32 0 0-96L326.4 288 272 288l-16 0 0-32 16 0 60.8 0 12.8-64L288 192l-16 0 0-32 16 0 64 0L384 0 320 0l-6.4 32L240 32c0 1-.1 2.1-.3 3.1l-51.2 256L185.9 304l-13.1 0L41.6 304z"]
};
const faStandardDefinition = {
  prefix: 'fass',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M0 32l576 0 0 448L0 480 0 32zM304 160l0 24 0 144 0 24 24 0 56 0c53 0 96-43 96-96s-43-96-96-96l-56 0-24 0zm48 48l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96zm-184.9 .1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1 .7 21.1 3.4 25.7 4.4l21.8 5 10-43.7-21.8-5c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5c0 0 0 0 0 0l1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3c0 0 0 0 0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1l-21.5-6.1-12.3 43.1 21.5 6.1c1.5 .4 3.3 .9 5.3 1.5c0 0 0 0 0 0c10.8 3.2 28.4 8.3 39.4 9.9l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5c0 0 0 0 0 0l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3c0 0 0 0 0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z"]
};
const faRectangleSd = faStandardDefinition;
const faH1 = {
  prefix: 'fass',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M64 96l0-32L0 64 0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96zm341 61.2l43-19.1L448 384l-32 0-32 0 0 64 32 0 64 0 64 0 32 0 0-64-32 0-32 0 0-288 0-32-32 0-16 0-6.8 0L451 66.8 384 96.5l0 70 21-9.3z"]
};
const faHandPointRight = {
  prefix: 'fass',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M512 96l0 64-240 0 0-64 240 0zM352 288l0 64-128 0 0-64 128 0zm32-32l-112 0 0-64 112 0 0 64zM320 384l0 64-128 0 0-64 128 0zM149 64l91 0 0 192-48 0-32 0 0-96 0-16-32 0 0 16 0 112 0 16 16 0 48 0 0 64-32 0 0 96C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64z"]
};
const faMagnifyingGlassLocation = {
  prefix: 'fass',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 64 80 144 80 144s80-80 80-144zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSearchLocation = faMagnifyingGlassLocation;
const faMessageBot = {
  prefix: 'fass',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M544 0L96 0l0 176-32 0 0-16L0 160l0 64 64 0 0-16 32 0 0 208 128 0 0 96 144-96 176 0 0-208 32 0 0 16 64 0 0-64-64 0 0 16-32 0L544 0zM160 96l320 0 0 192-320 0 0-192zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faForwardStep = {
  prefix: 'fass',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M256 96l0-32 64 0 0 32 0 320 0 32-64 0 0-32 0-160L0 448 0 64 256 256l0-160z"]
};
const faStepForward = faForwardStep;
const faFaceSmileBeam = {
  prefix: 'fass',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM129.7 327.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faSmileBeam = faFaceSmileBeam;
const faLightCeiling = {
  prefix: 'fass',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M224 162L224 0l64 0 0 162c126.3 15.7 224 123.5 224 254L0 416C0 285.5 97.7 177.7 224 162zm32 350c-35.3 0-64-28.7-64-64l128 0c0 35.3-28.7 64-64 64z"]
};
const faMessageExclamation = {
  prefix: 'fass',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM280 80l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 272l0 48 48 0 0-48-48 0z"]
};
const faCommentAltExclamation = faMessageExclamation;
const faBowlScoop = {
  prefix: 'fass',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M32 224C32 118 118 32 224 32s192 86 192 192L32 224zM4.5 300.7L0 256l448 0-4.5 44.7C437 366.2 381.9 416 316.2 416L256 416l80 72 0 24-224 0 0-24 80-72-60.2 0C66.1 416 11 366.2 4.5 300.7z"]
};
const faBowlShavedIce = faBowlScoop;
const faSquareX = {
  prefix: 'fass',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M448 32L0 32 0 480l448 0 0-448zm-98.9 96L253.9 256l95.2 128-59.8 0L224 296.2 158.7 384l-59.8 0 95.2-128L98.9 128l59.8 0L224 215.8 289.3 128l59.8 0z"]
};
const faBuildingMemo = {
  prefix: 'fass',
  iconName: 'building-memo',
  icon: [640, 512, [], "e61e", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 48 0 0-224-32 0 0-64 32 0 0-64-32 0 0-64 32 0 0-32 96 0 0-64zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm480 0L320 96l0 416 320 0 0-416zM400 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64-184l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm16 96l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm-16 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z"]
};
const faUtilityPoleDouble = {
  prefix: 'fass',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M288 0l0 32 0 32 96 0 0-8 0-24 48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 0 32 0 24 0 8-32 0-51.2 0L288 221.9l0 34.1 96 0 0-8 0-24 48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 0 32 0 24 0 8-32 0-51.2 0L288 413.9l0 66.1 0 32-64 0 0-32 0-66.1L83.2 320 32 320 0 320l0-8 0-24 0-32 0-8 0-24 48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 96 0 0-34.1L83.2 128 32 128 0 128l0-8L0 96 0 64l0-8L0 32l48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 96 0 0-32 0-32 64 0zM140.8 128L224 183.4l0-55.4-83.2 0zM288 183.4L371.2 128 288 128l0 55.4zM140.8 320L224 375.4l0-55.4-83.2 0zM288 375.4L371.2 320 288 320l0 55.4z"]
};
const faFlagCheckered = {
  prefix: 'fass',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M64 0l0 32 0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c43.2 21.6 93.4 23 137.6 4.4c3.2-1.4 6.4-2.8 9.6-4.4L448 16l0 71.6L448 368l-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384l0 96 0 32L0 512l0-32 0-80 0-66L0 64 0 32 0 0 64 0zm0 187.1l64-13.9 0 65.5L64 252.6 64 318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6L128 173.2 128 98 64 114l0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"]
};
const faChevronsUp = {
  prefix: 'fass',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M278.6 41.4L256 18.7 233.4 41.4l-192 192L18.7 256 64 301.3l22.6-22.6L256 109.3 425.4 278.6 448 301.3 493.3 256l-22.6-22.6-192-192zm0 192L256 210.7l-22.6 22.6-192 192L18.7 448 64 493.3l22.6-22.6L256 301.3 425.4 470.6 448 493.3 493.3 448l-22.6-22.6-192-192z"]
};
const faChevronDoubleUp = faChevronsUp;
const faFootball = {
  prefix: 'fass',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6C47.8 183.4 35.1 215.9 26.9 249L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4l-4.4-21.5-21.6-3.6c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4l4.4 21.5 21.6 3.6c58.2 9.7 109.9 12 155.6 7.9zM272 153.4l11.3 11.3 64 64L358.6 240 336 262.6l-11.3-11.3-64-64L249.4 176 272 153.4zm-48 48l11.3 11.3 64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4zm-48 48l11.3 11.3 64 64L262.6 336 240 358.6l-11.3-11.3-64-64L153.4 272 176 249.4z"]
};
const faFootballBall = faFootball;
const faUserVneck = {
  prefix: 'fass',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zm0 432L138.7 304 64 304 0 512l448 0L384 304l-74.7 0L224 432z"]
};
const faSchoolCircleExclamation = {
  prefix: 'fass',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M640 96l0 170.8C608.1 221.6 555.5 192 496 192c-38.5 0-74.2 12.4-103.1 33.4c9.6-14.1 15.1-31.1 15.1-49.4c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c15.6 0 30.2-4 42.9-11.1c-23.4 27.1-38.8 61.4-42.2 99.1l-.7 0c-35.3 0-64 28.7-64 64l0 96L0 512 0 96l160 0L320 0 480 96l160 0zM144 192l-64 0 0 96 64 0 0-96zm0 128l-64 0 0 96 64 0 0-96zM336 128l0 16 0 16 16 0 16 0 0 32-16 0-32 0-16 0 0-16 0-32 0-16 32 0zm160 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faCrop = {
  prefix: 'fass',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M128 0l0 32 0 32 0 64 0 210.7L338.7 128 192 128l-32 0 0-64 32 0 210.7 0 38.6-38.6L464 2.7 509.3 48 486.6 70.6 448 109.3 448 384l32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32 0-64 0-210.7L173.3 384 320 384l32 0 0 64-32 0L96 448l-32 0 0-32 0-288-32 0L0 128 0 64l32 0 32 0 0-32L64 0l64 0z"]
};
const faAnglesDown = {
  prefix: 'fass',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M246.6 470.6L224 493.3l-22.6-22.6-160-160L18.7 288 64 242.7l22.6 22.6L224 402.7 361.4 265.4 384 242.7 429.3 288l-22.6 22.6-160 160zm0-192L224 301.3l-22.6-22.6-160-160L18.7 96 64 50.7 86.6 73.4 224 210.7 361.4 73.4 384 50.7 429.3 96l-22.6 22.6-160 160z"]
};
const faAngleDoubleDown = faAnglesDown;
const faUsersRectangle = {
  prefix: 'fass',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M32 0L0 0 0 32 0 480l0 32 32 0 576 0 32 0 0-32 0-448 0-32L608 0 32 0zM64 448L64 64l512 0 0 384L64 448zM223.8 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM120 256L96 336l94.3 0 19.4-58.1 7.3-21.9L120 256zm329.7 80l94.3 0-24-80-96.9 0 7.3 21.9L449.7 336zM432 384l-16-48-16-48-17.6 0-124.8 0L240 288l-16 48-16 48 224 0zm80-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faPeopleRoof = {
  prefix: 'fass',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M335.6 12.1L320 3.3l-15.6 8.7-272 152L4.5 179.7l31.2 55.9 27.9-15.6L320 76.7 576.4 219.9l27.9 15.6 31.2-55.9-27.9-15.6-272-152zM320 240a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM144 336a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm392-40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM96 352l-14.1 0L75 364.3 19 465.1l-11.7 21 42 23.3 11.7-21 27-48.6L88 512l112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21-35.2-63.4 3.4-6.3L264 345.5l0 86.5 112 0 0-86.5 26.9 49.9 3.4 6.3L371 465.1l-11.7 21 42 23.3 11.7-21 27-48.6 0 72.2 112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21L565 364.3 558.1 352 544 352l-96 0-14 0-44.9-83.4L382.3 256 368 256l-96 0-14.3 0-6.8 12.6L206 352l-14 0-96 0z"]
};
const faSquareArrowRight = {
  prefix: 'fass',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M448 480l0-448L0 32 0 480l448 0zM377 273L265 385l-17 17L214.1 368l17-17 71-71L88 280l-24 0 0-48 24 0 214.1 0-71-71-17-17L248 110.1l17 17L377 239l17 17-17 17z"]
};
const faArrowSquareRight = faSquareArrowRight;
const faLocationPlus = {
  prefix: 'fass',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM168 304l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"]
};
const faMapMarkerPlus = faLocationPlus;
const faLightbulbExclamationOn = {
  prefix: 'fass',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M449.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2l-160 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0zM240 512l0-96 160 0 0 96-160 0zM344 88l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zM296 256l0 48 48 0 0-48-48 0zM87.3 16l6 4 24 16 20 13.3L110.7 89.3 90.7 76l-24-16-6-4-20-13.3L67.3 2.7 87.3 16zM579.3 56l-6 4-24 16-20 13.3L502.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L579.3 56zM24 160l48 0 24 0 0 48-24 0-48 0L0 208l0-48 24 0zm544 0l48 0 24 0 0 48-24 0-48 0-24 0 0-48 24 0zM117.3 332l-24 16-6 4-20 13.3L40.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3z"]
};
const faPeopleLine = {
  prefix: 'fass',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M320 112a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm392-40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM96 224l-14.1 0L75 236.3 19 337.1l-11.7 21 42 23.3 11.7-21 27-48.6L88 384l112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21-35.2-63.5 3.4-6.3L264 217.5l0 86.5 112 0 0-86.5 26.9 49.9 3.4 6.3L371 337.1l-11.7 21 42 23.3 11.7-21 27-48.6 0 72.2 112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21L565 236.3 558.1 224 544 224l-96 0-14 0-44.9-83.4L382.3 128 368 128l-96 0-14.3 0-6.8 12.6L206 224l-14 0-96 0zM32 416L0 416l0 64 32 0 576 0 32 0 0-64-32 0L32 416z"]
};
const faBeerMugEmpty = {
  prefix: 'fass',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M32 32l352 0 0 64 96 0 32 0 0 32 0 176 0 20.8-19 8.4L384 381.7l0 98.3L32 480 32 32zM384 311.6l64-28.4L448 160l-64 0 0 151.6zM160 144l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224zm64 0l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224zm64 0l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224z"]
};
const faBeer = faBeerMugEmpty;
const faCrateEmpty = {
  prefix: 'fass',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M512 224L0 224 0 352l512 0 0-128zm0 160L0 384 0 512l512 0 0-128zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faDiagramPredecessor = {
  prefix: 'fass',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M448 416l0-64L64 352l0 64 384 0zm64 64l-64 0L64 480 0 480l0-64 0-64 0-64 64 0 384 0 64 0 0 64 0 64 0 64zM384 96l-96 0 0 128L0 224 0 32l208 0 80 0 128 0 32 0 0 32 0 64 64 0 0 32-96 96-96-96 0-32 64 0 0-32z"]
};
const faTransporter = {
  prefix: 'fass',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-18.4 80l15.4 0 102.2 0 15.4 0 9.6 12L409 236l20 25L379 301l-20-25-31-38.7L328 416l-64 0 0-96-16 0 0 96-64 0 0-178.7L153 276l-20 25L83 261l20-25L180 140l9.6-12zM296 512l-80 0L96 512l0-64 320 0 0 64-120 0zM480 32l32 16L480 64 464 96 448 64 416 48l32-16L464 0l16 32zM48 64L64 96l32 16L64 128 48 160 32 128 0 112 32 96 48 64z"]
};
const faCalendarCircleUser = {
  prefix: 'fass',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M160 0L96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64zm96 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 512l330.8 0C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-63.3 77.7c-20.4 21.2-49 34.3-80.7 34.3s-60.3-13.2-80.7-34.3L376 416l112 0 24.7 29.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faArrowUpLong = {
  prefix: 'fass',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M169.4 22.6L192 0l22.6 22.6 128 128 22.6 22.6L320 218.5l-22.6-22.6L224 122.5 224 480l0 32-64 0 0-32 0-357.5L86.6 195.9 64 218.5 18.7 173.3l22.6-22.6 128-128z"]
};
const faLongArrowUp = faArrowUpLong;
const faPersonCarryBox = {
  prefix: 'fass',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 480l0 32 64 0 0-32s0 0 0 0l0-69.5-64-64L0 480zM32 128L0 128l0 32L0 274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 4 24 4 24s0 0 0 0l4 24 .5 2.7 64.9 0-2.2-13.3-4-24s0 0 0 0l-4-24-4-24-8-48-1.7-10.1-7.3-7.3L96 306.7l0-65.1 21.4 32.1 9.5 14.3 17.1 0 48 0 32 0 32 0 128 0 0-192L192 96l0 128-30.9 0-54.5-81.7L97.1 128 80 128l-48 0z"]
};
const faPersonCarry = faPersonCarryBox;
const faFireFlameSimple = {
  prefix: 'fass',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M203.1 9.7L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258C3.7 277.8 0 299 0 320.2C0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2c-34.8-95.8-93.3-181.2-170-248.3zm78.7 296.2c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1L192 192l18 15.7c30.3 26.5 54.5 59.3 70.8 96.1l.9 2.1z"]
};
const faBurn = faFireFlameSimple;
const faPerson = {
  prefix: 'fass',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128z"]
};
const faMale = faPerson;
const faLaptop = {
  prefix: 'fass',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M96 32L64 32l0 32 0 288 64 0 0-256 384 0 0 256 64 0 0-288 0-32-32 0L96 32zM0 384l0 48 48 48 544 0 48-48 0-48L0 384z"]
};
const faFileCsv = {
  prefix: 'fass',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8 0 16-32 0 0-16 0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8 0-16 32 0 0 16 0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0 16 0 0 32-16 0-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512l-16 0 0-32 16 0 42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zM448 352l0 16 0 35c0 17.3 3.1 34.4 9.2 50.6l6.8 18.2 6.8-18.2c6.1-16.2 9.2-33.3 9.2-50.6l0-35 0-16 32 0 0 16 0 35c0 21.1-3.8 42-11.2 61.8L487 501.6 483.1 512 472 512l-16 0-11.1 0L441 501.6l-13.8-36.8C419.8 445 416 424.1 416 403l0-35 0-16 32 0z"]
};
const faMenorah = {
  prefix: 'fass',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M32 0L59.8 48.7C62.6 53.5 64 58.9 64 64.4C64 81.8 49.8 96 32.4 96l-.8 0C14.2 96 0 81.8 0 64.4c0-5.5 1.4-10.9 4.2-15.7L32 0zm96 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C160 81.8 145.8 96 128.4 96l-.8 0C110.2 96 96 81.8 96 64.4c0-5.5 1.4-10.9 4.2-15.7L128 0zm68.2 48.7L224 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C256 81.8 241.8 96 224.4 96l-.8 0C206.2 96 192 81.8 192 64.4c0-5.5 1.4-10.9 4.2-15.7zM320 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C352 81.8 337.8 96 320.4 96l-.8 0C302.2 96 288 81.8 288 64.4c0-5.5 1.4-10.9 4.2-15.7L320 0zm68.2 48.7L416 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C448 81.8 433.8 96 416.4 96l-.8 0C398.2 96 384 81.8 384 64.4c0-5.5 1.4-10.9 4.2-15.7zM512 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C544 81.8 529.8 96 512.4 96l-.8 0C494.2 96 480 81.8 480 64.4c0-5.5 1.4-10.9 4.2-15.7L512 0zm68.2 48.7L608 0l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C640 81.8 625.8 96 608.4 96l-.8 0C590.2 96 576 81.8 576 64.4c0-5.5 1.4-10.9 4.2-15.7zM64 128l0 32 0 160 224 0 0-160 0-32 64 0 0 32 0 160 224 0 0-160 0-32 64 0 0 32 0 192 0 32-32 0-256 0 0 64 128 0 32 0 0 64-32 0-160 0-160 0-32 0 0-64 32 0 128 0 0-64L32 384 0 384l0-32L0 160l0-32 64 0zm96 0l0 32 0 128-64 0 0-128 0-32 64 0zm96 0l0 32 0 128-64 0 0-128 0-32 64 0zm192 0l0 32 0 128-64 0 0-128 0-32 64 0zm96 0l0 32 0 128-64 0 0-128 0-32 64 0z"]
};
const faUnion = {
  prefix: 'fass',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M0 288L0 32l64 0 0 256c0 70.7 57.3 128 128 128s128-57.3 128-128l0-256 64 0 0 256c0 106-86 192-192 192S0 394 0 288z"]
};
const faChevronsLeft = {
  prefix: 'fass',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4L18.7 256l22.6 22.6 192 192L256 493.3 301.3 448l-22.6-22.6L109.3 256 278.6 86.6 301.3 64 256 18.7 233.4 41.4l-192 192zm192 0L210.7 256l22.6 22.6 192 192L448 493.3 493.3 448l-22.6-22.6L301.3 256 470.6 86.6 493.3 64 448 18.7 425.4 41.4l-192 192z"]
};
const faChevronDoubleLeft = faChevronsLeft;
const faCircleHeart = {
  prefix: 'fass',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.2 287.1c-14.9-14.9-23.2-35-23.2-56l0-3.6c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L352 311.9l-96 96-96-96-24.8-24.8z"]
};
const faHeartCircle = faCircleHeart;
const faTruckPlane = {
  prefix: 'fass',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M200 0c31.5 0 56 54.7 56 86.1l0 9.9 0 404.7-56-19.8L88 512l0-56 56-44.5 0-81.2L0 368l0-80 144-95.5 0-106.5C144 54.7 169.4 0 200 0zm88 128l352 0 0 320-32 0 0 64-64 0 0-64-160 0 0 64-64 0 0-64-32 0 0-320zM552 240l-176 0-24 64 224 0-24-64zm16 160a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM384 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faRecordVinyl = {
  prefix: 'fass',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBringForward = {
  prefix: 'fass',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 448l224 0 0-224-64 0 0-64 64 0 64 0 0 64 0 224 0 64-64 0-224 0-64 0 0-64 0-64 64 0 0 64zM0 352L0 0 352 0l0 352L0 352z"]
};
const faSquareP = {
  prefix: 'fass',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M448 32L0 32 0 480l448 0 0-448zM152 128l92 0c50.8 0 92 41.2 92 92l0 24-3.2 0c-10.6 39.2-46.3 68-88.8 68l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24 24 0zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z"]
};
const faFaceGrinStars = {
  prefix: 'fass',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm416.5 46.8c-46.2 18.3-101.2 29-160.2 29s-114.1-10.6-160.2-29C112.3 376.7 177.9 432 256.3 432s144-55.3 160.2-129.2zM160 109.4l-7.2 15.1-16.6 34.7-38.1 5-16.6 2.2L93.6 178l27.9 26.5-7 37.8-3.1 16.5 14.7-8L160 232.5l33.8 18.3 14.7 8-3.1-16.5-7-37.8L226.4 178l12.2-11.5-16.6-2.2-38.1-5-16.6-34.7L160 109.4zm192 0l-7.2 15.1-16.6 34.7-38.1 5-16.6 2.2L285.6 178l27.9 26.5-7 37.8-3.1 16.5 14.7-8L352 232.5l33.8 18.3 14.7 8-3.1-16.5-7-37.8L418.4 178l12.2-11.5-16.6-2.2-38.1-5-16.6-34.7L352 109.4z"]
};
const faGrinStars = faFaceGrinStars;
const faSigma = {
  prefix: 'fass',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M0 480l32 0 320 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32-210.7 0L246.6 278.6 269.3 256l-22.6-22.6L109.3 96 320 96l0 32 0 32 64 0 0-32 0-64 0-32-32 0L32 32 0 32 0 77.3l9.4 9.4L178.7 256 9.4 425.4 0 434.7 0 480z"]
};
const faCameraMovie = {
  prefix: 'fass',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256l-224 0C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM576 256l0 256L448 448l0-128 128-64zM416 288l0 224L64 512l0-160-32 0L0 352l0-64 32 0 32 0 64 0 32 0 256 0z"]
};
const faBong = {
  prefix: 'fass',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M128 273.1c-19.5 11.3-35.7 27.5-46.9 46.9l221.8 0c-11.2-19.4-27.4-35.6-46.9-46.9l-32-18.5 0-36.9L224 64l-64 0 0 153.7 0 36.9-32 18.5zm228.6 12.2C374 314.1 384 347.9 384 384c0 49.2-18.5 94-48.9 128L48.9 512C18.5 478 0 433.2 0 384c0-71.1 38.6-133.1 96-166.3L96 64 64 64 64 0 96 0l64 0 64 0 64 0 32 0 0 64-32 0 0 153.7c14.2 8.2 27.2 18.2 38.8 29.6L366.1 208l-7-7-17-17L376 150.1l17 17 24 24 24 24 17 17L424 265.9l-17-17-7-7-43.3 43.3z"]
};
const faClarinet = {
  prefix: 'fass',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 128l16 0 32 0 96 0 96 0 32 0 16 0 0 32-16 0-16 0 0 32 91.2 0 44-29.3L640 146.1l0 29.9 0 192 0 29.9-24.9-16.6-44-29.3L96 352l-3.1 0-2.9-1.1-80-32L0 314.8 0 304l0-64 0-10.8 10.1-4 80-32 2.9-1.1 3.1 0 160 0 0-32-16 0-16 0 0-32zm224 32l-64 0 0 32 64 0 0-32zm-96 0l-64 0 0 32 64 0 0-32zM272 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faTruckFlatbed = {
  prefix: 'fass',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M576 416l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0-16 0-48 0 0 256-120.4 0c-17.6-19.6-43.1-32-71.6-32s-54 12.4-71.6 32L0 352l0 64 64 0c0 53 43 96 96 96s96-43 96-96l96 0 32 0c0 53 43 96 96 96s96-43 96-96zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faSpaghettiMonsterFlying = {
  prefix: 'fass',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7l24 0 0 48-24 0c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8l24 0 0 48-24 0c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464l24 0 0 48-24 0c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512l-24 0 0-48 24 0c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1c0 0 0 0 0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2L0 392l0-48 24 0c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3L0 248l0-48 24 0c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faPastafarianism = faSpaghettiMonsterFlying;
const faArrowDownUpAcrossLine = {
  prefix: 'fass',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M160 509.3l22.6-22.6 96-96L301.3 368 256 322.7l-22.6 22.6L192 386.7l0-98.7 352 0 32 0 0-64-32 0-96 0 0-98.7 41.4 41.4L512 189.3 557.3 144l-22.6-22.6-96-96L416 2.7 393.4 25.4l-96 96L274.7 144 320 189.3l22.6-22.6L384 125.3l0 98.7-192 0-64 0-96 0L0 224l0 64 32 0 96 0 0 98.7L86.6 345.4 64 322.7 18.7 368l22.6 22.6 96 96L160 509.3zM128 64l0 128 64 0 0-128 0-32-64 0 0 32zM384 320l0 128 0 32 64 0 0-32 0-128-64 0z"]
};
const faArrowsRotateReverse = {
  prefix: 'fass',
  iconName: 'arrows-rotate-reverse',
  icon: [512, 512, [], "e630", "M406.7 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0L125.5 160l34.3 0 32 0 0 64-32 0-112 0-32 0 0-32 0-112 0-32 64 0 0 32 0 35.2L97.4 97.6c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7l-60.4 21.3zm25.1 194.3l-17.6 17.5c0 0 0 0 0 0c-87.5 87.4-229.3 87.4-316.7 0C73 390 55.3 361.3 44.5 330.6l60.4-21.3c7.7 21.8 20.2 42.3 37.8 59.8c62.5 62.5 163.8 62.5 226.3 0l.1-.1L386.1 352l-34.4 0-32 0 0-64 32 0 112 0 32 0 0 32 0 112 0 32-64 0 0-32 0-35.1z"]
};
const faLeafHeart = {
  prefix: 'fass',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 96l104 0c50.2 0 92.7-33 106.9-78.6C501.5 58.8 512 106.2 512 156.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440l0 16 0 24L0 480l0-24 0-16c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96c0 0 0 0 0 0zM189.7 241.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4L288 355.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8l-3.5 0c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9l-3.5 0c-28.6 0-51.8 23.2-51.8 51.8z"]
};
const faHouseBuilding = {
  prefix: 'fass',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M640 0L320 0l0 161 64 53.3 0-22.3 64 0 0 64-32 0 0 32 32 0 0 64-32 0 0 160 224 0L640 0zM512 192l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zM448 96l0 64-64 0 0-64 64 0zm64 0l64 0 0 64-64 0 0-64zM0 256L0 512l384 0 0-256L192 96 0 256zm240 16l0 96-96 0 0-96 96 0z"]
};
const faCheeseSwiss = {
  prefix: 'fass',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M141.8 145.7L0 256l512 0C512 132.3 411.7 32 288 32L217.1 87.2c4.4 7.2 6.9 15.7 6.9 24.8c0 26.5-21.5 48-48 48c-13.4 0-25.5-5.5-34.2-14.3zM416 288c0 26.5-21.5 48-48 48s-48-21.5-48-48L0 288 0 480l512 0 0-192-96 0zM176 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faSpoon = {
  prefix: 'fass',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M224 160.2C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192l-39.6 0-21.5-21.5L70.6 486.6 48 509.3 2.7 464l22.6-22.6L245.5 221.3 224 199.8l0-39.6z"]
};
const faUtensilSpoon = faSpoon;
const faJarWheat = {
  prefix: 'fass',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32 0L288 0l0 64L32 64 32 0zM0 96l320 0 0 416L0 512 0 96zM192 320c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 32 0 16 0zm0-96c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 32 0 16 0zm0 192c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 0 32 0 16 32 0 0-16 0-32 16 0z"]
};
const faEnvelopesBulk = {
  prefix: 'fass',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M480 0l0 128-256 0-32 0 0 32 0 64-96 0L96 0 480 0zM224 192l0-32 32 0 352 0 0 256-224 0 0-160 0-32-32 0-128 0 0-32zm128 64l0 32 0 18.1L192 420.3 32 306.1 32 256l288 0 32 0zm192-32l-64 0 0 64 64 0 0-64zM352 345.4L352 512 32 512l0-166.6L182.7 453l9.3 6.6 9.3-6.6L352 345.4z"]
};
const faMailBulk = faEnvelopesBulk;
const faFileCircleExclamation = {
  prefix: 'fass',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faBowArrow = {
  prefix: 'fass',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M352 32L512 0 480 160l-47-47L183.8 362.1 200 416l-96 96L80 432 0 408l96-96 53.9 16.2L399 79 352 32zM192 64c47.7 0 95.4 13.2 137.1 39.7l-46.8 46.8c-28.1-15-59.2-22.5-90.3-22.5c-29.9 0-58.3 10.2-85.8 28.9L191 241.8 145.8 287 25.4 166.6 2.7 144 48 98.7 60.3 111c38-28.1 81.6-47 131.7-47zM361.5 229.7l46.8-46.8C434.8 224.6 448 272.3 448 320c0 50.1-18.9 93.7-47 131.7L413.3 464 368 509.3l-22.6-22.6L225 366.2 270.2 321l84.8 84.8C373.8 378.3 384 349.9 384 320c0-31.1-7.5-62.2-22.5-90.3z"]
};
const faCartXmark = {
  prefix: 'fass',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L496 288l-325.3 0 9.1 48L488 336l24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM378.4 89.3L336 131.7 293.6 89.3l-28.3 28.3L307.7 160l-42.4 42.4 28.3 28.3L336 188.3l42.4 42.4 28.3-28.3L364.3 160l42.4-42.4L378.4 89.3z"]
};
const faHexagonXmark = {
  prefix: 'fass',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm353.9-64L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z"]
};
const faTimesHexagon = faHexagonXmark;
const faXmarkHexagon = faHexagonXmark;
const faCircleH = {
  prefix: 'fass',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152l0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24 48 0 0 24 0 80 128 0 0-80 0-24 48 0 0 24z"]
};
const faHospitalSymbol = faCircleH;
const faMerge = {
  prefix: 'fass',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M160 64l15.4 0L185 76 303.4 224l80.6 0 0-64 32 0 96 96-96 96-32 0 0-64-80.6 0L185 436l-9.6 12L160 448 32 448 0 448l0-64 32 0 112.6 0L247 256 144.6 128 32 128 0 128 0 64l32 0 128 0z"]
};
const faPager = {
  prefix: 'fass',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M0 64l512 0 0 384L0 448 0 64zm64 64l0 128 384 0 0-128L64 128zM80 320l-24 0 0 48 24 0 56 0 24 0 0-48-24 0-56 0zm136 0l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0z"]
};
const faCartMinus = {
  prefix: 'fass',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L496 288l-325.3 0 9.1 48L488 336l24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 172l160 0 0-40-160 0 0 40z"]
};
const faAddressBook = {
  prefix: 'fass',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M448 0L32 0l0 512 416 0L448 0zM320 288l32 96-224 0 32-96 160 0zM176 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64zm0 112l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zm0 144l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64z"]
};
const faContactBook = faAddressBook;
const faPanFrying = {
  prefix: 'fass',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M448 224c0 33.4-7.3 65.1-20.4 93.6l140.3 90.7L487.2 512 364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224zM319.9 154c-21.2-5.4-50.6-22.6-65.8-38.4c-24.5-25.5-65-26.3-90.5-1.8c-11.6 11.2-18.1 25.6-19.4 40.5c-2.2 24.7-9.2 56.2-21.5 77.6c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6c10.2-1.4 20.3-5.4 29.2-12c28.4-21.1 34.3-61.1 13.3-89.5c-9.1-12.3-21.8-20.4-35.5-23.9zM504 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faGrid = {
  prefix: 'fass',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M0 32l128 0 0 128L0 160 0 32zM0 192l128 0 0 128L0 320 0 192zM128 352l0 128L0 480 0 352l128 0zM160 32l128 0 0 128-128 0 0-128zM288 192l0 128-128 0 0-128 128 0zM160 352l128 0 0 128-128 0 0-128zM448 32l0 128-128 0 0-128 128 0zM320 192l128 0 0 128-128 0 0-128zM448 352l0 128-128 0 0-128 128 0z"]
};
const faGrid3 = faGrid;
const faFootballHelmet = {
  prefix: 'fass',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M494.2 226.2L340.3 245.5l14 74.5L496 320l16 0 0 16 0 72 0 72 0 16-16 0-128 0-13.3 0-2.4-13.1-13.5-72L327.7 352 292 352l7.7 20.5c2.9 7.6 4.3 15.7 4.3 23.8l0 1.3c0 36.7-29.7 66.4-66.4 66.4c-9 0-17.9-1.8-26.1-5.4L112 416l-34.9 0C39.1 373.5 16 317.5 16 256C16 123.5 123.5 16 256 16c122.5 0 223.5 91.7 238.2 210.2zM256 256l24 64 41.7 0-13.2-70.6L256 256zm104.3 96l7.5 40L480 392l0-40-119.7 0zM480 424l-106.2 0 7.5 40 98.7 0 0-40zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHandLove = {
  prefix: 'fass',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M192 0l0 32 0 96 0 224 96 0 32 0 96 0 0-96 0-160 0-32 64 0 0 32 0 240c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64L28.3 356.1l-29-27.6 55.2-57.9 29 27.6 44.6 42.4c0-1.5-.1-3.1-.1-4.6l0-304 0-32 64 0zm32 160l64 0 0 160-64 0 0-160zm160 32l0 128-64 0 0-128 64 0z"]
};
const faTrees = {
  prefix: 'fass',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M64 128L192 0 320 128l0 32-48 0 80 96 0 32-48 0 80 96 0 32-160 0 0 64 0 32-64 0 0-32 0-64L0 416l0-32 80-96-48 0 0-32 80-96-48 0 0-32zM416 480l0-32 0-32 0-32 0-11.6-7.4-8.9L372.3 320l11.7 0 0-32 0-32 0-11.6-7.4-8.9L340.3 192l11.7 0 0-32 0-32 0-13.3-9.4-9.4L448 0 576 128l0 32-48 0 80 96 0 32-48 0 80 96 0 32-160 0 0 64 0 32-64 0 0-32z"]
};
const faStrikethrough = {
  prefix: 'fass',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12l30.9 8.2 16.5-61.8-30.9-8.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9L32 224 0 224l0 64 32 0 448 0 32 0 0-64-32 0-209.9 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c0 0 0 0 0 0c-5.6-1.9-11-3.7-15.9-5.4l-30.4-10.1L87.5 436.3l30.4 10.1c3.6 1.2 7.9 2.7 12.7 4.3c0 0 0 0 0 0s0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6c0 0 0 0 0 0l.2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2z"]
};
const faPage = {
  prefix: 'fass',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M0 512H384V112L272 0H0V512z"]
};
const faK = {
  prefix: 'fass',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M236.5 32l83.2 0L309.4 44.5 166.8 215.9 317.9 480l-73.7 0L123.1 268.5 64 339.6 64 448l0 32L0 480l0-32L0 328 0 64 0 32l64 0 0 32 0 175.5 39.4-47.4L236.5 32z"]
};
const faDiagramPrevious = {
  prefix: 'fass',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M448 352L64 352l0 64 384 0 0-64zm64-64l0 64 0 64 0 64-64 0L64 480 0 480l0-64 0-64 0-64 64 0 168 0 0-64-40 0-32 0 0-32 73.4-73.4L256 96l22.6 22.6L352 192l0 32-32 0-40 0 0 64 168 0 64 0zM0 32l512 0 0 192-128 0 0-32 0-13.3-9.4-9.4-96-96L256 50.7 233.4 73.4l-96 96-9.4 9.4 0 13.3 0 32L0 224 0 32z"]
};
const faGaugeMin = {
  prefix: 'fass',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6 80.2 215 55 255.8l20.4 12.6 117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAltSlowest = faGaugeMin;
const faFolderGrid = {
  prefix: 'fass',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM176 240l-96 0 0 96 96 0 0-96zm128 0l-96 0 0 96 96 0 0-96zm32 0l0 96 96 0 0-96-96 0z"]
};
const faEggplant = {
  prefix: 'fass',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M480 65.9l31.4-31.4L477.4 .6 446.1 32 288 32l16 48 48 16 16 48 48 16 16 48 48 16 0-158.1zM271 82.3c-30.1 22.4-65.7 39.7-101.2 56.9C83.4 181.3-1.6 222.5 0 336c1.4 95.3 79.8 175.9 176.4 176c130.5 .1 227.9-140.1 276.4-263.4l-30.9-10.3-15.2-5.1-5.1-15.2-10.9-32.8-32.8-10.9-15.2-5.1-5.1-15.2-10.9-32.8-32.8-10.9-15.2-5.1-5.1-15.2L271 82.3z"]
};
const faExcavator = {
  prefix: 'fass',
  iconName: 'excavator',
  icon: [640, 512, [], "e656", "M96 0l32 0L256 0l16.6 0 9.6 13.5 96 136 5.9 8.3 0 2.2 0 8 0 56 0 96L0 320 0 160l96 0L96 32 96 0zM239.4 64L160 64l0 96 147.2 0L239.4 64zM80 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 416zM0 432c0-44.2 35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80zM640 320l0 64 0 48c0 44.2-35.8 80-80 80l-112 0 0-48L576 336l0-208L416 288l0-128L576 0l64 0 0 320z"]
};
const faRam = {
  prefix: 'fass',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64l0 8 0 24 48 0 0-24 0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32-10.3 10.3-55.2 23.6-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2L384 320l192 0 0-152.2 14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5-55.1-23.6L544 96l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8 0 24 48 0 0-24 0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l-32 0c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-49.5 58.6l30.8-13.2C309.3 83.1 284.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0L120 512l88 0 0-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 85.7 88 0 22.5-120c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L352 352l0-135.6-21.4 9.2L286.5 122.6zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faLandmarkFlag = {
  prefix: 'fass',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M368 0l0 96-96 0 0 32 192 0 32 0 0 64-32 0L48 192l-32 0 0-64 32 0 192 0L240 0l32 0 96 0zM64 224l64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 192 51.1 38.3c.1 .1 .2 .1 .2 .2L512 464l0 15.6c0 .3 0 .5 0 .8l0 31.6-32 0L32 512 0 512l0-31.6c0-.3 0-.5 0-.8L0 464l12.7-9.5c.1-.1 .2-.1 .2-.2L64 416l0-192z"]
};
const faLips = {
  prefix: 'fass',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M0 224L192 64l96 48 96-48L576 224s-80 224-240 224l-96 0C80 448 0 224 0 224zm64 0s80 96 224 96s224-96 224-96L368 192s-48.1 16-80 16s-80-16-80-16L64 224z"]
};
const faPencil = {
  prefix: 'fass',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M10.2 461L0 512l51-10.2L160 480 420.7 219.3l-16-16-96-96-16-16L32 352 10.2 461zM315.3 68.7l16 16 96 96 16 16 34.7-34.7L512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9 315.3 68.7zM99.9 352l12.1 0 0 48 48 0 0 12.1-23.7 23.7-75.1 15 15-75.1L99.9 352zM326.6 176l-11.3 11.3-144 144L160 342.6 137.4 320l11.3-11.3 144-144L304 153.4 326.6 176z"]
};
const faPencilAlt = faPencil;
const faBackward = {
  prefix: 'fass',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M0 256L256 448l0-384L0 256zM512 448l0-384L288 232l0 48L512 448z"]
};
const faCaretRight = {
  prefix: 'fass',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M112 96L256 256 112 416l-48 0L64 96l48 0z"]
};
const faComments = {
  prefix: 'fass',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M416 176c0 97.2-93.1 176-208 176c-36.2 0-70.3-7.8-99.9-21.6L0 352l37.6-75.1C13.9 248.3 0 213.5 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zm32 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9L640 512 531.9 490.4C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176z"]
};
const faPaste = {
  prefix: 'fass',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M160 0c-23.7 0-44.4 12.9-55.4 32L0 32 0 448l192 0 0-320 0-32 32 0 96 0 0-64L215.4 32C204.4 12.9 183.7 0 160 0zm0 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 88l-32 0 0 32 0 288 0 64 288 0 0-288-96-96-96 0-64 0z"]
};
const faFileClipboard = faPaste;
const faDesktopArrowDown = {
  prefix: 'fass',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M576 0L352 0l0 64 160 0 0 224L64 288 64 64l160 0 0-64L0 0 0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0L336 416l240 0L576 0zM312 24l0-24L264 0l0 24 0 142.1-39-39-17-17L174.1 144l17 17 80 80 17 17 17-17 80-80 17-17L368 110.1l-17 17-39 39L312 24z"]
};
const faCodePullRequest = {
  prefix: 'fass',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M56 56l48 0 0 48-48 0 0-48zM0 0L0 56l0 48 0 56 48 0 0 192L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-192 48 0 0-56 0-48 0-56L104 0 56 0 0 0zM56 408l48 0 0 48-48 0 0-48zm400 0l0 48-48 0 0-48 48 0zM400 192l0 160-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-160c0-70.7-57.3-128-128-128l-16 0 0-64L288 0 192 96l96 96 32 0 0-64 16 0c35.3 0 64 28.7 64 64z"]
};
const faPumpkin = {
  prefix: 'fass',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M236.1 103.8C252.5 98.7 269.9 96 288 96c22.6 0 44.2 4.3 64 12l0-76L288 0 236.1 103.8zm158.1 27.9c15.4 11.7 28.9 25.9 39.8 42C392.6 144.9 342.3 128 288 128s-104.6 16.9-146 45.7c10.9-16.1 24.3-30.3 39.8-42c-9.6-2.4-19.6-3.7-29.8-3.7C68.1 128 0 214 0 320S68.1 512 152 512c24.4 0 47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2s47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2c83.9 0 152-86 152-192s-68.1-192-152-192c-10.2 0-20.1 1.3-29.8 3.7z"]
};
const faClipboardList = {
  prefix: 'fass',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M101.5 64C114.6 26.7 150.2 0 192 0s77.4 26.7 90.5 64L384 64l0 448L0 512 0 64l101.5 0zM224 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zM96 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-136l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zM96 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faPenField = {
  prefix: 'fass',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M304 240L288 352l112-16L564.7 171.3l-96-96L304 240zM640 96L544 0 491.3 52.7l96 96L640 96zM32 128L0 128l0 32L0 480l0 32 32 0 512 0 32 0 0-32 0-160 0-32-64 0 0 32 0 128L64 448l0-256 192 0 32 0 0-64-32 0L32 128zM96 288l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64z"]
};
const faBlueberries = {
  prefix: 'fass',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm16-304l0 16 0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-32 0-16 32 0zM384 64l0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-32 0-16 32 0 0 16z"]
};
const faTruckRampBox = {
  prefix: 'fass',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M640 0l0 400c0 61.9-50.1 112-112 112c-61.6 0-111.6-49.8-112-111.3L48.6 502.8l-30.8 8.6L.6 449.7l30.8-8.6L352 352.1 352 0 640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM14.8 176.8l77.3-20.7 24.8 92.7 61.8-16.6-24.8-92.7 77.3-20.7 58 216.4-216.4 58-58-216.4z"]
};
const faTruckLoading = faTruckRampBox;
const faNote = {
  prefix: 'fass',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M0 32l448 0 0 288-128 0-32 0 0 32 0 128L0 480 0 32zM402.7 352l45.3 0-32 32-64 64-32 32 0-45.3 0-50.7 0-32 32 0 50.7 0zM112 112l-48 0 0 48 48 0 0-48zM64 232l0 48 48 0 0-48-48 0zm48 120l-48 0 0 48 48 0 0-48z"]
};
const faArrowDownToSquare = {
  prefix: 'fass',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M278.6 342.6l96-96L397.3 224 352 178.7l-22.6 22.6L288 242.7 288 32l0-32L224 0l0 32 0 210.7-41.4-41.4L160 178.7 114.7 224l22.6 22.6 96 96L256 365.3l22.6-22.6zM32 32L0 32 0 64 0 480l0 32 32 0 448 0 32 0 0-32 0-416 0-32-32 0-96 0 0 64 64 0 0 352L64 448 64 96l64 0 0-64L32 32z"]
};
const faUserCheck = {
  prefix: 'fass',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zM617 177L489 305l-17 17-17-17-64-64-17-17L408 190.1l17 17 47 47L583 143l17-17L633.9 160l-17 17z"]
};
const faCloudXmark = {
  prefix: 'fass',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zM417.9 224L384 190.1l-17 17-47 47-47-47-17-17L222.1 224l17 17 47 47-47 47-17 17L256 385.9l17-17 47-47 47 47 17 17L417.9 352l-17-17-47-47 47-47 17-17z"]
};
const faVialVirus = {
  prefix: 'fass',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M0 32l32 0 64 0 64 0 64 0 32 0 0 32 0 32-32 0 0 112.5-47.4 47.4 39.6 39.6 .6 .6-.8 0-56 0 0 112 56 0 .8 0-.6 .6-39.6 39.6 11 11c-16.4 13-37.1 20.8-59.7 20.8c-53 0-96-43-96-96L32 96 0 96 0 64 0 32zM96 96l0 96 64 0 0-96L96 96zM216 376c0 0 0 0 0 0l-24 0 0-24 0-24 24 0c0 0 0 0 .1 0c28.8 0 43.2-34.8 22.8-55.2l-17-17 17-17 17-17 17 17c20.4 20.4 55.2 5.9 55.2-22.9l0-.1 0-23.9 24 0 24 0 0 24 0 .2c.1 28.7 34.9 43 55.2 22.7l17-17 17 17 17 17-17 17c-20.4 20.4-6 55.2 22.8 55.2c0 0 0 0 .1 0l24 0 0 24 0 24-24 0c0 0 0 0 0 0c-28.8 0-43.2 34.8-22.9 55.2l17 17-17 17-17 17-17-17c-20.3-20.3-55-6-55.2 22.7l0 .2 0 24-24 0-24 0 0-23.8 0-.2c0-28.8-34.8-43.2-55.2-22.9l-17 17-17-17-17-17 17-17c20.4-20.4 5.9-55.2-22.9-55.2zm104-24a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBookBlank = {
  prefix: 'fass',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0L448 0 416 0 384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
const faBookAlt = faBookBlank;
const faGolfFlagHole = {
  prefix: 'fass',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M128 0L416 128 175.5 234.9c.4 1.6 .5 3.3 .5 5.1l0 84.8c25.2-3.1 52.1-4.8 80-4.8c141.4 0 256 43 256 96s-114.6 96-256 96S0 469 0 416c0-35.5 51.5-66.6 128-83.2l0-76.8 0-16L128 0zm96 448c35.3 0 64-14.3 64-32s-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32z"]
};
const faMessageArrowDown = {
  prefix: 'fass',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM280 120l0-24-48 0 0 24 0 118.1-31-31-17-17L150.1 224l17 17 72 72 17 17 17-17 72-72 17-17L328 190.1l-17 17-31 31L280 120z"]
};
const faCommentAltArrowDown = faMessageArrowDown;
const faFaceUnamused = {
  prefix: 'fass',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 192l16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32zm208 0l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32 16 0zm12.1 202.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9z"]
};
const faSheetPlastic = {
  prefix: 'fass',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M224 512L0 512 0 0 384 0l0 352-160 0 0 160zm32 0l0-128 128 0L256 512zM171.3 75.3L182.6 64 160 41.4 148.7 52.7l-96 96L41.4 160 64 182.6l11.3-11.3 96-96zm96 32L278.6 96 256 73.4 244.7 84.7l-160 160L73.4 256 96 278.6l11.3-11.3 160-160z"]
};
const faCircle9 = {
  prefix: 'fass',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm96-48c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3l-44.4 48.4L185.4 384l65.1 0 68.1-74.3c21.4-23.4 33.3-54 33.3-85.7z"]
};
const faBlog = {
  prefix: 'fass',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M192 0l0 64c141.4 0 256 114.6 256 256l64 0C512 143.3 368.7 0 192 0zm0 96l0 64c88.4 0 160 71.6 160 160l64 0C416 196.3 315.7 96 192 96zM96 144l0-48L0 96l0 48L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"]
};
const faUserNinja = {
  prefix: 'fass',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0c-49.6 0-92.6 28.2-113.8 69.4c-3-5.8-6.8-11.3-11.7-16.1c-25-25-67.9-22.6-67.9-22.6s-2.4 42.9 22.6 67.9c5.8 5.8 12.6 10.1 19.6 13.4c-7 3.2-13.8 7.6-19.6 13.4c-25 25-22.6 67.9-22.6 67.9s42.9 2.4 67.9-22.6c1.2-1.2 2.4-2.5 3.5-3.8c16.4 51.8 64.8 89.3 122 89.3zM448 512L384 304l-76 0L224 416 140 304l-76 0L0 512l448 0zM160 96l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0z"]
};
const faPencilSlash = {
  prefix: 'fass',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L409.5 295.1l75.2-75.2-16-16-96-96-16-16-91.3 91.3L48.4 14.8zM306.6 215.3l50-50L368 153.9l22.6 22.6-11.3 11.3-47.2 47.2-25.5-19.8zm33.4 149.2L263.2 304l-27.9 27.9L224 343.2l-22.6-22.6 11.3-11.3L237.9 284l-41-32.3L96 352.6l-21.8 109L64 512.6l51-10.2 109-21.8L340.1 364.5zM379.3 69.3l16 16 96 96 16 16 34.7-34.7L576 128.6 542.1 94.6 481.9 34.5 448 .6 414.1 34.5 379.3 69.3zM163.9 352.6l12.1 0 0 48 48 0 0 12.1-23.7 23.7-75.1 15 15-75.1 23.7-23.7z"]
};
const faBowlingPins = {
  prefix: 'fass',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 0c35.3 0 64 28.7 64 64l0 1.1c0 7.4-1 14.8-2.9 21.9l-17.6 64.9c-.7 2.7-1.3 5.4-1.8 8.1l-83.2 0c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22L64 64C64 28.7 92.7 0 128 0zM83.1 209.6c1.9-5.7 3.3-11.6 4.1-17.6l81.8 0c.8 6 2.2 11.8 4.1 17.6l49.3 148.3 3.1 9.4-2.7 9.5-32 112L184.1 512 160 512l-64 0-24.1 0-6.6-23.2-32-112-2.7-9.5 3.1-9.4L83.1 209.6zM384 0c35.3 0 64 28.7 64 64l0 1.1c0 7.4-1 14.8-2.9 21.9l-17.6 64.9c-.7 2.7-1.3 5.4-1.8 8.1l-83.2 0c-.5-2.7-1.1-5.4-1.8-8.1L323 87.1c-2-7.2-3-14.6-3-22l0-1.1c0-35.3 28.7-64 64-64zM339.1 209.6c1.9-5.7 3.3-11.6 4.1-17.6l81.8 0c.8 6 2.2 11.8 4.1 17.6l49.3 148.3 3.1 9.4-2.7 9.5-32 112L440.1 512 416 512l-64 0-24.1 0-6.6-23.2-32-112-2.7-9.5 3.1-9.4 49.4-148.3z"]
};
const faPersonArrowUpFromLine = {
  prefix: 'fass',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L114 142.8l-81.7 128 53.9 34.4 33.8-53L120 448l-88 0L0 448l0 64 32 0 576 0 32 0 0-64-32 0-344 0 0-195.8 33.8 53 53.9-34.4L270 142.8 260.6 128l-17.5 0-102.2 0zM200 448l-16 0 0-96 16 0 0 96zM598.6 121.4l-80-80L496 18.7 473.4 41.4l-80 80L370.7 144 416 189.3l22.6-22.6L464 141.3 464 384l0 32 64 0 0-32 0-242.7 25.4 25.4L576 189.3 621.3 144l-22.6-22.6z"]
};
const faDownRight = {
  prefix: 'fass',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M368 432l0-288-32-32L232 216 80 64 0 144 152 296 48 400l32 32 288 0z"]
};
const faScrollTorah = {
  prefix: 'fass',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M96 0L0 0 0 512l96 0L96 0zM512 32L128 32l0 448 384 0 0-448zM544 0l0 512 96 0L640 0 544 0zM187.1 332l10.5-18 33.8-58-33.8-58-10.5-18 20.9 0 67.8 0 33.9-58L320 104.2l10.4 17.8 33.9 58 67.8 0 20.9 0-10.5 18-33.8 58 33.8 58 10.5 18L432 332l-67.8 0-33.9 58L320 407.8 309.6 390l-33.9-58L208 332l-20.9 0zM320 360.2L336.4 332l-32.9 0L320 360.2zM289.6 308l60.9 0 30.3-52-30.3-52-60.9 0-30.3 52 30.3 52zm105.1-28.2L378.2 308l32.9 0-16.4-28.2zM411.1 204l-32.9 0 16.4 28.2L411.1 204zM320 151.8L303.6 180l32.9 0L320 151.8zm-74.7 80.4L261.8 204l-32.9 0 16.4 28.2zM261.8 308l-16.4-28.2L228.9 308l32.9 0z"]
};
const faTorah = faScrollTorah;
const faWebhook = {
  prefix: 'fass',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M208 128c0-44.2 35.8-80 80-80s80 35.8 80 80c0 10.7-2.1 20.8-5.8 30l44.5 18c6-14.9 9.3-31.1 9.3-48.1C416 57.3 358.7 0 288 0S160 57.3 160 128c0 37.1 15.8 70.5 41 93.9L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5 12.7-20.3-20.3-12.7C223 181.7 208 156.6 208 128zm81.7 48l82.8 132.5 12.7 20.4 20.4-12.8c12.3-7.7 26.8-12.1 42.4-12.1c44.2 0 80 35.8 80 80s-35.8 80-80 80c-22.2 0-42.2-9-56.8-23.6l-34.1 33.8C380.3 497.5 412.5 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-16.3 0-31.9 3.1-46.3 8.6L330.4 150.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0zM448 432c26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24L232 360l-24 0 0 24c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-39.7 28.9-72.7 66.8-78.9L107 257.7C46.3 267.7 0 320.4 0 384c0 70.7 57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l152.7 0c8.3 14.3 23.8 24 41.6 24z"]
};
const faBlindsOpen = {
  prefix: 'fass',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M0 0L32 0 480 0l32 0 0 64-32 0L160 64l0 64 0 64 0 66.7c13.6 4.8 24.4 15.6 29.3 29.3c.1 .3 .2 .7 .4 1c1.5 4.7 2.4 9.7 2.4 15c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7 0-64 0-64L32 64 0 64 0 0zM40 128l56 0 0 64L0 192l40-64zm0 160l25.6 0c-1 5.2-1.6 10.5-1.6 16c0 18 6 34.6 16 48L0 352l40-64zm472 64l-304 0c10-13.4 16-30 16-48c0-5.5-.6-10.8-1.6-16L472 288l40 64zm0-160l-320 0 0-64 280 0 40 64zM0 512l40-64 432 0 40 64L0 512z"]
};
const faFence = {
  prefix: 'fass',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M64 32L0 96 0 480l128 0 0-64 32 0 0-64-32 0 0-128 32 0 0-64-32 0 0-64L64 32zM320 352l0-128 32 0 0-64-32 0 0-64L256 32 192 96l0 384 128 0 0-64 32 0 0-64-32 0zM448 32L384 96l0 384 128 0 0-384L448 32z"]
};
const faUp = {
  prefix: 'fass',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M192 32L0 224l0 32 128 0 0 224 128 0 0-224 128 0 0-32L192 32z"]
};
const faArrowAltUp = faUp;
const faBroomBall = {
  prefix: 'fass',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M376 248l40 40 0 32-51.7 0L256 211.7l0-51.7 32 0 40 40L528 0l48 48L376 248zM222.6 234.9L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L0 512l0-32L160 336 64 384l0-3.5c0-38.8 15.4-75.9 42.8-103.4c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faQuidditch = faBroomBall;
const faQuidditchBroomBall = faBroomBall;
const faDrumstick = {
  prefix: 'fass',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M160 278.5L160 176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176l-102.5 0-58.4 58.3C185.6 421.1 192 435.8 192 452c0 33.1-26.9 60-60 60s-60-26.9-60-60l0-12-12 0c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.6 16.8L160 278.5z"]
};
const faSquareV = {
  prefix: 'fass',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M448 32L0 32 0 480l448 0 0-448zM351.9 144L246 385.6 239.7 400l-31.4 0L202 385.6 96.1 144l52.4 0L224 316.2 299.5 144l52.4 0z"]
};
const faFaceAwesome = {
  prefix: 'fass',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2c-3.3-.5-6.6-.8-10-.8c-35.3 0-64 28.7-64 64l0 40 128 0 0-40c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22c-5.4-1.3-11-2-16.8-2c-39.8 0-72 32.2-72 72l0 32 144 0 0-32c0-10.4-2.2-20.2-6.1-29.1c-5.8 8-15.2 13.1-25.9 13.1zm48 112s0 0 0 0l-32.6 0-286.7 0L80 288s0 0 0 0l3.8 18.8c.9 4.5 2 8.9 3.2 13.2c21.1 75.2 89.9 128 169.1 128c55.9 0 106.6-26.3 139-68.3c0 0 0 0 0 0c16.2-20.9 27.8-45.6 33.2-73L432 288zM240.1 415.1c1.7-44 37.8-79.1 82.2-79.1c19.6 0 37.6 6.8 51.7 18.3C347.8 392 304.3 416 256 416c-5.4 0-10.7-.3-15.9-.9z"]
};
const faGaveDandy = faFaceAwesome;
const faDialOff = {
  prefix: 'fass',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zm448 32c0 80.2-59 146.6-136 158.2L312 288l0-24-48 0 0 24 0 158.2c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160s160 71.6 160 160z"]
};
const faToggleOff = {
  prefix: 'fass',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M512 128l0 256L64 384l0-256 448 0zm64-64l-64 0L64 64 0 64l0 64L0 384l0 64 64 0 448 0 64 0 0-64 0-256 0-64zM96 160l0 192 192 0 0-192L96 160z"]
};
const faFaceSmileHorns = {
  prefix: 'fass',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 0C264.6 0 213.2 17.6 171.3 47.6C57.1 42.8 0 0 0 0C0 80.1 55.6 160.1 74.1 184.5C67.5 207.2 64 231.2 64 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-24.8-3.5-48.8-10.1-71.5C584.4 160.1 640 80.1 640 0c0 0-57.1 42.8-171.3 47.6C426.8 17.6 375.4 0 320 0zM272.4 272c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32zM320 424c-71.6 0-113.7-47.7-126.3-72.8l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C433.7 376.3 391.6 424 320 424z"]
};
const faBoxArchive = {
  prefix: 'fass',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M512 32l0 96L0 128 0 32l512 0zM32 160l448 0 0 320L32 480l0-320zm128 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z"]
};
const faArchive = faBoxArchive;
const faGrapes = {
  prefix: 'fass',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M360 0s-40 40-40 80s7.3 55.3 32 80s40 32 80 32s80-40 80-40s-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80zM304 152a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM112 232a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm32 80A56 56 0 1 0 32 312a56 56 0 1 0 112 0zM112 456A56 56 0 1 0 0 456a56 56 0 1 0 112 0zm144-32a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM280 288a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
const faPersonDrowning = {
  prefix: 'fass',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M192 64l0-32-64 0 0 32 0 144 0 23.4 22.3 7.1 37.6 12-18.4 129c7.7 2.2 15.3 3.5 22.5 3.5c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0l1.1-.8L288 336l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c6.9 3.2 14.2 5.9 21.5 7.7l17.1-94 137.2-31.2 31.2-7.1-14.2-62.4-31.2 7.1L337.4 230.9 192 184.6 192 64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM272.4 461.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 409.9 19.3 416 0 416l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faDialMax = {
  prefix: 'fass',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zm401.4-81.3c56.7 56.7 62 145.4 15.7 208L305.3 270.9l-17-17-33.9 33.9 17 17L383.2 416.7c-62.6 46.2-151.3 41-208-15.7c-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0z"]
};
const faCircleM = {
  prefix: 'fass',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 152l0-24 36.3 0 7.2 9.9L256 255l84.5-117.1 7.2-9.9 36.3 0 0 24 0 208 0 24-48 0 0-24 0-133.8-60.5 83.8L256 337l-19.5-26.9L176 226.2 176 360l0 24-48 0 0-24 0-208z"]
};
const faCalendarImage = {
  prefix: 'fass',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320zM160 344l24 32 72-104L368 448 80 448l80-104zm-32-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleCaretDown = {
  prefix: 'fass',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM384 240L256 368 128 240l0-32 256 0 0 32z"]
};
const faCaretCircleDown = faCircleCaretDown;
const faArrowDown91 = {
  prefix: 'fass',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M160 479.4l23.6-25.7 88-96L293.2 334 246 290.8l-21.6 23.6L192 349.7 192 64l0-32-64 0 0 32 0 285.7L95.6 314.4 74 290.8 26.8 334l21.6 23.6 88 96L160 479.4zM352 288l0 64 32 0 16 0 0 64-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-96 0-32-32 0-48 0-32 0zM432 88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-88 32c0 42.3 29.9 77.7 69.8 86.1l-25.1 41.3-5.2 8.6 74.9 0L502 184.1c11.7-19.3 18-41.5 18-64.1c0-48.6-39.4-88-88-88s-88 39.4-88 88z"]
};
const faSortNumericDesc = faArrowDown91;
const faSortNumericDownAlt = faArrowDown91;
const faFaceGrinTongueSquint = {
  prefix: 'fass',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-31.9-23.3-55.2-57.8-64-97.9c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm230.9-64L112 256l45.7-64L112 128l118.9 64zM400 128l-45.7 64L400 256 281.1 192 400 128zM320 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faGrinTongueSquint = faFaceGrinTongueSquint;
const faShishKebab = {
  prefix: 'fass',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L416 141.3l-22.6 22.6L349.3 208 304 162.7l25.4-25.4c-17-35.7-10.8-79.7 18.8-109.3c37.5-37.5 98.3-37.5 135.8 0c31.4 31.4 36.5 79.2 15.3 115.9l-55.4-32c7.1-12.2 5.3-28.2-5.1-38.6zM104 453.3L46.6 510.6 1.4 465.4 58.7 408 104 453.3zM128 208l88-88L392 296l-88 88L128 208zM16 320l88-88L280 408l-88 88L16 320z"]
};
const faSprayCan = {
  prefix: 'fass',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M224 0l0 128L96 128 96 0 224 0zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 256L0 512 0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faAlarmSnooze = {
  prefix: 'fass',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192l96 0 40.8 0L317 227.7 256.8 336l55.2 0 24 0 0 48-24 0-96 0-40.8 0L195 348.3 255.2 240 200 240l-24 0 0-48 24 0z"]
};
const faScarecrow = {
  prefix: 'fass',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M320 96c0 11.2-1.9 22-5.5 32L432 128l-16 32 32 32-32 32 16 32-112 0 32 160-64-32-64 32-64-32L96 416l32-160L16 256l16-32L0 192l32-32L16 128l117.5 0c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 480l0-44.2 17.7 8.8 14.3 7.2 14.3-7.2 17.7-8.8 0 44.2 0 32-64 0 0-32z"]
};
const faTruckMonster = {
  prefix: 'fass',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M224 0l32 0L384 0l16 0 9.6 12.8L496 128l112 0 0 96 32 0 0 64-32 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64l-64 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64L0 288l0-64 32 0 0-96 192 0 0-96 0-32zM368 64l-80 0 0 64 128 0L368 64zM128 256l64 0 0 20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3l20.6 0 0 64-20.6 0c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8l0 20.6-64 0 0-20.6c-7.4-2.2-14.6-5.2-21.3-8.8L92.1 497.1 46.9 451.9l14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3L32 416l0-64 20.6 0c2.2-7.4 5.2-14.6 8.8-21.3L46.9 316.1l45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8l0-20.6zm32 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448 276.6l0-20.6 64 0 0 20.6c7.4 2.2 14.6 5.2 21.3 8.8l14.6-14.6 45.3 45.3-14.6 14.6c3.6 6.7 6.6 13.8 8.8 21.3l20.6 0 0 64-20.6 0c-2.2 7.4-5.2 14.6-8.8 21.3l14.6 14.6-45.3 45.3-14.6-14.6c-6.7 3.6-13.8 6.6-21.3 8.8l0 20.6-64 0 0-20.6c-7.4-2.2-14.6-5.2-21.3-8.8l-14.6 14.6-45.3-45.3 14.6-14.6c-3.6-6.7-6.6-13.8-8.8-21.3L352 416l0-64 20.6 0c2.2-7.4 5.2-14.6 8.8-21.3l-14.6-14.6 45.3-45.3 14.6 14.6c6.7-3.6 13.8-6.6 21.3-8.8zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faGiftCard = {
  prefix: 'fass',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M353.5 68.8C361.1 55.9 374.9 48 389.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-72 0-1.3 0 34.8-59.2zm-131 0L257.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3L288 85.5l-24.1-41C247.7 16.9 218.1 0 186.2 0L184 0C135.4 0 96 39.4 96 88c0 14.4 3.5 28 9.6 40L64 128 0 128l0 64L0 448l0 64 64 0 448 0 64 0 0-64 0-256 0-64-64 0-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM512 384l0 64L64 448l0-64 448 0zm0-64L64 320l0-128 166.1 0-40.5 48.6 36.9 30.7L288 197.5l61.6 73.9 36.9-30.7L345.9 192 512 192l0 128z"]
};
const faW = {
  prefix: 'fass',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M506.8 32l67.6 0L430.3 458.2 423 480l-47 0-6.7-23L288 178.3 206.7 457 200 480l-47 0-7.4-21.8L1.6 32l67.6 0L173.8 341.4 257.3 55 264 32l48 0 6.7 23 83.5 286.4L506.8 32z"]
};
const faCodePullRequestDraft = {
  prefix: 'fass',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M56 56l0 48 48 0 0-48L56 56zM0 0L56 0l48 0 56 0 0 56 0 48 0 56-48 0 0 192 48 0 0 56 0 48 0 56-56 0-48 0L0 512l0-56 0-48 0-56 48 0 0-192L0 160l0-56L0 56 0 0zM56 408l0 48 48 0 0-48-48 0zm336 0l-48 0 0 48 48 0 0-48zm-48-56l48 0 56 0 0 56 0 48 0 56-56 0-48 0-56 0 0-56 0-48 0-56 56 0zM320 192l96 0 0 96-96 0 0-96zM416 32l0 96-96 0 0-96 96 0z"]
};
const faSquareB = {
  prefix: 'fass',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M448 32L0 32 0 480l448 0 0-448zM128 128l24 0 92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0-24 0 0-24 0-80 0-24 0-24 0-80 0-24zm144 76c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM176 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z"]
};
const faElephant = {
  prefix: 'fass',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M121.9 72.6c11.7-9.1 24.5-16.9 38.1-23.2l0 62.6c0 79.5 64.5 144 144 144l16 0 0-32-16 0c-61.9 0-112-50.1-112-112l0-74 0-38L304 0c30.5 0 58.2 12.2 78.4 32l1.6 0c88.4 0 160 71.6 160 160l0 119.4c-9.4 5.4-20.3 8.6-32 8.6c-20.9 0-39.5-10-51.2-25.6l-25.6 19.2c6.6 8.7 14.6 16.3 23.7 22.4c0 0 0 0 0 0c6.5 4.3 13.6 7.9 21.1 10.5c0 0 0 0 0 0c10 3.5 20.8 5.5 32 5.5s22-1.9 32-5.5c0 0 0 0 0 0c13.9-4.9 26.4-13 36.6-23.4l11.2-11.4 22.9 22.4-11.2 11.4C587.4 362 566.9 374.1 544 380l0 21.5c0 8 6.5 14.5 14.5 14.5c6.2 0 11.8-4 13.7-9.9l5.4-16.2 60.7 20.2L633 426.3c-10.7 32.1-40.7 53.7-74.5 53.7c-43.4 0-78.5-35.1-78.5-78.5l0-21.5c-25.2-6.5-47.3-20.4-64-39.3L416 512l-128 0 0-102c-15.3 3.9-31.4 6-48 6s-32.7-2.1-48-6l0 102L64 512l0-174.9L45.9 377.7 2.1 358.3 32 290.9 32 248c0-72.2 35.4-136.2 89.9-175.4zM464 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faEarthAfrica = {
  prefix: 'fass',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M454 192C427 108.4 348.5 48 256 48c-22.3 0-43.8 3.5-64 10l0 102 32 0 32-32 96 0-64 64-88 0-40 40 0 88 96 0 0 96 48 0 48-48 0-48 32 0 0-64-32-32 0-32 102 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faGlobeAfrica = faEarthAfrica;
const faRainbow = {
  prefix: 'fass',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 96C178.6 96 64 210.6 64 352l0 96 0 32L0 480l0-32 0-96C0 175.3 143.3 32 320 32s320 143.3 320 320l0 96 0 32-64 0 0-32 0-96C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64l0 96 0 32-64 0 0-32 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96 0 32-64 0 0-32 0-96c0-35.3-28.7-64-64-64zM160 352l0 96 0 32-64 0 0-32 0-96c0-123.7 100.3-224 224-224s224 100.3 224 224l0 96 0 32-64 0 0-32 0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"]
};
const faCircleNotch = {
  prefix: 'fass',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M201.1 71.9C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1l18.3-61.3C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6l18.3 61.3z"]
};
const faTabletScreenButton = {
  prefix: 'fass',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M0 0L448 0l0 512L0 512 0 0zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z"]
};
const faTabletAlt = faTabletScreenButton;
const faPaw = {
  prefix: 'fass',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5zM234.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM64 480c0-176 128-256 192-256s192 80 192 256L256 432 64 480zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3z"]
};
const faMessageQuestion = {
  prefix: 'fass',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM168 136l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 188.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 80c-30.9 0-56 25.1-56 56zm64 152l0 48 48 0 0-48-48 0z"]
};
const faCloud = {
  prefix: 'fass',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336L0 480z"]
};
const faTrowelBricks = {
  prefix: 'fass',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M256 152l0 104-48 0L0 128 208 0l48 0 0 104 88 0 0-24 168 0 0 96-168 0 0-24-88 0zm32 72l224 0 0 128-224 0 0-128zM160 384l0 128L0 512 0 384l160 0zm352 0l0 128-320 0 0-128 320 0z"]
};
const faSquare3 = {
  prefix: 'fass',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M448 32L0 32 0 480l448 0 0-448zM280 128l24 0 0 34.6-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2l-25.2 0c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4l25.2 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1 0-34.7 7.8-7.1L218.3 176 152 176l-24 0 0-48 24 0 128 0z"]
};
const faFaceFlushed = {
  prefix: 'fass',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 400l16 0 128 0 16 0 0-32-16 0-128 0-16 0 0 32zM160 296a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faFlushed = faFaceFlushed;
const faHospitalUser = {
  prefix: 'fass',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M320 0L0 0 0 256l144 0 16 0 0 32-16 0L0 288l0 64 144 0 16 0 0 32-16 0L0 384 0 512l253.1 0L320 359 320 0zM184 64l0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm8 112l-176 0L288 512l288 0L520 384z"]
};
const faMicrowave = {
  prefix: 'fass',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M0 32l576 0 0 416-64 0 0 32-64 0 0-32-320 0 0 32-64 0 0-32L0 448 0 32zm96 96l0 224 320 0 0-224L96 128zm416-16l-32 0 0 256 32 0 0-256z"]
};
const faChfSign = {
  prefix: 'fass',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M80 96c-8.8 0-16 7.2-16 16l0 272 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 64 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16L0 112C0 67.8 35.8 32 80 32s80 35.8 80 80l0 16-64 0 0-16c0-8.8-7.2-16-16-16zM256 32l0 32 0 160 96 0 0-160 0-32 64 0 0 32 0 384 0 32-64 0 0-32 0-160-96 0 0 160 0 32-64 0 0-32 0-384 0-32 64 0zm192 0l32 0 128 0 32 0 0 64-32 0-96 0 0 128 64 0 32 0 0 64-32 0-64 0 0 160 0 32-64 0 0-32 0-384 0-32z"]
};
const faTentArrowLeftRight = {
  prefix: 'fass',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M109.8 52.2L89.9 72l396.1 0L466.2 52.2l-17-17L483.2 1.3l17 17L561 79l17 17-17 17-60.8 60.8-17 17-33.9-33.9 17-17L486.1 120 89.9 120l19.8 19.8 17 17L92.8 190.7l-17-17L15 113l-17-17L15 79 75.8 18.2l17-17 33.9 33.9-17 17zM64 512L96 288 288 160 480 288l32 224-128 0L288 352l0 160L64 512z"]
};
const faCartCircleArrowUp = {
  prefix: 'fass',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM417.4 360l11.3-11.3 56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6l0 89.4 0 16-32 0 0-16 0-89.4-28.7 28.7L440 382.6 417.4 360z"]
};
const faTrashClock = {
  prefix: 'fass',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM416 128L32 128 56 512l274.8 0C285.6 480.1 256 427.5 256 368c0-90.4 68.2-164.9 155.9-174.9L416 128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288l0 16 0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0z"]
};
const faReflectBoth = {
  prefix: 'fass',
  iconName: 'reflect-both',
  icon: [512, 512, [], "e66f", "M96 32L256 192 416 32l0-32L96 0l0 32zm96 224L32 96 0 96 0 416l32 0L192 256zm128 0L480 416l32 0 0-320-32 0L320 256zm-64 64L96 480l0 32 320 0 0-32L256 320z"]
};
const faGavel = {
  prefix: 'fass',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M344 56L320 80 432 192l24-24 56 56L368 368l-56-56 24-24L224 176l-24 24-56-56L288 0l56 56zM214.6 342.6L232 360 80 512 0 432 152 280l17.4 17.4L234.7 232 280 277.3l-65.4 65.4z"]
};
const faLegal = faGavel;
const faSprinklerCeiling = {
  prefix: 'fass',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0L0 96l0 26.2 25.7 5.1L128 147.8l0-65.3L64 69.8 64 0 0 0zM256 82.6l0 65.3 102.3-20.5 25.7-5.1L384 96l0-96L320 0l0 69.8L256 82.6zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 64l0-32-64 0 0 32 0 128-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-128z"]
};
const faBrowsers = {
  prefix: 'fass',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M576 0L96 0l0 416 480 0L576 0zM512 72l0 48-256 0 0-48 256 0zM160 64l64 0 0 64-64 0 0-64zM48 120l0-24L0 96l0 24L0 488l0 24 24 0 432 0 24 0 0-48-24 0L48 464l0-344z"]
};
const faTrillium = {
  prefix: 'fass',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M224 0s-96 80-96 160c0 14.5 3.2 28.2 8.9 40.5c-13.1 1.3-26.1 5.4-38.2 12.4C29.4 252.9 8.2 376 8.2 376s117.3 43.1 186.6 3.1c11.8-6.8 21.7-15.8 29.3-26.1c7.6 10.3 17.4 19.3 29.3 26.1c69.3 40 186.6-3.1 186.6-3.1s-21.3-123.1-90.6-163.1c-12.1-7-25.1-11.1-38.2-12.4c5.7-12.3 8.9-26 8.9-40.5C320 80 224 0 224 0zM184 240a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM-4 120.5s-1.5 42.2 54.4 90.3c9.5-9.8 20.3-18.6 32.4-25.6c4.7-2.7 9.6-5.1 14.5-7.2c-.8-5.9-1.3-11.9-1.3-17.9c0-12.9 1.9-25.5 5.1-37.7C31.7 98.2-4 120.5-4 120.5zM210.7 406.9c-11.8 6.8-24.4 11.7-37.3 15C187.5 492.6 224 512 224 512s36.5-19.4 50.6-90.2c-12.9-3.3-25.5-8.2-37.3-15c-4.7-2.7-9.1-5.6-13.3-8.8c-4.2 3.2-8.6 6.1-13.3 8.8zM365.3 185.1c12.5 7.2 23.5 16.3 33.3 26.5c56.9-48.5 55.4-91.2 55.4-91.2s-36.3-22.7-106.9 2.5c3.1 12 4.9 24.4 4.9 37c0 6.1-.4 12.1-1.2 17.9c4.9 2.1 9.8 4.5 14.5 7.2z"]
};
const faTableCellsUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-unlock',
  icon: [640, 512, [], "e692", "M512 32L0 32 0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32zM152 96l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm288-80c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-32 0-48 0-32 0-32 0 0-48z"]
};
const faMusicSlash = {
  prefix: 'fass',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M48.4 14.8L29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7-60.8-47.2c10-12.6 15.9-27.8 15.9-44.1l0-248 0-72 0-43L534.8 17.4l-320 96L192 120.2l0 6.1L48.4 14.8zM315.3 222L512 163l0 129.5c-10-2.9-20.8-4.6-32-4.6c-22 0-42.2 6.2-58.4 16.5L315.3 222zM192 247.3l0 109.3c-10-2.9-20.8-4.6-32-4.6c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-134.3-64-50.4z"]
};
const faTruckRamp = {
  prefix: 'fass',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M640 400L640 0 352 0l0 352.1L31.4 441.2 .6 449.7l17.1 61.7 30.8-8.6L416 400.7c.4 61.5 50.4 111.3 112 111.3c61.9 0 112-50.1 112-112zM528 352a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faBinoculars = {
  prefix: 'fass',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M192 32l0 64L96 96l0-64 96 0zm0 96l0 352L0 480 0 336l48-80L64 128l128 0zm128 0l128 0 16 128 48 80 0 144-192 0 0-352zm0-96l96 0 0 64-96 0 0-64zm-32 96l0 160-64 0 0-160 64 0z"]
};
const faMicrophoneSlash = {
  prefix: 'fass',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M224 0L416 0l0 300.2 18 14c8.9-17.5 14-37.2 14-58.2l0-40 0-24 48 0 0 24 0 40c0 32.1-8.6 62.1-23.6 88L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1l19 14.7L224 151.1 224 0zM358.2 378.2l43.1 33.9c-17.6 9.2-36.9 15.4-57.3 18.2l0 33.6 48 0 24 0 0 48-24 0-72 0-72 0-24 0 0-48 24 0 48 0 0-33.6C210.1 418.7 144 345.1 144 256l0-40 0-6.5 48 37.8 0 8.7c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"]
};
const faBoxTissue = {
  prefix: 'fass',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M113.8 224L64 0 208 0c40 0 52 24 64 48s24 48 64 48l112 0L405.3 224 384 288l-256 0-14.2-64zM95.2 288L64 288l0 32 38.3 0 25.7 0 256 0 23.1 0 40.9 0 0-32-30.3 0 21.3-64 72.9 0 0 160L0 384 0 224l81 0 14.2 64zM0 416l512 0 0 96L0 512l0-96z"]
};
const faCircleC = {
  prefix: 'fass',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80z"]
};
const faStarChristmas = {
  prefix: 'fass',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M0 256l192 64 64 192 64-192 192-64L320 192 256 0 192 192 0 256zM54.1 88l17 17 48 48 17 17L169.9 136l-17-17L105 71l-17-17L54.1 88zm403.9 0L424 54.1 407 71l-48 48-17 17L376 169.9l17-17 48-48 17-17zM441 407l-48-48-17-17L342.1 376l17 17 48 48 17 17L457.9 424l-17-17zM54.1 424L88 457.9l17-17 48-48 17-17L136 342.1l-17 17L71 407l-17 17z"]
};
const faChartBullet = {
  prefix: 'fass',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M288 32l0 24 0 8 160 0 64 0 0 64 0 32 0 64-64 0-160 0 0 8 0 24-48 0 0-24 0-8L64 224 0 224l0-64 0-32L0 64l64 0 176 0 0-8 0-24 48 0zM160 128l0 32 80 0 0-32-80 0zm128 0l0 32 160 0 0-32-160 0zm48 224l-80 0 0 32 80 0 0-32zm0-64l0-8 0-24 48 0 0 24 0 8 64 0 64 0 0 64 0 32 0 64-64 0-64 0 0 8 0 24-48 0 0-24 0-8L64 448 0 448l0-64 0-32 0-64 64 0 272 0zm48 64l0 32 64 0 0-32-64 0z"]
};
const faMotorcycle = {
  prefix: 'fass',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M280 32l-24 0 0 48 24 0 57.7 0 16.4 30.3L256 192l-64-64L32 128l0 64 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l93.8 0 0-96-64 0L391.7 78.9 373.1 44.6 366.3 32 352 32l-72 0zM462.7 311.2l28.2 52.2 42.2-22.8-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l66.4 0C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l-66.4 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTreeChristmas = {
  prefix: 'fass',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M144 81.3l53.3-28L224 0l26.7 53.3L304 80l-53.3 26.7L224 160l-26.7-53.3L144 81.3zM24 320L174.3 132.1 204.2 192l39.6 0 29.9-59.9L424 320l0 32-56 0 80 128 0 32L0 512l0-32L80 352l-56 0 0-32zm160-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM288 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faTireFlat = {
  prefix: 'fass',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M256 32C114.6 32 0 146.6 0 288c0 47.9 13.2 92.8 36.1 131.1L0 448l0 64 512 0 0-64-36.1-28.9C498.8 380.8 512 335.9 512 288C512 146.6 397.4 32 256 32zm96 384c-2.1 1.6-4.3 3.2-6.6 4.7C319.9 437.9 289.1 448 256 448c-36 0-69.3-11.9-96-32c-38.9-29.2-64-75.7-64-128c0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128zm-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6l0 65zM381.7 312.2c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1z"]
};
const faSunglasses = {
  prefix: 'fass',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-8.1 29-16.1 57.8-26.2 100.6L224 272l32 0 0 32 64 0 0-32 32 0 175.3 0c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1s0 0 0 0s0 0 0 0s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8s0 0 0 0l0 32 0 48 0 24 0 72 0 32-32 0-192 0-32 0 0-32 0-80-64 0 0 80 0 32-32 0L32 480 0 480l0-32 0-72 0-24 0-48 0-32s0 0 0 0l0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM64 336l0 60 120-60L64 336zm320 52l104-52-104 0 0 52z"]
};
const faBadge = {
  prefix: 'fass',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z"]
};
const faMessagePen = {
  prefix: 'fass',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM304.8 112l-29.1 29.1L323 188.4l29.1-29.1L304.8 112zm-51.7 51.7l-85.2 85.2L160 304.1l55.3-7.9L300.4 211l-47.3-47.3z"]
};
const faCommentAltEdit = faMessagePen;
const faMessageEdit = faMessagePen;
const faBellConcierge = {
  prefix: 'fass',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64l-24 0 0 48 24 0 16 0 0 33.3C119.6 157.2 32 252.4 32 368l448 0c0-115.6-87.6-210.8-200-222.7l0-33.3 16 0 24 0 0-48-24 0-40 0-40 0zM24 400L0 400l0 48 24 0 464 0 24 0 0-48-24 0L24 400z"]
};
const faConciergeBell = faBellConcierge;
const faPenRuler = {
  prefix: 'fass',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M195.3 67.3l-56 56L128 134.6 105.4 112l11.3-11.3 56-56L128 0 0 128 105.4 233.4l128-128L195.3 67.3zM384 512L512 384l-44.7-44.7-56 56L400 406.6 377.4 384l11.3-11.3 56-56-38.1-38.1-128 128L384 512zM32 352L0 512l160-32L420.7 219.3l-128-128L32 352zM512 128L384 0 315.3 68.7l128 128L512 128z"]
};
const faPencilRuler = faPenRuler;
const faFileMp3 = {
  prefix: 'fass',
  iconName: 'file-mp3',
  icon: [512, 512, [], "e648", "M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM256 368l0 128 0 16-32 0 0-16 0-74.2-17.9 33.7-13.9 26.2-14.3-26L160 423l0 73 0 16-32 0 0-16 0-128 0-16 16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0 0 16zm48-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48l-32 0-16 0 0-32 16 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0-16 0 0-32 16 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0-16 0 0-32 16 0z"]
};
const faArrowProgress = {
  prefix: 'fass',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M256 128l0-32L64 96l0 128 416 0 32 0 0 32 0 192 0 32-32 0-64 0 0 32-128 0 0-128 128 0 0 32 32 0 0-128L32 288 0 288l0-32L0 64 0 32l32 0 224 0 0-32 24 0 72 64-72 64-24 0zM128 384l0 32 32 0 0-32 24 0 72 64-72 64-24 0 0-32-32 0 0 32L0 512 0 384l128 0zM512 0l0 128-128 0L384 0 512 0z"]
};
const faChessRookPiece = {
  prefix: 'fass',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M67.4 384L80 264 40 224 40 96l56 0 0 48 32 0 0-48 64 0 0 48 32 0 0-48 56 0 0 128-40 40 12.6 120L67.4 384zM136 248l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM16 512l0-32 48-64 192 0 48 64 0 32L16 512z"]
};
const faChessRookAlt = faChessRookPiece;
const faSquareRoot = {
  prefix: 'fass',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M320 32l-24 0-6.7 23L198.1 367.6 123.6 239.9 114.4 224 96 224l-64 0L0 224l0 64 32 0 45.6 0L180.4 464.1l9.3 15.9 42.4 0 6.7-23L344 96l200 0 32 0 0-64-32 0L320 32z"]
};
const faAlbumCollectionCirclePlus = {
  prefix: 'fass',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M32 0L56 0 456 0l24 0 0 48-24 0L56 48 32 48 32 0zm8 512L0 160l512 0-3.7 32.4c-4.1-.3-8.2-.4-12.3-.4c-46.9 0-89.5 18.3-121 48.2C342.9 220.1 301.4 208 256 208C154.4 208 72 268.9 72 344s82.4 136 184 136c33.2 0 64.4-6.5 91.3-17.9c12.4 19.6 28.6 36.6 47.5 49.9L40 512zM256 376c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM40 80l432 0 24 0 0 48-24 0L40 128l-24 0 0-48 24 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faPeopleArrows = {
  prefix: 'fass',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm9.4 198.6L114.7 304l22.6-22.6 88-88L224 160 32 160 24 352l40 0 0 160 128 0 0-130.7-54.6-54.6zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM616 352l-8-192-192 0-1.4 33.4 88 88L525.3 304l-22.6 22.6L448 381.3 448 512l128 0 0-160 40 0zM272 192L160 304 272 416l0-80 96 0 0 80L480 304 368 192l0 80-96 0 0-80z"]
};
const faPeopleArrowsLeftRight = faPeopleArrows;
const faSignPost = {
  prefix: 'fass',
  iconName: 'sign-post',
  icon: [512, 512, [], "e624", "M224 0l64 0 0 64 144 0 80 96-80 96L32 256 32 64l192 0 0-64zm64 288l0 224-64 0 0-224 64 0z"]
};
const faFaceAngryHorns = {
  prefix: 'fass',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 0C264.6 0 213.2 17.6 171.3 47.6C57.1 42.8 0 0 0 0C0 80.1 55.6 160.1 74.1 184.5C67.5 207.2 64 231.2 64 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-24.8-3.5-48.8-10.1-71.5C584.4 160.1 640 80.1 640 0c0 0-57.1 42.8-171.3 47.6C426.8 17.6 375.4 0 320 0zm70.8 422.6l-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C252.2 371.4 280.3 352 320 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4zM240.4 304c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8z"]
};
const faMarsAndVenusBurst = {
  prefix: 'fass',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M176 0L133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2 100 236.6l-.4 98L176 273.2l57.2 46c-16-28-25.2-60.5-25.2-95.2c0-60.7 28.1-114.7 72.1-149.9L218.2 88.5 176 0zM640 0L512 0 480 32l47 47-23.2 23.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2l0 1.8 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3-24 0-24 0 0 48 24 0 24 0 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1c0 0 0 .1 0 .1s0 .1 0 .1l0 .1c0 0 0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l24 0-24 0 0 24 48 0 0-24-24 0 24 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0 0 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1s0-.1 0-.1l0-.1c0 0 0-.1 0-.1s0-.1 0-.1l0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.1 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 24 0 24 0 0-48-24 0-24 0 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-1.8c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L561 113l47 47 32-32L640 0zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faTombstone = {
  prefix: 'fass',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M32 192C32 86 118 0 224 0S416 86 416 192l0 224L32 416l0-224zM0 448l32 0 384 0 32 0 0 64-32 0L32 512 0 512l0-64zM248 120l0-24-48 0 0 24 0 40-48 0-24 0 0 48 24 0 48 0 0 120 0 24 48 0 0-24 0-120 48 0 24 0 0-48-24 0-48 0 0-40z"]
};
const faSquareCaretRight = {
  prefix: 'fass',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M448 480l0-448L0 32 0 480l448 0zM192 128L320 256 192 384l-32 0 0-256 32 0z"]
};
const faCaretSquareRight = faSquareCaretRight;
const faScissors = {
  prefix: 'fass',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M160 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-7.5 104.5c-12.6 4.9-26.2 7.5-40.5 7.5C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 14.3-2.7 27.9-7.5 40.5L256 192 416 32l64 0 32 32L216.5 359.5c4.9 12.6 7.5 26.2 7.5 40.5c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c14.3 0 27.9 2.7 40.5 7.5L192 256l-39.5-39.5zM278.6 342.6l64-64L512 448l-32 32-64 0L278.6 342.6zM112 352a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]
};
const faCut = faScissors;
const faListMusic = {
  prefix: 'fass',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M512 .4l0 44.4 0 64 0 23.1-21.9 7.3L416 163.9 416 432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c17.2 0 33.5 2.8 48 7.7l0-218.9 0-64 0-23.1 21.9-7.3 96-32L512 .4zM32 64l224 0 32 0 0 64-32 0L32 128 0 128 0 64l32 0zm0 128l224 0 32 0 0 64-32 0L32 256 0 256l0-64 32 0zm0 128l96 0 32 0 0 64-32 0-96 0L0 384l0-64 32 0z"]
};
const faSunPlantWilt = {
  prefix: 'fass',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M194.4 76.9L160 0 125.6 76.9 46.9 46.9l30.1 78.7L0 160l76.9 34.4L46.9 273.1l78.7-30.1L160 320l34.4-76.9 78.7 30.1-30.1-78.7L320 160l-76.9-34.4 30.1-78.7L194.4 76.9zM160 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4c-14.8 7.7-24 23.1-24 44.6c0 19.5 21.5 52.9 48 78c26.5-25 48-58.7 48-78c0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.7-24 23.1-24 44.6c0 19.5 21.5 52.9 48 78c26.5-25 48-58.7 48-78c0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8 0 168L32 448 0 448l0 64 32 0 576 0 32 0 0-64-32 0-104 0 0-168 0-8 0-96z"]
};
const faToiletsPortable = {
  prefix: 'fass',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M256 0l0 64L0 64 0 0 256 0zM0 96l24 0 208 0 24 0 0 24 0 368 0 24-48 0 0-24 0-8L48 480l0 8 0 24L0 512l0-24L0 120 0 96zM208 224l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zM576 0l0 64L320 64l0-64L576 0zM320 96l24 0 208 0 24 0 0 24 0 368 0 24-48 0 0-24 0-8-160 0 0 8 0 24-48 0 0-24 0-368 0-24zM528 224l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16z"]
};
const faHockeyPuck = {
  prefix: 'fass',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6L512 376s-96 72-256 72S0 376 0 376L0 222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"]
};
const faMustache = {
  prefix: 'fass',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M192 112l-8 0-6.4 4.8L94.1 179.5 35.7 147 0 127.2 0 168l0 39.4s0 0 0 0C0 313.8 86.2 400 192.6 400c46.7 0 91.7-16.9 126.9-47.7l.5-.4 .5 .4c35.1 30.7 80.2 47.7 126.9 47.7C553.8 400 640 313.8 640 207.4c0 0 0 0 0 0l0-39.4 0-40.8L604.3 147l-58.4 32.4-83.6-62.7L456 112l-8 0-80 0-11 0-7.2 8.4L320 155.1l-29.8-34.7L283 112l-11 0-80 0z"]
};
const faHyphen = {
  prefix: 'fass',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 224l32 0 256 0 32 0 0 64-32 0L32 288 0 288l0-64z"]
};
const faTable = {
  prefix: 'fass',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M64 256l0-96 160 0 0 96L64 256zm0 64l160 0 0 96L64 416l0-96zm224 96l0-96 160 0 0 96-160 0zM448 256l-160 0 0-96 160 0 0 96zM64 32L0 32 0 96 0 416l0 64 64 0 384 0 64 0 0-64 0-320 0-64-64 0L64 32z"]
};
const faUserChef = {
  prefix: 'fass',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 64c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-64 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM128 410.8l224-89.6 0 30.8 48 0 48 160-96 0-224 0 0-101.2zM96 400l0 112L0 512 48 352l48 0 0-32 106.4 26.6-96.4 38.5-10.1 4L96 400zm128 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faMessageImage = {
  prefix: 'fass',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM176 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120-16l-19.6 27.8L219.1 221l-17.1-19.3L184 181.5l-17.9 20.2-64 72L96 280.5l0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136L296 112z"]
};
const faCommentAltImage = faMessageImage;
const faUsersMedical = {
  prefix: 'fass',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM48 192l148 0c-2.6 10.2-4 21-4 32c0 38.2 16.8 72.5 43.3 96L0 320 48 192zM640 320l-32 0 0-32-32 0-64 0-32 0 0 32-75.3 0c26.6-23.5 43.3-57.8 43.3-96c0-11-1.4-21.8-4-32l148 0 48 128zM480 480l0 32-352 0 48-160 240 0 0 32 0 64 0 32 32 0 32 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm288 96l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faSensorTriangleExclamation = {
  prefix: 'fass',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M448 32L0 32 0 480l237 0L448 93.2 448 32zM112 120l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm96 0l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm240 40L256 512l384 0L448 160zm16 144l0 64 0 16-32 0 0-16 0-64 0-16 32 0 0 16zM432 416l32 0 0 32-32 0 0-32z"]
};
const faSensorAlert = faSensorTriangleExclamation;
const faMagnifyingGlassArrowRight = {
  prefix: 'fass',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119l-17-17L190.1 136l17 17 31 31L120 184l-24 0 0 48 24 0 118.1 0-31 31-17 17L224 313.9l17-17 72-72 17-17-17-17-72-72z"]
};
const faTachographDigital = {
  prefix: 'fass',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M640 64L0 64 0 448l640 0 0-384zM352 128l0 128L64 256l0-128 288 0zM64 352l16 0 256 0 16 0 0 32-16 0L80 384l-16 0 0-32zm320 0l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zM96 288l0 32-32 0 0-32 32 0zm32 0l32 0 0 32-32 0 0-32zm96 0l0 32-32 0 0-32 32 0zm32 0l32 0 0 32-32 0 0-32zm96 0l0 32-32 0 0-32 32 0z"]
};
const faDigitalTachograph = faTachographDigital;
const faFaceMask = {
  prefix: 'fass',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M509.8 384c21.8-37.7 34.2-81.4 34.2-128c0-2.2 0-4.5-.1-6.7L416 284.2l0 99.8 93.8 0zm-21.9 32L416 416s0 0 0 0l-32 32-192 0-32-32s0 0 0 0l-71.9 0c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96zM66.2 384l93.8 0 0-99.8L32.1 249.3c-.1 2.2-.1 4.4-.1 6.7c0 46.6 12.5 90.3 34.2 128zM35 216.9l143.2 39 219.7 0 143.2-39C522.2 94.1 416.1 0 288 0S53.8 94.1 35 216.9zM240 176c-47 0-77.1 19.7-84.7 27.3l-22.6-22.6C146.4 167 184.6 144 240 144l16 0 0 32-16 0zm80-32l16 0c55.4 0 93.6 23 107.3 36.7l-22.6 22.6C413.1 195.7 383 176 336 176l-16 0 0-32zM208 304l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z"]
};
const faPickleball = {
  prefix: 'fass',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M288 0L528 240l-9 9c-24.8-15.7-54.3-24.8-85.9-24.8c-72 0-133 47.3-153.3 112.5L155.7 212.8l-11.3-11.3-22.6 22.7 11.3 11.3L273 374.9c-.2 3-.3 6.1-.3 9.1c0 31.7 9.2 61.2 25.2 86L288 480 160 432 80 512 16 448l80-80L48 240 288 0zm16 384a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm32-16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-80-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
const faStarSharpHalf = {
  prefix: 'fass',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M288 391.2l0-391L224.5 195.6l-205.6 0L185.2 316.4 121.7 512 288 391.2z"]
};
const faUsersSlash = {
  prefix: 'fass',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M202.6 134.5C215.9 120.2 224 101.1 224 80c0-44.2-35.8-80-80-80C115.8 0 90.9 14.6 76.7 36.8l-28.3-22L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L441.5 320 640 320 592 192l-148 0c2.6 10.2 4 21 4 32c0 30.1-10.4 57.7-27.7 79.5L395 283.9c13.1-16.4 21-37.2 21-59.9c0-53-43-96-96-96c-31.3 0-59.1 15-76.6 38.2l-40.8-31.7zM48 192L0 320l235.3 0c-20.6-18.2-35.3-42.8-40.8-70.8L121.9 192 48 192zM176 352L128 512l384 0-5-16.5L324.9 352 176 352zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"]
};
const faClover = {
  prefix: 'fass',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M120.9 126.9L160 192 94.9 152.9C85.1 147.1 74 144 62.6 144C28 144 0 172 0 206.6V224l32 32L0 288v17.4C0 340 28 368 62.6 368c11.4 0 22.5-3.1 32.2-8.9L160 320l-39.1 65.1c-5.8 9.7-8.9 20.9-8.9 32.2c0 34.6 28 62.6 62.6 62.6H192l32-32 32 32h17.4c34.6 0 62.6-28 62.6-62.6c0-11.4-3.1-22.5-8.9-32.2L288 320l65.1 39.1c9.7 5.8 20.9 8.9 32.2 8.9c34.6 0 62.6-28 62.6-62.6V288l-32-32 32-32V206.6c0-34.6-28-62.6-62.6-62.6c-11.4 0-22.5 3.1-32.2 8.9L288 192l39.1-65.1c5.8-9.7 8.9-20.9 8.9-32.2C336 60 308 32 273.4 32H256L224 64 192 32H174.6C140 32 112 60 112 94.6c0 11.4 3.1 22.5 8.9 32.2z"]
};
const faMeat = {
  prefix: 'fass',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384l-69.2 0-26.4 26.4C185.6 421.1 192 435.8 192 452c0 33.1-26.9 60-60 60s-60-26.9-60-60l0-12-12 0c-33.1 0-60-26.9-60-60s26.9-60 60-60c16.2 0 30.9 6.4 41.7 16.8L128 310.5l0-69.2c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5s20.4 34.9 11.5 43.8s-28.5 3.7-43.8-11.5z"]
};
const faReply = {
  prefix: 'fass',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M0 208L192 384l32 0 0-96 80 0c61.9 0 112 50.1 112 112c0 48-32 80-32 80s128-48 128-176c0-97.2-78.8-176-176-176l-112 0 0-96-32 0L0 208z"]
};
const faMailReply = faReply;
const faStarAndCrescent = {
  prefix: 'fass',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M328 48c44.1 0 85 13.7 118.6 37.1C399.8 32.9 331.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c75.7 0 143.8-32.9 190.6-85.1C413 450.3 372.1 464 328 464c-114.9 0-208-93.1-208-208s93.1-208 208-208zm98.3 157.8L384 120l-42.3 85.8L247 219.5l68.5 66.7-16.2 94.2L384 336l84.6 44.5-16.2-94.2L521 219.5l-94.6-13.8z"]
};
const faEmptySet = {
  prefix: 'fass',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M435.4 121.9l67.2-67.2L457.4 9.4 390.1 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4l45.3 45.3 67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z"]
};
const faHouseFire = {
  prefix: 'fass',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M439.4 126L288.4 0 0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 64 0c.1-56.8 36.1-108.7 71.8-149.9c24.3-28 51.2-52.6 79.6-76.1zm8.6 34.1s-128 103.6-128 192s71.6 160 160 160s160-71.6 160-160c0-73.6-96-160-96-160s-13.9 12.5-31 32c-32.3-37.5-65-64-65-64zM481 448c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96c-15 10-31 15-49 15z"]
};
const faSquareMinus = {
  prefix: 'fass',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M448 32L0 32 0 480l448 0 0-448zM152 232l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faMinusSquare = faSquareMinus;
const faHelicopter = {
  prefix: 'fass',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M576 64L384 64l0 64 32 0c88.4 0 160 71.6 160 160l0 64 0 32-32 0-160 0-96 0L192 256 32 192 0 64l64 0 48 64 208 0 0-64L128 64l0-64L576 0l0 64zM384 320l128 0 0-32c0-53-43-96-96-96l-32 0 0 128zm256 96l0 64 0 32-32 0-384 0 0-64 352 0 0-32 64 0z"]
};
const faBird = {
  prefix: 'fass',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M0 160l0 32C0 294.3 68.5 380.5 162.1 407.4L217.6 512l54.3 0-.7-1.2L221 416c1 0 2 0 3 0c12.6 0 25-1 37.1-3.1L313.6 512l54.3 0-.7-1.2L308.3 399.6C390.3 366.3 448 285.9 448 192l0-21.3L512 128 447.4 84.9C441.9 37.1 401.3 0 352 0c-53 0-96 43-96 96l0 64L0 160zM352 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faCompass = {
  prefix: 'fass',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 384l64-192 192-64L320 320 128 384zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faSquareCaretDown = {
  prefix: 'fass',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M0 480l448 0 0-448L0 32 0 480zM352 224L224 352 96 224l0-32 256 0 0 32z"]
};
const faCaretSquareDown = faSquareCaretDown;
const faHeartHalfStroke = {
  prefix: 'fass',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M256 389.5L402.7 242.8 427 218.5c13.5-13.5 21-31.7 21-50.7c0-39.6-32.1-71.8-71.8-71.8c-19 0-37.3 7.6-50.7 21l-24.2 24.2L256 186.5l0 203zM256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 301.3 434.8 256 480l-45.3-45.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8c0 0 0 0 0 0s0 0 0 0C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96s0 0 0 0z"]
};
const faHeartHalfAlt = faHeartHalfStroke;
const faFileCircleQuestion = {
  prefix: 'fass',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-22.4 56c-23 0-41.6 18.6-41.6 41.6l0 6.4 32 0 0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5 0 9.7 0 6.8 0 16 32 0 0-13.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0zM448 416l-32 0 0 32 32 0 0-32z"]
};
const faTruckUtensils = {
  prefix: 'fass',
  iconName: 'truck-utensils',
  icon: [640, 512, [], "e628", "M416 0L0 0 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 240l0 16-128 0 0-96 48 0 2.7 0L544 237.3l0 2.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM81.2 151.7L96 64l16 0 5.3 94.9 10.7 0L136 64l16 0 8 94.9 10.7 0L176 64l16 0 14.8 87.7c.8 4.8 1.2 9.6 1.2 14.5c0 27.9-21 50.9-48 54.2l0 83.6 0 16-32 0 0-16 0-83.6c-27-3.2-48-26.3-48-54.2c0-4.9 .4-9.7 1.2-14.5zM320 112l0 16 0 96 0 80 0 16-32 0 0-16 0-80-32 0 0-69C256 84.2 308 64 308 64l12 0 0 48z"]
};
const faLaptopCode = {
  prefix: 'fass',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M64 32l32 0 448 0 32 0 0 32 0 288-64 0 0-256L128 96l0 256-64 0L64 64l0-32zM0 432l0-48 640 0 0 48-48 48L48 480 0 432zM281 209l-31 31 31 31 17 17L264 321.9l-17-17-48-48-17-17 17-17 48-48 17-17L297.9 192l-17 17zM393 175l48 48 17 17-17 17-48 48-17 17L342.1 288l17-17 31-31-31-31-17-17L376 158.1l17 17z"]
};
const faJoystick = {
  prefix: 'fass',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M336 112c0 50.7-33.7 93.6-80 107.4L256 320l-64 0 0-100.6c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112zM200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 320l64 0 0 32 320 0 0 160L0 512 0 352l64 0 0-32z"]
};
const faGrillFire = {
  prefix: 'fass',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M0 32l448 0 0 64c0 24.1-3.8 47.4-10.9 69.1c-16.9-16.3-34.8-31.3-53.1-46.1c-31.6 25.6-61.5 52.3-88.2 83.1c-28.9 33.3-58 73.7-68.1 117.9c-1.2 0-2.5 0-3.7 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368l72.8 0c1.4 16.7 4.9 32.8 10.2 48L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 32zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM449 224.1c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160s128-192 128-192s32.6 26.4 65 64zM466 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"]
};
const faRectangleVerticalHistory = {
  prefix: 'fass',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M576 0L192 0l0 512 384 0L576 0zM96 48l0 416 48 0 0-416L96 48zM0 96L0 416l48 0L48 96 0 96z"]
};
const faSwatchbook = {
  prefix: 'fass',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 416c0 53 43 96 96 96s96-43 96-96L192 0 0 0 0 416zM128 64l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm108.7 96L512 512l0-192-139 0L186.5 506.5c-1.9 1.9-3.8 3.7-5.8 5.5zM458 189.7L322.3 54 224 152.2l0 271.5 234-234z"]
};
const faPrescriptionBottle = {
  prefix: 'fass',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M0 0L384 0l0 96L0 96 0 0zM32 128l320 0 0 384L32 512l0-96 112 0 16 0 0-32-16 0L32 384l0-64 112 0 16 0 0-32-16 0L32 288l0-64 112 0 16 0 0-32-16 0L32 192l0-64z"]
};
const faBars = {
  prefix: 'fass',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 64l448 0 0 64L0 128 0 64zM0 224l448 0 0 64L0 288l0-64zM448 384l0 64L0 448l0-64 448 0z"]
};
const faNavicon = faBars;
const faKeyboardLeft = {
  prefix: 'fass',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M160 64l480 0 0 384-480 0 0-384zm64 64l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM384 128l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm160 96l-160 0 0 64 160 0 0-64zM416 128l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM0 256l96-96 32 0 0 192-32 0L0 256z"]
};
const faPeopleGroup = {
  prefix: 'fass',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M128 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM53.3 275.1L64 292.4l0-45.1L53.3 275.1zM0 280L40 176l172.3 0-.1 .1-64 112L138 305.9 150 322.6l42 58.9 0 2.5 0 64L64 448l0-64L0 280zM448 381.5l42-58.9L502 305.9l-10.2-17.8-64-112-.1-.1L600 176l40 104L576 384l0 64-128 0 0-64 0-2.5zM512 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm74.7 243.1L576 247.3l0 45.1 10.7-17.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM232.9 301.1L256 333.4l0-72.7-23.1 40.4zM384 260.7l0 72.7 23.1-32.3L384 260.7zM464 304L384 416l0 64-128 0 0-64L176 304l64-112 160 0 64 112z"]
};
const faHourglassEnd = {
  prefix: 'fass',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 0L32 0 352 0l32 0 0 64-32 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64 32 0 0 64-32 0L32 512 0 512l0-64 32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64L0 64 0 0zM96 64l0 50.7 96 96 96-96L288 64 96 64z"]
};
const faHourglass3 = faHourglassEnd;
const faHeartCrack = {
  prefix: 'fass',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M224 208l64 112L160 208l80-80L175.7 38c-12.8-4-26.3-6-40-6C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480 448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-27.6 0-54.4 8.4-76.8 23.8L320 128l-96 80z"]
};
const faHeartBroken = faHeartCrack;
const faFaceBeamHandOverMouth = {
  prefix: 'fass',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M512 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3L411.9 424l-22.6-22.6-9.4-9.4 9.4-9.4L411.9 360l-22.6-22.6-9.4-9.4 16-16-22.6-22.6-22.6-22.6L328 244.1l-16 16-9.4-9.4L280 228.1l-22.6 22.6-51.7 51.7-21.7 0-40 0-32 0 0 32 0 82.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM176 120c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80zm104 80s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80zm22.6 96l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L280 273.4 302.6 296z"]
};
const faDropletPercent = {
  prefix: 'fass',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 512c106 0 192-86 192-192S192 0 192 0S0 214 0 320S86 512 192 512zm86.6-256l-11.3 11.3-128 128L128 406.6 105.4 384l11.3-11.3 128-128L256 233.4 278.6 256zM136 240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHumidity = faDropletPercent;
const faSquareUpRight = {
  prefix: 'fass',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M0 32l448 0 0 448L0 480 0 32zM320 320l0-160-160 0-16 16 52 52-84 84 56 56 84-84 52 52 16-16z"]
};
const faExternalLinkSquareAlt = faSquareUpRight;
const faFaceKissBeam = {
  prefix: 'fass',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448l-3.9-15s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0-13.9s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faKissBeam = faFaceKissBeam;
const faCorn = {
  prefix: 'fass',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M512 40c0 15-8.3 28.1-20.5 34.9C499.2 82.2 504 92.6 504 104c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 22.1-17.9 40-40 40c-1.1 0-2.3 0-3.4-.1c2.2 4.9 3.4 10.4 3.4 16.1c0 13.6-6.8 25.7-17.3 32.9c-47.7-29.7-103.6-41.1-157.5-34.2c6.9-53.9-4.5-109.8-34.2-157.5C214.3 102.8 226.4 96 240 96c5.7 0 11.2 1.2 16.1 3.4c-.1-1.1-.1-2.2-.1-3.4c0-22.1 17.9-40 40-40c6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40zM139.9 82.5l10.4 10.4c50.2 50.2 69.4 119.6 57.5 184.6c-38.7 10.7-75.2 31.2-105.5 61.6L28.7 412.7 0 384l0-64L112 208 139.9 82.5zM51.3 435.3l73.6-73.6c28.6-28.6 63.5-47.1 100.1-55.6c67.6-15.6 141.4 3 194 55.6l10.4 10.4L304 400 192 512l-64 0L51.3 435.3z"]
};
const faRollerCoaster = {
  prefix: 'fass',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M64 190.1c0-31.8 15.8-60 40-77L104 456l0 24 48 0 0-24 0-359.8c2-.1 4-.2 6.1-.2c14.8 0 29.1 3.5 41.9 9.9L200 456l0 24 48 0 0-24 0-301.3 48 69.1L296 456l0 24 48 0 0-24 0-163.1 20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8L392 456l0 24 48 0 0-24 0-78.4c13.6 4.2 28 6.4 42.6 6.4l5.4 0 0 72 0 24 48 0 0-24 0-77.6c14.4-4.2 27.8-10.5 40-18.6l0 88.2 0 32 64 0 0-32 0-208s0 0 0 0c0-79.5-64.5-144-144-144l-4 0c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3l0-74.2 7.3-3.9c12.7-6.8 26.5-11 40.7-12.5l0 127.3c.9 0 1.7 .1 2.6 .1l13.4 0c12.3 0 23.5-4.6 32-12.2l0-109.1c28.3 12.3 48 40.5 48 73.3c0 0 0 0 0 0c0 44.2-35.8 80-80 80l-13.4 0c-26.2 0-50.8-12.8-65.7-34.4L287.9 99.9C258.4 57.4 209.9 32 158.1 32C70.8 32 0 102.8 0 190.1L0 448l0 32 64 0 0-32 0-257.9z"]
};
const faPhotoFilmMusic = {
  prefix: 'fass',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M640 0L192 0l0 320 176 0 0-64-16 0-64 0 0-32 72-80 28 32 60-80 51 68 141-47L640 0zM160 392l0-296L0 96 0 448l289.9 0c4.4-18.3 15.9-33.2 29.7-43.5c6.7-5 14.2-9.2 22.3-12.5L160 392zM288 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM56 152l48 0 0 48-48 0 0-48zm48 96l0 48-48 0 0-48 48 0zM56 344l48 0 0 48-48 0 0-48zM640 152l-31.6 10.5-192 64L400 232l0 17.3 0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48 0-33.3z"]
};
const faRadar = {
  prefix: 'fass',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96l64 0c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256l64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L455 23l17-17L505.9 40 489 57l-174 174c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z"]
};
const faSickle = {
  prefix: 'fass',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M224 352l-43-43c-33.9-33.9-53-80-53-128C128 81 209 0 309 0l11 0C426 0 512 86 512 192l-22.7-31.2C463.3 125.1 421.9 104 377.8 104C301.7 104 240 165.7 240 241.8l0 9.8c0 18.8 3.6 37.4 10.6 54.8L256 320l-32 32zM0 448l88-88L64 336l48-48L224 400l-48 48-24-24L64 512 0 448z"]
};
const faFilm = {
  prefix: 'fass',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M0 32l512 0 0 448L0 480 0 32zM48 352l0 64 64 0 0-64-64 0zm416 0l-64 0 0 64 64 0 0-64zM48 224l0 64 64 0 0-64-64 0zm416 0l-64 0 0 64 64 0 0-64zM48 96l0 64 64 0 0-64L48 96zm416 0l-64 0 0 64 64 0 0-64zM160 96l0 128 192 0 0-128L160 96zM352 288l-192 0 0 128 192 0 0-128z"]
};
const faCoconut = {
  prefix: 'fass',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M141.1 141.1c-43.7 43.7-73 91.8-85.8 133.3c-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5c-41.5 12.8-89.6 42.1-133.3 85.8zM260.3 9.4C309.5-5.8 361.5-4.8 395.1 28.8l41 40.9C484.7 118.3 512 184.2 512 252.9c0 143.1-116 259-259 259c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.8 309.5 9.4 260.3c15.6-50.4 49.7-105 97.8-153.1S209.9 25 260.3 9.4zm63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9s5.4-95.9 67.9-158.4S298.8 72.6 323.8 97.6zm95.4 107.1l-11.3-11.3L385.3 216l11.3 11.3 32 32 11.3 11.3L462.6 248l-11.3-11.3-32-32zm-56 136l-11.3-11.3L329.3 352l11.3 11.3 32 32 11.3 11.3L406.6 384l-11.3-11.3-32-32zm-136 56l-11.3-11.3L193.3 408l11.3 11.3 32 32 11.3 11.3L270.6 440l-11.3-11.3-32-32z"]
};
const faRulerHorizontal = {
  prefix: 'fass',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M0 128L0 384l640 0 0-256-112 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80L0 128z"]
};
const faShieldCross = {
  prefix: 'fass',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M267.5 10.1L256 5.7l-11.5 4.4L37 90.2 17.8 97.6l-1.2 20.6C13.6 167.8 21.4 243.7 53.9 318C86.6 392.8 145 467.1 243.4 509.4l12.6 5.4 12.6-5.4C367 467.1 425.4 392.8 458.1 318c32.5-74.2 40.3-150.2 37.3-199.8l-1.2-20.6L475 90.2l-207.5-80zM224 86.6l32-12.3 32 12.3 0 73.4 143.3 0c-1.2 19.4-4.2 41.2-9.4 64L288 224l0 202.8c-10 6.5-20.7 12.5-32 18c-11.3-5.5-22-11.5-32-18L224 224 90.1 224c-5.2-22.8-8.2-44.6-9.4-64L224 160l0-73.4z"]
};
const faCassetteTape = {
  prefix: 'fass',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M0 32l576 0 0 448-92.9 0L439 362.4 435.1 352 424 352l-272 0-11.1 0L137 362.4 92.9 480 0 480 0 32zM412.9 384l36 96-321.8 0 36-96 249.8 0zM341.5 192l-106.9 0c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32l106.9 0c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM112 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faSquareTerminal = {
  prefix: 'fass',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M0 32l448 0 0 448L0 480 0 32zM62.1 176l17 17 63 63L79 319l-17 17L96 369.9l17-17 80-80 17-17-17-17-80-80-17-17L62.1 176zM216 336l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faPeopleRobbery = {
  prefix: 'fass',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM40 128L8 128l0 32L8 288l0 32s0 0 0 0L8 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.3 13 20.5 9.4 14.9 17.6 0 48 0 32 0 0-64-32 0-30.4 0-51.5-81.1L148.7 128l-17.6 0L40 128zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM273.1 168.2l6.3 23.8 24.6 0 24 0 0 288 0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-288 24 0 24.6 0 6.3-23.8 32-120 8.2-30.9L505.3 .8l-8.2 30.9L471.4 128 408 128s0 0 0 0l-16 0s0 0 0 0l-63.4 0L302.9 31.8 294.7 .8 232.8 17.3l8.2 30.9 32 120z"]
};
const faLightbulb = {
  prefix: 'fass',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM112 416l0 96 160 0 0-96-160 0zm0-240l-32 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80z"]
};
const faCaretLeft = {
  prefix: 'fass',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M144 96L0 256 144 416l48 0 0-320-48 0z"]
};
const faCommentMiddle = {
  prefix: 'fass',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M320.1 409.4C430.5 386.3 512 304.9 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4L256 512l64.1-102.6z"]
};
const faTrashCanList = {
  prefix: 'fass',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M288 0L128 0 112 32 0 32 0 96l416 0 0-64L304 32 288 0zm96 128L32 128l0 384 352 0 0-384zM160 208l0 224 0 16-32 0 0-16 0-224 0-16 32 0 0 16zm128 0l0 224 0 16-32 0 0-16 0-224 0-16 32 0 0 16zm352-80l-192 0 0 64 192 0 0-64zM608 256l-160 0 0 64 160 0 0-64zM448 384l0 64 96 0 0-64-96 0z"]
};
const faBlock = {
  prefix: 'fass',
  iconName: 'block',
  icon: [448, 512, [], "e46a", "M0 32l448 0 0 448L0 480 0 32zm96 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faCircleExclamation = {
  prefix: 'fass',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-384l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 368l0-48 48 0 0 48-48 0z"]
};
const faExclamationCircle = faCircleExclamation;
const faSchoolCircleXmark = {
  prefix: 'fass',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M640 96l0 170.8C608.1 221.6 555.5 192 496 192c-38.5 0-74.2 12.4-103.1 33.4c9.6-14.1 15.1-31.1 15.1-49.4c0-48.6-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88c15.6 0 30.2-4 42.9-11.1c-23.4 27.1-38.8 61.4-42.2 99.1l-.7 0c-35.3 0-64 28.7-64 64l0 96L0 512 0 96l160 0L320 0 480 96l160 0zM144 192l-64 0 0 96 64 0 0-96zm0 128l-64 0 0 96 64 0 0-96zM336 128l0 16 0 16 16 0 16 0 0 32-16 0-32 0-16 0 0-16 0-32 0-16 32 0zm160 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z"]
};
const faArrowRightFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M486.6 278.6L509.3 256l-22.6-22.6-128-128L336 82.7 290.7 128l22.6 22.6L386.7 224 192 224l-32 0 0 64 32 0 194.7 0-73.4 73.4L290.7 384 336 429.3l22.6-22.6 128-128zM160 96l32 0 0-64-32 0L32 32 0 32 0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0z"]
};
const faSignOut = faArrowRightFromBracket;
const faFaceFrownSlight = {
  prefix: 'fass',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM382.3 392.8l-28.6 14.3C344.9 389.7 312.4 352 256 352s-88.9 37.7-97.7 55.2l-28.6-14.3C142.3 367.7 184.4 320 256 320s113.7 47.7 126.3 72.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleChevronDown = {
  prefix: 'fass',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM239 345L135 241l-17-17L152 190.1l17 17 87 87 87-87 17-17L393.9 224l-17 17L273 345l-17 17-17-17z"]
};
const faChevronCircleDown = faCircleChevronDown;
const faSidebarFlip = {
  prefix: 'fass',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M512 32L0 32 0 480l512 0 0-448zM288 96l0 320L64 416 64 96l224 0zm64 0l96 0 0 48-96 0 0-48zm96 96l0 48-96 0 0-48 96 0zm-96 96l96 0 0 48-96 0 0-48z"]
};
const faUnlockKeyhole = {
  prefix: 'fass',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M144 144c0-44.2 35.8-80 80-80c38.7 0 71 27.5 78.4 64l64.7 0C359.2 56 298.1 0 224 0C144.5 0 80 64.5 80 144l0 48L0 192 0 512l448 0 0-320-304 0 0-48zM256 384l-64 0-32 0 0-64 32 0 64 0 32 0 0 64-32 0z"]
};
const faUnlockAlt = faUnlockKeyhole;
const faTemperatureList = {
  prefix: 'fass',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M81.8 317.8L96 300.2l0-22.7L96 64l96 0 0 213.5 0 22.7 14.2 17.6C217.4 331.5 224 348.9 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM256 0L192 0 96 0 32 0l0 64 0 213.5C12 302.2 0 333.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L256 64l0-64zM144 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 176l0-16-32 0 0 16 0 146.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM352 32l-32 0 0 64 32 0 128 0 32 0 0-64-32 0L352 32zM320 160l0 64 32 0 128 0 32 0 0-64-32 0-128 0-32 0zm64 128l-32 0 0 64 32 0 96 0 32 0 0-64-32 0-96 0z"]
};
const faCloudShowersHeavy = {
  prefix: 'fass',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zM72 352l56 0L56 512 0 512 72 352zm120 0l56 0L176 512l-56 0 72-160zm168 0L288 512l-56 0 72-160 56 0zm64 0l56 0L408 512l-56 0 72-160z"]
};
const faHeadphonesSimple = {
  prefix: 'fass',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M256 80C141.1 80 48 173.1 48 288l0 104 0 24L0 416l0-24L0 288C0 146.6 114.6 32 256 32s256 114.6 256 256l0 104 0 24-48 0 0-24 0-104c0-114.9-93.1-208-208-208zM80 288l112 0 0 192L80 480l0-192zm240 0l112 0 0 192-112 0 0-192z"]
};
const faHeadphonesAlt = faHeadphonesSimple;
const faSitemap = {
  prefix: 'fass',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M208 32l160 0 0 160-56 0 0 40 184 0 24 0 0 24 0 64 56 0 0 160-160 0 0-160 56 0 0-40-160 0 0 40 56 0 0 160-160 0 0-160 56 0 0-40-160 0 0 40 56 0 0 160L0 480 0 320l56 0 0-64 0-24 24 0 184 0 0-40-56 0 0-160z"]
};
const faPipeSection = {
  prefix: 'fass',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M64 96L0 96l0 32L0 384l0 32 64 0 0-32 0-256 0-32zm576 0l-64 0 0 32 0 256 0 32 64 0 0-32 0-256 0-32zm-96 32L96 128l0 256 448 0 0-256z"]
};
const faSpaceStationMoonConstruction = {
  prefix: 'fass',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M511 279.1c.7-7.6 1-15.3 1-23.1c0-10.8-.7-21.5-2-32l-62 0 0-64-32 0-64 0 0-64 64 0 0-39.9C372.2 21 316.5 0 256 0C114.6 0 0 114.6 0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9zM6.8 314.8C33.4 427.9 134.9 512 256 512c76.5 0 145.1-33.5 192-86.7l0-41.3-64 0 0-41.2c-40.7 6-83.7 9.2-128 9.2c-91.3 0-176.6-13.6-249.2-37.2zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
const faCircleDollarToSlot = {
  prefix: 'fass',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M352 392.6c-28.7 15-61.4 23.4-96 23.4c-35.9 0-69.7-9.1-99.1-25.1c-19-10.3-36.1-23.5-50.9-38.9C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-14.9 14.9-32.2 27.6-51.1 37.5zM276.1 91.9l-40.2 0 0 20.1 0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0s0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0s0 0 0 0c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4 0 20.1 40.2 0 0-20.1 0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.4-3.2-21-4.4l0-6.3 0-20.1zM32 352l32 0c19.5 25.9 44 47.7 72.2 64L64 416l0 32 192 0 192 0 0-32-72.2 0c28.2-16.3 52.8-38.1 72.2-64l32 0 32 0 0 32 0 96 0 32-32 0L32 512 0 512l0-32 0-96 0-32 32 0z"]
};
const faDonate = faCircleDollarToSlot;
const faMemory = {
  prefix: 'fass',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M576 64L0 64l0 82.7c18.6 6.6 32 24.4 32 45.3s-13.4 38.7-32 45.3L0 320l576 0 0-82.7c-18.6-6.6-32-24.4-32-45.3s13.4-38.7 32-45.3L576 64zm0 288L0 352l0 96 80 0 0-32 0-16 32 0 0 16 0 32 96 0 0-32 0-16 32 0 0 16 0 32 96 0 0-32 0-16 32 0 0 16 0 32 96 0 0-32 0-16 32 0 0 16 0 32 80 0 0-96zM192 128l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0zm128 32l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zm128-32l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0z"]
};
const faFaceSleeping = {
  prefix: 'fass',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M384 48l0-13.8C346.3 12.5 302.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-46.6-12.5-90.3-34.2-128L432 128l-48 0 0-48 0-8 0-8 0-16zM256 64l16 0 64 0 16 0 0 16 0 8 0 8-6.4 4.8L309.3 128l26.7 0 16 0 0 32-16 0-64 0-16 0 0-16 0-8 0-8 6.4-4.8L298.7 96 272 96l-16 0 0-32zM216 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM395.2 234.4l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zM432 0L416 0l0 32 16 0 26.7 0L422.4 59.2 416 64l0 8 0 8 0 16 16 0 64 0 16 0 0-32-16 0-26.7 0 36.3-27.2L512 32l0-8 0-8 0-16L496 0 432 0z"]
};
const faRoadSpikes = {
  prefix: 'fass',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M32 96l0 256 128 0 64 0 64 0 64 0 64 0 64 0 128 0L448 96l-32 0 0 153.6L320 96l-32 0 0 153.6L192 96l-32 0 0 153.6L64 96 32 96zM0 384l0 64 32 0 576 0 32 0 0-64-32 0L32 384 0 384z"]
};
const faFireBurner = {
  prefix: 'fass',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M288 0l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 256l32 0 32 0 32 0 0 64-32 0 0 64 448 0 0-64-32 0 0-64 32 0 32 0 32 0 0 32 0 96 32 0 0 128L0 512 0 384l32 0 0-96 0-32zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faSquirrel = {
  prefix: 'fass',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M160 299.3c-19.9 22.6-32 52.2-32 84.7l0 128 128 0 64 0 32 0 96 0 32 0 0-64-32 0-16 0c10-13.4 16-30 16-48c0-26.2-12.6-49.4-32-64c-13.4-10-30-16-48-16c-9.4 0-18.3 1.6-26.7 4.5l-10.7-30.2c11.7-4.1 24.3-6.4 37.3-6.4c17.2 0 33.5 3.9 48 10.8l0-58.8 64 0 32-48 0-32-87.9-58.6c-2.5-1.7-5.3-3-8.1-3.9l0-1.5 0-32c-20.4 0-38.2 10.9-48 27.1C358.2 74.9 340.4 64 320 64l0 32 0 32 0 54.2 0 41.8-25.3 38c-2.2-.7-4.4-1.3-6.7-1.9l0-116C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c5.4 0 10.7-.3 16-.9l0 12.2zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faArrowUpToLine = {
  prefix: 'fass',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M32 32L0 32 0 96l32 0 320 0 32 0 0-64-32 0L32 32zM214.6 169.4L192 146.7l-22.6 22.6-128 128L18.7 320 64 365.3l22.6-22.6L160 269.3 160 448l0 32 64 0 0-32 0-178.7 73.4 73.4L320 365.3 365.3 320l-22.6-22.6-128-128z"]
};
const faArrowToTop = faArrowUpToLine;
const faFlag = {
  prefix: 'fass',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M64 32L64 0 0 0 0 32 0 64 0 368 0 480l0 32 64 0 0-32 0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 336l0-320L393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"]
};
const faFaceCowboyHat = {
  prefix: 'fass',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M192 0l64 32L320 0l55.4 110.8c36.5-11.1 68.9-27.1 95.3-46.8L488 81.3C460.8 163.5 367.2 224 256 224S51.2 163.5 24 81.3L41.3 64c26.4 19.7 58.8 35.7 95.3 46.8L192 0zM48 304c0-37.9 10.1-73.4 27.8-104c48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104c0 114.9-93.1 208-208 208S48 418.9 48 304zm208.2 72.8c-44.3 0-85.6-8-120.2-21.7c12.2 55.4 61.4 96.9 120.2 96.9s108-41.5 120.2-96.9c-34.6 13.8-75.9 21.7-120.2 21.7zM216 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHanukiah = {
  prefix: 'fass',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M316.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6C331.2 17.1 344 36.3 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM28.1 54c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c0 0 0 0 0 0C43.2 65.1 56 84.3 56 104c0 13.3-10.7 24-24 24s-24-10.7-24-24C8 84.3 20.8 65.1 28.1 54zM112 48c.9 1.6 2.3 3.6 3.9 6c0 0 0 0 0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm60.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c0 0 0 0 0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM240 48c.9 1.6 2.3 3.6 3.9 6c0 0 0 0 0 0c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm156.1 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM528 48c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zm-67.9 6c1.6-2.4 3-4.5 3.9-6c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50zM608 48c.9 1.6 2.3 3.6 3.9 6c7.4 11.1 20.1 30.3 20.1 50c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.7 12.8-38.9 20.1-50c1.6-2.4 3-4.5 3.9-6zM352 112l0 32 0 176 224 0 0-128 0-32 64 0 0 32 0 160 0 32-32 0-256 0 0 64 128 0 32 0 0 64-32 0-160 0-160 0-32 0 0-64 32 0 128 0 0-64L32 384 0 384l0-32L0 192l0-32 64 0 0 32 0 128 224 0 0-176 0-32 64 0zM128 160l0 16 0 112-32 0 0-112 0-16 32 0zm64 0l0 16 0 112-32 0 0-112 0-16 32 0zm64 0l0 16 0 112-32 0 0-112 0-16 32 0zm160 0l0 16 0 112-32 0 0-112 0-16 32 0zm64 0l0 16 0 112-32 0 0-112 0-16 32 0zm64 0l0 16 0 112-32 0 0-112 0-16 32 0z"]
};
const faChartScatter3d = {
  prefix: 'fass',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M64 32L0 32 0 96l64 0 0-64zM288 64l0-32-64 0 0 32 0 209L43.5 423.4 18.9 443.9l41 49.2 24.6-20.5L256 329.7 427.5 472.6l24.6 20.5 41-49.2-24.6-20.5L288 273l0-209zM0 224l0 64 64 0 0-64L0 224zm160-96l-64 0 0 64 64 0 0-64zM352 32l0 64 64 0 0-64-64 0zm160 96l-64 0 0 64 64 0 0-64zM352 224l0 64 64 0 0-64-64 0zM288 416l-64 0 0 64 64 0 0-64z"]
};
const faDisplayChartUp = {
  prefix: 'fass',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M0 0L576 0l0 416-240 0 10.7 32 69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416 0 416 0 0zM64 64l0 288 448 0 0-288L64 64zM376 96l80 0 24 0 0 24 0 80 0 24-48 0 0-24 0-22.1L321 289l-17 17-17-17-63-63-87 87L103 279 207 175l17-17 17 17 63 63L398.1 144 376 144l-24 0 0-48 24 0z"]
};
const faSquareCode = {
  prefix: 'fass',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M448 32L0 32 0 480l448 0 0-448zM177 209l-47 47 47 47 17 17L160 353.9l-17-17L79 273l-17-17 17-17 64-64 17-17L193.9 192l-17 17zM305 175l64 64 17 17-17 17-64 64-17 17L254.1 320l17-17 47-47-47-47-17-17L288 158.1l17 17z"]
};
const faFeather = {
  prefix: 'fass',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M113.9 448L73 489l-17 17L22.1 472l17-17L287.2 206.8l-22.3-22.3-11.3 11.3L64 385.4 64 224 242.7 45.3C271.7 16.3 311 0 352 0s80.3 16.3 109.3 45.3l5.5 5.5C495.7 79.7 512 119 512 160c0 26.3-6.7 51.9-19.2 74.6L368 272l0 16 80 0-52.6 52.6L304 368l0 16 48 0-64 64-174.1 0z"]
};
const faVolumeLow = {
  prefix: 'fass',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M0 160L0 352l128 0L272 480l48 0 0-448-48 0L128 160 0 160zM409.6 332.8C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4z"]
};
const faVolumeDown = faVolumeLow;
const faXmarkToSlot = {
  prefix: 'fass',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M96 32l384 0 0 352L96 384 96 32zM369 161l17-17L352 110.1l-17 17-47 47-47-47-17-17L190.1 144l17 17 47 47-47 47-17 17L224 305.9l17-17 47-47 47 47 17 17L385.9 272l-17-17-47-47 47-47zM0 288l64 0 0 128 448 0 0-128 64 0 0 192L0 480 0 288z"]
};
const faTimesToSlot = faXmarkToSlot;
const faVoteNay = faXmarkToSlot;
const faBoxTaped = {
  prefix: 'fass',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M64 32L0 160l160 0L192 32 64 32zM288 160l160 0L384 32 256 32l32 128zM160 192L0 192 0 480l448 0 0-288-160 0 0 96-128 0 0-96z"]
};
const faBoxAlt = faBoxTaped;
const faCommentSlash = {
  prefix: 'fass',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L513.7 376c38.8-36.5 62.3-84 62.3-136C576 125.1 461.4 32 320 32c-68.2 0-130.2 21.7-176 57L48.4 14.8zM424.1 430.1L82.9 161.3C70.7 185.6 64 212.2 64 240c0 49.6 21.3 95.1 56.9 130.8L80 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c37 0 72.3-6.4 104.1-17.9z"]
};
const faSwords = {
  prefix: 'fass',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M16 96L0 0 96 16 393.4 313.4l-80 80L16 96zM408 456l-72 24-32-32L448 304l32 32-24 72 56 56-48 48-56-56zM96 336l57.4-57.4 80 80L176 416l32 32-32 32-72-24L48 512 0 464l56-56L32 336l32-32 32 32zM496 96L358.6 233.4l-80-80L416 16 512 0 496 96z"]
};
const faCloudSunRain = {
  prefix: 'fass',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M104 104L121.3 0 208 60.7 294.7 0l13.2 79c-20.5 10.9-37.7 27.3-49.6 47.2c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2l0 97.8L121.3 416 104 312 0 294.7 60.7 208 0 121.3 104 104zM294.5 415.9l.2 0c0 0 0 .1 0 .1l9.3 0-64 96-56 0 64-96 46.7 0-.1-.1zm-49.4-260c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64c13.8 0 26.7 4.4 37.1 11.9zM344 416l56 0-64 96-56 0 64-96zm152 0l-64 96-56 0 64-96 56 0zm40 0l56 0-64 96-56 0 64-96zm103.9-32.1l-80 0-271.9 0-96 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z"]
};
const faAlbum = {
  prefix: 'fass',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M0 32l448 0 0 448L0 480 0 32zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleN = {
  prefix: 'fass',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48-384l48 0 0 24 0 208 0 24-36.6 0-7.2-10.3L208 228.8 208 360l0 24-48 0 0-24 0-208 0-24 36.6 0 7.2 10.3L304 283.2 304 152l0-24z"]
};
const faCompress = {
  prefix: 'fass',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 64l0-32L96 32l0 32 0 64-64 0L0 128l0 64 32 0 96 0 32 0 0-32 0-96zM32 320L0 320l0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0zM352 64l0-32-64 0 0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64zM320 320l-32 0 0 32 0 96 0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0-96 0z"]
};
const faWheatAwn = {
  prefix: 'fass',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M489 57l17-17L472 6.1 455 23 383 95l-17 17L400 145.9l17-17 72-72zM316.8 38.6L294.2 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L25.4 441.4 2.7 464 48 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L396 321.5l-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L489 153l17-17L472 102.1l-17 17-43.4 43.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L393 57l17-17L376 6.1 359 23 329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3z"]
};
const faWheatAlt = faWheatAwn;
const faAnkh = {
  prefix: 'fass',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128L32 256 0 256l0 64 32 0 96 0 0 160 0 32 64 0 0-32 0-160 96 0 32 0 0-64-32 0-46.8 0c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"]
};
const faHandsHoldingChild = {
  prefix: 'fass',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM290.5 96l59.1 0 8.8 0 6.7 5.7 50.5 42.7 18.3 15.5-31 36.7L384.5 181l-19.8-16.7L375.8 253l3 23.8-47.6 6-3-23.8-4.4-35-7.6 0-4.4 35-3 23.8-47.6-6 3-23.8 11.1-88.8L255.5 181l-18.3 15.5-31-36.7 18.3-15.5L275 101.7l6.7-5.7 8.8 0zM80 64l0 40 0 8 0 32 0 80 0 66.7 84.1 84.1L205.8 347l-36.4-36.4L146.7 288l-9.4-9.4L114.7 256 160 210.7l22.6 22.6 9.4 9.4 22.6 22.6 64 64 9.4 9.4 0 13.3 0 64 0 32 0 32 0 32-32 0-96 0-13.3 0-9.4-9.4-128-128L0 365.3 0 352 0 224l0-64 0-32 0-24L0 64l80 0zm480 0l80 0 0 40 0 24 0 32 0 64 0 128 0 13.3-9.4 9.4-128 128-9.4 9.4L480 512l-96 0-32 0 0-32 0-32 0-32 0-64 0-13.3 9.4-9.4 64-64L448 242.7l9.4-9.4L480 210.7 525.3 256l-22.6 22.6-9.4 9.4-22.6 22.6L434.2 347l41.7 27.8L560 290.7l0-66.7 0-80 0-32 0-8 0-40z"]
};
const faAsterisk = {
  prefix: 'fass',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M224 32l0 32 0 135.5 95.5-57.3L347 125.7l32.9 54.9L352.5 197l-98.3 59 98.3 59 27.4 16.5L347 386.3l-27.4-16.5L224 312.5 224 448l0 32-64 0 0-32 0-135.5L64.5 369.8 37 386.3 4.1 331.4 31.5 315l98.3-59L31.5 197 4.1 180.6 37 125.7l27.4 16.5L160 199.5 160 64l0-32 64 0z"]
};
const faKeySkeletonLeftRight = {
  prefix: 'fass',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M448 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-60 32c14.2 55.2 64.3 96 124 96c70.7 0 128-57.3 128-128S582.7 0 512 0C452.4 0 402.2 40.8 388 96L192 96l-32 0 0 32 0 64 0 32 64 0 0-32 0-32 32 0 0 32 0 32 64 0 0-32 0-32 68 0zM192 384A64 64 0 1 1 64 384a64 64 0 1 1 128 0zm60-32c-14.2-55.2-64.3-96-124-96C57.3 256 0 313.3 0 384s57.3 128 128 128c59.6 0 109.8-40.8 124-96l196 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32-32 0 0-32 0-32-64 0 0 32 0 32-68 0z"]
};
const faCommentLines = {
  prefix: 'fass',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM152 176l-24 0 0 48 24 0 208 0 24 0 0-48-24 0-208 0zm0 96l-24 0 0 48 24 0 112 0 24 0 0-48-24 0-112 0z"]
};
const faLuchadorMask = {
  prefix: 'fass',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M224 0C100.3 0 0 100.3 0 224L0 512l448 0 0-288C448 100.3 347.7 0 224 0zM128 384c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm224 0c0 35.3-28.7 64-64 64l-128 0c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-34c-44.2 0-80-35.8-80-80l0-16 0-32 32 0 48 0c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80l48 0 32 0 0 32 0 16c0 44.2-35.8 80-80 80l0 34c27.6 7.1 48 32.2 48 62zM176 304l0 16 96 0 0-16-16-16-32-32-32 32-16 16zm82.7-80c-1.8 5-2.7 10.4-2.7 16l0 16 32 0 16 0c20.9 0 38.7-13.4 45.3-32c1.8-5 2.7-10.4 2.7-16l0-16-32 0-16 0c-20.9 0-38.7 13.4-45.3 32zM144 192l-16 0-32 0 0 16c0 5.6 1 11 2.7 16c6.6 18.6 24.4 32 45.3 32l16 0 32 0 0-16c0-5.6-1-11-2.7-16c-6.6-18.6-24.4-32-45.3-32z"]
};
const faLuchador = faLuchadorMask;
const faMaskLuchador = faLuchadorMask;
const faSquareCheck = {
  prefix: 'fass',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M448 32L0 32 0 480l448 0 0-448zM337 209L209 337l-17 17-17-17-64-64-17-17L128 222.1l17 17 47 47L303 175l17-17L353.9 192l-17 17z"]
};
const faCheckSquare = faSquareCheck;
const faShredder = {
  prefix: 'fass',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M64 0L96 0 368 0l13.3 0 9.4 9.4 48 48 9.4 9.4L448 80l0 112 64 0 0 192L0 384 0 192l64 0L64 32 64 0zM384 93.3L354.7 64 128 64l0 128 256 0 0-98.7zM456 248l-48 0 0 48 48 0 0-48zM40 416l48 0 0 72 0 24-48 0 0-24 0-72zm96 0l48 0 0 72 0 24-48 0 0-24 0-72zm96 0l48 0 0 72 0 24-48 0 0-24 0-72zm96 0l48 0 0 72 0 24-48 0 0-24 0-72zm96 0l48 0 0 72 0 24-48 0 0-24 0-72z"]
};
const faBookOpenCover = {
  prefix: 'fass',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M304 32l0 376L96 368 96 0 304 32zM64 400l256 51.2L576 400l0-371.2L640 16l0 432L320 512 0 448 0 16 64 28.8 64 400zm272 8l0-376L544 0l0 368L336 408z"]
};
const faBookOpenAlt = faBookOpenCover;
const faSandwich = {
  prefix: 'fass',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M0 64l512 0 0 112L0 176 0 64zM320 384l96-48 32 0 64 0 0 112L0 448 0 336l192 0 32 0 96 48zM144.2 209.1L256 238.9l111.8-29.8 8-2.1 8 2 96 24 31 7.8-15.5 62.1-31-7.8-88-22-112 29.9-8.2 2.2-8.2-2.2L135.7 273l-88 22-31 7.8L1.2 240.7l31-7.8 96-24 8-2 8 2.1z"]
};
const faPesetaSign = {
  prefix: 'fass',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M64 32L32 32l0 32 0 96L0 160l0 64 32 0 0 96 0 160 64 0 0-128 96 0c77.4 0 142-55 156.8-128l35.2 0 0-64-35.2 0C334 87 269.4 32 192 32L64 32zM282.5 160L96 160l0-64 96 0c41.8 0 77.4 26.7 90.5 64zM96 224l186.5 0c-13.2 37.3-48.7 64-90.5 64l-96 0 0-64z"]
};
const faSquareParkingSlash = {
  prefix: 'fass',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6 544 32 96 32l0 19.8-47.6-37zM224 151.1l0-23.1 32 0 80 0c53 0 96 43 96 96c0 26.2-10.5 49.9-27.5 67.3l-51.6-40.1C362 245.5 368 235.5 368 224c0-17.7-14.3-32-32-32l-48 0 0 8.8-64-49.7zM487.4 480L288 322.9l0 29.1 0 32-64 0 0-32 0-64 0-15.5L96 171.6 96 480l391.4 0z"]
};
const faParkingSlash = faSquareParkingSlash;
const faTrainTunnel = {
  prefix: 'fass',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M256 0C114.6 0 0 114.6 0 256L0 512l105.4 0 64-64L112 448l0-320 288 0 0 320-57.4 0 64 64L512 512l0-256C512 114.6 397.4 0 256 0zM361.4 512l-64-64-82.7 0-64 64 210.7 0zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-192l-192 0 0 128 192 0 0-128z"]
};
const faHeading = {
  prefix: 'fass',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 32l32 0 16 0 64 0 16 0 32 0 0 64-32 0-16 0 0 112 224 0 0-112-16 0-32 0 0-64 32 0 16 0 64 0 16 0 32 0 0 64-32 0-16 0 0 144 0 176 16 0 32 0 0 64-32 0-16 0-64 0-16 0-32 0 0-64 32 0 16 0 0-144-224 0 0 144 16 0 32 0 0 64-32 0-16 0-64 0-16 0L0 480l0-64 32 0 16 0 0-176L48 96 32 96 0 96 0 32z"]
};
const faHeader = faHeading;
const faGhost = {
  prefix: 'fass',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M48 448L0 480 0 192C0 86 86 0 192 0S384 86 384 192l0 288-48-32-72 64-72-64-72 64L48 448zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faFaceAnguished = {
  prefix: 'fass',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 320c44.2 0 80 35.8 80 80l0 16-160 0 0-16c0-44.2 35.8-80 80-80zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm141 .9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faHockeySticks = {
  prefix: 'fass',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M337.1 393.7l50.3 100.6 8.8 17.7 19.8 0 64 0s0 0 0 0l64 0 0-32 0-128-156.2 0-14.9-29.9-35.8 71.6zM267.2 253.9l35.8-71.6L220.6 17.7 163.4 46.3 267.2 253.9zM576 352l0 160 64 0 0-160-64 0zM96 352l0 128 0 32 32 0 32 0 64 0 19.8 0 8.8-17.7 224-448L419.4 17.7 252.2 352 96 352zM0 352L0 512l64 0 0-160L0 352z"]
};
const faAbacus = {
  prefix: 'fass',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 96l0 112-64 0 0-32 8 0 24 0 0-48-24 0-8 0 0-32 64 0zm-96 32l-8 0-24 0 0 48 24 0 8 0 0 32-128 0 0-32 8 0 24 0 0-48-24 0-8 0 0-32 128 0 0 32zm-160 0l-8 0-24 0 0 48 24 0 8 0 0 32-96 0 0-32 8 0 24 0 0-48-24 0-8 0 0-32 96 0 0 32zm-128 0l-8 0-24 0 0 48 24 0 8 0 0 32-64 0L64 96l64 0 0 32zM64 416l0-176 64 0 0 24-8 0-24 0 0 48 24 0 8 0 0 24-8 0-24 0 0 48 24 0 8 0 0 32-64 0zm96-32l8 0 24 0 0-48-24 0-8 0 0-24 8 0 24 0 0-48-24 0-8 0 0-24 96 0 0 24-8 0-24 0 0 48 24 0 8 0 0 24-8 0-24 0 0 48 24 0 8 0 0 32-96 0 0-32zm128-72l8 0 24 0 0-48-24 0-8 0 0-24 128 0 0 96-8 0-24 0 0 48 24 0 8 0 0 32-128 0 0-32 8 0 24 0 0-48-24 0-8 0 0-24zm160 72l8 0 24 0 0-48-24 0-8 0 0-96 64 0 0 176-64 0 0-32zM64 32L0 32 0 96 0 416l0 64 64 0 448 0 64 0 0-64 0-320 0-64-64 0L64 32z"]
};
const faFilmSimple = {
  prefix: 'fass',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M384 32L128 32l0 64L64 96l0-64L0 32 0 480l64 0 0-64 64 0 0 64 256 0 0-64 64 0 0 64 64 0 0-448-64 0 0 64-64 0 0-64zM64 160l64 0 0 64-64 0 0-64zm384 0l0 64-64 0 0-64 64 0zM64 288l64 0 0 64-64 0 0-64zm384 0l0 64-64 0 0-64 64 0z"]
};
const faFilmAlt = faFilmSimple;
const faList = {
  prefix: 'fass',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M112 48L16 48l0 96 96 0 0-96zm80 16l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z"]
};
const faListSquares = faList;
const faTreePalm = {
  prefix: 'fass',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M96 80l37.2 61.9c-4 3.5-8 7.2-12 11.2C41.9 232.3 64.6 322.8 98.5 356.8L248.4 206.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4l-13 41.5 43.5 0 64 0 28.2 0 3.5-28c12.4-99-2.3-207.2-31.7-292l131.2 0L480 144l28.8 48 67.2 0c0-48-48-128-160-128c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C48 0 0 80 0 128l67.2 0L96 80z"]
};
const faSquarePhoneFlip = {
  prefix: 'fass',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M0 32l448 0 0 448L0 480 0 32zm280 96l-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L168 272 96 312l16 72 16 0c123.7 0 224-100.3 224-224l0-16-72-16z"]
};
const faPhoneSquareAlt = faSquarePhoneFlip;
const faUserBeardBolt = {
  prefix: 'fass',
  iconName: 'user-beard-bolt',
  icon: [576, 512, [], "e689", "M224 0L200 0C142.6 0 96 46.6 96 104l0 8L64 200l0 40 32 32 0 32 48 48 32 0 32 32 32 0 32-32 32 0 48-48 0-32 32-32 0-40-32-88 0-8C352 46.6 305.4 0 248 0L224 0zm73.3 96c4.3 9.8 6.7 20.6 6.7 32l0 16c0 12.7-3 24.8-8.3 35.5l-25.6-25.6-5.9-5.9-8.3 0-64 0-8.3 0-5.9 5.9-25.6 25.6C147 168.8 144 156.7 144 144l0-16c0-11.4 2.4-22.2 6.7-32L192 96l32-32 32 32 41.3 0zM269.5 209.8c-1.8 1.2-3.6 2.4-5.5 3.5c-11.8 6.8-25.4 10.7-40 10.7s-28.2-3.9-40-10.7c-1.9-1.1-3.8-2.3-5.5-3.5L200.3 188l47.4 0 21.8 21.8zM320 416l0-34.7-2.7 2.7L304 384l-18.7 0-22.6 22.6-9.4 9.4L240 416l-32 0-13.3 0-9.4-9.4L162.7 384 144 384l-13.3 0-9.4-9.4-48-48L66.7 320 64 320 0 512l366.5 0 30-96L320 416zm80 96L576 376l0-24-88 0 40-128L352 360l0 24 88 0L400 512z"]
};
const faCartPlus = {
  prefix: 'fass',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0-9.1-48L496 288 576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM316 180l-60 0 0-40 60 0 0-60 40 0 0 60 60 0 0 40-60 0 0 60-40 0 0-60z"]
};
const faGamepad = {
  prefix: 'fass',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M640 64L0 64 0 448l640 0 0-384zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 176l48 0 0 56 56 0 0 48-56 0 0 56-48 0 0-56-56 0 0-48 56 0 0-56z"]
};
const faBorderCenterV = {
  prefix: 'fass',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M448 480l0-64-64 0 0 64 64 0zm0-96l0-64-64 0 0 64 64 0zM64 384l0-64L0 320l0 64 64 0zM384 192l64 0 0-64-64 0 0 64zM64 192l0-64L0 128l0 64 64 0zm320 96l64 0 0-64-64 0 0 64zM64 288l0-64L0 224l0 64 64 0zM384 96l64 0 0-64-64 0 0 64zM0 96l64 0 0-64L0 32 0 96zM64 480l0-64L0 416l0 64 64 0zM288 288l64 0 0-64-64 0 0 64zM352 96l0-64-64 0 0 64 64 0zM288 480l64 0 0-64-64 0 0 64zM160 96l0-64L96 32l0 64 64 0zM96 480l64 0 0-64-64 0 0 64zm64-192l0-64-64 0 0 64 64 0zm32 160l0 32 64 0 0-32 0-384 0-32-64 0 0 32 0 384z"]
};
const faCircleDot = {
  prefix: 'fass',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faDotCircle = faCircleDot;
const faClipboardMedical = {
  prefix: 'fass',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 288l0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0z"]
};
const faFaceDizzy = {
  prefix: 'fass',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM123.3 132.7L112 121.4 89.4 144l11.3 11.3L137.4 192l-36.7 36.7L89.4 240 112 262.6l11.3-11.3L160 214.6l36.7 36.7L208 262.6 230.6 240l-11.3-11.3L182.6 192l36.7-36.7L230.6 144 208 121.4l-11.3 11.3L160 169.4l-36.7-36.7zm192 0L304 121.4 281.4 144l11.3 11.3L329.4 192l-36.7 36.7L281.4 240 304 262.6l11.3-11.3L352 214.6l36.7 36.7L400 262.6 422.6 240l-11.3-11.3L374.6 192l36.7-36.7L422.6 144 400 121.4l-11.3 11.3L352 169.4l-36.7-36.7z"]
};
const faDizzy = faFaceDizzy;
const faEgg = {
  prefix: 'fass',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM96 288c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2l-21.6-23.6c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288l0 16 32 0 0-16z"]
};
const faUpToLine = {
  prefix: 'fass',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M32 288L192 128 352 288l0 32-96 0 0 160-128 0 0-160-96 0 0-32zM352 96L32 96 0 96 0 32l32 0 320 0 32 0 0 64-32 0z"]
};
const faArrowAltToTop = faUpToLine;
const faHouseMedicalCircleXmark = {
  prefix: 'fass',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M320 368.7c.2 59.2 29.7 111.6 74.8 143.3L64.1 512l0-224.4L0 287.6 0 240 288.4 0 520.5 193.7c-8-1.1-16.2-1.7-24.5-1.7c-54.7 0-103.5 24.9-135.8 64L320 256l0-64-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-15.3zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z"]
};
const faWatchFitness = {
  prefix: 'fass',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M64 0L320 0l0 48L64 48 64 0zm0 464l256 0 0 48L64 512l0-48zM0 80l384 0 0 352L0 432 0 80zm139.2 80C106.5 160 80 186.5 80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z"]
};
const faClockNineThirty = {
  prefix: 'fass',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136 0-24-24 0-104 0-24 0 0 48 24 0 80 0 0 112 0 24 48 0 0-24z"]
};
const faCampground = {
  prefix: 'fass',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M241 2l20 25 27 33.8L315 27 335 2l50 40L365 67l-36 45L569 412l7 8.8 0 11.2 0 48 0 32-32 0L32 512 0 512l0-32 0-48 0-11.2L7 412 247 112 211 67 191 42 241 2zm47 289.7L168.5 448l239.1 0L288 291.7z"]
};
const faFolderPlus = {
  prefix: 'fass',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM232 400l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faJug = {
  prefix: 'fass',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M160 0L288 0l32 0 0 64-32 0L160 64l-32 0 0-64 32 0zM359 151l-3.7 3.7L387 190.9 393 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm67.9 67.9L416 229.8 416 512 32 512l0-288L144 96l160 0 19.7 22.5 1.4-1.4c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zM352 288L96 288l0 128 256 0 0-128z"]
};
const faFutbol = {
  prefix: 'fass',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M406.2 136.4l-28.5 80.1 70.1 48c-1.6 35.9-13 69.2-31.6 97.4l-85-2.3-24 81.5c-16.3 4.5-33.5 6.9-51.2 6.9s-34.9-2.4-51.2-6.9l-24-81.5-85 2.3c-18.6-28.1-30.1-61.5-31.6-97.4l70.1-48-28.5-80.1c21.5-26.9 50-47.9 82.8-60.2L256 128l67.4-51.8c32.8 12.3 61.3 33.3 82.8 60.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-336l-76.1 55.3L209 320.7l94 0 29.1-89.4L256 176z"]
};
const faFutbolBall = faFutbol;
const faSoccerBall = faFutbol;
const faSnowBlowing = {
  prefix: 'fass',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M512 48l32 0c53 0 96 43 96 96s-43 96-96 96l-128 0-32 0 0-64 32 0 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-32 0 0-64 32 0zM200 64l0 24 0 25.4 12.7-12.7L224 89.4 246.6 112l-11.3 11.3L200 158.6l0 55.8 48.3-27.9 12.9-48.2 4.1-15.5 30.9 8.3-4.1 15.5-4.6 17.3 15-8.7 20.8-12 24 41.6-20.8 12-15 8.7 17.3 4.6 15.5 4.1L336 245.2 320.6 241l-48.2-12.9L224 256l48.3 27.9L320.6 271l15.5-4.1 8.3 30.9-15.5 4.1-17.3 4.6 15 8.7 20.8 12-24 41.6-20.8-12-15-8.7 4.6 17.3 4.1 15.5-30.9 8.3-4.1-15.5-12.9-48.2L200 297.6l0 55.8 35.3 35.3L246.6 400 224 422.6l-11.3-11.3L200 398.6l0 25.4 0 24-48 0 0-24 0-25.4-12.7 12.7L128 422.6 105.4 400l11.3-11.3L152 353.4l0-55.8-48.3 27.9L90.7 373.7l-4.1 15.5-30.9-8.3 4.1-15.5 4.6-17.3-15 8.7-20.8 12-24-41.6 20.8-12 15-8.7-17.3-4.6L7.7 297.7 16 266.8 31.4 271l48.2 12.9L128 256 79.7 228.1 31.4 241 16 245.2 7.7 214.3l15.5-4.1 17.3-4.6-15-8.7-20.8-12 24-41.6 20.8 12 15 8.7-4.6-17.3-4.1-15.5 30.9-8.3 4.1 15.5 12.9 48.2L152 214.4l0-55.8-35.3-35.3L105.4 112 128 89.4l11.3 11.3L152 113.4 152 88l0-24 48 0zM480 464l0-64 32 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-120 0-32 0 0-64 32 0 120 0c53 0 96 43 96 96s-43 96-96 96l-24 0-32 0z"]
};
const faPaintbrush = {
  prefix: 'fass',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M224 192L512 0l64 64L384 352l-75.3 30.1L193.9 267.3 224 192zm-54.4 96.2L287.8 406.4C284.5 465.3 235.7 512 176 512L0 512l0-64 64 0 0-48c0-59.7 46.7-108.5 105.6-111.8z"]
};
const faPaintBrush = faPaintbrush;
const faLock = {
  prefix: 'fass',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 80 0 0 320L0 512 0 192l80 0z"]
};
const faArrowDownFromLine = {
  prefix: 'fass',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M214.6 454.6L192 477.3l-22.6-22.6-128-128L18.7 304 64 258.7l22.6 22.6L160 354.7 160 192l0-32 64 0 0 32 0 162.7 73.4-73.4L320 258.7 365.3 304l-22.6 22.6-128 128zM32 96L0 96 0 32l32 0 320 0 32 0 0 64-32 0L32 96z"]
};
const faArrowFromTop = faArrowDownFromLine;
const faGasPump = {
  prefix: 'fass',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M32 0L320 0l0 256 8 0c48.6 0 88 39.4 88 88l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-154c-27.6-7.1-48-32.2-48-62l0-64L368 48l32-32L512 128l0 64 0 32 0 152c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-32c0-22.1-17.9-40-40-40l-8 0 0 112L32 416 32 0zM96 64l0 128 160 0 0-128L96 64zM352 448l0 64L0 512l0-64 352 0z"]
};
const faSignalBarsSlash = {
  prefix: 'fass',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M608 0L512 0l0 374.7L448 325l0-197-96 0 0 122.5L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10L608 0zM288 322.9L203.1 256 192 256l0 256 96 0 0-189.1zM448 449l-96-75.6L352 512l96 0 0-63zM128 384l-96 0 0 128 96 0 0-128z"]
};
const faSignalAltSlash = faSignalBarsSlash;
const faMonkey = {
  prefix: 'fass',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-80.6 49.6-149.6 120-178l0 18 0 32 32 0 135.9 0L566.1 400.9l9.9 9.5 0 13.7 0 56 0 32-64 0 0-32 0-42.3-96-91.6L416 448l32 0 32 0 0 64-32 0-32 0-256 0C71.6 512 0 440.4 0 352L0 32 0 0 32 0 192 0l32 0 0 32 0 128 0 32-32 0-64 0-32 0 0-64 32 0 32 0 0-64L64 64l0 288c0 53 43 96 96 96l0-32zm96-288c0-35.3 28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64c0 32.6-24.4 59.6-56 63.5l0 64.5-104 0-72 0-32 0 0-27.8 0-36.7c-31.6-3.9-56-30.9-56-63.5zM384 64c-26.5 0-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3l0 48.7 80 0 0-48.7c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48l-64 0zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faRectanglePro = {
  prefix: 'fass',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M640 32L0 32 0 480l640 0 0-448zM80 160l24 0 56 0c35.3 0 64 28.7 64 64l0 24-4.7 0c-9.5 23.5-32.5 40-59.3 40l-32 0 0 40 0 24-48 0 0-24 0-64 0-80 0-24zm48 80l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32zm272 8c0-48.6 39.4-88 88-88s88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16zm88-40c-22.1 0-40 17.9-40 40l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40zM264 160l56 0c35.3 0 64 28.7 64 64l0 24-4.7 0c-4.7 11.7-12.8 21.7-23.1 28.7l24.1 38.5 23 36.7-56.6 0-7-11.3-33-52.7L288 288l0 40 0 24-48 0 0-24 0-64 0-80 0-24 24 0zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32 32 0z"]
};
const faPro = faRectanglePro;
const faHouseNight = {
  prefix: 'fass',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M88 88c0-38.1 24.2-70.5 58-82.7C135.3 1.8 123.8 0 112 0C50.1 0 0 50.1 0 112s50.1 112 112 112c40.6 0 76.1-21.6 95.8-53.9c-9.9 3.8-20.6 5.9-31.8 5.9c-48.6 0-88-39.4-88-88zM256 0L234.7 42.7 192 64l42.7 21.3L256 128l21.3-42.7L320 64 277.3 42.7 256 0zM400 96L160 304l0 48 64 0 0 160 352 0 0-160 64 0 0-48L400 96zM352 288l96 0 0 96-96 0 0-96zM74.7 362.7L32 384l42.7 21.3L96 448l21.3-42.7L160 384l-42.7-21.3L96 320 74.7 362.7z"]
};
const faHotTubPerson = {
  prefix: 'fass',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M272 24c0 26.7 14.3 46.4 35 73.4l1.4 1.9C327.5 124 352 155.8 352 200l0 24-48 0 0-24c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C248.5 100 224 68.2 224 24l0-24 48 0 0 24zm112 0c0 26.7 14.3 46.4 35 73.4l1.4 1.9C439.5 124 464 155.8 464 200l0 24-48 0 0-24c0-26.7-14.3-46.4-35-73.4l-1.4-1.9C360.5 100 336 68.2 336 24l0-24 48 0 0 24zM0 512L0 336l0-80 0-96 128 0 128 96 256 0 0 256L0 512zM128 320l-32 0 0 16 0 96 0 16 32 0 0-16 0-96 0-16zm96 0l-32 0 0 16 0 96 0 16 32 0 0-16 0-96 0-16zm96 0l-32 0 0 16 0 96 0 16 32 0 0-16 0-96 0-16zm96 0l-32 0 0 16 0 96 0 16 32 0 0-16 0-96 0-16zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z"]
};
const faHotTub = faHotTubPerson;
const faGlobePointer = {
  prefix: 'fass',
  iconName: 'globe-pointer',
  icon: [512, 512, [], "e60e", "M345.9 320l-64 0 20.9-71L263 209.3 160.4 239.5c.8-16.3 2.8-32.1 5.7-47.5l179.7 0c3.9 20.5 6.1 41.9 6.1 64s-2.2 43.5-6.1 64zM128.1 249L1.8 286.1C.6 276.2 0 266.2 0 256c0-22.1 2.8-43.5 8.1-64l125.6 0c-3.2 18.3-5.2 37.3-5.5 57zM234.5 481.1l38-129.1 65.9 0c-11.4 40.2-28.4 75.9-45.8 105.4c-13 21.9-25.9 40-36.5 53.5c-6.4-8.2-13.8-18.2-21.5-29.8zM384 256c0-22.1-2-43.5-5.6-64l125.6 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-125.6 0c3.6-20.5 5.6-41.9 5.6-64zm-12.6-96c-17-65.6-48.3-120-74-156.7c89.2 14.5 163 75.2 196 156.7l-122 0zm-197.7 0c11.4-40.2 28.4-75.9 45.8-105.4c13-21.9 25.9-40 36.5-53.5c10.5 13.5 23.5 31.6 36.5 53.5c17.4 29.4 34.5 65.1 45.8 105.4l-164.6 0zM214.6 3.3c-25.7 36.7-57 91-74 156.7l-122 0c33-81.5 106.7-142.2 196-156.7zM371.4 352l122 0c-33 81.5-106.7 142.2-196 156.7c25.7-36.7 57-91 74-156.7zM0 320l254.5-74.9 12.3 12.3L192 512l-48-96-1.4-1.4-96 96L1.4 465.4l96-96L96 368 0 320z"]
};
const faBlanket = {
  prefix: 'fass',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M0 32l32 0 384 0 32 0 0 32 0 160 0 32 0 48 0 48 0 32-32 0-288 0-32 0 0-64 32 0 256 0 0-16 0-16L64 288l0 64 0 64 352 0 32 0 0 64-32 0L32 480 0 480l0-32 0-96 0-96 0-32L0 64 0 32z"]
};
const faMapLocation = {
  prefix: 'fass',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M288 320s120-130 120-200C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200zM133 138.8L0 192 0 512l160-64 0-247.1c-11.9-21.4-21.5-42.6-27-62.1zM288 373.3s-51.5-55.7-96-121L192 448l192 64 0-259.7c-44.6 65.3-96 121-96 121zM422 189.6c-1.9 3.7-4 7.5-6 11.3L416 512l160-64 0-320L422 189.6z"]
};
const faMapMarked = faMapLocation;
const faHouseFloodWater = {
  prefix: 'fass',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M80 144L288 0 496 144l0 48-48.6 0 .3 71.2c-7.9 5.5-14.9 9.8-22.9 13.5C411.6 282.7 397 287 384 287s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0L288 240l-18.6 13.4-1.1 .8s0 0 0 0s0 0 0 0s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 282.7 205 287 192 287s-27.6-4.3-40.7-10.3c-8.1-3.7-15.2-8.1-23.3-13.7l0-70.9-48 0 0-48zM288 373.4c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.8c-4.5 2.4-9.7 5.1-15.6 7.8C60.6 390.1 31.9 400 0 400l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7zM272.4 493.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.8c-4.5 2.4-9.7 5.1-15.6 7.8C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faCommentsQuestionCheck = {
  prefix: 'fass',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M416 176c0 97.2-93.1 176-208 176c-36.2 0-70.3-7.8-99.9-21.6L0 352l37.6-75.1C13.9 248.3 0 213.5 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zm32 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9L640 512 531.9 490.4C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176zM181.3 77.3c-25.8 0-46.7 20.9-46.7 46.7l0 5.5 40 0 0-5.5c0-3.7 3-6.7 6.7-6.7l47.4 0c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1l-10 5.8 0 11.6 0 17.9 0 20 40 0 0-20 0-6.3 26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6l-47.4 0zM228 250.7l-40 0 0 40 40 0 0-40zm338.1 75.5L580.3 312 552 283.7l-14.1 14.1L472 363.7l-25.9-25.9L432 323.7 403.7 352l14.1 14.1 40 40L472 420.3l14.1-14.1 80-80z"]
};
const faTree = {
  prefix: 'fass',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M224 0L56 176l0 32 48 0L24 288l0 32 56 0L0 416l0 32 192 0 0 32 0 32 64 0 0-32 0-32 192 0 0-32-80-96 56 0 0-32-80-80 48 0 0-32L224 0z"]
};
const faArrowsCross = {
  prefix: 'fass',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M288 32l-32 0 0 64 32 0 50.7 0L25.4 409.4 2.7 432 48 477.3l22.6-22.6L384 141.3l0 50.7 0 32 64 0 0-32 0-128 0-32-32 0L288 32zM70.6 57.4L48 34.7 2.7 80l22.6 22.6L156.1 233.4l45.3-45.3L70.6 57.4zM338.7 416L288 416l-32 0 0 64 32 0 128 0 32 0 0-32 0-128 0-32-64 0 0 32 0 50.7-92.1-92.1-45.3 45.3L338.7 416z"]
};
const faBackpack = {
  prefix: 'fass',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M136 0l24 0L288 0l24 0 0 24 0 72 8 0c70.7 0 128 57.3 128 128l0 288-64 0 0-112 0-96 0-16-16 0L80 288l-16 0 0 16 0 96 0 112L0 512 0 224C0 153.3 57.3 96 128 96l8 0 0-72 0-24zM96 512l0-96 256 0 0 96L96 512zM264 48l-80 0 0 48 80 0 0-48zm40 128l-160 0-16 0 0 32 16 0 160 0 16 0 0-32-16 0zm48 208L96 384l0-64 256 0 0 64z"]
};
const faSquareSmall = {
  prefix: 'fass',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M0 96H320V416H0V96z"]
};
const faFolderArrowUp = {
  prefix: 'fass',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM280 376l0-102.1 31 31 17 17L361.9 288l-17-17-72-72-17-17-17 17-72 72-17 17L184 321.9l17-17 31-31L232 376l0 24 48 0 0-24z"]
};
const faFolderUpload = faFolderArrowUp;
const faBridgeLock = {
  prefix: 'fass',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M32 32l32 0 512 0 32 0 0 64-32 0-40 0 0 64-8 0c-61.9 0-112 50.1-112 112l0 16-32 0 0 24.4c-17-15.2-39.4-24.4-64-24.4c-53 0-96 43-96 96l0 96-96 0 0-96c0-53-43-96-96-96l0-128 72 0 0-64L64 96 32 96l0-64zM408 96l0 64 80 0 0-64-80 0zm-48 64l0-64-80 0 0 64 80 0zM152 96l0 64 80 0 0-64-80 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faCrosshairsSimple = {
  prefix: 'fass',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M445.3 224L384 224l-32 0 0 64 32 0 61.3 0C431.9 368.4 368.4 431.9 288 445.3l0-61.3 0-32-64 0 0 32 0 61.3C143.6 431.9 80.1 368.4 66.7 288l61.3 0 32 0 0-64-32 0-61.3 0C80.1 143.6 143.6 80.1 224 66.7l0 7.3 0 54.1 0 32 64 0 0-32 0-54.1 0-7.3C368.4 80.1 431.9 143.6 445.3 224zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faSackDollar = {
  prefix: 'fass',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M320 96L192 96 128 0 384 0 320 96zM192 128l128 0c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416l0 96-96 0L96 512 0 512l0-96C0 250.9 122.3 172.7 179 136.4c0 0 0 0 0 0s0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 96l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.2l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3z"]
};
const faPenToSquare = {
  prefix: 'fass',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M144 272L128 384l112-16L436.7 171.3l-96-96L144 272zM512 96L416 0 363.3 52.7l96 96L512 96zM32 64L0 64 0 96 0 480l0 32 32 0 384 0 32 0 0-32 0-160 0-32-64 0 0 32 0 128L64 448l0-320 128 0 32 0 0-64-32 0L32 64z"]
};
const faEdit = faPenToSquare;
const faSquareSliders = {
  prefix: 'fass',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M448 480l0-448L0 32 0 480l448 0zM384 304l0 64-32 0-32 0 0 16 0 32-64 0 0-32 0-16L96 368l-32 0 0-64 32 0 160 0 0-16 0-32 64 0 0 32 0 16 32 0 32 0zM352 144l32 0 0 64-32 0-160 0 0 16 0 32-64 0 0-32 0-16-32 0-32 0 0-64 32 0 32 0 0-16 0-32 64 0 0 32 0 16 160 0z"]
};
const faSlidersHSquare = faSquareSliders;
const faCarSide = {
  prefix: 'fass',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M106.3 64L128 64l256 0 15.4 0L409 76 527.4 224 640 224l0 208-65.3 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-130.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80L0 432 0 224l42.3 0 56-139.9 8-20.1zM434.7 432a48 48 0 1 0 90.5-32 48 48 0 1 0 -90.5 32zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM111.3 224L224 224l0-96-74.3 0-38.4 96zM272 224l173.4 0-76.8-96L272 128l0 96z"]
};
const faMessageMiddleTop = {
  prefix: 'fass',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M338.3 96L512 96l0 416L0 512 0 96l173.7 0L256 0l82.3 96z"]
};
const faCommentMiddleTopAlt = faMessageMiddleTop;
const faLightbulbOn = {
  prefix: 'fass',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M449.2 297.8c-19.8 27.1-39.7 54.4-49.2 86.2l-160 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0zM240 512l0-96 160 0 0 96-160 0zM320 96l0-32c-61.9 0-112 50.1-112 112l32 0c0-44.2 35.8-80 80-80zM87.3 16l6 4 24 16 20 13.3L110.7 89.3 90.7 76l-24-16-6-4-20-13.3L67.3 2.7 87.3 16zM579.3 56l-6 4-24 16-20 13.3L502.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L579.3 56zM24 160l48 0 24 0 0 48-24 0-48 0L0 208l0-48 24 0zm544 0l48 0 24 0 0 48-24 0-48 0-24 0 0-48 24 0zM117.3 332l-24 16-6 4-20 13.3L40.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3z"]
};
const faKnife = {
  prefix: 'fass',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M320 146.7L466.7 0s45.3 40 45.3 104c0 73.2-68 140.8-164.3 236.4c-9 8.9-18.3 18.1-27.7 27.6l-65.4-65.4s0 0 0 0l-184 184L48 509.3 2.7 464l22.6-22.6 272-272L320 146.7s0 0 0 0z"]
};
const faUtensilKnife = faKnife;
const faShareNodes = {
  prefix: 'fass',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"]
};
const faShareAlt = faShareNodes;
const faDisplayChartUpCircleDollar = {
  prefix: 'fass',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M0 0L576 0l0 211.2c-19.5-10-41.1-16.4-64-18.5L512 64 64 64l0 288 256.7 0c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144L160 512l-32 0 0-64 32 0 69.3 0L240 416 0 416 0 0zM480 120l0 72.7c-16.8 1.5-32.9 5.4-48 11.3l0-4 0-22.1L321 289l-17 17-17-17-63-63-87 87L103 279 207 175l17-17 17 17 63 63L398.1 144 376 144l-24 0 0-48 24 0 80 0 24 0 0 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L529.9 301c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4 0-16-32 0 0 16 0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L436 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4 0 16 32 0 0-16 0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
const faWaveSine = {
  prefix: 'fass',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M215.9 106.3c-10-6.6-22.4-10.7-39.3-10.3c-34.9 .7-62.8 27.5-84.3 64.8c-10.2 17.7-17.6 35.6-22.5 49.3c-2.4 6.8-4.2 12.4-5.3 16.2c-.6 1.9-1 3.4-1.2 4.3l-.3 1 0 .2L32 224C.9 216.3 .9 216.3 .9 216.3s0 0 0 0c0 0 0 0 0-.1l0-.2 .1-.5c.1-.4 .2-1 .4-1.6c.4-1.4 .9-3.3 1.6-5.7c1.4-4.8 3.5-11.6 6.4-19.6c5.7-16 14.6-37.7 27.3-59.7C61.2 86.7 105.2 33.5 175.3 32c29-.6 54.3 6.7 75.7 20.8c21.1 13.8 36.8 33 49.1 53.9c23.5 39.9 37.5 91.8 50.1 138.4c.2 .9 .5 1.7 .7 2.6c13.4 49.8 25.5 93.6 44.1 125.2c9 15.3 18.6 26 29 32.8c10 6.6 22.4 10.7 39.3 10.3c34.9-.7 62.8-27.5 84.3-64.8c10.2-17.7 17.6-35.6 22.5-49.3c2.4-6.8 4.2-12.4 5.3-16.2c.6-1.9 1-3.4 1.2-4.3l.3-1 0-.2L608 288c31.1 7.7 31.1 7.7 31.1 7.7s0 0 0 0c0 0 0 0 0 .1l0 .2-.1 .5c-.1 .4-.2 1-.4 1.6c-.4 1.4-.9 3.3-1.6 5.7c-1.4 4.8-3.5 11.6-6.4 19.6c-5.7 16-14.6 37.7-27.3 59.7c-24.3 42.1-68.3 95.4-138.4 96.9c-29 .6-54.3-6.7-75.7-20.8c-21.1-13.8-36.8-33-49.1-53.9c-23.5-39.9-37.5-91.9-50.1-138.4c-.2-.9-.5-1.7-.7-2.6c-13.4-49.8-25.5-93.6-44.1-125.2c-9-15.3-18.6-26-29-32.8z"]
};
const faHeartCircleMinus = {
  prefix: 'fass',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm224 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-16 0-128 0-16 0 0 32 16 0 128 0 16 0z"]
};
const faCircleW = {
  prefix: 'fass',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM409.5 152L343.1 382.6l-5 17.4-35.6 0-5.3-16.7L256 254.7 214.9 383.3 209.5 400l-35.6 0-5-17.4L102.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L359.5 152l50 0z"]
};
const faCircleCalendar = {
  prefix: 'fass',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 96l0 32 64 0 0-32 32 0 0 32 64 0 0 64-256 0 0-64 64 0 0-32 32 0zM128 384l0-160 256 0 0 160-256 0z"]
};
const faCalendarCircle = faCircleCalendar;
const faHourglassHalf = {
  prefix: 'fass',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M0 0L32 0 352 0l32 0 0 64-32 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64 32 0 0 64-32 0L32 512 0 512l0-64 32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64L0 64 0 0zM96 64l0 50.7L109.3 128l165.5 0L288 114.7 288 64 96 64zm13.3 320l165.5 0L192 301.3 109.3 384z"]
};
const faHourglass2 = faHourglassHalf;
const faMicroscope = {
  prefix: 'fass',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M160 0l96 0 0 32 32 0 0 288-32 0 0 32-96 0 0-32-32 0 0-288 32 0 0-32zM32 448l288 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l0-64c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128l16.9 0 32 0 0 64-32 0-160 0L32 512 0 512l0-64 32 0zm80-64l192 0 16 0 0 32-16 0-192 0-16 0 0-32 16 0z"]
};
const faSunset = {
  prefix: 'fass',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M256 224l0-1.8-77.5-70.5-23.7-21.5 43.1-47.4 23.7 21.5L256 135.7 256 32l0-32 64 0 0 32 0 103.7 34.5-31.3 23.7-21.5 43 47.4-23.7 21.5L320 222.2l0 1.8-2 0-8.4 7.7L288 251.2l-21.5-19.6L258 224l-2 0zm-74 0l106 73.1L394 224l23.3 126.7L544 374l-40 58-97.3 0c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80L72 432 32 374l126.7-23.3L182 224zM0 464l24 0 528 0 24 0 0 48-24 0L24 512 0 512l0-48z"]
};
const faSink = {
  prefix: 'fass',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 192-64 0 0-56 0-24-24 0-80 0-24 0 0 48 24 0 56 0 0 32-80 0L0 288l0 64 32 0 192 0 64 0 192 0 32 0 0-64-32 0-80 0 0-32 64 0 24 0 0-48-24 0-88 0-24 0 0 24 0 56-64 0 0-192zM480 384L32 384l0 32c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-32z"]
};
const faCalendarExclamation = {
  prefix: 'fass',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320zM248 240l0 24 0 96 0 24-48 0 0-24 0-96 0-24 48 0zm0 176l0 48-48 0 0-48 48 0z"]
};
const faTruckContainerEmpty = {
  prefix: 'fass',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M456 160l-24 0 0 24 0 72 0 32 0 32-224 0L80 320l-48 0L0 320l0 32 0 32 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L432 384l17.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l33.6 0 0-96 0-32 0-9.9-7-7-72-72-7-7-9.9 0-88 0zm126.1 96L480 256l0-48 54.1 0 48 48zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHandHeart = {
  prefix: 'fass',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M288 0l0 32 0 224 32 0 0-192 0-32 64 0 0 32 0 192 32 0 0-128 0-32 64 0 0 32 0 208c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64L29.3 357 .3 329.4l55.2-57.9 29 27.6 43.6 41.5c0-1.5-.1-3.1-.1-4.6l0-272 0-32 64 0 0 32 0 192 32 0 0-224 0-32 64 0zM213.4 359.5c0 10.7 4.4 21 12.1 28.4L280.7 441l7.4 7.1 7.4-7.1 55.2-53.1c7.7-7.4 12.1-17.7 12.1-28.4c0-21.8-17.7-39.5-39.5-39.5l-1.6 0c-10.6 0-20.8 4.1-28.5 11.5l-5.1 4.9-5.1-4.9c-7.7-7.4-17.9-11.5-28.5-11.5l-1.6 0c-21.8 0-39.5 17.7-39.5 39.5z"]
};
const faBagShopping = {
  prefix: 'fass',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48L0 160 0 512l448 0 0-352-112 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faShoppingBag = faBagShopping;
const faArrowDownZA = {
  prefix: 'fass',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M160 479.4l23.6-25.7 88-96L293.2 334 246 290.8l-21.6 23.6L192 349.7 192 64l0-32-64 0 0 32 0 285.7L95.6 314.4 74 290.8 26.8 334l21.6 23.6 88 96L160 479.4zM320 32l0 64 32 0 52 0-73 63.9L320 169.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9L512 86.5 512 72l0-8 0-32-32 0L352 32l-32 0zm75.5 224l-8.6 18.7-88 192L292.8 480l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 256l-41.1 0zM416 364.8L432.1 400l-32.3 0L416 364.8z"]
};
const faSortAlphaDesc = faArrowDownZA;
const faSortAlphaDownAlt = faArrowDownZA;
const faMitten = {
  prefix: 'fass',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M352 384L64 384 5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0l3.4 0c66 0 123.5 44.9 139.5 108.9l33.6 134.3L368 192l80 80L352 384zM32 416l352 0 0 96L32 512l0-96z"]
};
const faReplyClock = {
  prefix: 'fass',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M352 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM512 64l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16zM224 160l96.7 0c8.1 89.7 83.5 160 175.3 160c5.1 0 10.2-.2 15.2-.6c.5 5.5 .8 11 .8 16.6c0 128-128 176-128 176s32-32 32-80c0-61.9-50.1-112-112-112l-80 0 0 96-32 0L0 240 192 64l32 0 0 96z"]
};
const faReplyTime = faReplyClock;
const faPersonRays = {
  prefix: 'fass',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L178 142.8l-81.7 128 53.9 34.4 33.8-53L184 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L334 142.8 324.6 128l-17.5 0-102.2 0zM57 23L40 6.1 6.1 40 23 57l64 64 17 17L137.9 104 121 87 57 23zM489 57l17-17L472 6.1 455 23 391 87l-17 17L408 137.9l17-17 64-64zM121 425l17-17L104 374.1 87 391 23 455l-17 17L40 505.9l17-17 64-64zM425 391l-17-17L374.1 408l17 17 64 64 17 17L505.9 472l-17-17-64-64z"]
};
const faRight = {
  prefix: 'fass',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M448 256L256 64l-32 0 0 128L0 192 0 320l224 0 0 128 32 0L448 256z"]
};
const faArrowAltRight = faRight;
const faCircleF = {
  prefix: 'fass',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24 24 0z"]
};
const faUsers = {
  prefix: 'fass',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM48 192l148 0c-2.6 10.2-4 21-4 32c0 38.2 16.8 72.5 43.3 96L0 320 48 192zM640 320l-235.3 0c26.6-23.5 43.3-57.8 43.3-96c0-11-1.4-21.8-4-32l148 0 48 128zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM464 352l48 160-384 0 48-160 288 0z"]
};
const faFacePleading = {
  prefix: 'fass',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 64c44.2 0 80-35.8 80-80c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2 4.4-15.4L165 92.2l-4.4 15.4-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1l-15.9 2 4 31.8 13.8-1.7C85.9 205.5 80 222.1 80 240c0 44.2 35.8 80 80 80zm192 0c44.2 0 80-35.8 80-80c0-17.9-5.9-34.5-15.9-47.9l13.8 1.7 4-31.8-15.9-2-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2L347 92.2 316.2 101l4.4 15.4 1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80zM280.1 426.7l10.7 11.9 23.8-21.4-10.7-11.9C294.7 395.1 278.7 384 256 384s-38.7 11.1-47.9 21.3l-10.7 11.9 23.8 21.4 10.7-11.9c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
const faEyeSlash = {
  prefix: 'fass',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM222.5 150c25.6-23.6 59.9-38 97.5-38c79.5 0 144 64.5 144 144c0 24.7-6.2 47.9-17.1 68.2l-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8l11.6 58.2L222.5 150zM444.9 446.6L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L85.7 163.5C60.2 197.1 42.1 230.8 32 256c30 74.7 129.6 224 288 224c46.9 0 88.6-13.1 124.9-33.4zM324.8 351.9l-99.1-78.1C234 318.3 273.1 352 320 352c1.6 0 3.2 0 4.8-.1z"]
};
const faFlaskVial = {
  prefix: 'fass',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M224 0l32 0 0 64-32 0 0 245.9-59.3 96.3-4.7 7.7 0 9.1 0 19.6c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96L32 64 0 64 0 0 32 0 96 0l64 0 64 0zM196.7 415.2L221 375.8l99-160.8L320 64l-32 0 0-64 32 0 32 0L480 0l32 0 32 0 0 64-32 0 0 150.9L635.3 415.2l4.7 7.7 0 9.1 0 48 0 32-32 0-384 0-32 0 0-32 0-48 0-8.4 0-.6 4.7-7.7zM96 64l0 96 64 0 0-96L96 64zm288 0l0 160 0 9.1-4.7 7.7L330.5 320l171 0-48.8-79.2-4.7-7.7 0-9.1 0-160-64 0z"]
};
const faPoliceBox = {
  prefix: 'fass',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M208 0l0 16 0 16 112 0 0 32 32 0 0 384 32 0 0 64L0 512l0-64 32 0L32 64l32 0 0-32 112 0 0-16 0-16 32 0zM96 128l0 32 32 0 0-32-32 0zm0 48l0 32 32 0 0-32-32 0zm80-48l-32 0 0 32 32 0 0-32zm-32 48l0 32 32 0 0-32-32 0zm96-48l-32 0 0 32 32 0 0-32zm0 48l-32 0 0 32 32 0 0-32zm16-48l0 32 32 0 0-32-32 0zm32 48l-32 0 0 32 32 0 0-32zM96 240l0 80 80 0 0-80-80 0z"]
};
const faCucumber = {
  prefix: 'fass',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M37.5 474.5c47.8 47.8 123.9 49.9 174.2 6.4L232 501.3 277.3 456l-20.1-20.1L435.9 257.1 456 277.3 501.3 232l-20.4-20.4c43.5-50.3 41.4-126.4-6.4-174.2c-50-50-131-50-181 0L172.1 158.9 152 138.7 106.7 184l20.1 20.1L37.5 293.5c-50 50-50 131 0 181zM168 280l0 48-48 0 0-48 48 0zm112-32l48 0 0 48-48 0 0-48zM424 88l0 48-48 0 0-48 48 0z"]
};
const faHeadSideBrain = {
  prefix: 'fass',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zM288 208l48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48l16 0 0 48 64 0 0-48 16 0c26.5 0 48-21.5 48-48l0-16zM160 176l0 2.7c0 0 0 0-.1 0c0-.9 .1-1.8 .1-2.7z"]
};
const faHand = {
  prefix: 'fass',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M288 32l0-32L224 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6L84.5 299.1l-29-27.6L.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208 0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224z"]
};
const faHandPaper = faHand;
const faPersonBikingMountain = {
  prefix: 'fass',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160L336 88 223.2 175.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 448l64 0 0-177.1-57-38 60.3-48.5L404.8 224 512 224l0-64-84.8 0zM176 176L304 80 256 20l-42.7 0L112 96l64 80zm-16 80l-64 0 0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8L60.1 270.9 14.9 316.1l14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L0 352l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3L14.9 451.9l45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8L96 512l64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6zm-32 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352-64l0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8l-14.6-14.6-45.3 45.3 14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L384 352l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3l-14.6 14.6 45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6-64 0zM448 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faBikingMountain = faPersonBikingMountain;
const faUtensilsSlash = {
  prefix: 'fass',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M303.9 213.2C314.1 198 320 179.7 320 160L288 0 256 0l0 160-16 0L224 0 192 0 180.3 117.2 160 101.4 160 0 128 0 114.7 66.3 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6l0-47.6 0-112 0-32L544 0C512 0 384 32 384 176l0 99.4-80.1-62.2zM96.8 172.2c5.3 42 37.8 75.5 79.2 82.4L176 480l0 32 64 0 0-32 0-194.9L96.8 172.2z"]
};
const faPrintMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M128 0l0 32 0 128 64 0 0-96 226.7 0L448 93.3l0 66.7 64 0 0-80 0-13.3-9.4-9.4-48-48L445.3 0 432 0 160 0 128 0zM352 192L64 192l0 192 64 0 0 96 0 32 32 0 320 0 32 0 0-26.2L498.2 472c-15.8 5.2-32.6 8-50.2 8c-36 0-69.3-11.9-96-32l-160 0 0-64 0-16 0-16 99.2 0c-2.1-10.3-3.2-21-3.2-32c0-52.3 25.1-98.8 64-128zm96 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faPrintSearch = faPrintMagnifyingGlass;
const faTurnRight = {
  prefix: 'fass',
  iconName: 'turn-right',
  icon: [512, 512, [], "e639", "M512 224L352 64l-32 0 0 112L0 176 0 480l96 0 0-208 224 0 0 112 32 0L512 224z"]
};
const faFolderBookmark = {
  prefix: 'fass',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM288 160l0 192 80-56 80 56 0-192-160 0z"]
};
const faArrowTurnLeftDown = {
  prefix: 'fass',
  iconName: 'arrow-turn-left-down',
  icon: [384, 512, [], "e633", "M342.6 361.4l22.6-22.6L320 293.5l-22.6 22.6L224 389.5 224 64l128 0 32 0 0-64L352 0 192 0 160 0l0 32 0 357.5L86.6 316.1 64 293.5 18.8 338.7l22.6 22.6 128 128L192 512l22.6-22.6 128-128z"]
};
const faOm = {
  prefix: 'fass',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M368 0L336 32l32 32 32-32L368 0zm16 192l-13.3 0-9.4 9.4L306.7 256l-61.5 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-41.2 0-77.1 22.2-96.5 55.2l55.1 32.5C111 169.4 126.4 160 144 160c26.5 0 48 21.5 48 48s-21.5 48-48 48l-56 0 24 64 32 0 16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64C48 448 0 352 0 352s0 160 160 160c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64l49.1 0 13.3 0 9.4-9.4L397.3 256l18.7 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32c-64 0-96-48-96-48l0 64s16 48 96 48c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-32 0zM480 64s-66.5 32-112 32s-112-32-112-32s16 96 120 96c72 0 104-32 104-32l0-64z"]
};
const faPi = {
  prefix: 'fass',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M32 64L0 64l0 64 32 0 64 0 0 217.8L66.3 420.1l59.4 23.8 32-80 2.3-5.7 0-6.2 0-224 128 0 0 288 0 32 32 0 80 0 23.1 0 7.3-21.9 16-48-60.7-20.2L376.9 384 352 384l0-256 64 0 32 0 0-64-32 0L32 64z"]
};
const faFlaskRoundPotion = {
  prefix: 'fass',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M192 206.2l0-38.8L192 64l64 0 0 103.4 0 38.8 34.4 17.9c46.2 24.1 77.5 72.2 77.6 127.6c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c6.8-46.4 35.8-85.7 76-106.6L192 206.2zm128-38.8L320 64l32 0 0-64L320 0 256 0 192 0 128 0 96 0l0 64 32 0 0 103.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6z"]
};
const faFlaskPotion = faFlaskRoundPotion;
const faFaceShush = {
  prefix: 'fass',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M0 256C0 357.2 58.7 444.7 144 486.3l0-54.3 0-56 0-24 0-32 32 0 24 0 0-44.1c-14.8-6.9-26.6-15.9-35.3-24.6L153.4 240 176 217.4l11.3 11.3c3.5 3.5 7.7 7.1 12.7 10.5l0-15.2 0-32 32 0 48 0 32 0 0 32 0 15.2c4.9-3.4 9.2-7 12.7-10.5L336 217.4 358.6 240l-11.3 11.3c-8.7 8.7-20.5 17.7-35.3 24.6l0 44.1 8 0 32 0 0 32 0 10.1 .8-1 24.6 20.5 36.9 30.7 24.6 20.5-10 12C480 398 512 330.7 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 248l0-24-48 0 0 24 0 72 48 0 0-72zM200 352l-24 0 0 24 0 56 0 56 0 24 24 0 80 0 40 0 11.2 0 7.2-8.6 40-48 15.4-18.4-36.9-30.7-15.4 18.4L308.8 464l-21.2 0L224 419.5l0-19.5 24 0 24 0 0 32 48 0 0-56 0-24-24 0-48 0-48 0z"]
};
const faWorm = {
  prefix: 'fass',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M256 96c0-53 43-96 96-96L480 0l0 128 0 48 0 16 0 184c0 75.1-60.9 136-136 136s-136-60.9-136-136l0-80c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 168 0 48-96 0 0-48 0-168c0-75.1 60.9-136 136-136s136 60.9 136 136l0 80c0 22.1 17.9 40 40 40s40-17.9 40-40l0-184-32 0c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faHouseCircleXmark = {
  prefix: 'fass',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M520.5 193.7L288.4 0 0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z"]
};
const faPlug = {
  prefix: 'fass',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2C297 398 352 333.4 352 256l0-32 32 0 0-64-32 0L32 160z"]
};
const faCalendarCircleExclamation = {
  prefix: 'fass',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M160 0L96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64zm96 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 512l330.8 0C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faSquareI = {
  prefix: 'fass',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M448 32L0 32 0 480l448 0 0-448zM152 128l72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48 24 0z"]
};
const faChevronUp = {
  prefix: 'fass',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z"]
};
const faFaceSaluting = {
  prefix: 'fass',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M310.1 61.9l-26.5 18-26.5 18-30 20.4 35.5 48.9 6.6 9.1c1-.1 2.1-.2 3.2-.2c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.1 0-24.4-7.9-29.3-19.1l-13.4 9.7-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-26.5 0-52.1 4-76.1 11.5l16.2 23.9 18 26.5zM128 185.8l0-39.1L239.2 71.3l26.5-18L229.7 .4l-26.5 18L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9 25.9-18.8-37.6-51.8s0 0 0 0s0 0 0 0L173.2 153 160 162.6l-14.2 10.4L128 185.8zM227.5 354l25-20c7.2 9 39.7 34 99.5 34s92.3-25 99.5-34l25 20c-14.1 17.6-56.3 46-124.5 46s-110.4-28.4-124.5-46zM432.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGaugeSimpleLow = {
  prefix: 'fass',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9l-11.1-21.3-42.6 22.1 11.1 21.3 76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faTachometerSlow = faGaugeSimpleLow;
const faFacePersevering = {
  prefix: 'fass',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9zM222.6 112l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4 222.6 112zm78.1 11.3L289.4 112 312 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM112 208l118.9 64L112 336l45.7-64L112 208zm169.1 64L400 208l-45.7 64L400 336 281.1 272z"]
};
const faCircleCamera = {
  prefix: 'fass',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196 160l12-32 96 0 12 32 68 0 0 192-256 0 0-192 68 0zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faCameraCircle = faCircleCamera;
const faHandSpock = {
  prefix: 'fass',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M251.2 39.7L242.9 8.8 181.1 25.4l8.3 30.9L242.9 256l-29.6 0L166.6 102.7l-9.3-30.6L96.1 90.7l9.3 30.6 71.7 235.5-61.6-58.6-29-27.6L31.4 328.5l29 27.6L156.8 448c43.1 41.1 100.4 64 160 64l2.3 0 8.9 0 8.3 0c56.7 0 106.7-37.3 122.8-91.7l83.7-283.2 9.1-30.7L490.4 88.2l-9.1 30.7L440.8 256l-24.7 0L455.3 70.6l6.6-31.3L399.3 26.1l-6.6 31.3L350.7 256l-41.5 0L251.2 39.7z"]
};
const faSpiderWeb = {
  prefix: 'fass',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M142 .1l23.1 4.3L288 27.5l122.8-23L434 .1l8.3 22 46.3 123.6 77 92.4L580.4 256l-14.9 17.9-77 92.4L442.2 489.8l-8.3 22-23.1-4.3L288 484.5l-122.8 23L142 511.9l-8.3-22L87.4 366.3l-77-92.4L-4.4 256l14.9-17.9 77-92.4L133.8 22.2 142 .1zm25.1 92.7l-28.9 77-1.7 4.4-3 3.6L88.4 232l44.7 0 34.8-39.8 21.4-60.6L167.1 92.8zm42.1-23.1l21.5 37.5L288 123.9l57.4-16.6 21.5-37.5L293.2 83.5l-5.2 1-5.2-1L209.2 69.7zM408.9 92.8l-22.2 38.8 21.4 60.6L442.9 232l44.7 0-45.1-54.1-3-3.6-1.7-4.4-28.9-77zM487.6 280l-44.7 0-34.7 39.6-20.9 61.7 21.6 37.9 28.9-77 1.7-4.4 3-3.6L487.6 280zM366.8 442.3l-19.6-34.2-59.7-19.8-56.9 16.5-21.5 37.5 73.6-13.8 5.2-1 5.2 1 73.6 13.8zM167.1 419.2l22.2-38.8-21.4-60.6L133.1 280l-44.7 0 45.1 54.1 3 3.6 1.7 4.4 28.9 77zM196.9 280l10.2 11.6 3 3.5 1.5 4.4 9.1 25.9L246.6 280l-49.8 0zm68 64.9l16.5-4.8 7.2-2.1 7.1 2.3 16.1 5.3L288 304.4l-23.1 40.5zm90.6-19.2l8.8-26 1.5-4.5 3.1-3.6L379.1 280l-49.8 0 26.1 45.7zM379.1 232l-10.2-11.6-3-3.5-1.5-4.4-9.1-25.9L329.4 232l49.8 0zm-68-64.9l-16.5 4.8-6.7 1.9-6.7-1.9-16.5-4.8L288 207.6l23.1-40.5zm-90.4 19.5l-9.1 25.9-1.5 4.4-3 3.5L196.9 232l49.8 0-25.9-45.3z"]
};
const faCircleMicrophone = {
  prefix: 'fass',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 256l0-160 96 0 0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48zm-48-32l0 16 0 16c0 53 43 96 96 96s96-43 96-96l0-16 0-16 32 0 0 16 0 16c0 65.3-48.9 119.1-112 127l0 17 0 16-32 0 0-16 0-17c-63.1-7.9-112-61.7-112-127l0-16 0-16 32 0z"]
};
const faMicrophoneCircle = faCircleMicrophone;
const faBookArrowUp = {
  prefix: 'fass',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64-88 0 0-174.1 39 39 17 17L353.9 232l-17-17-80-80-17-17-17 17-80 80-17 17L160 265.9l17-17 39-39L216 384 96 384c-17.7 0-32 14.3-32 32z"]
};
const faPopsicle = {
  prefix: 'fass',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M160 0C71.6 0 0 71.6 0 160L0 384l320 0 0-224C320 71.6 248.4 0 160 0zm32 512l0-96-64 0 0 96 64 0z"]
};
const faCommand = {
  prefix: 'fass',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 0L32 0 160 0l32 0 0 32 0 96 128 0 0-96 0-32 32 0L480 0l32 0 0 32 0 128 0 32-32 0-96 0 0 128 96 0 32 0 0 32 0 128 0 32-32 0-128 0-32 0 0-32 0-96-128 0 0 96 0 32-32 0L32 512 0 512l0-32L0 352l0-32 32 0 96 0 0-128-96 0L0 192l0-32L0 32 0 0zM128 128l0-64L64 64l0 64 64 0zm64 192l128 0 0-128-128 0 0 128zm-64 64l-64 0 0 64 64 0 0-64zm256 0l0 64 64 0 0-64-64 0zm0-256l64 0 0-64-64 0 0 64z"]
};
const faBlinds = {
  prefix: 'fass',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M32 0L0 0 0 64l16 0L0 128l128 0 0-64 32 0 0 64 352 0L496 64l16 0 0-64L480 0 32 0zM24 160L0 256l98.7 0c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7L24 160zM144 320c-20.9 0-38.7-13.4-45.3-32L24 288 0 384l512 0-24-96-298.7 0c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3L512 256l-24-96-328 0 0 66.7zM0 512l512 0-24-96L24 416 0 512z"]
};
const faStopwatch = {
  prefix: 'fass',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M224 0L144 0l0 64 48 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1L445.3 144 400 98.7l-22.6 22.6L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l48 0 0-64L224 0zm24 216l0 112 0 24-48 0 0-24 0-112 0-24 48 0 0 24z"]
};
const faSaxophone = {
  prefix: 'fass',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6l0 2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 225l-8-8-17-17L328 166.1l17 17 8 8L367 177l-8-8-17-17L376 118.1l17 17 8 8L415 129l-8-8-17-17L424 70.1l17 17 8 8 63-63 80 0 48 32 0 32-96 0L288.6 418.6C257.9 457.4 211.2 480 161.8 480C72.4 480 0 407.6 0 318.2l0-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176 24 176 0 176l0-48 24 0 240 0 24 0 0 48-24 0-17.3 0zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faSquare2 = {
  prefix: 'fass',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M448 32L0 32 0 480l448 0 0-448zM161.7 146.5c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336l83.3 0 24 0 0 48-24 0-144 0-24 0 0-34.4 7.6-7.1L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3L174.5 197l-19.1 14.5-29.1-38.2 19.1-14.5 16.2-12.3z"]
};
const faFieldHockeyStickBall = {
  prefix: 'fass',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M506.6 59L479.8 98.8l-33 49.1L367 94.6l33.2-49.4L427 5.4 506.6 59zM349.1 121.2l79.8 53.3L241.1 453.7c-24.3 36.2-65.1 57.9-108.7 58.1C59.3 512 .1 452.5 .6 379.4l0-2.7c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5 26.3-40.2 80.4 52.5-26.3 40.2-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6l0 2.7c-.1 19.7 15.8 35.8 35.5 35.7c11.8 0 22.7-5.9 29.3-15.7L349.1 121.2zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faFieldHockey = faFieldHockeyStickBall;
const faArrowUpSquareTriangle = {
  prefix: 'fass',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M512 32l0 192-192 0 0-192 192 0zm-352 .4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26zM416 288L528 480l-224 0L416 288z"]
};
const faSortShapesUpAlt = faArrowUpSquareTriangle;
const faFaceScream = {
  prefix: 'fass',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M569 315.8c4.6-19.2 7-39.2 7-59.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 20.6 2.4 40.7 7 59.9L82.3 306l20.6-18 21 17.5c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187l21-17.5 20.6 18 11.3 9.8zM320 320c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7zm183.4 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.6-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.6 93.7zM192 512c-7-68.4-34.8-137-88.7-181.9L39.1 386.2c26.4 40 43.6 75.3 43.2 125.7L192 512zm365.7 0c-.4-50.5 16.7-85.7 43.2-125.7l-64.3-56.2C482.8 375 455 443.6 448 512l109.8 0z"]
};
const faSquareM = {
  prefix: 'fass',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M448 32L0 32 0 480l448 0 0-448zM96 152l0-24 36.3 0 7.2 9.9L224 255l84.5-117.1 7.2-9.9 36.3 0 0 24 0 208 0 24-48 0 0-24 0-133.8-60.5 83.8L224 337l-19.5-26.9L144 226.2 144 360l0 24-48 0 0-24 0-208z"]
};
const faCameraWeb = {
  prefix: 'fass',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M340.5 415.4C405 376 448 305 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 81 43 152 107.5 191.4L32 472l0 40 384 0 0-40-75.5-56.6zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM176 224l-32 0c0-44.2 35.8-80 80-80l0 32c-26.5 0-48 21.5-48 48z"]
};
const faWebcam = faCameraWeb;
const faCommentArrowDown = {
  prefix: 'fass',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM280 152l0-24-48 0 0 24 0 118.1-31-31-17-17L150.1 256l17 17 72 72 17 17 17-17 72-72 17-17L328 222.1l-17 17-31 31L280 152z"]
};
const faLightbulbCfl = {
  prefix: 'fass',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M160 64l-25.2 5L0 96 0 32 122.5 7.5 160 0l0 38.3L160 64zm160 0l0 64L0 192l0-64L320 64zM0 288l0-64 320-64 0 64L0 288zM64 480l0-96 32 0 0-82.6 48-9.6 0 92.2 32 0 0-35.2 0-28.8 0-35.2L320 256l0 64-96 19.2 0 44.8 32 0 0 96-64 0 0 32-64 0 0-32-64 0z"]
};
const faWindowFrameOpen = {
  prefix: 'fass',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M480 64l0 160 0 64-64 0L96 288l-64 0 0-64L32 64 32 0 96 0 416 0l64 0 0 64zM232 64L96 64l0 160 136 0 0-160zm48 0l0 160 136 0 0-160L280 64zM96 448l320 0 0-128 64 0 0 128 32 0 0 64-32 0-32 0L64 512l-32 0L0 512l0-64 32 0 0-128 64 0 0 128z"]
};
const faFaceKiss = {
  prefix: 'fass',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448l-3.9-15s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0-13.9s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faKiss = faFaceKiss;
const faBridgeCircleXmark = {
  prefix: 'fass',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M64 32L32 32l0 64 32 0 40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0 32 0 0-64-32 0L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z"]
};
const faPeriod = {
  prefix: 'fass',
  iconName: 'period',
  icon: [192, 512, [], "2e", "M32 352H160V480H32V352z"]
};
const faFaceGrinTongue = {
  prefix: 'fass',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faGrinTongue = faFaceGrinTongue;
const faUpToDottedLine = {
  prefix: 'fass',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M64 32l0 64L0 96 0 32l64 0zm96 0l0 64L96 96l0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM64 288L224 128 384 288l0 32-96 0 0 160-128 0 0-160-96 0 0-32z"]
};
const faThoughtBubble = {
  prefix: 'fass',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-53.7 0-99.7 33.1-118.7 80L128 80C57.3 80 0 137.3 0 208s57.3 128 128 128l44.8 0c16.6 28.7 47.6 48 83.2 48s66.6-19.3 83.2-48l44.8 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-9.3 0c-19-46.9-65-80-118.7-80zM0 448l0 64 64 0 0-64L0 448zm184-56l-80 0 0 80 80 0 0-80z"]
};
const faSkeletonRibs = {
  prefix: 'fass',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M352 32l0-32L288 0l0 32 0 32-64 0-18.1 0-9.3 15.5L224 96c-27.4-16.5-27.4-16.5-27.4-16.5s0 0 0 0s0 0 0 0l-.1 .1-.3 .4-.9 1.5c-.8 1.3-1.9 3.2-3.2 5.6c-2.8 4.9-6.7 11.9-11.3 20.7c-9.3 17.6-21.7 42.4-34.1 71.4c-2.8 6.5-5.6 13.2-8.4 20.2l-.4 .1 .1 .6C116.4 254.4 96 321.6 96 384l0 64 0 32 32 0 64 0 5.8 0 5.4-2L288 446.2l0 33.8 0 32 64 0 0-32 0-33.8L436.8 478l5.4 2 5.8 0 64 0 32 0 0-32 0-64c0-62.4-20.4-129.6-41.9-183.7l.1-.6-.4-.1c-2.8-7-5.6-13.7-8.4-20.2c-12.4-29-24.8-53.8-34.1-71.4c-4.7-8.8-8.6-15.8-11.3-20.7c-1.4-2.4-2.5-4.3-3.2-5.6l-.9-1.5-.3-.4-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L416 96l27.4-16.5L434.1 64 416 64l-64 0 0-32zm-64 96l0 38.3-72.7 16.2c8.1-17.6 15.8-32.8 22-44.5c1.9-3.7 3.8-7 5.4-10l45.4 0zM186 254.6l102-22.7 0 39.7L171.3 303.4c4.1-16.4 9.2-32.8 14.7-48.8zM160.3 372.7L288 337.9l0 39.9L186.2 416 160 416l0-32c0-3.7 .1-7.5 .3-11.3zM352 377.8l0-38.8 118.8 35.6 9.1 2.7c.1 2.2 .1 4.4 .1 6.6l0 32-26.2 0L352 377.8zm117.8-70.3L352 272.2l0-40.3 102 22.7c6 17.3 11.4 35.2 15.7 53zm-45-125L352 166.3l0-38.3 45.4 0c1.6 3 3.4 6.3 5.4 10c6.2 11.7 13.9 26.9 22 44.5zM0 80l0 32 0 96 0 32L0 480l0 32 64 0 0-32 0-240 0-16 16-12c30.2-22.7 48-58.2 48-96l0-4 0-32L96 80 32 80 0 80zm608 0l-64 0-32 0 0 32 0 4c0 37.8 17.8 73.3 48 96l16 12 0 16 0 240 0 32 64 0 0-32 0-240 0-32 0-96 0-32-32 0z"]
};
const faRaygun = {
  prefix: 'fass',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M192 64l96 0 0-8 0-24 48 0 0 24 0 240 0 24-48 0 0-24 0-8L176 512 48 448l80-160-16 0C50.1 288 0 237.9 0 176C0 131.3 26.2 92.8 64 74.8L64 0 192 64zm224 0l0 24 0 56 64 0 96-48 0 160-96-48-64 0 0 56 0 24-48 0 0-24 0-176 0-24 48 0zM136 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFlute = {
  prefix: 'fass',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M0 160l96 0 0 192L0 352 0 160zM640 352l-512 0 0-192 512 0 0 192zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faAcorn = {
  prefix: 'fass',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M259.7 48.4c-3.3 4.8-6 10.1-8 15.6L352 64c53 0 96 43 96 96l0 32L0 192l0-32c0-53 43-96 96-96l106.1 0c3-15.3 9.2-29.9 18.1-42.9L233.9 1.4l39.5 27.3L259.7 48.4zM224 480C80 432 48 304 48 224l176 0 176 0c0 80-32 208-176 256z"]
};
const faVideoArrowUpRight = {
  prefix: 'fass',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M0 64l384 0 0 384L0 448 0 64zm576 0l0 384L416 337.1l0-162.3L576 64zM152 160l-24 0 0 48 24 0 54.1 0L103 311l-17 17L120 361.9l17-17 103-103 0 54.1 0 24 48 0 0-24 0-112 0-24-24 0-112 0z"]
};
const faGrateDroplet = {
  prefix: 'fass',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M0 32l32 0 96 0 96 0 96 0 96 0 32 0 0 32 0 93.9L343.7 318.1c-15.4 23.7-23.7 51.4-23.7 79.7l0 2.1c0 29.6 8.9 57.1 24.2 80L320 480l-96 0-96 0-96 0L0 480l0-32L0 256 0 64 0 32zM64 96l0 128 32 0L96 96 64 96zm0 320l32 0 0-128-32 0 0 128zm128 0l0-128-32 0 0 128 32 0zm96 0l0-128-32 0 0 128 32 0zM384 96l-32 0 0 128 32 0 0-128zM256 96l0 128 32 0 0-128-32 0zm-96 0l0 128 32 0 0-128-32 0zm304 96l93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3l0 2.1c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-2.1c0-22.1 6.4-43.7 18.5-62.3L464 192z"]
};
const faSealExclamation = {
  prefix: 'fass',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M256 0l75 75 106 0 0 106 75 75-75 75 0 106-106 0-75 75-75-75L75 437l0-106L0 256l75-75L75 75l106 0L256 0zm24 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 320l0 48 48 0 0-48-48 0z"]
};
const faChessBishop = {
  prefix: 'fass',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M128 0L96 0l0 64 27 0C78.1 107.2 8 190.2 8 288c0 47.4 30.8 72.3 56 84.7L64 400l192 0 0-27.3c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4L176 294.6 153.4 272l11.3-11.3L270.8 154.6c-23-37.9-51.5-69.2-73.8-90.6l27 0 0-64L192 0 128 0zM0 512l320 0 0-32-48-48L48 432 0 480l0 32z"]
};
const faMessageSms = {
  prefix: 'fass',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM152 144l-19.2 0C112.5 144 96 160.5 96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-8 0s0 0 0 0l-8 0zm40 16l0 96 0 16 32 0 0-16 0-48 19.2 25.6L256 250.7l12.8-17.1L288 208l0 48 0 16 32 0 0-16 0-96 0-16-24 0-4.8 6.4L256 197.3l-35.2-46.9L216 144l-24 0 0 16zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-16 0-8 0s0 0 0 0l-11.3 0c-20.3 .1-36.7 16.6-36.7 36.8z"]
};
const faCoffeeBeans = {
  prefix: 'fass',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M295.8 82.2L464.5 183.3l28.8 57.5C527.7 189.4 514 110.1 458 54c-58-58-140.8-70.6-192-31.6l29.8 59.7zm-24.3 22.5L242.8 47.1C208.3 98.6 222 177.9 278 234c58 58 140.8 70.6 192 31.6l-29.8-59.7L271.5 104.7zM88.8 250.4l19-57.4C46.7 205.2 0 271.8 0 352c0 83 50 151.3 114.1 160l21.2-64.1L88.5 259.3l-1.1-4.5 1.5-4.4zm31.8 5.7l46.9 188.6 1.1 4.5-1.5 4.4-19 57.4C209.3 498.8 256 432.2 256 352c0-83-50-151.3-114.1-160l-21.2 64.1z"]
};
const faHatWitch = {
  prefix: 'fass',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M224 128L112 384l112 0 0-80 0-16 16 0 96 0 16 0 0 16 0 80 112 0L384 192l32-64 64 0 32 64L544 88 440 0 224 128zm96 256l0-64-64 0 0 64 64 0zM0 416l0 32 128 64 320 0 128-64 0-32L0 416z"]
};
const faFaceGrinWink = {
  prefix: 'fass',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zm122.9-94.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGrinWink = faFaceGrinWink;
const faClockThreeThirty = {
  prefix: 'fass',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-136 0-24 24 0 104 0 24 0 0 48-24 0-80 0 0 112 0 24-48 0 0-24z"]
};
const faEarDeaf = {
  prefix: 'fass',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M509.3 48L486.6 70.6l-24 24L440 117.3 394.7 72l22.6-22.6 24-24L464 2.7 509.3 48zm-304 304l-22.6 22.6-112 112L48 509.3 2.7 464l22.6-22.6 112-112L160 306.7 205.3 352zM240 128c-61.9 0-112 50.1-112 112l-64 0c0-97.2 78.8-176 176-176s176 78.8 176 176c0 54.7-25 103.5-64 135.8l0 24.2c0 61.9-50.1 112-112 112l-32 0 0-64 32 0c26.5 0 48-21.5 48-48l0-40.2 0-17.1 14.2-9.5C332.3 313 352 278.8 352 240c0-61.9-50.1-112-112-112zM208 240l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faDeaf = faEarDeaf;
const faDeafness = faEarDeaf;
const faHardOfHearing = faEarDeaf;
const faAlarmClock = {
  prefix: 'fass',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M161.3 25.6C144.1 9.7 121.2 0 96 0C43 0 0 43 0 96c0 19 5.5 36.6 15 51.5L161.3 25.6zM256 512c50.3 0 96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6zM498.3 147.5c9.5-14.9 15-32.6 15-51.5c0-53-43-96-96-96C392.1 0 369.1 9.7 352 25.6L498.3 147.5zM280 184l0 94.1 41 41 17 17L304 369.9l-17-17-48-48-7-7 0-9.9 0-104 0-24 48 0 0 24z"]
};
const faEclipse = {
  prefix: 'fass',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M256 73.1L150 0 126.7 126.7 0 150 73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l12.5-68.2c-31.6-15.1-58.8-37.9-79.2-66c-12.4 4-25.6 6.2-39.4 6.2c-70.7 0-128-57.3-128-128s57.3-128 128-128c13.7 0 27 2.2 39.4 6.2c20.3-28.1 47.6-50.9 79.2-66L362 0 256 73.1zM256 256c0-33.6 8-65.4 22.1-93.4c-7.1-1.7-14.5-2.6-22.1-2.6c-53 0-96 43-96 96s43 96 96 96c7.6 0 15-.9 22.1-2.6C264 321.3 256 289.6 256 256zM464 432a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
const faFaceRelieved = {
  prefix: 'fass',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 379.3l22.6-22.6c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3l22.6 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7zM197.1 95.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5L98.7 135.1l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1 10.1 30.4zm124.2 2.1l-6.3-2.1 10.1-30.4 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5-26.6 17.8L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1zm73.9 137.1l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2z"]
};
const faRoadCircleCheck = {
  prefix: 'fass',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M160 32l128 0 0 64 0 32 64 0 0-32 0-64 128 0 46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-59.5 0-112.1 29.6-144 74.8l0-42.8 0-32-64 0 0 32 0 64 0 32 38.6 0c-4.3 15.3-6.6 31.4-6.6 48c0 5.4 .2 10.7 .7 16L288 384l0 32 0 64L32 480 160 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z"]
};
const faDiceFive = {
  prefix: 'fass',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M448 32L0 32 0 480l448 0 0-448zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faOctagonMinus = {
  prefix: 'fass',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zm184 72l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faMinusOctagon = faOctagonMinus;
const faSquareRss = {
  prefix: 'fass',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm32 80c150.2 0 272 121.8 272 272l-48 0c0-123.7-100.3-224-224-224l0-48zm0 96c97.2 0 176 78.8 176 176l-48 0c0-70.7-57.3-128-128-128l0-48zm0 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faRssSquare = faSquareRss;
const faFaceZany = {
  prefix: 'fass',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5l0-44.5c-16-10.5-30.2-24-41.9-40.2L409.9 204.1c29.4 65.1 11.7 141.7-41.9 187.4l0 56.5c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm112-8a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm96 296l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTricycle = {
  prefix: 'fass',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M280 32l-24 0 0 48 24 0 88 0 0 21-47.6 40.8c-.8 .7-1.6 1.4-2.3 2.2l-10.9 0c-58.8 0-114 23.9-154.1 64.6L133.6 176l2.4 0 24 0 0-48-24 0-80 0-24 0 0 48 24 0 21.6 0 44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6l12.1 0 11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 44.7-38.3L416 123l0-11 0-56 0-24-24 0L280 32zm64.2 260l16.5 65.9 46.6-11.6-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faLandMineOn = {
  prefix: 'fass',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M344 24l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zM69.7 132.3l104 72 19.7 13.7-27.3 39.5-19.7-13.7-104-72L22.6 158.1l27.3-39.5 19.7 13.7zm528 39.5l-104 72-19.7 13.7-27.3-39.5 19.7-13.7 104-72 19.7-13.7 27.3 39.5-19.7 13.7zM192 288l256 0 0 64-256 0 0-64zm-64 96l384 0 64 128L64 512l64-128z"]
};
const faSquareArrowUpLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M448 32L0 32 0 480l448 0 0-448zM136 144l152 0 24 0 0 48-24 0-94.1 0L329 327l17 17L312 377.9l-17-17-135-135L160 328l0 24-48 0 0-24 0-160 0-24 24 0z"]
};
const faICursor = {
  prefix: 'fass',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M32 0c38.2 0 72.5 16.8 96 43.3C151.5 16.8 185.8 0 224 0l32 0 0 64-32 0c-35.3 0-64 28.7-64 64l0 96 32 0 32 0 0 64-32 0-32 0 0 96c0 35.3 28.7 64 64 64l32 0 0 64-32 0c-38.2 0-72.5-16.8-96-43.3C104.5 495.2 70.2 512 32 512L0 512l0-64 32 0c35.3 0 64-28.7 64-64l0-96-32 0-32 0 0-64 32 0 32 0 0-96c0-35.3-28.7-64-64-64L0 64 0 0 32 0z"]
};
const faChartMixedUpCircleDollar = {
  prefix: 'fass',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M400 0L368 0l0 64 32 0 28.8 0L319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199l40 50L192.6 136.5l108.2 81.1 19.3 14.5c4.4-3.6 9-7.1 13.8-10.3l6-4.8L480 105l0 39 0 32 64 0 0-32 0-112 0-32L512 0 400 0zM160 224l0 256 64 0 0-256-64 0zM32 320l0 160 64 0 0-160-64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L372 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]
};
const faSaltShaker = {
  prefix: 'fass',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M384 512l-8-64L335.9 127C326.8 54.5 265.1 0 192 0S57.2 54.5 48.1 127L8 448 0 512l64.5 0 255 0 64.5 0zm-72.5-64l-239 0 32-256 175 0 32 256zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faStamp = {
  prefix: 'fass',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M320 167.6c19.6-17.6 32-43.1 32-71.6c0-53-43-96-96-96s-96 43-96 96c0 28.4 12.4 54 32 71.6l0 88.4-80 0C50.1 256 0 306.1 0 368l0 48 32 0 0 32 0 64 64 0 320 0 64 0 0-64 0-32 32 0 0-48c0-61.9-50.1-112-112-112l-80 0 0-88.4zM416 416l0 32L96 448l0-32 320 0z"]
};
const faFilePlus = {
  prefix: 'fass',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM216 240l0 24 0 48 48 0 24 0 0 48-24 0-48 0 0 48 0 24-48 0 0-24 0-48-48 0-24 0 0-48 24 0 48 0 0-48 0-24 48 0z"]
};
const faDrawSquare = {
  prefix: 'fass',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 209.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-209.1C12.9 140.4 0 119.7 0 96zm96 55.4l0 209.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-209.1c-9.7-5.6-17.8-13.7-23.4-23.4l-209.1 0c-5.6 9.7-13.7 17.8-23.4 23.4z"]
};
const faToiletPaperUnderSlash = {
  prefix: 'fass',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M528 512l48 0s0 0 0 0l-352 0 0-96 182.2 0L528 512zm48-87.6l44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L94.9 50.9C112 19.3 134.9 0 160 0L412.2 0C400.6 12.2 391 26.9 383.5 41.9C363.5 82 352 135.1 352 192c0 21.4 1.6 42.3 4.7 62.2l39.2 30.4c-7.6-27.5-11.9-59-11.9-92.6c0-83.6 26.7-154.7 64-181.1C458 3.8 468.8 0 480 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-11.6 39.9-30.1 70.8-52.3 85.9L537 394.2c16.3-13.6 29.3-32 39-51.1l0 81.3zM64 192c0-15 .9-29.6 2.5-43.6L365.5 384 160 384c-53 0-96-86-96-192zm416 64c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z"]
};
const faToiletPaperReverseSlash = faToiletPaperUnderSlash;
const faStairs = {
  prefix: 'fass',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 32l32 0 128 0 32 0 0 64-32 0-96 0 0 96 0 32-32 0-96 0 0 96 0 32-32 0-96 0 0 96 0 32-32 0L32 480 0 480l0-64 32 0 96 0 0-96 0-32 32 0 96 0 0-96 0-32 32 0 96 0 0-96 0-32z"]
};
const faDroneFront = {
  prefix: 'fass',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M160 112l0-16L96 96l0 16-72 0L0 112l0 48 24 0 72 0 0 16 0 16 0 64 0 20.8 19 8.4 56.5 25.1-21.9 26.3-5.6 6.7 0 8.7 0 40 0 24 48 0 0-24 0-31.3 25.1-30.1L259 349.2l6.2 2.8 6.8 0 96 0 6.8 0 6.2-2.8 41.9-18.6L448 360.7l0 31.3 0 24 48 0 0-24 0-40 0-8.7-5.6-6.7-21.9-26.3L525 285.2l19-8.4 0-20.8 0-64 0-16 0-16 72 0 24 0 0-48-24 0-72 0 0-16-64 0 0 16-104 0-24 0 0 48 24 0 104 0 0 16 0 16 0 43.2-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2l0-43.2 0-16 0-16 104 0 24 0 0-48-24 0-104 0z"]
};
const faDroneAlt = faDroneFront;
const faGlassEmpty = {
  prefix: 'fass',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M99.2 448l185.6 0 30-384L69.2 64l30 384zM344 512L40 512 5 64 0 0 64.2 0 319.8 0 384 0l-5 64L344 512z"]
};
const faDialHigh = {
  prefix: 'fass',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zM288.4 127.6c80.2 0 146.6 59 158.2 136l-158.2 0-24 0 0 48 24 0 158.2 0c-11.6 77-78 136-158.2 136c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
};
const faUserHelmetSafety = {
  prefix: 'fass',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M256 0L192 0l0 80L163.6 23.1C125.6 43.5 99 82.6 96.2 128l-.2 0-24 0 0 48 24 0 256 0 24 0 0-48-24 0-.2 0C349 82.6 322.4 43.5 284.4 23.1L256 80l0-80zM224 320c65.3 0 119.1-48.9 127-112L97 208c7.9 63.1 61.7 112 127 112zM448 512L400 352 48 352 0 512l448 0z"]
};
const faUserConstruction = faUserHelmetSafety;
const faUserHardHat = faUserHelmetSafety;
const faI = {
  prefix: 'fass',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M32 32L0 32 0 96l32 0 96 0 0 320-96 0L0 416l0 64 32 0 96 0 64 0 96 0 32 0 0-64-32 0-96 0 0-320 96 0 32 0 0-64-32 0-96 0-32 0-32 0L32 32z"]
};
const faHryvniaSign = {
  prefix: 'fass',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M114.2 123.1C131.5 105.7 155 96 179.5 96L223 96c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31L0 176l0 64 155.5 0-50.6 28.9c-1.7 1-3.4 2-5.1 3.1L0 272l0 64 52.3 0c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113l43.5 0c41.5 0 81.3-16.5 110.6-45.8l11.5-11.5-45.3-45.3-11.5 11.5C252.5 406.3 229 416 204.5 416L161 416c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31L384 336l0-64-155.5 0 50.6-28.9c1.7-1 3.4-2 5.1-3.1l99.8 0 0-64-52.3 0c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113l-43.5 0C138.1 32 98.3 48.5 68.9 77.8L57.4 89.4l45.3 45.3 11.5-11.5z"]
};
const faHryvnia = faHryvniaSign;
const faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'fass',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M381.3 176L502.6 54.6 457.4 9.4 336 130.7 336 80l0-32-64 0 0 32 0 128 0 32 32 0 128 0 32 0 0-64-32 0-50.7 0zM80 272l-32 0 0 64 32 0 50.7 0L9.4 457.4l45.3 45.3L176 381.3l0 50.7 0 32 64 0 0-32 0-128 0-32-32 0L80 272z"]
};
const faPills = {
  prefix: 'fass',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 96c-26.5 0-48 21.5-48 48l0 112 96 0 0-112c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112l0 224c0 61.9-50.1 112-112 112S0 429.9 0 368L0 144zM576 320c0 38.4-13.5 73.7-36.1 101.3L314.7 196.1C342.3 173.5 377.6 160 416 160c88.4 0 160 71.6 160 160zM416 480c-88.4 0-160-71.6-160-160c0-38.4 13.5-73.7 36.1-101.3L517.3 443.9C489.7 466.5 454.4 480 416 480z"]
};
const faFaceGrinWide = {
  prefix: 'fass',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
const faGrinAlt = faFaceGrinWide;
const faTooth = {
  prefix: 'fass',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5l0 6.2c0 15.8 3.7 31.3 10.7 45.5L73 239.6l39.4 220.6 3.5 19.8 20.1 0 8 0 19.9 0 3.7-19.5L195.9 312l56.3 0 28.3 148.5 3.7 19.5 19.9 0 8 0 20.1 0 3.5-19.8L375 239.6l30.2-60.5c7.1-14.1 10.7-29.7 10.7-45.5l0-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 32.1 25-19.6 25.3-37-28.8-37-28.8z"]
};
const faBasketballHoop = {
  prefix: 'fass',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M320 0C434 0 513.6 48.5 564.1 96.9c32.2 30.8 54.7 65.7 75.9 104.2l0 171.7L505.6 432.6 526.2 288l-32.3 0-7.2 50.3-22.9 160-2 13.7L448 512l-8 0-7.2 0-4.8-5.3-44.2-49.5L340 506.6l-4.8 5.4-7.2 0-16 0-7.2 0-4.8-5.4-43.9-49.4-44.2 49.5-4.8 5.3-7.2 0-8 0-13.9 0-2-13.7-22.9-160L146.1 288l-32.3 0 20.6 144.6L0 372.8 0 201.1c21.2-38.5 43.7-73.4 75.9-104.2C126.4 48.5 206 0 320 0zM178.4 288l5.2 36.6 44-36.6-49.2 0zm99.3 0l-1.2 1L320 337.6 363.4 289l-1.2-1-84.4 0zm134.5 0l44 36.6 5.2-36.6-49.2 0zM176 128l-16 0 0 16 0 64-48 0-16 0 0 32 16 0 64 0 288 0 64 0 16 0 0-32-16 0-48 0 0-64 0-16-16 0-288 0zm272 32l0 48-256 0 0-48 256 0zM388 309.4l-46.6 52.2 42.4 47.5 52.7-59.3L388 309.4zm47.9 158l11.7-81.9-42.3 47.6 30.6 34.3zM320 385.6l-42.4 47.5L319.2 480l1.6 0 41.6-46.8L320 385.6zm-21.4-24L252 309.4l-48.5 40.3 52.7 59.3 42.4-47.5zM204.1 467.4l30.6-34.3-42.3-47.6 11.7 81.9z"]
};
const faObjectsAlignBottom = {
  prefix: 'fass',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M512 512l0-48L0 464l0 48 512 0zM64 384l160 0L224 0 64 0l0 384zm224 0l160 0 0-256-160 0 0 256z"]
};
const faV = {
  prefix: 'fass',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M0 32L162.1 459.4l7.8 20.6 44.2 0 7.8-20.6L384 32l-68.4 0L192 357.8 68.4 32 0 32z"]
};
const faSparkles = {
  prefix: 'fass',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M384 64L416 0l32 64 64 32-64 32-32 64-32-64L320 96l64-32zM128 192L192 64l64 128 128 64L256 320 192 448 128 320 0 256l128-64zM416 320l32 64 64 32-64 32-32 64-32-64-64-32 64-32 32-64z"]
};
const faSquid = {
  prefix: 'fass',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M396.3 26C430.3 16 468.6 7.2 512 0c-7.1 42.7-15.7 80.7-25.5 114.2l18.2 115.3 3.5 22.1-22.1-3.9-50.8-9C388.3 320.2 332.5 350 287.6 354.6l37.2 37.2c6.2 6.2 16.4 6.2 22.6 0l56.1-56.1c19-19 49.9-18.7 68.6 .7l27.5 28.6 9.5 9.9-8.3 10.9-2.5 3.3c-28.3 37-81 40.1-113.6 10.9L370 414.4c-18.7 18.7-49.1 18.7-67.9 0l-45.3-45.3L223 403.1l32.6 32.6c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5L229.4 484l2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-56-56c-1.7 6.5-4.7 12.7-8.8 18.4l-20.1 27.3c-2.5 3.5-3.9 7.6-3.9 11.9c0 11.1 9 20.1 20.1 20.1l11.9 0 16 0 0 32-16 0-11.9 0c-28.8 0-52.1-23.3-52.1-52.1c0-11.1 3.6-21.9 10.1-30.9l20.1-27.3c6.8-9.2 5.8-22-2.3-30.1c-8.2-8.2-21.2-9.1-30.4-2.1l-26.2 20c-9 6.9-20.1 10.6-31.4 10.6C23.2 400 0 376.8 0 348.1L0 336l0-16 32 0 0 16 0 12.1c0 11 8.9 19.9 19.9 19.9c4.4 0 8.6-1.4 12-4.1l26.2-20c5.8-4.4 12.3-7.6 19.1-9.4L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3L27.6 283 4.4 261l3.3-3.5c18.6-19.6 49.7-20 68.7-.9l33.4 33.4L143.8 256 98.5 210.7c-18.7-18.7-18.7-49.1 0-67.9L113 128.4C83.6 95.6 86.6 42.9 123.4 14.2l3.7-2.9 11-8.6 10 9.8 29 28.4c19.1 18.7 19.3 49.4 .4 68.3l-56.3 56.3c-6.2 6.2-6.2 16.4 0 22.6l36.3 36.3c4.7-45 34.7-100.8 116.4-147.9l-8.8-49.7L261.2 4.7l22.1 3.5L396.3 26zM200.9 280a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faLeafyGreen = {
  prefix: 'fass',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M216.5 26.2C181.6-8.7 125-8.7 90.1 26.2c-15.4 15.4-24 35.1-25.8 55.3C49 83.9 34.3 91.1 22.4 102.9c-28.3 28.3-29.8 73.3-4.5 103.4l0 72.6L72.1 333l0 80.4L96 389.5l0-98.7 48-48 0-96 66.1-66.1c2.8-15.4 8.4-29.8 16.2-42.7c-2.9-4.1-6.2-8-9.9-11.7zM549.9 183.9C566.2 164.4 576 139.4 576 112C576 50.1 525.9 0 464 0c-27.4 0-52.4 9.8-71.9 26.1C376.3 14.7 357 8 336 8c-50.2 0-91.4 38.5-95.6 87.6L176 160l0 96-48 48 0 98.7L89.4 441.4 66.7 464 112 509.3l22.6-22.6L173.3 448l98.7 0 48-48 96 0 64.4-64.4c49.1-4.2 87.6-45.4 87.6-95.6c0-21-6.7-40.3-18.1-56.1zM486.6 112l-11.3 11.3L390.6 208l57.4 0 16 0 0 32-16 0-89.4 0-59.3 59.3-48 48L240 358.6 217.4 336l11.3-11.3L272 281.4l0-89.4 0-16 32 0 0 16 0 57.4 36.7-36.7 112-112L464 89.4 486.6 112z"]
};
const faCircleArrowUpRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm88 144l-152 0-24 0 0 48 24 0 94.1 0L151 327l-17 17L168 377.9l17-17 135-135L320 328l0 24 48 0 0-24 0-160 0-24-24 0z"]
};
const faCalendars = {
  prefix: 'fass',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M256 0L192 0l0 64L96 64l0 96 416 0 0-96-96 0 0-64L352 0l0 64-96 0 0-64zM96 192l0 224 416 0 0-224L96 192zM0 160L0 488l0 24 24 0 392 0 0-48L48 464l0-304L0 160z"]
};
const faBangladeshiTakaSign = {
  prefix: 'fass',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M0 96l32 0c17.7 0 32 14.3 32 32l0 32L0 160l0 64 64 0 0 160c0 53 43 96 96 96l32 0c106 0 192-86 192-192l0-32c0-53-43-96-96-96l-32 0 0 64 32 0c17.7 0 32 14.3 32 32l0 32c0 70.7-57.3 128-128 128l-32 0c-17.7 0-32-14.3-32-32l0-160 64 0 0-64-64 0 0-32c0-53-43-96-96-96L0 32 0 96z"]
};
const faBicycle = {
  prefix: 'fass',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M312 32l-24 0 0 48 24 0 25.7 0 34.6 64-149.4 0-27.4-38-7.2-10L176 96l-56 0L96 96l0 48 24 0 43.7 0 22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l49 0 13.7 0 7-11.8 84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L373.1 44.6 366.3 32 352 32l-40 0zM458.6 303.7l32.3 59.7 11.4 21.1 42.2-22.8-11.4-21.1-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM128 368l70.2 0c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-26.5 53.1L128 368zm38.8-48l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z"]
};
const faHammerWar = {
  prefix: 'fass',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M224 0l0 32 0 24.9L336 32l48 0 0 256-48 0L192 256 48 288 0 288 0 32l48 0L160 56.9 160 32l0-32 64 0zM192 288.8l32 7.1L224 480l0 32-64 0 0-32 0-184.1 32-7.1z"]
};
const faCircleD = {
  prefix: 'fass',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24 24 0zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160 48 0z"]
};
const faSpiderBlackWidow = {
  prefix: 'fass',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M0 118.7l0 21.2 1.2 3.7 24 72L29 227l11.4 3.8L116.1 256 40.4 281.2 29 285l-3.8 11.4-24 72L0 372.1l0 21.2 39.2 13.1 7.6-22.8L67 323l84.2-28.1L79 367 67.7 378.4l6.2 14.8 40 96 9.2 22.2 44.3-18.5-9.2-22.2-33.8-81.2L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l35.7 35.7-33.8 81.2-9.2 22.2 44.3 18.5 9.2-22.2 40-96 6.2-14.8L433 367l-72.1-72.1L445 323l20.2 60.6 7.6 22.8L512 393.3l0-21.2-1.2-3.7-24-72L483 285l-11.4-3.8L395.9 256l75.7-25.2L483 227l3.8-11.4 24-72 1.2-3.7 0-21.2-39.2-13.1-7.6 22.8L445 189l-84.2 28.1L433 145l11.4-11.4-6.2-14.8-40-96L388.9 .6 344.6 19.1l9.2 22.2 33.8 81.2L336 174.1l0-14.1c0-38.7-27.5-71-64-78.4l0 46.4-32 0 0-46.4c-36.5 7.4-64 39.7-64 78.4l0 14.1-51.7-51.7 33.8-81.2 9.2-22.2L123.1 .6l-9.2 22.2-40 96-6.2 14.8L79 145l72.1 72.1L67 189 46.8 128.4l-7.6-22.8L0 118.7zM216 288l80 0 0 16-24 32 24 32 0 16-80 0 0-16 24-32-24-32 0-16z"]
};
const faStaffSnake = {
  prefix: 'fass',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M208 511l0 1-32 0 0-1-1.5-47L136 464l-40 0 0-80 40 0 36 0-1-32-19 0c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7l0 94.7c0 8.8 7.2 16 16 16l16.5 0L164 128l-28 0-9.2 0c-4.5 18.4-21.1 32-40.8 32L0 160 0 96C0 69.5 21.5 48 48 48l10 0c1.1 0 2.3 0 3.4 .1c.9-.1 1.7-.1 2.6-.1l97.5 0L160 0l64 0-1.5 48L288 48c53 0 96 43 96 96s-43 96-96 96l-40 0 0-80 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-28 0-4.5 144 40.5 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-80 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-43 0-5 159zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faRodAsclepius = faStaffSnake;
const faRodSnake = faStaffSnake;
const faStaffAesculapius = faStaffSnake;
const faPear = {
  prefix: 'fass',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M510.7 35.2l-17 17L457.9 88c33.9 49.8 28.8 118.3-15.4 162.5l-58.8 58.8c.2 3.5 .3 7.1 .3 10.7c0 106-86 192-192 192S0 426 0 320S86 128 192 128c3.6 0 7.2 .1 10.7 .3l58.8-58.8c44.2-44.2 112.6-49.3 162.5-15.4l35.9-35.9 17-17 33.9 33.9zM288 320c0 53-43 96-96 96l0 32c70.7 0 128-57.3 128-128l-32 0z"]
};
const faHeadSideCoughSlash = {
  prefix: 'fass',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M448 325l46 35.7c6.5 1.7 11.9 6 15 11.7l46.1 35.8c8.7 1.1 16 7 19.2 14.9L616.7 456c10.7 .3 19.6 7.6 22.4 17.4l.8 .6-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1l19 14.7 40 31.1C126.1 17.1 173.2 0 224.3 0L256 0C358.1 0 441.6 79.7 447.6 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 5zM0 224.3c0-38.7 9.8-75.2 27.1-107L341.8 365.3 320 368l0 40 82.5 5.2L448 449l0 31-128 0 0 32-32 0-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faFileMov = {
  prefix: 'fass',
  iconName: 'file-mov',
  icon: [512, 512, [], "e647", "M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM256 368l0 128 0 16-32 0 0-16 0-74.2-17.9 33.7-13.9 26.2-14.3-26L160 423l0 73 0 16-32 0 0-16 0-128 0-16 16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0 0 16zm192 0l0 35c0 17.3 3.1 34.4 9.2 50.6l6.8 18.2 6.8-18.2c6.1-16.2 9.2-33.3 9.2-50.6l0-35 0-16 32 0 0 16 0 35c0 21.1-3.8 42-11.2 61.8L487 501.6 483.1 512 472 512l-16 0-11.1 0L441 501.6l-13.8-36.8C419.8 445 416 424.1 416 403l0-35 0-16 32 0 0 16zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
const faTriangle = {
  prefix: 'fass',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M0 480L256 32 512 480H0z"]
};
const faApartment = {
  prefix: 'fass',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M448 0L128 0l0 96L0 96 0 512l128 0 32 0 96 0 0-128 64 0 0 128 96 0 32 0 128 0 0-320-128 0L448 0zM320 320l0-64 64 0 0 64-64 0zm192 96l-64 0 0-64 64 0 0 64zM64 320l0-64 64 0 0 64-64 0zm64 96l-64 0 0-64 64 0 0 64zm64-96l0-64 64 0 0 64-64 0zM384 64l0 64-64 0 0-64 64 0zM192 64l64 0 0 64-64 0 0-64zM384 224l-64 0 0-64 64 0 0 64zm64 96l0-64 64 0 0 64-64 0zM128 224l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0z"]
};
const faTruckMedical = {
  prefix: 'fass',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M416 0L0 0 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 240l0 16-128 0 0-96 48 0 2.7 0L544 237.3l0 2.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM176 64l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faAmbulance = faTruckMedical;
const faPepper = {
  prefix: 'fass',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M191.6 36.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L208 19.2C224.4 1.7 224.4 1.7 224.4 1.7s0 0 0 0s0 0 0 0l.1 .1 .2 .2 .6 .6c.5 .5 1.1 1.1 2 2c1.6 1.7 3.8 4 6.4 7c5.1 5.9 11.9 14.5 18.7 25.4c10.3 16.4 21 38.8 25.5 65.4zm86.3 65.6c17.7-6.8 37.6-8.4 57.5-3.4c10.5 2.6 20.1 6.9 28.7 12.4c21.5-13.8 48.5-19.1 75.3-12.4c51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.9c-10.5-2.6-20.1-6.9-28.7-12.4c-5.7 3.7-11.8 6.8-18.4 9.2c-10.6 4-21.9 6.1-33.5 6.1c-11.8 0-23.3-2.1-34-6.2c-6.5-2.4-12.5-5.5-18.2-9.1c-8.6 5.5-18.2 9.8-28.7 12.4C123.8 522 71.7 490.7 58.9 439.3l-56-224C-10 163.8 21.3 111.7 72.7 98.9c14.4-3.6 28.8-3.7 42.4-1C84.2 128.6 72.1 176 83.8 223l41 163.8 31-7.8-41-163.8C102 163.8 125.3 111.7 176.7 98.9c4-1 7.9-1.7 11.9-2.2c8.7-1 17.3-.9 25.7 .4l.6 .1c4.6 .7 9.1 1.8 13.5 3.1c-3.8-14.5-10.1-27.4-16.7-37.9c-5.2-8.4-10.4-15-14.3-19.4c-1.9-2.2-3.5-3.9-4.5-4.9c-.5-.5-.9-.9-1.1-1.1l-.2-.2z"]
};
const faPiano = {
  prefix: 'fass',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M0 192L0 512l512 0 0-224L384 224l0-32C384 86 298 0 192 0S0 86 0 192zM416 352l32 0 0 96L64 448l0-96 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48 64 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48z"]
};
const faGunSquirt = {
  prefix: 'fass',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M128 32l0 24 0 8 384 0 32 0 0 32 0 32 32 0 0 64-32 0 0 32 0 32-32 0-264 0-18 72 42 0 0-16 0-24 48 0 0 24 0 40 0 40 0 24-48 0 0-24 0-16-54 0L192 480 32 480 88.1 255.7C38.8 251.7 0 210.4 0 160c0-47.6 34.6-87.1 80-94.7L80 56l0-24 48 0zm352 96L64 128l0 64 416 0 0-64z"]
};
const faWheatAwnCircleExclamation = {
  prefix: 'fass',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M489 57l17-17L472 6.1 455 23 383 95l-17 17L400 145.9l17-17 72-72zM316.8 38.6L294.1 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L25.4 441.4 2.7 464 48 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.5 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.5c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L489 153l17-17L472 102.1l-17 17-43.4 43.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L393 57l17-17L376 6.1 359 23 329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faSnowman = {
  prefix: 'fass',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M352 96c0 18.7-5.4 36.2-14.7 51c9.3 9.8 16.8 21.3 22.1 34L408 160.2l0-40.2 0-24 48 0 0 24 0 19.6 22.5-9.7 22.1-9.5 18.9 44.1-22.1 9.5-56 24-73.6 31.5c-.6 11.8-3 23.1-6.9 33.6C394.7 292.6 416 335.8 416 384c0 52.3-25.1 98.8-64 128l-192 0c-38.9-29.2-64-75.7-64-128c0-48.2 21.3-91.4 55.1-120.8c-3.9-10.5-6.3-21.8-6.9-33.6L70.5 198.1l-56-24-22.1-9.5 18.9-44.1 22.1 9.5L56 139.6 56 120l0-24 48 0 0 24 0 40.2L152.6 181c5.3-12.7 12.8-24.2 22.1-34c-9.3-14.8-14.7-32.3-14.7-51c0-53 43-96 96-96s96 43 96 96zM272 272l-32 0 0 32 32 0 0-32zm0 96l0-32-32 0 0 32 32 0zM240 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24l0 .3c0 2.9 .8 5.8 2.3 8.3L256 152l13.7-23.4c1.5-2.5 2.3-5.4 2.3-8.3l0-.3c0-8.8-7.2-16-16-16s-16 7.2-16 16zm32 88l-32 0 0 32 32 0 0-32z"]
};
const faUserAlien = {
  prefix: 'fass',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 119.3-160 217-160 217s-160-97.7-160-217zm80 9l-16 0-16 0 0 16c0 35.3 28.7 64 64 64l16 0 16 0 0-16c0-35.3-28.7-64-64-64zm96 64l0 16 16 0 16 0c35.3 0 64-28.7 64-64l0-16-16 0-16 0c-35.3 0-64 28.7-64 64zM400 352l48 160L0 512 48 352l80 0 96 72 96-72 80 0z"]
};
const faShieldCheck = {
  prefix: 'fass',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z"]
};
const faMortarPestle = {
  prefix: 'fass',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M469.5 0L252.3 160l144.9 0L510.1 47.2 469.5 0zM32 192L0 192l0 64 32 0c0 82.5 43.4 147.7 123.9 176.2C138.4 454.1 128 481.8 128 512l256 0c0-30.2-10.4-57.9-27.9-79.8C436.6 403.7 480 338.5 480 256l32 0 0-64-32 0L32 192z"]
};
const faRoadBarrier = {
  prefix: 'fass',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M64 64l0-32L0 32 0 64 0 448l0 32 64 0 0-32 0-181.7L149.2 96 64 96l0-32zm576 0l0-32-64 0 0 32 0 53.7L490.8 288l85.2 0 0 160 0 32 64 0 0-32 0-384zM330.8 96l-5.4 10.7L234.8 288l74.3 0 5.4-10.7L405.2 96l-74.3 0zM437.2 288l5.4-10.7L533.2 96l-74.3 0-5.4 10.7L362.8 288l74.3 0zM277.2 96l-74.3 0-5.4 10.7L106.8 288l74.3 0 5.4-10.7L277.2 96z"]
};
const faChartCandlestick = {
  prefix: 'fass',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zM320 48l0-16-32 0 0 16 0 48-32 0 0 160 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0-160-32 0 0-48zm64 144l0 128 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0-128-32 0 0-48 0-16-32 0 0 16 0 48-32 0zM224 128l-32 0 0-48 0-16-32 0 0 16 0 48-32 0 0 192 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0-192z"]
};
const faBriefcaseBlank = {
  prefix: 'fass',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M152 0L128 0l0 24 0 72L0 96 0 480l512 0 0-384L384 96l0-72 0-24L360 0 152 0zM336 96L176 96l0-48 160 0 0 48z"]
};
const faSchool = {
  prefix: 'fass',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M640 512l-256 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96L0 512 0 96l160 0L320 0 480 96l160 0 0 416zM144 192l-64 0 0 96 64 0 0-96zm352 0l0 96 64 0 0-96-64 0zM144 320l-64 0 0 96 64 0 0-96zm352 0l0 96 64 0 0-96-64 0zM408 176a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-72-48l0 16 0 16 16 0 16 0 0 32-16 0-32 0-16 0 0-16 0-32 0-16 32 0z"]
};
const faIgloo = {
  prefix: 'fass',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M320 33.8L320 160 48.5 160C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160l0-120.9C424.9 55.7 487.2 99.8 527.5 160L352 160zM29.9 192L96 192l0 128L0 320c0-46 10.8-89.4 29.9-128zM192 320l-64 0 0-128 320 0 0 128-64 0 0 32 192 0 0 128-224 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L0 480 0 352l192 0 0-32zm288 0l0-128 66.1 0c19.2 38.6 29.9 82 29.9 128l-96 0z"]
};
const faBracketRound = {
  prefix: 'fass',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M0 256C0 140.2 71.9 62.9 110.2 37.4l35.5 53.3C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4l-35.5 53.3C71.9 449 0 371.8 0 256z"]
};
const faParenthesis = faBracketRound;
const faJoint = {
  prefix: 'fass',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M384 0l64 0 0 43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 43-64 0 0-43c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43l0-43zM640 288l-64 0 0-43c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-43 64 0 0 43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1l0 43zM0 432s89.6-64 234.6-77.5L365.8 512 288 512C112 512 0 432 0 432zm464 80l-56.5 0L274.3 352.2c4.5-.1 9.1-.2 13.7-.2l48 0 56.5 0L525.8 512 464 512zm103.5 0L434.2 352 640 352l0 160-16 0-56.5 0z"]
};
const faHorseSaddle = {
  prefix: 'fass',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M448 160l0 78.1 0 1.9s0 0 0 0c-.5 30-12.8 56.4-32 75.7L416 512l-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8L256 329.1l0-73.1 48 0 16 0 0-16 0-112C320 57.3 377.3 0 448 0l32 0 80 0 16 0 0 32-16 0-16 0 32 32 0 128-80 32-32-64-16 0zM224 256l0 64 0 8 0 8 0 19.9-14.1 14.1-27 27 38.3 115-101.2 0L82.5 399.2 73.1 371l21-21 26.6-26.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256l0 56 0 24L0 336l0-24 0-56c0-44.6 33.2-81.5 76.3-87.2c11.4-18.7 29.9-32.7 51.7-38.2L128 240l0 16 16 0 80 0zm-64-32l0-96 43.2 0 52.8 0 32 0 0 96-128 0zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faMugMarshmallows = {
  prefix: 'fass',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M32 32l194.7 0-73.4 73.4L130.7 128 32 128l0-96zm240 0l96 96-192 0 96-96zM0 160l96 0 0 96 64 0 0-96 192 0 32 0 16 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0 0 96L0 480 0 160zm384 64l0 96 16 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-16 0z"]
};
const faFilters = {
  prefix: 'fass',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M192 96L352 256l0 128 128 96 0-224L640 96l0-64L192 32l0 64zM0 96l0 64L160 320l0 96 128 96 0-192 32-32 0-18.7L169.4 118.6l-9.4-9.4L160 96 0 96z"]
};
const faBellOn = {
  prefix: 'fass',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M352 0L288 0l0 51.2C215 66 160 130.6 160 208l0 88L96 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L352 0zm32 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM0 176l0 48 24 0 80 0 24 0 0-48-24 0-80 0L0 176zm536 0l-24 0 0 48 24 0 80 0 24 0 0-48-24 0-80 0zM608.2 50.7L586.7 7.8 565.3 18.5l-64 32L479.8 61.3l21.5 42.9 21.5-10.7 64-32 21.5-10.7zM53.3 61.5l64 32 21.5 10.7 21.5-42.9L138.7 50.5l-64-32L53.3 7.8 31.8 50.7 53.3 61.5z"]
};
const faAngleRight = {
  prefix: 'fass',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z"]
};
const faDialMed = {
  prefix: 'fass',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zm128 31.2C128 207 187 140.6 264 129l0 158.2 0 24 48 0 0-24L312 129c77 11.6 136 78 136 158.2c0 88.4-71.6 160-160 160s-160-71.6-160-160z"]
};
const faHorse = {
  prefix: 'fass',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128l-64 0-52.8 0-54.4 0c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faQ = {
  prefix: 'fass',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M64 256c0 88.4 71.6 160 160 160c25.3 0 49.2-5.9 70.5-16.3L194.9 256l77.9 0 72.4 104.5c24.2-28 38.8-64.5 38.8-104.5c0-88.4-71.6-160-160-160S64 167.6 64 256zM331.3 452.7C299.4 470.1 262.9 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.8-25 117.8-65.5 158.3l66.2 95.5 1.5 2.2-77.9 0-41.1-59.3z"]
};
const faMonitorWaveform = {
  prefix: 'fass',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M576 32L0 32 0 480l576 0 0-448zM80 96l416 0 16 0 0 16 0 288 0 16-16 0L80 416l-16 0 0-16 0-128 0-160 0-16 16 0zM96 256l96 0 8.6 0 4.8 7.1L223 289.6l51.2-89.5 14.8-26 13.4 26.7L329.9 256l70.1 0 16 0 0 32-16 0-80 0-9.9 0-4.4-8.8-18.6-37.3-49.2 86L225 350.4l-14.4-21.5L183.4 288 96 288l0 96 384 0 0-256L96 128l0 128z"]
};
const faMonitorHeartRate = faMonitorWaveform;
const faLinkSimple = {
  prefix: 'fass',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96l64 0 32 0 0 64-32 0-64 0c-53 0-96 43-96 96s43 96 96 96l64 0 32 0 0 64-32 0-64 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-64 0-32 0 0-64 32 0 64 0c53 0 96-43 96-96s-43-96-96-96l-64 0-32 0 0-64 32 0 64 0c88.4 0 160 71.6 160 160zM192 224l192 0 32 0 0 64-32 0-192 0-32 0 0-64 32 0z"]
};
const faWhistle = {
  prefix: 'fass',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M44.1 188.8C18.5 180.5 0 156.4 0 128C0 92.7 28.7 64 64 64c23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c46.6 0 91.9 15.7 128.5 44.7l78.1 61.8L416 224l32 24 45.9-27.5L640 336 536 448 380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256c0-23.6 4.3-46.3 12.1-67.2zM80 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faG = {
  prefix: 'fass',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L224 288l0-64 192 0 32 0 0 32c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c70.8 0 134 32.9 175 84.1l-50 40C319.6 119.4 274.6 96 224 96z"]
};
const faWineGlassCrack = {
  prefix: 'fass',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M14.5 192.7L32 0s0 0 0 0L136 0l32 48L80 104 200 224 160 120l80-56L208 0l80 0s0 0 0 0l17.5 192.7C312.3 267.3 262 332.9 192 348.5l0 99.5 80 0 0 64-112 0L48 512l0-64 80 0 0-99.5C58 332.9 7.7 267.3 14.5 192.7z"]
};
const faFragile = faWineGlassCrack;
const faSlotMachine = {
  prefix: 'fass',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M448 0L64 0l0 64 384 0 0-64zm64 96L0 96 0 416l64 0 0 96 352 0 32 0 144 0 32 0 0-32 0-268.2c9.8-8.8 16-21.6 16-35.8c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8L560 448l-112 0 0-32 64 0 0-320zM80 176l72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L119.4 336l-52.9 0 3.7-8.1 48-103.9L80 224l-24 0 0-48 24 0zM263.4 336l-52.9 0 3.7-8.1 48-103.9L224 224l-24 0 0-48 24 0 72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L263.4 336zm144 0l-52.9 0 3.7-8.1 48-103.9L368 224l-24 0 0-48 24 0 72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L407.4 336z"]
};
const faNotesMedical = {
  prefix: 'fass',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M96 416L96 32l384 0 0 288-96 96L96 416zM320 128l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64zM296 464l24 0 0 48-24 0L24 512 0 512l0-24L0 152l0-24 48 0 0 24 0 312 248 0z"]
};
const faCarWash = {
  prefix: 'fass',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M64 128c-26.5 0-48-21.5-48-48C16 48 64 0 64 0s48 48 48 80s-21.5 48-48 48zm160 0c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48zM432 80c0 32-21.5 48-48 48s-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80zM106.9 160l21.1 0 192 0 21.1 0 8.3 19.4L396 288l36 0 0 96 0 64 0 64-80 0 0-64L96 448l0 64-80 0 0-64 0-64 0-96 36 0L98.6 179.4l8.3-19.4zm192 64l-149.8 0-27.4 64 204.7 0-27.4-64zM96 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faEscalator = {
  prefix: 'fass',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM424 160l24 0 96 0 64 0 0 128-64 0-72 0L234.1 496.2 216 512l-24 0-96 0-64 0 0-128 64 0 72 0L405.9 175.8 424 160zM320 128l0 80.4-128 112L192 128l128 0z"]
};
const faCommentImage = {
  prefix: 'fass',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288l0 32 320 0 0-32L296 144 195.5 264.6 160 224 96 288z"]
};
const faTemperatureHalf = {
  prefix: 'fass',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M112 300.2L97.8 317.8C86.6 331.5 80 348.9 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-19.1-6.6-36.5-17.8-50.3L208 300.2l0-22.7L208 64l-96 0 0 213.5 0 22.7zM208 0l64 0 0 64 0 213.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5L48 64 48 0l64 0 96 0zm0 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 208l0-16 32 0 0 16 0 114.8c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature2 = faTemperatureHalf;
const faThermometer2 = faTemperatureHalf;
const faThermometerHalf = faTemperatureHalf;
const faDongSign = {
  prefix: 'fass',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M320 32l-64 0 0 32-64 0 0 64 64 0 0 49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c23.3 0 45.2-6.2 64-17.1l0 17.1 64 0 0-128 0-160 32 0 0-64-32 0 0-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM384 512l0-64L0 448l0 64 384 0z"]
};
const faDonut = {
  prefix: 'fass',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160l0 24 0 16 0 22.1-55.2 27.6-2.3 1.2-1.8 1.8-44 44-74.3 7.4-1.5 .2-1.5 .4L256 375.3l-75.4-22.6-1.5-.4-1.5-.2-74.3-7.4-44-44-1.8-1.8-2.3-1.2L0 270.1 0 248l0-16 0-24zm0 97.9l38.5 19.3 46.2 46.2 4 4 5.7 .6 78.5 7.8 78.5 23.6 4.6 1.4 4.6-1.4 78.5-23.6 78.5-7.8 5.7-.6 4-4 46.2-46.2L512 305.9C510.4 393.4 396.4 464 256 464S1.6 393.4 0 305.9zM283.3 107.3L294.6 96 272 73.4 260.7 84.7l-16 16L233.4 112 256 134.6l11.3-11.3 16-16zm-112 16L182.6 112 160 89.4l-11.3 11.3-32 32L105.4 144 128 166.6l11.3-11.3 32-32zm224 9.4L384 121.4 361.4 144l11.3 11.3 32 32L416 198.6 438.6 176l-11.3-11.3-32-32zM64 192l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0zm331.3 36.7L384 217.4 361.4 240l11.3 11.3 32 32L416 294.6 438.6 272l-11.3-11.3-32-32zm-240 16L144 233.4 121.4 256l11.3 11.3 32 32L176 310.6 198.6 288l-11.3-11.3-32-32zm176 38.6L342.6 272 320 249.4l-11.3 11.3-32 32L265.4 304 288 326.6l11.3-11.3 32-32zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32z"]
};
const faDoughnut = faDonut;
const faCapsules = {
  prefix: 'fass',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"]
};
const faPooStorm = {
  prefix: 'fass',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M208 0c64 0 112 43 112 96c0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64c0 12.7-3.7 24.6-10.1 34.5c42.5 9.9 74.1 48 74.1 93.5l0 64-96 0 0-64-76.5 0 40-128-51 0L64 344.3 64 384 0 384l0-64c0-45.5 31.6-83.6 74.1-93.5C67.7 216.6 64 204.7 64 192c0-35.3 28.7-64 64-64l32 0C272 96 208 0 208 0zM184 384l-88 0 0-24L272 224 232 352l88 0 0 24L144 512l40-128z"]
};
const faPooBolt = faPooStorm;
const faTally1 = {
  prefix: 'fass',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M160 32l0 32 0 384 0 32-64 0 0-32L96 64l0-32 64 0z"]
};
const faFileVector = {
  prefix: 'fass',
  iconName: 'file-vector',
  icon: [384, 512, [], "e64c", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM128 192l0 32 128 0 0-32 64 0 0 64-32 0 0 128 32 0 0 64-64 0 0-32-128 0 0 32-64 0 0-64 32 0 0-128-32 0 0-64 64 0zm128 64l-128 0 0 128 128 0 0-128z"]
};
const faFaceFrownOpen = {
  prefix: 'fass',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM255.6 368c-38.7 0-74.5 11.4-103.6 30.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 379.4 294.3 368 255.6 368z"]
};
const faFrownOpen = faFaceFrownOpen;
const faSquareDashed = {
  prefix: 'fass',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M32 32l96 0 0 64L64 96l0 64L0 160 0 64 0 32l32 0zM0 192l64 0 0 128L0 320 0 192zm384 0l64 0 0 128-64 0 0-128zm64-32l-64 0 0-64-64 0 0-64 96 0 32 0 0 32 0 96zm0 192l0 96 0 32-32 0-96 0 0-64 64 0 0-64 64 0zM64 352l0 64 64 0 0 64-96 0L0 480l0-32 0-96 64 0zM288 480l-128 0 0-64 128 0 0 64zM160 96l0-64 128 0 0 64L160 96z"]
};
const faBagShoppingPlus = {
  prefix: 'fass',
  iconName: 'bag-shopping-plus',
  icon: [448, 512, [], "e651", "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48L0 160 0 512l448 0 0-352-112 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48zm32 152l56 0 0-56 0-24 48 0 0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24 0-56-56 0-24 0 0-48 24 0z"]
};
const faSquareJ = {
  prefix: 'fass',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M448 32L0 32 0 480l448 0 0-448zM304 152l0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24 48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0 0 24z"]
};
const faHandPointUp = {
  prefix: 'fass',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M32 0L96 0l0 240-64 0L32 0zM224 160l64 0 0 128-64 0 0-128zm-32-32l0 112-64 0 0-112 64 0zm128 64l64 0 0 128-64 0 0-128zM0 363l0-91 192 0 0 48 0 32-96 0-16 0 0 32 16 0 112 0 16 0 0-16 0-48 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363z"]
};
const faMoneyBill = {
  prefix: 'fass',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M576 64L0 64 0 448l576 0 0-384zM128 384l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faArrowUpBigSmall = {
  prefix: 'fass',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M320 32l0 224 224 0 0-224L320 32zm0 288l0 160 160 0 0-160-160 0zM183.7 58.5L160 32.4l-23.7 26-80 88L34.8 170.2l47.4 43.1 21.5-23.7L128 162.8 128 448l0 32 64 0 0-32 0-285.2 24.3 26.8 21.5 23.7 47.4-43.1-21.5-23.7-80-88z"]
};
const faSortSizeUp = faArrowUpBigSmall;
const faBarcodeRead = {
  prefix: 'fass',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M24 0L0 0 0 24 0 160l48 0L48 48l112 0 0-48L24 0zM192 384l0-256-64 0 0 256 64 0zM352 128l-64 0 0 256 64 0 0-256zm96 0l-64 0 0 256 64 0 0-256zM576 0L552 0 416 0l0 48 112 0 0 112 48 0 0-136 0-24zM24 512l136 0 0-48L48 464l0-112L0 352 0 488l0 24 24 0zm552 0l0-24 0-136-48 0 0 112-112 0 0 48 136 0 24 0zM256 128l-32 0 0 256 32 0 0-256z"]
};
const faBaguette = {
  prefix: 'fass',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8l70.8 70.8L438.6 160 416 182.6l-11.3-11.3L329.3 96l-88 58.7 74 74L326.6 240 304 262.6l-11.3-11.3-78.6-78.6-88 58.7 77.2 77.2L214.6 320 192 342.6l-11.3-11.3L98.9 249.6 57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z"]
};
const faBowlSoftServe = {
  prefix: 'fass',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M288 0L256 0l10.8 16.3c3.4 5 5.2 11 5.2 17c0 17-13.7 30.7-30.7 30.7L160 64c-35.3 0-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32L96 160c-35.3 0-64 28.7-64 64l0 64 448 0 0-64c0-35.3-28.7-64-64-64l-8.6 0c5.4-9.4 8.6-20.3 8.6-32C416 57.3 358.7 0 288 0zM64 320l-16 0 0 16 0 8c0 57.4 46.6 104 104 104l32 0-24 64 192 0-24-64 32 0c57.4 0 104-46.6 104-104l0-8 0-16-16 0L64 320z"]
};
const faFaceHoldingBackTears = {
  prefix: 'fass',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 432c55.6 0 88.4-37 98.3-56.8l-28.6-14.3C319.6 373 296.4 400 256 400s-63.6-27-69.7-39.2l-28.6 14.3C167.6 395 200.4 432 256 432zM240 272l0-32c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2 4.4-15.4L165 92.2l-4.4 15.4-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1l-15.9 2 4 31.8 13.8-1.7C85.9 205.5 80 222.1 80 240c0 18 6 34.6 16 48l0 32 0 16 32 0 0-16 0-6.7c9.8 4.3 20.6 6.7 32 6.7c18 0 34.6-6 48-16l0 16 32 0 0-16 0-16 0-16zm144 41.3l0 6.7 0 16 32 0 0-16 0-32c10-13.4 16-30 16-48c0-17.9-5.9-34.5-15.9-47.9l13.8 1.7 4-31.8-15.9-2-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2L347 92.2 316.2 101l4.4 15.4 1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z"]
};
const faSquareUp = {
  prefix: 'fass',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M448 32L0 32 0 480l448 0 0-448zM352 256l-80 0 0 128-96 0 0-128-80 0 0-16L224 112 352 240l0 16z"]
};
const faArrowAltSquareUp = faSquareUp;
const faTrainSubwayTunnel = {
  prefix: 'fass',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 256-105.4 0-64-64 57.4 0 0-320-288 0 0 320 57.4 0-64 64L0 512 0 256zM297.4 448l64 64-210.7 0 64-64 82.7 0zM240 192l0 128-80 0 0-128 80 0zm32 128l0-128 80 0 0 128-80 0zm-88 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm120 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faSubwayTunnel = faTrainSubwayTunnel;
const faSquareExclamation = {
  prefix: 'fass',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M448 32L0 32 0 480l448 0 0-448zM248 128l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM200 320l48 0 0 48-48 0 0-48z"]
};
const faExclamationSquare = faSquareExclamation;
const faSemicolon = {
  prefix: 'fass',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M160 64l0 128L32 192 32 64l128 0zM16 512L48 288l112 0L80 512l-64 0z"]
};
const faBookmark = {
  prefix: 'fass',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 512L192 400 384 512V0H0V512z"]
};
const faFanTable = {
  prefix: 'fass',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M256 413.6C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6l0 34.4-96 0-32 0 0 64 32 0 128 0 128 0 32 0 0-64-32 0-96 0 0-34.4zM178.9 53.7L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4l-2.2 15.8-120-16.9c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2l-12.6-9.8 74.6-95.5c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7l14.8-6zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faAlignJustify = {
  prefix: 'fass',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M448 32L0 32 0 96l448 0 0-64zm0 256L0 288l0 64 448 0 0-64zM0 160l0 64 448 0 0-64L0 160zM448 416L0 416l0 64 448 0 0-64z"]
};
const faBatteryLow = {
  prefix: 'fass',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M480 160l0 192L64 352l0-192 416 0zM64 96L0 96l0 64L0 352l0 64 64 0 416 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L64 96zm96 96l-64 0 0 128 64 0 0-128z"]
};
const faBattery1 = faBatteryLow;
const faCreditCardFront = {
  prefix: 'fass',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M0 32l576 0 0 448L0 480 0 32zM480 288L96 288l0 32 384 0 0-32zM96 352l0 32 96 0 0-32-96 0zm128 0l0 32 160 0 0-32-160 0zM512 96L384 96l0 96 128 0 0-96z"]
};
const faBrainArrowCurvedRight = {
  prefix: 'fass',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M240 0l0 56 0 400 0 56-56 0c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0l56 0zm32 0l56 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7c4.9 2.3 9.5 5.1 13.8 8.3l0 32-32 0c-79.5 0-144 64.5-144 144c0 42.7 21.1 74 40.3 93.6c-5.2 1.6-10.7 2.4-16.3 2.4l-56 0 0-56 0-400 0-56zM528 240L640 352 528 464l-16 0 0-64-48 0c-35.3 0-64 28.7-64 64l0 48s-64-32-64-96c0-61.9 50.1-112 112-112l64 0 0-64 16 0z"]
};
const faMindShare = faBrainArrowCurvedRight;
const faUmbrellaBeach = {
  prefix: 'fass',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M346.3 271.8l-60.1-21.9L214 448 32 448 0 448l0 64 32 0 512 0 32 0 0-64-32 0-261.9 0 64.1-176.2zm121.1-.2l-3.3 9.1 101.7 37c20.7-90.4-9.7-183.3-75.2-244.3c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM88.4 143.9l105 38.2 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2C217 7.7 131.5 59.7 88.4 143.9z"]
};
const faHelmetUn = {
  prefix: 'fass',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240L0 352l0 32 32 0 168 0 14.9 0L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6l96 0 24 0 0-48-24 0-86.5 0-1.5-1.5L368 288l48 0 32 0 32 0 32 0 0-64-32 0-.5 0zM320 417.2l-78-73.7L274.4 288l45.6 0 0 129.2zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16 32 0 0 16zM272 96l8 0 9.9 0 4.4 8.8L320 156.2l0-44.2 0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L288 163.8l0 44.2 0 16-32 0 0-16 0-96 0-16 16 0z"]
};
const faLocationSmile = {
  prefix: 'fass',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM95.4 267.1l33.3-22.2c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1l33.3 22.2C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9z"]
};
const faMapMarkerSmile = faLocationSmile;
const faArrowLeftToLine = {
  prefix: 'fass',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 96L0 64l64 0 0 32 0 320 0 32L0 448l0-32L0 96zM137.4 278.6L114.7 256l22.6-22.6 128-128L288 82.7 333.3 128l-22.6 22.6L237.3 224 416 224l32 0 0 64-32 0-178.7 0 73.4 73.4L333.3 384 288 429.3l-22.6-22.6-128-128z"]
};
const faArrowToLeft = faArrowLeftToLine;
const faBullseye = {
  prefix: 'fass',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSushi = {
  prefix: 'fass',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M479.7 320l-73.8-24.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8L576 352l-57.4-19.1L479.7 320s0 0 0 0zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2l-92.7-30.8L393.5 66.1zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64l110.9 0zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.9 0 352 21.3 224.4zM32 384l0-9.2 250.1-86.7 261.9 87 0 8.9c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64z"]
};
const faNigiri = faSushi;
const faMessageCaptions = {
  prefix: 'fass',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM120 192l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0zm224 0l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zM120 272l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zm128 0l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faCommentAltCaptions = faMessageCaptions;
const faTrashList = {
  prefix: 'fass',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M288 0l16 32 112 0 0 64L0 96 0 32l112 0L128 0 288 0zM32 128l352 0L360 512 56 512 32 128zm608 0l0 64-192 0 0-64 192 0zM608 256l0 64-160 0 0-64 160 0zM448 384l96 0 0 64-96 0 0-64z"]
};
const faBacon = {
  prefix: 'fass',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M210.8 190c-27.5 47.2-53 91-210.8 162l58.8 73.4c68.6-32.2 110.4-60.4 138.9-86.5c30-27.5 46-53.2 63.5-81.5l1.2-1.9c18.2-29.3 38.1-60.8 76.2-96.1c33.8-31.3 81.4-65 154.2-103.4L448 0C269.6 89.2 239.1 141.4 210.8 190zM79.3 451.1L128 512c157.8-71 183.3-114.8 210.8-162c28.3-48.6 58.7-100.8 237.2-190L513.2 81.5C439 120.2 392.4 153.4 360.4 183c-34.9 32.2-52.9 60.7-70.8 89.4L288 275c-17.5 28.2-35.4 57.1-68.7 87.6c-30.5 28-73.4 56.8-140 88.6z"]
};
const faOption = {
  prefix: 'fass',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M448 448l-15.4 0L423 436 176.6 128 32 128 0 128 0 64l32 0 160 0 15.4 0L217 76 463.4 384 608 384l32 0 0 64-32 0-160 0zm0-320l-32 0 0-64 32 0 160 0 32 0 0 64-32 0-160 0z"]
};
const faRaccoon = {
  prefix: 'fass',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M288.4 0L288 .5l0-.5L224 0l-9.9 0-4.4 8.8-16 32-3 5.9 2.1 6.3 15.3 45.8-28.5 35.1-3.6 4.4 0 5.7 0 40 0 11.9 11.4 3.4 77.7 23.3 46 30.7 4 2.7 4.8 0 32 0 4.8 0 4-2.7 46-30.7 77.7-23.3 11.4-3.4 0-11.9 0-40 0-5.7-3.6-4.4L463.9 98.8l15.3-45.8 2.1-6.3-3-5.9-16-32L457.9 0 448 0 384 0l0 .5-.4-.5L376 0 296 0l-7.6 0zm19 32l57.2 0c1.3 0 2.6 .1 3.9 .2l49.2 60.5-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9c-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 49.2-60.5c1.3-.1 2.6-.2 3.9-.2zm45.4 141.5l38.6 21-.2 .1L360 215.4c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-31.1-20.8-.2-.1 38.6-21c6.9-3.8 12.6-9.1 16.8-15.3c4.2 6.3 9.9 11.6 16.8 15.3zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM182.4 231.2C130.1 269 96 330.5 96 400l0 16-32 0 0-16c0-16.4 1.7-32.5 4.8-48L0 352l0 48c0 61.9 50.1 112 112 112l128 0 80 0 0-16c0-26.5-21.5-48-48-48l-32 0-16 0 0-32 16 0 32 0c44.2 0 80 35.8 80 80l0 16 24 0c0 0 0 0 .1 0l39.9 0 64 0 0-16.4c-.2-26.3-21.6-47.6-48-47.6l-16 0s0 0 0 0l0-72-6.4 4.8-12.8 9.6-19.2-25.6 12.8-9.6L448 312l0-9.3c0-19.7-7.2-38.5-20.1-53l-7.3 2.2-42 28L366.5 288 352 288l-32 0-14.5 0-12.1-8.1-42-28-68.9-20.7zM0 128l128 0 0-96L0 32l0 96zm0 32l0 64 128 0 0-64L0 160zM0 320l77.7 0c8.2-23.2 19.8-44.7 34.3-64L0 256l0 64zm480-24l-.2-.6 0 .8 .2-.2zM326 362.5L309.5 390l-13.7-8.2-80-48L202 325.5 218.5 298l13.7 8.2 80 48 13.7 8.2z"]
};
const faHandPointDown = {
  prefix: 'fass',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M32 512l64 0 0-240-64 0 0 240zM224 352l64 0 0-128-64 0 0 128zm-32 32l0-112-64 0 0 112 64 0zm128-64l64 0 0-128-64 0 0 128zM0 149l0 91 192 0 0-48 0-32-96 0-16 0 0-32 16 0 112 0 16 0 0 16 0 48 64 0 0-32 96 0C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149z"]
};
const faArrowUpFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M246.6 25.4L224 2.7 201.4 25.4l-128 128L50.7 176 96 221.3l22.6-22.6L192 125.3 192 320l0 32 64 0 0-32 0-194.7 73.4 73.4L352 221.3 397.3 176l-22.6-22.6-128-128zM64 352l0-32L0 320l0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448l0-96z"]
};
const faHeadSideGear = {
  prefix: 'fass',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM256 96l-64 0 0 37.5c-11.2 4-21.5 10-30.4 17.6l-32.5-18.7-32 55.4 32.5 18.7c-1.1 5.7-1.6 11.6-1.6 17.6s.5 11.9 1.6 17.5L97.1 260.3l32 55.4L161.6 297c8.9 7.6 19.2 13.6 30.4 17.6l0 37.5 64 0 0-37.5c11.2-4 21.5-10 30.4-17.6l32.5 18.7 32-55.4-32.5-18.7c1.1-5.7 1.6-11.6 1.6-17.5s-.5-11.9-1.6-17.6l32.5-18.7-32-55.4L286.4 151c-8.9-7.6-19.1-13.6-30.4-17.6L256 96zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faTrashPlus = {
  prefix: 'fass',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0L392 512 56 512 32 128zM200 432l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faFileCad = {
  prefix: 'fass',
  iconName: 'file-cad',
  icon: [512, 512, [], "e672", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8 0 16-32 0 0-16 0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8 0-16 32 0 0 16 0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm232 0l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0-16 0 0-16 0-128 0-16 16 0zm16 32l0 96 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0zm-160 8c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 56 0 48 0 16-32 0 0-16 0-32-32 0 0 32 0 16-32 0 0-16 0-48 0-56zm32 40l32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40z"]
};
const faObjectsAlignTop = {
  prefix: 'fass',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M512 0l0 48L0 48 0 0 512 0zM64 128l160 0 0 384L64 512l0-384zm224 0l160 0 0 256-160 0 0-256z"]
};
const faFolder = {
  prefix: 'fass',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 480H512V96H272L224 32H0V480z"]
};
const faFolderBlank = faFolder;
const faFaceAnxiousSweat = {
  prefix: 'fass',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256l16-21.3 25.6 34.1L112 320c10.4 13.8 16 30.7 16 48c0 24.6-11.1 46.5-28.5 61.2C146.3 480.1 213.4 512 288 512zM79.3 404.4C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288 36.4 303.5 9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48c12 0 22.9-4.4 31.3-11.6zM288 320c44.2 0 80 35.8 80 80l0 16-160 0 0-16c0-44.2 35.8-80 80-80zm79.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160l-11.3 11.3zM337.4 160L360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L337.4 160z"]
};
const faCreditCardBlank = {
  prefix: 'fass',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M576 32L0 32 0 480l576 0 0-448zM96 352l96 0 0 32-96 0 0-32zm128 0l160 0 0 32-160 0 0-32z"]
};
const faFileWaveform = {
  prefix: 'fass',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M256 0L32 0l0 288 112 0 9.9 0 4.4 8.8L176 332.2l49.7-99.4L240 204.2l14.3 28.6L281.9 288l70.1 0 16 0 0 32-16 0-80 0-9.9 0-4.4-8.8L240 275.8l-49.7 99.4L176 403.8l-14.3-28.6L134.1 320 32 320l0 192 384 0 0-352-160 0L256 0zm32 0l0 128 128 0L288 0z"]
};
const faFileMedicalAlt = faFileWaveform;
const faMicrochipAi = {
  prefix: 'fass',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M176 24l0-24L128 0l0 24 0 40L64 64l0 64-40 0L0 128l0 48 24 0 40 0 0 56-40 0L0 232l0 48 24 0 40 0 0 56-40 0L0 336l0 48 24 0 40 0 0 64 64 0 0 40 0 24 48 0 0-24 0-40 56 0 0 40 0 24 48 0 0-24 0-40 56 0 0 40 0 24 48 0 0-24 0-40 64 0 0-64 40 0 24 0 0-48-24 0-40 0 0-56 40 0 24 0 0-48-24 0-40 0 0-56 40 0 24 0 0-48-24 0-40 0 0-64-64 0 0-40 0-24L336 0l0 24 0 40-56 0 0-40 0-24L232 0l0 24 0 40-56 0 0-40zM352 176l0 16 0 128 0 16-32 0 0-16 0-128 0-16 32 0zM162.5 336l-34.9 0 9.8-22.4 14-32 42-96 4.2-9.6 20.9 0 4.2 9.6 42 96 14 32 9.8 22.4-34.9 0-4.2-9.6L239.5 304l-63.1 0-9.8 22.4-4.2 9.6zM208 231.9L190.5 272l35.1 0L208 231.9z"]
};
const faMug = {
  prefix: 'fass',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M384 64L32 64l0 384 384 0 0-128 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0-32 0zm32 64l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128z"]
};
const faPlaneUpSlash = {
  prefix: 'fass',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M256 93.7C256 59.5 285 0 320 0c36 0 64 59.5 64 93.7l0 66.3L576 288l0 96-91.2-30.4L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L244.9 167.4 256 160l0-66.3zM448 449l0 63L320 480 192 512l0-64 64-48 0-80L64 384l0-96 97.3-64.9L384 398.5l0 1.5 38.4 28.8L448 449z"]
};
const faRadiation = {
  prefix: 'fass',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M216 186.7c-23.9 13.8-40 39.7-40 69.3L0 256C0 161.3 51.5 78.5 128 34.3l88 152.4zM256 336c14.6 0 28.2-3.9 40-10.7l88 152.4C346.4 499.5 302.6 512 256 512s-90.4-12.5-128-34.3l88-152.4c11.8 6.8 25.4 10.7 40 10.7zm256-80l-176 0c0-29.6-16.1-55.5-40-69.3L384 34.3c76.5 44.3 128 127 128 221.7zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faPenCircle = {
  prefix: 'fass',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 288L252.7 179.3l80 80L224 368l-96 16 16-96zm256-96l-44.7 44.7-80-80L320 112l80 80z"]
};
const faBagSeedling = {
  prefix: 'fass',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M32 0L480 0 448 64 64 64 32 0zM56 96l400 0 10.6 42.5c8.9 35.5 13.4 72 13.4 108.7l0 17.7c0 36.6-4.5 73.1-13.4 108.7L456 416 56 416 45.4 373.5C36.5 338 32 301.5 32 264.8l0-17.7c0-36.6 4.5-73.1 13.4-108.7L56 96zm8 352l384 0 32 64L32 512l32-64zm96-288l-32 0 0 16c0 59.2 45.9 107.6 104 111.7l0 40.3 0 24 48 0 0-24 0-40.3c58.1-4.1 104-52.6 104-111.7l0-16-32 0c-40.7 0-76.4 21.8-96 54.3c-19.6-32.5-55.3-54.3-96-54.3z"]
};
const faChartSimple = {
  prefix: 'fass',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M160 32l128 0 0 448-128 0 0-448zM0 224l128 0 0 256L0 480 0 224zM448 96l0 384-128 0 0-384 128 0z"]
};
const faCrutches = {
  prefix: 'fass',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M154.2 23.8L176.9 1.1l45.3 45.3L204.5 64 297 156.5l-45.3 45.3-92.5-92.5L108.5 160 228.1 279.6l-13.9 55.7-10.5 10.5L63.3 205.3 45.7 222.9 .4 177.6 23 155 154.2 23.8zm278.5 370l2.8-2.8 2.4 2.4c0 0 0 0 .1 .1l72.9 72.9-45.3 45.3-73-73-27.9-27.9 67.9-17zM485 23.8L616.2 155l22.6 22.6-45.3 45.3L571 200.2 439.8 69 417.1 46.4 462.4 1.1 485 23.8zM281.4 217.4L412.1 86.6l45.3 45.3L405.3 184 456 234.7l52.1-52.1 45.3 45.3L422.6 358.6l-6.3 6.3-8.6 2.2L288.4 396.9l-41.7 41.7-73 73-45.3-45.3 72.9-72.9c0 0 0 0 .1-.1l41.7-41.7L273 232.2l2.1-8.6 6.3-6.3zm51.5 39L316 324l67.7-16.9L410.7 280 360 229.3l-27.1 27.1z"]
};
const faCircleParking = {
  prefix: 'fass',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM200 128l80 0c53 0 96 43 96 96l0 32-5.5 0c-13.2 37.3-48.7 64-90.5 64l-48 0 0 32 0 32-64 0 0-32 0-32 0-64 0-96 0-32 32 0zm112 96c0-17.7-14.3-32-32-32l-48 0 0 64 48 0c17.7 0 32-14.3 32-32z"]
};
const faParkingCircle = faCircleParking;
const faMarsStroke = {
  prefix: 'fass',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M512 0L384 0 352 32l41.4 41.4-23 23L345 71l-17-17L294.1 88l17 17 25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201l17 17L457.9 184l-17-17-25.4-25.4 23-23L480 160l32-32L512 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"]
};
const faLeafOak = {
  prefix: 'fass',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M512 248l0-72-48-32 16-64L432 32 368 48 336 0 264 0 240 96 176 32 128 80l16 112L96 160 32 224l48 96 0 65.4L229.6 235.8l11.3-11.3 22.3 22.3L55 455l-17 17L72 505.9l17-17 57-57 46.1 0 96 48 64-64-32-48 112 16 48-48-64-64 96-24z"]
};
const faSquareBolt = {
  prefix: 'fass',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M448 32L0 32 0 480l448 0 0-448zM200 272l-88 0 0-24L288 112 248 240l88 0 0 24L160 400l40-128z"]
};
const faVial = {
  prefix: 'fass',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M356.1 22.8L333.4 .2 288.2 45.4 306.7 64 28.1 342.6C10.1 360.6 0 385 0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1L448 205.3l18.6 18.6 45.3-45.3-22.6-22.6-18.6-18.6-96-96s0 0 0 0L356.1 22.8zM205.3 256L352 109.3 402.7 160l-96 96-101.5 0z"]
};
const faGauge = {
  prefix: 'fass',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88l0-24-48 0 0 24 0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faDashboard = faGauge;
const faGaugeMed = faGauge;
const faTachometerAltAverage = faGauge;
const faWandMagicSparkles = {
  prefix: 'fass',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L192 64l42.7 21.3L256 128l21.3-42.7L320 64 277.3 42.7 256 0 234.7 42.7zM384.4 192.4l-32.8-32.8L432 79.2 464.8 112l-80.4 80.4zM96 32L64 96 0 128l64 32 32 64 32-64 64-32L128 96 96 32zM416 352l-64 32 64 32 32 64 32-64 64-32-64-32-32-64-32 64zM144 512l39.6-39.6L504.4 151.6 544 112 504.4 72.4 471.6 39.6 432 0 392.4 39.6 71.6 360.4 32 400l39.6 39.6 32.8 32.8L144 512z"]
};
const faMagicWandSparkles = faWandMagicSparkles;
const faLambda = {
  prefix: 'fass',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M32 32L0 32 0 96l32 0 108.2 0 16.4 32.9L2.2 480l69.9 0L193.8 203.3 323.4 462.3l8.8 17.7 19.8 0 64 0 32 0 0-64-32 0-44.2 0L188.6 49.7 179.8 32 160 32 32 32z"]
};
const faE = {
  prefix: 'fass',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 32 0 256 0 32 0 0-64-32 0L64 416l0-128 160 0 32 0 0-64-32 0L64 224 64 96l224 0 32 0 0-64-32 0L32 32z"]
};
const faPizza = {
  prefix: 'fass',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M256 464c57.4 0 109.4-23.3 147.1-60.9L437 437c-46.3 46.3-110.3 75-181 75C114.6 512 0 397.4 0 256S114.6 0 256 0c70.7 0 134.7 28.7 181 75l-33.9 33.9C365.4 71.3 313.4 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm124.5-83.5c-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9s180.2-68.7 248.9 0L256 256 380.5 380.5zM192 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm190.6 14.6C509.4 354.3 528 307.3 528 256s-18.6-98.3-49.4-134.6l34-34c39.5 45 63.4 104 63.4 168.6s-23.9 123.6-63.4 168.6l-34-34zM344 256l35.5-35.5c3.6 2.2 7.9 3.5 12.5 3.5c13.3 0 24-10.7 24-24c0-4.6-1.3-8.9-3.5-12.5l43.4-43.4c53.5 64.8 53.5 158.9 0 223.8L344 256zm104 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faBowlChopsticksNoodles = {
  prefix: 'fass',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M0 96l0 32 128-20 0 32L0 144l0 32 128 0 0 48L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224l-224 0-32 0 0-48 0-40 0-48 0-40 0-8 0-24-48 0 0 24 0 17 0 38.5 0 42 0 38.5 0 48-32 0 0-48 0-37.5 0-38L176 63l0-7 0-24-48 0 0 24 0 16L0 96zm512 80l0-48-224 7 0 41 224 0zm0-128l0-48L288 42l0 41L512 48z"]
};
const faH3 = {
  prefix: 'fass',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M64 96l0-32L0 64 0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96zm560 13.3L624 64l-32 0L400 64l-32 0 0 64 32 0 114.7 0L432 210.7l0 61.3 16 0 72 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-60.3 0c-11 0-20.6-7.5-23.3-18.2L431 344.2 369 359.8l5.4 21.6c9.8 39.2 45 66.7 85.4 66.7l60.3 0c55.2 0 101.7-37.3 115.7-88l4.3 0 0-32c0-64.6-51-117.2-114.9-119.9l89.5-89.5 9.4-9.4z"]
};
const faPenClip = {
  prefix: 'fass',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M512 128l-72.4 72.4-128-128L384 0 512 128zM224 30.1l17 17L417 223l-1 1-33 33L160 480 0 512 32 352 255 129l-31-31-95 95-17 17L78.1 176l17-17L207 47l17-17z"]
};
const faPenAlt = faPenClip;
const faBridgeCircleExclamation = {
  prefix: 'fass',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M64 32L32 32l0 64 32 0 40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2l0-72.2-72 0 0-64 40 0 32 0 0-64-32 0L64 32zM488 96l0 64-80 0 0-64 80 0zM360 96l0 64-80 0 0-64 80 0zM232 96l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faBadgePercent = {
  prefix: 'fass',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209l17-17L320 158.1l-17 17L175 303l-17 17L192 353.9l17-17L337 209z"]
};
const faRotateReverse = {
  prefix: 'fass',
  iconName: 'rotate-reverse',
  icon: [512, 512, [], "e631", "M368.9 142.9c17.5 17.5 30.1 38 37.8 59.8L467 181.4c-10.8-30.6-28.4-59.3-52.9-83.7c-87.5-87.5-229.3-87.5-316.8 0c0 0 0 0 0 0L39.8 40l-24 24 0 160 160 0 24-24-57.1-57.1s0 0 0 0c62.5-62.5 163.8-62.5 226.3 0zm0 226.3c-62.5 62.5-163.8 62.5-226.3 0c-17.5-17.5-30.1-38-37.8-59.8L44.5 330.6C55.3 361.3 73 390 97.4 414.4c87.5 87.5 229.3 87.5 316.7 0c0 0 0 0 0 0L471.8 472l24-24 0-160-160 0-24 24 57.1 57.1z"]
};
const faUser = {
  prefix: 'fass',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512L384 304 64 304 0 512l448 0z"]
};
const faSensor = {
  prefix: 'fass',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M448 32L0 32 0 480l448 0 0-448zM112 120l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm96 0l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24z"]
};
const faComma = {
  prefix: 'fass',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M48 288L16 512H80l80-224H48z"]
};
const faSchoolCircleCheck = {
  prefix: 'fass',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M640 512l-42.8 0s0 0 0 0l42.8 0s0 0 0 0zm-245.2 0s0 0 0 0L384 512s0 0 0 0l10.8 0zM576 211.2c25.6 13.1 47.6 32.2 64 55.6L640 96 480 96 320 0 160 96 0 96 0 512l256 0 0-96c0-35.3 28.7-64 64-64c0 0 0 0 0 0s0 0 0 0l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c16.5-11.9 35.1-21.1 55.1-26.8l0-38.6 128 0 0 51.2zM144 192l0 96-64 0 0-96 64 0zm0 128l0 96-64 0 0-96 64 0zM336 128l-32 0 0 16 0 32 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-16 0-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faToiletPaperUnder = {
  prefix: 'fass',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M96 0L348.2 0C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9L96 384C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416l256 0c44.8 0 76.9-35.2 96-72.9L512 512l-352 0 0-96zM64 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faToiletPaperReverse = faToiletPaperUnder;
const faLightEmergency = {
  prefix: 'fass',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160L64 352l0-160zm160-80l0-32c-61.9 0-112 50.1-112 112l32 0c0-44.2 35.8-80 80-80zM448 480L0 480l0-96 448 0 0 96z"]
};
const faArrowDownToArc = {
  prefix: 'fass',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 448c106 0 192-86 192-192l64 0c0 141.4-114.6 256-256 256S0 397.4 0 256l64 0c0 106 86 192 192 192zM390.6 230.6l-112 112L256 365.3l-22.6-22.6-112-112L98.7 208 144 162.7l22.6 22.6L224 242.7 224 32l0-32 64 0 0 32 0 210.7 57.4-57.4L368 162.7 413.3 208l-22.6 22.6z"]
};
const faDumpster = {
  prefix: 'fass',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M32 32L0 160l114.9 0L140.5 32 32 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0L576 160 544 32 435.5 32l25.6 128zM32 192l4 32L0 224l0 64 44 0L64 448l0 32 64 0 0-32 320 0 0 32 64 0 0-32 20-160 44 0 0-64-36 0 4-32L32 192z"]
};
const faVanShuttle = {
  prefix: 'fass',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M32 32L0 32 0 64 0 352l0 32 32 0 32 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-32 0-136 0-11.7-7.5-8.9-128-152L494.9 32 480 32 352 32 192 32 32 32zM546 192l-162 0 0-96 81.1 0L546 192zM64 192l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM432 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faShuttleVan = faVanShuttle;
const faBuildingUser = {
  prefix: 'fass',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 77.1 0L384 359 384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm8 112l-176 0L352 512l288 0L584 384z"]
};
const faLightSwitch = {
  prefix: 'fass',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M384 0L0 0 0 512l384 0L384 0zM96 272l192 0 0 144L96 416l0-144zm0-32L96 96l192 0 0 144L96 240zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faSquareCaretLeft = {
  prefix: 'fass',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M0 32L0 480l448 0 0-448L0 32zM256 384L128 256 256 128l32 0 0 256-32 0z"]
};
const faCaretSquareLeft = faSquareCaretLeft;
const faHighlighter = {
  prefix: 'fass',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M314.3 314.3L460.3 110.8 433.2 83.7 229.7 229.7l84.5 84.5zM128 320l0-96L440 0 544 104 320 416l-96 0-48 48L80 368l48-48s0 0 0 0zM4.7 468.7l65.4-65.4 70.6 70.6-33.4 33.4-4.7 4.7L96 512l-80 0L0 512l0-16 0-16 0-6.6 4.7-4.7z"]
};
const faWavePulse = {
  prefix: 'fass',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M285.2 0L312 0l16 0 25.5 0 5.7 24.9 63.9 281.3 27.6-63 8.4-19.2 20.9 0 128 0 32 0 0 64-32 0-107.1 0L453.3 396.8 444.9 416 424 416l-16 0-25.5 0-5.7-24.9-54-237.6L263.5 485.6 258.8 512 232 512l-16 0-25 0L185 487.8 135 288 32 288 0 288l0-64 32 0 128 0 25 0 6.1 24.2 29.1 116.3L280.5 26.4 285.2 0z"]
};
const faHeartRate = faWavePulse;
const faKey = {
  prefix: 'fass',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391l-7 7L0 408l0 80 0 24 24 0 80 0 24 0 0-24 0-40 40 0 24 0 0-24 0-40 40 0 9.9 0 7-7 33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faArrowLeftToBracket = {
  prefix: 'fass',
  iconName: 'arrow-left-to-bracket',
  icon: [512, 512, [], "e669", "M160 96L64 96l0 320 96 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l32 0 128 0 32 0 0 64-32 0zm9.4 182.6L146.7 256l22.6-22.6 128-128L320 82.7 365.3 128l-22.6 22.6L269.3 224 480 224l32 0 0 64-32 0-210.7 0 73.4 73.4L365.3 384 320 429.3l-22.6-22.6-128-128z"]
};
const faHatSanta = {
  prefix: 'fass',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M149.7 137.8L64 352l384 0L384 192l81.3 22.2-2.6-13.4-6.3-32.2 32.3-5.6 5.4-.9L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8zm395.8 23.5L526.9 189l-32.8 5.6 6.4 32.7-19.2 27.2L509 273.1l5.6 32.8 32.7-6.4 27.2 19.2L593.1 291l32.8-5.6-6.4-32.7 19.2-27.2L611 206.9l-5.6-32.8-32.7 6.4-27.2-19.2zM0 384l0 96 48 0 416 0 48 0 0-96-48 0L48 384 0 384z"]
};
const faTamale = {
  prefix: 'fass',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M0 48S48 0 160 0S320 48 320 48L295.4 208l-59.2 0L248 72.7l.7-8-15.9-1.4-.7 8L220.1 208 168 208l0-144 0-8-16 0 0 8 0 144-52.1 0L88 71.3l-.7-8L71.3 64.7l.7 8L83.8 208l-59.2 0L0 48zM256 304l39.4 0L320 464s-48 48-160 48S0 464 0 464L24.6 304 64 304 44.8 329.6l34.5 25.9L72 439.3l-.7 8 15.9 1.4 .7-8 6.4-73.9 27.2 20.4 28.8-38.4 1.6-2.1L152 448l0 8 16 0 0-8 0-101.3 1.6 2.1 28.8 38.4 27.2-20.4 6.4 73.9 .7 8 15.9-1.4-.7-8-7.3-83.8 34.5-25.9L256 304zM24 240l136 0 136 0 16 0 0 32-16 0-104 0 28.8 38.4 9.6 12.8-25.6 19.2-9.6-12.8L160 282.7l-35.2 46.9-9.6 12.8L89.6 323.2l9.6-12.8L128 272 24 272 8 272l0-32 16 0z"]
};
const faBoxCheck = {
  prefix: 'fass',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M208 32l0 128L0 160 64 32l144 0zm32 0l144 0 64 128-208 0 0-128zM0 192l448 0 0 288L0 480 0 192zm337 89l17-17L320 230.1l-17 17-111 111-47-47-17-17L94.1 328l17 17 64 64 17 17 17-17L337 281z"]
};
const faBullhorn = {
  prefix: 'fass',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M440 0L426.1 0l-9.5 10.1L382 47.1C333.6 98.7 266 128 195.2 128l-3.2 0-32 0L0 128 0 352l64 0 0 160 128 0 0-160 3.2 0c70.8 0 138.4 29.3 186.8 80.9l34.7 37 9.5 10.1 13.9 0 8 0 32 0 0-32 0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32l0-32L448 0l-8 0zM416 103.6L416 240l0 136.4C356.7 319.8 277.7 288 195.2 288l-3.2 0 0-96 3.2 0c82.4 0 161.4-31.8 220.8-88.4z"]
};
const faSteak = {
  prefix: 'fass',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512L0 512 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122s0 0 0 0c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416L96 416l0-56c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3c-2.9 6.6-5.6 13.2-8.3 19.8c-11.4 27.8-22.8 55.7-46.4 79.3c-41.4 41.4-78.6 57.1-107 69l-1.1 .5-.7 .3s0 0 0 0c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360l0 72 0 16 16 0 160 0c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120C442.7 87.8 406.6 64 368 64c-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faLocationCrosshairsSlash = {
  prefix: 'fass',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M352 32l0-32L288 0l0 32 0 34.7c-40.2 6.7-76.2 26-103.8 53.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L485.2 353.9C497 334 505.4 311.7 509.3 288l34.7 0 32 0 0-64-32 0-34.7 0C495.9 143.6 432.4 80.1 352 66.7L352 32zm82 282.2l-39-30.3c3.2-8.7 5-18.1 5-27.9c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3l-39-30.3c22.6-19.9 52.2-32 84.6-32c70.7 0 128 57.3 128 128c0 21-5 40.7-14 58.2zM414.9 422.9l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3L96 224l-32 0 0 64 32 0 34.7 0c13.5 80.4 76.9 143.9 157.3 157.3l0 34.7 0 32 64 0 0-32 0-34.7c22.6-3.8 43.8-11.5 62.9-22.4z"]
};
const faLocationSlash = faLocationCrosshairsSlash;
const faPersonDolly = {
  prefix: 'fass',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM0 346.5l64 64L64 480s0 0 0 0l0 32L0 512l0-32L0 346.5zM0 128l32 0 48 0 17.1 0 9.5 14.3L161.1 224l46.1 0-6.5-26.2-5.8-23.3 46.6-11.6 5.8 23.3 49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6 23.3-5.8 11.6 46.6-23.3 5.8L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288 144 288l-17.1 0-9.5-14.3L96 241.7l0 65.1 54.6 54.6 7.3 7.3 1.7 10.1 8 48 4 24 4 24s0 0 0 0l4 24 2.2 13.3-64.9 0-.5-2.7-4-24s0 0 0 0l-4-24-4-24-6.3-37.9L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7L0 160l0-32zM288 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm38.4-80L288 230.4 441.6 192 480 345.6 326.4 384z"]
};
const faGlobe = {
  prefix: 'fass',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M352 256c0 22.1-2.2 43.5-6.1 64l-179.7 0c-3.9-20.5-6.1-41.9-6.1-64s2.2-43.5 6.1-64l179.7 0c3.9 20.5 6.1 41.9 6.1 64zm26.4-64l125.6 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-125.6 0c3.6-20.5 5.6-41.9 5.6-64s-2-43.5-5.6-64zm115-32l-122 0c-17-65.6-48.3-120-74-156.7c89.2 14.5 163 75.2 196 156.7zm-155.1 0l-164.6 0c11.4-40.2 28.4-75.9 45.8-105.4c13-21.9 25.9-40 36.5-53.5c10.5 13.5 23.5 31.6 36.5 53.5c17.4 29.4 34.5 65.1 45.8 105.4zm-197.7 0l-122 0c33-81.5 106.7-142.2 196-156.7c-25.7 36.7-57 91-74 156.7zM8.1 192l125.6 0c-3.6 20.5-5.6 41.9-5.6 64s2 43.5 5.6 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM173.7 352l164.6 0c-11.4 40.2-28.4 75.9-45.8 105.4c-13 21.9-25.9 40-36.5 53.5c-10.5-13.5-23.5-31.6-36.5-53.5c-17.4-29.4-34.5-65.1-45.8-105.4zm-33.2 0c17 65.6 48.3 120 74 156.7c-89.2-14.5-163-75.2-196-156.7l122 0zm352.8 0c-33 81.5-106.7 142.2-196 156.7c25.7-36.7 57-91 74-156.7l122 0z"]
};
const faSynagogue = {
  prefix: 'fass',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M320 0L160 128l0 32 0 112 0 240 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 128 0 0-240 0-112 0-32L320 0zM512 240l0 272 128 0 0-240-80-80-48 48zM80 192L0 272 0 512l128 0 0-272L80 192zm240-73.9l21.3 36.9 42.6 0L362.7 192 384 228.9l-42.6 0L320 265.9l-21.3-36.9-42.7 0L277.4 192 256 155.1l42.7 0L320 118.1z"]
};
const faFileChartColumn = {
  prefix: 'fass',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM216 248l0 176 0 24-48 0 0-24 0-176 0-24 48 0 0 24zm88 64l0 112 0 24-48 0 0-24 0-112 0-24 48 0 0 24zM128 376l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24z"]
};
const faFileChartLine = faFileChartColumn;
const faPersonHalfDress = {
  prefix: 'fass',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm72 416l0-32 0-227.8 33.8 53 53.9-34.4L238 142.8 228.6 128l-17.5 0L168 128l0 224 0 128 0 32 64 0zM152 384l0-256-43.1 0-17.5 0-9.4 14.8L.2 270.8l53.9 34.4 42-65.8L48 384l40 0 0 96 0 32 64 0 0-32 0-96s0 0 0 0z"]
};
const faFolderImage = {
  prefix: 'fass',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120-16l-19.6 27.8L219.1 317l-17.1-19.3L184 277.5l-17.9 20.2-64 72L96 376.5l0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136L296 208z"]
};
const faCalendarPen = {
  prefix: 'fass',
  iconName: 'calendar-pen',
  icon: [448, 512, ["calendar-edit"], "f333", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM280.7 351.3l-56-56L136 384l-8 64 64-8 88.7-88.7zm22.6-22.6L336 296l-56-56-32.7 32.7 56 56z"]
};
const faCalendarEdit = faCalendarPen;
const faRoadBridge = {
  prefix: 'fass',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M320 0L640 0l0 512-320 0L320 0zM504 200l-48 0 0 24 0 64 0 24 48 0 0-24 0-64 0-24zm0 184l0-24-48 0 0 24 0 64 0 24 48 0 0-24 0-64zm0-344l-48 0 0 24 0 64 0 24 48 0 0-24 0-64 0-24zM32 96l256 0 0 64-40 0 0 64 40 0 0 96c-53 0-96 43-96 96l0 96-96 0 0-96c0-53-43-96-96-96l0-96 72 0 0-64-40 0L0 160 0 96l32 0zm168 64l-80 0 0 64 80 0 0-64z"]
};
const faFaceSmileTear = {
  prefix: 'fass',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm153.6 57.4l-24.2 21 10.5 12.1c22.2 25.7 61 53.5 116.1 53.5l16 0 0-32-16 0c-43.4 0-74-21.8-91.9-42.5l-10.5-12.1zM352 288l-38.4 51.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L352 288zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faMessagePlus = {
  prefix: 'fass',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM232 320l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faCommentAltPlus = faMessagePlus;
const faLocationArrow = {
  prefix: 'fass',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M0 256H224V480h48L432 48 0 208v48z"]
};
const faC = {
  prefix: 'fass',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0l45.3 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0l-45.3 45.3z"]
};
const faTabletButton = {
  prefix: 'fass',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M448 0L0 0 0 512l448 0L448 0zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPersonDressFairy = {
  prefix: 'fass',
  iconName: 'person-dress-fairy',
  icon: [640, 512, [], "e607", "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM448 384l-64 0 0 128-128 0 0-128-64 0 64-224 128 0 64 224zM34.9 32c78.3 0 149.3 31.6 200.8 82.7L149.6 416l74.4 0 0 31.3C191.7 468 153.2 480 112 480l-16 0-32 0 0-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64 0 32l32 0 2.9 0zM528 480c-41.2 0-79.7-12-112-32.7l0-31.3 74.4 0L404.3 114.7C455.9 63.6 526.8 32 605.1 32l2.9 0 32 0 0 32 0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448l0 32-32 0-16 0z"]
};
const faRectangleHistoryCircleUser = {
  prefix: 'fass',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M320 368c0 59.5 29.5 112.1 74.8 144L0 512 0 160l512 0 0 32.7c-5.3-.5-10.6-.7-16-.7c-97.2 0-176 78.8-176 176zM464 80l0 48L48 128l0-48 416 0zM416 0l0 48L96 48 96 0 416 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L552 416l-112 0-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faBuildingLock = {
  prefix: 'fass',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M0 0L384 0l0 193.6c-16.3 16.6-27.4 38.3-30.9 62.4L320 256l0-32-64 0 0 64 64 0 0 32 0 192-80 0 0-128-96 0 0 128L0 512 0 0zM128 224l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM64 96l0 64 64 0 0-64L64 96zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faChartLineUp = {
  prefix: 'fass',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm288 64l-32 32 41.4 41.4L304 258.7l-73.4-73.4L208 162.7l-22.6 22.6-80 80 45.3 45.3L208 253.3l73.4 73.4L304 349.3l22.6-22.6 80-80L448 288l32-32 0-128-128 0z"]
};
const faMailbox = {
  prefix: 'fass',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M0 208L0 448l288 0 0-240c0-79.5-64.5-144-144-144S0 128.5 0 208zm64-16l16 0 128 0 16 0 0 32-16 0L80 224l-16 0 0-32zM320 448l256 0 0-240c0-79.5-64.5-144-144-144L245.2 64C290.4 95.9 320 148.5 320 208l0 240zm64-256l16 0 64 0 32 0 16 0 0 16 0 64 0 16-16 0-32 0-16 0 0-16 0-48-48 0-16 0 0-32z"]
};
const faSignPosts = {
  prefix: 'fass',
  iconName: 'sign-posts',
  icon: [576, 512, [], "e625", "M64 0l0 32L0 32 0 416l576 0 0-384-64 0 0-32L448 0l0 32L128 32l0-32L64 0zm64 448l-64 0 0 64 64 0 0-64zm320 0l0 64 64 0 0-64-64 0z"]
};
const faTruckBolt = {
  prefix: 'fass',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M0 0L416 0l0 96 80 0L608 208l0 144 32 0 0 64-32 0-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96L0 416 0 0zM416 256l128 0 0-16-80-80-48 0 0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 192l88 0-24 96L288 160l-88 0 24-96L96 192z"]
};
const faPizzaSlice = {
  prefix: 'fass',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M99.9 112.2L0 512l399.8-99.9c.2-4 .2-8 .2-12.1c0-159.1-128.9-288-288-288c-4 0-8.1 .1-12.1 .2zM432 404l80-20C512 171.9 340.1 0 128 0L108 80c1.3 0 2.7 0 4 0c176.7 0 320 143.3 320 320c0 1.3 0 2.7 0 4zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faMoneyBillWave = {
  prefix: 'fass',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M0 60.3L0 451.7c96 48.9 192 24.5 288 0s192-48.9 288 0l0-391.5c-96-48.9-192-24.5-288 0s-192 48.9-288 0zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64l-64 0 0-64zm64-208c0 35.3-28.7 64-64 64l0-64 64 0zM512 304l0 64-64 0c0-35.3 28.7-64 64-64zM448 96l64 0 0 64c-35.3 0-64-28.7-64-64z"]
};
const faChartArea = {
  prefix: 'fass',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm64 288l352 0 0-112L384 128l-64 64L240 96 128 224l0 128z"]
};
const faAreaChart = faChartArea;
const faHouseFlag = {
  prefix: 'fass',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M512 0l0 32 128 0 0 160-128 0 0 320-64 0 0-320 0-160 0-32 64 0zM416 165.2L416 512l-96 0 0-160-128 0 0 160L64.1 512l0-224.4L0 287.6 0 240 256.4 32 416 165.2z"]
};
const faCircleThreeQuartersStroke = {
  prefix: 'fass',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 64l0 192 192 0c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faPersonCircleMinus = {
  prefix: 'fass',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-16 0-128 0-16 0 0 32 16 0 128 0 16 0z"]
};
const faScalpel = {
  prefix: 'fass',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M352 288L495.7 115.6C506.2 102.9 512 87 512 70.5l0-4.2C512 29.7 482.3 0 445.8 0c-18.9 0-36.9 8.1-49.5 22.2L160 288l192 0zM176 320L0 512s288-16 288-192l-112 0z"]
};
const faBan = {
  prefix: 'fass',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faCancel = faBan;
const faBellExclamation = {
  prefix: 'fass',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M256 0L192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0zm32 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM248 112l0 24 0 96 0 24-48 0 0-24 0-96 0-24 48 0zm0 184l0 48-48 0 0-48 48 0z"]
};
const faCircleBookmark = {
  prefix: 'fass',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 384l0-256 192 0 0 256-96-64-96 64z"]
};
const faBookmarkCircle = faCircleBookmark;
const faEggFried = {
  prefix: 'fass',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-160 0l-32 0c0-44.2 35.8-80 80-80l0 32c-26.5 0-48 21.5-48 48z"]
};
const faFaceWeary = {
  prefix: 'fass',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM211.3 187.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 153.4 222.6 176l-11.3 11.3zM289.4 176L312 153.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L289.4 176zM256 384c-48.9 0-93.5 16.8-127.4 44.3c-.4-4.1-.6-8.2-.6-12.3c0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3C349.5 400.8 304.9 384 256 384z"]
};
const faUniformMartialArts = {
  prefix: 'fass',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M180 0l57.7 0 69.9 144.7L253 288l-109 0 0-154.9L96 220.3 96 368l0 48L0 416l0-48L0 208l0-12.3 5.9-10.8 88-160L107.6 0 136 0l8 0 36 0zM144 352l0-32 120 0 56 0 176 0 0 32-107.6 0-38.5 0L392 415.2l8.9 13.3-26.6 17.8L365.4 433 320 364.8 274.6 433l-8.9 13.3-26.6-17.8 8.9-13.3L290.1 352l-38.5 0L144 352zm77.3 45.5l-26.6 39.9 79.9 53.3 26.6-39.9L320 422.5l18.8 28.2 26.6 39.9 79.9-53.3-26.6-39.9-9-13.5 86.3 0 0 128-352 0 0-128 86.3 0-9 13.5zM496 133.1L496 288l-208.8 0 52.7-138.3L396.9 0 460 0l36 0 8 0 28.4 0 13.7 24.9 88 160 5.9 10.8 0 12.3 0 160 0 48-96 0 0-48 0-147.7-48-87.3z"]
};
const faCameraRotate = {
  prefix: 'fass',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M224 32L202.7 96 64 96l0 384 512 0 0-384L437.3 96 416 32 224 32zM448 272l-88 0-16-16 27-27c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249 215 215l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l27-27 16 16 0 88zM192 304l88 0 16 16-27 27c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327 425 361l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-27 27-16-16 0-88z"]
};
const faSunDust = {
  prefix: 'fass',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M256 73.1L150 0 126.7 126.7 0 150 73.1 256 0 362l126.7 23.3s0 0 0 0l38.8-38.8C142.3 323.3 128 291.3 128 256c0-70.7 57.3-128 128-128c35.3 0 67.4 14.3 90.5 37.5l38.8-38.8s0 0 0 0L362 0 256 73.1zM188.1 323.9L323.9 188.1C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96c0 26.5 10.7 50.5 28.1 67.9zM512 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCommentText = {
  prefix: 'fass',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM184 160l-24 0 0 48 24 0 48 0 0 104 0 24 48 0 0-24 0-104 48 0 24 0 0-48-24 0-72 0-72 0z"]
};
const faSprayCanSparkles = {
  prefix: 'fass',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M96 0l0 128 128 0L224 0 96 0zm0 160c-53 0-96 43-96 96L0 512l320 0 0-256c0-53-43-96-96-96L96 160zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM320 32L288 48l32 16 16 32 16-32 32-16L352 32 336 0 320 32zm64 96l-32 16 32 16 16 32 16-32 32-16-32-16L400 96l-16 32zM464 0L448 32 416 48l32 16 16 32 16-32 32-16L480 32 464 0zM448 224l-32 16 32 16 16 32 16-32 32-16-32-16-16-32-16 32z"]
};
const faAirFreshener = faSprayCanSparkles;
const faSignalBars = {
  prefix: 'fass',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M608 0L512 0l0 512 96 0L608 0zM352 128l0 384 96 0 0-384-96 0zM288 256l-96 0 0 256 96 0 0-256zM128 384l-96 0 0 128 96 0 0-128z"]
};
const faSignalAlt = faSignalBars;
const faSignalAlt4 = faSignalBars;
const faSignalBarsStrong = faSignalBars;
const faDiamondExclamation = {
  prefix: 'fass',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M256 0L0 256 256 512 512 256 256 0zm24 128l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 368l0-48 48 0 0 48-48 0z"]
};
const faStar = {
  prefix: 'fass',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M288.1 0l86.5 164 182.7 31.6L428 328.5 454.4 512 288.1 430.2 121.7 512l26.4-183.5L18.9 195.6 201.5 164 288.1 0z"]
};
const faDialMin = {
  prefix: 'fass',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zM400.9 401c-56.7 56.7-145.4 62-208 15.7L304.7 304.9l17-17-33.9-33.9-17 17L158.9 382.8c-46.2-62.6-41-151.3 15.7-208c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3z"]
};
const faRepeat = {
  prefix: 'fass',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M0 224L0 96 0 64l32 0 288 0 0-64 32 0 96 96-96 96-32 0 0-64L64 128l0 96 0 32L0 256l0-32zm512 64l0 128 0 32-32 0-288 0 0 64-32 0L64 416l96-96 32 0 0 64 256 0 0-96 0-32 64 0 0 32z"]
};
const faCross = {
  prefix: 'fass',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M256 0L128 0l0 128L0 128 0 256l128 0 0 256 128 0 0-256 128 0 0-128-128 0L256 0z"]
};
const faPageCaretDown = {
  prefix: 'fass',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M384 112l0 400L0 512 0 0 272 0 384 112zM96 224l0 32 96 96 96-96 0-32L96 224z"]
};
const faFileCaretDown = faPageCaretDown;
const faBox = {
  prefix: 'fass',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M64 32L0 160l208 0 0-128L64 32zM240 160l208 0L384 32 240 32l0 128zm208 32L0 192 0 480l448 0 0-288z"]
};
const faVenusMars = {
  prefix: 'fass',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32-32 0-32 0 0-64 32 0 32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l21.6-21.6L480 32 512 0 640 0l0 128-32 32-41.4-41.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
const faClockSevenThirty = {
  prefix: 'fass',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-56.7-20 30-13.3 20-39.9-26.6 13.3-20 64-96L280 256l0 136 0 24-48 0 0-24z"]
};
const faArrowPointer = {
  prefix: 'fass',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M32 32L0 46.9 0 432l29 31.8 96.1-117.2 48.2 102.7 13.6 29 57.9-27.2-13.6-29L183.3 320 320 320l-.1-42L32 32z"]
};
const faMousePointer = faArrowPointer;
const faClockFourThirty = {
  prefix: 'fass',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-91.2L338.7 340l20 13.3 26.6-39.9-20-13.3-96-64L232 211.2l0 44.8 0 136 0 24 48 0 0-24z"]
};
const faSignalBarsGood = {
  prefix: 'fass',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M448 128l-96 0 0 384 96 0 0-384zM192 256l0 256 96 0 0-256-96 0zM32 384l0 128 96 0 0-128-96 0z"]
};
const faSignalAlt3 = faSignalBarsGood;
const faCactus = {
  prefix: 'fass',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M160 96c0-53 43-96 96-96s96 43 96 96l0 256 64 0 0-80 0-48 96 0 0 48 0 128 0 48-48 0-112 0 0 64-192 0 0-192L48 320 0 320l0-48L0 144 0 96l96 0 0 48 0 80 64 0 0-128zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faLightbulbGear = {
  prefix: 'fass',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M225.9 372.5l6.6 11.5L112 384c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c96.7 0 175.1 77.9 176 174.4l-28 0 0 44.6-37.1-21.4L225.9 330.9 262 351.7l-36.1 20.8zM112 416l139 0 21 36.3 0 59.7-160 0 0-96zm0-240c0-44.2 35.8-80 80-80l0-32C130.1 64 80 114.1 80 176l32 0zm260 30.4l88.1 0 0 42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8l0 42.4L372 497l0-42.2c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9l0-42.2zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
const faMaximize = {
  prefix: 'fass',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M32 192l32 32 52-52 84 84-84 84L64 288 32 320l0 160 160 0 32-32-52-52 84-84 84 84-52 52 32 32 160 0 0-160-32-32-52 52-84-84 84-84 52 52 32-32 0-160L320 32 288 64l52 52-84 84-84-84 52-52L192 32 32 32l0 160z"]
};
const faExpandArrowsAlt = faMaximize;
const faChargingStation = {
  prefix: 'fass',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M320 0L32 0l0 416 288 0 0-112 16 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-123.7c32.5-10.2 56-40.5 56-76.3l0-48-32 0 0-48 0-16-32 0 0 16 0 48-32 0 0-48 0-16-32 0 0 16 0 48-32 0 0 48c0 35.8 23.5 66.1 56 76.3L472 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-16 0L320 0zM208 96l-24 96 88 0L144 320l24-96-88 0L208 96zM352 448L0 448l0 64 352 0 0-64z"]
};
const faShapes = {
  prefix: 'fass',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M160 224l256 0L288 0 160 224zm128 48l0 224 224 0 0-224-224 0zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
const faTriangleCircleSquare = faShapes;
const faPlaneTail = {
  prefix: 'fass',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M512 256l0 256-256 0L0 416l0-96 64-16L0 0 144 0 384 256l128 0zM224 352l-24 0 0 48 24 0 128 0 24 0 0-48-24 0-128 0z"]
};
const faGaugeSimpleMax = {
  prefix: 'fass',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8L457 255.8 431.8 215l-20.4 12.6L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
const faTachometerFastest = faGaugeSimpleMax;
const faCircleU = {
  prefix: 'fass',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120 0-24 48 0 0 24z"]
};
const faShieldSlash = {
  prefix: 'fass',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L498.4 364.1c9.1-15.2 17-30.7 23.8-46.2c32.5-74.2 40.3-150.2 37.3-199.8l-1.2-20.6L539 90.2l-207.5-80L320 5.7l-11.5 4.4L130.7 78.7 48.4 14.8zM117.9 318c32.7 74.8 91.1 149.1 189.5 191.4l12.6 5.4 12.6-5.4c41.8-18 76.3-41.7 104.8-68.8L80.6 159.5C83 205.3 93.5 262.1 117.9 318z"]
};
const faSquarePhoneHangup = {
  prefix: 'fass',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M448 32L0 32 0 480l448 0 0-448zM346.7 320L272 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L101.3 320 64 262.8l10.7-10.4c82.5-80.5 216.2-80.5 298.7 0L384 262.8 346.7 320z"]
};
const faPhoneSquareDown = faSquarePhoneHangup;
const faArrowUpLeft = {
  prefix: 'fass',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M64 96L32 96l0 32 0 224 0 32 64 0 0-32 0-146.7L297.4 406.6 320 429.3 365.3 384l-22.6-22.6L141.3 160 288 160l32 0 0-64-32 0L64 96z"]
};
const faTransporter1 = {
  prefix: 'fass',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-15.4 0L180 140 103 236 83 261 133 301l20-25 31-38.7 0 50.7 144 0 0-50.7L359 276l20 25L429 261l-20-25L332 140l-9.6-12-15.4 0-102.2 0zM416 512l0-64L96 448l0 64 120 0 80 0 120 0zm48-384l-16 32-32 16 32 16 16 32 16-32 32-16-32-16-16-32zM64 352L48 320 32 352 0 368l32 16 16 32 16-32 32-16L64 352zm112-32l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z"]
};
const faPeanuts = {
  prefix: 'fass',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M297.4 102.4c5.4 12.2 8.5 24.9 9.4 37.5c-3.7 12.1-7.9 20.1-13.4 25.6c-10.6 10.6-27.1 16.9-50 21.5c-35.8 6.5-68.2 23.2-94.7 49.8C114.3 271.1 96 315.4 96 364l0 129.9L55.3 512 9.7 409.6C3.5 395.7 .4 381.2 0 366.9c-.4-14.3 2-28.9 7.4-43.1c5.5-14.2 13.5-26.7 23.4-37c5.4-5.7 11.4-10.8 18-15.3c15.4-10.9 30.1-23.9 36.8-41.5s4.6-37.1 .4-55.5c-1.9-7.8-2.9-15.7-3.1-23.5c-.4-14.2 2-28.7 7.3-42.9l.2-.4c5.4-14.1 13.4-26.5 23.3-36.9c9.8-10.4 21.9-19 35.7-25.2L251.9 0l45.6 102.4zM492 0L640 0l0 148c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.6 .6-1.1 1.1-1.7 1.7C353.1 495.8 316.5 512 276 512l-148 0 0-148c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C362.4 74 373 57.8 387.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0zm52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]
};
const faShuffle = {
  prefix: 'fass',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M512 128L416 32l-32 0 0 64-64 0-16 0-9.6 12.8L244 176l40 53.3L336 160l48 0 0 64 32 0 96-96zm0 256l-96-96-32 0 0 64-48 0L153.6 108.8 144 96l-16 0L32 96 0 96l0 64 32 0 80 0L294.4 403.2 304 416l16 0 64 0 0 64 32 0 96-96zM204 336l-40-53.3L112 352l-80 0L0 352l0 64 32 0 96 0 16 0 9.6-12.8L204 336z"]
};
const faRandom = faShuffle;
const faPersonRunning = {
  prefix: 'fass',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 96l-13.3 0-9.4 9.4-48 48L34.7 176 80 221.3l22.6-22.6L141.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L213.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L305 340.9 238 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L198.2 96 192 96l-64 0zM109.5 310.7L91.2 352 32 352 0 352l0 64 32 0 80 0 20.8 0 8.4-19L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9z"]
};
const faRunning = faPersonRunning;
const faMobileRetro = {
  prefix: 'fass',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M0 0L320 0l0 512L0 512 0 0zM64 128l0 128 192 0 0-128L64 128zM184 304l-48 0 0 48 48 0 0-48zm-48 80l0 48 48 0 0-48-48 0zm128 0l-48 0 0 48 48 0 0-48zM56 384l0 48 48 0 0-48-48 0zm208-80l-48 0 0 48 48 0 0-48zM56 304l0 48 48 0 0-48-48 0zM128 48l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z"]
};
const faGripLinesVertical = {
  prefix: 'fass',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M64 32L0 32 0 480l64 0L64 32zm128 0l-64 0 0 448 64 0 0-448z"]
};
const faBinBottlesRecycle = {
  prefix: 'fass',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M256 0L128 0l0 32-16 0 0 32 16 0 128 0 16 0 0-32-16 0 0-32zM32 144l0 48 320 0 0-48s0 0 0 0l-32.4-16.2L256 96 128 96 32 144zm543.6-8l0-41.9-64-30 0-64.1-128 0 0 64.1-61.8 29 44.5 22.3 17.7 8.8 0 19.8 0 48 191.6 0 0-56zM640 224L0 224l0 64 32 0L64 512l512 0 32-224 32 0 0-64zM304 288l32 0 8.6 0 4.7 7.2 26.3 40-27.1 17L327.4 320l-14.8 0-20.3 30.5-27.1-17 25.6-38.4 4.8-7.1 8.6 0zm89.3 73.9l19.3 29.3 2.6 4 0 4.8 0 32 0 16-16 0-61.5 0 0-32 45.5 0 0-11.2-17.1-25.9 27.1-17zM305.7 416l0 32L240 448l-16 0 0-16 0-32 0-4.8 2.7-4 20.6-31 27.1 17L256 404.8l0 11.2 49.7 0z"]
};
const faArrowUpFromSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M278.6 25.4L256 2.7 233.4 25.4l-96 96L114.7 144 160 189.3l22.6-22.6L224 125.3 224 320l0 32 64 0 0-32 0-194.7 41.4 41.4L352 189.3 397.3 144l-22.6-22.6-96-96zM32 32L0 32 0 64 0 480l0 32 32 0 448 0 32 0 0-32 0-416 0-32-32 0-64 0 0 64 32 0 0 352L64 448 64 96l32 0 0-64L32 32z"]
};
const faFileDashedLine = {
  prefix: 'fass',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M128 0L352 0l0 160 160 0 0 96-384 0L128 0zm0 368l384 0 0 144-384 0 0-144zM512 128l-128 0L384 0 512 128zM56 288l112 0 24 0 0 48-24 0L56 336l-24 0 0-48 24 0zm224 0l80 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm192 0l112 0 24 0 0 48-24 0-112 0-24 0 0-48 24 0z"]
};
const faPageBreak = faFileDashedLine;
const faBracketCurlyRight = {
  prefix: 'fass',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M160 32l32 0 0 32 0 114.7 54.6 54.6 9.4 9.4 0 26.5-9.4 9.4L192 333.3 192 448l0 32-32 0-96 0-32 0 0-64 32 0 64 0 0-96 0-13.3 9.4-9.4L178.7 256l-41.4-41.4-9.4-9.4 0-13.3 0-96L64 96 32 96l0-64 32 0 96 0z"]
};
const faSpider = {
  prefix: 'fass',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M0 139.9l0-21.2 39.2-13.1 7.6 22.8L67 189l84.2 28.1L79 145 67.7 133.6l6.2-14.8 40-96L123.1 .6l44.3 18.5-9.2 22.2-33.8 81.2L176 174.1l0-14.1c0-38.7 27.5-71 64-78.4l0 46.4 32 0 0-46.4c36.5 7.4 64 39.7 64 78.4l0 14.1 51.7-51.7L353.8 41.2l-9.2-22.2L388.9 .6l9.2 22.2 40 96 6.2 14.8L433 145l-72.1 72.1L445 189l20.2-60.6 7.6-22.8L512 118.7l0 21.2-1.2 3.7-24 72L483 227l-11.4 3.8L395.9 256l75.7 25.2L483 285l3.8 11.4 24 72 1.2 3.7 0 21.2-39.2 13.1-7.6-22.8L445 323l-84.2-28.1L433 367l11.4 11.4-6.2 14.8-40 96-9.2 22.2-44.3-18.5 9.2-22.2 33.8-81.2L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-35.7 35.7 33.8 81.2 9.2 22.2-44.3 18.5-9.2-22.2-40-96-6.2-14.8L79 367l72.1-72.1L67 323 46.8 383.6l-7.6 22.8L0 393.3l0-21.2 1.2-3.7 24-72L29 285l11.4-3.8L116.1 256 40.4 230.8 29 227l-3.8-11.4-24-72L0 139.9z"]
};
const faClockThree = {
  prefix: 'fass',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136 0 24 24 0 104 0 24 0 0-48-24 0-80 0 0-112 0-24-48 0 0 24z"]
};
const faHandsBound = {
  prefix: 'fass',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M96 32L96 0 32 0l0 32 0 32 0 32 0 80 0 16 0 32 0 11.8 7.7 9L131.6 352l-3.6 0-24 0 0 48 24 0 32 0 128 0 64 0 128 0 32 0 24 0 0-48-24 0-3.6 0 91.9-107.2 7.7-9 0-11.8 0-32 0-16 0-80 0-32 0-32 0-32L544 0l0 32 0 32 0 32 0 67.9-76.2 86.4L432.1 226l39.8-44.8 21.3-23.9-47.8-42.5-21.3 23.9-64 72-8.1 9.1 0 12.2 0 88 0 32-64 0 0-32 0-88 0-12.2-8.1-9.1-64-72-21.3-23.9-47.8 42.5 21.3 23.9L207.9 226l-35.7 24.2L96 163.9 96 96l0-32 0-32zm32 400l-24 0 0 48 24 0 32 0 0 32 128 0 0-32 64 0 0 32 128 0 0-32 32 0 24 0 0-48-24 0-32 0-128 0-64 0-128 0-32 0z"]
};
const faScalpelLineDashed = {
  prefix: 'fass',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M495.7 115.6L352 288l-192 0L396.2 22.2C408.8 8.1 426.8 0 445.8 0C482.3 0 512 29.7 512 66.2l0 4.2c0 16.5-5.8 32.5-16.3 45.1zM0 512L176 320l112 0C288 496 0 512 0 512zm240-32l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm128 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm128 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0z"]
};
const faScalpelPath = faScalpelLineDashed;
const faFileInvoiceDollar = {
  prefix: 'fass',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM64 64l16 0 64 0 16 0 0 32-16 0L80 96 64 96l0-32zm0 64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm144 96l0 16 0 9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.8c6.3 4.6 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9l0 8.9 0 16-32 0 0-16 0-9.6c-9.4-1.7-23.6-6.6-32.4-9.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.7-16.7-8.1-30.5-12.3l-2-.6c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4l0-9.3 0-16 32 0z"]
};
const faPipeSmoking = {
  prefix: 'fass',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M489.5 0l17.1 0L608 0l32 0 0 64-32 0-84.2 0L435 197.1l-15.5-10.4-24-16-13.7-9.1L480 14.2 489.5 0zM351.1 179.6l26.6 17.8 24 16 26.6 17.8-17.8 26.6L287.8 442.1C258.6 485.8 209.6 512 157.1 512C70.3 512 0 441.7 0 354.9L0 256l0-32 32 0 192 0 32 0 0 32 0 66.3 77.4-116.1 17.8-26.6z"]
};
const faFaceAstonished = {
  prefix: 'fass',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm141 .9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faWindow = {
  prefix: 'fass',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M512 32L0 32 0 480l512 0 0-448zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
const faPlaneCircleExclamation = {
  prefix: 'fass',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3 85.5 57C354.3 247.8 320 303.9 320 368c0 54.7 24.9 103.5 64 135.8l0 8.2L256 480 128 512l0-64 64-48 0-80L0 384l0-96L192 160l0-66.3zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faEar = {
  prefix: 'fass',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M384 192c0 71.2-38.7 133.3-96.3 166.5c.2 3.1 .3 6.3 .3 9.5c0 79.5-64.5 144-144 144S0 447.5 0 368L0 192C0 86 86 0 192 0S384 86 384 192zm-256 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8 0 24 48 0 0-24 0-8c0-61.9-50.1-112-112-112S80 130.1 80 192l0 40 0 14.8 13.3 6.6L128 270.8l0 5.9L88.6 309.6 70.2 324.9l30.7 36.9 18.4-15.4 48-40 8.6-7.2 0-11.2 0-32 0-14.8-13.3-6.6L128 217.2l0-25.2z"]
};
const faFileLock = {
  prefix: 'fass',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M0 0L224 0l0 160 160 0 0 33.6c-19.8 20.2-32 47.9-32 78.4l0 15.7-32 0L320 512 0 512 0 0zM384 128l-128 0L256 0 384 128zm80 112c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faDiagramVenn = {
  prefix: 'fass',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M256 412.8C216.4 372.4 192 317 192 256s24.4-116.4 64-156.8C245.7 97.1 235 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c11 0 21.7-1.1 32-3.2zm64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6zM370.7 192l-101.4 0c-6.5 14.9-10.8 31.1-12.5 48l126.4 0c-1.7-16.9-6-33.1-12.5-48zM269.3 320l101.4 0c6.5-14.9 10.8-31.1 12.5-48l-126.4 0c1.7 16.9 6 33.1 12.5 48zM288 352c9.1 12.1 19.9 22.9 32 32c12.1-9.1 22.9-19.9 32-32l-64 0zm64-192c-9.1-12.1-19.9-22.9-32-32c-12.1 9.1-22.9 19.9-32 32l64 0z"]
};
const faArrowDownFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-down-from-bracket',
  icon: [448, 512, [], "e667", "M246.6 486.6L224 509.3l-22.6-22.6-128-128L50.7 336 96 290.7l22.6 22.6L192 386.7 192 192l0-32 64 0 0 32 0 194.7 73.4-73.4L352 290.7 397.3 336l-22.6 22.6-128 128zM64 160l0 32L0 192l0-32L0 32 0 0 32 0 416 0l32 0 0 32 0 128 0 32-64 0 0-32 0-96L64 64l0 96z"]
};
const faXRay = {
  prefix: 'fass',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M0 32l32 0 448 0 32 0 0 64-32 0 0 320 32 0 0 64-32 0L32 480 0 480l0-64 32 0L32 96 0 96 0 32zM272 96l-32 0 0 16 0 32-80 0-16 0 0 32 16 0 80 0 0 48-112 0-16 0 0 32 16 0 112 0 0 70.6L181.3 304 128 304l0 57.6L170.7 416l170.7 0L384 361.6l0-57.6-53.3 0L272 326.6l0-70.6 112 0 16 0 0-32-16 0-112 0 0-48 80 0 16 0 0-32-16 0-80 0 0-32 0-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faGoalNet = {
  prefix: 'fass',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M32 32L0 32 0 64 0 448l0 32 64 0 0-32L64 96l512 0 0 352 0 32 64 0 0-32 0-384 0-32-32 0L32 32zm160 96l-32 0 0 64-64 0 0 32 64 0 0 64-64 0 0 32 64 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64zm64 256l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64z"]
};
const faCoffinCross = {
  prefix: 'fass',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M104 512L0 144 112 0 272 0 384 144 280 512l-176 0zM216 120l0-24-48 0 0 24 0 40-48 0-24 0 0 48 24 0 48 0 0 120 0 24 48 0 0-24 0-120 48 0 24 0 0-48-24 0-48 0 0-40z"]
};
const faOctopus = {
  prefix: 'fass',
  iconName: 'octopus',
  icon: [640, 512, [], "e688", "M207.8 359.6c-2.8 40.4-36.4 72.3-77.4 72.4l-.1 0c-36.7 0-68.3-25.6-76-61.5L47.5 339 .5 349l6.8 31.6c12.4 58 63.6 99.4 122.9 99.4c0 0 .1 0 .1 0c45 0 89-13.3 126.4-38.3L295.3 416l49.5 0 38.6 25.7c37.4 25 81.4 38.3 126.4 38.3c59.3 0 110.5-41.4 123-99.4l6.8-31.6L592.5 339l-6.8 31.6c-7.7 35.8-39.4 61.5-76 61.5c-41.1 0-74.8-31.9-77.6-72.4c11.3 7.3 24.5 11.9 38.9 13c38.8 2.8 74.3-21.9 85.3-59.2l10.9-36.9c6.4-21.6 26.2-36.5 48.8-36.5l24 0 0-48-24 0c-43.8 0-82.5 28.9-94.8 71l-10.9 36.9c-4.6 15.7-19.5 26-35.8 24.8c-20.5-1.5-35.3-20.3-31.7-40.6l19-109.3c1.5-8.4 2.2-17 2.2-25.6l0-5.2C464 64.5 399.5 0 320 0S176 64.5 176 144l0 5.2c0 8.6 .7 17.1 2.2 25.6l19 109.3c3.5 20.3-11.2 39.1-31.7 40.6c-16.3 1.2-31.2-9.2-35.8-24.8L118.8 263c-12.4-42.1-51-71-94.8-71L0 192l0 48 24 0c22.6 0 42.4 14.9 48.8 36.5l10.9 36.9c11 37.3 46.5 62 85.3 59.2c14.4-1 27.7-5.7 38.9-13zM240 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faSpellCheck = {
  prefix: 'fass',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M106.7 0L98.5 19.7 5.1 243.7 0 256l69.3 0 13.3-32 90.7 0 13.3 32 69.3 0-5.1-12.3-93.3-224L149.3 0 106.7 0zm2.7 160L128 115.2 146.7 160l-37.3 0zM288 0L256 0l0 32 0 96 0 96 0 32 32 0 80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0zm80 80c0 8.8-7.2 16-16 16l-32 0 0-32 32 0c8.8 0 16 7.2 16 16zM320 192l0-32 32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0zM550.6 294.6L573.3 272 528 226.7l-22.6 22.6L336 418.7l-73.4-73.4L240 322.7 194.7 368l22.6 22.6 96 96L336 509.3l22.6-22.6 192-192z"]
};
const faLocationXmark = {
  prefix: 'fass',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm97.9-384l-17 17-47 47 47 47 17 17L256 289.9l-17-17-47-47-47 47-17 17L94.1 256l17-17 47-47-47-47-17-17L128 94.1l17 17 47 47 47-47 17-17L289.9 128z"]
};
const faMapMarkerTimes = faLocationXmark;
const faMapMarkerXmark = faLocationXmark;
const faCircleQuarterStroke = {
  prefix: 'fass',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M64 256l192 0 0-192c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
const faLasso = {
  prefix: 'fass',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121l-71 0-32 0 0-64 32 0 71 0c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z"]
};
const faSlash = {
  prefix: 'fass',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z"]
};
const faPersonToPortal = {
  prefix: 'fass',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM114.7 96L128 96l64 0 6.2 0 5.7 2.3 80 32 11.3 4.5 5.4 10.9L339.8 224l12.8 0C357.5 97.7 391.2 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.8 0-74.5-97.7-79.4-224L320 288l-19.8 0-8.8-17.7-24.3-48.6L238 299 305 340.9l20.4 12.8-6.6 23.2-16 56-16 56L280.1 512l-66.6 0 11.7-40.8 16-56 9.4-32.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.3-94-27.7 0-38.6 38.6L80 221.3 34.7 176l22.6-22.6 48-48 9.4-9.4zM91.2 352l18.3-41.3c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6L141.2 397l-8.4 19L112 416l-80 0L0 416l0-64 32 0 59.2 0z"]
};
const faPortalEnter = faPersonToPortal;
const faCalendarStar = {
  prefix: 'fass',
  iconName: 'calendar-star',
  icon: [448, 512, [], "f736", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM253.6 303.2L224 232l-29.6 71.2-76.9 6.2 58.6 50.2-17.9 75L224 394.4l65.8 40.2-17.9-75 58.6-50.2-76.9-6.2z"]
};
const faComputerMouse = {
  prefix: 'fass',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M0 192l176 0L176 0 0 0 0 192zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32L384 0 208 0l0 192 176 0z"]
};
const faMouse = faComputerMouse;
const faArrowRightToBracket = {
  prefix: 'fass',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M352 96l96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0 0 64 32 0zm-9.4 182.6L365.3 256l-22.6-22.6-128-128L192 82.7 146.7 128l22.6 22.6L242.7 224 32 224 0 224l0 64 32 0 210.7 0-73.4 73.4L146.7 384 192 429.3l22.6-22.6 128-128z"]
};
const faSignIn = faArrowRightToBracket;
const faPegasus = {
  prefix: 'fass',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128L160 32s-20.2 141.7 68.1 199.7c-8.7-2.7-16.7-6.1-24.2-10.1c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43c-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faFilesMedical = {
  prefix: 'fass',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M320 128l0-32 0-96L96 0l0 416 352 0 0-288-96 0-32 0zm96-64L384 32 352 0l0 45.3L352 64l0 32 32 0 18.7 0L448 96 416 64zM48 96L0 96l0 24L0 488l0 24 24 0 304 0 24 0 0-48-24 0L48 464l0-344 0-24zm192 64l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faCannon = {
  prefix: 'fass',
  iconName: 'cannon',
  icon: [640, 512, [], "e642", "M256.4 464.8c-56.1 28-121.7 16.1-164.4-25.1L42.9 464.2 0 378.3l49.1-24.5c-7.3-58.9 22.5-118.5 78.5-146.6C192 176 559 51.3 559 51.3l81 161.9s-51.5 35.2-117.2 79.5C497.4 251.5 451.9 224 400 224c-79.5 0-144 64.5-144 144c0 30.6 9.5 58.9 25.8 82.3c-10.5 6.4-19.2 11.3-25.4 14.5zM288 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm144 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faNfcLock = {
  prefix: 'fass',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M0 32l448 0 0 129.1c-24.9 3.6-47.2 15.3-64 32.5l0-81.6 0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 144 0 16-32 0 0 96L96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96l0 16 0 288 0 16 16 0 240 0 0 64L0 480 0 32zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faPersonSkiLift = {
  prefix: 'fass',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M256 198.3l-32 8.5L224 0l32 0 0 198.3zM64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm103.5 60.7l13.7 30.1 32.7 71.9 65.9-17.6L320 256l0 132.5 144-53.2 0-23.3 0-24 48 0 0 24 0 40c0 10-6.3 19-15.7 22.5l-344 127.1L129.8 510l-16.6-45 22.5-8.3L256 412.2l0-114.5-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3L96.9 210.3 83.8 182l27.9-13.8 26.1-12.9 29.6-14.7zm-121.8 49L125 355.6l68.7-18.7 23.2-6.3 12.6 46.3-23.2 6.3-88 24L99 412.4l-8.6-18.1-88-184L-8 188.7 35.3 168l10.4 21.7z"]
};
const faSkiLift = faPersonSkiLift;
const faSquare6 = {
  prefix: 'fass',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M0 32l448 0 0 448L0 480 0 32zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-49.2-37-89.8-84.7-95.3l44.4-48.4L294.6 128l-65.1 0-68.1 74.3c-21.4 23.4-33.3 54-33.3 85.7z"]
};
const faShopSlash = {
  prefix: 'fass',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M0 192l0-64 15.1-20.1L121.8 192 0 192zm276.6 0L320 225.7l0-1.7 64 0 0 51.4 128 99.4L512 224l64 0 0 200.4 44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L71.5 32.7 96 0 544 0l96 128 0 64-363.4 0zM320 384l0-35.9 64 50.4L384 512 64 512l0-128 0-160 64 0 0 160 192 0z"]
};
const faStoreAltSlash = faShopSlash;
const faWindTurbine = {
  prefix: 'fass',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M340.8 425L317.1 202.8 415.4 2 234.8 133.7l-223 15.2 204.4 90.6L340.8 425zM288 403.8l-64-95.2L224 464l-72 0-24 0 0 48 24 0 208 0 24 0 0-48-24 0-72 0 0-60.2zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSlidersSimple = {
  prefix: 'fass',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M64 384l64 0 0-64-64 0 0 64zm128 0l0 64-64 0-64 0L0 448l0-64 0-64 0-64 64 0 64 0 64 0 0 64 288 0 32 0 0 64-32 0-288 0zM32 192L0 192l0-64 32 0 288 0 0-64 64 0 64 0 64 0 0 64 0 64 0 64-64 0-64 0-64 0 0-64L32 192zm416 0l0-64-64 0 0 64 64 0z"]
};
const faGridRound = {
  prefix: 'fass',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160A64 64 0 1 1 0 256a64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96A64 64 0 1 1 160 96a64 64 0 1 1 128 0zM224 320a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
const faBadgeSheriff = {
  prefix: 'fass',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M272 48c0 14.8-6.7 28-17.2 36.8L289 143.5l65.9 .3c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L353.9 256l29.2 51.1c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-65.9 .3-34.2 58.7c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8L159 368.5l-65.9-.3C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L94.1 256 64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l65.9-.3 34.2-58.7C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 336l80-80-80-80-80 80 80 80z"]
};
const faServer = {
  prefix: 'fass',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M512 32L0 32 0 224l512 0 0-192zM344 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM512 288L0 288 0 480l512 0 0-192zM344 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faVirusCovidSlash = {
  prefix: 'fass',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M360 48l24 0 0-48L360 0 320 0 280 0 256 0l0 48 24 0 16 0 0 33.6c-38.3 5.2-72.7 22.8-99 48.5l-25.5-19.8 1.4-1.4 28.3-28.3 17-17L184.2 29.7l-17 17L139 75l-5.7 5.7L48.4 14.8 29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L472.4 344c11.2-19.3 18.8-41 21.9-64l33.6 0 0 16 0 24 48 0 0-24 0-40 0-40 0-24-48 0 0 24 0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3 17 17 33.9-33.9-17-17L501 75 472.7 46.7l-17-17L421.8 63.7l17 17L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6L344 48l16 0zm41.3 364.2L149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5L112 232l0-16 0-24-48 0 0 24 0 40 0 40 0 24 48 0 0-24 0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3l-23.8 23.8-11.3-11.3-17-17L93.7 391.8l17 17L139 437l28.3 28.3 17 17 33.9-33.9-17-17L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0-24 0 0 48 24 0 40 0 40 0 24 0 0-48-24 0-16 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2z"]
};
const faIntersection = {
  prefix: 'fass',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M64 480l0-32 0-224c0-70.7 57.3-128 128-128s128 57.3 128 128l0 224 0 32 64 0 0-32 0-224c0-106-86-192-192-192S0 118 0 224L0 448l0 32 64 0z"]
};
const faShopLock = {
  prefix: 'fass',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M0 192l449.6 0c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32l33.6 0 0-64L544 0 96 0 0 128l0 64zm384 32l-64 0 0 160-192 0 0-160-64 0 0 160 0 128 320 0 0-128 0-96.3 0-63.7zm144 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faFamily = {
  prefix: 'fass',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm48 48c0-5.5 .6-10.8 1.6-16L32 160 24 352l40 0 0 160 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48zM336 448l0 64 112 0 0-128 64 0L448 160l-113.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48l16 0 32 0 0 32 0 160 0 32-32 0zm48-320A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 192l0-160-160 0 0 160 32 0 0 96 96 0 0-96 32 0z"]
};
const faHourglassStart = {
  prefix: 'fass',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 0L32 0 352 0l32 0 0 64-32 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64 32 0 0 64-32 0L32 512 0 512l0-64 32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64L0 64 0 0zM96 397.3L96 448l192 0 0-50.7-96-96-96 96z"]
};
const faHourglass1 = faHourglassStart;
const faUserHairBuns = {
  prefix: 'fass',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l46.4 0 32-32 32 32 46.4 0c1 5.2 1.6 10.5 1.6 16zM40 192l65.3 0c19 46.9 65 80 118.7 80s99.7-33.1 118.7-80l65.3 0 0-128-73.1 0C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64L40 64l0 128zM448 512L384 320 64 320 0 512l448 0z"]
};
const faBlenderPhone = {
  prefix: 'fass',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M153.6 44.8l-25 89.6-58.9-6.7c-12.6 41.8-12.6 86.8 0 128.6l58.9-6.7 25 89.6L84.9 384 72.4 371.2c-96.6-99-96.6-259.4 0-358.4L84.9 0l68.7 44.8zM224 352L192 0 576 0 558.5 64 400 64l-16 0 0 32 16 0 149.8 0-17.5 64L400 160l-16 0 0 32 16 0 123.6 0-17.5 64L400 256l-16 0 0 32 16 0 97.5 0L480 352l-256 0zm320 32l0 128-384 0 0-128 384 0zM352 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faHourglassClock = {
  prefix: 'fass',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M32 0L0 0 0 64l32 0 0 64 0 13.3 9.4 9.4L146.7 256 41.4 361.4 32 370.7 32 384l0 64L0 448l0 64 32 0 298.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448l0-50.7 96-96 64 64c.4-26.2 6.5-51.1 17.2-73.3l-36-36L342.6 150.6l9.4-9.4 0-13.3 0-64 32 0 0-64L352 0 32 0zM288 64l0 50.7-96 96-96-96L96 64l192 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288l0 16 0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0z"]
};
const faPersonSeatReclined = {
  prefix: 'fass',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32l-41 0 9.9 39.8 25.9 103.8C178 332 203.6 352 233 352l7 0 89.9 0 37.5 99.3 10.7 28.3 28.8-9 48-15.1 30.5-9.6-19.1-61.1-30.5 9.6-19.2 6-34.7-91.7L374.1 288 352 288l-87 0-8-32 63 0 32 0 0-64-32 0-79 0-1.9-7.8L233 160l-25 0-32 0zm-80.5-5.9l-5.9-31.5L26.7 134.4l5.9 31.5 48 256L85.4 448l26.6 0 160 0 32 0 0-64-32 0-133.4 0L95.5 154.1z"]
};
const faPaperPlaneTop = {
  prefix: 'fass',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M83.4 226.6L304 256 83.4 285.4 0 480l64 0L512 256 64 32 0 32 83.4 226.6z"]
};
const faPaperPlaneAlt = faPaperPlaneTop;
const faSend = faPaperPlaneTop;
const faMessageArrowUp = {
  prefix: 'fass',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM280 296l0-110.1 31 31 17 17L361.9 200l-17-17-72-72-17-17-17 17-72 72-17 17L184 233.9l17-17 31-31L232 296l0 24 48 0 0-24z"]
};
const faCommentAltArrowUp = faMessageArrowUp;
const faLightbulbExclamation = {
  prefix: 'fass',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM112 416l0 96 160 0 0-96-160 0zM216 64l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM168 304l0-48 48 0 0 48-48 0z"]
};
const faLayerMinus = {
  prefix: 'fass',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M384 56l0 48 24 0 112 0 24 0 0-48-24 0L408 56l-24 0zM0 256L288 384 576 256 288 128 0 256zM288 419L104.6 337.5 0 384 288 512 576 384 471.4 337.5 288 419z"]
};
const faLayerGroupMinus = faLayerMinus;
const faChartPieSimpleCircleCurrency = {
  prefix: 'fass',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-5.4 0-10.7 .2-16 .6L272 240l103.2 0c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80L224 288l0-255.5C98.9 40.8 0 144.8 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-25.3 25.3-22.6-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L460.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L531.3 426z"]
};
const faCircleE = {
  prefix: 'fass',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24 24 0z"]
};
const faBuildingWheat = {
  prefix: 'fass',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M0 0L384 0l0 512-144 0 0-128-96 0 0 128L0 512 0 0zM128 224l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zM64 96l0 64 64 0 0-64L64 96zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm384 96l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm0 128c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zm0 112c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0 0 16zM512 496l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zm0-96l-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80l0 16zm0-128l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0c44.2 0 80 35.8 80 80zM552 32l0 24 0 104 0 24-48 0 0-24 0-104 0-24 48 0zm72 64l0 32 0 24-48 0 0-24 0-32 0-24 48 0 0 24zM480 72l0 24 0 32 0 24-48 0 0-24 0-32 0-24 48 0z"]
};
const faGaugeMax = {
  prefix: 'fass',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8l117.5-72.8L457 255.8 431.8 215l-20.4 12.6L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAltFastest = faGaugeMax;
const faPersonBreastfeeding = {
  prefix: 'fass',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M144 80a80 80 0 1 1 160 0A80 80 0 1 1 144 80zM269.2 443.8l23-32.9-52.8-8.8L192 354.7l0-66.7-24 0-40 0 0 53.3 0 26.7c0 .7 0 1.4 .1 2.1l69.2 34.3 43 21.3-42.6 86-43-21.3L26.7 427 0 413.8 0 384l0-16 0-16 9.6-12.8 96-128L120 192l24 0 176 0 26.2 0 14.2 22 72 112 17.4 27.1-18.5 26.4-56 80-27.5 39.3-78.6-55zM276 376a44 44 0 1 0 0-88 44 44 0 1 0 0 88z"]
};
const faApostrophe = {
  prefix: 'fass',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M72 352c66.3 0 120-53.7 120-120l0-8 0-96 0-96L0 32 0 224l128 0 0 8c0 30.9-25.1 56-56 56l-8 0-32 0 0 64 32 0 8 0z"]
};
const faFilePng = {
  prefix: 'fass',
  iconName: 'file-png',
  icon: [512, 512, [], "e666", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l4 0 10.6 0 4.1 9.7L352 430.6l0-62.6 0-16 32 0 0 16 0 128 0 16-16 0-5.6 0-10.6 0-4.1-9.7L320 437.1l0 58.9 0 16-32 0 0-16 0-128 0-16 16 0zm112 40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 16-32 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8-16 0 0-32 16 0 16 0 16 0 0 16 0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z"]
};
const faFireHydrant = {
  prefix: 'fass',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M224 32l0 4c45 11.6 80.4 47 92 92l12 0 24 0 0 48-24 0L56 176l-24 0 0-48 24 0 12 0c11.6-45 47-80.4 92-92l0-4 0-32 64 0 0 32zM32 464l24 0 8 0 0-64-48 0 0-128 48 0 0-64 256 0 0 64 48 0 0 128-48 0 0 64 8 0 24 0 0 48-24 0-8 0L64 512l-8 0-24 0 0-48zm160-64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faRightToBracket = {
  prefix: 'fass',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M192 96L352 256 192 416l-32 0 0-96L0 320 0 192l160 0 0-96 32 0zM352 416l96 0 0-320-96 0-32 0 0-64 32 0 128 0 32 0 0 32 0 384 0 32-32 0-128 0-32 0 0-64 32 0z"]
};
const faSignInAlt = faRightToBracket;
const faVideoPlus = {
  prefix: 'fass',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M0 64l384 0 0 384L0 448 0 64zm576 0l0 384L416 337.1l0-162.3L576 64zM216 184l0-24-48 0 0 24 0 48-48 0-24 0 0 48 24 0 48 0 0 48 0 24 48 0 0-24 0-48 48 0 24 0 0-48-24 0-48 0 0-48z"]
};
const faSquareRight = {
  prefix: 'fass',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M448 480l0-448L0 32 0 480l448 0zM224 384l0-80L96 304l0-96 128 0 0-80 16 0L368 256 240 384l-16 0z"]
};
const faArrowAltSquareRight = faSquareRight;
const faCommentSmile = {
  prefix: 'fass',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM168.4 254.1l-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z"]
};
const faVenus = {
  prefix: 'fass',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0-32 0 0 64 32 0 32 0 0 32 0 32 64 0 0-32 0-32 32 0 32 0 0-64-32 0-32 0 0-34.9z"]
};
const faPassport = {
  prefix: 'fass',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M0 0L448 0l0 512L0 512 0 0zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384l-16 0 0 32 16 0 224 0 16 0 0-32-16 0-224 0z"]
};
const faThumbtackSlash = {
  prefix: 'fass',
  iconName: 'thumbtack-slash',
  icon: [640, 512, ["thumb-tack-slash"], "e68f", "M482.7 352l29.3 0 0-32c0-22.5-23.7-76.5-82.1-106.7L418.5 64 448 64l32 0 0-64L448 0 192 0 160 0l0 64 32 0 29.5 0-6.2 80.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L482.7 352zm-157.8 0L175.8 234.5C142.2 263 128 299.1 128 320l0 32 196.9 0zM288 480l0 32 64 0 0-32 0-96-64 0 0 96z"]
};
const faThumbTackSlash = faThumbtackSlash;
const faInboxIn = {
  prefix: 'fass',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M288 32l0 178.7 41.4-41.4L352 146.7 397.3 192l-22.6 22.6-96 96L256 333.3l-22.6-22.6-96-96L114.7 192 160 146.7l22.6 22.6L224 210.7 224 32l0-32 64 0 0 32zM0 320l144 0 32 64 160 0 32-64 144 0 0 192L0 512 0 320z"]
};
const faInboxArrowDown = faInboxIn;
const faHeartPulse = {
  prefix: 'fass',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M64 288l80 0 16 0 6.2-14.8 18.7-44.9 49.3 109.5 20.7 46.1 22.6-45.2L320 253.7l10.5 21.1 6.6 13.3 14.8 0 96 0s0 0 0 0L256 480 64 288s0 0 0 0zM20.8 240C7.3 218.5 0 193.5 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 25.8-7.3 50.8-20.8 72.2l-124.4 0-25.4-50.7L320 146.3l-21.5 42.9-41.4 82.8L205.9 158.2l-22.7-50.5-21.3 51.1L128 240 20.8 240z"]
};
const faHeartbeat = faHeartPulse;
const faCircle8 = {
  prefix: 'fass',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm16 48l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0 16 0z"]
};
const faCloudsMoon = {
  prefix: 'fass',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M448 140C448 72.3 499 16.5 564.7 8.9C548.2 3.1 530.5 0 512 0C423.6 0 352 71.6 352 160c0 11.5 1.2 22.7 3.5 33.5c53.7 8.2 96.5 49.8 106.4 103c14.2 5.4 27.1 13.3 38.4 23.1c3.9 .3 7.8 .4 11.8 .4c51.2 0 96.7-24 126-61.4c-17.5 8.6-37.2 13.4-58 13.4c-72.9 0-132-59.1-132-132zM106.8 288.1c18-37.9 56.5-64.1 101.3-64.1c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72l0 72 72 0 34.8 0zM64 511.9l80 0 271.9 0 96 0 0-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9l0 80z"]
};
const faClockTenThirty = {
  prefix: 'fass',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136 0-12.8L269.3 236l-96-64-20-13.3-26.6 39.9 20 13.3L232 268.8 232 392l0 24 48 0 0-24z"]
};
const faPeopleCarryBox = {
  prefix: 'fass',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM80 128l-32 0 0 32 0 114.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 8 48 4 24 .5 2.7 64.9 0-2.2-13.3-4-24-8-48-8-48-1.7-10.1-7.3-7.3L144 306.7l0-65.1 21.4 32.1 3.7 5.5 5.6 3.6 49.6 32 7.9 5.1 9.4 0 14.4 0 0-32s0 0 0 0l0 32 127.8 0 .2 0 14.2 0 9.4 0 7.9-5.1 49.6-32 5.6-3.6 3.7-5.5 21.4-32.1 0 65.1-54.6 54.6-7.3 7.3-1.7 10.1-8 48-8 48-4 24L410 512l64.9 0 .5-2.7 4-24 8-48 6.3-37.9 56.8-56.7L573.1 320c12-12 18.7-28.3 18.7-45.3l0-114.7 0-32-32 0-48 0-17.1 0-9.5 14.3-60.3 90.5-8.9 5.7L416 128l-192 0 0 110.6-9.1-5.8-60.3-90.5L145.1 128 128 128l-48 0zM52.5 351L9.5 486.3 1.3 512l67.2 0 2-6.3 33-103.7L52.5 351zM463.8 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM587.3 351l-51 50.9 33 103.7 2 6.3 67.2 0-8.2-25.7L587.3 351z"]
};
const faPeopleCarry = faPeopleCarryBox;
const faFolderUser = {
  prefix: 'fass',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96l-160 0-24 64 208 0-24-64z"]
};
const faTrashCanXmark = {
  prefix: 'fass',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0 0 384L32 512l0-384zM321.9 256L288 222.1l-17 17-47 47-47-47-17-17L126.1 256l17 17 47 47-47 47-17 17L160 417.9l17-17 47-47 47 47 17 17L321.9 384l-17-17-47-47 47-47 17-17z"]
};
const faTemperatureHigh = {
  prefix: 'fass',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM81.8 317.8L96 300.2l0-22.7L96 64l96 0 0 213.5 0 22.7 14.2 17.6C217.4 331.5 224 348.9 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM256 0L192 0 96 0 32 0l0 64 0 213.5C12 302.2 0 333.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L256 64l0-64zM144 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112l0-16-32 0 0 16 0 210.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faMicrochip = {
  prefix: 'fass',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M176 24l0-24L128 0l0 24 0 40L64 64l0 64-40 0L0 128l0 48 24 0 40 0 0 56-40 0L0 232l0 48 24 0 40 0 0 56-40 0L0 336l0 48 24 0 40 0 0 64 64 0 0 40 0 24 48 0 0-24 0-40 56 0 0 40 0 24 48 0 0-24 0-40 56 0 0 40 0 24 48 0 0-24 0-40 64 0 0-64 40 0 24 0 0-48-24 0-40 0 0-56 40 0 24 0 0-48-24 0-40 0 0-56 40 0 24 0 0-48-24 0-40 0 0-64-64 0 0-40 0-24L336 0l0 24 0 40-56 0 0-40 0-24L232 0l0 24 0 40-56 0 0-40zM352 160l-192 0 0 192 192 0 0-192zM160 128l192 0 32 0 0 32 0 192 0 32-32 0-192 0-32 0 0-32 0-192 0-32 32 0z"]
};
const faLeftLongToLine = {
  prefix: 'fass',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 416l0 32 64 0 0-32L64 96l0-32L0 64 0 96 0 416zM288 96L128 256 288 416l32 0 0-96 320 0 0-128-320 0 0-96-32 0z"]
};
const faCrown = {
  prefix: 'fass',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L192 256 72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L96 480l384 0 55.3-304c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24L384 256 309 106z"]
};
const faWeightHanging = {
  prefix: 'fass',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32L88 128 0 512l512 0L424 128l-77.5 0z"]
};
const faXmarksLines = {
  prefix: 'fass',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M32 32L0 32 0 96l32 0 576 0 32 0 0-64-32 0L32 32zm0 384L0 416l0 64 32 0 576 0 32 0 0-64-32 0L32 416zM57 183l-17-17L6.1 200l17 17 39 39L23 295l-17 17L40 345.9l17-17 39-39 39 39 17 17L185.9 312l-17-17-39-39 39-39 17-17L152 166.1l-17 17-39 39L57 183zm224 0l-17-17L230.1 200l17 17 39 39-39 39-17 17L264 345.9l17-17 39-39 39 39 17 17L409.9 312l-17-17-39-39 39-39 17-17L376 166.1l-17 17-39 39-39-39zm224 0l-17-17L454.1 200l17 17 39 39-39 39-17 17L488 345.9l17-17 39-39 39 39 17 17L633.9 312l-17-17-39-39 39-39 17-17L600 166.1l-17 17-39 39-39-39z"]
};
const faFilePrescription = {
  prefix: 'fass',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM104 196l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31 14.7-13.5 27 29.5-14.7 13.5L270 379.7l31.7 29.7 14.6 13.7-27.4 29.2-14.6-13.7-33.9-31.8-34.9 32-14.7 13.5-27-29.5 14.7-13.5 32.6-29.9-64.8-60.8-2.8-2.6L124 316l0 44 0 20-40 0 0-20 0-64 0-80 0-20 20 0zm55.1 79.7l.3 .3 16.6 0c11 0 20-9 20-20s-9-20-20-20l-52 0 0 40 34.8 0 .3-.3z"]
};
const faTableCellsLock = {
  prefix: 'fass',
  iconName: 'table-cells-lock',
  icon: [640, 512, [], "e679", "M512 32L0 32 0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32zM152 96l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faCalendarRange = {
  prefix: 'fass',
  iconName: 'calendar-range',
  icon: [448, 512, [], "e0d6", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320zM128 256l0 64-64 0 0-64 64 0zM320 448l0-64 64 0 0 64-64 0zm64-184l0 48-192 0 0-48 192 0zM64 392l192 0 0 48L64 440l0-48z"]
};
const faFlowerDaffodil = {
  prefix: 'fass',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M288 281.3c9.8 4.3 20.6 6.7 32 6.7c44.2 0 80-35.8 80-80c0-26.2-12.6-49.4-32-64c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-44.2 0-80 35.8-80 80c0 26.2 12.6 49.4 32 64c-19.4 14.6-32 37.8-32 64c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7l0 113.4C192.1 349.5 139.5 320 80 320L0 320l0 16c0 97.2 78.8 176 176 176l48 0 32 0 32 0 48 0c97.2 0 176-78.8 176-176l0-16-80 0c-59.5 0-112.1 29.5-144 74.8l0-113.4zM200 144l56-56 56 56-56 56-56-56z"]
};
const faHandBackPointUp = {
  prefix: 'fass',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M176 0L96 0l0 224 0 13.3 0 2.7 0 80 0 16-32 0 0-16 0-56L16 304l0 68c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L288 512c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0 0-32-80 0L176 0z"]
};
const faWeightScale = {
  prefix: 'fass',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L0 64 0 512l512 0 0-448L391.8 64zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3 6.3-14.7L295.6 91l-6.3 14.7L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
const faWeight = faWeightScale;
const faArrowUpToArc = {
  prefix: 'fass',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 64c106 0 192 86 192 192l64 0C512 114.6 397.4 0 256 0S0 114.6 0 256l64 0C64 150 150 64 256 64zM390.6 281.4l-112-112L256 146.7l-22.6 22.6-112 112L98.7 304 144 349.3l22.6-22.6L224 269.3 224 480l0 32 64 0 0-32 0-210.7 57.4 57.4L368 349.3 413.3 304l-22.6-22.6z"]
};
const faStarExclamation = {
  prefix: 'fass',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M374.6 164L288.1 0 201.5 164 18.9 195.6 148.1 328.5 121.7 512l166.4-81.8L454.4 512 428 328.5 557.2 195.6 374.6 164zM312 160l0 24 0 80 0 24-48 0 0-24 0-80 0-24 48 0zM264 320l48 0 0 48-48 0 0-48z"]
};
const faBooks = {
  prefix: 'fass',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M355.4 398.3L320 268.3l0-125.5 93.7-25.1 67.2 247L355.4 398.3zM405.3 86.8L320 109.6l0-93.4L381.7 0l23.6 86.8zM363.8 429.2l125.5-33.6L512 478.9 386.3 512l-22.5-82.8zM0 0L128 0l0 96L0 96 0 0zM0 128l128 0 0 256L0 384 0 128zM0 416l128 0 0 96L0 512l0-96zM160 0L288 0l0 96L160 96l0-96zm0 128l128 0 0 256-128 0 0-256zm0 288l128 0 0 96-128 0 0-96z"]
};
const faUserGroup = {
  prefix: 'fass',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zM640 512l-158.5 0-2.9-9.4L422.4 320 576 320l64 192zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
};
const faUserFriends = faUserGroup;
const faArrowUpAZ = {
  prefix: 'fass',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M395.5 32l-8.6 18.7-88 192L292.8 256l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 32l-41.1 0zm4.4 144L416 140.8 432.1 176l-32.3 0zM183.6 58.4L160 32.6 136.4 58.4l-88 96L26.8 178 74 221.2l21.6-23.6L128 162.3 128 448l0 32 64 0 0-32 0-285.7 32.4 35.4L246 221.2 293.2 178l-21.6-23.6-88-96zM352 288l-32 0 0 64 32 0 52 0-73 63.9L320 425.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9 10.9-9.6 0-14.5 0-8 0-32-32 0-128 0z"]
};
const faSortAlphaUp = faArrowUpAZ;
const faLayerPlus = {
  prefix: 'fass',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M488 24l0-24L440 0l0 24 0 32-32 0-24 0 0 48 24 0 32 0 0 32 0 24 48 0 0-24 0-32 32 0 24 0 0-48-24 0-32 0 0-32zM0 256L288 384 576 256 288 128 0 256zM288 419L104.6 337.5 0 384 288 512 576 384 471.4 337.5 288 419z"]
};
const faLayerGroupPlus = faLayerPlus;
const faPlayPause = {
  prefix: 'fass',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M320 256L64 448 64 64 320 256zM448 96l0 320 0 32-64 0 0-32 0-320 0-32 64 0 0 32zm128 0l0 320 0 32-64 0 0-32 0-320 0-32 64 0 0 32z"]
};
const faBlockQuestion = {
  prefix: 'fass',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", "M448 32L0 32 0 480l448 0 0-448zM72 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM72 384a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 200c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 280.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L192 192c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48z"]
};
const faSnooze = {
  prefix: 'fass',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M192 0L160 0l0 64 32 0 33.3 0-57.6 67.2-7.7 9 0 11.8 0 8 0 32 32 0 96 0 32 0 0-64-32 0-33.3 0 57.6-67.2 7.7-9L320 40l0-8 0-32L288 0 192 0zM320 224l-32 0 0 64 32 0 33.3 0-57.6 67.2-7.7 9 0 11.8 0 8 0 32 32 0 96 0 32 0 0-64-32 0-33.3 0 57.6-67.2 7.7-9 0-11.8 0-8 0-32-32 0-96 0zM32 256L0 256l0 64 32 0 98.7 0L9.4 441.4 0 450.7 0 464l0 16 0 32 32 0 160 0 32 0 0-64-32 0-98.7 0L214.6 326.6l9.4-9.4 0-13.3 0-16 0-32-32 0L32 256z"]
};
const faZzz = faSnooze;
const faScannerImage = {
  prefix: 'fass',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M78.5 46.7L50 32.2 21 89.2l28.5 14.5L410.8 288 32 288 0 288l0 32L0 448l0 32 32 0 512 0 32 0 0-32 0-128 0-19.6-17.5-8.9L78.5 46.7zM64 352l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
const faTvRetro = {
  prefix: 'fass',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M185 23l-17-17L134.1 40l17 17 39 39L0 96 0 512l512 0 0-416L321.9 96l39-39 17-17L344 6.1 327 23l-71 71L185 23zM424 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 160l320 0 0 288L64 448l0-288z"]
};
const faSquareT = {
  prefix: 'fass',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M448 32L0 32 0 480l448 0 0-448zM120 144l104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48 24 0z"]
};
const faFarm = {
  prefix: 'fass',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M0 96C0 43 43 0 96 0s96 43 96 96L0 96zm0 32l181.4 0-51 123.8-2.4 5.9 0 6.3 0 248L0 512 0 128zM160 512l0-248 56-136L368 64l152 64 56 136 0 248-144 0 0-112-128 0 0 112-144 0zM416 224l-96 0 0 96 96 0 0-96z"]
};
const faBarnSilo = faFarm;
const faChessKnight = {
  prefix: 'fass',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M96 48L64 80l0 160 48 40 112-72 0 40L64 352l0 48 320 0 28.7-157.8c2.2-12.1 3.3-24.4 3.3-36.8C416 92 324 0 210.5 0L64 0l0 32L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM16 512l416 0 0-32-48-48L64 432 16 480l0 32z"]
};
const faBarsSort = {
  prefix: 'fass',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 64l448 0 0 64L0 128 0 64zM0 224l320 0 0 64L0 288l0-64zM192 384l0 64L0 448l0-64 192 0z"]
};
const faPalletBoxes = {
  prefix: 'fass',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M64 0L320 0l0 256L64 256 64 0zM384 64l192 0 0 192-192 0 0-192zM0 320l32 0 32 0 32 0 32 0 160 0 32 0 32 0 160 0 32 0 32 0 32 0 32 0 0 64-32 0-32 0 0 64 32 0 32 0 0 64-32 0-32 0-32 0-32 0-160 0-32 0-32 0-160 0-32 0-32 0-32 0L0 512l0-64 32 0 32 0 0-64-32 0L0 384l0-64zM128 448l160 0 0-64-160 0 0 64zm224 0l160 0 0-64-160 0 0 64z"]
};
const faPaletteBoxes = faPalletBoxes;
const faPalletAlt = faPalletBoxes;
const faFaceLaughSquint = {
  prefix: 'fass',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM112 112l118.9 64L112 240l45.7-64L112 112zm169.1 64L400 112l-45.7 64L400 240 281.1 176z"]
};
const faLaughSquint = faFaceLaughSquint;
const faCodeSimple = {
  prefix: 'fass',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M199.9 133.3L90.8 256 199.9 378.7l21.3 23.9-47.8 42.5-21.3-23.9-128-144L5.2 256l18.9-21.3 128-144 21.3-23.9 47.8 42.5-21.3 23.9zm176.2 0l-21.3-23.9 47.8-42.5 21.3 23.9 128 144L570.8 256l-18.9 21.3-128 144-21.3 23.9-47.8-42.5 21.3-23.9L485.2 256 376.1 133.3z"]
};
const faBoltSlash = {
  prefix: 'fass',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M433.4 313.7L528 224 356.7 197.6 416 0 241.8 165 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L433.4 313.7zM112 288l163.6 25.2L171.8 231.4 112 288zm250 93.2l-79.9-63L224 512 362 381.2z"]
};
const faPanelFire = {
  prefix: 'fass',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M0 32l448 0 0 90.1-17 10.6c-13.3 8.3-29.9 20.6-47 36.1L384 96 64 96l0 128 270.1 0c-15.2 21-28.8 45.2-37.2 72L264 296l0 48 24.2 0c-.1 2.6-.2 5.2-.2 7.8c0 49.2 18.5 94.2 49 128.2L0 480 0 32zM168 296l0 48 48 0 0-48-48 0zm-96 0l0 48 48 0 0-48-48 0zM448 160l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faBinaryCircleCheck = {
  prefix: 'fass',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M224 0l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-96-16 0-32 0 0-64zM0 288l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0L0 512l0-64 32 0 16 0 0-96-16 0L0 352l0-64zM32 0L160 0l32 0 0 32 0 160 0 32-32 0L32 224 0 224l0-32L0 32 0 0 32 0zM64 160l64 0 0-96L64 64l0 96zM192 288l32 0 115.2 0c-12.3 24-19.2 51.2-19.2 80l0-16-64 0 0 96 32 0 32 0 19.2 0c11 21.5 26.3 40.5 44.8 55.8l0 8.2-32 0-128 0-32 0 0-32 0-160 0-32zm128 80c0 5.4 .2 10.7 .7 16l-.7 0 0-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z"]
};
const faCommentMinus = {
  prefix: 'fass',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM184 216l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faBurrito = {
  prefix: 'fass',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M251.4 52.6L4.6 299.4C34.3 322.4 71.6 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c53.6 0 102.5 20.3 139.4 53.6c12.8-14.2 20.6-33 20.6-53.6c0-11.4-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32c0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7C342.2 2.4 331.4 0 320 0c-20.6 0-39.4 7.8-53.6 20.6zm193 240C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-41.2 0-79.7-12-112-32.7L0 400 112 512l96 0L459.4 260.6z"]
};
const faViolin = {
  prefix: 'fass',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM333.8 52.2l17-17L316.8 1.3l-17 17L18.2 299.8l-17 17 33.9 33.9 17-17L333.8 52.2zM472 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM614.6 70.6L637.3 48 592 2.7 569.4 25.4 417 177.7C398 166.5 375.7 160 352 160c-25.4 0-49.1 7.4-69 20.2c3.2 8.7 5 18.1 5 27.8c0 44.2-35.8 80-80 80c-16.7 0-32.3-5.1-45.1-13.9c-21.7 25.2-34.9 58-34.9 93.9c0 17 2.9 33.2 8.3 48.4L188 375l22.4-17.9 20.3 20.3 32 32 20.3 20.3L265 452l-41.4 51.7c15.1 5.4 31.4 8.3 48.4 8.3c35.9 0 68.7-13.1 93.9-34.9C357.1 464.3 352 448.7 352 432c0-44.2 35.8-80 80-80c9.8 0 19.2 1.8 27.8 5c12.8-19.9 20.2-43.6 20.2-69c0-23.7-6.5-46-17.7-65L614.6 70.6zM208 400s0 0 0 0l-80 64 48 48 18.2-22.8s0 0 0 0l1.9-2.4L240 432l-32-32s0 0 0 0z"]
};
const faObjectsColumn = {
  prefix: 'fass',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M192 32L0 32 0 288l192 0 0-256zM448 224l-192 0 0 256 192 0 0-256zM0 352L0 480l192 0 0-128L0 352zM448 32L256 32l0 128 192 0 0-128z"]
};
const faSquareChevronDown = {
  prefix: 'fass',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M0 480l448 0 0-448L0 32 0 480zM207 345L103 241l-17-17L120 190.1l17 17 87 87 87-87 17-17L361.9 224l-17 17L241 345l-17 17-17-17z"]
};
const faChevronSquareDown = faSquareChevronDown;
const faCommentPlus = {
  prefix: 'fass',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM232 352l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faTriangleInstrument = {
  prefix: 'fass',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M320 32l0-32L256 0l0 32 0 53.3-5.3 8.9L38.4 448 0 512l74.6 0 426.7 0 74.6 0-38.4-64L437.7 281.5 391 328.1 463 448 113 448 288 156.4l60.6 101-41.8 41.8c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l33.3-33.3 46.6-46.6L537 137l17-17L520 86.1l-17 17L395.3 210.8l-70-116.6L320 85.3 320 32z"]
};
const faTriangleMusic = faTriangleInstrument;
const faWheelchair = {
  prefix: 'fass',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 352c0 61.9 50.1 112 112 112c49.9 0 92.3-32.7 106.7-77.8l45.7 14.6C291.8 465.3 231.4 512 160 512C71.6 512 0 440.4 0 352c0-78.3 56.3-143.5 130.6-157.3l8.8 47.2C87.4 251.5 48 297.2 48 352zM153 128l39 0 32 0 26.2 0 5.1 25.7 4.5 22.3 76.2 0 32 0 0 64-32 0-63.4 0 9.6 48L384 288l22.2 0 7.8 20.8 37.1 99 10.7-3.6 30.3-10.2 20.5 60.6-30.3 10.2-40 13.5-29.3 9.9-10.9-29L361.8 352l-105.2 0c-.4 0-.8 0-1.3 0L224 352l-26.2 0-5.1-25.7-32-160L153 128z"]
};
const faUserPilotTie = {
  prefix: 'fass',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M80 99.2L80 128c16 10.7 67.2 32 144 32s128-21.3 144-32l0-28.8L400 80l0-32L224 0 48 48l0 32L80 99.2zm88.8-40.7l14.3 7.2L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zM448 512L400 352l-80 0L252.2 464.9 240 416l32-64-96 0 32 64-12.2 48.9L128 352l-80 0L0 512l192 0 64 0 192 0zM320 416l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32z"]
};
const faPianoKeyboard = {
  prefix: 'fass',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M576 64L0 64 0 448l576 0 0-384zM512 224l0 160-80 0 0-64 16 0 0-32 0-64 64 0zM400 384l-96 0 0-64 16 0 0-32 0-64 64 0 0 64 0 32 16 0 0 64zm-128 0l-96 0 0-64 16 0 0-32 0-64 64 0 0 64 0 32 16 0 0 64zm-128 0l-80 0 0-160 64 0 0 64 0 32 16 0 0 64z"]
};
const faBedEmpty = {
  prefix: 'fass',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M64 64l0-32L0 32 0 64 0 256l0 96 0 32 0 64 0 32 64 0 0-32 0-32 288 0 224 0 0 32 0 32 64 0 0-32 0-192 0-32-32 0L64 224 64 64z"]
};
const faCircleArrowUp = {
  prefix: 'fass',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-409L385 215l17 17L368 265.9l-17-17-71-71L280 392l0 24-48 0 0-24 0-214.1-71 71-17 17L110.1 232l17-17L239 103l17-17 17 17z"]
};
const faArrowCircleUp = faCircleArrowUp;
const faToggleOn = {
  prefix: 'fass',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M576 64L0 64 0 448l576 0 0-384zm-96 96l0 192-192 0 0-192 192 0z"]
};
const faRectangleVertical = {
  prefix: 'fass',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M384 0l0 512L0 512 0 0 384 0z"]
};
const faRectanglePortrait = faRectangleVertical;
const faPersonWalking = {
  prefix: 'fass',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M256 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.3 128.6l-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48L7.5 260.2l60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16zM68.7 398L25.4 441.4 2.7 464 48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398z"]
};
const faWalking = faPersonWalking;
const faL = {
  prefix: 'fass',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M96 32l0 32 0 352 192 0 32 0 0 64-32 0L64 480l-32 0 0-32L32 64l0-32 64 0z"]
};
const faSignalStream = {
  prefix: 'fass',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M200.1 186.6l-50.2-39.7C126.2 176.9 112 214.8 112 256s14.2 79.1 37.9 109.1l50.2-39.7C185 306.3 176 282.2 176 256s9-50.3 24.1-69.4zm-87.9-69.4L61.9 77.5C23.2 126.6 0 188.6 0 256s23.2 129.4 61.9 178.5l50.2-39.7C82 356.6 64 308.5 64 256s18-100.6 48.2-138.8zM375.9 325.4l50.2 39.7c23.7-30 37.9-67.9 37.9-109.1s-14.2-79.1-37.9-109.1l-50.2 39.7C391 205.7 400 229.8 400 256s-9 50.3-24.1 69.4zm87.9 69.4l50.2 39.7C552.8 385.4 576 323.4 576 256s-23.2-129.4-61.9-178.5l-50.2 39.7C494 155.4 512 203.5 512 256s-18 100.6-48.2 138.8zM288 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
const faDownToBracket = {
  prefix: 'fass',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M384 192L224 352 64 192l0-32 96 0L160 0 288 0l0 160 96 0 0 32zM64 352l0 96 320 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 352l0-32 64 0 0 32z"]
};
const faCircleZ = {
  prefix: 'fass',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-352.5l-4.3 6.2L229.8 336l98.2 0 24 0 0 48-24 0-144 0-24 0 0-31.5 4.3-6.2L282.2 176 184 176l-24 0 0-48 24 0 144 0 24 0 0 31.5z"]
};
const faStars = {
  prefix: 'fass',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M356 60L336 0 316 60 256 80l60 20 20 60 20-60 60-20L356 60zM464 208l-16-48-16 48-48 16 48 16 16 48 16-48 48-16-48-16zM253.3 265.1L193.5 144 133.7 265.1 0 284.6l96.7 94.3L73.9 512l119.6-62.9L313 512 290.2 378.9l96.7-94.3L253.3 265.1z"]
};
const faFire = {
  prefix: 'fass',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M0 276.5C0 144 176 0 176 0s64.5 59.3 88.6 89.4c11-14.4 47.4-42.9 47.4-42.9s136 113.4 136 229.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-2.8-5.6-5.6-11.2-9.8-16.8l-50.6 58.8s-81.4-103.6-87.1-110.6C133.1 243.8 112 273.2 112 306.8C112 375.4 162.6 416 225.7 416z"]
};
const faBedPulse = {
  prefix: 'fass',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M472 0l16 0 14.8 0 6.6 13.3L534.8 64 616 64l24 0 0 48-24 0-96 0-14.8 0-6.6-13.3L480.4 62.5 429.7 170.2 423.2 184 408 184l-16 0-15.6 0-6.3-14.3L344.4 112 216 112l-24 0 0-48 24 0 144 0 15.6 0 6.3 14.3 18.5 41.5 49.9-106L456.8 0 472 0zM320 160l10.7 0 10.1 22.7L355.6 216l36.4 0 16 0 35.5 0 15.1-32.2L469.9 160l74.1 0c53 0 96 43 96 96l0 224 0 32-64 0 0-32 0-32-224 0-32 0L64 448l0 32 0 32L0 512l0-32L0 96 0 64l64 0 0 32 0 256 224 0 0-160 0-32 32 0zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faProcedures = faBedPulse;
const faHouseDay = {
  prefix: 'fass',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M160 0L119.6 62.4 46.9 46.9l15.6 72.7L0 160l62.4 40.4L46.9 273.1l72.7-15.6 16.2 25.1 3.2-2.8 52.1-45.1c-9.6 4-20.1 6.3-31.1 6.3c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 15.1-4.2 29.3-11.5 41.3l67-58.1-38-24.6 15.6-72.7L200.4 62.4 160 0zm48 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 96L160 304l0 48 64 0 0 160 352 0 0-160 64 0 0-48L400 96zM352 288l96 0 0 96-96 0 0-96z"]
};
const faShuttleSpace = {
  prefix: 'fass',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M192 480l-64 0 0-96 224 0L192 480zM96 380.8l0 3.2 0 96-64 0 0-96-8 0L0 384l0-24 0-32L0 184l0-32 0-24 24 0 8 0 0-96 64 0 0 96 0 3.2L150.7 160 456 160c70.4 0 127.6 23.5 171.2 81.6L638 256l-10.8 14.4C583.6 328.5 526.4 352 456 352l-305.3 0L96 380.8zM128 128l0-96 64 0 160 96-224 0zM512 248c0-22.1-17.9-40-40-40l0 96c22.1 0 40-17.9 40-40l0-16z"]
};
const faSpaceShuttle = faShuttleSpace;
const faShirtLongSleeve = {
  prefix: 'fass',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M136 0L107.6 0 93.9 24.9l-88 160L0 195.7 0 208 0 368l0 48 96 0 0-48 0-147.7 48-87.3L144 512l352 0 0-378.9 48 87.3L544 368l0 48 96 0 0-48 0-160 0-12.3-5.9-10.8-88-160L532.4 0 504 0l-8 0L460 0 416 0c0 53-43 96-96 96s-96-43-96-96L180 0 144 0l-8 0z"]
};
const faChartPieSimple = {
  prefix: 'fass',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M511.4 240L272 240 272 .6c5.3-.4 10.6-.6 16-.6C411.7 0 512 100.3 512 224c0 5.4-.2 10.7-.6 16zM0 272C0 144.8 98.9 40.8 224 32.5L224 288l255.5 0C471.2 413.1 367.2 512 240 512C107.5 512 0 404.6 0 272z"]
};
const faChartPieAlt = faChartPieSimple;
const faFaceLaugh = {
  prefix: 'fass',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faLaugh = faFaceLaugh;
const faFolderOpen = {
  prefix: 'fass',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M99.4 209.7L0 408.4 0 32l208 0 64 64 208 0 0 96-352 0-19.8 0-8.8 17.7zM0 480L128 224l448 0L448 480 0 480z"]
};
const faAlbumCollectionCircleUser = {
  prefix: 'fass',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M32 0L56 0 456 0l24 0 0 48-24 0L56 48 32 48 32 0zm8 512L0 160l512 0-3.7 32.4c-4.1-.3-8.2-.4-12.3-.4c-46.9 0-89.5 18.3-121 48.2C342.9 220.1 301.4 208 256 208C154.4 208 72 268.9 72 344s82.4 136 184 136c33.2 0 64.4-6.5 91.3-17.9c12.4 19.6 28.6 36.6 47.5 49.9L40 512zM256 376c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM40 80l432 0 24 0 0 48-24 0L40 128l-24 0 0-48 24 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L552 416l-112 0-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faCandy = {
  prefix: 'fass',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.1-28.5 52.6-47.3L318.1 64zM492.3 340.8c4.6-9.3 8.4-19 11.5-29.1l101 53.5L633 327l-35.6-35.6L640 279l0-46-42.6-12.5L633 185l-28.2-38.2-101 53.5c-20.5-67.8-77.6-119.8-148.3-133L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2c-4.6 9.3-8.4 19-11.5 29.1l-101-53.5L7 185l35.6 35.6L0 233l0 46 42.6 12.5L7 327l28.2 38.2 101-53.5c20.5 67.8 77.6 119.8 148.3 133z"]
};
const faBowlHot = {
  prefix: 'fass',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M176 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C218.8 99 240 122.9 240 168l0 24-48 0 0-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C149.2 93 128 69.1 128 24l0-24 48 0 0 24zm128 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C346.8 99 368 122.9 368 168l0 24-48 0 0-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C277.2 93 256 69.1 256 24l0-24 48 0 0 24zM3.6 285.2L0 224l512 0-3.6 61.2C503.5 368.1 454 438.2 384 472.9l0 39.1-256 0 0-39.1C58 438.2 8.5 368.1 3.6 285.2z"]
};
const faSoup = faBowlHot;
const faFlatbread = {
  prefix: 'fass',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.3 363.3l-22.6-22.6 192-192 22.6 22.6-192 192zm80-240l-128 128-22.6-22.6 128-128 22.6 22.6zm32 288l-22.6-22.6 128-128 22.6 22.6-128 128z"]
};
const faHeartCirclePlus = {
  prefix: 'fass',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faCodeFork = {
  prefix: 'fass',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 48 0 0 32c0 53 43 96 96 96l48 0 0 64-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-64 48 0c53 0 96-43 96-96l0-32 48 0 0-56 0-48 0-56L392 0 344 0 288 0l0 56 0 48 0 56 48 0 0 32c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-32 48 0 0-56 0-48 0-56L104 0 56 0zM392 56l0 48-48 0 0-48 48 0zM200 408l48 0 0 48-48 0 0-48z"]
};
const faCity = {
  prefix: 'fass',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M480 0L288 0l0 96-64 0 0-72 0-24L176 0l0 24 0 72-64 0 0-72 0-24L64 0l0 24 0 72L0 96l0 96L0 512l288 0 64 0 128 0 160 0 0-320-160 0L480 0zm96 352l0 64-64 0 0-64 64 0zm-384 0l64 0 0 64-64 0 0-64zm-64 64l-64 0 0-64 64 0 0 64zM512 256l64 0 0 64-64 0 0-64zM64 160l64 0 0 64-64 0 0-64zm192 96l0 64-64 0 0-64 64 0zm0-96l0 64-64 0 0-64 64 0zM64 320l0-64 64 0 0 64-64 0zm352-64l0 64-64 0 0-64 64 0zM352 64l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z"]
};
const faSignalBarsWeak = {
  prefix: 'fass',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M32 384h96V512H32V384z"]
};
const faSignalAlt1 = faSignalBarsWeak;
const faMicrophoneLines = {
  prefix: 'fass',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M96 0l0 256c0 53 43 96 96 96s96-43 96-96l-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-96L96 0zM320 224l0 32c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40 0-24-48 0 0 24 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40 0-24-48 0 0 24 0 8z"]
};
const faMicrophoneAlt = faMicrophoneLines;
const faClockTwelve = {
  prefix: 'fass',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136 0 24-48 0 0-24 0-136 0-24 48 0 0 24z"]
};
const faPepperHot = {
  prefix: 'fass',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M423.9 44.4L419 35.7l42-23.3 4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 33.1-10.1 63.9-27.3 89.4L448 256l-112 0L320 144l-88-9.8C261.3 101 304.2 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8zM171.2 345.5L262 163.9l29.4 6.5 12.9 90.1 3.9 27.5 27.8 0 92.2 0 23.9 47.8C372.3 443.9 244.3 512 103.2 512L0 512l0-80 84.5-18.8c37.6-8.4 69.5-33.2 86.7-67.7z"]
};
const faCitrusSlice = {
  prefix: 'fass',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M391.4 391.4C294.5 488.2 137.9 487.9 41 391L7 425c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7L391 41c96.9 96.9 97.1 253.6 .3 350.4zM176 428.3L176 254c-7.1-1.8-13.7-4.9-19.7-8.8L48 353.5l15.3 15.3c32 32 71.4 51.8 112.7 59.5zm69.1-272c4 5.9 7 12.6 8.8 19.7l174.3 0c-7.7-41.2-27.4-80.5-59.2-112.4L353.5 48 245.1 156.3zM254 208c-1.5 5.9-3.8 11.4-6.8 16.5L379.6 357c36.8-42.6 54.2-96.1 52.2-149L254 208zm-29.5 39.1c-5.1 3-10.6 5.3-16.5 6.8l0 177.9c52.9 2 106.4-15.5 149-52.2L224.5 247.1z"]
};
const faSheep = {
  prefix: 'fass',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M576 135.8l14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5L554.3 74.3 512 32l-64 0L405.7 74.3 350.5 97.9l-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2L384 288l192 0 0-152.2zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM286.5 90.6l15.8-6.8C290.6 71.6 274.2 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0L120 512l88 0 0-85.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 85.7 88 0 22.5-120c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L352 320l0-135.6-21.4 9.2L286.5 90.6z"]
};
const faUnlock = {
  prefix: 'fass',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M224 64c-44.2 0-80 35.8-80 80l0 48 304 0 0 320L0 512 0 192l80 0 0-48C80 64.5 144.5 0 224 0c74.1 0 135.2 56 143.1 128l-64.7 0C295 91.5 262.7 64 224 64z"]
};
const faColonSign = {
  prefix: 'fass',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255.2 23.3l-9.8 41.9c9.9 1.1 19.6 3 29 5.5l14.5-62 62.3 14.5L333.6 98.4c16.8 11.7 31.7 26 43.9 42.4l-51.2 38.4c-2.8-3.8-5.9-7.4-9.1-10.8L268.9 375.9c23.1-8.6 43-23.7 57.5-43.1l51.2 38.4c-29.6 39.4-74 67-125 74.7l-13.4 57.4-62.3-14.5 10.3-44.3c-9.8-1.9-19.3-4.5-28.4-7.9l-15.6 66.7L80.8 488.7l19.9-85.5C58.7 368 32 315.1 32 256C32 165.6 94.5 89.7 178.7 69.4L192.8 8.7l62.3 14.5zM201.7 382.1l58.1-249c-9.3-2.7-19.1-4.4-29.1-4.9L173.4 373.6c9 3.9 18.4 6.7 28.3 8.5zM96 256c0 26.8 8.2 51.6 22.3 72.2l42.9-183.7C122.3 166.4 96 208.1 96 256z"]
};
const faHeadset = {
  prefix: 'fass',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M256 48C141.1 48 48 141.1 48 256l0 40 0 24L0 320l0-24 0-40C0 114.6 114.6 0 256 0S512 114.6 512 256l0 208.1 0 24-24 0L320 488l0 24-80 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l80 0 0 24 144 .1L464 256c0-114.9-93.1-208-208-208zM192 224l0 160L80 384l0-160 112 0zm240 0l0 160-112 0 0-160 112 0z"]
};
const faBadgerHoney = {
  prefix: 'fass',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M160 400l20.6-48 118.1 0L320 480l96 0L393 342.1c27.9-29 80.6-70.8 144.1-90.8L560 288l29.5-47.2c6.1-.5 12.3-.8 18.5-.8l32-32 0-64L496 64l-64 0L368 96 192 96l-32 0-32 0C57.3 96 0 153.3 0 224l0 32 0 32 49.1 0c9 15.5 21.1 29 35.6 39.5L64 400l24 80 96 0-24-80zM368 144l11.3 0 10.1-5.1L443.3 112l40.2 0L570 160l-51.3 0c.9 2.5 1.4 5.2 1.4 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8 .5-5.5 1.4-8L432 160 272 256l-80 0c-52.3 0-96.2-35.8-108.5-84.3c14.7-17 36.4-27.7 60.5-27.7l224 0z"]
};
const faH4 = {
  prefix: 'fass',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M64 64l0 32 0 128 192 0 0-128 0-32 64 0 0 32 0 160 0 160 0 32-64 0 0-32 0-128L64 288l0 128 0 32L0 448l0-32L0 256 0 96 0 64l64 0zm576 0l0 32 0 320 0 32-64 0 0-32 0-96-160 0-38.4 0 6.9-37.8L424.5 64l65.1 0L454.4 256 576 256l0-160 0-32 64 0z"]
};
const faStoreSlash = {
  prefix: 'fass',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M579.6 103.8L512 0 128 0 94.8 50.9 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6l0-15.6 0-131.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3l0 99.2-179.1-139c7.1-4.4 13.5-9.7 19-15.8c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM112.2 223.2c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 384l0 128 432 0L365.5 384 160 384z"]
};
const faRoadCircleXmark = {
  prefix: 'fass',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M160 32l128 0 0 64 0 32 64 0 0-32 0-64 128 0 46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-59.5 0-112.1 29.6-144 74.8l0-42.8 0-32-64 0 0 32 0 64 0 32 38.6 0c-4.3 15.3-6.6 31.4-6.6 48c0 5.4 .2 10.7 .7 16L288 384l0 32 0 64L32 480 160 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z"]
};
const faSignalSlash = {
  prefix: 'fass',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M544 512l64 0s0 0 0 0l-64 0s0 0 0 0zm0-112.4L544 32l0-32 64 0 0 32 0 417.3 12.9 10 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L288 200.8l0-8.8 64 0 0 32 0 26.5 64 49.7L416 128l0-32 64 0 0 32 0 221.9 64 49.7zm-64 74.6l0 5.8 0 32-64 0 0-32 0-56.2 64 50.4zM352 373.3L352 480l0 32-64 0 0-32 0-157.1 64 50.4zM224 288l0 32 0 160 0 32-64 0 0-32 0-160 0-32 64 0zM96 416l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z"]
};
const faUserMinus = {
  prefix: 'fass',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zm88-104l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faMarsStrokeUp = {
  prefix: 'fass',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M160 0L80 80l0 16 56 0 0 24-32 0-24 0 0 48 24 0 32 0 0 24c0 .6 0 1.2 .1 1.8C59.1 205.3 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59.1-146.7-136.1-158.2c0-.6 .1-1.2 .1-1.8l0-24 32 0 24 0 0-48-24 0-32 0 0-24 56 0 0-16L160 0zM64 352a96 96 0 1 1 192 0A96 96 0 1 1 64 352z"]
};
const faMarsStrokeV = faMarsStrokeUp;
const faChampagneGlasses = {
  prefix: 'fass',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M183.6 127.4L209 79.2l61.2 22.3-11.5 53.2-75-27.3zM178.4 0L87.7 172.2C60.2 224.4 76.8 287 122 319.8L91.1 404.7 52 390.4 21.9 379.5 0 439.6l30.1 10.9 69.2 25.2L168.6 501l30.1 10.9 21.9-60.1-30.1-10.9-39.2-14.3 30.9-84.9c55.7 3.9 108.6-33.3 121.2-91L320 173.8l16.7 76.9c12.5 57.7 65.4 94.9 121.2 91l30.9 84.9-39.2 14.3-30.1 10.9 21.9 60.1L471.4 501l69.2-25.2 69.2-25.2L640 439.6l-21.9-60.1L588 390.4l-39.2 14.3L518 319.8c45.2-32.8 61.8-95.4 34.3-147.6L461.6 0 320 51.5 178.4 0zm278 127.4l-75 27.3-11.5-53.2L431 79.2l25.3 48.1z"]
};
const faGlassCheers = faChampagneGlasses;
const faTaco = {
  prefix: 'fass',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M256 32l69.9 54.1 88.3-2.7 24.7 84.9L512 218l-22.2 61.8C437.5 207.2 352.3 160 256 160s-181.5 47.2-233.8 119.8L0 218l73.1-49.7L97.8 83.4l88.3 2.7L256 32zM0 480l0-32C0 306.6 114.6 192 256 192s256 114.6 256 256l0 32L0 480zm112-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faHexagonPlus = {
  prefix: 'fass',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zM232 368l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faPlusHexagon = faHexagonPlus;
const faClipboard = {
  prefix: 'fass',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faHouseCircleExclamation = {
  prefix: 'fass',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M520.5 193.7L288.4 0 0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faFileArrowUp = {
  prefix: 'fass',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM216 408l0 24-48 0 0-24 0-102.1-31 31-17 17L86.1 320l17-17 72-72 17-17 17 17 72 72 17 17L264 353.9l-17-17-31-31L216 408z"]
};
const faFileUpload = faFileArrowUp;
const faWifi = {
  prefix: 'fass',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9l44.3-46.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7l44.3 46.2zM320 256c56.8 0 108.6 21.1 148.2 56l42.4-48C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72l42.4 48c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faWifi3 = faWifi;
const faWifiStrong = faWifi;
const faMessages = {
  prefix: 'fass',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M0 0L416 0l0 320-213.3 0L96 384l0-64L0 320 0 0zM256 448l0-96 192 0 0-224 192 0 0 320-96 0 0 64L437.3 448 256 448z"]
};
const faCommentsAlt = faMessages;
const faBath = {
  prefix: 'fass',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M64 0L32 0l0 32 0 224L0 256l0 64 32 0 448 0 32 0 0-64-32 0L96 256 96 64l18.7 0 18.8 18.8C130 91.8 128 101.7 128 112c0 19.6 7 37.5 18.7 51.4L134.1 176 168 209.9l17-17L289 89l17-17L272 38.1 259.4 50.7C245.5 39 227.6 32 208 32c-10.3 0-20.2 2-29.2 5.5L150.6 9.4 141.3 0 128 0 64 0zM32 352l0 16c0 28.4 12.4 54 32 71.6L64 480l0 32 64 0 0-32 0-16 256 0 0 16 0 32 64 0 0-32 0-40.4c19.6-17.6 32-43.1 32-71.6l0-16L32 352z"]
};
const faBathtub = faBath;
const faUmbrellaSimple = {
  prefix: 'fass',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M288 0l0 32 0 2C414.3 49.7 512 157.5 512 288L0 288C0 157.5 97.7 49.7 224 34l0-2 0-32 64 0zm0 430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7-14.3-28.6 57.2-28.6 14.3 28.6 2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4L224 320l64 0 0 110.6z"]
};
const faUmbrellaAlt = faUmbrellaSimple;
const faRectangleHistoryCirclePlus = {
  prefix: 'fass',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M320 368c0 59.5 29.5 112.1 74.8 144L0 512 0 160l512 0 0 32.7c-5.3-.5-10.6-.7-16-.7c-97.2 0-176 78.8-176 176zM464 80l0 48L48 128l0-48 416 0zM416 0l0 48L96 48 96 0 416 0zm80 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faUnderline = {
  prefix: 'fass',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 32l32 0 96 0 32 0 0 64-32 0-16 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-16 0-32 0 0-64 32 0 96 0 32 0 0 64-32 0-16 0 0 128c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 96 48 96 16 96l0-64zM0 480l0-64 32 0 384 0 32 0 0 64-32 0L32 480 0 480z"]
};
const faPrescriptionBottlePill = {
  prefix: 'fass',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M0 0L384 0l0 96L0 96 0 0zM32 128l320 0 0 83.2c-57 29.1-96 88.4-96 156.8c0 59.5 29.6 112.1 74.8 144L32 512l0-96 112 0 16 0 0-32-16 0L32 384l0-64 112 0 16 0 0-32-16 0L32 288l0-64 112 0 16 0 0-32-16 0L32 192l0-64zM288 368c0-34 11.8-65.2 31.5-89.9L521.9 480.5C497.2 500.2 466 512 432 512c-79.5 0-144-64.5-144-144zm288 0c0 34-11.8 65.2-31.5 89.9L342.1 255.5C366.8 235.8 398 224 432 224c79.5 0 144 64.5 144 144z"]
};
const faUserPen = {
  prefix: 'fass',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM331 417.4L317.4 512 0 512 64 304l320 0 14.2 46.2L331 417.4zM569 223.8l71 71-41.3 41.3-71-71L569 223.8zm-63.9 63.9l71 71L434.9 500 352 511.9 363.9 429 505.1 287.8z"]
};
const faUserEdit = faUserPen;
const faBinarySlash = {
  prefix: 'fass',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M512 374.7l0-54.7 0-32-32 0-79.7 0-82.4-64 2.1 0 0-32 0-160 0-32L288 0 160 0 128 0l0 32 0 44.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L512 374.7zM192 126.3L192 64l64 0 0 96-20.6 0L192 126.3zM446.8 448L384 448l0-49.5-64-50.4L320 480l0 32 32 0 128 0 32 0 0-12.6L446.8 448zM352 0l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32L432 0 384 0 352 0zM128 288l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32-32 0-48 0-32 0z"]
};
const faSquareO = {
  prefix: 'fass',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M448 32L0 32 0 480l448 0 0-448zM144 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
const faCaduceus = {
  prefix: 'fass',
  iconName: 'caduceus',
  icon: [512, 512, [], "e681", "M280 89.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 6.4 0 20L128 64 0 224l138.7 0c33.5 0 66.2-10.5 93.3-30l0 136.5-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8 0-24-48 0 0 24 0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8 0 24 48 0 0-24 0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 32.8 0 64 48 0 0-64 0-32.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8 0 24 48 0 0-24 0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8 0-24-48 0 0 24 0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4 280 194c27.2 19.5 59.8 30 93.3 30L512 224 384 64 280 116l0-20 0-6.4z"]
};
const faSignature = {
  prefix: 'fass',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-130 39L96 264.2 96 288l0 160 0 32 32 0 64 0 18.6 0 9.2-16.1 25.5-44.7c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5-14 42.1 44.4 0 128 0 32 0 0-64-32 0-83.6 0 18-53.9 19.5-58.5-59 17.7L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32 0 32 64 0 0-32 0-32zM160 311.8l71.8-21.5c-10.4 33.8-24.5 66.4-42.1 97.2L173.4 416 160 416l0-104.2zM24 368L0 368l0 48 24 0 40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0zm592 48l24 0 0-48-24 0-310.1 0c-6.7 16.3-14.2 32.3-22.3 48L616 416z"]
};
const faStroopwafel = {
  prefix: 'fass',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM75 188.1L52.4 210.7l11.3 11.3L97.6 256 63.7 289.9 52.4 301.3 75 323.9l11.3-11.3 33.9-33.9 45.3 45.3-56.6 56.6L97.6 391.8l22.6 22.6 11.3-11.3 56.6-56.6 45.3 45.3-33.9 33.9L188.1 437l22.6 22.6 11.3-11.3L256 414.4l33.9 33.9 11.3 11.3L323.9 437l-11.3-11.3-33.9-33.9 45.3-45.3 56.6 56.6 11.3 11.3 22.6-22.6-11.3-11.3-56.6-56.6 45.3-45.3 33.9 33.9L437 323.9l22.6-22.6-11.3-11.3L414.4 256l33.9-33.9 11.3-11.3L437 188.1l-11.3 11.3-33.9 33.9-45.3-45.3 56.6-56.6 11.3-11.3L391.8 97.6l-11.3 11.3-56.6 56.6-45.3-45.3 33.9-33.9L323.9 75 301.3 52.4 289.9 63.7 256 97.6 222.1 63.7 210.7 52.4 188.1 75l11.3 11.3 33.9 33.9-45.3 45.3-56.6-56.6L120.2 97.6 97.6 120.2l11.3 11.3 56.6 56.6-45.3 45.3L86.3 199.4 75 188.1zm181 181l-45.3-45.3L256 278.6l45.3 45.3L256 369.1zm67.9-67.9L278.6 256l45.3-45.3L369.1 256l-45.3 45.3zM210.7 188.1L256 142.9l45.3 45.3L256 233.4l-45.3-45.3zm-22.6 22.6L233.4 256l-45.3 45.3L142.9 256l45.3-45.3z"]
};
const faBold = {
  prefix: 'fass',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 32l32 0 48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0L0 480l0-64 32 0 16 0 0-160L48 96 32 96 0 96 0 32zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z"]
};
const faAnchorLock = {
  prefix: 'fass',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352l64 0 0 128 0 32 32 0 192 0 96 0 0-64-64 0 0-208 32 0 32 0 0-64-32 0-10.9 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faBuildingNgo = {
  prefix: 'fass',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0L384 0zM64 288l0-64 64 0 0 64-64 0zm160-64l0 64-64 0 0-64 64 0zm32 64l0-64 64 0 0 64-64 0zM32 64l16 0 8 0 9.9 0 4.4 8.8L96 124.2 96 80l0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L64 131.8 64 176l0 16-32 0 0-16 0-96 0-16zm136 0l48 0 16 0 0 32-16 0-32 0 0 64 16 0 0-16 0-16 32 0 0 16 0 32 0 16-16 0-48 0-16 0 0-16 0-96 0-16 16 0zm120 48l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16-48c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z"]
};
const faTransporter3 = {
  prefix: 'fass',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 512l120 0 80 0 120 0 0-64L96 448l0 64zm0-256.5c0 .3 0 .7 0 1L96 288l16 0 288 0 16 0 0-32-16 0-288 0-16 0 0-.5zM464 0L448 32 416 48l32 16 16 32 16-32 32-16L480 32 464 0zM64 128L48 96 32 128 0 144l32 16 16 32 16-32 32-16L64 128zm112 0l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm-32 64l-16 0 0 32 16 0 224 0 16 0 0-32-16 0-224 0zm32 128l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z"]
};
const faEngineWarning = {
  prefix: 'fass',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M424 112l-24 0-72 0 0 16 0 16 104 0 80 64 0 240-288 0-51.2-64L96 384l0-104-48 0 0 72 0 24L0 376l0-24L0 160l0-24 48 0 0 24 0 72 48 0 0-88 64 0 48 0 72 0 0-16 0-16-72 0-24 0 0-48 24 0 192 0 24 0 0 48zm120 80l96 0 0 256-96 0 0-256zm-220-4l-40 0 0 20 0 88 0 20 40 0 0-20 0-88 0-20zM280 352l0 48 48 0 0-48-48 0z"]
};
const faEngineExclamation = faEngineWarning;
const faCircleDownRight = {
  prefix: 'fass',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 192l0 160-160 0-24-24 52-52-76-76 56-56 76 76 52-52 24 24z"]
};
const faSquareK = {
  prefix: 'fass',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M448 32L0 32 0 480l448 0 0-448zM337.1 128l-1 1.1L238.3 238.3 330 376.7l4.8 7.3-57.6 0L205.1 275.2 176 307.7l0 52.3 0 24-48 0 0-24 0-61.5L128 152l0-24 48 0 0 24 0 83.8L190.1 220l82.5-92 64.5 0z"]
};
const faManatSign = {
  prefix: 'fass',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M224 32l-64 0 0 66.7C69.2 113.9 0 192.9 0 288L0 448l0 32 64 0 0-32 0-160c0-59.6 40.8-109.8 96-124l0 316 64 0 0-316c55.2 14.2 96 64.3 96 124l0 160 0 32 64 0 0-32 0-160c0-95.1-69.2-174.1-160-189.3L224 32z"]
};
const faMoneyCheckPen = {
  prefix: 'fass',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M0 64l576 0 0 108.4L564.4 184s0 0 0 0L331 417.4 326.6 448 0 448 0 64zM96 288l0 32 256 0 0-32L96 288zm352-96L96 192l0 32 352 0 0-32zm121 31.8l71 71-41.3 41.3-71-71L569 223.8zm-63.9 63.9l71 71L434.9 500 352 511.9 363.9 429 505.1 287.8z"]
};
const faMoneyCheckEdit = faMoneyCheckPen;
const faNotEqual = {
  prefix: 'fass',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M328 32l75.8 0-.7 1.1L332.8 144l67.2 0 32 0 0 64-32 0-107.7 0-60.8 96L400 304l32 0 0 64-32 0-209.1 0L120 480l-75.8 0 .7-1.1L115.2 368 48 368l-32 0 0-64 32 0 107.7 0 60.8-96L48 208l-32 0 0-64 32 0 209.1 0L328 32z"]
};
const faBorderTopLeft = {
  prefix: 'fass',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 448l0 32 64 0 0-32L64 96l352 0 32 0 0-64-32 0L32 32 0 32 0 64 0 448zm160-32l-64 0 0 64 64 0 0-64zm192 0l-64 0 0 64 64 0 0-64zm-96 64l0-64-64 0 0 64 64 0zm192-64l-64 0 0 64 64 0 0-64zM384 288l64 0 0-64-64 0 0 64zm0 32l0 64 64 0 0-64-64 0zm0-128l64 0 0-64-64 0 0 64z"]
};
const faBorderStyle = faBorderTopLeft;
const faMapLocationDot = {
  prefix: 'fass',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 70-120 200-120 200s-120-130-120-200C168 53.7 221.7 0 288 0s120 53.7 120 120zM160 200.9L160 448 0 512 0 192l133-53.2c5.5 19.4 15.1 40.6 27 62.1zm224 51.5L384 512 192 448l0-195.7c44.5 65.3 96 121 96 121s51.4-55.7 96-121zm32-51.5c2.1-3.8 4.1-7.5 6-11.3L576 128l0 320L416 512l0-311.1zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
const faMapMarkedAlt = faMapLocationDot;
const faTilde = {
  prefix: 'fass',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M0 128l32 0 96 0 13.3 0 9.4 9.4L333.3 320l50.7 0 0-128 0-32 64 0 0 32 0 160 0 32-32 0-96 0-13.3 0-9.4-9.4L114.7 192 64 192l0 128 0 32L0 352l0-32L0 160l0-32z"]
};
const faJedi = {
  prefix: 'fass',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M245.2 318.3l-25.1-50.2 50.1 25.1L280 0l16 0 9.8 293.2 50.1-25.1-25.1 50.2L384 336l-53.2 17.7 25.1 50.2-47.2-23.6 2.2 65.7C370.6 435.2 416 382.9 416 320c0-38.3-16.8-72.7-43.5-96.1C417.8 195.6 448 145.3 448 88c0-30.5-8.5-59-23.3-83.2c64.9 37.8 112.8 101.7 129.2 177.4L512 224l47.5 0c.3 5.3 .5 10.6 .5 16c0 18.2-1.8 36-5.2 53.2L496 352l39.9 0C493.3 446.4 398.3 512 288 512S82.7 446.4 40.1 352L80 352 21.2 293.2C17.8 276 16 258.2 16 240c0-5.4 .2-10.7 .5-16L64 224 22.2 182.2C38.5 106.5 86.4 42.6 151.3 4.8C136.5 29 128 57.5 128 88c0 57.3 30.2 107.6 75.5 135.9C176.8 247.3 160 281.7 160 320c0 62.9 45.4 115.2 105.1 126l2.2-65.7-47.2 23.6 25.1-50.2L192 336l53.2-17.7z"]
};
const faSquarePollVertical = {
  prefix: 'fass',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M448 32L0 32 0 480l448 0 0-448zM160 224l0 160-64 0 0-160 64 0zm32-96l64 0 0 256-64 0 0-256zM352 288l0 96-64 0 0-96 64 0z"]
};
const faPoll = faSquarePollVertical;
const faArrowDownSquareTriangle = {
  prefix: 'fass',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M160 479.6l23.7-26 80-88 21.5-23.7-47.4-43-21.5 23.7L192 349.2 192 64l0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 298.8l-47.4 43 21.5 23.7 80 88 23.7 26zM416 288L304 480l224 0L416 288zM512 32L320 32l0 192 192 0 0-192z"]
};
const faSortShapesDownAlt = faArrowDownSquareTriangle;
const faMugHot = {
  prefix: 'fass',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M112 0L64 0l0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24l0-24zM0 192L0 512l384 0 0-96 16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-16 0-32 0L0 192zm384 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96zM224 24l0-24L176 0l0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"]
};
const faDogLeashed = {
  prefix: 'fass',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M176 192l80 0 0 191.3c-5.3 .5-10.6 .7-16 .7c-28.8 0-56-6.9-80-19.2L160 512l-96 0 0-264.9c-29.1-13.6-50.5-41.4-54.8-75.1l-1-7.9-4-31.8 63.5-7.9 4 31.8 1 7.9c2 16 15.6 28 31.8 28l39.5 0 16 0 16 0zM320 364.8c-10.1 5.2-20.8 9.4-32 12.6l0-169.3L416 262l0 250-96 0 0-147.2zM426.7 192l-6.2 37.2L305.9 180.9 336 0l32 0 24 32 72 0 32 32 80 0 0 48c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM132.6 13L275 148.4l11.6 11-22 23.2-11.6-11L110.6 36.2 99 25.2 121 2l11.6 11z"]
};
const faCarBattery = {
  prefix: 'fass',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 64l128 0 0 32 96 0 0-32 128 0 0 32 80 0 0 352L0 448 0 96l80 0 0-32zM384 192l0-16-32 0 0 16 0 32-32 0-16 0 0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-32zM80 224l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z"]
};
const faBatteryCar = faCarBattery;
const faFaceDowncastSweat = {
  prefix: 'fass',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M48 0L86.4 51.2c2 2.7 3.7 5.6 5.1 8.6C94.5 66.1 96 73 96 80c0 9.9-3 19.2-8.2 26.8C79.2 119.6 64.6 128 48 128c-4.4 0-8.7-.6-12.8-1.7c0 0 0 0 0 0C14.9 120.7 0 102.1 0 80C0 69.6 3.4 59.5 9.6 51.2L48 0zm80 80c0-13.9-3.6-27.4-10.4-39.4C157.5 14.9 205 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8c8.5 3.1 17.8 4.8 27.4 4.8c44.2 0 80-35.8 80-80zM316.1 410.7l10.7 11.9 23.8-21.4-10.7-11.9C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3l-10.7 11.9 23.8 21.4 10.7-11.9c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7zM96 256l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm208 0l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0z"]
};
const faMailboxFlagUp = {
  prefix: 'fass',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M576 208c0-42.6-18.5-81-48-107.3L528 80l0-64-64 0-64 0-64 0 0 48-90.8 0C290.4 95.9 320 148.5 320 208l0 240 256 0 0-240zM384 224l0-16 0-96 0-32 0-16 16 0 64 0 16 0 0 16 0 32 0 16-16 0-48 0 0 80 0 16-32 0zM0 208L0 448l288 0 0-240c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 224c-8.8 0-16-7.2-16-16z"]
};
const faMemoCircleInfo = {
  prefix: 'fass',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M384 0L0 0 0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-80.6 54.1-148.5 128-169.4L384 0zM80 128l224 0 16 0 0 32-16 0L80 160l-16 0 0-32 16 0zm0 96l160 0 16 0 0 32-16 0L80 256l-16 0 0-32 16 0zm0 96l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm15.3-224l0 32-32 0 0-32 32 0zm1.2 64l0 16 0 64 15.5 0 0 32-15.5 0-.5 0-32 0-16 0 0-32 16 0 .5 0 0-48-.5 0-16 0 0-32 16 0 16.5 0 16 0z"]
};
const faGift = {
  prefix: 'fass',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L0 128 0 256l512 0 0-128-73.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 224 192 0 0-224L32 288zM288 512l192 0 0-224-192 0 0 224z"]
};
const faDiceTwo = {
  prefix: 'fass',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M0 32l448 0 0 448L0 480 0 32zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faVolume = {
  prefix: 'fass',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M32 160l0 192 128 0L304 480l48 0 0-448-48 0L160 160 32 160zM441.6 332.8C464.9 315.3 480 287.4 480 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4zm57.6 76.8c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2l28.8 38.4z"]
};
const faVolumeMedium = faVolume;
const faTransporter5 = {
  prefix: 'fass',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M480 32l32 16L480 64 464 96 448 64 416 48l32-16L464 0l16 32zM48 128l16 32 32 16L64 192 48 224 32 192 0 176l32-16 16-32zM416 512l-120 0-80 0L96 512l0-64 320 0 0 64zM224 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zM176 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zM112 256l288 0 16 0 0 32-16 0-288 0-16 0 0-32 16 0zm64 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faGaugeCircleBolt = {
  prefix: 'fass',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24-224l-10.7 64 66.7 0L472 448l10.7-64L416 384l104-96z"]
};
const faCoinFront = {
  prefix: 'fass',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264l0-24-48 0 0 24 0 144 0 24 48 0 0-24 0-144z"]
};
const faFileSlash = {
  prefix: 'fass',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M128 76.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L512 374.7 512 160l-160 0L352 0 128 0l0 76.6zM128 512l384 0 0-12.6L128 196.9 128 512zM512 128L384 0l0 128 128 0z"]
};
const faMessageArrowUpRight = {
  prefix: 'fass',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM200 128l-24 0 0 48 24 0 54.1 0-87 87-17 17L184 313.9l17-17 87-87 0 54.1 0 24 48 0 0-24 0-112 0-24-24 0-112 0z"]
};
const faTreasureChest = {
  prefix: 'fass',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M0 160l0 96 128 0 0-224C57.3 32 0 89.3 0 160zM0 480l128 0 0-192L0 288 0 480zm416 0l0-192-64 0 0 64-128 0 0-64-64 0 0 192 256 0zm160 0l0-192-128 0 0 192 128 0zm0-320c0-70.7-57.3-128-128-128l0 224 128 0 0-96zM416 256l0-224L160 32l0 224 64 0 0-64 128 0 0 64 64 0zM304 240l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64z"]
};
const faChessQueen = {
  prefix: 'fass',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M200 56a56 56 0 1 1 112 0A56 56 0 1 1 200 56zM64 480l48-48 288 0 48 48 0 32L64 512l0-32zM424 192c20.6 0 39-9.7 50.7-24.9L512 192 400 400l-288 0L0 192l37.3-24.9C49 182.3 67.4 192 88 192c35.3 0 64-28.7 64-64l42 0c6.2 24 26 42.6 50.7 47c3.4 .6 7.2 1 11.3 1s7.8-.3 11.3-1c24.7-4.4 44.5-23 50.7-47l42 0c0 35.3 28.7 64 64 64z"]
};
const faPaintbrushFine = {
  prefix: 'fass',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M575.2 80l-39.6 39.6L306.9 348.3l-79.2-79.2L456.4 40.4 496 .8 575.2 80zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112L0 512l0-64 64 0 0-48c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z"]
};
const faPaintBrushAlt = faPaintbrushFine;
const faPaintBrushFine = faPaintbrushFine;
const faPaintbrushAlt = faPaintbrushFine;
const faGlasses = {
  prefix: 'fass',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-8.1 29-16.1 57.8-26.2 100.6L224 272l32 0 0 32 64 0 0-32 32 0 175.3 0c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1s0 0 0 0s0 0 0 0s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8s0 0 0 0l0 32 0 48 0 24 0 72 0 32-32 0-192 0-32 0 0-32 0-80-64 0 0 80 0 32-32 0L32 480 0 480l0-32 0-72 0-24 0-48 0-32s0 0 0 0l0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM64 336l0 80 128 0 0-80L64 336zm320 80l128 0 0-80-128 0 0 80z"]
};
const faHoodCloak = {
  prefix: 'fass',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M0 464l0 48 128 0 0-192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 192 128 0 0-48-64-80 0-96c0-98.4-42.4-172.6-104.8-215.2L480 0 288 0C160 0 64 128 64 288l0 96L0 464zm416 48l0-192c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 192 256 0z"]
};
const faSquareQuote = {
  prefix: 'fass',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M0 32l448 0 0 448L0 480 0 32zM208 160L96 160l0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-8 0-56 0-24 0-32zm32 0l0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-8 0-56 0-24 0-32-112 0z"]
};
const faUpLeft = {
  prefix: 'fass',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M16 80l0 288 32 32L152 296 304 448l80-80L232 216 336 112 304 80 16 80z"]
};
const faBringFront = {
  prefix: 'fass',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 64l64 0 32 0 32 0 64 0 0-64L192 0 64 0 0 0 0 64 0 192l0 64 64 0 64 0 0-64-64 0L64 64zM480 448l-32 0-64 0 0 64 64 0 128 0 64 0 0-64 0-128 0-64-64 0-64 0 0 64 64 0 0 128-64 0-32 0zm0-352L160 96l0 320 320 0 0-320z"]
};
const faChessBoard = {
  prefix: 'fass',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M448 32L0 32 0 480l448 0 0-448zM128 96l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"]
};
const faBurgerCheese = {
  prefix: 'fass',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M32 192l0 32 448 0 0-32s0-160-224-160S32 192 32 192zm96-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM480 384L32 384l0 96 448 0 0-96zM224 256l-32 0s0 0 0 0L16 256l0 96 480 0 0-96-48 0s0 0 0 0l-32 0-96 64-96-64z"]
};
const faCheeseburger = faBurgerCheese;
const faBuildingCircleCheck = {
  prefix: 'fass',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0 0-8.2c-39.1-32.3-64-81.1-64-135.8s24.9-103.5 64-135.8L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faRepeat1 = {
  prefix: 'fass',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M0 96L0 224l0 32 64 0 0-32 0-96 256 0 0 64 32 0 96-96L352 0 320 0l0 64L32 64 0 64 0 96zM512 416l0-128 0-32-64 0 0 32 0 96-256 0 0-64-32 0L64 416l96 96 32 0 0-64 288 0 32 0 0-32zM224 240l16 0 0 56 0 24 48 0 0-24 0-80 0-24-24 0-40 0-8 0 0 48 8 0z"]
};
const faArrowDownToLine = {
  prefix: 'fass',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M214.6 342.6L192 365.3l-22.6-22.6-128-128L18.7 192 64 146.7l22.6 22.6L160 242.7 160 64l0-32 64 0 0 32 0 178.7 73.4-73.4L320 146.7 365.3 192l-22.6 22.6-128 128zM32 416l320 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z"]
};
const faArrowToBottom = faArrowDownToLine;
const faGrid5 = {
  prefix: 'fass',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M0 32l64 0 0 64L0 96 0 32zm0 96l64 0 0 64L0 192l0-64zm64 96l0 64L0 288l0-64 64 0zM0 320l64 0 0 64L0 384l0-64zm64 96l0 64L0 480l0-64 64 0zM96 32l64 0 0 64L96 96l0-64zm64 96l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zM96 416l64 0 0 64-64 0 0-64zM256 32l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zM288 32l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zM448 32l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z"]
};
const faSwapArrows = {
  prefix: 'fass',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M128 2.7l22.6 22.6 80 80L253.3 128 208 173.3l-22.6-22.6L160 125.3 160 416l128 0 0-352 0-32 32 0 192 0 32 0 0 32 0 322.7 25.4-25.4L592 338.7 637.3 384l-22.6 22.6-80 80L512 509.3l-22.6-22.6-80-80L386.7 384 432 338.7l22.6 22.6L480 386.7 480 96 352 96l0 352 0 32-32 0-192 0-32 0 0-32 0-322.7L70.6 150.6 48 173.3 2.7 128l22.6-22.6 80-80L128 2.7z"]
};
const faRightLongToLine = {
  prefix: 'fass',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 96l0-32-64 0 0 32 0 320 0 32 64 0 0-32 0-320zM352 416L512 256 352 96l-32 0 0 96L0 192 0 320l320 0 0 96 32 0z"]
};
const faPersonChalkboard = {
  prefix: 'fass',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-18.1 0-9.3 15.5L48.9 251.1 32.4 278.5l54.9 33L103.7 284 120 256.9 120 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-288 56 0 64 0 16 0 32 0 0-64-32 0-16 0 0-64 192 0 0 192-192 0 0-32-64 0 0 32 0 64 64 0 192 0 64 0 0-64 0-192 0-64L576 0 384 0 320 0l0 64 0 64-76.9 0-102.2 0z"]
};
const faMarsStrokeRight = {
  prefix: 'fass',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M320 256A112 112 0 1 0 96 256a112 112 0 1 0 224 0zm62.4 24C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152l33.6 0 0-48 0-24 48 0 0 24 0 48 32 0 0-72 32 0 96 96-96 96-32 0 0-72-32 0 0 48 0 24-48 0 0-24 0-48-33.6 0z"]
};
const faMarsStrokeH = faMarsStrokeRight;
const faHandBackFist = {
  prefix: 'fass',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M192 0L96 0l0 80 0 16 0 32 0 48 0 16-32 0 0-16 0-48-32 0 0 105.5c0 44.7 19.8 87 54.1 115.6c12.6 10.5 26.8 18.8 41.9 24.7L128 512l224 0 0-137.3c46.9-19 80-65 80-118.7l0-32 0-96 0-32-80 0 0-32-80 0 0-32-80 0 0-32z"]
};
const faHandRock = faHandBackFist;
const faGridRound5 = {
  prefix: 'fass',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faTally = {
  prefix: 'fass',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M160 32l0 32 0 214.5 64-22.6L224 64l0-32 64 0 0 32 0 169.4 64-22.6L352 64l0-32 64 0 0 32 0 124.2 64-22.6L480 64l0-32 64 0 0 32 0 79 37.4-13.2 30.2-10.7 21.3 60.4-30.2 10.7L544 210.9 544 448l0 32-64 0 0-32 0-214.5-64 22.6L416 448l0 32-64 0 0-32 0-169.4-64 22.6L288 448l0 32-64 0 0-32 0-124.2-64 22.6L160 448l0 32-64 0 0-32 0-79L58.6 382.2 28.5 392.8 7.2 332.5l30.2-10.6L96 301.1 96 64l0-32 64 0z"]
};
const faTally5 = faTally;
const faSquareCaretUp = {
  prefix: 'fass',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M448 32L0 32 0 480l448 0 0-448zM96 288L224 160 352 288l0 32L96 320l0-32z"]
};
const faCaretSquareUp = faSquareCaretUp;
const faCloudShowersWater = {
  prefix: 'fass',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64l1.6 0c35.3 0 64 28.7 64 64l0 64L64 224l0-64c0-35.3 28.7-64 64-64c0-53 43-96 96-96zM32 384l72-128 48 0L80 384l-48 0zM264 256L192 384l-48 0 72-128 48 0zm64 0l48 0L304 384l-48 0 72-128zm160 0L416 384l-48 0 72-128 48 0zM272.4 493.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faChartBar = {
  prefix: 'fass',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zm64 64l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64zm32 96l128 0 32 0 0 64-32 0-128 0-32 0 0-64 32 0zm0 96l256 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0z"]
};
const faBarChart = faChartBar;
const faHandsBubbles = {
  prefix: 'fass',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128l0 32 .1 72.6c.1 52.2 23.9 101 63.9 133c.8-80.9 42.8-155.8 111.5-198.8l46.6-29.1 34.2-21.4 39-67.5 12-20.8L297.7 4l-12 20.8-84 145.5-20.8-12L244.2 48.8l12-20.8L214.6 4l-12 20.8L139.4 134.3s0 0 0 0l-43.3 75L96 160l0-32L32 128zm284.1-11.8l28.8 46.1 28.7-49.8 12-20.8-41.6-24-12 20.8-16 27.7zm43.2 69.1L376 212l23.4 0L420 176.2l12-20.8-41.6-24-12 20.8-19.1 33.1zm-61.1-37.4l-27.1 17-60.2 37.6C159.3 234.7 128 291.2 128 352l0 8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512l176 0 24 0 0-48-24 0-104 0 0-24 136 0 24 0 0-48-24 0-136 0 0-24 168 0 24 0 0-48-24 0-168 0 0-24 136 0 24 0 0-48-24 0-136 0s0 0 0 0l-93.2 0L305 219.1l27.1-17-33.9-54.3zM544 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faHandsWash = faHandsBubbles;
const faLessThanEqual = {
  prefix: 'fass',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M413.3 33.8l2.7-1 0 67.9L159.5 192 416 283.2l0 67.9-2.7-1-360-128L32 214.6l0-45.2 21.3-7.6 360-128zM32 416l384 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z"]
};
const faTrain = {
  prefix: 'fass',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M448 0L0 0 0 448l66.7 0L25.4 489.4 2.7 512l90.5 0 64-64 133.5 0 64 64 90.5 0-22.6-22.6L381.3 448l66.7 0L448 0zM384 64l0 160L64 224 64 64l320 0zM176 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faUpFromDottedLine = {
  prefix: 'fass',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M64 192L224 32 384 192l0 32-96 0 0 160-128 0 0-160-96 0 0-32zm0 224l0 64L0 480l0-64 64 0zm96 0l0 64-64 0 0-64 64 0zm32 64l0-64 64 0 0 64-64 0zm160-64l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64z"]
};
const faEyeLowVision = {
  prefix: 'fass',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM222.5 150c51.7-47.6 131.8-51.4 188-5.9c54.7 44.3 68.5 120.3 36.3 180.1l-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8l11.6 58.2L222.5 150zM444.9 446.6L85.7 163.5c-10.9 14.3-20.4 28.6-28.5 42.2L393.1 469c18.3-5.7 35.6-13.3 51.8-22.4zM329.2 479.8L34.9 249.2c-1 2.3-2 4.6-2.9 6.8c30 74.7 129.6 224 288 224c3.1 0 6.1-.1 9.2-.2z"]
};
const faLowVision = faEyeLowVision;
const faTrafficLightGo = {
  prefix: 'fass',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faFaceExhaling = {
  prefix: 'fass',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7L320 407.8l0-47.6 22.8-6.8L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM203.2 234.4l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm105.6 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm287.4-5.5c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-22.1 0-39.9 17.9-39.9 40c0 1.6 .1 3.2 .3 4.7L352 384l65.8 19.8c-1.2 3.9-1.9 8-1.9 12.2c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"]
};
const faSensorFire = {
  prefix: 'fass',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M448 32L0 32 0 480l336.8 0C306.5 446.1 288 401.3 288 352.2c0-56.8 36.1-108.8 71.8-150.1c26.7-30.8 56.6-57.5 88.2-83.1l0-87zM112 120l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm96 0l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm240 40c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
const faUserUnlock = {
  prefix: 'fass',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M352 128A128 128 0 1 0 96 128a128 128 0 1 0 256 0zm32 384l0-208s0 0 0 0L64 304 0 512l384 0zM496 272c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48-32 0 0 192 224 0 0-192-32 0-48 0-48 0-16 0 0-48z"]
};
const faHexagonDivide = {
  prefix: 'fass',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zM288 128l-64 0 0 64 64 0 0-64zM168 232l-24 0 0 48 24 0 176 0 24 0 0-48-24 0-176 0zm56 88l0 64 64 0 0-64-64 0z"]
};
const fa00 = {
  prefix: 'fass',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176L0 336c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM64 176c0-44.2 35.8-80 80-80s80 35.8 80 80l0 160c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160zM496 32c-79.5 0-144 64.5-144 144l0 160c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM416 176c0-44.2 35.8-80 80-80s80 35.8 80 80l0 160c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160z"]
};
const faCrow = {
  prefix: 'fass',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M456 0c-48.6 0-88 39.4-88 88l0 29.2L.3 400l39 50.7L126.1 384l133.1 0 18.6 45.1 14 34 14 34 6.1 14.9 51.9 0-13.6-33.1-14-34-14-34L311.1 384l40.9 0c1.1 0 2.1 0 3.2 0l46.6 113.2 6.1 14.9 51.9 0-13.6-33.1-42-102C484.9 354.1 544 280 544 192l0-64 0-8 96-24 0-32L592 32l-68.1 0C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faCassetteBetamax = {
  prefix: 'fass',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M576 32L0 32l0 96 576 0 0-96zm0 128L0 160 0 480l576 0 0-320zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 320a96 96 0 1 1 192 0A96 96 0 1 1 64 320zm256-96l192 0 0 192-192 0 0-192z"]
};
const faBetamax = faCassetteBetamax;
const faSailboat = {
  prefix: 'fass',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M256 352L256 0 528 352l-272 0zM0 384l576 0L480 512 96 512 0 384zM224 64l0 288L48 352 224 64z"]
};
const faWindowRestore = {
  prefix: 'fass',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M448 64L192 64l0 32-64 0 0-32 0-64 64 0L448 0l64 0 0 64 0 256 0 64-64 0-32 0 0-64 32 0 0-256zM0 512L0 128l384 0 0 384L0 512zM64 256l256 0 0-64L64 192l0 64z"]
};
const faNfcMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M0 32l448 0 0 128c-22.8 0-44.4 4.8-64 13.3l0-61.3 0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 64c-38.9 29.2-64 75.7-64 128c0 22.8 4.8 44.4 13.3 64L96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96l0 16 0 288 0 16 16 0 240 0c29.2 38.9 75.7 64 128 64L0 480 0 32zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426c-20.5 14-45.3 22.1-72 22.1z"]
};
const faFileBinary = {
  prefix: 'fass',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM80 256l96 0 16 0 0 16 0 128 0 16-16 0-96 0-16 0 0-16 0-128 0-16 16 0zM96 384l64 0 0-96-64 0 0 96zM240 256l32 0 16 0 0 16 0 112 16 0 16 0 0 32-16 0-32 0-32 0-16 0 0-32 16 0 16 0 0-96-16 0-16 0 0-32 16 0z"]
};
const faCircleV = {
  prefix: 'fass',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM383.9 144L278 385.6 271.7 400l-31.4 0L234 385.6 128.1 144l52.4 0L256 316.2 331.5 144l52.4 0z"]
};
const faSquarePlus = {
  prefix: 'fass',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M448 32L0 32 0 480l448 0 0-448zM200 368l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"]
};
const faPlusSquare = faSquarePlus;
const faBowlScoops = {
  prefix: 'fass',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0-22.7 6.7-43.8 18.3-61.4c19.8-30.2 53.8-50.2 92.6-50.6l1.1 0c61.9 0 112 50.1 112 112c0 5.4-.4 10.8-1.1 16l-221.7 0c-.7-5.2-1.1-10.6-1.1-16zM0 208C0 146.1 50.1 96 112 96l1.1 0c38.7 .4 72.7 20.4 92.6 50.6C196.9 165.2 192 186 192 208c0 5.4 .3 10.7 .9 16L1.1 224C.4 218.8 0 213.4 0 208zM325.4 64.4c-40.9 3-77.1 23-101.4 53.1c-24.3-30.1-60.5-50.1-101.4-53.1C140.5 26.3 179.2 0 224 0s83.5 26.3 101.4 64.4zM4.5 300.7L0 256l448 0-4.5 44.7C437 366.2 381.9 416 316.2 416L256 416l80 72 0 24-224 0 0-24 80-72-60.2 0C66.1 416 11 366.2 4.5 300.7z"]
};
const faMistletoe = {
  prefix: 'fass',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M312 24l0-24L264 0l0 24 0 94.1-98 98L91.3 230.4C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c7.2 10.4 19.3 17.2 32.9 17.2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2L264 185.9l0 72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9l0 9.1c0 53 43 96 96 96s96-43 96-96l0-9.1c0-25.1-9-49.4-25.3-68.4L312 284l0-98.1L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98L312 24zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
const faCustard = {
  prefix: 'fass',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M448 64l25.9 116.5-69.5-19.9-4.4-1.3-4.4 1.3L288 191.4 180.4 160.6l-4.4-1.3-4.4 1.3-69.5 19.9L128 64l320 0zM64.3 350.9L94.2 216 176 192.6l107.6 30.7 4.4 1.3 4.4-1.3L400 192.6 481.8 216 512 352 64.3 350.9zM32 384l512 0 32 0 0 64-32 0L32 448 0 448l0-64 32 0z"]
};
const faLacrosseStick = {
  prefix: 'fass',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M336 64s0 0 0 0l.3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1l0 .3s0 0 0 0c0 33.1-21.9 62.1-53.7 71.2l-35.1 10L353 259l-5 4-54 43.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2L249 164l4-5 1.8-6.2 10-35.1C273.9 85.9 302.9 64 336 64zm0-64s0 0 0 0C274.4 0 220.2 40.9 203.3 100.1L195 129l-39.2 49c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-120 120L2.8 464 48 509.3l22.6-22.6 120-120c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8L383 317l28.9-8.3C471.1 291.8 512 237.6 512 176c0 0 0 0 0 0c0-.1 0-.2 0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0L336 0z"]
};
const faHockeyMask = {
  prefix: 'fass',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M0 240C0 432 48 512 224 512s224-80 224-272L448 0 224 0 0 0 0 240zM160 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM176 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM272 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM264 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm8 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 272c-35.3 0-64-28.7-64-64l0-32 128 0 0 32c0 35.3-28.7 64-64 64zm256-64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32 128 0 0 32z"]
};
const faSunrise = {
  prefix: 'fass',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M354.5 154.9L320 123.5l0 84.5 0 32-64 0 0-32 0-84.5-34.5 31.3-23.7 21.5L154.8 129l23.7-21.5 88-80L288 8l21.5 19.6 88 80L421.2 129l-43 47.4-23.7-21.5zM182 224l106 73.1L394 224l23.3 126.7L544 374l-40 58-97.3 0c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80L72 432 32 374l126.7-23.3L182 224zm22.9 208c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l-166.3 0zM0 464l24 0 528 0 24 0 0 48-24 0L24 512 0 512l0-48z"]
};
const faSubtitles = {
  prefix: 'fass',
  iconName: 'subtitles',
  icon: [576, 512, [], "e60f", "M576 32L0 32 0 480l576 0 0-448zM120 240l176 0 24 0 0 48-24 0-176 0-24 0 0-48 24 0zm256 0l80 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zM120 336l80 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm160 0l176 0 24 0 0 48-24 0-176 0-24 0 0-48 24 0z"]
};
const faPanelEws = {
  prefix: 'fass',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M512 0L0 0 0 288l16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-32 0 0-96 96 0 0 96-32 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320 0 512l512 0L512 0zM112 64l96 0 16 0 0 32-16 0-96 0L96 96l0-32 16 0zm192 0l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM112 128l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm192 0l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM416 256l0 192-128 0 0-192 128 0z"]
};
const faToriiGate = {
  prefix: 'fass',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M384 128l0 64 64 0 0-64 64-64 0-64L416 32 96 32 0 0 0 64l64 64 0 64 64 0 0-64 96 0 0 64 64 0 0-64 96 0zM64 288l0 192 0 32 64 0 0-32 0-192 256 0 0 192 0 32 64 0 0-32 0-192 32 0 32 0 0-64-32 0L32 224 0 224l0 64 32 0 32 0z"]
};
const faCloudExclamation = {
  prefix: 'fass',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zM344 160l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM296 352l0 48 48 0 0-48-48 0z"]
};
const faMessageLines = {
  prefix: 'fass',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM152 144l-24 0 0 48 24 0 208 0 24 0 0-48-24 0-208 0zm0 96l-24 0 0 48 24 0 112 0 24 0 0-48-24 0-112 0z"]
};
const faCommentAltLines = faMessageLines;
const faFrog = {
  prefix: 'fass',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M368 32c41.7 0 75.9 31.8 79.7 72.5L576 144l0 80L400.8 323.5 493.3 416l50.7 0 32 0 0 64-32 0-64 0-13.3 0-9.4-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4l-11.6 11 22.1 23.2 11.6-11 73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416l58.2 0 32 0 0 64-32 0L32 480 0 480l0-32 0-32C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faBucket = {
  prefix: 'fass',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M75.5 0L96 0 352 0l20.5 0 3.2 20.3L397.8 160l-48.6 0L331.5 48l-215 0L98.8 160l-48.6 0L72.3 20.3 75.5 0zM0 192l448 0 0 64-37.1 0L384 512 64 512 37.1 256 0 256l0-64z"]
};
const faFloppyDiskPen = {
  prefix: 'fass',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M0 32l32 0 288 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 76.4-181 181L258 480 32 480 0 480l0-32L0 64 0 32zM320 96L64 96l0 128 256 0 0-128zM288 352a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM505 224l71 71-41.3 41.3-71-71L505 224zm-63.9 63.9l71 71L370.9 500.1 288 512l11.9-82.9L441.1 287.9z"]
};
const faImage = {
  prefix: 'fass',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M0 32l512 0 0 448L0 480 0 32zM323.5 202.1L304 174.7l-19.5 27.3L196.2 325.6l-26.3-29.6L152 275.9l-17.9 20.2-64 72L64 374.9l0 9.1 0 8 0 24 24 0 72 0 24 0 32 0 24 0 184 0 24 0 0-24 0-8 0-7.7-4.5-6.3-120-168zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faWindowFrame = {
  prefix: 'fass',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M32 256L32 64 32 0 96 0 416 0l64 0 0 64 0 192 0 192 32 0 0 64-32 0-64 0L96 512l-64 0L0 512l0-64 32 0 0-192zm384 32l-136 0 0 160 136 0 0-160zm-184 0L96 288l0 160 136 0 0-160zm48-64l136 0 0-160L280 64l0 160zM232 64L96 64l0 160 136 0 0-160z"]
};
const faMicrophone = {
  prefix: 'fass',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M288 0L96 0l0 256c0 53 43 96 96 96s96-43 96-96L288 0zM64 216l0-24-48 0 0 24 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40 0-24-48 0 0 24 0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"]
};
const faCow = {
  prefix: 'fass',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M480 64L272 64l-16 0L144 64C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 32 8 0c35.3 0 64-28.7 64-64l0-32 0-40c0-21.3 9.3-40.5 24-53.7L96 192l0 64 0 192 96 0 0-120.2c9.9 6.6 20.6 12 32 16.1l0 24.2 0 16 32 0 0-16 0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9 0 16 32 0 0-16 0-24.2c11.4-4 22.1-9.4 32-16.1L352 448l96 0 0-192 32 32 0 64 64 96 64 0 32-160-16-22.4 0-81.6 0-24-48 0 0 24 0 14.4L480 64zm80 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 128l224 0 0 32-30.1 30.1C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9L160 160l0-32z"]
};
const faFileZip = {
  prefix: 'fass',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M0 0L224 0l0 160 160 0 0 144-208 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM240 352l64 0 16 0 0 16 0 8 0 4.2-2.1 3.7L263 480l41 0 16 0 0 32-16 0-64 0-16 0 0-16 0-8 0-4.2 2.1-3.7L281 384l-41 0-16 0 0-32 16 0zm144 16l0 128 0 16-32 0 0-16 0-128 0-16 32 0 0 16zm32-16l16 0 24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16zm32 80l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z"]
};
const faSquareRing = {
  prefix: 'fass',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M448 32L0 32 0 480l448 0 0-448zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"]
};
const faDownFromLine = {
  prefix: 'fass',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M352 320L192 480 32 320l0-32 96 0 0-160 128 0 0 160 96 0 0 32zm0-224L32 96 0 96 0 32l32 0 320 0 32 0 0 64-32 0z"]
};
const faArrowAltFromTop = faDownFromLine;
const faCaretUp = {
  prefix: 'fass',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M0 272L160 128 320 272v48H0V272z"]
};
const faShieldXmark = {
  prefix: 'fass',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM353.9 192L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z"]
};
const faShieldTimes = faShieldXmark;
const faScrewdriver = {
  prefix: 'fass',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M353.9 192l62.1 0L512 64 448 0 320 96l0 62.1-82.3 82.3 33.9 33.9L353.9 192zM0 416l96 96L280 328l-96-96L0 416z"]
};
const faCircleSortDown = {
  prefix: 'fass',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM144 320l0-32 224 0 0 32L256 416 144 320zm0-96l0-32L256 96l112 96 0 32-32 0-160 0-32 0zm112-85.9L193.2 192l125.7 0L256 138.1z"]
};
const faSortCircleDown = faCircleSortDown;
const faFolderClosed = {
  prefix: 'fass',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M512 480L0 480 0 192l512 0 0 288zm0-320L0 160 0 32l224 0 48 64 240 0 0 64z"]
};
const faHouseTsunami = {
  prefix: 'fass',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7l20.1-60.8C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9l0-.1c2.5 .1 5 .1 7.6 .1c0 0 0 0 0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5s0 0 0 0c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c0 0 0 0 0 0l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1c0 0 0 0 0 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3l27.1-58C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zM448 32L320 128l0 134.9c8.1 5.6 15.2 10 23.3 13.7c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 240l19.7 14.2c13.9 10 23.6 17 35.5 22.5c13.1 6 27.6 10.3 40.5 10.3l-.4-159L448 32zM272.4 493.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faSquareNfi = {
  prefix: 'fass',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M448 32L0 32 0 480l448 0 0-448zM80 160l8 0 9.9 0 4.4 8.8L160 284.2 160 176l0-16 32 0 0 16 0 160 0 16-16 0-8 0-9.9 0-4.4-8.8L96 227.8 96 336l0 16-32 0 0-16 0-160 0-16 16 0zm160 0l64 0 16 0 0 32-16 0-48 0 0 32 48 0 16 0 0 32-16 0-48 0 0 80 0 16-32 0 0-16 0-96 0-64 0-16 16 0zm144 16l0 160 0 16-32 0 0-16 0-160 0-16 32 0 0 16z"]
};
const faForklift = {
  prefix: 'fass',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M128 0L96 0l0 32 0 128L0 160 0 416c0 53 43 96 96 96s96-43 96-96l64 0c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6l0-88.4 0-5.5-1.9-5.2-80-224L326.6 0 304 0 128 0zM256 256l-96-96 0-96 121.4 0L350 256l-94 0zM96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM544 32l0-32L480 0l0 32 0 384 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-352z"]
};
const faArrowUpFromGroundWater = {
  prefix: 'fass',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M320 352l0-32 0-194.7 25.4 25.4L368 173.3 413.3 128l-22.6-22.6-80-80L288 2.7 265.4 25.4l-80 80L162.7 128 208 173.3l22.6-22.6L256 125.3 256 320l0 32 64 0zM288 485.4c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7zM192 192L0 192 0 415c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5l1.1-.8L96 368l18.6 13.4 1.1 .8s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3l0-223zm384 0l-192 0 0 223c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0L480 368l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3l0-223z"]
};
const faBracketSquareRight = {
  prefix: 'fass',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 32l-32 0L64 32 32 32l0 64 32 0 64 0 0 320-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-384 0-32z"]
};
const faMartiniGlass = {
  prefix: 'fass',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M0 48L16 64 210.7 258.7 224 272l0 176-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-176 13.3-13.3L496 64l16-16 0-48L448 0 64 0 0 0 0 48zm341.5 80l-171 0-64-64 299 0-64 64z"]
};
const faGlassMartiniAlt = faMartiniGlass;
const faRotateLeft = {
  prefix: 'fass',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M142.9 142.9L200 200l-24 24L16 224 16 64 40 40 97.6 97.6s0 0 0 0c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0l45.3-45.3c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0c0 0 0 0 0 0z"]
};
const faRotateBack = faRotateLeft;
const faRotateBackward = faRotateLeft;
const faUndoAlt = faRotateLeft;
const faTableColumns = {
  prefix: 'fass',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M0 32l512 0 0 448L0 480 0 32zM64 160l0 256 160 0 0-256L64 160zm384 0l-160 0 0 256 160 0 0-256z"]
};
const faColumns = faTableColumns;
const faSquareA = {
  prefix: 'fass',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M448 32L0 32 0 480l448 0 0-448zM208.8 128l30.5 0 6.5 13.8L359.4 384l-53 0-22.5-48-119.7 0-22.5 48-53 0L202.3 141.8l6.5-13.8zM224 208.5L186.7 288l74.6 0L224 208.5z"]
};
const faTick = {
  prefix: 'fass',
  iconName: 'tick',
  icon: [192, 512, [], "e32f", "M64 288L32 32H160L128 288H64z"]
};
const faLemon = {
  prefix: 'fass',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M448 80L400 32 327.7 56.1C244 16.3 146.2 46.2 80.2 112.2s-96 163.7-56.1 247.4L0 432l48 48 72.3-24.1c83.7 39.8 181.4 9.9 247.4-56.1s96-163.7 56.1-247.4L448 80zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1l-4.5 15.4-30.7-9 4.5-15.4c19.1-65.1 73.7-119.8 138.9-138.9l15.4-4.5 9 30.7-15.4 4.5z"]
};
const faHeadSideMask = {
  prefix: 'fass',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M32 224.3c0-22.7 3.4-44.7 9.7-65.3L256 301.9 256 512l-128 0-32 0 0-32 0-98.8C55 339.3 32 283 32 224.3zM268.8 272L53.5 128.4C89.4 52.5 166.8 0 256.3 0L288 0C390.1 0 473.6 79.7 479.7 180.3L537 252l7 8.8 0 11.2-272 0-3.2 0zM304 304l240 0s0 0 0 0l-19.7 64L368 368l-16 0 0 32 16 0 146.5 0-9.8 32L368 432l-16 0 0 32 16 0 126.8 0L480 512l-192 0 0-208 16 0s0 0 0 0zm80-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faHandshake = {
  prefix: 'fass',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M298.8 64L224 64l-96 64 0 224 28.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 44.8-48.9 35.2 32.2 64.9-70.8-35.4-32.4-134.2-123-96.4 75-13 10.1-9.7-13.4-64-88-8.9-12.3 11.8-9.6L298.8 64zm74.1 124.9L512 316.8 512 128l-.7 0-3.9-2.5L411.3 64l-61.7 0L197.9 186.9l45.3 62.3 131-101.9 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2zM96 128L0 128 0 384l96 0 0-256zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 256 96 0 0-256-96 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faGem = {
  prefix: 'fass',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M0 208L256 480 512 208 400 32 112 32 0 208zM376 64L299.6 189 464 208 256 232 48 208l164.4-19L136 64 256 177.7 376 64z"]
};
const faDolly = {
  prefix: 'fass',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M0 0L32 0l96 0 23.1 0 7.3 21.9L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4 30.4-10.1 20.2 60.7-30.4 10.1L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64 32 64 0 64 0 0zM311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l76.1-24.7 69.2 213L327.2 309.6c-9.3-6.3-19.6-11.3-30.4-15L234.9 104.1 311 79.4z"]
};
const faDollyBox = faDolly;
const faSmoking = {
  prefix: 'fass',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M448 0l0 43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 43-64 0 0-43c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43l0-43 64 0zM576 288l0-43c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-43 64 0 0 43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1l0 43-64 0zM0 352l32 0 384 0 32 0 0 32 0 96 0 32-32 0L32 512 0 512l0-32 0-96 0-32zm224 64l0 32 160 0 0-32-160 0zm320-64l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zm96 0l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0z"]
};
const faMinimize = {
  prefix: 'fass',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M288 64l32-32 52 52L456 0l56 56-84 84 52 52-32 32-160 0 0-160zm0 384l0-160 160 0 32 32-52 52 84 84-56 56-84-84-52 52-32-32zm-96 32l-52-52L56 512 0 456l84-84L32 320l32-32 160 0 0 160-32 32zM224 64l0 160L64 224 32 192l52-52L0 56 56 0l84 84 52-52 32 32z"]
};
const faCompressArrowsAlt = faMinimize;
const faRefrigerator = {
  prefix: 'fass',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M384 0L0 0 0 160l288 0 0-48 0-16 32 0 0 16 0 48 64 0L384 0zm0 192l-64 0 0 176 0 16-32 0 0-16 0-176L0 192 0 512l384 0 0-320z"]
};
const faMonument = {
  prefix: 'fass',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M192 0L96 96 56 416l272 0L288 96 192 0zm64 320l-128 0 0-48 128 0 0 48zM32 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z"]
};
const faOctagonXmark = {
  prefix: 'fass',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zm353.9 32l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"]
};
const faTimesOctagon = faOctagonXmark;
const faXmarkOctagon = faOctagonXmark;
const faAlignSlash = {
  prefix: 'fass',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M48.4 14.8L29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L482.7 352l61.3 0 0-64-143.7 0-82.4-64L544 224l0-64-308.6 0L153 96l391 0 0-64L96 32l0 19.8-47.6-37zM324.9 352l-81.2-64L96 288l0 64 228.9 0zM162.5 224L96 171.6 96 224l66.5 0zM487.4 480l-81.2-64L96 416l0 64 391.4 0z"]
};
const faSnowplow = {
  prefix: 'fass',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M128 0l0 160-64 0 0 138.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48l42.8 0 0 64 0 13.3 9.4 9.4 64 64 45.3-45.3L576 402.7l0-50.7 0-64 0-52.8L633 164l-50-40-64 80-7 8.8 0 11.2 0 64-64 0 0-64L339.8 0 128 0zM64 400c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48zM380.2 224L256 224l-64-64 0-96 108.2 0 80 160zM120 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm264-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM280 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faAnglesRight = {
  prefix: 'fass',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M278.6 278.6L301.3 256l-22.6-22.6-160-160L96 50.7 50.7 96l22.6 22.6L210.7 256 73.4 393.4 50.7 416 96 461.3l22.6-22.6 160-160zm192 0L493.3 256l-22.6-22.6-160-160L288 50.7 242.7 96l22.6 22.6L402.7 256 265.4 393.4 242.7 416 288 461.3l22.6-22.6 160-160z"]
};
const faAngleDoubleRight = faAnglesRight;
const faTruckRampCouch = {
  prefix: 'fass',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M640 0l0 400c0 61.9-50.1 112-112 112c-61.6 0-111.6-49.8-112-111.3L48.6 502.8l-30.8 8.6L.6 449.7l30.8-8.6L352 352.1 352 0 640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2l0 125.5-38.7 10.4L126.7 386.6 34 411.5 13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z"]
};
const faTruckCouch = faTruckRampCouch;
const faCannabis = {
  prefix: 'fass',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M329.9 199.3c11.2-8.5 23-16.1 34.8-22.8c41-23.3 84.4-36.9 112.2-42.5l23.5-4.7-4.7 23.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.3 16.2-20.3 32.4-33.2 47.1c24.8 6.7 46.2 16.9 60 24.6l25.2 14-25.2 14c-14.8 8.2-38.4 19.4-65.5 26c-18.9 4.6-40.1 7.3-61.4 4.7l8.3 33.1 8.5 33.7-31.1-15.5L280 417.2l0 70.8 0 24-48 0 0-24 0-70.8-58.5 29.1-31.1 15.5 8.5-33.7 8.3-33.1c-21.4 2.5-42.6-.1-61.4-4.7c-27.1-6.7-50.7-17.8-65.5-26L7 350.3l25.2-14c13.8-7.7 35.2-17.8 60-24.6C79.3 297 68.3 280.8 59 264.6c-23.4-40.8-37.1-84-42.7-111.7l-4.7-23.5L35.1 134c27.9 5.5 71.2 19.2 112.2 42.5c11.8 6.7 23.6 14.3 34.8 22.8C179.1 83.9 256 0 256 0s76.9 83.9 73.9 199.3z"]
};
const faCirclePlay = {
  prefix: 'fass',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256L176 384l0-256L384 256z"]
};
const faPlayCircle = faCirclePlay;
const faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'fass',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M352 0L320 0l0 64 32 0 50.7 0L297.4 169.4 274.7 192 320 237.3l22.6-22.6L448 109.3l0 50.7 0 32 64 0 0-32 0-128 0-32L480 0 352 0zM214.6 342.6L237.3 320 192 274.7l-22.6 22.6L64 402.7 64 352l0-32L0 320l0 32L0 480l0 32 32 0 128 0 32 0 0-64-32 0-50.7 0L214.6 342.6z"]
};
const faLocationArrowUp = {
  prefix: 'fass',
  iconName: 'location-arrow-up',
  icon: [448, 512, [], "e63a", "M80 480L32 448 224 32 416 448l-48 32L224 368 80 480z"]
};
const faTablets = {
  prefix: 'fass',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M640 160c0 38.4-13.5 73.7-36.1 101.3L378.7 36.1C406.3 13.5 441.6 0 480 0c88.4 0 160 71.6 160 160zM480 320c-88.4 0-160-71.6-160-160c0-38.4 13.5-73.7 36.1-101.3L581.3 283.9C553.7 306.5 518.4 320 480 320zM160 512C77 512 8.8 448.9 .8 368l318.4 0c-8 80.9-76.2 144-159.2 144zM.8 336C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144L.8 336z"]
};
const fa360Degrees = {
  prefix: 'fass',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM305.7 67.4L320 96c-14.3-28.6-14.3-28.6-14.3-28.6s0 0 0 0c0 0 0 0-.1 0l-.1 .1-.3 .2-.9 .5c-.7 .4-1.7 .9-2.8 1.6c-2.3 1.3-5.4 3.2-9.1 5.7c-7.3 4.9-17 12.2-26.9 22C245.9 116.9 224 148.5 224 192l0 96 0 32s0 0 0 0l0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80c-5.5 0-10.8 .6-16 1.6l0-1.6c0-20.5 10.1-36.9 22.6-49.4c6.2-6.2 12.4-10.9 17.1-14c2.3-1.5 4.2-2.7 5.4-3.3c.6-.3 1-.6 1.2-.7l.1-.1 28.5-14.2L334.3 53.1 305.7 67.4zM32 64L0 64l0 64 32 0 65.3 0L39.7 195.2l-7.7 9L32 216l0 8 0 32 32 0 16 0c26.5 0 48 21.5 48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 352c0 53 43 96 96 96s96-43 96-96l0-48c0-47.6-29.8-88.3-71.7-104.5l64-74.6 7.7-9 0-11.8 0-8 0-32-32 0L32 64zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm16-80c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80l0-224c0-44.2-35.8-80-80-80zM288 272c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z"]
};
const faEthernet = {
  prefix: 'fass',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M0 192L0 448l96 0 0-112 0-16 32 0 0 16 0 112 64 0 0-112 0-16 32 0 0 16 0 112 64 0 0-112 0-16 32 0 0 16 0 112 64 0 0-112 0-16 32 0 0 16 0 112 96 0 0-256-64 0 0-64-64 0 0-64L128 64l0 64-64 0 0 64L0 192z"]
};
const faEuroSign = {
  prefix: 'fass',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7 .6 16L0 272l0 64 62.7 0C94.9 420.2 176.5 480 272 480l48 0 0-64-48 0c-59.2 0-110.9-32.2-138.6-80L288 336l0-64-175.2 0c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16L288 240l0-64-154.6 0c27.7-47.8 79.4-80 138.6-80l48 0 0-64-48 0C176.5 32 94.9 91.8 62.7 176L0 176l0 64 48.6 0z"]
};
const faEur = faEuroSign;
const faEuro = faEuroSign;
const faChair = {
  prefix: 'fass',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M296 48l0 208-48 0 0-208-48 0 0 208-48 0 0-208-40 0 0 208-48 0L64 48 64 0l48 0L336 0l48 0 0 48 0 208-48 0 0-208-40 0zM0 384l0-32 32-64 384 0 32 64 0 32-32 0 0 96 0 32-64 0 0-32 0-96L96 384l0 96 0 32-64 0 0-32 0-96L0 384z"]
};
const faCircleCheck = {
  prefix: 'fass',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"]
};
const faCheckCircle = faCircleCheck;
const faSquareDashedCirclePlus = {
  prefix: 'fass',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M32 32L0 32 0 64l0 96 64 0 0-64 64 0 0-64L32 32zM0 192L0 320l64 0 0-128L0 192zM0 352l0 96 0 32 32 0 96 0 0-64-64 0 0-64L0 352zM432 192c5.4 0 10.7 .2 16 .7L448 64l0-32-32 0-96 0 0 64 64 0 0 102.6c15.3-4.3 31.4-6.6 48-6.6zM262.6 416L160 416l0 64 136.2 0c-15.3-18.5-26.9-40.2-33.6-64zM160 96l128 0 0-64L160 32l0 64zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16z"]
};
const faHandHoldingCircleDollar = {
  prefix: 'fass',
  iconName: 'hand-holding-circle-dollar',
  icon: [576, 512, [], "e621", "M416 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM248.8 111.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L212 201.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faMoneySimpleFromBracket = {
  prefix: 'fass',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M32 0L608 0l32 0 0 32 0 128 0 32-64 0 0-32 0-96L64 64l0 96 0 32L0 192l0-32L0 32 0 0 32 0zM512 96l0 416-384 0 0-416 384 0zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
const faBat = {
  prefix: 'fass',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M224 48l32 32 64 0 32-32 27.9 111.7L480 112c61.9 72.3 96 164.3 96 259.5l0 28.5-96-48-48 80-64-64L288 480 208 368l-64 64L96 352 0 400l0-28.5C0 276.3 34.1 184.3 96 112l100.1 47.7L224 48z"]
};
const faCircleStop = {
  prefix: 'fass',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-352l0 192-192 0 0-192 192 0z"]
};
const faStopCircle = faCircleStop;
const faHeadSideHeadphones = {
  prefix: 'fass',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M160 106.8l0-97.5C67.4 36.9 0 122.8 0 224.2c0 58.7 23 115.1 64 157L64 480l0 32 32 0 192 0 32 0 0-32 0-32 96 0 32 0 0-32 0-96 32 0 32 0 0-32 0-16 0-11.2-7-8.8-57.3-71.7C441.6 79.7 358.1 0 256 0l0 106.8c37.8 18 64 56.5 64 101.2c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-44.7 26.2-83.2 64-101.2zM176 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faPhoneRotary = {
  prefix: 'fass',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 128s96-96 256-96s256 96 256 96l0 80-96 0-32-80s-48-24-128-24s-128 24-128 24L96 208 0 208l0-80zM32 480l0-96L160 160l192 0L480 384l0 96L32 480zM328 312a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
const faArrowUpToBracket = {
  prefix: 'fass',
  iconName: 'arrow-up-to-bracket',
  icon: [448, 512, [], "e66a", "M246.6 169.4L224 146.7l-22.6 22.6-128 128L50.7 320 96 365.3l22.6-22.6L192 269.3 192 480l0 32 64 0 0-32 0-210.7 73.4 73.4L352 365.3 397.3 320l-22.6-22.6-128-128zM64 160l0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0 0 32 0 160l0 32 64 0 0-32z"]
};
const faCompassDrafting = {
  prefix: 'fass',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M352 96c0 14.1-3.1 27.6-8.6 39.7l53.9 90.3c-23.9 26-54.9 45.4-89.8 55.1L256 192 188 309.5c21.5 6.8 44.3 10.5 68 10.5c82.9 0 155.3-45 194.1-112l55.4 32C455.7 326 362.6 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L91.4 476.2 0 512l0-94.2L64 310.7C41.3 290.4 21.9 266.5 6.6 240l55.4-32c9.8 17 21.9 32.6 35.7 46.4l70.9-118.7c-5.5-12.1-8.5-25.5-8.5-39.7c0-53 43-96 96-96s96 43 96 96zm20.9 297.9c33.8-13.3 64.7-32.1 91.7-55.3L512 417.8l0 94.2-91.4-35.8-47.6-82.2zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faDraftingCompass = faCompassDrafting;
const faPlateWheat = {
  prefix: 'fass',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M400 32c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32 16 0zM56 64l48 0 24 0 0 48-24 0-48 0-24 0 0-48 24 0zM24 136l112 0 24 0 0 48-24 0L24 184 0 184l0-48 24 0zm8 72l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM272 32l16 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32zm-96 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32 16 0zM480 176l0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80l16 0zm-128 0l16 0 0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80zm-96 0l0 32c0 44.2-35.8 80-80 80l-16 0 0-32c0-44.2 35.8-80 80-80l16 0zM96 444C40.8 429.8 0 379.6 0 320l512 0c0 59.6-40.8 109.8-96 124l0 36L96 480l0-36z"]
};
const faCalendarCircleMinus = {
  prefix: 'fass',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M160 0L96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64zm96 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 512l330.8 0C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 16l-16 0-128 0-16 0 0-32 16 0 128 0 16 0 0 32z"]
};
const faChopsticks = {
  prefix: 'fass',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M420.5 60.9L24.6 510.4 0 491 343.1 0l77.5 60.9zM576 61l64 74.6L149.4 512 129 488.2 576 61z"]
};
const faCarWrench = {
  prefix: 'fass',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M80 0c32.8 0 61 19.7 73.3 48l205.3 0C371 19.7 399.2 0 432 0c12.5 0 24.4 2.9 34.9 8c19.6 9.5 34.8 26.9 41.4 48L480 56l-26.8 0L432 56l0 48 21.2 0 26.8 0 28.3 0c-6.6 21.1-21.8 38.5-41.4 48c-10.6 5.1-22.4 8-34.9 8c-32.8 0-61-19.7-73.3-48l-205.3 0C141 140.3 112.8 160 80 160c-12.5 0-24.4-2.9-34.9-8c-19.6-9.5-34.8-26.9-41.4-48L32 104l26.8 0L80 104l0-48L58.8 56 32 56 3.7 56C10.3 34.9 25.4 17.5 45.1 8C55.6 2.9 67.5 0 80 0zm49.4 160l22.6 0 208 0 22.6 0 7.6 21.2L428.3 288l35.7 0 0 96 0 64 0 64-80 0 0-64-256 0 0 64-80 0 0-64 0-64 0-96 35.7 0 38.1-106.8 7.6-21.2zm208 64l-162.9 0-22.9 64 208.6 0-22.9-64zM128 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCarMechanic = faCarWrench;
const faIcicles = {
  prefix: 'fass',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M96 352L0 0H512L416 512 336 160 288 352 240 192 192 416 144 192 96 352z"]
};
const faPersonShelter = {
  prefix: 'fass',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M64 181.4L64 512 0 512 0 144 256 0 512 144l0 368-64 0 0-330.6L256 73.4 64 181.4zM256 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm-48 96l96 0 14.3 0 6.8 12.6 56 104 11.4 21.1-42.3 22.8-11.4-21.1L312 313.5 312 488l0 24-48 0 0-24 0-88-16 0 0 88 0 24-48 0 0-24 0-174.5-26.9 49.9-11.4 21.1-42.3-22.8 11.4-21.1 56-104 6.8-12.6 14.3 0z"]
};
const faNeuter = {
  prefix: 'fass',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1L160 480l0 32 64 0 0-32 0-130.9z"]
};
const faIdBadge = {
  prefix: 'fass',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M384 0L0 0 0 512l384 0L384 0zM272 320l32 96L80 416l32-96 160 0zM128 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z"]
};
const faKazoo = {
  prefix: 'fass',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M514 128l94 0 32 0 0 32 0 192 0 32-32 0-94 0c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16l-158 0-4.6 0-4.4-1.3-192-56L0 320l0-24 0-80 0-24 23-6.7 192-56 4.4-1.3 4.6 0 158 0c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16zm30 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM427.3 212.7L448 233.4l20.7-20.7L480 201.4 502.6 224l-11.3 11.3L470.6 256l20.7 20.7L502.6 288 480 310.6l-11.3-11.3L448 278.6l-20.7 20.7L416 310.6 393.4 288l11.3-11.3L425.4 256l-20.7-20.7L393.4 224 416 201.4l11.3 11.3z"]
};
const faMarker = {
  prefix: 'fass',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M32 352L0 512l160-32L292.7 347.3l-128-128L32 352zM187.3 196.7l128 128L485.5 154.5c17-17 26.5-40 26.5-64C512 40.5 471.5 0 421.5 0c-24 0-47 9.5-64 26.5L318.2 65.8 269.6 18.1l-17-16.7L235.8 18.2 111 143l-17 17L128 193.9l17-17L253 69l31.3 30.7-97 97z"]
};
const faBinBottles = {
  prefix: 'fass',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M256 0l0 32 16 0 0 32-16 0L128 64l-16 0 0-32 16 0 0-32L256 0zM32 144l96-48 128 0 63.6 31.8L352 144s0 0 0 0l0 48L32 192l0-48zm543.6-8l0 56L384 192l0-48 0-19.8-17.7-8.8L321.8 93.1l61.8-29 0-64.1 128 0 0 64.1 64 30 0 41.9zM0 224l640 0 0 64-32 0L576 512 64 512 32 288 0 288l0-64z"]
};
const faFaceLaughBeam = {
  prefix: 'fass',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM176 136c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faLaughBeam = faFaceLaughBeam;
const faSquareArrowDownLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M448 480L0 480 0 32l448 0 0 448zM136 368l152 0 24 0 0-48-24 0-94.1 0L329 185l17-17L312 134.1l-17 17-135 135L160 184l0-24-48 0 0 24 0 160 0 24 24 0z"]
};
const faBatteryBolt = {
  prefix: 'fass',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M64 352l125.5 0-20 64L64 416 0 416l0-64L0 160 0 96l64 0 243.5 0-84.3 64L64 160l0 192zm172.5 64l84.3-64L480 352l0-192-125.5 0 20-64L480 96l64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0-243.5 0zM208 400l40-128-88 0 0-24L336 112 296 240l88 0 0 24L208 400z"]
};
const faTreeLarge = {
  prefix: 'fass',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M56 176L224 0 392 176v32H344l80 112v32H368l80 128v32H0V480L80 352H24V320l80-112H56V176z"]
};
const faHelicopterSymbol = {
  prefix: 'fass',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M445.3 224l64.7 0C495.6 108.2 403.8 16.4 288 2l0 64.7C368.4 80.1 431.9 143.6 445.3 224zM510 288l-64.7 0C431.9 368.4 368.4 431.9 288 445.3l0 64.7c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.1 368.4 66.7 288L2 288zm0-64l64.7 0C80.1 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm206-64l0-32-64 0 0 32 0 192 0 32 64 0 0-32 0-64 96 0 0 64 0 32 64 0 0-32 0-192 0-32-64 0 0 32 0 64-96 0 0-64z"]
};
const faAperture = {
  prefix: 'fass',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 0c12.1 0 23.9 .8 35.5 2.4L163.6 224 76.6 73.3C122.8 28 186.1 0 256 0zM0 256C0 196.6 20.2 141.9 54.2 98.5L182.1 320l-174 0C2.8 299.5 0 278.1 0 256zM187.5 502.7C110.6 481.4 48.2 425.1 18.6 352l255.9 0-87 150.7zM256 512c-12.1 0-23.9-.8-35.5-2.4L348.4 288l87 150.7C389.2 484 325.9 512 256 512zM512 256c0 59.4-20.2 114.1-54.2 157.5L329.9 192l174 0c5.3 20.5 8.1 41.9 8.1 64zM324.5 9.3C401.4 30.6 463.8 86.9 493.4 160l-255.9 0 87-150.7z"]
};
const faUniversalAccess = {
  prefix: 'fass',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-86.5L138 161.1 121.1 206l22.5 8.4 64 24 .4 .2 0 53.5-30.8 92.3-7.6 22.8 45.5 15.2 7.6-22.8L249.3 320l13.4 0 26.5 79.6 7.6 22.8 45.5-15.2-7.6-22.8L304 292.1l0-53.5 .4-.2 64-24 22.5-8.4L374 161.1l-22.5 8.4L291.6 192l-71.3 0-59.9-22.5zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
const faGearComplex = {
  prefix: 'fass',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M302.7 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.6 41 39.7 108.9l35 45c-8.3 14.7-14.8 30.4-19.4 47L-1.3 208 0 304l55.3 7c4.5 16.6 11.1 32.4 19.4 47.1l-35 45L107.6 471l44.6-34.7c14.8 8.5 30.7 15.3 47.5 20l7 55.7 96 0 6.9-55c17.2-4.6 33.6-11.3 48.7-19.9L401.8 471l67.9-67.9L436.2 360c8.9-15.3 15.8-31.8 20.6-49.3l54-6.7 0-96-54-6.7c-4.7-17.4-11.7-34-20.6-49.3l33.5-43.1L401.8 41 358.3 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L302.7 0zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faFileMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm16 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2l17 17L280 442.1l-17-17-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faFileSearch = faFileMagnifyingGlass;
const faUpRight = {
  prefix: 'fass',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M368 80l0 288-32 32L232 296 80 448 0 368 152 216 48 112 80 80l288 0z"]
};
const faCircleChevronUp = {
  prefix: 'fass',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17-345L377 271l17 17L360 321.9l-17-17-87-87-87 87-17 17L118.1 288l17-17L239 167l17-17 17 17z"]
};
const faChevronCircleUp = faCircleChevronUp;
const faUserPolice = {
  prefix: 'fass',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M80 99.2L48 80l0-32L224 0 400 48l0 32L368 99.2l0 28.8c-16 10.7-67.2 32-144 32s-128-21.3-144-32l0-28.8zM227 48.6l-3-1.2-3 1.2L189 61.4l-5 2 0 5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8l0-5.4-5-2L227 48.6zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM138.7 352L224 416l85.3-64 90.7 0 48 160L0 512 48 352l90.7 0zM352 400.4l-4.6 14.2-6.1 18.8-19.8 0-14.9 0 12.1 8.7 16 11.6-6.2 18.8L324 486.5l12-8.8 16-11.7 16 11.7 12 8.8-4.6-14.1-6.2-18.8 16-11.6 12.1-8.7-14.9 0-19.8 0-6.1-18.8L352 400.4z"]
};
const faLariSign = {
  prefix: 'fass',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M176 32l0 64.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7L208 32l64 0 0 81.4c66.1 30.3 112 97.1 112 174.6l-64 0c0-40.4-18.7-76.5-48-99.9l0 99.9-64 0 0-127c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1l0 127-64 0 0-99.9C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128l192 0 0 64-192 0L0 480l0-64 48.9 0C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6L112 32l64 0z"]
};
const faVolcano = {
  prefix: 'fass',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64l-48 0-32 48-32 0-32-48-48 0zM298.4 272l-84.9 0-66.2 74.5L240 320l80 64 54-27-75.6-85zM192 224l128 0L512 440l0 24 0 48-48 0L48 512 0 512l0-48 0-24L192 224z"]
};
const faTeddyBear = {
  prefix: 'fass',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M152 102C137.5 91.8 128 75 128 56c0-30.9 25.1-56 56-56c22.3 0 41.6 13.1 50.6 32L288 32l53.4 0c9-18.9 28.3-32 50.6-32c30.9 0 56 25.1 56 56c0 19-9.5 35.8-24 46l0 26c0 70.7-60.9 128-136 128s-136-57.3-136-128l0-26zm88 26a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM88 148.6l29.7 37.7L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7L488 148.6 563.4 208l-29.7 37.7-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7l0 64.9 40 0 8-48 80 16L552 512l-40 0-32 0L96 512l-32 0-40 0L0 368l80-16 8 48 40 0 0-64.9c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7 12.6 208 88 148.6zM384 384l-32-32-128 0-32 32 0 32 192 0 0-32z"]
};
const faStocking = {
  prefix: 'fass',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M384 0L64 0l0 96 320 0 0-96zM96 128l0 128L55.7 282.9C20.9 306.1 0 345.1 0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L352 384l0-256L96 128z"]
};
const faPersonWalkingDashedLineArrowRight = {
  prefix: 'fass',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM132.3 126.6l10 2 80 16 15.3 3.1 7 14 35.2 70.5 38.5 19.2-28.6 57.2-48-24-9.5-4.8-4.8-9.5-13.7-27.4-18.4 62.4 52.3 57 5.2 5.7 2 7.5 24 88 8.4 30.9-61.7 16.8-8.4-30.9-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l17-63.6L89.9 215.5 78.4 250.1 68.2 280.5 7.5 260.2l10.1-30.4 16-48 4.5-13.4L51 162.8l72-32 9.3-4.1zm-38.6 209c2.1 3 4.5 5.8 7 8.6l40.7 44.4-15.7 39.3-2.4 6.1-4.6 4.6-48 48L48 509.3 2.7 464l22.6-22.6L68.7 398l25-62.4zM416 24l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zM534.6 153.4l80 80L637.3 256l-22.6 22.6-80 80L512 381.3 466.7 336l22.6-22.6L514.7 288 384 288l-32 0 0-64 32 0 130.7 0-25.4-25.4L466.7 176 512 130.7l22.6 22.6zM416 128l0 24 0 16 0 24-48 0 0-24 0-16 0-24 48 0zm0 216l0 16 0 24-48 0 0-24 0-16 0-24 48 0 0 24zm0 72l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0z"]
};
const faImageSlash = {
  prefix: 'fass',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L576 424.4 576 32 70.5 32 48.4 14.8zM157.7 99.6c5.7-2.3 11.8-3.6 18.3-3.6c26.5 0 48 21.5 48 48c0 2.3-.2 4.6-.5 6.8L157.7 99.6zM327.5 231.5l21-29.4L368 174.7l19.5 27.3 120 168 1.9 2.7-182-141.3zM214.2 279.9l8-8.8L64 146.4 64 480l423.4 0-81.2-64-113.3 0L280 416l-32 0-24 0-72 0-24 0 0-24 0-8 0-9.3 6.2-6.9 80-88z"]
};
const faMaskSnorkel = {
  prefix: 'fass',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M576 32l0 32 0 96-64 0 0 32 64 0 0 184c0 75.1-60.9 136-136 136l-8 0c-70.7 0-128-57.3-128-128l0-32 64 0 0 32c0 35.3 28.7 64 64 64l8 0c39.8 0 72-32.2 72-72l0-312 0-32 64 0zM0 64l448 0 0 224-176 0-32-64-32 0-32 64L0 288 0 64z"]
};
const faSmoke = {
  prefix: 'fass',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3c-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-11.5 7.3-22 16-31.2 25.9C372.7 102.8 347.2 96 320 96c-66.5 0-123.5 40.6-147.7 98.3zm276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9c-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9C563.1 284.5 516.9 256 464 256c-5.2 0-10.3 .3-15.4 .8zM144 512L0 512 0 368c0-79.5 64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3C257.6 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112l0 112-112 0-320 0z"]
};
const faSterlingSign = {
  prefix: 'fass',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M112 157.9c0-34.2 27.7-61.9 61.9-61.9c7.9 0 15.7 1.5 23 4.4l63.2 25.3 29.7 11.9 23.8-59.4L283.9 66.3 220.7 41c-14.9-5.9-30.7-9-46.8-9C104.4 32 48 88.4 48 157.9L48 224 0 224l0 64 48 0 0 48.4L3.4 425.7 0 432.4 0 440l0 8 0 32 32 0 256 0 32 0 0-64-32 0L79.8 416l28.8-57.7 3.4-6.8 0-7.6 0-56 144 0 0-64-144 0 0-66.1z"]
};
const faGbp = faSterlingSign;
const faPoundSign = faSterlingSign;
const faBatteryExclamation = {
  prefix: 'fass',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96l0 64L64 160l0 192 128 0 0 64L64 416 0 416l0-64L0 160 0 96l64 0 144 0zm128 64l0-64 144 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0-128 0 0-64 128 0 0-192-144 0zM296 96l0 24 0 176 0 24-48 0 0-24 0-176 0-24 48 0zm8 256l0 64-64 0 0-64 64 0z"]
};
const faViruses = {
  prefix: 'fass',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M168 0l24 0 24 0 0 24 0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5 17-17 17 17s0 0 0 0s0 0 0 0l17 17-17 17-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0 24 0 0 24 0 24-24 0-13.5 0c-35.6 0-53.5 43.1-28.3 68.3c0 0 0 0 0 0l9.5 9.5 17 17-17 17-17 17-17-17-9.5-9.5s0 0 0 0C259.1 293 216 310.9 216 346.5l0 13.5 0 24-24 0-24 0 0-24 0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5-17 17-17-17-17-17 17-17 9.5-9.5C91 259.1 73.1 216 37.5 216L24 216 0 216l0-24 0-24 24 0 13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5-17-17 17-17 17-17 17 17 9.5 9.5s0 0 0 0C124.9 91 168 73.1 168 37.5L168 24l0-24zm72 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM597.8 266.2l11.3 11.3-11.3 11.3C574.5 312.1 591 352 624 352l16 0 0 16 0 16-16 0c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C551.9 446.5 512 463 512 496l0 16-16 0-16 0 0-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3s0 0 0 0l-11.3-11.3 11.3-11.3C417.5 423.9 401 384 368 384l-16 0 0-16 0-16 16 0c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3s0 0 0 0l11.3-11.3 11.3 11.3C440.1 289.5 480 273 480 240l0-16 16 0 16 0 0 16c0 33 39.9 49.5 63.2 26.2l11.3-11.3 11.3 11.3zM512 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faSquarePersonConfined = {
  prefix: 'fass',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M0 32l448 0 0 448L0 480 0 32zM256 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm18.7 48l-9.4 9.4-16 16-9.4 9.4 0 13.3 0 66.7-41.4-41.4-51.2 8.3-24 48-12 24-12 24-12 24L76.2 416l71.6 0 8.8-17.7 12-24 12-24 4.1-8.3 54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L352 224l0-32-32 0-32 0-13.3 0z"]
};
const faUserTie = {
  prefix: 'fass',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2L176 304l48 0 48 0-33.1 55.2 33.4 123.9L312.2 320l71.8 0 64 192-168 0-14.9 0-82.3 0L168 512 0 512 64 320l71.8 0 39.9 163.1 33.4-123.9z"]
};
const faUpToBracket = {
  prefix: 'fass',
  iconName: 'up-to-bracket',
  icon: [448, 512, [], "e66e", "M384 320L224 160 64 320l0 32 96 0 0 160 128 0 0-160 96 0 0-32zM64 160l0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0 0 32 0 160l0 32 64 0 0-32z"]
};
const faArrowDownLong = {
  prefix: 'fass',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M214.6 489.4L192 512l-22.6-22.6-128-128L18.7 338.7 64 293.5l22.6 22.6L160 389.5 160 32l0-32 64 0 0 32 0 357.5 73.4-73.4L320 293.5l45.3 45.3-22.6 22.6-128 128z"]
};
const faLongArrowDown = faArrowDownLong;
const faTentArrowDownToLine = {
  prefix: 'fass',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M241.9 136l-17 17-64 64-17 17-17-17L63 153l-17-17L80 102.1l17 17 23 23L120 24l0-24 48 0 0 24 0 118.1 23-23 17-17L241.9 136zM384 448l76.8 0L384 320l0 128zm219.4 0l4.6 0 32 0 0 64-32 0L32 512 0 512l0-64 32 0 132.6 0L192 256 384 128 576 256l27.4 192z"]
};
const faCertificate = {
  prefix: 'fass',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M187.4 0L256 57.2 324.6 0l30.8 83.9 88-15.3-15.3 88L512 187.4 454.8 256 512 324.6l-83.9 30.8 15.3 88-88-15.3L324.6 512 256 454.8 187.4 512l-30.8-83.9-88 15.3 15.3-88L0 324.6 57.2 256 0 187.4l83.9-30.8-15.3-88 88 15.3L187.4 0z"]
};
const faCrystalBall = {
  prefix: 'fass',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M448 224c0 62.7-25.7 119.3-67.2 160L67.2 384C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM177.3 110.7L160 64l-17.3 46.7L96 128l46.7 17.3L160 192l17.3-46.7L224 128l-46.7-17.3zM304 112l-25.9 70.1L208 208l70.1 25.9L304 304l25.9-70.1L400 208l-70.1-25.9L304 112zM0 512l64-96 320 0 64 96L0 512z"]
};
const faReplyAll = {
  prefix: 'fass',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M106.4 184.4L224 76.6 224 32l-32 0L0 208 192 384l32 0 0-44.6L106.4 231.6 80.6 208l25.7-23.6zM224 120l-72.3 66.3L128 208l23.7 21.7L224 296l96 88 32 0 0-96 16 0c61.9 0 112 50.1 112 112c0 48-32 80-32 80s128-48 128-176c0-97.2-78.8-176-176-176l-48 0 0-96-32 0-96 88z"]
};
const faMailReplyAll = faReplyAll;
const faSuitcase = {
  prefix: 'fass',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M152 0L128 0l0 24 0 72 0 32 0 352 256 0 0-352 0-32 0-72 0-24L360 0 152 0zM336 96L176 96l0-48 160 0 0 48zM0 96L0 480l96 0L96 96 0 96zM512 480l0-384-96 0 0 384 96 0z"]
};
const faPersonSkating = {
  prefix: 'fass',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 96l32 0 160 0 13.3 0 9.4 9.4 19.3 19.3 23.4 23.4-24.2 22.6-83.4 77.8 64.9 64.9 9.4 9.4 0 13.3 0 80 0 32-64 0 0-32 0-66.7-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17L160 160l-32 0 0-64zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7L104 421.3 58.7 376l22.6-22.6zm307 91.2l31 7.8-3.9 15.5-8 32-3 12.1L392 512l-104 0-16 0 0-32 16 0 91.5 0 5-19.9 3.9-15.5zM135.2 478.3l-32 16-10.3 5.2-8.2-8.2-72-72L1.4 408 24 385.4l11.3 11.3 63.8 63.8 21.7-10.8 14.3-7.2 14.3 28.6-14.3 7.2z"]
};
const faSkating = faPersonSkating;
const faStarShooting = {
  prefix: 'fass',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M297 57l17-17L280 6.1 263 23 231 55l-17 17L248 105.9l17-17 32-32zM489 249l17-17L472 198.1l-17 17-32 32-17 17L440 297.9l17-17 32-32zm17-209L472 6.1 455 23 327 151l-17 17L344 201.9l17-17L489 57l17-17zM253.3 265.1L193.5 144 133.7 265.1 0 284.6l96.7 94.3L73.9 512l119.6-62.9L313 512 290.2 378.9l96.7-94.3L253.3 265.1z"]
};
const faBinaryLock = {
  prefix: 'fass',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M224 0l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32L304 0 256 0 224 0zM0 288l0 64 32 0 16 0 0 96-16 0L0 448l0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32-32 0-48 0L0 288zM32 0L0 0 0 32 0 192l0 32 32 0 128 0 32 0 0-32 0-160 0-32L160 0 32 0zM64 160l0-96 64 0 0 96-64 0zM192 288l0 32 0 160 0 32 32 0 128 0 32 0 0-32 0-160 0-32-32 0-128 0-32 0zm64 64l64 0 0 96-64 0 0-96zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faFilterCircleDollar = {
  prefix: 'fass',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M192 384l0-96L0 64 0 0 512 0l0 64L399.8 194.9C318 210.1 256 281.8 256 368c0 27.8 6.4 54.1 17.9 77.4L192 384zm96-16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L465.9 301c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4 0-16-32 0 0 16 0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L372 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4 0 16 32 0 0-16 0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
const faFunnelDollar = faFilterCircleDollar;
const faCameraRetro = {
  prefix: 'fass',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M220.6 121.2L271.1 96 448 96l0 96-114.8 0c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24L64 192l0-64 128 0c9.9 0 19.7-2.3 28.6-6.8zM256 32L192 64l-32 0 0-32L64 32l0 32L0 64l0 64L0 416l0 64 64 0 384 0 64 0 0-64 0-320 0-64-64 0L256 32zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"]
};
const faCircleArrowDown = {
  prefix: 'fass',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm17-103L385 297l17-17L368 246.1l-17 17-71 71L280 120l0-24-48 0 0 24 0 214.1-71-71-17-17L110.1 280l17 17L239 409l17 17 17-17z"]
};
const faArrowCircleDown = faCircleArrowDown;
const faCommentPen = {
  prefix: 'fass',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM304.8 144l-29.1 29.1L323 220.4l29.1-29.1L304.8 144zm-51.7 51.7l-85.2 85.2L160 336.1l55.3-7.9L300.4 243l-47.3-47.3z"]
};
const faCommentEdit = faCommentPen;
const faFileImport = {
  prefix: 'fass',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M128 0L352 0l0 160 160 0 0 352-384 0 0-176 174.1 0-39 39-17 17L280 425.9l17-17 80-80 17-17-17-17-80-80-17-17L246.1 232l17 17 39 39L128 288 128 0zm0 288l0 48L24 336 0 336l0-48 24 0 104 0zM512 128l-128 0L384 0 512 128z"]
};
const faArrowRightToFile = faFileImport;
const faBanjo = {
  prefix: 'fass',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M367.1 99.7L376 64 448 0l64 64-64 72-35.7 8.9L331.3 226c13.9 20.6 23.4 44.3 27 70l1.7 0 24 0 0 48-24 0-1.7 0c-4.1 28.5-15.3 54.6-31.7 76.6l1.2 1.2 17 17-33.9 33.9-17-17-1.2-1.2c-22 16.5-48.2 27.7-76.6 31.7l0 1.7 0 24-48 0 0-24 0-1.7c-28.5-4.1-54.6-15.3-76.6-31.7l-1.2 1.2-17 17L39.3 438.8l17-17 1.2-1.2C41 398.6 29.8 372.5 25.7 344L24 344 0 344l0-48 24 0 1.7 0c4.1-28.5 15.3-54.6 31.7-76.6l-1.2-1.2-17-17 33.9-33.9 17 17 1.2 1.2c22-16.5 48.2-27.7 76.6-31.7l0-1.7 0-24 48 0 0 24 0 1.7c25.7 3.7 49.5 13.1 70 27l81.1-81.1zM192 432a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM155.3 308.7l48 48L214.6 368 192 390.6l-11.3-11.3-48-48L121.4 320 144 297.4l11.3 11.3z"]
};
const faSquareArrowUpRight = {
  prefix: 'fass',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M0 32l448 0 0 448L0 480 0 32zM312 144l-152 0-24 0 0 48 24 0 94.1 0L119 327l-17 17L136 377.9l17-17 135-135L288 328l0 24 48 0 0-24 0-160 0-24-24 0z"]
};
const faExternalLinkSquare = faSquareArrowUpRight;
const faLightEmergencyOn = {
  prefix: 'fass',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36l-20-13.3L22.7 62.7 42.7 76l48 32 20 13.3 26.6-39.9L117.3 68l-48-32zM597.3 76l20-13.3L590.7 22.7 570.7 36l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM24 192L0 192l0 48 24 0 72 0 24 0 0-48-24 0-72 0zm520 0l-24 0 0 48 24 0 72 0 24 0 0-48-24 0-72 0zM320 32c-88.4 0-160 71.6-160 160l0 160 320 0 0-160c0-88.4-71.6-160-160-160zM240 192l-32 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80zM544 384L96 384l0 96 448 0 0-96z"]
};
const faKerning = {
  prefix: 'fass',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M201.3 489.6l208-480 29.4 12.7-208 480-29.4-12.7zM419.6 352l-27.2 64-69.5 0L450.5 115.5 458.8 96l42.3 0 8.3 19.5L637.2 416l-69.5 0-27.2-64-120.9 0zm93.7-64L480 209.8 446.8 288l66.5 0zM317.2 96L189.4 396.5 181.2 416l-42.3 0-8.3-19.5L2.8 96l69.5 0L160 302.2 247.6 96l69.5 0z"]
};
const faBoxOpen = {
  prefix: 'fass',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M64 32L320 64 576 32l64 128-64 18.3L416 224l-57.6-96L320 64l-38.4 64L224 224 64 178.3 0 160 64 32zm0 384l0-204.4 151.2 43.2 23.6 6.7 12.6-21L318.9 128l2.2 0 67.5 112.5 12.6 21 23.6-6.7L576 211.6 576 416 320 480 64 416z"]
};
const faSquareF = {
  prefix: 'fass',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M448 32L0 32 0 480l448 0 0-448zM152 128l144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24 24 0z"]
};
const faScroll = {
  prefix: 'fass',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M0 80l0 80 48 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-48 0-16 16 0 208 0 0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112l0-16-288 0 0 32c0 53-43 96-96 96l176 0 96 0z"]
};
const faSpa = {
  prefix: 'fass',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M207.8 252.3C158.4 214.4 96.5 192 30 192L0 192C0 351.1 128.9 480 288 480s288-128.9 288-288l-30 0c-56.1 0-108.8 15.9-153.6 43.6c-33.5 20.7-62.5 48-85.3 80.2c-7 9.9-13.4 20.3-19.1 31c-5.7-10.8-12.1-21.1-19.1-31c-17.1-24.2-37.7-45.6-61-63.5zM288 32s-66.4 56.9-97 170.8c37.7 21.6 70.7 50.5 97 85c26.3-34.5 59.3-63.4 97-85C354.4 88.9 288 32 288 32z"]
};
const faArrowLeftFromLine = {
  prefix: 'fass',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M384 96l0-32 64 0 0 32 0 320 0 32-64 0 0-32 0-320zM25.4 278.6L2.7 256l22.6-22.6 128-128L176 82.7 221.3 128l-22.6 22.6L125.3 224 288 224l32 0 0 64-32 0-162.7 0 73.4 73.4L221.3 384 176 429.3l-22.6-22.6-128-128z"]
};
const faArrowFromRight = faArrowLeftFromLine;
const faStrawberry = {
  prefix: 'fass',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M320 80c0 33.9 11 44.3 29.4 61.7c0 0 0 0 0 0c3.3 3.1 6.9 6.5 10.6 10.3s7.1 7.3 10.3 10.6c0 0 0 0 0 0C387.7 181 398.1 192 432 192c40 0 80-40 80-40s-29.5-36.8-74.3-39.8c.7-.7 1.5-1.5 2.2-2.2c21.5-21.5 48.2-52.2 62.1-84.5L457.9 6.5C447.8 30.2 426.5 55.5 406 76c-2 2-4.1 4-6 5.9c0-.6 0-1.3 0-2c0-48-40-80-40-80s-40 40-40 80zM192.2 64C96.2 64 0 160 0 336L0 512l176 0c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zM172.8 172.8c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm-32 96c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 28.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4 99.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zM118.4 329.6s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4 99.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6-227.2s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4 99.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 28.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6z"]
};
const faLocationPinLock = {
  prefix: 'fass',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M192 512s28.8-31.1 64-75.8L256 288l32 0 0-16c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faPause = {
  prefix: 'fass',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M128 64L0 64 0 448l128 0 0-384zm192 0L192 64l0 384 128 0 0-384z"]
};
const faClockEightThirty = {
  prefix: 'fass',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-91.2L173.3 340l-20 13.3-26.6-39.9 20-13.3 96-64L280 211.2l0 44.8 0 136 0 24-48 0 0-24z"]
};
const faPlaneEngines = {
  prefix: 'fass',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-35-59.5-64-93.7-64l-116.6 0-36.6-64 22.9 0 0-64-59.4 0L256 0 160 0l54.9 192L112 192 64 128 0 128l24.2 96.9C10.3 228.4 0 241 0 256s10.3 27.6 24.2 31.1L0 384l64 0 48-64 102.9 0L160 512l96 0 36.6-64 59.4 0 0-64-22.9 0 36.6-64 116.6 0c34.2 0 93.7-28 93.7-64z"]
};
const faPlaneAlt = faPlaneEngines;
const faHillAvalanche = {
  prefix: 'fass',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M0 512l480 0L0 32 0 512zM551.1 391.1c34.4-34.4 34.4-90.1 0-124.4s-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTemperatureEmpty = {
  prefix: 'fass',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M97.8 317.8L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM272 0L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faTemperature0 = faTemperatureEmpty;
const faThermometer0 = faTemperatureEmpty;
const faThermometerEmpty = faTemperatureEmpty;
const faBomb = {
  prefix: 'fass',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M432 0L405.3 53.3 352 80l53.3 26.7L432 160l26.7-53.3L512 80 458.7 53.3 432 0zM326.6 105.4L304 82.7l-22.6 22.6-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9L429.3 208l-22.6-22.6-80-80zM200 192c-57.4 0-104 46.6-104 104l0 8-32 0 0-8c0-75.1 60.9-136 136-136l8 0 0 32-8 0z"]
};
const faGaugeLow = {
  prefix: 'fass',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3l-9.7-22-43.9 19.3 9.7 22 64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAltSlow = faGaugeLow;
const faRegistered = {
  prefix: 'fass',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128l24 0 104 0c44.2 0 80 35.8 80 80c0 37.8-26.3 69.5-61.6 77.9L369.1 384l-57 0-61.3-96L208 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 112l56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64z"]
};
const faTrashCanPlus = {
  prefix: 'fass',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0 0 384L32 512l0-384zm168 72l0 80-80 0 0 48 80 0 0 80 48 0 0-80 80 0 0-48-80 0 0-80-48 0z"]
};
const faAddressCard = {
  prefix: 'fass',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M576 32L0 32 0 480l576 0 0-448zM256 288l32 96L64 384l32-96 160 0zM112 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0zm0 64l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0zm0 64l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0z"]
};
const faContactCard = faAddressCard;
const faVcard = faAddressCard;
const faScaleUnbalancedFlip = {
  prefix: 'fass',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M251.1 39.3L138.1 1.6 117.9 62.4l125.9 42c7 22 23.3 39.9 44.2 49L288 448l-160 0-32 0 0 64 32 0 192 0 32 0 0-32 0-326.7c5.1-2.2 9.9-5 14.4-8.2l135.5 45.2 30.4 10.1 20.2-60.7-30.4-10.1L399.5 88.8c.3-2.9 .5-5.8 .5-8.8c0-44.2-35.8-80-80-80c-29.3 0-55 15.8-68.9 39.3zM528 224l-32 0-14.5 0-6.7 12.9-88 168-2.7 5.2 0 5.9 0 32 0 9.9 7 7 40 40 7 7 9.9 0 128 0 9.9 0 7-7 40-40 7-7 0-9.9 0-32 0-5.9-2.7-5.2-88-168L542.5 224 528 224zm60.9 192l-153.8 0 75.4-144 3 0 75.4 144zM158.5 96L144 96l-32 0L97.5 96l-6.7 12.9-88 168L0 282.1 0 288l0 32 0 9.9 7 7 40 40 7 7 9.9 0 128 0 9.9 0 7-7 40-40 7-7 0-9.9 0-32 0-5.9-2.7-5.2-88-168L158.5 96zm-29 48l75.4 144L51.1 288l75.4-144 3 0z"]
};
const faBalanceScaleRight = faScaleUnbalancedFlip;
const faGlobeSnow = {
  prefix: 'fass',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M380.8 384c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160L192 384l0-32-80 0 0-16 80-80-48 0 0-16 80-80 80 80 0 16-48 0 80 80 0 16-80 0 0 32 124.8 0zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM224 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 512l448 0-64-96L64 416 0 512z"]
};
const faSubscript = {
  prefix: 'fass',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M0 64l32 0 32 0 16.7 0 9.6 13.6L176 200.2 261.8 77.6 271.3 64 288 64l32 0 32 0 0 64-32 0-15.3 0L215.1 256l89.6 128 15.3 0 32 0 0 64-32 0-32 0-16.7 0-9.6-13.6L176 311.8 90.2 434.4 80.7 448 64 448l-32 0L0 448l0-64 32 0 15.3 0 89.6-128L47.3 128 32 128 0 128 0 64zM384 288l32 0 32 0 32 0 0 32 0 128 32 0 0 64-32 0-64 0-32 0 0-64 32 0 0-96-32 0 0-64z"]
};
const faDiamondTurnRight = {
  prefix: 'fass',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M256 0L0 256 256 512 512 256 256 0zm48 336l-16 0 0-72-80 0 0 64 0 24-48 0 0-24 0-88 0-24 24 0 104 0 0-72 16 0 96 96-96 96z"]
};
const faDirections = faDiamondTurnRight;
const faIntegral = {
  prefix: 'fass',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M128 0l32 0L272 0l32 0 0 32 0 64 0 32-64 0 0-32 0-32-48 0 0 416 0 32-32 0L48 512l-32 0 0-32 0-64 0-32 64 0 0 32 0 32 48 0 0-416 0-32z"]
};
const faBurst = {
  prefix: 'fass',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M256 0l56.8 118.8L437 75 393.2 199.2 512 256 393.2 312.8 437 437 312.8 393.2 256 512 199.2 393.2 75 437l43.8-124.2L0 256l118.8-56.8L0 0 199.2 118.8 256 0z"]
};
const faHouseLaptop = {
  prefix: 'fass',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M0 208L240 0 480 208l0 16-192 0 0-32-96 0 0 96 80 0 0 128L64 416l0-160L0 256l0-48zm544 96l-192 0 0 144 192 0 0-144zm-240 0l0-48 48 0 192 0 48 0 0 48 0 144 48 0 0 32-32 32-16 0-48 0-192 0-48 0-16 0-32-32 0-32 48 0 0-144z"]
};
const faLaptopHouse = faHouseLaptop;
const faFaceTired = {
  prefix: 'fass',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-128c-48.9 0-93.5 16.8-127.4 44.3c-.4-4.1-.6-8.2-.6-12.3c0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3C349.5 400.8 304.9 384 256 384zM112 144l118.9 64L112 272l45.7-64L112 144zm169.1 64L400 144l-45.7 64L400 272 281.1 208z"]
};
const faTired = faFaceTired;
const faMoneyBills = {
  prefix: 'fass',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M96 32l0 352 544 0 0-352L96 32zm64 224c35.3 0 64 28.7 64 64l-64 0 0-64zM224 96c0 35.3-28.7 64-64 64l0-64 64 0zM576 256l0 64-64 0c0-35.3 28.7-64 64-64zM512 96l64 0 0 64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faBlindsRaised = {
  prefix: 'fass',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M32 0L0 0 0 64l16 0L0 128l128 0 0-64 32 0 0 64 352 0L496 64l16 0 0-64L480 0 32 0zM144 512c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 224l352 0-16-64-336 0 0 64-32 0 0-64L16 160 0 224l128 0 0 194.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faSmog = {
  prefix: 'fass',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M192 287.1c-5.3 .6-10.6 .9-16 .9L32 288l0-144C32 64.5 96.5 0 176 0c34.5 0 66.1 12.1 90.9 32.3C289.6 12.2 319.4 0 352 0c49.1 0 91.8 27.7 113.2 68.3C475 65.5 485.3 64 496 64c61.9 0 112 50.1 112 112l0 112-112 0-27.3 0c-22.6 19.9-52.2 32-84.7 32s-62.1-12.1-84.7-32L192 288l0-.9zM616 368l24 0 0 48-24 0-336 0-24 0 0-48 24 0 336 0zm-64 96l24 0 0 48-24 0-112 0-24 0 0-48 24 0 112 0zm-192 0l24 0 0 48-24 0L24 512 0 512l0-48 24 0 336 0zM224 368l0 48-24 0L96 416l-24 0 0-48 24 0 104 0 24 0z"]
};
const faUfoBeam = {
  prefix: 'fass',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M184 152s24 40 104 40s104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104zm-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4zM256 256l32 32 32-32-32-32-32 32zM96 176L64 208l32 32 32-32L96 176zm352 32l32 32 32-32-32-32-32 32zM74.1 326.3l4.2-9.5c14.2 5.6 29.6 10.6 45.9 15l-6.2 14-64 144-9.7 21.9L.3 492.2l9.7-21.9 64-144zm384 19.5l-6.2-14c16.3-4.4 31.6-9.4 45.9-15l4.2 9.5 64 144 9.7 21.9-43.9 19.5-9.7-21.9-64-144z"]
};
const faHydra = {
  prefix: 'fass',
  iconName: 'hydra',
  icon: [640, 512, [], "e686", "M156.8 0L168 0l4.8 0c46 0 83.2 37.2 83.2 83.2l0 28.8 0 16 0 34.9 0 1.3 0 4.5 0 .6c0 .5 0 .9 0 1.4c.8 46.8 40 85.3 87.8 85.3l5.3 0 9.2 0 .1 0c46.7 0 90.3 23.4 116.2 62.2l10.7 16.1c7.4 11 19.7 17.7 33 17.7c32.1 0 50.9-36.1 32.5-62.4l-33.1-47.2 45.4-44 25.6 19.2C621 241.8 640 279.7 640 320c0 70.7-57.3 128-128 128l-32 0 0 64-96 0-10.7-64-74.7 0L288 512l-96 0 0-68c-55.2-14.2-96-64.3-96-124l0-64-64 0L0 256l0-47.4L12 199l40-32 8.8-7L72 160l8 0c35.1 0 64.9 22.6 75.7 54L152 287.2l-.3 5.8 3.5 4.6 24 32 9.6 12.8 25.6-19.2-9.6-12.8L184.3 283 192 128.8l0-.4 0-.4 0-16 0-16-16 0-16 0-32 0L96 96l0-47.4L108 39 148 7l8.8-7zM288 170.3l0-52.6C303.8 85.6 336.8 64 374.2 64l1.8 0 11.2 0 8.8 7 40 32 12 9.6 0 47.4-32 0-71 0-9.6 38.5-4 24.1c-24.6-5.6-42.9-27.3-43.3-52.3z"]
};
const faCircleCaretUp = {
  prefix: 'fass',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272L256 144 384 272l0 32-256 0 0-32z"]
};
const faCaretCircleUp = faCircleCaretUp;
const faUserVneckHairLong = {
  prefix: 'fass',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zm0 416l-72-96-88 0L0 512l448 0L384 320l-88 0-72 96z"]
};
const faSquareALock = {
  prefix: 'fass',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M0 32l448 0 0 129.1c-54.3 7.8-96 54.4-96 110.9l0 16-32 0-5.7 0L245.7 141.8 239.2 128l-30.5 0-6.5 13.8L88.6 384l53 0 22.5-48 119.7 0 22.5 48 13.6 0 0 96L0 480 0 32zM261.3 288l-74.6 0L224 208.5 261.3 288zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faCrutch = {
  prefix: 'fass',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M334.4 1.1L289.1 46.4 311.8 69 443 200.2l22.6 22.6 45.3-45.3L488.2 155 357 23.8 334.4 1.1zM209.3 161.5l-55.9 55.9-6.3 6.3-2.1 8.6L115.1 351.6 73.4 393.4c0 0 0 0-.1 .1L.4 466.3l45.3 45.3 73-73 41.7-41.7L279.8 367l8.6-2.2 6.3-6.3 56-56 74.7-74.7-45.3-45.3L328 234.7 277.3 184l52.1-52.1L284.1 86.6l-74.6 74.6-.1 .1-.1 .1zM232 229.3L282.7 280l-27.1 27.1L188 324l16.9-67.7L232 229.3z"]
};
const faGasPumpSlash = {
  prefix: 'fass',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M96 0L384 0l0 275.4L521.4 382c4.2-6.3 6.6-13.9 6.6-22l0-136-48 0 0-128L432 48l32-32L576 128l0 40 0 24 0 32 0 136c0 19.2-6.2 37-16.6 51.5l61.6 47.8 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L96 51.8 96 0zm0 171.6L384 398.5l0 17.5L96 416l0-244.4zM64 448l352 0 0 32 0 32L64 512l0-64z"]
};
const faFontAwesome = {
  prefix: 'fass',
  iconName: 'font-awesome',
  icon: [512, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 352 0 64 64 0 0-64 400 0 0-32L432 272l64-144 0-32L91.7 96z"]
};
const faFontAwesomeFlag = faFontAwesome;
const faFontAwesomeLogoFull = faFontAwesome;
const faCloudArrowUp = {
  prefix: 'fass',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zm79-217l-17 17L240 313.9l17-17 39-39L296 392l0 24 48 0 0-24 0-134.1 39 39 17 17L433.9 280l-17-17-80-80-17-17-17 17-80 80z"]
};
const faCloudUpload = faCloudArrowUp;
const faCloudUploadAlt = faCloudArrowUp;
const faPalette = {
  prefix: 'fass',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M256 0C397.4 0 512 114.6 512 256l0 64-156.1 0c-37.5 0-67.9 30.4-67.9 67.9c0 18 7.2 35.3 19.9 48L320 448l-64 64C114.6 512 0 397.4 0 256S114.6 0 256 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTransporter4 = {
  prefix: 'fass',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M224 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm0 64l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm-48 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm-32 64l224 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0zm-32 64l288 0 16 0 0 32-16 0-288 0-16 0 0-32 16 0zm64 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zM416 512l-120 0-80 0L96 512l0-64 320 0 0 64zM64 384l32 16L64 416 48 448 32 416 0 400l32-16 16-32 16 32zM464 128l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32z"]
};
const faChartMixedUpCircleCurrency = {
  prefix: 'fass',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M400 0L368 0l0 64 32 0 28.8 0L319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199l40 50L192.6 136.5l108.2 81.1 19.3 14.5c4.4-3.6 9-7.1 13.8-10.3l6-4.8L480 105l0 39 0 32 64 0 0-32 0-112 0-32L512 0 400 0zM160 224l0 256 64 0 0-256-64 0zM32 320l0 160 64 0 0-160-64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-25.3 25.3-22.6-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L396.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]
};
const faObjectsAlignRight = {
  prefix: 'fass',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 512l-48 0L464 0l48 0 0 512zM384 64l0 160L0 224 0 64l384 0zm0 224l0 160-256 0 0-160 256 0z"]
};
const faArrowsTurnRight = {
  prefix: 'fass',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M342.6 25.4L320 2.7 274.7 48l22.6 22.6L322.7 96 32 96 0 96l0 32L0 256l0 32 64 0 0-32 0-96 258.7 0-25.4 25.4L274.7 208 320 253.3l22.6-22.6 80-80L445.3 128l-22.6-22.6-80-80zm-80 256L240 258.7 194.7 304l22.6 22.6L242.7 352 32 352 0 352l0 32 0 96 0 32 64 0 0-32 0-64 178.7 0-25.4 25.4L194.7 464 240 509.3l22.6-22.6 80-80L365.3 384l-22.6-22.6-80-80z"]
};
const faVest = {
  prefix: 'fass',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M207.1 237.4L151.2 69.7C168.7 79.8 192.7 88 224 88s55.3-8.2 72.8-18.3L224 288l0 224 224 0 0-256-64-96 0-32 0-104 0-24L360 0 320 0l-7 0L299.6 0l-6.9 11.1-.3 .4c-.4 .6-1.2 1.5-2.3 2.8c-2.3 2.6-6.1 6.3-11.5 10.1C268.1 31.8 250.6 40 224 40s-44.1-8.2-54.7-15.6c-5.4-3.8-9.2-7.5-11.5-10.1c-1.1-1.3-1.9-2.3-2.3-2.8l-.3-.4L148.4 0 135 0l-7 0L88 0 64 0l0 24 0 104 0 32L0 256 0 512l192 0 0-224 0-5.2 1.6-4.9 13.5-40.5zM336 345.4l11.3 11.3 48 48L406.6 416 384 438.6l-11.3-11.3-48-48L313.4 368 336 345.4zM100.7 356.7L112 345.4 134.6 368l-11.3 11.3-48 48L64 438.6 41.4 416l11.3-11.3 48-48z"]
};
const faPig = {
  prefix: 'fass',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M453.1 46L528 32l0 46c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3l40 0 16 0 0 32c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224l32 0 0 144-67.5 0c-22.2 21.2-49.7 36.2-79.8 43.3L473.1 480 384 480l0-64-64 0-48 0 0 64-89.1 0L155 382.4C110.3 358 80 310.5 80 256l0-16-32.6 0C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2 7.8 31-8.2 2c-6.9 1.7-11.7 7.9-11.7 15c0 8.5 6.9 15.4 15.4 15.4l35.8 0C98 135 162.6 80 240 80l122.4 0c14.6 0 29 1.4 43.1 4c8.4-19.3 25.9-33.8 47.7-37.9zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
const faInboxFull = {
  prefix: 'fass',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M71 32l25 0 320 0 25 0L447 56.2l64 256 1 3.8 0 3.9 0 128 0 32-32 0L32 480 0 480l0-32L0 320l0-3.9 1-3.8 64-256L71 32zm50 64L73 288l71 0 32 64 160 0 32-64 71 0L391 96 121 96zm55 48l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm-32 80l224 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0z"]
};
const faCircleEnvelope = {
  prefix: 'fass',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 204.1l0-44.1 256 0 0 44.1L256 254.8 128 204.1zm133.9 82.8L384 238.5 384 352l-256 0 0-113.5 122.1 48.4 5.9 2.3 5.9-2.3z"]
};
const faEnvelopeCircle = faCircleEnvelope;
const faTrianglePersonDigging = {
  prefix: 'fass',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M320 32L64 480l512 0L320 32zM285.9 225.1l40 16 5.6 2.3 2.7 5.4 27.6 55.3 52.1 31.3L432 304l64 112-128 0 30.2-52.8-56.7-34-85.7-51.4-14.4-8.6 9.3-14 16-24 7.2-10.8 12.1 4.8zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM237.2 307.4l14.9 9.3 60.3 37.7 7.5 4.7 0 8.9 0 32 0 16-16 0-16 0 0-16 0-23.1-37.9-23.7L218.9 416l-35.7 0 2.6-5.1 43.7-87.7 7.9-15.8z"]
};
const faConstruction = faTrianglePersonDigging;
const faFerry = {
  prefix: 'fass',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M224 0L352 0l32 0 0 32 48 0 48 0 0 32L468 80 456 96 120 96 108 80 96 64l0-32 48 0 48 0 0-32 32 0zM64 128l448 0 0 176-60.2 84.3c-9.7 6.9-17.7 12.1-27.1 16.4C411.6 410.7 397 415 384 415s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0s0 0 0 0L288 368l-18.6 13.4-1.1 .8s0 0 0 0s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 410.7 205 415 192 415s-27.6-4.3-40.7-10.3c-9.4-4.3-17.4-9.5-27.1-16.4L64 304l0-176zm64 64l0 96 320 0 0-96-320 0zM272.4 493.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faBullseyeArrow = {
  prefix: 'fass',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M366.4 213.5l28.6 4.8c3.3 12 5 24.7 5 37.7c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144c13.1 0 25.7 1.7 37.7 5l4.8 28.6-31.2 31.2c-3.7-.5-7.5-.8-11.3-.8c-44.2 0-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80c0-3.8-.3-7.6-.8-11.3l31.2-31.2zM448 256c0-10.9-.9-21.6-2.7-32.1l9.3-9.3 43.1-43.1C507 198 512 226.4 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c29.6 0 58 5 84.5 14.3L297.4 57.4l-9.3 9.3C277.6 64.9 266.9 64 256 64C150 64 64 150 64 256s86 192 192 192s192-86 192-192zm-12.3-67.7L432 192l-66.9-11.2L265 281 231 247 331.2 146.9 320 80l3.7-3.7 48.5-48.5L400 0l25.7 64.4L432 80l15.6 6.3L512 112l-27.8 27.8-48.5 48.5z"]
};
const faArrowsDownToPeople = {
  prefix: 'fass',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M120 0l48 0 0 24 0 118.1 23-23 17-17L241.9 136l-17 17-64 64-17 17-17-17L63 153l-17-17L80 102.1l17 17 23 23L120 24l0-24zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM104 296a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm392-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM81.9 352L96 352l96 0 14 0 44.9-83.4 6.8-12.6 14.3 0 96 0 14.3 0 6.8 12.6L434 352l14 0 96 0 14.1 0 6.9 12.3 56 100.8 11.7 21-42 23.3-11.7-21-27-48.6 0 72.2-112 0 0-72.2-27 48.6-11.7 21-42-23.3 11.7-21 35.2-63.4-3.4-6.3L376 345.5l0 86.5-112 0 0-86.5-26.9 49.9-3.4 6.3L269 465.1l11.7 21-42 23.3-11.7-21-27-48.6 0 72.2L88 512l0-72.2L61 488.5l-11.7 21-42-23.3 11.7-21L75 364.3 81.9 352zM415 153l-17-17L432 102.1l17 17 23 23L472 24l0-24 48 0 0 24 0 118.1 23-23 17-17L593.9 136l-17 17-64 64-17 17-17-17-64-64z"]
};
const faSeedling = {
  prefix: 'fass',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M512 0l0 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0l64 0zM0 64l64 0c123.7 0 224 100.3 224 224l0 32 0 160 0 32-64 0 0-32 0-160C100.3 320 0 219.7 0 96L0 64z"]
};
const faSprout = faSeedling;
const faClockSeven = {
  prefix: 'fass',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 128.7-60 90-13.3 20 39.9 26.6 13.3-20 64-96 4-6 0-7.3 0-136 0-24-48 0 0 24z"]
};
const faLeftRight = {
  prefix: 'fass',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M384 128L512 256 384 384l-32 0 0-80-192 0 0 80-32 0L0 256 128 128l32 0 0 80 192 0 0-80 32 0z"]
};
const faArrowsAltH = faLeftRight;
const faBoxesPacking = {
  prefix: 'fass',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M640 0L256 0l0 128 160 0 0 128-32 0 0 256 256 0L640 0zM507.3 260.7l64 64-22.6 22.6L512 310.6 512 432l0 16-32 0 0-16 0-121.4-36.7 36.7-22.6-22.6 64-64L496 249.4l11.3 11.3zM0 160l0 64 384 0 0-64L0 160zm352 96L32 256l0 256 320 0 0-256zm-96 64l0 32-128 0 0-32 128 0z"]
};
const faCircleArrowLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM103 239L215 127l17-17L265.9 144l-17 17-71 71L392 232l24 0 0 48-24 0-214.1 0 71 71 17 17L232 401.9l-17-17L103 273l-17-17 17-17z"]
};
const faArrowCircleLeft = faCircleArrowLeft;
const faFlashlight = {
  prefix: 'fass',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M576 416l64 0 0-320-64 0 0 320zM544 97.7C449.1 107.9 384 160 384 160L0 160 0 352l384 0s65.1 52.1 160 62.3l0-316.5zM224 224l96 0 0 64-96 0 0-64z"]
};
const faFileJpg = {
  prefix: 'fass',
  iconName: 'file-jpg',
  icon: [512, 512, [], "e646", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM208 512c-26.5 0-48-21.5-48-48l0-16 0-16 32 0 0 16 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 0-16 32 0 0 16 0 96c0 26.5-21.5 48-48 48zM456 352l16 0c22.1 0 40 17.9 40 40l0 16-32 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8-16 0 0-32 16 0 16 0 16 0 0 16 0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm-168 0l16 0 32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16zm32 80l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48z"]
};
const faGroupArrowsRotate = {
  prefix: 'fass',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M159.7 89.9c20.8-12.1 44-20.4 68.8-23.9L219.5 2.6c-35.2 5-68.1 17.2-97.2 35.1C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-17.8 29.1-30 61.9-35 97.2l63.4 9.1c3.5-24.8 11.8-48 23.9-68.8c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1zm262.4 69.9c12.1 20.8 20.4 44 23.9 68.8l63.4-9.1c-5-35.2-17.2-68.1-35-97.2c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-29.1-17.8-61.9-30-97.2-35.1l-9.1 63.4c24.8 3.5 48 11.8 68.8 23.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.1-.3zM89.9 352.3c-12.1-20.8-20.4-44-23.9-68.8L2.6 292.5c5 35.2 17.2 68.1 35.1 97.2C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c29.1 17.8 61.9 30 97.2 35l9.1-63.4c-24.8-3.5-48-11.8-68.8-23.9c.2-2 .3-4.1 .3-6.1c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3zm262.4 69.9c-20.8 12.1-44 20.4-68.8 23.9l9.1 63.4c35.2-5 68.1-17.2 97.2-35c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c17.8-29.1 30-61.9 35-97.2l-63.4-9.1c-3.5 24.8-11.8 48-23.9 68.8c-2-.2-4.1-.3-6.1-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.1zM227.7 313.8c-20.8-10.6-34.9-32.2-34.9-57c0-15.6 5.6-29.9 14.9-41.1l25.9 25.9 0-81.6L152 160l21.7 21.7c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8l21.8-42.7zm93.1-58.6c0 15.6-5.6 29.9-14.9 41.1L280 270.4l0 81.6 81.6 0-21.7-21.7c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8l-21.8 42.7c20.8 10.6 34.9 32.2 34.9 57z"]
};
const faBowlFood = {
  prefix: 'fass',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32L8.6 224C3.1 214.6 0 203.7 0 192zm0 88l0-24 512 0 0 24c0 67-39.2 124.9-96 151.8l0 48.2L96 480l0-48.2C39.2 404.9 0 347 0 280z"]
};
const faSquare9 = {
  prefix: 'fass',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M0 32l448 0 0 448L0 480 0 32zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm96-48c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3l-44.4 48.4L153.4 384l65.1 0 68.1-74.3c21.4-23.4 33.3-54 33.3-85.7z"]
};
const faCandyCane = {
  prefix: 'fass',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23l0 5.6c0 9.9-5.1 19.1-13.5 24.3L14.5 403.5 82.4 512l356-222.5c45.8-28.6 73.6-78.8 73.6-132.8l0-5.6C512 67.6 444.4 0 361 0c-28.3 0-56 8-80 23L200.4 73.3l67.8 108.5 80.5-50.3zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"]
};
const faArrowDownWideShort = {
  prefix: 'fass',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M320 480l-32 0 0-64 32 0 32 0 32 0 0 64-32 0-32 0zm0-128l-32 0 0-64 32 0 96 0 32 0 0 64-32 0-96 0zm0-128l-32 0 0-64 32 0 160 0 32 0 0 64-32 0-160 0zm0-128l-32 0 0-64 32 0 224 0 32 0 0 64-32 0L320 96zM151.7 469.5l-23.7 26-23.7-26-80-88L2.8 357.8l47.4-43 21.5 23.7L96 365.2 96 80l0-32 64 0 0 32 0 285.2 24.3-26.8 21.5-23.7 47.4 43-21.5 23.7-80 88z"]
};
const faSortAmountAsc = faArrowDownWideShort;
const faSortAmountDown = faArrowDownWideShort;
const faSquareDollar = {
  prefix: 'fass',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M448 32L0 32 0 480l448 0 0-448zM244.2 149.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 36.8L201 400l0-38.9c-11.7-2.6-26.7-7.4-36.6-10.6c0 0 0 0 0 0c-6.6-2.1-13.1-4.2-19.7-6.2c-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2c2.2 .7 4.4 1.4 6.6 2.1c7.3 2.3 14.6 4.6 21.9 6.9c0 0 0 0 0 0c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7l0-38.3 43.2 0 0 37.4z"]
};
const faDollarSquare = faSquareDollar;
const faUsdSquare = faSquareDollar;
const faPhoneArrowRight = {
  prefix: 'fass',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M144 0L0 32 0 64C0 311.4 200.6 512 448 512l32 0 32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0zM413.8 23l-17-17L362.9 40l17 17 39 39L312 96l-24 0 0 48 24 0 106.9 0-39 39-17 17 33.9 33.9 17-17 80-80 17-17-17-17-80-80z"]
};
const faHandHoldingSeedling = {
  prefix: 'fass',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M96 0c0 88.4 71.6 160 160 160l0 96 0 32 64 0 0-32 0-96C320 71.6 248.4 0 160 0L96 0zM480 0L416 0c-40.7 0-77.8 15.2-106 40.1c25.7 32.1 41.3 72.6 42 116.7C425 142 480 77.4 480 0zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faMessageCheck = {
  prefix: 'fass',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM369 153l17-17L352 102.1l-17 17-111 111-47-47-17-17L126.1 200l17 17 64 64 17 17 17-17L369 153z"]
};
const faCommentAltCheck = faMessageCheck;
const faCloudBolt = {
  prefix: 'fass',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M0 320l96 0 48 0L312.6 192l51 0-40 128 76.5 0 16 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96zm232 64L192 512 368 376l0-24-88 0 40-128L144 360l0 24 88 0z"]
};
const faThunderstorm = faCloudBolt;
const faChartLineUpDown = {
  prefix: 'fass',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm416 0L352 64 336 80l41.4 41.4L288 210.7l-57.4-57.4L208 130.7l-22.6 22.6-88 88 45.3 45.3L208 221.3l57.4 57.4L288 301.3l22.6-22.6 112-112L464 208l16-16 0-128zm0 320l0-128-16-16-41.4 41.4-34.7-34.7-45.3 45.3 34.7 34.7L336 368l16 16 128 0z"]
};
const faTextSlash = {
  prefix: 'fass',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L355.7 253.4 400.2 96 503 96 497 120.2 487 160l66 0 6.1-24.2 16-64L585 32l-41 0L192 32l-25 0L161 56.2l-9.6 38.5L48.4 14.8zM206.6 137.6l.5-1.9L217 96l116.7 0L301.2 211.1l-94.6-73.4zM327.3 353.9L272.9 311 243.3 416 192 416l-32 0 0 64 32 0 160 0 32 0 0-64-32 0-42.2 0 17.6-62.1z"]
};
const faRemoveFormat = faTextSlash;
const faWatch = {
  prefix: 'fass',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M320 0l0 72.2C283.7 46.8 239.6 32 192 32s-91.7 14.8-128 40.2L64 0 320 0zm0 439.8l0 72.2L64 512l0-72.2c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2zM0 256a192 192 0 1 1 384 0A192 192 0 1 1 0 256zm216-80l0-24-48 0 0 24 0 80 0 12.8 10.7 7.1 48 32 20 13.3 26.6-39.9-20-13.3L216 243.2l0-67.2z"]
};
const faCircleDownLeft = {
  prefix: 'fass',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 192l0 160 160 0 24-24-52-52 76-76-56-56-76 76-52-52-24 24z"]
};
const faText = {
  prefix: 'fass',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M0 32l32 0 160 0 64 0 160 0 32 0 0 32 0 64 0 32-64 0 0-32 0-32L256 96l0 320 48 0 32 0 0 64-32 0-160 0-32 0 0-64 32 0 48 0 0-320L64 96l0 32 0 32L0 160l0-32L0 64 0 32z"]
};
const faProjector = {
  prefix: 'fass',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M440 24l0-24L392 0l0 24 0 80 0 24 48 0 0-24 0-80zM281 39l-17-17L230.1 56l17 17 56 56 17 17L353.9 112 337 95 281 39zM585 73l17-17L568 22.1 551 39 495 95l-17 17L512 145.9l17-17 56-56zm55 119l-128 0c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32L0 192 0 448l64 0 16 64 64 0 16-64 160 0c26.7 20.1 60 32 96 32c24.4 0 47.5-5.5 68.2-15.2L496 512l64 0 16-64 64 0 0-256zM416 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFaceSmileWink = {
  prefix: 'fass',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM129.7 327.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm148.4 29.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z"]
};
const faSmileWink = faFaceSmileWink;
const faTombstoneBlank = {
  prefix: 'fass',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M224 0C118 0 32 86 32 192l0 224 384 0 0-224C416 86 330 0 224 0zM32 448L0 448l0 64 32 0 384 0 32 0 0-64-32 0L32 448z"]
};
const faTombstoneAlt = faTombstoneBlank;
const faChessKingPiece = {
  prefix: 'fass',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16l0-16L112 0l0 16 0 16L96 32 80 32l0 32 16 0 16 0 0 32L40 96l0 32 28.6 80L48 208l0 48 24 0 5.8 0L60.4 384l135.3 0L178.2 256l5.8 0 24 0 0-48-20.6 0L216 128l0-32-72 0 0-32 16 0 16 0 0-32-16 0-16 0 0-16zM43.9 416l-2.4 3.4-40 56L0 477.4 0 480l0 24 0 8 8 0 240 0 8 0 0-8 0-24 0-2.6-1.5-2.1-40-56-2.4-3.4-4.1 0L48 416l-4.1 0z"]
};
const faChessKingAlt = faChessKingPiece;
const faCircle6 = {
  prefix: 'fass',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-49.2-37-89.8-84.7-95.3l44.4-48.4L326.6 128l-65.1 0-68.1 74.3c-21.4 23.4-33.3 54-33.3 85.7z"]
};
const faWavesSine = {
  prefix: 'fass',
  iconName: 'waves-sine',
  icon: [640, 512, [], "e65d", "M256.2 140.6c-11 18.2-20.4 40.1-29.3 64.6c-9.2-27.9-19.8-57.4-32.9-84.7c2.4-4.5 4.9-8.9 7.5-13.2C226.3 66.4 263.3 32 320 32s93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C563 402.4 582.6 416 608 416l32 0 0 64-32 0c-56.7 0-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C365 109.6 345.4 96 320 96s-45 13.6-63.8 44.6zM158.1 391.4c-2.4 4.5-4.9 8.9-7.5 13.2C125.7 445.6 88.7 480 32 480L0 480l0-64 32 0c25.4 0 45-13.6 63.8-44.6c11-18.2 20.4-40.1 29.3-64.6c9.2 27.9 19.8 57.4 32.9 84.7zm225.8-20c11-18.2 20.4-40.1 29.3-64.6c9.2 27.9 19.8 57.4 32.9 84.7c-2.4 4.5-4.9 8.9-7.5 13.2C413.7 445.6 376.7 480 320 480s-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5c0 0 0 0 0 0l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C77 109.6 57.4 96 32 96L0 96 0 32l32 0c56.7 0 93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C275 402.4 294.6 416 320 416s45-13.6 63.8-44.6zM544.2 140.6c-11 18.2-20.4 40.1-29.3 64.6c-9.2-27.9-19.8-57.5-32.9-84.7c2.4-4.5 4.9-8.9 7.5-13.2C514.3 66.4 551.3 32 608 32l32 0 0 64-32 0c-25.4 0-45 13.6-63.8 44.6z"]
};
const faLeft = {
  prefix: 'fass',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M0 256L192 448l32 0 0-128 224 0 0-128-224 0 0-128-32 0L0 256z"]
};
const faArrowAltLeft = faLeft;
const faFileWord = {
  prefix: 'fass',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM107.6 240l31.7 109.3L164 257.7l4.8-17.7 18.4 0 9.6 0 18.4 0 4.8 17.7 24.7 91.5L276.4 240l50 0L271.1 430.7 266 448l-18 0-8 0-18.4 0-4.8-17.7-24.8-92-24.8 92L162.4 448 144 448l-8 0-18 0-5-17.3L57.7 240l50 0z"]
};
const faFilePowerpoint = {
  prefix: 'fass',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM136 240l68 0c42 0 76 34 76 76s-34 76-76 76l-44 0 0 32 0 24-48 0 0-24 0-56 0-104 0-24 24 0zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28l-44 0 0 56 44 0z"]
};
const faSquareDown = {
  prefix: 'fass',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M0 480l448 0 0-448L0 32 0 480zM96 256l80 0 0-128 96 0 0 128 80 0 0 16L224 400 96 272l0-16z"]
};
const faArrowAltSquareDown = faSquareDown;
const faObjectsAlignCenterVertical = {
  prefix: 'fass',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M64 32l160 0 0 200 64 0 0-136 160 0 0 136 64 0 0 48-64 0 0 136-160 0 0-136-64 0 0 200L64 480l0-200L0 280l0-48 64 0L64 32z"]
};
const faArrowsLeftRight = {
  prefix: 'fass',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M486.6 278.6L509.3 256l-22.6-22.6-96-96L368 114.7 322.7 160l22.6 22.6L386.7 224l-261.5 0 41.4-41.4L189.3 160 144 114.7l-22.6 22.6-96 96L2.7 256l22.6 22.6 96 96L144 397.3 189.3 352l-22.6-22.6L125.3 288l261.5 0-41.4 41.4L322.7 352 368 397.3l22.6-22.6 96-96z"]
};
const faArrowsH = faArrowsLeftRight;
const faHouseLock = {
  prefix: 'fass',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M288.4 0L488.7 167.1C446.2 183 416 224 416 272l0 16-32 0 0 224-32 0 0-160-128 0 0 160L64.1 512l0-224.4L0 287.6 0 240 288.4 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faCloudArrowDown = {
  prefix: 'fass',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zm79-167l80 80 17 17 17-17 80-80 17-17L400 262.1l-17 17-39 39L344 184l0-24-48 0 0 24 0 134.1-39-39-17-17L206.1 296l17 17z"]
};
const faCloudDownload = faCloudArrowDown;
const faCloudDownloadAlt = faCloudArrowDown;
const faWreath = {
  prefix: 'fass',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5l0-23.5 0-44.4-42.1 14L224 382.3l-85.9-28.6L96 339.6 96 384l0 23.5c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0zM224 120l-29.8 31.9-43.7-1.5 1.5 43.7L120 224l31.9 29.8-1.5 43.7 43.7-1.5L224 328l29.8-31.9 43.7 1.5-1.5-43.7L328 224l-31.9-29.8 1.5-43.7-43.7 1.5L224 120zM128 384l96 32 96-32 0 128-96-32-96 32 0-128z"]
};
const faChildren = {
  prefix: 'fass',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160 128A64 64 0 1 0 160 0a64 64 0 1 0 0 128zm-41.5 32l-16.2 0-9.6 13.1-70.5 96L3.3 294.9l51.6 37.9 18.9-25.8L88 287.6l0 .4 0 2.3L56 400l32 0 0 80 0 32 64 0 0-32 0-80 16 0 0 80 0 32 64 0 0-32 0-80 32 0L232 290.3l0-2.3 0-.4 14.2 19.3 18.9 25.8 51.6-37.9-18.9-25.8-70.5-96L217.7 160l-16.2 0-83 0zM480 128A64 64 0 1 0 480 0a64 64 0 1 0 0 128zm-41.5 32l-16.2 0-9.6 13.1-70.5 96-18.9 25.8 51.6 37.9 18.9-25.8L408 287.6 408 480l0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-192.4 14.2 19.3 18.9 25.8 51.6-37.9-18.9-25.8-70.5-96L537.7 160l-16.2 0-83 0z"]
};
const faMeterDroplet = {
  prefix: 'fass',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400l0-2.1c0-28.3 8.2-56 23.7-79.7L499.6 177C466.3 74.3 369.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm144 32L434.5 335.6c-12.1 18.5-18.5 40.2-18.5 62.3l0 2.1c0 61.9 50.1 112 112 112s112-50.1 112-112l0-2.1c0-22.1-6.4-43.7-18.5-62.3L528 192z"]
};
const faChalkboard = {
  prefix: 'fass',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M64 32L32 32l0 32 0 320 64 0L96 96l384 0 0 288 64 0 0-320 0-32-32 0L64 32zM224 352l0 64L32 416 0 416l0 64 32 0 512 0 32 0 0-64-32 0-128 0 0-64-192 0z"]
};
const faBlackboard = faChalkboard;
const faUserLargeSlash = {
  prefix: 'fass',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M576 512l-48 0L284.3 320 144 320 64 512l512 0s0 0 0 0zM382.2 273.9C430.6 250.7 464 201.3 464 144C464 64.5 399.5 0 320 0C250.1 0 191.8 49.9 178.7 116L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L382.2 273.9z"]
};
const faUserAltSlash = faUserLargeSlash;
const faSignalStrong = {
  prefix: 'fass',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M480 128l0-32-64 0 0 32 0 352 0 32 64 0 0-32 0-352zM352 224l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256zM224 288l-64 0 0 32 0 160 0 32 64 0 0-32 0-160 0-32zM96 416l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64z"]
};
const faSignal4 = faSignalStrong;
const faLollipop = {
  prefix: 'fass',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72l0-16-48 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 53-43 96-96 96l-8 0C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c41.5 0 79.9-13.1 111.2-35.5L465.4 510.6l45.3-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192C384 86 298 0 192 0S0 86 0 192z"]
};
const faLollypop = faLollipop;
const faListTree = {
  prefix: 'fass',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M96 48L0 48l0 96 24 0 0 112 0 160 0 24 24 0 80 0 0 24 96 0 0-96-96 0 0 24-56 0 0-112 56 0 0 24 96 0 0-96-96 0 0 24-56 0 0-88 24 0 0-96zm64 16l0 64 32 0 288 0 32 0 0-64-32 0L192 64l-32 0zM288 224l0 64 32 0 160 0 32 0 0-64-32 0-160 0-32 0zm0 160l0 64 32 0 160 0 32 0 0-64-32 0-160 0-32 0z"]
};
const faEnvelopeOpen = {
  prefix: 'fass',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M64 246.9L256 384 448 246.9l0-22.9L256 80 64 224l0 22.9zM0 192L256 0 512 192l0 256 0 64-64 0L64 512 0 512l0-64L0 192z"]
};
const faDrawCircle = {
  prefix: 'fass',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M104 206c14.7 11.7 24 29.8 24 50s-9.4 38.3-24 50c15.8 48.2 53.9 86.2 102 102c11.7-14.7 29.8-24 50-24s38.3 9.4 50 24c48.2-15.8 86.2-53.9 102-102c-14.7-11.7-24-29.8-24-50s9.4-38.3 24-50c-15.8-48.2-53.9-86.2-102-102c-11.7 14.7-29.8 24-50 24s-38.3-9.4-50-24c-48.2 15.8-86.2 53.9-102 102zm92.7 266.1c-76-20.8-135.9-80.7-156.7-156.7C16.5 305.8 0 282.8 0 256s16.5-49.8 39.9-59.3c20.8-76 80.7-135.9 156.7-156.7C206.2 16.5 229.2 0 256 0s49.8 16.5 59.3 39.9c76 20.8 135.9 80.7 156.7 156.7c23.4 9.5 39.9 32.5 39.9 59.3s-16.5 49.8-39.9 59.3c-20.8 76-80.7 135.9-156.7 156.7C305.8 495.5 282.8 512 256 512s-49.8-16.5-59.3-39.9z"]
};
const faCatSpace = {
  prefix: 'fass',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7l0 84.7c0 53 43 96 96 96s96-43 96-96l0-84.7c19.9 22.6 32 52.2 32 84.7zM416 96L374.9 54.9C395.6 40.5 420.8 32 448 32s52.4 8.5 73.1 22.9L480 96l-64 0zm64 220.8C553 302 608 237.4 608 160C608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1c-54.9 8.1-102.2 39.5-131.6 83.8l0-85.8c0-53-43-96-96-96L32 96l0 64 32 0c17.7 0 32 14.3 32 32l0 288 0 32 32 0 208 0 32 0 0-64-32 0-56 0L416 339.2 416 480l0 32 64 0 0-32 0-163.2zM400 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM241.3 46.7L224 0 206.7 46.7 160 64l46.7 17.3L224 128l17.3-46.7L288 64 241.3 46.7z"]
};
const faHandshakeSimpleSlash = {
  prefix: 'fass',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L509 372.4l6.8-7.4-35.4-32.4-134.2-123-23.4 18.2-26.1-20.3 77.4-60.2 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2L550.2 352l89.8 0 0-224-48 0-76 0-4 0-.7 0-3.9-2.5L411.3 64l-61.7 0L233.2 158.3l-26-20.2L298.8 64 224 64l-60.4 40.3L48.4 14.8zM0 128L0 352l156.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 34.2-37.3L40.6 128 0 128z"]
};
const faHandshakeAltSlash = faHandshakeSimpleSlash;
const faRabbitRunning = {
  prefix: 'fass',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M448 32l-24 0-4.7 16.5c-3.2 11.2-5 22.5-5.6 33.8c23.5 20.8 41.5 47.4 51.9 77.7l-25.6 0c-18-44.5-55.4-79-102.1-93L328 64 296 80l7.1 19.7c13.5 37.5 39.5 68.4 72.9 88.2l0 26.8L271.7 154.9C240.8 137.3 205.8 128 170.2 128c-32.3 0-62.2 16.8-78.9 44.4C81 159.9 65.4 152 48 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c4.9 17.2 14.5 33.1 28.4 45.9L258.4 439.6l9.2 8.4 12.4 0 128 0 32 0 0-64-32 0-64 0-16.8 0L312 384l0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8 8.8-30.8 30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7L568 320l0-88.9-71-57.9c8-48.9-7.6-99.1-42.8-135L448 32zM152.1 408.4l-26.8 17.5 35 53.6L187.1 462l28.2-18.4-48.7-44.6-14.5 9.5zM472 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faRabbitFast = faRabbitRunning;
const faMemoPad = {
  prefix: 'fass',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M0 0L0 96l448 0 0-96L0 0zM0 128L0 512l448 0 0-384L0 128zm96 80l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm0 96l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z"]
};
const faMattressPillow = {
  prefix: 'fass',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M256 64L0 64 0 448l256 0 0-384zm32 384l352 0 0-384L288 64l0 384zM64 128l128 0 0 256L64 384l0-256z"]
};
const faAlarmPlus = {
  prefix: 'fass',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6l-19.2 19.2L80 509.3 34.7 464l22.6-22.6 19.2-19.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l19.2 19.2L477.3 464 432 509.3l-22.6-22.6-19.2-19.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM280 176l-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24z"]
};
const faAlicorn = {
  prefix: 'fass',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M448 160l0 78.1 0 1.9s0 0 0 0c-.5 30-12.8 56.4-32 75.7L416 512l-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8L224 320l0 16 0 19.9-14.1 14.1-27 27 38.3 115-101.2 0L82.5 399.2 73.1 371l21-21 26.6-26.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256l0 56 0 24L0 336l0-24 0-56c0-44.6 33.2-81.5 76.3-87.2c13-21.4 35.2-36.5 61.1-40c3.8 15.3 9.2 29.8 16.5 43c11.3 20.4 27.4 37.7 49.9 49.8c7.5 4 15.5 7.4 24.2 10.1C139.8 173.7 160 32 160 32l160 96C320 57.3 377.3 0 448 0l32 0 64 0 16 0 0 32-16 0-16 0 16 16 96 0 0 16L560 90.7 560 192l-80 32-32-64zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faCommentQuestion = {
  prefix: 'fass',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM168 168l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 220.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 112c-30.9 0-56 25.1-56 56zm64 200l48 0 0-48-48 0 0 48z"]
};
const faGingerbreadMan = {
  prefix: 'fass',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M320 96c0 33.4-17 62.8-42.9 80l90.9 0 64 0 0 128-64 0-48 0 0 24.8 80 96 0 87.2-94 0-82-98.4L142 512l-94 0 0-87.2 80-96 0-24.8-48 0-64 0 0-128 64 0 90.9 0C145 158.8 128 129.4 128 96c0-53 43-96 96-96s96 43 96 96zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faGuaraniSign = {
  prefix: 'fass',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M224 0L160 0l0 66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3l0 66.7 64 0 0-66.7c90.8-15.2 160-94.2 160-189.3l0-32-32 0-128 0 0-92c22.1 5.7 41.8 17.1 57.6 32.6l44.8-45.7C299 92 263.5 73.3 224 66.7L224 0zM160 132L160 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380l0-92 92 0c-11.6 45-47 80.4-92 92z"]
};
const faBurgerFries = {
  prefix: 'fass',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M64 32L97.4 221.4 117.7 272l10.3 0 0-181.3L112 0 64 32zM18.7 192l41.1 0L41.8 90.5 0 80 18.7 192zM384 80L342.7 90.3 325.8 192l7.3 0c10.4-6.1 22-11.7 35-16.5L384 80zM256 512l0-208L96 304 64 224 0 224 64 512l192 0zm0-240l4 0c2.2-5.2 4.7-10.3 7.6-15.3c3.1-5.3 7-11.3 11.9-17.7l10.2-25.5L320 32 256 48l0 224zm-96 0l64 0 0-32 0-208L160 0l0 272zm480 15.8s-32-96-176-96s-176 96-176 96l0 32 352 0 0-32zm-256-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-256 112l0 64 352 0 0-64-352 0zm0 96l0 64 352 0 0-64-352 0z"]
};
const faMugTea = {
  prefix: 'fass',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M144 64l0 64L96 176l0 112 128 0 0-112-48-48 0-64 208 0 32 0 32 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 128L32 448 32 64l112 0zM416 256l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z"]
};
const faBorderTop = {
  prefix: 'fass',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 32l448 0 0 64L0 96 0 32zm0 96l64 0 0 64L0 192l0-64zm448 0l0 64-64 0 0-64 64 0zm-256 0l64 0 0 64-64 0 0-64zM64 320l0 64L0 384l0-64 64 0zm320 0l64 0 0 64-64 0 0-64zm-128 0l0 64-64 0 0-64 64 0zM0 224l64 0 0 64L0 288l0-64zm448 0l0 64-64 0 0-64 64 0zm-256 0l64 0 0 64-64 0 0-64zM64 416l0 64L0 480l0-64 64 0zm320 0l64 0 0 64-64 0 0-64zm-128 0l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm64 192l0 64-64 0 0-64 64 0zm128 0l64 0 0 64-64 0 0-64zm64-192l0 64-64 0 0-64 64 0z"]
};
const faArrowsRotate = {
  prefix: 'fass',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160l-32 0 0 64 32 0 112 0 32 0 0-32 0-112 0-32-64 0 0 32 0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4l60.4 21.3zM80 396.9l17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7l-60.4-21.3c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0 32 0 0-64-32 0L48 288l-32 0 0 32 0 112 0 32 64 0 0-32 0-35.1z"]
};
const faRefresh = faArrowsRotate;
const faSync = faArrowsRotate;
const faCircleBookOpen = {
  prefix: 'fass',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c-27.8 0-56 16-56 16l0-176s28.2-16 56-16s56 16 56 16l0 176s-28.2-16-56-16zm144 0c-27.8 0-56 16-56 16l0-176s28.2-16 56-16s56 16 56 16l0 176s-28.2-16-56-16z"]
};
const faBookCircle = faCircleBookOpen;
const faArrowsToDottedLine = {
  prefix: 'fass',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M256 32l0-32L192 0l0 32 0 32-64 0 0 32 96 96 96-96 0-32-64 0 0-32zM192 448l0 32 0 32 64 0 0-32 0-32 64 0 0-32-96-96-96 96 0 32 64 0zM64 224L0 224l0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z"]
};
const faFireExtinguisher = {
  prefix: 'fass',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M128 0l96 0 0 56 64 0 0-24L512 0l0 160L288 128l0-24-64 0 0 34.8c37.8 18 64 56.5 64 101.2l0 144L64 384l0-144c0-44.7 26.2-83.2 64-101.2l0-28.8c-36.2 11.1-66 36.9-82.3 70.5l-43.1-21C26.7 109.8 72.7 72.6 128 60.4L128 0zM288 512L64 512l0-96 224 0 0 96zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faMagnifyingGlassArrowsRotate = {
  prefix: 'fass',
  iconName: 'magnifying-glass-arrows-rotate',
  icon: [512, 512, [], "e65e", "M413.6 240c-5.2 33.6-18.4 64.5-37.6 90.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40c-53.4 0-102-20.1-138.9-53.1L24 408 0 384 0 240l144 0 24 24-53.5 53.5C139.6 339 172.3 352 208 352c68.5 0 125.9-47.9 140.4-112l65.1 0zM346.9 53.1L392 8l24 24 0 144-144 0-24-24 53.5-53.5C276.4 77 243.7 64 208 64C139.5 64 82.1 111.9 67.6 176L2.4 176C17.8 76.3 104 0 208 0c53.4 0 102 20.1 138.9 53.1z"]
};
const faGarageOpen = {
  prefix: 'fass',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M0 128L0 512l96 0 0-320 448 0 0 320 96 0 0-384L320 0 0 128zM176.7 320l-15.1 39.4-1.6 4.2 0 4.5 0 24 0 24 0 64 0 32 64 0 0-32 0-16 192 0 0 16 0 32 64 0 0-32 0-64 0-24 0-25.8 0-4.5-1.7-4.2L463.7 320l-51.5 0 6.3 16L222 336l6.2-16-51.4 0zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM512 224l-384 0 0 64 384 0 0-64z"]
};
const faShelvesEmpty = {
  prefix: 'fass',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M64 32L64 0 0 0 0 32 0 160l0 32 0 32L0 416l0 32 0 32 0 32 64 0 0-32 512 0 0 32 64 0 0-32 0-32 0-32 0-192 0-32 0-32 0-128 0-32L576 0l0 32 0 128L64 160 64 32zm0 192l512 0 0 192L64 416l0-192z"]
};
const faCruzeiroSign = {
  prefix: 'fass',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M96 256c0-88.4 71.6-160 160-160c47.8 0 90.6 20.9 120 54.2l48-42.4C383 61.4 322.9 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c66.9 0 127-29.4 168-75.8l-48-42.4C346.6 395.1 303.8 416 256 416l0-96 0-1.4c0-16.9 13.7-30.6 30.6-30.6c5.6 0 11 1.5 15.8 4.4l25.1 15.1 32.9-54.9-25.1-15.1c-14.7-8.8-31.5-13.5-48.7-13.5c-10.7 0-21 1.8-30.6 5.1l0-5.1-64 0 0 94.6 0 1.4 0 82.7C135.5 378 96 321.6 96 256z"]
};
const faWatchApple = {
  prefix: 'fass',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M64 0l0 48 256 0 0-48L64 0zM384 80L0 80 0 432l384 0 0-352zM192 213.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32 240L64 464l0 48 256 0 0-48z"]
};
const faWatchCalculator = {
  prefix: 'fass',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M64 0L320 0l0 48L64 48 64 0zm0 512l0-48 256 0 0 48L64 512zM0 80l384 0 0 352L0 432 0 80zm64 64l0 64 256 0 0-64L64 144zm48 104l-48 0 0 48 48 0 0-48zm56 0l0 48 48 0 0-48-48 0zm152 0l-48 0 0 48 48 0 0-48zM64 336l0 48 48 0 0-48-48 0zm152 0l-48 0 0 48 48 0 0-48zm56 0l0 48 48 0 0-48-48 0z"]
};
const faListDropdown = {
  prefix: 'fass',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M512 32L0 32 0 480l512 0 0-448zM448 192l0 224L64 416l0-224 384 0zM352 96l96 0-48 48L352 96zM128 232l-24 0 0 48 24 0 256 0 24 0 0-48-24 0-256 0zm0 96l-24 0 0 48 24 0 256 0 24 0 0-48-24 0-256 0z"]
};
const faCabinetFiling = {
  prefix: 'fass',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M0 0L448 0l0 240L0 240 0 0zM0 272l448 0 0 240L0 512 0 272zM128 96l0 16 0 32 0 16 32 0 0-16 0-16 128 0 0 16 0 16 32 0 0-16 0-32 0-16-16 0L144 96l-16 0zm0 256l0 16 0 32 0 16 32 0 0-16 0-16 128 0 0 16 0 16 32 0 0-16 0-32 0-16-16 0-160 0-16 0z"]
};
const faBurgerSoda = {
  prefix: 'fass',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M224 0L205 0l-4.4 18.5L174.9 128 32 128 0 128l0 64 32 0 301.1 0c14.5-8.5 31.3-16 50.9-21.6l0-42.4-32 0-127.8 0L243 48l37 0 24 0 0-48L280 0 224 0zM40 224L64 512l192 0 0-229.4c3-9.1 6.7-17.5 11.6-25.9c5.4-9.3 13.4-20.8 24.8-32.7L40 224zm600 63.8s-32-96-176-96s-176 96-176 96l0 32 352 0 0-32zm-256-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-256 112l0 64 352 0 0-64-352 0zm0 96l0 64 352 0 0-64-352 0z"]
};
const faSquareArrowUp = {
  prefix: 'fass',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M448 32L0 32 0 480l448 0 0-448zM241 103L353 215l17 17L336 265.9l-17-17-71-71L248 392l0 24-48 0 0-24 0-214.1-71 71-17 17L78.1 232l17-17L207 103l17-17 17 17z"]
};
const faArrowSquareUp = faSquareArrowUp;
const faGreaterThanEqual = {
  prefix: 'fass',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M34.7 33.8l-2.7-1 0 67.9L288.5 192 32 283.2l0 67.9 2.7-1 360-128 21.3-7.6 0-45.2-21.3-7.6-360-128zM416 416L32 416 0 416l0 64 32 0 384 0 32 0 0-64-32 0z"]
};
const faPalletBox = {
  prefix: 'fass',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M128 0L256 0l0 128 64-48 64 48L384 0 512 0l0 256-384 0L128 0zM0 320l32 0 32 0 32 0 32 0 160 0 32 0 32 0 160 0 32 0 32 0 32 0 32 0 0 64-32 0-32 0 0 64 32 0 32 0 0 64-32 0-32 0-32 0-32 0-160 0-32 0-32 0-160 0-32 0-32 0-32 0L0 512l0-64 32 0 32 0 0-64-32 0L0 384l0-64zM128 448l160 0 0-64-160 0 0 64zm224 0l160 0 0-64-160 0 0 64z"]
};
const faFaceConfounded = {
  prefix: 'fass',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216.9 354.7L256 380.8l39.1-26.1 8.9-5.9 8.9 5.9 40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 387.2l-39.1 26.1-8.9 5.9-8.9-5.9L208 387.2l-39.1 26.1-7.7 5.2-8.3-4.2-32-16-14.3-7.2 14.3-28.6 14.3 7.2 23.7 11.8 40.3-26.8 8.9-5.9 8.9 5.9zM112 192l118.9 64L112 320l45.7-64L112 192zm169.1 64L400 192l-45.7 64L400 320 281.1 256z"]
};
const faShieldHalved = {
  prefix: 'fass',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M267.5 10.1L256 5.7l-11.5 4.4L37 90.2 17.8 97.6l-1.2 20.6C13.6 167.8 21.4 243.7 53.9 318C86.6 392.8 145 467.1 243.4 509.4l12.6 5.4 12.6-5.4C367 467.1 425.4 392.8 458.1 318c32.5-74.2 40.3-150.2 37.3-199.8l-1.2-20.6L475 90.2l-207.5-80zM256 74.3s0 0 0 0l176 67.9c-.5 40.6-8.8 96-32.5 150.2C373.3 352.2 328.9 409.5 256 444.8l0-370.5z"]
};
const faShieldAlt = faShieldHalved;
const faTruckPlow = {
  prefix: 'fass',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M128 32l32 0 128 0 18.1 0 9.3 15.5L402.1 192l77.9 0 0 96 32 0 0-112 0-8.9 4.6-7.6 48-80L581 52.1 635.9 85l-16.5 27.4L576 184.9 576 288l0 64 0 7.1 43.4 72.4L635.9 459 581 491.9l-16.5-27.4-48-80-4.6-7.6 0-8.9 0-16-37.5 0c3.5 10 5.5 20.8 5.5 32c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32L224 352c-1.9 0-3.8-.2-5.6-.5c3.7 10.2 5.6 21.1 5.6 32.5c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32L0 352 0 192l128 0 0-128 0-32zm64 160l135.5 0L269.9 96 192 96l0 96zM160 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faBookAtlas = {
  prefix: 'fass',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9l63 0c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9l31.1 0c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9l-31.1 0c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208l31.1 0c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32l-31.1 0c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9l-63 0c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"]
};
const faAtlas = faBookAtlas;
const faVirus = {
  prefix: 'fass',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M256 0L224 0l0 32 0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75 97.6 52.4 75 75s0 0 0 0s0 0 0 0L52.4 97.6 75 120.2l8.2 8.2s0 0 0 0C118.4 163.7 93.4 224 43.5 224L32 224 0 224l0 32 0 32 32 0 11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8 52.4 414.4 75 437s0 0 0 0l22.6 22.6L120.2 437l8.2-8.2c0 0 0 0 0 0c35.3-35.2 95.6-10.3 95.6 39.6l0 11.5 0 32 32 0 32 0 0-32 0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2 22.6 22.6L437 437l22.6-22.6L437 391.8l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0 32 0 0-32 0-32-32 0-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 22.6-22.6L437 75 414.4 52.4 391.8 75l-8.2 8.2s0 0 0 0C348.3 118.4 288 93.4 288 43.5L288 32l0-32L256 0zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faGridRound2 = {
  prefix: 'fass',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z"]
};
const faCommentMiddleTop = {
  prefix: 'fass',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M320.1 102.6C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4L256 0l64.1 102.6z"]
};
const faWave = {
  prefix: 'fass',
  iconName: 'wave',
  icon: [576, 512, [], "e65b", "M0 336l0-32 32 0c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2l-38.6 27.1C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c0 0 0 0 0 0c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 32 0 32 0 10.6c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2l-7.6-4.1-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2l-7.6-4.1-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2L96 349.8l-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6L0 368l0-32zm0 74.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 5.4 0 32 0 32c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 470.1 31.9 480 0 480l0-32 0-32 0-5.4z"]
};
const faEnvelopeCircleCheck = {
  prefix: 'fass',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M0 64l0 80L256 320l78.4-53.9c26.1-60.2 84.9-103 154.1-105.9L512 144l0-80L0 64zM274.1 346.4L256 358.8l-18.1-12.5L0 182.8 0 448l360.2 0C335.1 417.6 320 378.5 320 336c0-7.5 .5-14.9 1.4-22.1l-47.2 32.5zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 398.6l-11.3-11.3-40-40L417.4 336 440 313.4l11.3 11.3L480 353.4l60.7-60.7L552 281.4 574.6 304z"]
};
const faLayerGroup = {
  prefix: 'fass',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M0 128L288 256 576 128 288 0 0 128zm104.6 81.5L0 256 288 384 576 256 471.4 209.5 288 291 104.6 209.5zM288 419L104.6 337.5 0 384 288 512 576 384 471.4 337.5 288 419z"]
};
const faRestroomSimple = {
  prefix: 'fass',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zm32 96L32 160 24 352l40 0 0 160 128 0 0-160 40 0-8-192zM344 0L296 0l0 24 0 464 0 24 48 0 0-24 0-464 0-24zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM640 384L576 160l-128 0L384 384l64 0 0 128 128 0 0-128 64 0z"]
};
const faArrowsToDot = {
  prefix: 'fass',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M256 192L160 96l0-32 64 0 0-32 0-32 64 0 0 32 0 32 64 0 0 32-96 96zM416 352l-96-96 96-96 32 0 0 64 32 0 32 0 0 64-32 0-32 0 0 64-32 0zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64l96 96 0 32-64 0 0 32 0 32-64 0 0-32 0-32-64 0 0-32 96-96zM96 352l-32 0 0-64-32 0L0 288l0-64 32 0 32 0 0-64 32 0 96 96L96 352z"]
};
const faBorderOuter = {
  prefix: 'fass',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 96l0 320 320 0 0-320L64 96zM0 32l64 0 320 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zm256 96l0 64-64 0 0-64 64 0zM96 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm-32 96l0 64-64 0 0-64 64 0z"]
};
const faHashtagLock = {
  prefix: 'fass',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M308.9 32l64.9 0-16 96 74.2 0 12.9 0-5.8 34.8c-20.5 4.7-38.9 15-53.5 29.2l-38.5 0-16 96L320 288l0 96-4.9 0-16 96-64.9 0 16-96-95.1 0-16 96-64.9 0 16-96L16 384 3.1 384l10.7-64 2.2 0 84.9 0 21.3-128L48 192l-12.9 0 10.7-64 2.2 0 84.9 0 16-96 64.9 0-16 96 95.1 0 16-96zM165.8 320l95.1 0 21.3-128-95.1 0L165.8 320zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faClockTwoThirty = {
  prefix: 'fass',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-136 0-12.8 10.7-7.1 96-64 20-13.3 26.6 39.9-20 13.3L280 268.8 280 392l0 24-48 0 0-24z"]
};
const faArchway = {
  prefix: 'fass',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 32l32 0 448 0 32 0 0 64-32 0L32 96 0 96 0 32zM0 416l32 0 0-288 448 0 0 288 32 0 0 64-32 0-64 0-32 0-32 0 0-128c0-53-43-96-96-96s-96 43-96 96l0 128-32 0-32 0-64 0L0 480l0-64z"]
};
const faHeartCircleCheck = {
  prefix: 'fass',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm224 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z"]
};
const faHouseChimneyCrack = {
  prefix: 'fass',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M576 287.6l-64.2 0 1 224.4-186.4 0L288 448l96-80L224 256l64 112-96 80 38.4 64L64.1 512l0-224.4L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6z"]
};
const faHouseDamage = faHouseChimneyCrack;
const faFileZipper = {
  prefix: 'fass',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM96 32l16 0 32 0 16 0 0 32-16 0-32 0L96 64l0-32zm0 64l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zm0 64l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zM64 416l0-72L96 224l64 0 32 120 0 72L64 416zm48-80l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0z"]
};
const faFileArchive = faFileZipper;
const faTicketPerforated = {
  prefix: 'fass',
  iconName: 'ticket-perforated',
  icon: [640, 512, [], "e63e", "M0 64l640 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144L0 448 0 64zm448 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faHeartHalf = {
  prefix: 'fass',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M39.8 263.8L256 480V96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96z"]
};
const faCommentCheck = {
  prefix: 'fass',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM369 193l17-17L352 142.1l-17 17-111 111-47-47-17-17L126.1 240l17 17 64 64 17 17 17-17L369 193z"]
};
const faSquare = {
  prefix: 'fass',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M0 32H448V480H0V32z"]
};
const faMemo = {
  prefix: 'fass',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M384 0L0 0 0 512l384 0L384 0zM80 128l224 0 16 0 0 32-16 0L80 160l-16 0 0-32 16 0zm0 96l224 0 16 0 0 32-16 0L80 256l-16 0 0-32 16 0zm0 96l128 0 16 0 0 32-16 0L80 352l-16 0 0-32 16 0z"]
};
const faMartiniGlassEmpty = {
  prefix: 'fass',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M0 48L16 64 210.7 258.7 224 272l0 176-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-176 13.3-13.3L496 64l16-16 0-48L448 0 64 0 0 0 0 48zM106.5 64l299 0L256 213.5 106.5 64z"]
};
const faGlassMartini = faMartiniGlassEmpty;
const faCouch = {
  prefix: 'fass',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M64 32l0 160 32 0 32 0 0 32 0 96 384 0 0-96 0-32 32 0 32 0 0-160L64 32zm0 192L0 224 0 480l96 0 0-32 448 0 0 32 96 0 0-256-64 0-32 0 0 32 0 64 0 32-32 0-384 0-32 0 0-32 0-64 0-32-32 0z"]
};
const faCediSign = {
  prefix: 'fass',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M256 32l0-32L192 0l0 32 0 34.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3l0 34.7 0 32 64 0 0-32 0-34.7c49.6-8.3 92.7-35.6 121.6-74.1l-51.2-38.4c-17.2 22.9-41.9 39.8-70.4 47.2L256 132c28.5 7.3 53.2 24.2 70.4 47.2l51.2-38.4C348.7 102.3 305.6 75 256 66.7L256 32zM192 132L192 380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"]
};
const faItalic = {
  prefix: 'fass',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 32l32 0 192 0 32 0 0 64-32 0-58.7 0L160 416l64 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0 58.7 0L224 96l-64 0-32 0 0-64z"]
};
const faGlassCitrus = {
  prefix: 'fass',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M448 144c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32l-71.8 0C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-.5 0 6.7-64.2c41.3-3.2 73.8-37.7 73.8-79.8zM274.3 256l6.7-64L71 192l6.7 64 196.6 0zM312 512L40 512 6.7 192 0 128l64.3 0 223.3 0 64.3 0-6.7 64L312 512z"]
};
const faCalendarLinesPen = {
  prefix: 'fass',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 44.4-181 181L253.4 512 0 512 0 192zm288 80L96 272l0 48 192 0 0-48zm-64 96L96 368l0 48 128 0 0-48zM505 223.8l71 71-41.3 41.3-71-71L505 223.8zm-63.9 63.9l71 71L370.9 500 288 511.9 299.9 429 441.1 287.8z"]
};
const faTableCellsColumnLock = {
  prefix: 'fass',
  iconName: 'table-cells-column-lock',
  icon: [640, 512, [], "e678", "M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM208 96l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faChurch = {
  prefix: 'fass',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M344 24l0-24L296 0l0 24 0 24-32 0-24 0 0 48 24 0 32 0 0 46.4L160 224l0 288 96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-288L344 142.4 344 96l32 0 24 0 0-48-24 0-32 0 0-24zM0 344L0 512l128 0 0-238.4L0 344zM640 512l0-168L512 273.6 512 512l128 0z"]
};
const faPersonSnowmobiling = {
  prefix: 'fass',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM373.5 85.3L362.7 63.8 319.8 85.3l10.7 21.5 37.4 74.7L360 192l-56 0-80-72-64 0L106.7 220.6c-11.4 21.6-9.4 47.8 5.3 67.4l-32 0L31.1 385.8c5.4-1.2 11.1-1.8 16.9-1.8l224 0c26.2 0 49.4 12.6 64 32l114 0 36 48-46 0-24 0 0 48 24 0 128 0 9.9 0 7-7 32-32 17-17L600 422.1l-17 17-25 25L546 464l-46-61.3L576 352l0-96L419.8 177.9 373.5 85.3zM272 256l40 0-24 32-24 0-72-32 32-48 48 48zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416z"]
};
const faSnowmobile = faPersonSnowmobiling;
const faFaceHushed = {
  prefix: 'fass',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm141 .9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faCommentsDollar = {
  prefix: 'fass',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352zm23.5 31C255.8 457.4 336.4 512 432 512c36.2 0 70.3-7.8 99.9-21.6L640 512l-37.6-75.1C626.1 408.3 640 373.5 640 336c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5c0 112.3-99.1 196.9-216.5 207zM228 80l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c0 0 0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z"]
};
const faTicketsSimple = {
  prefix: 'fass',
  iconName: 'tickets-simple',
  icon: [640, 512, [], "e659", "M640 32L96 32l0 128c26.5 0 48 21.5 48 48s-21.5 48-48 48l0 128 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faPickaxe = {
  prefix: 'fass',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M462.4 373.5s0 0 0 0l-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3c-1.2-2.9-3-7.2-5.5-12.7c-5-11-12.6-26.7-23.1-45.3c-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1c-5.5-2.5-9.8-4.3-12.7-5.5c-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L99.6 35.3 138 19.8C169.5 7 204 0 240 0c61 0 117.4 20.1 162.8 54L424 32l56 56-22 21.2C491.9 154.6 512 211 512 272c0 36-7 70.5-19.8 102l-15.5 38.4-14.3-38.8s0 0 0 0s0 0 0 0zM310.1 201.9c8.7 8.7 16.8 17.4 24.5 26.2L40 512 0 472 283.8 177.4c8.8 7.7 17.6 15.8 26.2 24.5z"]
};
const faLinkSimpleSlash = {
  prefix: 'fass',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-87.5-68C578.2 363 608 313 608 256c0-88.4-71.6-160-160-160l-64 0-32 0 0 64 32 0 64 0c53 0 96 43 96 96c0 42.9-28.2 79.3-67 91.5L400.3 288l15.7 0 32 0 0-64-32 0-98.1 0-82.4-64 20.6 0 32 0 0-64-32 0-64 0c-11.8 0-23.2 1.3-34.3 3.7L48.4 14.8zM70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160l64 0 32 0 0-64-32 0-64 0c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6L70.7 151.7z"]
};
const faDemocrat = {
  prefix: 'fass',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M64 32C64 12.1 80 0 80 0l48 45.7L176 0s16 12.1 16 32c0 26.5-21.9 42-29.5 46.6L248 160l232 0 64 0 14.3 0 9.5 10.6 72 80-47.6 42.8-49.4-54.9L544 240l0 80-352 0L144 208 72 256 0 184 87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352l96 0 0 64 0 96-96 0 0-96-160 0 0 96-96 0 0-96 0-64 96 0 160 0zM269.3 234.7L256.1 208 243 234.7l-30.2 3.9 22.1 20.4L229.4 288l26.8-14.1L282.9 288l-5.5-29.1 22.1-20.4-30.2-3.9zM368.1 208L355 234.7l-30.2 3.9 22.1 20.4L341.4 288l26.8-14.1L394.9 288l-5.5-29.1 22.1-20.4-30.2-3.9L368.1 208zm125.1 26.7L480.1 208 467 234.7l-30.2 3.9 22.1 20.4L453.4 288l26.8-14.1L506.9 288l-5.5-29.1 22.1-20.4-30.2-3.9z"]
};
const faFaceConfused = {
  prefix: 'fass',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.1 395.6l-1.1 .9-12.5 10-20-25 12.5-10 1.1-.9C205 327.5 272 304 341 304l11 0 16 0 0 32-16 0-11 0c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPinball = {
  prefix: 'fass',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1 29.6-55.7-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faZ = {
  prefix: 'fass',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M384 32l0 43.6-7.4 8.9L100.3 416 352 416l32 0 0 64-32 0L32 480 0 480l0-43.6 7.4-8.9L283.7 96 32 96 0 96 0 32l32 0 320 0 32 0z"]
};
const faPersonSkiing = {
  prefix: 'fass',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM13.8 247.6l21.3 11.1L232.7 361.3l46.2-69.2-76.5-76.5c-14.4-14.4-20.2-33.4-18.4-51.5l110.2 52.7 48.6 48.6 18.6 18.6-14.6 21.8L289.8 391l126.4 65.6 37.1-18.5 21.5-10.7 21.5 42.9L474.7 481l-48 24-10.9 5.5-10.9-5.6L12.9 301.3-8.4 290.2l22.1-42.6zM118.9 65.6L137 74.2l8.7-17.4 7.2-14.3 28.6 14.3-7.2 14.3-8.5 16.9 52.6 25.2c1-.5 2.1-1 3.2-1.5L323 66.8l26.2-11.6 14.4 24.8 51.7 88.6 48.6 27.7 27.8 15.9-31.8 55.6-27.8-15.9-56-32-7.4-4.3-4.3-7.4L346.8 178l-28.3 12.6-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4-7.2 14.3-28.6-14.3 7.2-14.3 9-18-17.6-8.4L90.7 87.5l13.8-28.8 14.4 6.9z"]
};
const faSkiing = faPersonSkiing;
const faDeer = {
  prefix: 'fass',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256 0l0 16 0 24c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-24 0-16 32 0 0 16 0 24c0 8.6-1.9 16.7-5.4 24l30.6 0L416 64c13.3 0 24-10.7 24-24l0-24 0-16 32 0 0 16 0 24c0 21.7-12.3 40.4-30.3 49.8c.6 .5 1.1 1.1 1.7 1.6L512 160l0 64-96 0-5.3 0L384 304l0 64 0 144-96 0 0-144-48 0-64-27.4 0 3.4 0 19.9-14.1 14.1-26.6 26.6L173.3 512 71.5 512 34.7 408 24.7 379.4l21.4-21.4L72.1 332 56 315.9c-3-3-5.7-6.1-8.1-9.5l-1.8 23.3-47.9-3.7L.1 302.2 2.4 272c4.2-54.2 49.3-96 103.7-96l7.9 0 14.1 0 96 0 78.4 0 9.6-32-56 0 0-32 64-16-24 0-16 0c-30.9 0-56-25.1-56-56l0-24 0-16 32 0zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faInputPipe = {
  prefix: 'fass',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 128l0 256 512 0 0-256L64 128zM0 64l64 0 512 0 64 0 0 64 0 256 0 64-64 0L64 448 0 448l0-64L0 128 0 64zM144 184l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24z"]
};
const faRoadLock = {
  prefix: 'fass',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M288 32L160 32 32 480l256 0 0-64 0-32 64 0 0 32 0 64 32 0 0-192 32 0 0-16c0-58.1 44.2-105.8 100.7-111.4L480 32 352 32l0 64 0 32-64 0 0-32 0-64zm64 192l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zm176 16c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faA = {
  prefix: 'fass',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M169.9 32l44.2 0 7.8 20.6 109.3 288L384.2 480l-68.5 0-36.4-96-174.5 0L68.3 480-.2 480 52.7 340.6l109.3-288L169.9 32zm85 288L192 154.2 129 320 255 320z"]
};
const faBookmarkSlash = {
  prefix: 'fass',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M128 512l0-315.1L512 499.4l0 12.6L320 400 128 512zM512 374.7l108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L128 76.6 128 0 512 0l0 374.7z"]
};
const faTemperatureArrowDown = {
  prefix: 'fass',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M113.8 317.8L128 300.1l0-22.7L128 64l96 0 0 213.5 0 22.7 14.2 17.6C249.4 331.5 256 348.9 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM288 0L224 0 128 0 64 0l0 64 0 213.5C44 302.2 32 333.7 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L288 64l0-64zM176 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7 0-16-32 0 0 16 0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm368-64l-64 0 0-288 0-32-64 0 0 32 0 288-64 0 0 32 96 96 96-96 0-32z"]
};
const faTemperatureDown = faTemperatureArrowDown;
const faMace = {
  prefix: 'fass',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M328.3 94.1c42.7 13.2 76.4 46.9 89.6 89.6L512 224l-94.1 40.3c-13.2 42.7-46.9 76.4-89.6 89.6L288 448l-40.3-94.1c-10.8-3.4-21.1-8-30.5-13.8L70.6 486.6 48 509.3 2.7 464l22.6-22.6L171.9 294.9c-5.8-9.5-10.5-19.7-13.8-30.5L64 224l94.1-40.3c13.2-42.7 46.9-76.4 89.6-89.6L288 0l40.3 94.1zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faFeatherPointed = {
  prefix: 'fass',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M137.4 131.6C228.5 40.5 428.3 6.9 512 0c-4.4 53.7-19.8 155.2-54.4 245.1L368 272l0 16 71.1 0c-8.2 16.9-17.2 32.9-27.1 47.6L304 368l0 16 66.4 0c-61.9 54.9-164.4 88.3-238 45.5L73 489l-17 17L22.1 472l17-17L287.2 206.8l-22.3-22.3-11.3 11.3L78.1 371.3c-37.9-77 1.1-181.5 59.3-239.7z"]
};
const faFeatherAlt = faFeatherPointed;
const faSausage = {
  prefix: 'fass',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M320 160c0-42.1 27.1-77.8 64.7-90.8L360 0 472 0 447.3 69.2c37.7 13 64.7 48.7 64.7 90.8c0 194.4-157.6 352-352 352c-42.1 0-77.8-27.1-90.8-64.7L0 472 0 360l69.2 24.7c13-37.7 48.7-64.7 90.8-64.7c88.4 0 160-71.6 160-160zM160 400c132.5 0 240-107.5 240-240l-32 0c0 114.9-93.1 208-208 208l0 32z"]
};
const faTrashCanClock = {
  prefix: 'fass',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM32 128l384 0 0 64.7c-29.3 2.6-56.6 12.5-80 27.7l0-12.5 0-16-32 0 0 16 0 39.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144L32 512l0-384zm112 64l-32 0 0 16 0 224 0 16 32 0 0-16 0-224 0-16zm96 0l-32 0 0 16 0 224 0 16 32 0 0-16 0-224 0-16zm48 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16z"]
};
const faP = {
  prefix: 'fass',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M64 288l96 0c53 0 96-43 96-96s-43-96-96-96L64 96l0 192zM0 352l0-32 0-32L0 96 0 64 0 32l32 0 32 0 96 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96 0 32L0 480l0-32 0-96z"]
};
const faBroomWide = {
  prefix: 'fass',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M328 136L464 0l48 48L376 184l40 40-37.8 61.9L226.1 133.8 288 96l40 40zM191 155.3L356.7 321 240 512 108 380l20-60L68 340 0 272 191 155.3z"]
};
const faSnowflake = {
  prefix: 'fass',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M256 32l0-32L192 0l0 32 0 30.1-8.6-8.6-17-17L132.5 70.4l17 17L192 129.9l0 70.6-61.2-35.3-15.6-58.2L109 83.9 62.7 96.3l6.2 23.2L72 131.3l-12.2-7-27.7-16L.2 163.7l27.7 16 12.2 7-11.8 3.2L5.1 196.1l12.4 46.4 23.2-6.2 58.2-15.6L160 256 98.8 291.3 40.7 275.7l-23.2-6.2L5.1 315.9l23.2 6.2L40 325.3l-12.2 7L.2 348.3l32 55.4 27.7-16 12.2-7-3.2 11.8-6.2 23.2L109 428.1l6.2-23.2 15.6-58.2L192 311.4l0 70.6-42.6 42.6-17 17 33.9 33.9 17-17 8.6-8.6 0 30.1 0 32 64 0 0-32 0-30.1 8.6 8.6 17 17 33.9-33.9-17-17L256 382.1l0-70.6 61.2 35.3 15.6 58.2 6.2 23.2 46.4-12.4-6.2-23.2L376 380.7l12.2 7 27.7 16 32-55.4-27.7-16-12.2-7 11.8-3.2 23.2-6.2-12.4-46.4-23.2 6.2-58.2 15.6L288 256l61.2-35.3 58.2 15.6 23.2 6.2 12.4-46.4-23.2-6.2L408 186.7l12.2-7 27.7-16-32-55.4-27.7 16-12.2 7 3.2-11.8 6.2-23.2L339 83.9l-6.2 23.2-15.6 58.2L256 200.6l0-70.6 42.6-42.6 17-17L281.6 36.5l-17 17L256 62.1 256 32z"]
};
const faStomach = {
  prefix: 'fass',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M192 32l0-32L128 0l0 32 0 160 0 32 32 0 96 0 0 64c0 35.3-28.7 64-64 64L32 352 0 352l0 32 0 16 0 80 0 32 64 0 0-32 0-48 48 0c24.6 0 36 9.5 58.2 28.2c0 0 0 0 0 0c1.7 1.4 3.4 2.9 5.3 4.4c12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208l0-80c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64L192 160l0-128zM445.1 332.7c-7.2 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c1.1-6.7 1.6-13.6 1.6-20.6l0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80c0 9.8-1 19.4-2.9 28.7z"]
};
const faNewspaper = {
  prefix: 'fass',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M96 32l32 0 352 0 32 0 0 32 0 384 0 32-32 0-320 0-32 0-48 0-48 0L0 480l0-32L0 128 0 96l64 0 0 32 0 288 16 0 16 0L96 64l0-32zm64 64l0 128 160 0 0-128L160 96zm224 0l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zm0 96l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zM160 288l0 32 16 0 256 0 16 0 0-32-16 0-256 0-16 0zm0 96l0 32 16 0 256 0 16 0 0-32-16 0-256 0-16 0z"]
};
const faRectangleAd = {
  prefix: 'fass',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M576 32L0 32 0 480l576 0 0-448zM368 280a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24-72c8.4 0 16.5 1.4 24 4.1l0-28.1 0-24 48 0 0 24 0 96 0 48 0 24-48 0 0-4.1c-7.5 2.7-15.6 4.1-24 4.1c-39.8 0-72-32.2-72-72s32.2-72 72-72zM192.3 160l15.7 0 4 0 16.1 0 6.1 14.8L307.4 352l-51.9 0-9.9-24-74 0-10.4 24-52.3 0L186 174.4l6.3-14.4zm.2 120l33.3 0-16.2-39.2L192.4 280z"]
};
const faAd = faRectangleAd;
const faGuitarElectric = {
  prefix: 'fass',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352 64l0 50.7L244.9 221.9c-21.9-40.6 14.1-76.5 14.1-76.5l-23.8-23.8-40.7 40.7c-9.4 9.4-15.4 21.8-21.2 34c-1.6 3.4-3.2 6.7-4.9 10c-3.5 6.9-8.7 14.6-16.4 22.3c-24.9 24.9-65.2 40-90.3 47.6c-14.6 4.4-28.3 11.6-39 22.4c-30.3 30.3-30.3 79.3 0 109.6l80.5 81.3C118.8 505 139.5 512.5 160 512c19.2-.5 38.2-8.1 52.8-22.7c10.8-10.8 18-24.5 22.4-39c7.5-25.1 22.7-66.2 47.6-91.2c7.7-7.7 15.4-12.9 22.3-16.4c3.3-1.7 6.6-3.3 10-4.9c12.2-5.8 24.6-11.8 34-21.2l28.8-28.8L354 264.1s-26.5 26.5-64.2 3.4L444.6 112.6c16.1 4.8 34.1 .7 46.5-11.7c19.7-19.7 17.9-52.1-3.8-69.5L448 0 352 64zM195.3 268.7l48 48L254.6 328 232 350.6l-11.3-11.3-48-48L161.4 280 184 257.4l11.3 11.3zm-64 64l48 48L190.6 392 168 414.6l-11.3-11.3-48-48L97.4 344 120 321.4l11.3 11.3z"]
};
const faArrowTurnDownRight = {
  prefix: 'fass',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M64 64l0-32L0 32 0 64 0 288l0 32 32 0 354.7 0-73.4 73.4L290.7 416 336 461.3l22.6-22.6 128-128L509.3 288l-22.6-22.6-128-128L336 114.7 290.7 160l22.6 22.6L386.7 256 64 256 64 64z"]
};
const faMoonCloud = {
  prefix: 'fass',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M543.6 41.2c-82.8 21.2-144 96.5-144 186c0 106 85.8 192 191.5 192c16.8 0 33.1-2.2 48.6-6.2c-40.6 41.4-97.2 67-159.8 67c-47.6 0-91.7-14.8-128-40.1l0-95.9c0-54.6-42-99.3-95.5-103.7C264.6 123.9 361.5 32 480 32c22.1 0 43.5 3.2 63.6 9.2zM64 416L0 416l0-64c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72c0 2.7-.1 5.4-.4 8l.4 0 0 64-72 0L64 416z"]
};
const faBreadSliceButter = {
  prefix: 'fass',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 224L64 480l0-224c-35.3 0-64-28.7-64-64zM256 376l88-88-88-88-88 88 88 88z"]
};
const faCircleArrowRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm409 17L297 385l-17 17L246.1 368l17-17 71-71L120 280l-24 0 0-48 24 0 214.1 0-71-71-17-17L280 110.1l17 17L409 239l17 17-17 17z"]
};
const faArrowCircleRight = faCircleArrowRight;
const faUserGroupCrown = {
  prefix: 'fass',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M96 0l0 53.7L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-90.3L352 0 304 24l-16 8L224 0 160 32l-16-8L96 0zm48 144l0-16 160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80zM448 512L384 304 64 304 0 512l448 0zm192 0L576 320l-153.6 0 56.2 182.6 2.9 9.4L640 512zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8l0 10.9 0 90.3c0 31.4-9 60.6-24.6 85.3C379 245.9 404.3 256 432 256z"]
};
const faUsersCrown = faUserGroupCrown;
const faCircleI = {
  prefix: 'fass',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48 24 0z"]
};
const faToiletPaperCheck = {
  prefix: 'fass',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M384 192c0-65.5 13.2-142.4 60.2-192L160 0C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512l325.3 0C376 409.7 384 301.9 384 192zM512 384c53 0 96-86 96-192S565 0 512 0s-96 86-96 192s43 192 96 192zm0-128c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM291.3 187.3l-72 72L208 270.6l-11.3-11.3-40-40L145.4 208 168 185.4l11.3 11.3L208 225.4l60.7-60.7L280 153.4 302.6 176l-11.3 11.3z"]
};
const faFilterCircleXmark = {
  prefix: 'fass',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M192 384l0-96L0 64 0 0 512 0l0 64L399.8 194.9C318 210.1 256 281.8 256 368c0 27.8 6.4 54.1 17.9 77.4L192 384zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z"]
};
const faLocust = {
  prefix: 'fass',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M288 32l24 0 48 0c116.6 0 211.6 92.4 215.9 208l.1 0 0 7.3 0 .7 0 72 0 .3c-.2 44.1-35.9 79.7-80 79.7l-12.4 0 45.7 80-55.3 0-45.7-80L348 400l-55.4 80-58.4 0 55.4-80-53 0-59.8 80-59.9 0 65-86.9-41.2-15.7L59.6 480l-61.2 0L269.2 137.1l25-31.7 15.9 37.1 21.5 50.2 41.2-55.1 24.9-33.3 16.4 38.2L455.8 240l72 0C523.6 150.9 450.1 80 360 80l-48 0-24 0 0-48zM403.6 240l-17.3-40.3L356.2 240l47.4 0zm-107.3 0l2.1-2.8-16.6-38.6L249.1 240l47.2 0zM32 240l118.7 0L64.1 348.2 32 336l0-96zm464 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faSort = {
  prefix: 'fass',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M160 32L0 192l0 32 320 0 0-32L160 32zm0 448L320 320l0-32L0 288l0 32L160 480z"]
};
const faUnsorted = faSort;
const faListOl = {
  prefix: 'fass',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M32 32l24 0 24 0 24 0 0 24 0 120 8 0 24 0 0 48-24 0-8 0-48 0-8 0-24 0 0-48 24 0 8 0 0-96L32 80l0-48zM8 352c0-35.3 28.7-64 64-64l17.2 0c34.7 0 62.8 28.1 62.8 62.8c0 17.7-7.5 34.6-20.5 46.5L93.4 432l34.6 0 24 0 0 48-24 0-96 0L8 480l0-24 0-.6 0-10.6 7.8-7.1 83.3-75.9c3.1-2.8 4.8-6.8 4.8-11c0-8.2-6.6-14.8-14.8-14.8L72 336c-8.8 0-16 7.2-16 16L8 352zM224 64l256 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0zm0 160l256 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0zm0 160l256 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0z"]
};
const faList12 = faListOl;
const faListNumeric = faListOl;
const faChartWaterfall = {
  prefix: 'fass',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zM192 224l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0zm96-64l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zm96-96l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0zm96 32l0 224 0 32-64 0 0-32 0-224 0-32 64 0 0 32z"]
};
const faSparkle = {
  prefix: 'fass',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M149.3 181.3L224 32l74.7 149.3L448 256 298.7 330.7 224 480 149.3 330.7 0 256l149.3-74.7z"]
};
const faFaceParty = {
  prefix: 'fass',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M54.3 144.7L35 93.5C49.7 67.8 67.7 44.3 88.5 23.6l45.8 12.2C99.7 65.1 72.1 102.3 54.3 144.7zm-1-130.5C41.5 27.2 30.7 41 20.9 55.6L0 0 53.3 14.2zM531.7 400C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176L528 176l-48 0 0 48 0 64 0 16-48 0-19.1 0c-1.2-2.3-2.6-4.4-4.2-6.3c-4.3-5.2-10.1-9.7-16.7-13.4C378.7 276.9 361.4 272 344 272l-3.9 15s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0 13.9s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l3.9 15c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c1.6-2 3.1-4.1 4.2-6.3l19.1 0 99.7 0zM384 351.7l0-15.7 16 0 208 0 0-96-64 0 0 32 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 16 0 96 0 16 0 0 16 0 128 0 16-16 0-224 0-16 0 0-15.7-.8-.3 .8-.3zM196.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm246.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0z"]
};
const faKidneys = {
  prefix: 'fass',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1c7.1 48 48.8 80.9 95.3 80.9c58.4 0 104-50.4 98.2-108.5l-7.3-72.7 39.2-44.1c15.2-17.1 23.5-39.1 23.5-61.9c0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3C194.5 5.9 175.1 0 155.2 0L152 0zM488 0l-3.2 0c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l39.2 44.1-7.3 72.7C433.7 333.6 479.3 384 537.7 384c46.5 0 88.2-32.9 95.3-80.9c3.6-24.4 7.1-54.2 7.1-79.1c0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0zM226.5 213.5l3.6 36.3L256 262.8 256 488l0 24 48 0 0-24 0-240 0-14.8-13.3-6.6-52.5-26.2-11.8 13.3zm187.1 0l-11.8-13.3-52.5 26.2L336 233.2l0 14.8 0 240 0 24 48 0 0-24 0-225.2 25.9-12.9 3.6-36.3z"]
};
const faWifiExclamation = {
  prefix: 'fass',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M296 320l48 0L368 32l-96 0 24 288zm24.2 32l-.3 0c-35.3 .1-63.8 28.7-63.8 64c0 35.3 28.7 64 64 64s64-28.7 64-64c0-35.3-28.6-63.9-63.8-64zm66-152.4l-5.4 64.7c32.8 9.2 62.5 25.7 87.4 47.7l42.4-48c-34.9-30.8-77.4-53.3-124.4-64.4zM259.3 264.3l-5.4-64.7c-46.9 11-89.4 33.5-124.4 64.4l42.4 48c24.9-21.9 54.6-38.4 87.4-47.7zm326.6-61.4l44.3-46.2C567.8 96.9 488.2 54.9 399.5 39l-5.3 64.1c73.6 14.4 139.6 49.8 191.7 99.7zm-340-99.7L240.5 39C151.8 54.9 72.2 96.9 9.8 156.7l44.3 46.2c52-49.9 118.1-85.4 191.7-99.7z"]
};
const faChartNetwork = {
  prefix: 'fass',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 0L160 0l0 128 58.6 0 29.1 62.3C221.8 210.4 203 239 195.6 272L128 272l0-32L0 240 0 368l128 0 0-32 67.6 0c14.6 64.1 71.9 112 140.4 112c38.4 0 73.3-15 99.1-39.5L512 459.8l0 52.2 128 0 0-128-126.3 0-43.1-28.7c6.1-15.9 9.4-33.2 9.4-51.3c0-20.3-4.2-39.7-11.8-57.2L542.8 192l97.2 0 0-128L512 64l0 71.3-81.7 59.9C405 173.3 372.1 160 336 160c-10.4 0-20.6 1.1-30.4 3.2L288 125.5 288 0zm48 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faPersonDressBurst = {
  prefix: 'fass',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M176 0L133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2 100 236.6l-.4 98L176 273.2l76.4 61.4-.4-98L312.8 223l15-23.5-57.1-45.1 42.9-88.1L218.2 88.5 176 0zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0-9.4 14.8-81.7 128 53.9 34.4 42-65.8L368 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0L543.8 239.4l42 65.8 53.9-34.4L558 142.8 548.6 128l-17.5 0-102.2 0z"]
};
const faDiceD4 = {
  prefix: 'fass',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M0 320L240 0l0 512L0 320zM272 0L512 320 272 512 272 0z"]
};
const faMoneyCheckDollar = {
  prefix: 'fass',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M576 64L0 64 0 448l576 0 0-384zM512 192l0 32-256 0 0-32 256 0zM256 288l256 0 0 32-256 0 0-32zM164 160l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z"]
};
const faMoneyCheckAlt = faMoneyCheckDollar;
const faVectorSquare = {
  prefix: 'fass',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M400 80l0 32-32 0 0-32 32 0zM368 32l-48 0 0 32L128 64l0-32L80 32 48 32 0 32 0 80l0 32 0 48 32 0 0 192L0 352l0 48 0 32 0 48 48 0 32 0 48 0 0-32 192 0 0 32 48 0 32 0 48 0 0-48 0-32 0-48-32 0 0-192 32 0 0-48 0-32 0-48-48 0-32 0zM96 160l32 0 0-32 192 0 0 32 32 0 0 192-32 0 0 32-192 0 0-32-32 0 0-192zM80 400l0 32-32 0 0-32 32 0zm288 0l32 0 0 32-32 0 0-32zM48 80l32 0 0 32-32 0 0-32z"]
};
const faBreadSlice = {
  prefix: 'fass',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V480H448V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"]
};
const faLanguage = {
  prefix: 'fass',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M256 64L0 64 0 448l256 0 48 0 16 0 256 0 64 0 0-64 0-256 0-64-64 0L320 64l-16 0-48 0zm320 64l0 256-256 0 0-256 256 0zM144.9 160l30.3 0 3.4 8.6 47.8 119.6c.1 .3 .2 .6 .3 .9l23.8 59.6 1.4 3.4-43.1 0-14.4-36-68.9 0-14.4 36-43.1 0 1.4-3.4L93.3 289c.1-.3 .2-.6 .4-.9l47.8-119.6 3.4-8.6zM160 229.9L141.5 276l36.9 0L160 229.9zM468 164l-40 0 0 20 0 4-36 0-20 0 0 40 20 0 56 0 32.9 0-22.7 50-20.1-20.1L424 243.7 395.7 272l14.1 14.1 12.4 12.4-23.2 11.6-17.9 8.9 17.9 35.8 17.9-8.9 38.2-19.1 30.6 18.3 17.2 10.3 20.6-34.3-17.1-10.3-15-9L524.9 228l15.1 0 0-40-20 0-8 0-44 0 0-4 0-20z"]
};
const faWheatAwnSlash = {
  prefix: 'fass',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L362.5 258.7l28.6-28.6 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L553 153l17-17L536 102.1l-17 17-43.4 43.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L457 57l17-17L440 6.1 423 23 393.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L358.1 16 335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-3.5 3.5-6.6 7.1-9.4 10.9L48.4 14.8zM293.8 327.5l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L89.4 441.4 66.7 464 112 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM553 57l17-17L536 6.1 519 23 447 95l-17 17L464 145.9l17-17 72-72z"]
};
const faFaceKissWinkHeart = {
  prefix: 'fass',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]
};
const faKissWinkHeart = faFaceKissWinkHeart;
const faDagger = {
  prefix: 'fass',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M224 0l0 32 0 96 80 0 32 0 48 0 0 48c0 26.5-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L192 192l-98.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48l0-48 48 0 32 0 80 0 0-96 0-32 64 0zM128 224l128 0 0 208-64 80-64-80 0-208z"]
};
const faPodium = {
  prefix: 'fass',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M288 0L192 0l0 24-24 0c-48.6 0-88 39.4-88 88l0 32-56 0L0 144l0 48 24 0 400 0 24 0 0-48-24 0-296 0 0-32c0-22.1 17.9-40 40-40l24 0 0 24 96 0c26.5 0 48-21.5 48-48s-21.5-48-48-48zM48 224L80 512l288 0 32-288L48 224z"]
};
const faDiamonds4 = {
  prefix: 'fass',
  iconName: 'diamonds-4',
  icon: [512, 512, [], "e68b", "M116.7 139.3L0 256 116.7 372.7 233.4 256 116.7 139.3zm22.6-22.6L256 233.4 372.7 116.7 256 0 139.3 116.7zm256 22.6L278.6 256 395.3 372.7 512 256 395.3 139.3zm-22.6 256L256 278.6 139.3 395.3 256 512 372.7 395.3z"]
};
const faMemoCircleCheck = {
  prefix: 'fass',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M384 0L0 0 0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-80.6 54.1-148.5 128-169.4L384 0zM80 128l224 0 16 0 0 32-16 0L80 160l-16 0 0-32 16 0zm0 96l160 0 16 0 0 32-16 0L80 256l-16 0 0-32 16 0zm0 96l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm496 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z"]
};
const faRouteHighway = {
  prefix: 'fass',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M240.5 12.6L224 2.7l-16.5 9.9-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7L51.2 5.8l-15 26.3-32 56L-4.3 103l7.7 15.3 18.2 36.4C28.4 168.4 32 183.5 32 198.8c0 12.5-2.4 25-7.1 36.6L9.1 275C3.1 290.1 0 306.2 0 322.5c0 50 29.1 95.4 74.6 116.3l136.1 62.4 13.3 6.1 13.3-6.1 136.1-62.4c45.5-20.8 74.6-66.3 74.6-116.3c0-16.3-3.1-32.4-9.1-47.5l-15.8-39.5c-4.7-11.7-7.1-24.1-7.1-36.6c0-15.3 3.6-30.4 10.4-44.1l18.2-36.4 7.7-15.3-8.5-14.9-32-56-15-26.3L369.7 19.4l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM95.9 192l256.3 0c-.1 2.3-.1 4.6-.1 6.8c0 20.7 3.9 41.2 11.6 60.4l15.8 39.5c3 7.5 4.6 15.6 4.6 23.7c0 25-14.6 47.7-37.3 58.1L224 436.8 101.3 380.5C78.6 370.1 64 347.4 64 322.5c0-8.1 1.6-16.2 4.6-23.7l15.8-39.5C92.1 240 96 219.5 96 198.8c0-2.3 0-4.6-.1-6.8z"]
};
const faDownToLine = {
  prefix: 'fass',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M352 224L192 384 32 224l0-32 96 0 0-160 128 0 0 160 96 0 0 32zM32 416l320 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z"]
};
const faArrowAltToBottom = faDownToLine;
const faFilter = {
  prefix: 'fass',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M192 416V320L0 96V32H512V96L320 320V512L192 416z"]
};
const faSquareG = {
  prefix: 'fass',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M448 32L0 32 0 480l448 0 0-448zM144 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"]
};
const faCirclePhone = {
  prefix: 'fass',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128l40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L312 272l72 40-16 72-16 0c-123.7 0-224-100.3-224-224l0-16 72-16z"]
};
const faPhoneCircle = faCirclePhone;
const faClipboardPrescription = {
  prefix: 'fass',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 196l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31 14.7-13.5 27 29.5-14.7 13.5L270 379.7l31.7 29.7 14.6 13.7-27.4 29.2-14.6-13.7-33.9-31.8-34.9 32-14.7 13.5-27-29.5 14.7-13.5 32.6-29.9-64.8-60.8-2.8-2.6L124 316l0 44 0 20-40 0 0-20 0-64 0-80 0-20 20 0zm55.1 79.7l.3 .3 16.6 0c11 0 20-9 20-20s-9-20-20-20l-52 0 0 40 34.8 0 .3-.3z"]
};
const faUserNurseHair = {
  prefix: 'fass',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M96 48L224 0 352 48l0 80-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128c0 0 0 0 0 0l0-40c0-2.7 .1-5.4 .3-8l-.3 0 0-80zm48 128c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-48 0-16-16-32 32-64 0zM126.1 320L224 424l97.9-104 62.1 0 64 192L0 512 64 320l62.1 0zM208 64l-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0 0 24z"]
};
const faQuestion = {
  prefix: 'fass',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 9.3c0 19.6-9 38.2-24.5 50.3l-75.3 59.2L128 288.4l0 15.6 0 48 64 0 0-32.4L255.1 270C286 245.7 304 208.6 304 169.3l0-9.3c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160l0 16 64 0 0-16zM200 400l-80 0 0 80 80 0 0-80z"]
};
const faFileSignature = {
  prefix: 'fass',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M224 0L0 0 0 512l384 0 0-85-1.7 1.7L262.2 445.9l-11.7 1.9-11.6 1.9-5.3-10.5L222.1 416l-12.2 0-11.6 23.2-4.4 8.8-9.9 0-8 0-11.9 0-3.4-11.4L144 381l-16.7 55.6L123.9 448 112 448l-32 0-16 0 0-32 16 0 20.1 0 20.6-68.6 3.4-11.4 11.9 0 16 0 11.9 0 3.4 11.4 15.4 51.4 3-5.9 4.4-8.8 9.9 0 32 0 9.9 0 4.4 8.8 7.2 14.5L267 313.4l117-117 0-36.4-160 0L224 0zm32 0l0 128 128 0L256 0zM505 119.8l-41.3 41.3 71 71L576 190.8l-71-71zm-63.9 63.9L299.9 325 288 407.9 370.9 396 512.1 254.7l-71-71z"]
};
const faToggleLargeOn = {
  prefix: 'fass',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M576 64L0 64 0 448l576 0 0-384zm-64 64l0 256-256 0 0-256 256 0z"]
};
const faUpDownLeftRight = {
  prefix: 'fass',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M160 96L256 0l96 96 0 32-64 0 0 96 96 0 0-64 32 0 96 96-96 96-32 0 0-64-96 0 0 96 64 0 0 32-96 96-96-96 0-32 64 0 0-96-96 0 0 64-32 0L0 256l96-96 32 0 0 64 96 0 0-96-64 0 0-32z"]
};
const faArrowsAlt = faUpDownLeftRight;
const faDryerHeat = {
  prefix: 'fass',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M448 0L0 0 0 512l448 0L448 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM171.3 204.7l-22.6 22.6L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-28.7-28.7zM280 233.4l-28.7-28.7-22.6 22.6L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6z"]
};
const faDryerAlt = faDryerHeat;
const faHouseChimneyUser = {
  prefix: 'fass',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M511.8 287.6l64.2 0 0-47.6-64-53.4L512 32l-96 0 0 74.5L288.4 0 0 240l0 47.6 64.1 0 0 224.4 448.7 0-1-224.4zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm80 160l32 96-224 0 32-96 160 0z"]
};
const faHandHoldingHeart = {
  prefix: 'fass',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M167.2 135.2L192 160l96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56l0-3.6C432 33.9 398.1 0 356.4 0c-23 0-44.7 10.4-59.1 28.4L288 40l-9.3-11.6C264.4 10.4 242.6 0 219.6 0C177.9 0 144 33.9 144 75.6l0 3.6c0 21 8.3 41.1 23.2 56zM140 327.1l-71.2 57L0 384.1l0 128 32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65-138.8 0 0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faArrowUpSmallBig = {
  prefix: 'fass',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M320 32l0 160 160 0 0-160L320 32zm0 224l0 224 224 0 0-224-224 0zM183.7 58.5L160 32.4l-23.7 26-80 88L34.8 170.2l47.4 43.1 21.5-23.7L128 162.8 128 448l0 32 64 0 0-32 0-285.2 24.3 26.8 21.5 23.7 47.4-43.1-21.5-23.7-80-88z"]
};
const faSortSizeUpAlt = faArrowUpSmallBig;
const faTrainTrack = {
  prefix: 'fass',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M407.1 32l-67.5 0 21.3 64L215.1 96l21.3-64-67.5 0L147.6 96 112 96 80 96l0 64 32 0 14.3 0-21.3 64L72 224l-32 0 0 64 32 0 11.6 0L62.3 352 32 352 0 352l0 64 32 0 8.9 0L19.6 480l67.5 0 21.3-64 359.2 0 21.3 64 67.5 0-21.3-64 8.9 0 32 0 0-64-32 0-30.3 0-21.3-64 11.6 0 32 0 0-64-32 0-32.9 0-21.3-64 14.3 0 32 0 0-64-32 0-35.6 0L407.1 32zM382.3 160l21.3 64-231.2 0 21.3-64 188.5 0zm42.7 128l21.3 64-316.5 0 21.3-64 273.9 0z"]
};
const faPuzzlePiece = {
  prefix: 'fass',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M192 89.6c-19.1-8.3-32-23.8-32-41.6c0-26.5 28.7-48 64-48s64 21.5 64 48c0 17.8-12.9 33.3-32 41.6l0 38.4 128 0 0 128 38.4 0c8.3-19.1 23.8-32 41.6-32c26.5 0 48 28.7 48 64s-21.5 64-48 64c-17.8 0-33.3-12.9-41.6-32L384 320l0 192-128 0 0-38.4c19.1-8.3 32-23.8 32-41.6c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 17.8 12.9 33.3 32 41.6l0 38.4L0 512 0 320l38.4 0c8.3 19.1 23.8 32 41.6 32c26.5 0 48-28.7 48-64s-21.5-64-48-64c-17.8 0-33.3 12.9-41.6 32L0 256 0 128l192 0 0-38.4z"]
};
const faMoneyCheck = {
  prefix: 'fass',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M576 64L0 64 0 448l576 0 0-384zM288 224l0 32L96 256l0-32 192 0zm192 96l0 32L96 352l0-32 384 0zm0-160l0 96-128 0 0-96 128 0z"]
};
const faStarHalfStroke = {
  prefix: 'fass',
  iconName: 'star-half-stroke',
  icon: [576, 512, ["star-half-alt"], "f5c0", "M319.7 60l54.8 104 115.8 20 66.9 11.6-47.3 48.7L428 328.5l16.7 116.3 9.7 67.2-60.9-29.9L288.1 430.2 182.6 482.1 121.7 512l9.7-67.2 16.7-116.3L66.2 244.2 18.9 195.6 85.7 184l115.8-20L256.4 60 288.1 0l31.7 60zM288.1 367.8l24.7 12.1 71.1 35-11.3-78.4-3.9-27.3 19.2-19.7 55.2-56.8L365 219.1l-27.1-4.7L325 190.1l-37-70.1 0 247.8z"]
};
const faStarHalfAlt = faStarHalfStroke;
const faFileExclamation = {
  prefix: 'fass',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM216 192l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM168 384l48 0 0 48-48 0 0-48z"]
};
const faCode = {
  prefix: 'fass',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M362.8 8l-9.4 30.6-128 416L216 485.2 277.2 504l9.4-30.6 128-416L424 26.8 362.8 8zm71.9 136l22.6 22.6L546.7 256l-89.4 89.4L434.7 368 480 413.3l22.6-22.6 112-112L637.3 256l-22.6-22.6-112-112L480 98.7 434.7 144zM160 98.7l-22.6 22.6-112 112L2.7 256l22.6 22.6 112 112L160 413.3 205.3 368l-22.6-22.6L93.3 256l89.4-89.4L205.3 144 160 98.7z"]
};
const faWhiskeyGlass = {
  prefix: 'fass',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M92.1 224L73.8 96l364.4 0L419.9 224 92.1 224zM64 480l384 0L502.9 96 512 32l-64.6 0L64.6 32 0 32 9.1 96 64 480z"]
};
const faGlassWhiskey = faWhiskeyGlass;
const faMoonStars = {
  prefix: 'fass',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M320 64L304 16 288 64 240 80l48 16 16 48 16-48 48-16L320 64zM440 200l-24-72-24 72-72 24 72 24 24 72 24-72 72-24-72-24zM128 288c0-72.5 48.2-133.7 114.2-153.4c-16-4.3-32.9-6.6-50.2-6.6C86 128 0 214 0 320S86 512 192 512c61.5 0 116.2-28.9 151.3-73.8c-17.2 6.4-35.9 9.8-55.3 9.8c-88.4 0-160-71.6-160-160z"]
};
const faBuildingCircleExclamation = {
  prefix: 'fass',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0 0-8.2c-39.1-32.3-64-81.1-64-135.8s24.9-103.5 64-135.8L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faClothesHanger = {
  prefix: 'fass',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M209.8 84.8C222.3 35 267.1 0 318.5 0L320 0c61.9 0 112 50.1 112 112l0 6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L626.3 389.7l13.7 9.5 0 16.7 0 64 0 32-32 0L32 512 0 512l0-32 0-64 0-16.7 13.7-9.5L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3l0-6.3c0-26.5-21.5-48-48-48l-1.5 0c-22 0-41.2 15-46.6 36.4l-.9 3.4-7.8 31-62.1-15.5 7.8-31 .9-3.4zM320 255L64 432.7 64 448l512 0 0-15.3L320 255z"]
};
const faMobileNotch = {
  prefix: 'fass',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M128 64l0 32 128 0 0-32 48 0 0 384L80 448 80 64l48 0zM80 0L16 0l0 64 0 384 0 64 64 0 224 0 64 0 0-64 0-384 0-64L304 0 80 0zm48 384l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z"]
};
const faMobileIphone = faMobileNotch;
const faMagnifyingGlassChart = {
  prefix: 'fass',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8l0 64 0 24 48 0 0-24 0-64 0-24-48 0 0 24zm80-96l0 160 0 24 48 0 0-24 0-160 0-24-48 0 0 24zm80 64l0 96 0 24 48 0 0-24 0-96 0-24-48 0 0 24z"]
};
const faArrowUpRightFromSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M320 0L288 0l0 64 32 0 82.7 0L201.4 265.4 178.7 288 224 333.3l22.6-22.6L448 109.3l0 82.7 0 32 64 0 0-32 0-160 0-32L480 0 320 0zM32 32L0 32 0 64 0 480l0 32 32 0 424 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448 64 96l96 0 32 0 0-64-32 0L32 32z"]
};
const faExternalLink = faArrowUpRightFromSquare;
const faCubesStacked = {
  prefix: 'fass',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M192 32l0 128 128 0 0-128L192 32zM165.8 159L55 223l64 110.9 110.9-64L165.8 159zM256 192l0 128 128 0 0-128-128 0zM448 480l0-128-128 0 0 128 128 0zM160 352l0 128 128 0 0-128-128 0zm-32 0L0 352 0 480l128 0 0-128z"]
};
const faImagesUser = {
  prefix: 'fass',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M96 32l0 352 480 0 0-352L96 32zM336 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM440 320l-208 0 24-64 160 0 24 64zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faWonSign = {
  prefix: 'fass',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M56.6 224L3.2 32l66.4 0L123 224l57.8 0L220.9 56.5 226.8 32 252 32l8 0 25.2 0 5.9 24.5L331.2 224l57.8 0L442.3 32l66.4 0L455.4 224l24.6 0 32 0 0 64-32 0-42.3 0L390.8 456.6 384.3 480 360 480l-8 0-25.2 0-5.9-24.5L280.8 288l-49.5 0L191.1 455.5 185.2 480 160 480l-8 0-24.3 0-6.5-23.4L74.3 288 32 288 0 288l0-64 32 0 24.6 0zm84.2 64L154 335.7 165.4 288l-24.7 0zm105.8-64l18.9 0L256 184.7 246.6 224zm100 64L358 335.7 371.2 288l-24.7 0z"]
};
const faKrw = faWonSign;
const faWon = faWonSign;
const faImagePolaroidUser = {
  prefix: 'fass',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M0 32l448 0 0 448L0 480 0 32zM64 96l0 256 56 0 24-64 160 0 24 64 56 0 0-256L64 96zm96 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faVirusCovid = {
  prefix: 'fass',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M320 48l-24 0-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6l-17-17 33.9-33.9 17 17L437 75l28.3 28.3 17 17-33.9 33.9-17-17L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16 0-24 48 0 0 24 0 40 0 40 0 24-48 0 0-24 0-16-33.6 0c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3 17-17 33.9 33.9-17 17L437 437l-28.3 28.3-17 17-33.9-33.9 17-17L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1l0 33.6 16 0 24 0 0 48-24 0-40 0-40 0-24 0 0-48 24 0 16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3 17 17-33.9 33.9-17-17L75 437 46.7 408.7l-17-17 33.9-33.9 17 17L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280L48 280l0 16 0 24L0 320l0-24 0-40 0-40 0-24 48 0 0 24 0 16 33.6 0c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2l-17 17L29.7 120.2l17-17L75 75l28.3-28.3 17-17 33.9 33.9-17 17L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1L232 48l-16 0-24 0 0-48 24 0 40 0 40 0 24 0 0 48zM240 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faSquareEllipsis = {
  prefix: 'fass',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M448 480l0-448L0 32 0 480l448 0zM160 224l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
const faPie = {
  prefix: 'fass',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M544 240l-12.7 0C497.7 137.8 401.4 64 288 64S78.3 137.8 44.7 240L32 240 0 240l0 64 32 0 9.2 0 63.9-30.4 6-2.9 6.3 2.3L200 303l82.5-30 5.5-2 5.5 2L376 303l82.5-30 6.3-2.3 6.1 2.9L534.8 304l9.2 0 32 0 0-64-32 0zM96 448l384 0 38.7-116.2-55.6-26.5L381.5 335l-5.5 2-5.5-2L288 305l-82.5 30-5.5 2-5.5-2-81.7-29.7L57.3 331.8 96 448zM206.3 151.2l-16 32-7.2 14.3-28.6-14.3 7.2-14.3 16-32 7.2-14.3 28.6 14.3-7.2 14.3zm192-14.3l16 32 7.2 14.3-28.6 14.3-7.2-14.3-16-32-7.2-14.3 28.6-14.3 7.2 14.3zM304 144l0 32 0 16-32 0 0-16 0-32 0-16 32 0 0 16z"]
};
const faChessKnightPiece = {
  prefix: 'fass',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M57.6 102.4L32 128l0 120 38.4 32L160 222.4l0 32L48 337.6 48 384l224 0 27.1-109.6c3.3-13.3 4.9-27 4.9-40.7C304 140 228 64 134.2 64L32 64l0 25.6 25.6 12.8zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 477.4L0 512l320 0 0-34.6L276.1 416 43.9 416 0 477.4z"]
};
const faChessKnightAlt = faChessKnightPiece;
const faAustralSign = {
  prefix: 'fass',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M194.3 32L216 32l16 0 21.7 0 8 20.1L330.5 224l85.5 0 32 0 0 64-32 0-59.9 0 12.8 32 47.1 0 32 0 0 64-32 0-21.5 0 27.2 68.1L432.9 480l-68.9 0-1.6-4.1L325.5 384l-203.1 0L85.7 475.9 84.1 480l-68.9 0 11.2-27.9L53.5 384 32 384 0 384l0-64 32 0 47.1 0 12.8-32L32 288 0 288l0-64 32 0 85.5 0L186.3 52.1l8-20.1zM224 130.2L186.5 224l75.1 0L224 130.2zM148.1 320l151.9 0-12.8-32-126.3 0-12.8 32z"]
};
const faCloudPlus = {
  prefix: 'fass',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zm152-80l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faF = {
  prefix: 'fass',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 64 0 0-32 0-160 160 0 32 0 0-64-32 0L64 224 64 96l224 0 32 0 0-64-32 0L32 32z"]
};
const faLeaf = {
  prefix: 'fass',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M272 96l104 0c50.2 0 92.7-33 106.9-78.6C501.5 58.8 512 106.2 512 156.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440l0 16 0 24L0 480l0-24 0-16c0-75.1 38.3-141.2 96.4-179.9C130.6 237.3 171.8 224 216 224c0 0 0 0 0 0l72 0 16 0 16 0 0-32-16 0-88 0c-40.2 0-78.2 9.6-111.7 26.5C126.9 147.5 193.4 96 272 96c0 0 0 0 0 0z"]
};
const faBedBunk = {
  prefix: 'fass',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-32 192 0 256 0 0 32 0 32 64 0 0-32 0-32 0-32 0-128 0-32 0-64 0-32 0-32 0-16C576 50.1 525.9 0 464 0L256 0 224 0l0 32 0 96L64 128l0-96zM512 256l-256 0-32 0 0 32 0 96L64 384l0-192 192 0 256 0 0 64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faRoad = {
  prefix: 'fass',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M256 32L128 32 0 480l256 0 0-64 0-32 64 0 0 32 0 64 256 0L448 32 320 32l0 64 0 32-64 0 0-32 0-64zm64 192l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z"]
};
const faTaxi = {
  prefix: 'fass',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M352 0L160 0l0 64-40 0L97.3 64 89.8 85.4 41.3 224 0 224 0 432l0 80 96 0 0-80 320 0 0 80 96 0 0-80 0-208-41.3 0L422.2 85.4 414.7 64 392 64l-40 0 0-64zm17.3 128l33.6 96-293.8 0 33.6-96 226.6 0zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faCab = faTaxi;
const faPersonCirclePlus = {
  prefix: 'fass',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faChartPie = {
  prefix: 'fass',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M304 240L304 .6c5.3-.4 10.6-.6 16-.6C443.7 0 544 100.3 544 224c0 5.4-.2 10.7-.6 16L304 240zM32 272C32 144.8 130.9 40.8 256 32.5L256 288 425 457c-41.5 34.4-94.8 55-153 55C139.5 512 32 404.6 32 272zm288 16l255.5 0C571 355.9 538.3 416.1 489 457L320 288z"]
};
const faPieChart = faChartPie;
const faBoltLightning = {
  prefix: 'fass',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M0 288L32 0H256L208 160H384v48L128 512l48-224H0z"]
};
const faClockEight = {
  prefix: 'fass',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136 0 12.8L269.3 276l-96 64-20 13.3-26.6-39.9 20-13.3L232 243.2 232 120l0-24 48 0 0 24z"]
};
const faSackXmark = {
  prefix: 'fass',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M192 96l128 0L384 0 128 0l64 96zm128 32l-128 0c-3.8 2.5-8.1 5.3-13 8.4c0 0 0 0 0 0s0 0 0 0C122.3 172.7 0 250.9 0 416l0 96 96 0 320 0 96 0 0-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM222.1 336l-55-55L201 247l55 55 55-55L345 281l-55 55 55 55L311 425l-55-55-55 55L167 391l55-55z"]
};
const faFileXls = {
  prefix: 'fass',
  iconName: 'file-xls',
  icon: [512, 512, [], "e64d", "M0 0L224 0l0 160 160 0 0 144-240 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM224 368c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4l0-16 32 0 0 16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496l0 16-32 0 0-16c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4l0 16-32 0 0-16c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368l0-16 32 0 0 16zm96 144l0-16 0-128 0-16 32 0 0 16 0 112 24 0 16 0 0 32-16 0-40 0-16 0zm88-114.3c0-25.2 20.4-45.7 45.7-45.7l26.3 0 16 0 0 32-16 0-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L432 512l-16 0 0-32 16 0 26.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z"]
};
const faFileExcel = {
  prefix: 'fass',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM97.7 240l56.8 0L192 299.1 229.5 240l56.8 0L220.4 344l65.9 104-56.8 0L192 388.9 154.5 448l-56.8 0 65.9-104L97.7 240z"]
};
const faFileContract = {
  prefix: 'fass',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM80 64l64 0 16 0 0 32-16 0L80 96 64 96l0-32 16 0zm0 64l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm56 176l16 0 11.9 0 3.4 11.4 15.4 51.4 3-5.9 4.4-8.8 9.9 0 32 0 9.9 0 4.4 8.8L257.9 384l46.1 0 16 0 0 32-16 0-56 0-9.9 0-4.4-8.8L222.1 384l-12.2 0-11.6 23.2-4.4 8.8-9.9 0-8 0-11.9 0-3.4-11.4L144 349l-16.7 55.6L123.9 416 112 416l-32 0-16 0 0-32 16 0 20.1 0 20.6-68.6 3.4-11.4 11.9 0z"]
};
const faFishFins = {
  prefix: 'fass',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M224 64l13.5 53.9c-37.7 17.5-67.9 43.1-90.6 67.6L32 128 0 160l48 96L0 352l32 32 114.9-57.5c22.6 24.4 52.8 50 90.6 67.6L224 448l48 32 73.4-64.2C499.1 409.8 576 256 576 256s-76.9-153.8-230.6-159.8L272 32 224 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleQ = {
  prefix: 'fass',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-336c-44.2 0-80 35.8-80 80s35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L238.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80zm0 208c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L401.9 384l-61.5 0-15.9-19.9C304.7 376.7 281.2 384 256 384z"]
};
const faBuildingFlag = {
  prefix: 'fass',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM480 0L416 0l0 32 0 480 64 0 0-320 160 0 0-160L480 32l0-32z"]
};
const faFaceGrinBeam = {
  prefix: 'fass',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faGrinBeam = faFaceGrinBeam;
const faObjectUngroup = {
  prefix: 'fass',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M128 0L0 0 0 128l32 0 0 96L0 224 0 352l128 0 0-32 192 0 0 32 128 0 0-128-32 0 0-96 32 0L448 0 320 0l0 32L128 32l0-32zM352 224l0 32-32 0-192 0-32 0 0-32 0-96 0-32 32 0 192 0 32 0 0 32 0 96zM320 512l0-32 192 0 0 32 128 0 0-128-32 0 0-96 32 0 0-128-128 0 0 32-32 0 0 64 32 0 32 0 0 32 0 96 0 32-32 0-32 0-160 0-32 0 0-32 0-32-64 0 0 32-32 0 0 128 128 0z"]
};
const faFaceDisguise = {
  prefix: 'fass',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M256 512c141.4 0 256-114.6 256-256c0-16.4-1.5-32.5-4.5-48L440 208c0 49.4-37.4 90.1-85.4 95.4l4.5 2.3 8.8 4.4 0 9.9 0 32 0 9.9-8.8 4.4-14.3 7.1L364.5 398l10 12.5-25 20-10-12.5-23.9-29.9-7.3 3.6 10.5 26.3 5.9 14.9-29.7 11.9-5.9-14.9-9.5-23.9-7.6 3.8 0 22.1 0 16-32 0 0-16 0-22.1-7.6-3.8-9.5 23.9-5.9 14.9-29.7-11.9 5.9-14.9 10.5-26.3-7.3-3.6L172.5 418l-10 12.5-25-20 10-12.5 19.6-24.5-14.3-7.1-8.8-4.4 0-9.9 0-32 0-9.9 8.8-4.4 4.5-2.3c-48-5.3-85.4-46-85.4-95.4L4.5 208C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512zm55.1-249.3c2.9 1.8 5.4 3.2 6.8 3.8c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 4.4 .4 8.7 1.3 12.8l29.6 42.3 .2-.4zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c1.4-.6 3.9-2 6.8-3.8l.2 .4 29.6-42.3c.8-4.1 1.3-8.4 1.3-12.8zM12.7 176l64.7 0c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3-7.2-14.3 28.6-14.3 7.2 14.3 3.5 7c4.6-2 9.3-3.6 14.2-4.9l0-19 0-16 32 0 0 16 0 16.3c4.4 .4 8.7 1 13 2l4.7-9.5 7.2-14.3 28.6 14.3-7.2 14.3-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3-7.2-14.3 28.6-14.3 7.2 14.3 4.7 9.5c4.2-.9 8.6-1.6 13-2L336 96l0-16 32 0 0 16 0 19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7 7.2-14.3 28.6 14.3-7.2 14.3-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5l64.7 0C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240.5l-50.9 72.7-2.3 3.3-3.6 1.8L176 329.9l0 12.2 80 40 80-40 0-12.2-23.2-11.6-3.6-1.8-2.3-3.3L256 240.5zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faCircleArrowDownRight = {
  prefix: 'fass',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm88 368l-152 0-24 0 0-48 24 0 94.1 0L151 185l-17-17L168 134.1l17 17 135 135L320 184l0-24 48 0 0 24 0 160 0 24-24 0z"]
};
const faAlien8bit = {
  prefix: 'fass',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", "M96 32l64 0 0 32 64 0 0 64 128 0 0-64 64 0 0-32 64 0 0 64-64 0 0 32 0 32 64 0 0 64 32 0 0-96 64 0 0 160-64 0 0 96-64 0 0 96-64 0-64 0 0-64 64 0 0-32-192 0 0 32 64 0 0 64-64 0-64 0 0-96-64 0 0-96L0 288 0 128l64 0 0 96 32 0 0-64 64 0 0-32 0-32L96 96l0-64zm64 288l64 0 0-96-64 0 0 96zm192 0l64 0 0-96-64 0 0 96z"]
};
const faAlienMonster = faAlien8bit;
const faHandPointRibbon = {
  prefix: 'fass',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M64 0l64 0 0 32 32 0 0 96L0 128 43.6 80 0 32l64 0L64 0zm96 128l0 32 0 80 64 0 0-112-64 0zM64 160l64 0 0 80-64 0 0-80zm192 0l64 0 0 128-64 0 0-128zm96 32l64 0 0 128-64 0 0-128zM32 363l0-91 192 0 0 48 0 32-96 0-16 0 0 32 16 0 112 0 16 0 0-16 0-48 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363z"]
};
const faPoop = {
  prefix: 'fass',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M176 128c44.2 0 80-35.8 80-80c0-17.5-5.6-33.7-15.1-46.8C245.8 .4 250.9 0 256 0c53 0 96 43 96 96c0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48l13.7 0c39.8 0 72 32.2 72 72c0 25.6-13.4 48.2-33.6 60.9C484.5 385.6 512 421.6 512 464l0 48L0 512l0-48c0-42.4 27.5-78.4 65.6-91.1C45.4 360.2 32 337.6 32 312c0-39.8 32.2-72 72-72l13.7 0C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64l5.5 0 10.5 0z"]
};
const faObjectExclude = {
  prefix: 'fass',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M0 0L352 0l0 160 160 0 0 352-352 0 0-160L0 352 0 0zM320 192l-128 0 0 128 128 0 0-128z"]
};
const faTelescope = {
  prefix: 'fass',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M476 277.7l97-56L445 0 348 56 476 277.7zM336.3 99.7c-1-1.8-2-3.6-2.8-5.4L36.7 284.9l19.2 33.3L0 350.5l49.9 86.4 55.9-32.3 16.3 28.2 115.7-62.1L180.3 512l51.8 0L304 335.6 375.9 512l51.8 0L346.4 312.5l86.1-46.2-.2-.3-96-166.3z"]
};
const faLocationPin = {
  prefix: 'fass',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M384 192c0 112-192 320-192 320S0 304 0 192C0 86 86 0 192 0S384 86 384 192z"]
};
const faMapMarker = faLocationPin;
const faSquareList = {
  prefix: 'fass',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M0 32l448 0 0 448L0 480 0 32zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248l-24 0 0 48 24 0 160 0 24 0 0-48-24 0-160 0zm0 96l-24 0 0 48 24 0 160 0 24 0 0-48-24 0-160 0zm0 96l-24 0 0 48 24 0 160 0 24 0 0-48-24 0-160 0z"]
};
const faKaaba = {
  prefix: 'fass',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M288 0L0 96l0 32 0 15.1 0 .9 288 96 288-96 0-.9 0-15.1 0-32L288 0zm0 189.4L79.8 120 288 50.6 496.2 120 288 189.4zM0 176.9l0 46.3 5.1 1.7L64 244.5l0 33.7L0 256.9 0 416l288 96 288-96 0-159.1-64 21.3 0-33.7 58.9-19.6 5.1-1.7 0-46.3L293.1 271.2l-5.1 1.7-5.1-1.7L0 176.9zm96 112l0-33.7 96 32 0 33.7-96-32zm128 42.7l0-33.7 64 21.3 64-21.3 0 33.7-58.9 19.6-5.1 1.7-5.1-1.7L224 331.5zm160-44.4l96-32 0 33.7-96 32 0-33.7z"]
};
const faToiletPaper = {
  prefix: 'fass',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M384 192c0-65.5 13.2-142.4 60.2-192L160 0C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512l325.3 0C376 409.7 384 301.9 384 192zM512 384c53 0 96-86 96-192S565 0 512 0s-96 86-96 192s43 192 96 192zm0-128c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM112 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faHelmetSafety = {
  prefix: 'fass',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M352 32L224 32l0 34.3L224 176 159.6 85.8C84.1 121.8 32 198.8 32 288l0 64 512 0 0-66.4c-.9-88.1-52.8-164.1-127.5-199.8L352 176l0-109.7L352 32zM0 408s80 72 288 72s288-72 288-72l0-24L0 384l0 24z"]
};
const faHardHat = faHelmetSafety;
const faHatHard = faHelmetSafety;
const faCommentCode = {
  prefix: 'fass',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM217 193l17-17L200 142.1l-17 17-64 64-17 17 17 17 64 64 17 17L233.9 304l-17-17-47-47 47-47zM329 159l-17-17L278.1 176l17 17 47 47-47 47-17 17L312 337.9l17-17 64-64 17-17-17-17-64-64z"]
};
const faSimCards = {
  prefix: 'fass',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M128 0L96 0l0 32 0 352 0 32 32 0 288 0 32 0 0-32 0-256 0-13.3-9.4-9.4-96-96L333.3 0 320 0 128 0zm80 144l0 48-48 0 0-48 48 0zm-48 80l64 0 96 0 64 0 0 48-64 0-96 0-64 0 0-48zm224-32l-48 0 0-48 48 0 0 48zm-80-48l0 48-64 0 0-48 64 0zm80 160l0 48-48 0 0-48 48 0zm-80 48l-64 0 0-48 64 0 0 48zm-96 0l-48 0 0-48 48 0 0 48zM48 120l0-24L0 96l0 24L0 488l0 24 24 0 336 0 24 0 0-48-24 0L48 464l0-344z"]
};
const faStarship = {
  prefix: 'fass',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM188.9 205.4L137 160l71 0 32 0 0-64-32 0L32 96 0 96l0 64 32 0 32.1 0 65.5 57.3L96 224l0 64 33.6 6.7L64.1 352 32 352 0 352l0 64 32 0 176 0 32 0 0-64-32 0-71 0 51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z"]
};
const faEject = {
  prefix: 'fass',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M0 320l0-48L224 32 448 272l0 48L0 320zM448 480L0 480l0-96 448 0 0 96z"]
};
const faCircleRight = {
  prefix: 'fass',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM256 384l0-80-128 0 0-96 128 0 0-80 16 0L400 256 272 384l-16 0z"]
};
const faArrowAltCircleRight = faCircleRight;
const faPlaneCircleCheck = {
  prefix: 'fass',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3 85.5 57C354.3 247.8 320 303.9 320 368c0 54.7 24.9 103.5 64 135.8l0 8.2L256 480 128 512l0-64 64-48 0-80L0 384l0-96L192 160l0-66.3zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z"]
};
const faSeal = {
  prefix: 'fass',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M331 75L256 0 181 75 75 75l0 106L0 256l75 75 0 106 106 0 75 75 75-75 106 0 0-106 75-75-75-75 0-106L331 75z"]
};
const faUserCowboy = {
  prefix: 'fass',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M160 0L110 112.4c27.2 8.7 64.7 15.6 114 15.6s86.8-6.9 114-15.6L288 0 224 32 160 0zM83.8 137.1c-32.4-12.7-49.4-27.2-55-34.7L.8 117.1c9.3 27.9 35 62.4 72.5 89.9c7.1 5.2 14.7 10.1 22.7 14.8c0 .8 0 1.5 0 2.3c0 70.7 57.3 128 128 128s128-57.3 128-128c0-.8 0-1.5 0-2.3c8-4.6 15.6-9.6 22.7-14.8c37.6-27.4 63.2-62 72.5-89.9l-28-14.7c-5.6 7.5-22.7 22-55 34.7C332.2 149.6 286.2 160 224 160s-108.2-10.4-140.2-22.9zM400 384L48 384 0 512l448 0L400 384z"]
};
const faHexagonVerticalNft = {
  prefix: 'fass',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M0 128L0 384 224 512 448 384l0-256L224 0 0 128zm80 32l8 0 11.9 0 3.4 11.4L128 253.7l0-77.7 0-16 32 0 0 16 0 160 0 16-16 0-8 0-11.9 0-3.4-11.4L96 258.3 96 336l0 16-32 0 0-16 0-160 0-16 16 0zm128 0l48 0 16 0 0 32-16 0-32 0 0 48 32 0 16 0 0 32-16 0-32 0 0 64 0 16-32 0 0-16 0-80 0-80 0-16 16 0zm96 0l32 0 32 0 16 0 0 32-16 0-16 0 0 144 0 16-32 0 0-16 0-144-16 0-16 0 0-32 16 0z"]
};
const faFaceRollingEyes = {
  prefix: 'fass',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"]
};
const faMehRollingEyes = faFaceRollingEyes;
const faBreadLoaf = {
  prefix: 'fass',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M397.4 34.9c-2.1-.9-4.1-1.9-6.2-2.8c3.1-.1 6-.2 8.8-.2c64 0 240 32 240 160c0 35.3-28.7 64-64 64l0 224-128 0 0-197.5c37.3-13.2 64-48.7 64-90.5c0-82.2-57.6-130.7-114.6-157.1zM0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64l0 224L64 480l0-224c-35.3 0-64-28.7-64-64z"]
};
const faRingsWedding = {
  prefix: 'fass',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M128.7 102.4L96 48 128 0l96 0 32 48-32.7 54.4C297.5 123.1 352 191.2 352 272c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-80.8 54.5-148.9 128.7-169.6zM64 272c0 58.7 45.1 106.8 102.5 111.6c-4.2-15.1-6.5-31.1-6.5-47.6c0-64.4 34.5-120.7 86.1-151.3C226.9 169.2 202.5 160 176 160c-61.9 0-112 50.1-112 112z"]
};
const faObjectGroup = {
  prefix: 'fass',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M0 128L0 64 0 0 64 0l64 0 0 32 320 0 0-32 64 0 64 0 0 64 0 64-32 0 0 256 32 0 0 64 0 64-64 0-64 0 0-32-320 0 0 32-64 0L0 512l0-64 0-64 32 0 0-256L0 128zM96 416l384 0 0-320L96 96l0 320zm32-288l192 0 0 160-192 0 0-160zM256 320l64 0 32 0 0-32 0-64 96 0 0 160-192 0 0-64z"]
};
const faFrenchFries = {
  prefix: 'fass',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M64 32L97.4 221.4 117.7 272l10.3 0 0-181.3L112 0 64 32zM18.7 192l41.1 0L41.8 90.5 0 80 18.7 192zM384 80L342.7 90.3 325.8 192l39.6 0L384 80zM320 32L256 48l0 224 10.3 0 23.4-58.6L320 32zM160 272l64 0 0-32 0-208L160 0l0 272zM0 224L64 512l256 0 64-288-64 0-32 80L96 304 64 224 0 224z"]
};
const faChartLine = {
  prefix: 'fass',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zM342.6 278.6l128-128-45.3-45.3L320 210.7l-57.4-57.4L240 130.7l-22.6 22.6-112 112 45.3 45.3L240 221.3l57.4 57.4L320 301.3l22.6-22.6z"]
};
const faLineChart = faChartLine;
const faCalendarArrowDown = {
  prefix: 'fass',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zm248 72l0-24-48 0 0 24 0 102.1-39-39-17-17L110.1 344l17 17 80 80 17 17 17-17 80-80 17-17L304 310.1l-17 17-39 39L248 264z"]
};
const faCalendarDownload = faCalendarArrowDown;
const faSendBack = {
  prefix: 'fass',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 64l0 128L64 192 64 64l128 0zM64 0L0 0 0 64 0 192l0 64 64 0 128 0 64 0 0-64 0-128 0-64L192 0 64 0zM576 320l0 128-128 0 0-128 128 0zM448 256l-64 0 0 64 0 128 0 64 64 0 128 0 64 0 0-64 0-128 0-64-64 0-128 0zM160 288l0 128 192 0 0-160 0-32 32 0 96 0 0-128L288 96l0 160 0 32-32 0-96 0z"]
};
const faMaskVentilator = {
  prefix: 'fass',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M384 393.2l0 76.6c38-12.6 70.6-36 93.5-66.4l144.4-36.1 18.2-4.5 0-18.7 0-192 0-24-24 0-161.5 0c-2.3-3.5-4.6-7-6.9-10.4L384 32 256 32l-64 85.6c-2.4 3.4-4.7 6.9-6.9 10.4L24 128 0 128l0 24L0 344l0 18.7 18.2 4.5 144.1 36c22.7 30.5 55.4 54.1 93.8 66.6l0-76.6c-19.7-16.4-32-40.3-32-66.9c0-26.5 12.4-63.2 32-91.6L288 192l32 0 32 0 31.8 42.8c19.7 28.4 32.2 65.1 32.2 91.6c0 26.7-12.4 50.4-32 66.8zM134.3 346.8L48 325.3 48 176l111.1 0C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46zM480.7 176L592 176l0 149.3-86.4 21.6c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 288l0 224 64 0 0-224-64 0z"]
};
const faTickets = {
  prefix: 'fass',
  iconName: 'tickets',
  icon: [640, 512, [], "e658", "M96 32l0 128c26.5 0 48 21.5 48 48s-21.5 48-48 48l0 128 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128L96 32zm416 96l-288 0 0 160 288 0 0-160zM224 96l288 0 32 0 0 32 0 160 0 32-32 0-288 0-32 0 0-32 0-160 0-32 32 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faSignatureLock = {
  prefix: 'fass',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-130 39L0 264.2 0 288 0 448l0 32 32 0 64 0 18.6 0 9.2-16.1 25.5-44.7c26.8-47 46.5-97.7 58.4-150.5L288 244.6l0 43.4 0 32 32 0 32 0 32 0 0-32 0-32-32 0 0-54.4 0-43-41.2 12.4-90.4 27.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32 0 32 64 0 0-32 0-32zM209.9 368c-6.7 16.3-14.2 32.3-22.3 48L384 416l0-48-174.1 0zM64 311.8l71.8-21.5c-10.4 33.8-24.5 66.4-42.1 97.2L77.4 416 64 416l0-104.2zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faArrowRight = {
  prefix: 'fass',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M422.6 278.6L445.3 256l-22.6-22.6-144-144L256 66.7 210.8 112l22.6 22.6L322.8 224 32 224 0 224l0 64 32 0 290.7 0-89.4 89.4L210.8 400 256 445.3l22.6-22.6 144-144z"]
};
const faSignsPost = {
  prefix: 'fass',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M224 0l64 0 0 32 160 0 64 64-64 64L32 160 32 32l192 0 0-32zm0 224l0-32 64 0 0 32 192 0 0 128L64 352 0 288l64-64 160 0zm64 160l0 128-64 0 0-128 64 0z"]
};
const faMapSigns = faSignsPost;
const faOctagonPlus = {
  prefix: 'fass',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zM232 368l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"]
};
const faPlusOctagon = faOctagonPlus;
const faCashRegister = {
  prefix: 'fass',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M320 0L32 0l0 128 112 0 0 32L32 160 0 371.2 0 512l512 0 0-140.8L480 160l-272 0 0-32 112 0L320 0zM96 48l160 0 16 0 0 32-16 0L96 80 80 80l0-32 16 0zM64 416l16 0 352 0 16 0 0 32-16 0L80 448l-16 0 0-32zm72-200l0 48-48 0 0-48 48 0zm48 48l0-48 48 0 0 48-48 0zm0 32l0 48-48 0 0-48 48 0zm96-80l48 0 0 48-48 0 0-48zm-48 80l48 0 0 48-48 0 0-48zm144-80l48 0 0 48-48 0 0-48zm0 80l0 48-48 0 0-48 48 0z"]
};
const faPersonCircleQuestion = {
  prefix: 'fass',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-22.4 56c-23 0-41.6 18.6-41.6 41.6l0 6.4 32 0 0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5 0 9.7 0 6.8 0 16 32 0 0-13.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0zM448 416l-32 0 0 32 32 0 0-32z"]
};
const faMelonSlice = {
  prefix: 'fass',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M391.4 391.4C294.6 488.2 137.9 487.9 41 391L7 425c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7L391 41c96.9 96.9 97.1 253.6 .3 350.4zM320 128c0 106-86 192-192 192c-14.4 0-28.4-1.6-41.9-4.6L48 353.5l15.3 15.3c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1L353.5 48 315.4 86.1c3 13.5 4.6 27.5 4.6 41.9z"]
};
const faSpaceStationMoon = {
  prefix: 'fass',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0S512 114.6 512 256zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faMessageSmile = {
  prefix: 'fass',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM168.4 222.1l-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9z"]
};
const faCommentAltSmile = faMessageSmile;
const faCupStraw = {
  prefix: 'fass',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M224 0l56 0 24 0 0 48-24 0-37 0-18.8 80L352 128l32 0 0 64-32 0L32 192 0 192l0-64 32 0 142.9 0L200.6 18.5 205 0l19 0zM64 512L40 224l304 0L320 512 64 512z"]
};
const faLeftFromLine = {
  prefix: 'fass',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M160 416L0 256 160 96l32 0 0 96 160 0 0 128-160 0 0 96-32 0zm224 0l0-320 0-32 64 0 0 32 0 320 0 32-64 0 0-32z"]
};
const faArrowAltFromRight = faLeftFromLine;
const faH = {
  prefix: 'fass',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M320 256l0 192 0 32 64 0 0-32 0-192 0-32 0-32 0-128 0-32-64 0 0 32 0 128L64 192 64 64l0-32L0 32 0 64 0 192l0 64L0 448l0 32 64 0 0-32 0-192 256 0z"]
};
const faBasketShoppingSimple = {
  prefix: 'fass',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M256.4 29.8L245.3 51.1 171.8 192l232.5 0L330.7 51.1 319.6 29.8 362.2 7.6l11.1 21.3L458.4 192 576 192l0 64-32 0L480 512 96 512 32 256 0 256l0-64 117.6 0L202.7 28.9 213.8 7.6l42.6 22.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faShoppingBasketAlt = faBasketShoppingSimple;
const faHandsHoldingHeart = {
  prefix: 'fass',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M199.2 135.1L224 159.9l96 96 96-96 24.8-24.8c14.9-14.9 23.2-35 23.2-56l0-3.6C464 33.8 430.1-.1 388.4-.1c-23 0-44.7 10.4-59.1 28.4L320 39.9l-9.3-11.6C296.4 10.4 274.6-.1 251.6-.1C209.9-.1 176 33.8 176 75.6l0 3.6c0 21 8.3 41.1 23.2 56zM80 64L0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40zm480 0l0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4 0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0z"]
};
const faHandsHeart = faHandsHoldingHeart;
const faClockNine = {
  prefix: 'fass',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136 0 24-24 0-104 0-24 0 0-48 24 0 80 0 0-112 0-24 48 0 0 24z"]
};
const faHammerBrush = {
  prefix: 'fass',
  iconName: 'hammer-brush',
  icon: [640, 512, [], "e620", "M256 0L144 0C64.5 0 0 64.5 0 144l0 16 80-32 32 32 144 0 0-32 32 0 0 32 64 0L352 0 288 0l0 32-32 0 0-32zM96 512l128 0L208 192l-96 0L96 512zm320 0l32-96 32 96 160 0 0-192-288 0 0 192 64 0zM352 256l0 32 288 0 0-32-96-64L544 0 448 0l0 192-96 64zM496 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
const faTarp = {
  prefix: 'fass',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M576 288l0-224L0 64 0 448l416 0 0-160 160 0zm0 32l-128 0 0 128L576 320zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFaceSleepy = {
  prefix: 'fass',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M256 512c47.1 0 91.2-12.7 129.1-34.9c-.7-4.3-1.1-8.7-1.1-13.1c0-22.9-.7-52.8-14.9-74.8l-13.9-21.7 18.2-18.2 20-20 15.4-15.4 19.9 8.6c20.7 8.9 42.4 21.3 61.4 37.3C504.2 328.1 512 293 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM474.8 389s0 0 0 0c-15-13.8-33.2-25.2-51.4-33.8l-.9-.4c-2.2-1-4.4-2-6.5-2.9l-20 20s0 0 0 0s0 0 0 0c8.8 13.8 13.8 29.1 16.5 43.9s3.3 28.9 3.4 40.1c0 2.9 0 5.6 0 8.1c0 26.5 21.5 48 48 48s48-21.5 48-48c0-29.7-15.4-54.9-37.2-75zm-219.1 7c-33.9 0-65.2 8.5-90.6 23c4.1-39.8 43.1-71 90.6-71s86.5 31.2 90.6 71c-25.4-14.5-56.8-23-90.6-23zM395.2 242.4l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2z"]
};
const faHandHorns = {
  prefix: 'fass',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M32 0L96 0l0 240-64 0L32 0zM224 160l64 0 0 128-64 0 0-128zm-32-32l0 112-64 0 0-112 64 0zM320 64l64 0 0 128 0 128 0 32c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-91 184 0 8 0 0 48 0 32-96 0-16 0 0 32 16 0 112 0 16 0 0-16 0-48 96 0 0-128 0-128z"]
};
const faScrewdriverWrench = {
  prefix: 'fass',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M224 144C224 64.5 288.5 0 368 0c19 0 37.1 3.7 53.7 10.3L336 96l0 80 80 0 85.7-85.7C508.3 106.9 512 125 512 144c0 61.3-38.3 113.7-92.3 134.4l-45.1-45.1L352 210.7l-22.6 22.6-8.4 8.4-97-97 0-.8zM0 416L168.4 247.6 241.8 321l-8.4 8.4L210.7 352l22.6 22.6L96 512 0 416zm137.9-8L104 374.1 70.1 408 104 441.9 137.9 408zM287 321l-129-129L96 192 0 64 64 0 192 96l0 62.1L321 287l31-31L512 416l-96 96L256 352l31-31z"]
};
const faTools = faScrewdriverWrench;
const faArrowsToEye = {
  prefix: 'fass',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M40 112l38.1 0L0 33.9 33.9 0 112 78.1 112 40l0-24 48 0 0 24 0 96 0 24-24 0-96 0-24 0 0-48 24 0zm521.9 0l38.1 0 24 0 0 48-24 0-96 0-24 0 0-24 0-96 0-24 48 0 0 24 0 38.1L606.1 0 640 33.9 561.9 112zM128 256c20-48 86.4-144 192-144s172 96 192 144c-20 48-86.4 144-192 144s-172-96-192-144zm192 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM528 433.9l0 38.1 0 24-48 0 0-24 0-96 0-24 24 0 96 0 24 0 0 48-24 0-38.1 0L640 478.1 606.1 512 528 433.9zM112 472l0-38.1L33.9 512 0 478.1 78.1 400 40 400l-24 0 0-48 24 0 96 0 24 0 0 24 0 96 0 24-48 0 0-24z"]
};
const faCircleThreeQuarters = {
  prefix: 'fass',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H256V0z"]
};
const faTrophyStar = {
  prefix: 'fass',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M128 0c0 22.6 .6 43.9 1.6 64L24 64 0 64 0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c5.9 1.3 11.3 2.4 16.2 3.3c1.7 .9 3.4 1.8 5.1 2.6l0 73.1-72 0-24 0 0 24 0 16 0 24 24 0 208 0 24 0 0-24 0-16 0-24-24 0-72 0 0-73.1c1.7-.8 3.3-1.7 5.1-2.6c4.9-.9 10.3-1.9 16.2-3.3c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88l0-24-24 0L446.4 64c1-20.1 1.6-41.4 1.6-64L128 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-7.2-3.2-14.4-6.7-21.7-10.7C109.8 262.6 56.4 209.9 48.9 112zM412.5 291.9c-7.2 4-14.5 7.5-21.7 10.7c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-7.5 97.9-60.9 150.6-114.6 179.9zM316.2 129.2l63.1 9.2-45.7 44.5 10.8 62.8L288 216l-56.4 29.7 10.8-62.8-45.7-44.5 63.1-9.2L288 72l28.2 57.2z"]
};
const faTrophyAlt = faTrophyStar;
const faPlugCircleBolt = {
  prefix: 'fass',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24-224l-10.7 64 66.7 0L408 448l10.7-64L352 384l104-96z"]
};
const faFaceThermometer = {
  prefix: 'fass',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M543.4 273.6C534.4 406.8 423.5 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0C391.8 0 481.2 61.8 521.4 150.7l-6 5.8L338 328.5c-14.7-5.2-31.3-8.5-50-8.5c-71.6 0-113.7 47.7-126.3 72.8l28.6 14.3c8.7-17.5 41.3-55.2 97.7-55.2s88.9 37.7 97.7 55.2l28.6-14.3c-2-4-4.8-8.7-8.3-13.6l10.3-10-24.8-24.8L383 336l17-17 8.5 8.5 25.1 25.1 15.3-14.8-25.4-25.4L415 304l17-17 8.5 8.5 25.7 25.7 15.3-14.8-25.9-25.9L447 272l17-17 8.5 8.5 26.2 26.2L514 275l-26.5-26.5L479 240l17-17 8.5 8.5 26.8 26.8 12.6-12.1c.1 3.3 .2 6.6 .2 9.9c0 4.9-.1 9.8-.4 14.6L545 272l-1.6 1.6zM208.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faGridRound4 = {
  prefix: 'fass',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7A44.8 44.8 0 1 1 0 315.7a44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM209.1 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM328.5 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 315.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6z"]
};
const faSignPostsWrench = {
  prefix: 'fass',
  iconName: 'sign-posts-wrench',
  icon: [640, 512, [], "e626", "M64 0l0 32L0 32 0 416l384 0c-20.1-26.7-32-60-32-96c0-47.8 21-90.7 54.2-120l9.1-8 12.1 0 20.7 0 32 0 0 32 0 64 32 24 32-24 0-64 0-32 32 0s0 0 0 0l0-160-64 0 0-32L448 0l0 32L128 32l0-32L64 0zm0 448l0 64 64 0 0-64-64 0zM427.3 224c-26.6 23.5-43.3 57.8-43.3 96c0 40.4 18.7 76.5 48 99.9l0 92.1 160 0 0-92.1c29.3-23.5 48-59.5 48-99.9c0-38.2-16.8-72.5-43.3-96L576 224l0 80-64 48-64-48 0-80-20.7 0z"]
};
const faShirtRunning = {
  prefix: 'fass',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M112 0l0 32 0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48 0-32 64 0 0 32 0 32 0 16 0 48 7.6 20.4L0 393.8 0 256 48 128l0-48 0-16 0-32L48 0l64 0zM0 472.5L366.9 210.4 384 256l0 256L0 512l0-39.5z"]
};
const faBookCircleArrowUp = {
  prefix: 'fass',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 10.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l224.7 0c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4L448 0 416 0 384 0 96 0zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM417.4 360l11.3-11.3 56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6l0 89.4 0 16-32 0 0-16 0-89.4-28.7 28.7L440 382.6 417.4 360z"]
};
const faFaceNauseated = {
  prefix: 'fass',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L184 89.4 206.6 112l-11.3 11.3zM305.4 112L328 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L305.4 112zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3l99.2 0c4.6-22.8 18.9-42 38.4-53.3l13.8-8 16 27.7-13.8 8c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6l13.8 8-16 27.7-13.8-8c-19.5-11.3-33.8-30.5-38.4-53.3l-99.2 0c-4.6 22.8-18.9 42-38.4 53.3l-13.8 8-16-27.7 13.8-8c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6l-13.8-8 16-27.7 13.8 8z"]
};
const faHeart = {
  prefix: 'fass',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M39.8 263.8L64 288 256 480 448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96z"]
};
const faFileChartPie = {
  prefix: 'fass',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm56 320l-120 0 0-120c66.3 0 120 53.7 120 120zM160 210.4L160 352l141.6 0c-11.1 54.8-59.5 96-117.6 96c-66.3 0-120-53.7-120-120c0-58.1 41.2-106.5 96-117.6z"]
};
const faMarsAndVenus = {
  prefix: 'fass',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M368 0L496 0l0 128-32 32-47-47-25.6 25.6C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2l0 1.8 0 24 24 0 24 0 0 48-24 0-24 0 0 32 0 24-48 0 0-24 0-32-24 0-24 0 0-48 24 0 24 0 0-24 0-1.8C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L383 79 336 32 368 0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
const faHouseUser = {
  prefix: 'fass',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M576 287.6l-64.2 0 1 224.4L64.1 512l0-224.4L0 287.6 0 240 288.4 0 576 240l0 47.6zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm48 192l-32-96-160 0-32 96 224 0z"]
};
const faHomeUser = faHouseUser;
const faCircleArrowDownLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM168 368l152 0 24 0 0-48-24 0-94.1 0L361 185l17-17L344 134.1l-17 17-135 135L192 184l0-24-48 0 0 24 0 160 0 24 24 0z"]
};
const faDumpsterFire = {
  prefix: 'fass',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M32 32L0 160l114.9 0L140.5 32 32 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l56.5 0c19.7-21.2 40.4-38.5 57.8-50.8L402.9 32 304 32l0 128zm260.5-24.7c2.3 1.9 4.6 3.8 6.8 5.8L544 32 435.5 32l11.7 58.6 5.4-3.4L512 146.6l30-30 22.5 18.7zM288 319.8c0-49.2 20.9-93.1 46.1-127.8L32 192l4 32L0 224l0 64 44 0L64 448l0 32 64 0 0-32 209 0c-30.5-34-49-78.9-49-128.2zM448 128c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
const faHexagonMinus = {
  prefix: 'fass',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm184-24l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faMinusHexagon = faHexagonMinus;
const faLeftToLine = {
  prefix: 'fass',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M256 416L96 256 256 96l32 0 0 96 160 0 0 128-160 0 0 96-32 0zM64 96l0 320 0 32L0 448l0-32L0 96 0 64l64 0 0 32z"]
};
const faArrowAltToLeft = faLeftToLine;
const faHouseCrack = {
  prefix: 'fass',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 224.4 166.3 0L192 448l96-80L224 256 384 368l-96 80 38.4 64 186.4 0-1-224.4z"]
};
const faPawSimple = {
  prefix: 'fass',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zm-16 80L107.7 283C64.2 293.8 32 333.2 32 380c0 55.2 44.8 100 100 100c24.8 0 47.5-9 65-24l54 0c17.5 15 40.2 24 65 24c55.2 0 100-44.8 100-100c0-46.8-32.2-86.2-75.7-97L272 160l-96 0zm128-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faPawAlt = faPawSimple;
const faArrowLeftLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 96L0 64l64 0 0 32 0 320 0 32L0 448l0-32L0 96zM128 256l22.6-22.6 128-128 22.6-22.6L346.5 128l-22.6 22.6L250.5 224 608 224l32 0 0 64-32 0-357.5 0 73.4 73.4L346.5 384l-45.3 45.3-22.6-22.6-128-128L128 256z"]
};
const faBracketsRound = {
  prefix: 'fass',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M110.2 37.4l35.5 53.3C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4l-35.5 53.3C71.9 449 0 371.8 0 256S71.9 62.9 110.2 37.4zm291.5 0C440.1 62.9 512 140.2 512 256s-71.9 193.1-110.2 218.6l-35.5-53.3C391.9 404.3 448 345 448 256s-56.1-148.3-81.8-165.4l35.5-53.3z"]
};
const faParentheses = faBracketsRound;
const faMartiniGlassCitrus = {
  prefix: 'fass',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48l-52.6 0C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-28.2 0-54.5-8.1-76.7-22.1l35.3-35.3c12.5 6 26.6 9.4 41.4 9.4zM0 160l0-32 416 0 0 32L232 344l0 120 88 0 0 48-88 0-24 0L96 512l0-48 88 0 0-120L0 160z"]
};
const faCocktail = faMartiniGlassCitrus;
const faUserShakespeare = {
  prefix: 'fass',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M224 48c44.2 0 80 35.8 80 80l0 32c0 40.1-29.5 73.3-68 79.1l0-15.1 0-12-24 0 0 12 0 15.1c-38.5-5.8-68-39-68-79.1l0-32c0-44.2 35.8-80 80-80zM96 128l0 32 0 8L64 208l0 64 98 0c18.4 10.2 39.5 16 62 16s43.6-5.8 62-16l98 0 0-64-32-40 0-8 0-32C352 57.3 294.7 0 224 0S96 57.3 96 128zm96 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 31l-8.5 8.5C204.9 178.1 194.1 180 192 180l-12 0 0 24 12 0c7 0 19.6-3 32.1-12.3c2.2 1.6 4.5 3.2 7.1 4.6c6.5 3.8 15.4 7.6 24.8 7.6l12 0 0-24-12 0c-3.3 0-7.8-1.5-12.8-4.4c-4.8-2.8-8.8-6.1-10.7-8.1L224 159zM448 512L384 320l-40.1 0-5.3-16L304 304l-160 0-34.6 0-5.3 16L64 320 0 512l208 0c0-8.8 7.2-16 16-16s16 7.2 16 16l208 0zM224 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-96-32l0-48 192 0 0 48-40-16-112 0-40 16z"]
};
const faArrowRightToArc = {
  prefix: 'fass',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M448 256c0-106-86-192-192-192l0-64C397.4 0 512 114.6 512 256s-114.6 256-256 256l0-64c106 0 192-86 192-192zM230.6 121.4l112 112L365.3 256l-22.6 22.6-112 112L208 413.3 162.7 368l22.6-22.6L242.7 288 32 288 0 288l0-64 32 0 210.7 0-57.4-57.4L162.7 144 208 98.7l22.6 22.6z"]
};
const faFaceSurprise = {
  prefix: 'fass',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faSurprise = faFaceSurprise;
const faBottleWater = {
  prefix: 'fass',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M96 0l0 64 128 0 0-64L96 0zM58.6 119.6C42 129.9 32 148 32 167.5c0 17 7.5 32.3 19.4 42.6C39.4 221.7 32 238 32 256c0 19.1 8.4 36.3 21.7 48C40.4 315.7 32 332.9 32 352s8.4 36.3 21.7 48C40.4 411.7 32 428.9 32 448l0 64 64 0 128 0 64 0 0-64c0-19.1-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48c0-18-7.4-34.3-19.4-45.9c11.9-10.4 19.4-25.6 19.4-42.6c0-19.5-10-37.6-26.6-47.9L223.7 96 96.3 96 58.6 119.6zM96 224l128 0 0 32L96 256l0-32zM224 352l0 32L96 384l0-32 128 0z"]
};
const faCirclePause = {
  prefix: 'fass',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192l0 128 0 32-64 0 0-32 0-128 0-32 64 0 0 32zm128 0l0 128 0 32-64 0 0-32 0-128 0-32 64 0 0 32z"]
};
const faPauseCircle = faCirclePause;
const faGaugeCirclePlus = {
  prefix: 'fass',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16z"]
};
const faFolders = {
  prefix: 'fass',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M576 384l0-288L368 96 304 32 96 32l0 352 480 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faAngel = {
  prefix: 'fass',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64.2c0 .1-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2s0 .1 0 .2zM368 144a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM209.4 285.3L120 464l-70.8 0 42.4-91.9 11.3-24.4L87.9 325.4 48 265.5 48 208l84.1 0 77.3 77.3zM248 256l-96-96L48 160 0 160l0 48 0 72 48 72L0 456l0 8 0 48 48 0 48 0 96 0 192 0 96 0 48 0 48 0 0-48 0-8L528 352l48-72 0-72 0-48-48 0-104 0-96 96-80 0zM526.8 464L456 464 366.6 285.3 443.9 208l84.1 0 0 57.5-39.9 59.9-14.9 22.4 11.3 24.4L526.8 464z"]
};
const faValueAbsolute = {
  prefix: 'fass',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M64 32L0 32 0 64 0 448l0 32 64 0 0-32L64 64l0-32zM182.6 137.4L160 114.7 114.7 160l22.6 22.6L210.7 256l-73.4 73.4L114.7 352 160 397.3l22.6-22.6L256 301.3l73.4 73.4L352 397.3 397.3 352l-22.6-22.6L301.3 256l73.4-73.4L397.3 160 352 114.7l-22.6 22.6L256 210.7l-73.4-73.4zM512 64l0-32-64 0 0 32 0 384 0 32 64 0 0-32 0-384z"]
};
const faRabbit = {
  prefix: 'fass',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M311.9 128l24 0c1-23.7-2.8-47.2-11-69.2c7.6-17.8 18.6-34.2 32.7-48.3L368 0l24 8 3 11.9c10.4 41.6 3.3 85.1-18.6 120.8L448 199.1l0 88.9-96 0 0 10.3 78 210.6 1.2 3.1-68.2 0L317.7 390.1 265.6 448l22.4 0 32 0 0 64-32 0-80 0-48 0-32 0-32 0 0-40.8C85.8 481.6 71.7 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7l0-88.8c-29.7-37.6-42.4-86.4-34-134.4L224 8l32-8 10.4 10.3C298 41.7 314.1 84.6 311.9 128zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faToiletPaperSlash = {
  prefix: 'fass',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M94.9 50.9L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-98.4-76.4C570.6 372.4 608 291 608 192C608 86 565 0 512 0s-96 86-96 192c0 48.6 9 92.9 23.9 126.7l-57.8-44.9c1.4-27.1 1.9-54.4 1.9-81.9c0-65.5 13.2-142.4 60.2-192L160 0c-25.1 0-48 19.3-65.1 50.9zM369.5 387.1L66.5 148.4C64.9 162.4 64 177 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512l325.3 0c17-40.8 28.5-82.5 36.2-124.9zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"]
};
const faCircleEuro = {
  prefix: 'fass',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 272c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L112 240l0-32 40.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0 24 0 0 48-24 0-41.1 0c-26.3 0-49.6 12.6-64.4 32l96.5 0 0 32-111.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2L304 272l0 32-97.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0 24 0 0 48-24 0-41.1 0c-54.4 0-101-33.8-119.8-81.5L112 304l0-32 32 0z"]
};
const faAppleWhole = {
  prefix: 'fass',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M208 96l0-16c0-44.2 35.8-80 80-80l16 0 16 0 0 16 0 16c0 44.2-35.8 80-80 80l-16 0-16 0 0-16zM0 288c0-76.3 35.7-160 112-160l112 32 112-32c76.3 0 112 83.7 112 160c0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288z"]
};
const faAppleAlt = faAppleWhole;
const faKitchenSet = {
  prefix: 'fass',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l59.6 0 0-16 48 0 104 0 48 0 0 48 0 48-48 0-104 0-48 0 0-16-59.6 0zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM424 240l0 32 120 0 0 48-288 0 0-48 120 0 0-32 48 0zM288 352l224 0 0 160-224 0 0-160zM176 320c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0 32L32 448l0-128 96 0 32 0 16 0zm0 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zm48 80l0 48L0 512l0-48 224 0z"]
};
const faDiamondHalf = {
  prefix: 'fass',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M256 0L0 256 256 512 256 0z"]
};
const faLockKeyhole = {
  prefix: 'fass',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80l0 48-160 0 0-48c0-44.2 35.8-80 80-80zM80 144l0 48L0 192 0 512l448 0 0-320-80 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z"]
};
const faLockAlt = faLockKeyhole;
const faR = {
  prefix: 'fass',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M32 32L0 32 0 64 0 288 0 448l0 32 64 0 0-32 0-128 93.2 0L246 480l73.2 0-4.2-7.5L225.5 311.3C280.7 291.1 320 238.1 320 176c0-79.5-64.5-144-144-144L32 32zM176 256L64 256 64 96l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
const faTemperatureQuarter = {
  prefix: 'fass',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M112 300.2L97.8 317.8C86.6 331.5 80 348.9 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-19.1-6.6-36.5-17.8-50.3L208 300.2l0-22.7L208 64l-96 0 0 213.5 0 22.7zM208 0l64 0 0 64 0 213.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5L48 64 48 0l64 0 96 0zm0 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.8 0-16 32 0 0 16 0 50.8c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature1 = faTemperatureQuarter;
const faThermometer1 = faTemperatureQuarter;
const faThermometerQuarter = faTemperatureQuarter;
const faSquareInfo = {
  prefix: 'fass',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M448 32L0 32 0 480l448 0 0-448zM184 336l24 0 0-64-24 0-24 0 0-48 24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm72-208l0 64-64 0 0-64 64 0z"]
};
const faInfoSquare = faSquareInfo;
const faWifiSlash = {
  prefix: 'fass',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L364.9 260.5c39.1 7.9 74.5 26.1 103.3 51.5l42.3-48C459.8 219.2 393 192 320 192c-13.5 0-26.8 .9-39.8 2.7l-95.6-74.2C226.7 104.7 272.3 96 320 96c103.2 0 196.8 40.7 265.8 106.9l44.3-46.2C549.7 79.5 440.4 32 320 32c-69.2 0-134.7 15.7-193.2 43.7L48.4 14.8zM380.8 396l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7l42.4 48c16.7-14.8 35.6-27 56.2-36.3zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7l44.3 46.2c12.4-11.9 25.6-23 39.5-33.1z"]
};
const faToiletPaperXmark = {
  prefix: 'fass',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M96 0L348.2 0C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9L96 384C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416l256 0c44.8 0 76.9-35.2 96-72.9L512 512l-352 0 0-96zm40-153.4L222.6 240l-11.3-11.3L174.6 192l36.7-36.7L222.6 144 200 121.4l-11.3 11.3L152 169.4l-36.7-36.7L104 121.4 81.4 144l11.3 11.3L129.4 192 92.7 228.7 81.4 240 104 262.6l11.3-11.3L152 214.6l36.7 36.7L200 262.6z"]
};
const faHandsHoldingDollar = {
  prefix: 'fass',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344 34.9L344 8 296 8l0 26.8c-4.7 1.2-9.3 2.7-13.6 4.7c-15.8 7.2-30 20.7-33.4 40.7c-1.9 10.9-.9 21.6 3.7 31.4c4.5 9.6 11.6 16.3 18.7 21.1c12.1 8.2 28 13 39.6 16.5l2.3 .7c14.1 4.3 22.8 7.3 28.1 11.1s2.2 10.3-3.2 12.6c-5.2 2.2-14.3 3.5-26.6 1.6c-5.7-.9-15.9-4.4-25.4-7.6c-2.3-.8-4.5-1.5-6.6-2.2l-22.8-7.6-15.2 45.5 22.8 7.6c1.1 .4 2.6 .9 4.2 1.4c7 2.4 18 6.2 27.3 8.5l0 27.2 48 0 0-26.2c4.5-1 8.9-2.4 13-4.2c16.7-7.2 30.5-21.1 34-41.7c1.9-11 1.1-21.8-3.2-31.7c-4.3-9.8-11.1-16.9-18.2-22.1c-12.7-9.2-29.4-14.3-41.4-17.9l-1-.3c-14.4-4.3-23.3-7.2-28.8-10.9c-5-3.4-.4-7.8 3.8-9.7c5.6-2.5 14.7-4.1 26.4-2.3c4.3 .7 17.6 3.3 21.3 4.3L373 91.4 385.4 45l-23.2-6.2c-3.9-1-11.8-2.6-18.2-3.9zM80 64L0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40zm480 0l0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4 0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0z"]
};
const faHandsUsd = faHandsHoldingDollar;
const faCube = {
  prefix: 'fass',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M256 6l10.8 3.8 224 80L512 97.4l0 22.6 0 272 0 22.6-21.2 7.6-224 80L256 506l-10.8-3.8-224-80L0 414.6 0 392 0 120 0 97.4l21.2-7.6 224-80L256 6zm32 420.6l160-57.1 0-180L288 246.6l0 180zM256 74L93.5 132 256 190l162.5-58L256 74z"]
};
const faArrowDownTriangleSquare = {
  prefix: 'fass',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M160 479.6l23.7-26 80-88 21.5-23.7-47.4-43-21.5 23.7L192 349.2 192 64l0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 298.8l-47.4 43 21.5 23.7 80 88 23.7 26zM416 32L304 224l224 0L416 32zm96 448l0-192-192 0 0 192 192 0z"]
};
const faSortShapesDown = faArrowDownTriangleSquare;
const faBitcoinSign = {
  prefix: 'fass',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M112 0L48 0l0 64L0 64l0 64 0 96 0 64 0 96 0 64 48 0 0 64 64 0 0-64 32 0 0 64 64 0 0-64c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-50.7-33.7-93.6-80-107.4L208 0 144 0l0 64-32 0 0-64zM64 128l112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L64 224l0-96zM176 288l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L64 384l0-96 112 0z"]
};
const faShutters = {
  prefix: 'fass',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M32 32L0 32 0 96l32 0 448 0 32 0 0-64-32 0L32 32zM0 224l512 0-24-96L24 128 0 224zM512 352l-24-96L24 256 0 352l512 0zM0 480l512 0-24-96L24 384 0 480z"]
};
const faShieldDog = {
  prefix: 'fass',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM160.9 286.2L144 320l128 64 0-64 48 0c44.2 0 80-35.8 80-80l0-48-80 0-16-32-64 0 0 64c0 35.3-28.7 64-64 64c-5.2 0-10.3-.6-15.1-1.8zM144 160l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-32-8 0-56 0zm112 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faSolarPanel = {
  prefix: 'fass',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M96 0L70.2 0 64.7 25.2l-64 296L0 324.6 0 328l0 24 0 32 32 0 256 0 0 64-64 0-32 0 0 64 32 0 192 0 32 0 0-64-32 0-64 0 0-64 256 0 32 0 0-32 0-24 0-3.4-.7-3.3-64-296L569.8 0 544 0 96 0zm3.3 168L121.8 64l90.9 0L202.3 168 99.3 168zM89 216l108.5 0L187.1 320 66.5 320 89 216zm156.8 0l148.6 0 10.4 104-169.4 0 10.4-104zm196.8 0L551 216l22.5 104-120.6 0L442.5 216zm98.1-48l-102.9 0L427.3 64l90.9 0 22.5 104zm-151.2 0l-139 0L260.9 64l118.2 0 10.4 104z"]
};
const faLockOpen = {
  prefix: 'fass',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 0 32 64 0 0-32 0-48C576 64.5 511.5 0 432 0S288 64.5 288 144l0 48L0 192 0 512l448 0 0-320-96 0 0-48z"]
};
const faTableTree = {
  prefix: 'fass',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M512 32L0 32 0 480l512 0 0-448zM448 160l0 256L64 416l0-256 32 0 0 96 0 16 0 80 0 16 16 0 128 0 16 0 0-32-16 0-112 0 0-64 48 0 16 0 0-32-16 0-48 0 0-80 320 0zM224 224l0 64 192 0 0-64-192 0zm192 96l-128 0 0 64 128 0 0-64z"]
};
const faHouseChimneyHeart = {
  prefix: 'fass',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M576 287.6l-64.2 0 1 224.4L64.1 512l0-224.4L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6zM235.2 208c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L288 400.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z"]
};
const faTally3 = {
  prefix: 'fass',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M160 32l0 32 0 384 0 32-64 0 0-32L96 64l0-32 64 0zm128 0l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0zM416 64l0 384 0 32-64 0 0-32 0-384 0-32 64 0 0 32z"]
};
const faElevator = {
  prefix: 'fass',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M64 80l0 16 160 0 0-16L144 0 64 80zm448 48L0 128 0 512l512 0 0-384zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 448l24-96 112 0 24 96L80 448zm328-96l24 96-160 0 24-96 112 0zM304 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM368 96l80-80 0-16L288 0l0 16 80 80z"]
};
const faMoneyBillTransfer = {
  prefix: 'fass',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M512 112l0 64 24 0L640 88 536 0 512 0l0 64L384 64l-24 0 0 48 24 0 128 0zM256 400l-128 0 0-64-24 0L0 424l104 88 24 0 0-64 128 0 24 0 0-48-24 0zm64-248l0-88L32 64l0 291 51.3-43.4 8.9-7.6 11.7 0 24 0 32 0 0 32 0 24 96 0 64 0 0 88 288 0 0-291-51.3 43.4-8.9 7.6L536 208l-24 0-32 0 0-32 0-24-96 0-64 0zM96 192l0-64 64 0c0 35.3-28.7 64-64 64zM480 384c0-35.3 28.7-64 64-64l0 64-64 0zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faMoneyBillTrendUp = {
  prefix: 'fass',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M304 0l32 0L448 0l32 0 0 32 0 112 0 32-64 0 0-32 0-34.7L310.6 214.6l-21 21-22.5-19.3L176 138.1 84.8 216.3 43.2 167.7l112-96L176 53.9l20.8 17.9 89.5 76.7L370.7 64 336 64l-32 0 0-64zM0 256l512 0 0 256L0 512 0 256zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faHouseFloodWaterCircleArrowRight = {
  prefix: 'fass',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM152 65.4l11.3 11.3 56 56L230.6 144l-11.3 11.3-56 56L152 222.6 129.4 200l11.3-11.3L169.4 160 80 160l-16 0 0-32 16 0 89.4 0L140.7 99.3 129.4 88 152 65.4zM320 144c0 55.2-25.4 104.5-65.2 136.8c3.4-1.2 6.7-2.6 9.9-4.1c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0l1.1-.8L320 240l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L512 240l19.7 14.2c10.8 7.8 19.1 13.8 28 18.6l-.3-80.8 48.6 0 0-48L400 0 302.5 67.5C313.7 90.6 320 116.6 320 144zM86 322.9c-15.4 7-34.7 13.1-54 13.1l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5s0 0 0 0c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5s0 0 0 0c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-2.7-1.2-5.2-2.5-7.7-3.8c-6 .6-12.1 .9-18.3 .9c-14.7 0-29-1.8-42.7-5.2c-4.9 2.9-9.9 5.6-15.3 8.1zM320 485.4c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7z"]
};
const faSquarePollHorizontal = {
  prefix: 'fass',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M448 32L0 32 0 480l448 0 0-448zM256 192L96 192l0-64 160 0 0 64zm96 32l0 64L96 288l0-64 256 0zM192 384l-96 0 0-64 96 0 0 64z"]
};
const faPollH = faSquarePollHorizontal;
const faCircle = {
  prefix: 'fass',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faLeftToBracket = {
  prefix: 'fass',
  iconName: 'left-to-bracket',
  icon: [512, 512, [], "e66d", "M320 96L160 256 320 416l32 0 0-96 160 0 0-128-160 0 0-96-32 0zM160 416l-96 0L64 96l96 0 32 0 0-64-32 0L32 32 0 32 0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0z"]
};
const faCartCircleExclamation = {
  prefix: 'fass',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faSword = {
  prefix: 'fass',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M400 16L166.6 249.4l96 96L496 112 512 0 400 16zM0 416l96 96 32-32-16-32 56-56 88 56 32-32L96 224 64 256l56 88L64 400 32 384 0 416z"]
};
const faBackwardFast = {
  prefix: 'fass',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M64 96l0-32L0 64 0 96 0 416l0 32 64 0 0-32 0-136L288 448l0-168L512 448l0-384L288 232l0-168L64 232 64 96z"]
};
const faFastBackward = faBackwardFast;
const faRecycle = {
  prefix: 'fass',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M309.1 0l9.4 15 63.8 102.1L432.8 88l12 20.8L412.6 229 292.4 196.8l-12-20.8 46.5-26.8L273.7 64l-35.4 0-33.5 53.6-55.5-32L193.4 15l9.4-15 17.7 0 70.8 0 17.7 0zm99.2 279.5l55.5-32 43.3 69.3 10.2 16.3-9.6 16.7-32 55.4L460.2 432 451 448l-18.5 0L320 448l0 56-24 0-88-88 88-88 24 0 0 56 94 0 6.3-10.9 22.4-38.8-34.3-54.8zM64.7 221.1L16 193l12-20.8L148.2 140l32.2 120.2-12 20.8-48.3-27.9L69.3 334.4 98 384l62 0 0 64-80.5 0L61 448l-9.2-16L4.3 349.7l-9.6-16.7L4.9 316.8l59.8-95.7z"]
};
const faUserAstronaut = {
  prefix: 'fass',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M370.7 96C346 39.5 289.6 0 224 0S102 39.5 77.3 96L48 96l0 128 29.3 0c24.7 56.5 81.1 96 146.7 96s122-39.5 146.7-96l29.3 0 0-128-29.3 0zM336 128l0 32c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-32 32-32 160 0 32 32zM192 160l-16-32-16 32-32 16 32 16 16 32 16-32 32-16-32-16zM97 304l-49 0L0 512l128 0 0-96 192 0 0 96 128 0L400 304l-49 0c-33.8 29.9-78.3 48-127 48s-93.2-18.1-127-48zm95 144l-32 0 0 16 0 48 32 0 0-48 0-16zm80 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faInterrobang = {
  prefix: 'fass',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M144 96c-35.3 0-64 28.7-64 64l0 16-64 0 0-16C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 9.3c0 39.3-18 76.4-48.9 100.6L192 319.6l0 .4 0 32-64 0 0-32 0-16 0-15.6L128 176l0-32 64 0 0 32 0 62.2 23.5-18.5C231 207.5 240 189 240 169.3l0-9.3c0-35.3-28.7-64-64-64l-32 0zM120 400l80 0 0 80-80 0 0-80z"]
};
const faPlaneSlash = {
  prefix: 'fass',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-72.8 0L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 190 147.5L192 0l96 0L397.7 192l116.6 0zM40.6 128L362.5 381.6 288 512l-96 0 54.9-192L144 320 96 384l-64 0L64 256 32 128l8.6 0z"]
};
const faCircleDashed = {
  prefix: 'fass',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M.5 240l64.2 0c3.4-41 19.6-78.3 44.7-108L64 86.6C27.5 128 4.1 181.3 .5 240zM132 109.4C161.7 84.3 199 68 240 64.7L240 .5C181.3 4.1 128 27.5 86.6 64L132 109.4zm140 338l0 64.2c58.6-3.6 112-27 153.4-63.5L380 402.6c-29.6 25.1-67 41.4-108 44.7zM402.6 380L448 425.4c36.5-41.4 59.9-94.7 63.5-153.4l-64.2 0c-3.4 41-19.6 78.3-44.7 108zm-316 68c41.4 36.5 94.7 59.9 153.4 63.5l0-64.2c-41-3.4-78.3-19.6-108-44.7L86.6 448zM64 425.4L109.4 380C84.3 350.3 68 313 64.7 272L.5 272c3.6 58.6 27 112 63.5 153.4zM425.4 64C384 27.5 330.6 4.1 272 .5l0 64.2c41 3.4 78.3 19.6 108 44.7L425.4 64zM448 86.6L402.6 132c25.1 29.6 41.4 67 44.7 108l64.2 0c-3.6-58.7-27-112-63.5-153.4z"]
};
const faTrademark = {
  prefix: 'fass',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M0 96l32 0 64 0 64 0 64 0 32 0 0 64-32 0-64 0 0 224 0 32-64 0 0-32 0-224-64 0L0 160 0 96zm288 32l0-32 48 0 9.6 12.8L464 266.7 582.4 108.8 592 96l48 0 0 32 0 256 0 32-64 0 0-32 0-160L489.6 339.2 464 373.3l-25.6-34.1L352 224l0 160 0 32-64 0 0-32 0-256z"]
};
const faBasketball = {
  prefix: 'fass',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"]
};
const faBasketballBall = faBasketball;
const faForkKnife = {
  prefix: 'fass',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M214.6 169.4L192 146.7s0 0 0 0L45.3 0S0 40 0 104c0 70.7 63.5 136.2 154.7 226.8L265.4 220.1l-50.7-50.7zM441.4 486.6L464 509.3 509.3 464l-22.6-22.6L355.9 310.6l-45.3 45.3L441.4 486.6zM488 24L472 8 348.6 78.5C321 94.3 304 123.6 304 155.3c0 19.4 6.4 38.1 18 53.4L89.4 441.4 66.7 464 112 509.3l22.6-22.6L367.2 254c15.3 11.6 34 18 53.4 18c31.8 0 61.1-17 76.8-44.6L568 104 552 88 448 192l-16-16L528 64 512 48 400 144l-16-16L488 24z"]
};
const faUtensilsAlt = faForkKnife;
const faSatelliteDish = {
  prefix: 'fass',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M192 0C368.7 0 512 143.3 512 320l-64 0C448 178.6 333.4 64 192 64l0-64zM164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L319.6 479.6C287.3 500.1 249.1 512 208 512C93.1 512 0 418.9 0 304c0-41.1 11.9-79.3 32.4-111.6L164.7 324.7zM416 320l-64 0c0-88.4-71.6-160-160-160l0-64c123.7 0 224 100.3 224 224z"]
};
const faBadgeCheck = {
  prefix: 'fass',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z"]
};
const faCircleUp = {
  prefix: 'fass',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256l-80 0 0 128-96 0 0-128-80 0 0-16L256 112 384 240l0 16z"]
};
const faArrowAltCircleUp = faCircleUp;
const faSlider = {
  prefix: 'fass',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 160l0 192-32 0 0-192 32 0zM320 96l-64 0 0 64 0 192 0 64 64 0 32 0 64 0 0-64 0-64 64 0 32 0 0-64-32 0-64 0 0-64 0-64-64 0-32 0zM0 288l32 0 192 0 0-64L32 224 0 224l0 64z"]
};
const faMobileScreenButton = {
  prefix: 'fass',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M16 0L368 0l0 512L16 512 16 0zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z"]
};
const faMobileAlt = faMobileScreenButton;
const faClockOneThirty = {
  prefix: 'fass',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-128.7 60-90 13.3-20-39.9-26.6-13.3 20-64 96-4 6 0 7.3 0 136 0 24 48 0 0-24z"]
};
const faInboxOut = {
  prefix: 'fass',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M288 288l0 32-64 0 0-32 0-162.7-41.4 41.4L160 189.3 114.7 144l22.6-22.6 96-96L256 2.7l22.6 22.6 96 96L397.3 144 352 189.3l-22.6-22.6L288 125.3 288 288zM0 320l144 0 32 64 160 0 32-64 144 0 0 192L0 512 0 320z"]
};
const faInboxArrowUp = faInboxOut;
const faCloudSlash = {
  prefix: 'fass',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L635.2 480l4.8 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.8 0-89 20.1-118.2 52.2L48.4 14.8zM96 192l0 8.2C40.1 220 0 273.3 0 336L0 480l144 0 343.4 0L97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4z"]
};
const faVolumeHigh = {
  prefix: 'fass',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M592 256c0 78.5-37.7 148.2-96 192l28.8 38.4C594.7 433.9 640 350.3 640 256.1l0-.1 0-.1c0-94.2-45.3-177.8-115.2-230.3L496 64c58.3 43.8 96 113.5 96 192zM438.4 371.2l28.8 38.4c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2zM400 256c0 15.7-7.5 29.6-19.2 38.4l28.8 38.4C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4zM0 160L0 352l128 0L272 480l48 0 0-448-48 0L128 160 0 160z"]
};
const faVolumeUp = faVolumeHigh;
const faUsersRays = {
  prefix: 'fass',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M40 6.1L6.1 40 23 57l56 56 17 17L129.9 96 113 79 57 23 40 6.1zm560 0L583 23 527 79l-17 17L544 129.9l17-17 56-56 17-17L600 6.1zM57 489l56-56 17-17L96 382.1 79 399 23 455l-17 17L40 505.9l17-17zm543 17L633.9 472l-17-17-56-56-17-17L510.1 416l17 17 56 56 17 17zM223.8 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM120 256L96 336l94.3 0 19.4-58.1 7.3-21.9L120 256zm329.7 80l94.3 0-24-80-96.9 0 7.3 21.9L449.7 336zM432 384l-16-48-16-48-17.6 0-124.8 0L240 288l-16 48-16 48 224 0zm80-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faWallet = {
  prefix: 'fass',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M480 32L0 32 0 480l512 0 0-352L64 128l0-32 416 0 0-64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faOctagonCheck = {
  prefix: 'fass',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zm369 49L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"]
};
const faFlatbreadStuffed = {
  prefix: 'fass',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M346.6 53.2L255.9 3.4 185.1 78.8 83.6 98.9 77.8 202.2 13 282.9 75 365.7l.5 25.5L133.8 333c-13.7-19.5-21.8-43.3-21.8-69c0-66.3 53.7-120 120-120c25.7 0 49.5 8.1 69 21.8L422.5 44.2l-75.9 9zM232 176c-48.6 0-88 39.4-88 88c0 16.8 4.7 32.5 12.9 45.9l121-121C264.5 180.7 248.8 176 232 176zM464.3 432.3c106.2-106.2 106.2-278.4 0-384.7L79.7 432.3c106.2 106.2 278.4 106.2 384.7 0zM256 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faClipboardCheck = {
  prefix: 'fass',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM297 273L185 385l-17 17-17-17L87 321l-17-17L104 270.1l17 17 47 47 95-95 17-17L313.9 256l-17 17z"]
};
const faCartCirclePlus = {
  prefix: 'fass',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16l-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16 0 48 48 0 16 0 0 32-16 0z"]
};
const faTruckClock = {
  prefix: 'fass',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M416 0L0 0 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 240l0 16-128 0 0-96 48 0 2.7 0L544 237.3l0 2.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 176a112 112 0 1 1 224 0A112 112 0 1 1 96 176zM224 96l-32 0 0 16 0 64 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-48 0-16z"]
};
const faShippingTimed = faTruckClock;
const faPool8Ball = {
  prefix: 'fass',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-80-48c0 11.5-4 22-10.7 30.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faFileAudio = {
  prefix: 'fass',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm-1.8 447.9l-15.5-28C268.1 403.5 288 372.1 288 336s-19.9-67.5-49.4-83.9l15.5-28C293.4 245.9 320 287.9 320 336s-26.6 90.1-65.8 111.9zm-31.1-56l-15.5-28c9.8-5.5 16.5-15.9 16.5-28s-6.6-22.5-16.5-28l15.5-28C242.7 291 256 311.9 256 336s-13.3 45-32.9 56zM64 376l0-80 56 0 40-40 16 0 0 160-16 0-40-40-56 0z"]
};
const faTurnDownLeft = {
  prefix: 'fass',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M0 288L160 448l32 0 0-112 320 0 0-304-96 0 0 208-224 0 0-112-32 0L0 288z"]
};
const faLockHashtag = {
  prefix: 'fass',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 80 0 0 320L0 512 0 192l80 0zm112 48l-32 0 0 16 0 32-32 0-16 0 0 32 16 0 32 0 0 64-32 0-16 0 0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 64 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-64 32 0 16 0 0-32-16 0-32 0 0-32 0-16-32 0 0 16 0 32-64 0 0-32 0-16zm0 144l0-64 64 0 0 64-64 0z"]
};
const faChartRadar = {
  prefix: 'fass',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M73.7 256L165.1 96l181.7 0 91.4 160L346.9 416l-181.7 0L73.7 256zM128 32L0 256 128 480l256 0L512 256 384 32 128 32zM290.2 180.8c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zM202 271.9l47.5-63.4 31.7 79.2L202 271.9z"]
};
const faStaff = {
  prefix: 'fass',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M306.3 0L336 0 464 0l48 0 0 48 0 160 0 36.2-34.8 9.9-33.4 9.6L413.7 317l-52.6-29.7-96 27.4L105.9 473.9 72 507.9 4.1 440l33.9-33.9L96 348.1 96 288l60.1 0 49.9-49.9 8.8-8.8 12-3.4L416 171.8 416 96l-50.3 0-2.7 5.5-21.5 42.9-85.9-42.9 21.5-42.9 16-32L306.3 0z"]
};
const faBurger = {
  prefix: 'fass',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M32 224l0-32s0-160 224-160s224 160 224 160l0 32L32 224zm112-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 352l0-96 480 0 0 96L16 352zM32 480l0-96 448 0 0 96L32 480z"]
};
const faHamburger = faBurger;
const faUtilityPole = {
  prefix: 'fass',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M288 0l0 32 0 32 96 0 0-8 0-24 48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 0 32 0 24 0 8-32 0-51.2 0L288 221.9l0 66.1 0 192 0 32-64 0 0-32 0-192 0-66.1L83.2 128 32 128 0 128l0-8L0 96 0 64l0-8L0 32l48 0 0 24 0 8 32 0 0-8 0-24 48 0 0 24 0 8 96 0 0-32 0-32 64 0zM140.8 128L224 183.4l0-55.4-83.2 0zM288 183.4L371.2 128 288 128l0 55.4z"]
};
const faTransporter6 = {
  prefix: 'fass',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M64 32L96 48 64 64 48 96 32 64 0 48 32 32 48 0 64 32zM224 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zM112 256l288 0 16 0 0 32-16 0-288 0-16 0 0-32 16 0zM416 512l-120 0-80 0L96 512l0-64 320 0 0 64zm48-160l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32z"]
};
const faArrowTurnLeft = {
  prefix: 'fass',
  iconName: 'arrow-turn-left',
  icon: [512, 512, [], "e632", "M150.6 374.6l22.6 22.6L218.5 352l-22.6-22.6L122.5 256l322.7 0 0 192 0 32 64 0 0-32 0-224 0-32-32 0-354.7 0 73.4-73.4L218.5 96 173.2 50.7 150.6 73.4l-128 128L0 224l22.6 22.6 128 128z"]
};
const faWrench = {
  prefix: 'fass',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M352 320c88.4 0 160-71.6 160-160c0-23.5-5.1-45.8-14.1-65.9L400 192l-80 0 0-80 97.9-97.9C397.8 5.1 375.5 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L0 416l96 96L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM137.9 408L104 441.9 70.1 408 104 374.1 137.9 408z"]
};
const faBugs = {
  prefix: 'fass',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M164.5 107.4l29.7-65.5 9.9-21.9L160.4 .2l-9.9 21.9L128 71.7 105.5 22.1 95.6 .2 51.9 20.1l9.9 21.9 29.7 65.5c-10.2 7.1-18.2 17-22.9 28.6l-15.2 0-2.1-18.7L48.7 93.5 1 98.8l2.7 23.9 4.5 40L10.5 184 32 184l32 0 0 23.3-37.8 9.5-16.1 4L8.2 237.3l-6.4 56L-1 317.1l47.7 5.5 2.7-23.8L54 259.2l17.9-4.5C82.8 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l17.9 4.5 4.5 39.5 2.7 23.8 47.7-5.5-2.7-23.8-6.4-56L246 220.7l-16.1-4L192 207.3l0-23.3 32 0 21.3 0 2.5-21.1 4.8-40L255.5 99l-47.7-5.7L205 117.1 202.7 136l-15.4 0c-4.7-11.6-12.7-21.5-22.9-28.6zM488 286.5l65.6-47 19.5-14-27.9-39-19.5 14-51.4 36.8 6.1-62.9 2.3-23.9-47.8-4.7-2.3 23.9L424.8 250c-12.3 1-24.2 5.6-34.1 13.3L376 254.8l6.8-20 7.7-22.7L345 196.7l-7.7 22.7-13.1 38.6-6.3 18.6 17 9.8 27.7 16L351 322.7 313.5 312 298 307.5l-10 12.7-34.9 44.5-14.8 18.9 37.8 29.6 14.8-18.9 25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l14.2 13.7L433.4 472l-8 22.6 45.3 15.9 8-22.6L495.8 439l5.1-14.5-11.1-10.7-28-27.1 11.6-20.1 27.7 16 17 9.8 13-14.8L558.2 347 574 329 538 297.3l-15.8 18-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"]
};
const faVectorPolygon = {
  prefix: 'fass',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M0 32l128 0 0 32 192 0 0-32 128 0 0 128-63.7 0-4.5 7.9L352 216.5l0 79 27.8 48.6 4.5 7.9 63.7 0 0 128-128 0 0-32-192 0 0 32L0 480 0 352l32 0 0-192L0 160 0 32zM320 368.5L292.3 320 224 320l0-128 68.3 0L320 143.5l0-15.5-192 0 0 32-32 0 0 192 32 0 0 32 192 0 0-15.5zM48 80l0 32 32 0 0-32L48 80zm320 0l0 32 32 0 0-32-32 0zM80 400l-32 0 0 32 32 0 0-32zm288 0l0 32 32 0 0-32-32 0zM304 240l-32 0 0 32 32 0 0-32z"]
};
const faDiagramNested = {
  prefix: 'fass',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M0 32l192 0 0 192-64 0 0 128 128 0 0-64 192 0 0 192-192 0 0-64L96 416l-32 0 0-32 0-160L0 224 0 32z"]
};
const faRupeeSign = {
  prefix: 'fass',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 32l32 0 80 0c79.5 0 144 64.5 144 144c0 59.6-36.2 110.7-87.8 132.6l54.3 169.6 .6 1.8-67.2 0L104.6 320 64 320l0 160L0 480 0 288 0 64 0 32zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0s0 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9c0 0 0 0 0 0c-2.5-1-4.6-1.8-6.3-2.5l-29.8-11.6 23.2-59.7 29.8 11.6c2.6 1 5.2 2 7.9 3.1c0 0 0 0 0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4L440 212l-19 61.1-30.6-9.5c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"]
};
const faRupee = faRupeeSign;
const faFileImage = {
  prefix: 'fass',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM96 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 448l-128 0-64 0-64 0 0-32 64-88 32.5 44.7L224 288l96 128 0 32z"]
};
const faCircleQuestion = {
  prefix: 'fass',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 184c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4l0 23.6-48 0 0-24 0-13.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L224 176c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 184l0-48 48 0 0 48-48 0z"]
};
const faQuestionCircle = faCircleQuestion;
const faTicketsPerforated = {
  prefix: 'fass',
  iconName: 'tickets-perforated',
  icon: [640, 512, [], "e63f", "M640 32L96 32l0 352 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128zM512 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faImageUser = {
  prefix: 'fass',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M512 32L0 32 0 480l512 0 0-448zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96-224 0 32-96 160 0z"]
};
const faBuoy = {
  prefix: 'fass',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M416 0L160 0l0 64 25 0L133.8 320 64 320l0 70.9c3.8-2.6 7.8-5.5 12.3-8.7l1.1-.8L96 368l18.6 13.4 1.1 .8s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 368l19.7 14.2s0 0 0 0c4.4 3.2 8.5 6.1 12.3 8.7l0-70.9-69.8 0L391 64l25 0 0-64zM325.8 64l9.8 49L288 168.5 240.4 113l9.8-49 75.5 0zm21.8 108.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320l-133.4 0zm51.1 173.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faPlaneDeparture = {
  prefix: 'fass',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M381 114.9L160 32 64 80 234.6 189.7 136 240 64 208 0 240 96 352l160 0L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 448l0 64 32 0 576 0 32 0 0-64-32 0L32 448 0 448z"]
};
const faHandshakeSlash = {
  prefix: 'fass',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L509 372.4l6.8-7.4-35.4-32.4-134.2-123-23.4 18.2-26.1-20.3 77.4-60.2 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L411.3 64l-61.7 0L233.2 158.3l-26-20.2L298.8 64 224 64l-60.4 40.3L48.4 14.8zM96 171.6L40.6 128 0 128 0 384l96 0 0-212.4zM405.1 415.2L128 196.9 128 352l28.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 34.2-37.3zM32 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM640 128l-96 0 0 256 96 0 0-256zM592 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faBookBookmark = {
  prefix: 'fass',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 96C0 43 43 0 96 0l96 0 0 224 80-64 80 64L352 0l32 0 32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32z"]
};
const faBorderCenterH = {
  prefix: 'fass',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M0 480l64 0 0-64L0 416l0 64zm96 0l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zM288 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zM192 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zM384 416l0 64 64 0 0-64-64 0zm0-384l0 64 64 0 0-64-64 0zM0 96l64 0 0-64L0 32 0 96zM192 320l0 64 64 0 0-64-64 0zm192 64l64 0 0-64-64 0 0 64zM0 320l0 64 64 0 0-64L0 320zM384 192l64 0 0-64-64 0 0 64zM0 128l0 64 64 0 0-64L0 128zm192 64l64 0 0-64-64 0 0 64zM32 224L0 224l0 64 32 0 384 0 32 0 0-64-32 0L32 224z"]
};
const faCanFood = {
  prefix: 'fass',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M272 304.1c11.4-2.4 22.2-5.3 32-8.6L304 426c-2.8 1.6-6.6 3.6-11.8 5.7C269.8 440.9 234.4 448 192 448s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7l0-130.4c9.8 3.3 20.6 6.2 32 8.6l0 15.9 0 48 48 0 64 0 48 0 0-48 0-15.9zm-48 6.7l0 9.2-16 0-32 0-16 0 0-9.2 0-54.8 64 0 0 54.8zM16 72l0 168 0 200c0 39.8 78.8 72 176 72s176-32.2 176-72l0-200 0-168c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24z"]
};
const faTypewriter = {
  prefix: 'fass',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M64 0L96 0 368 0l13.3 0 9.4 9.4 48 48 9.4 9.4L448 80l0 112 64 0 0 96-32 0 0 224L32 512l0-224L0 288l0-96 64 0L64 32 64 0zM384 128l-64 0 0-64L128 64l0 128 32 0 32 32 128 0 32-32 32 0 0-64zm48 192l0-32-32 0 0 32 32 0zm-96-32l0 32 32 0 0-32-32 0zm-32 0l-32 0 0 32 32 0 0-32zm-64 0l-32 0 0 32 32 0 0-32zm-64 0l-32 0 0 32 32 0 0-32zm-64 0l-32 0 0 32 32 0 0-32zm48 128l-16 0 0 32 16 0 192 0 16 0 0-32-16 0-192 0zm-16-64l-32 0 0 32 32 0 0-32zm32 32l32 0 0-32-32 0 0 32zm64-32l0 32 32 0 0-32-32 0zm64 32l32 0 0-32-32 0 0 32zm96-32l-32 0 0 32 32 0 0-32z"]
};
const faArrowRightFromArc = {
  prefix: 'fass',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M64 256C64 150 150 64 256 64l32 0 0-64L256 0C114.6 0 0 114.6 0 256S114.6 512 256 512l32 0 0-64-32 0C150 448 64 362 64 256zM374.6 121.4L352 98.7 306.7 144l22.6 22.6L386.7 224 192 224l-32 0 0 64 32 0 194.7 0-57.4 57.4L306.7 368 352 413.3l22.6-22.6 112-112L509.3 256l-22.6-22.6-112-112z"]
};
const faCircleK = {
  prefix: 'fass',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369.1 128l-1 1.1L270.3 238.3 362 376.7l4.8 7.3-57.6 0L237.1 275.2 208 307.7l0 52.3 0 24-48 0 0-24 0-61.5L160 152l0-24 48 0 0 24 0 83.8L222.1 220l82.5-92 64.5 0z"]
};
const faFaceHandOverMouth = {
  prefix: 'fass',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M512 256c0 113.1-73.3 209.1-175.1 242.9l52.3-52.3L411.9 424l-22.6-22.6-9.4-9.4 9.4-9.4L411.9 360l-22.6-22.6-9.4-9.4 16-16-22.6-22.6-22.6-22.6L328 244.1l-16 16-9.4-9.4L280 228.1l-22.6 22.6-51.7 51.7-21.7 0-40 0-32 0 0 32 0 82.4c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-33.7 72l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L280 273.4 302.6 296z"]
};
const faPopcorn = {
  prefix: 'fass',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M32.2 160l87.6 0 208.4 0 87.6 0c.1-1.3 .2-2.7 .2-4c0-20.9-14.5-38.3-34-42.9c1.3-4.2 2-8.6 2-13.1c0-24.3-19.7-44-44-44c-1.9 0-3.7 .1-5.6 .3C329.3 37.7 312.3 24 292 24c-8.5 0-16.5 2.4-23.2 6.6C261.8 12.7 244.4 0 224 0s-37.8 12.7-44.8 30.6C172.5 26.4 164.5 24 156 24c-20.3 0-37.3 13.7-42.4 32.3c-1.8-.2-3.7-.3-5.6-.3c-24.3 0-44 19.7-44 44c0 4.6 .7 9 2 13.1c-19.5 4.5-34 22-34 42.9c0 1.3 .1 2.7 .2 4zm79.9 153.9L97.8 192 0 192 80 512l288 0 80-320-97.8 0L335.9 313.9 318.2 464 286 464l18.1-153.9L318 192l-78 0 0 256 0 16-32 0 0-16 0-256-78 0 13.9 118.1L162 464l-32.2 0L112.1 313.9z"]
};
const faHouseWater = {
  prefix: 'fass',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 103.3c3.8-2.6 7.8-5.5 12.2-8.7l1.1-.8L96 368l18.6 13.4 1.1 .8s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 368l19.7 14.2s0 0 0 0s0 0 0 0c4.5 3.3 8.6 6.2 12.5 8.9l-.5-103.5zM224 192l128 0 0 128-128 0 0-128zm48.4 301.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faHouseFlood = faHouseWater;
const faObjectSubtract = {
  prefix: 'fass',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M512 512l-352 0 0-160-96 0L0 352l0-64L0 64 0 0 64 0 288 0l64 0 0 64 0 96 160 0 0 352zM288 288l0-224L64 64l0 224 224 0z"]
};
const faCodeBranch = {
  prefix: 'fass',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M56 56l0 48 48 0 0-48L56 56zM0 0L56 0l48 0 56 0 0 56 0 48 0 56-48 0 0 81.1c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l-48 0 0-56 0-48 0-56 56 0 48 0 56 0 0 56 0 48 0 56-48 0c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l48 0 0 56 0 48 0 56-56 0-48 0L0 512l0-56 0-48 0-56 48 0 0-192L0 160l0-56L0 56 0 0zM392 56l-48 0 0 48 48 0 0-48zM104 408l-48 0 0 48 48 0 0-48z"]
};
const faWarehouseFull = {
  prefix: 'fass',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M0 512L0 128 320 0 640 128l0 384-96 0 0-320L96 192l0 320L0 512zM512 384l0 128-160 0 0-128 160 0zM128 224l192 0 0 128-192 0 0-128zM320 384l0 128-192 0 0-128 192 0z"]
};
const faWarehouseAlt = faWarehouseFull;
const faHatCowboy = {
  prefix: 'fass',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M320 80L216 32 151.7 260.6c42.4 15.2 98.1 27.3 167.9 27.4l.8 0c69.8 0 125.5-12.2 167.9-27.4L424 32 320 80zM24 224L0 256s96 192 320 192s320-192 320-192l-24-32s-94.5 96-296 96s-296-96-296-96z"]
};
const faBridge = {
  prefix: 'fass',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M32 32L0 32 0 96l32 0 40 0 0 64L0 160 0 288c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96s96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96l0-128-72 0 0-64 40 0 32 0 0-64-32 0L32 32zM456 96l0 64-80 0 0-64 80 0zM328 96l0 64-80 0 0-64 80 0zM200 96l0 64-80 0 0-64 80 0z"]
};
const faPhoneFlip = {
  prefix: 'fass',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M512 32L368 0 288 144l83.8 67c-36.1 68.4-92.3 124.6-160.8 160.8L144 288 0 368 32 512H64c247.4 0 448-200.6 448-448l0-32z"]
};
const faPhoneAlt = faPhoneFlip;
const faArrowDownFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M64 32l0 64L0 96 0 32l64 0zm96 0l0 64L96 96l0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM246.6 454.6L224 477.3l-22.6-22.6-128-128L50.7 304 96 258.7l22.6 22.6L192 354.7 192 192l0-32 64 0 0 32 0 162.7 73.4-73.4L352 258.7 397.3 304l-22.6 22.6-128 128z"]
};
const faFileDoc = {
  prefix: 'fass',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM176 352l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0-16 0 0-16 0-128 0-16 16 0zm16 128l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM456 352l16 0c22.1 0 40 17.9 40 40l0 8 0 16-32 0 0-16 0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8 0-16 32 0 0 16 0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
const faSquareQuarters = {
  prefix: 'fass',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M0 32l64 0 320 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM64 96L224 256 384 96 64 96zm0 320l320 0L224 256 64 416z"]
};
const faTruckFront = {
  prefix: 'fass',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M0 0L512 0l0 448-32 0 0 64-96 0 0-64-256 0 0 64-96 0 0-64L0 448 0 0zM136 128l-24 96 288 0-24-96-240 0zm-8 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCat = {
  prefix: 'fass',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M337.1 192L320 192c-66.8 0-125.6 34.1-160 85.8l0-85.8c0-53-43-96-96-96L32 96l0 64 32 0c17.7 0 32 14.3 32 32l0 288 0 32 32 0 208 0 32 0 0-64-32 0-56 0L416 339.2 416 480l0 32 64 0 0-32 0-192 0-32 0-4c-10.2 2.6-21 4-32 4c-47.4 0-88.7-25.7-110.9-64zm194.3-16.4c8-14 12.6-30.3 12.6-47.6l0-82.7L544 0 512 32 480 64s0 0 0 0l-64 0s0 0 0 0L384 32 352 0l0 45.3 0 82.7s0 0 0 0c0 18.6 5.3 36 14.5 50.8c2.9 4.7 6.3 9.1 9.9 13.2c0 0 0 0 0 0c17.6 19.6 43.1 32 71.6 32c11.2 0 22-1.9 32-5.5c0 0 0 0 0 0c21.8-7.7 40-23.1 51.4-42.9zM400 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faTrashXmark = {
  prefix: 'fass',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0L392 512 56 512 32 128zM321.9 256L288 222.1l-17 17-47 47-47-47-17-17L126.1 256l17 17 47 47-47 47-17 17L160 417.9l17-17 47-47 47 47 17 17L321.9 384l-17-17-47-47 47-47 17-17z"]
};
const faCircleCaretLeft = {
  prefix: 'fass',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 384L144 256 272 128l32 0 0 256-32 0z"]
};
const faCaretCircleLeft = faCircleCaretLeft;
const faFiles = {
  prefix: 'fass',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M320 96l0 32 32 0 96 0 0 288L96 416 96 0 320 0l0 96zm128 0l-45.3 0L384 96l-32 0 0-32 0-18.7L352 0l32 32 32 32 32 32zM48 120l0 344 280 0 24 0 0 48-24 0L24 512 0 512l0-24L0 120 0 96l48 0 0 24z"]
};
const faAnchorCircleExclamation = {
  prefix: 'fass',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faFaceClouds = {
  prefix: 'fass',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M128 0C104.3 0 83.6 12.9 72.6 32L64 32C28.7 32 0 60.7 0 96l0 64 224 0 32 0 32 0 0-32 0-32c0-35.3-28.7-64-64-64l-40.6 0C172.4 12.9 151.7 0 128 0zM320 192l-32 0-19.9 0c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L72.1 192c-5.3 20.5-8.1 41.9-8.1 64c0 107.4 66.2 199.4 160 237.4l0-29.4c0-54.7 34.3-101.3 82.5-119.7C317.4 293.8 362.3 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96l0 64 0 32zm16 177.3c-41.2 6.9-73.6 40.1-79.2 81.8c-.6 4.2-.9 8.5-.9 12.9l0 16 0 23.9 0 8.1 64 0 320 0 0-48c0-44.7-30.6-82.3-72-93l0-11c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288c-44.2 0-80 35.8-80 80c0 .4 0 .9 0 1.3zM400.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faUserCrown = {
  prefix: 'fass',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M96 53.7L96 0l48 24 16 8L224 0l64 32 16-8L352 0l0 53.7 0 90.3c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-90.3zM144 128l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0zM384 304l64 208L0 512 64 304l320 0z"]
};
const faBasketShoppingPlus = {
  prefix: 'fass',
  iconName: 'basket-shopping-plus',
  icon: [576, 512, [], "e653", "M256.4 29.8L245.3 51.1 171.8 192l232.5 0L330.7 51.1 319.6 29.8 362.2 7.6l11.1 21.3L458.4 192 576 192l0 64-32 0L480 512 96 512 32 256 0 256l0-64 117.6 0L202.7 28.9 213.8 7.6l42.6 22.2zM184 328l0 48 24 0 56 0 0 56 0 24 48 0 0-24 0-56 56 0 24 0 0-48-24 0-56 0 0-56 0-24-48 0 0 24 0 56-56 0-24 0z"]
};
const faTruckField = {
  prefix: 'fass',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M32 32l352 0 0 32 64 0 20.8 0 8.4 19 62.7 141 68.1 0 0 96 32 0 0 64-32 0-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-32 0L0 384l0-64 32 0 0-32L0 288 0 128l32 0 0-96zM384 224l85.9 0-42.7-96L384 128l0 96zM112 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm416 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faRoute = {
  prefix: 'fass',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M416 256s96-96 96-160c0-53-43-96-96-96s-96 43-96 96c0 29.4 20.2 65.5 42.1 96L256 192l-32 0 0 32 0 128 0 32 32 0 192 0 0 64-259.4 0c-6.2 9.6-12.6 18.8-19 27.2c-10.7 14.2-21.3 26.9-30 36.8L480 512l32 0 0-32 0-128 0-32-32 0-192 0 0-64 128 0zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM149.9 448c21.9-30.5 42.1-66.6 42.1-96c0-53-43-96-96-96s-96 43-96 96c0 64 96 160 96 160s3.5-3.5 9.2-9.6c.4-.4 .7-.8 1.1-1.2c3.3-3.5 7.1-7.8 11.4-12.8c.2-.2 .4-.4 .6-.6c9.4-10.8 20.7-24.6 31.6-39.8zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCartCircleCheck = {
  prefix: 'fass',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faClipboardQuestion = {
  prefix: 'fass',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 248c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L160 240c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48z"]
};
const faPanorama = {
  prefix: 'fass',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M32 32L0 32 0 64 0 448l0 32 32 0 16 0 5.5 0 5.2-1.9s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l.1 0 .7-.3c.7-.2 1.8-.6 3.4-1.1c3.1-1 7.7-2.5 13.9-4.2c12.3-3.5 30.5-8.3 53.7-13.2C176.8 449.7 242.6 440 320 440s143.2 9.7 189.5 19.3c23.1 4.8 41.4 9.6 53.7 13.2c6.2 1.8 10.8 3.2 13.9 4.2c1.5 .5 2.7 .9 3.4 1.1l.7 .3 .1 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l5.2 1.9 5.5 0 16 0 32 0 0-32 0-384 0-32-32 0-16 0-5.5 0-5.2 1.9s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1 0-.7 .3c-.7 .2-1.8 .6-3.4 1.1c-3.1 1-7.7 2.5-13.9 4.2c-12.3 3.5-30.5 8.3-53.7 13.2C463.2 62.3 397.4 72 320 72s-143.2-9.7-189.5-19.3c-23.1-4.8-41.4-9.6-53.7-13.2c-6.2-1.8-10.8-3.2-13.9-4.2c-1.5-.5-2.7-.9-3.4-1.1l-.7-.3-.1 0s0 0 0 0s0 0 0 0L53.5 32 48 32 32 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272-18.6l19.8 29.1L512.3 353l31.8 46.7-55.7-9.5C442.7 382.4 385.2 376 320 376c-19 0-37.3 .5-54.9 1.5l-.8 1.2-.9-1.1c-42.5 2.4-80.5 7.3-112.7 12.8L88.4 401l39.5-49.3L197.3 265 216 241.6 234.7 265l26.4 33.1 87-127.6L368 141.4z"]
};
const faCommentMedical = {
  prefix: 'fass',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM224 208l-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64z"]
};
const faTeethOpen = {
  prefix: 'fass',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M576 32L0 32 0 256l576 0 0-224zM224 96c26.5 0 48 21.5 48 48l0 80-96 0 0-80c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80-96 0 0-80zM96 128c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 48-96 0 0-48zM576 480l0-192L0 288 0 480l576 0zM96 416c-26.5 0-48-21.5-48-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48zm80-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48zm80-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48s-48-21.5-48-48z"]
};
const faUserTieHairLong = {
  prefix: 'fass',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zM209.1 359.2L175.8 483.1 135.8 320 64 320 0 512l168 0 14.9 0 82.3 0 14.9 0 168 0L384 320l-71.8 0L272.2 483.1 238.9 359.2 272 304l-48 0-48 0 33.1 55.2z"]
};
const faFileCircleMinus = {
  prefix: 'fass',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-16 0-128 0-16 0 0 32 16 0 128 0 16 0z"]
};
const faHeadSideMedical = {
  prefix: 'fass',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zM192 160l-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64z"]
};
const faArrowTurnRight = {
  prefix: 'fass',
  iconName: 'arrow-turn-right',
  icon: [512, 512, [], "e635", "M358.6 374.6L336 397.3 290.7 352l22.6-22.6L386.7 256 64 256l0 192 0 32L0 480l0-32L0 224l0-32 32 0 354.7 0-73.4-73.4L290.7 96 336 50.7l22.6 22.6 128 128L509.3 224l-22.6 22.6-128 128z"]
};
const faTags = {
  prefix: 'fass',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M495.2 189.3l7 7 0 9.9 0 99.5 0 9.9-7 7L337 481 303 447 454.2 295.8l0-79.6L303 65 337 31 495.2 189.3zM0 256L0 32l224 0L416 224l0 64L224 480 0 256zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faWineGlass = {
  prefix: 'fass',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M84.6 128l5.8-64 139.1 0 5.8 64L84.6 128zM32 0L14.5 192.7C7.7 267.3 58 332.9 128 348.5l0 99.5-80 0 0 64 112 0 112 0 0-64-80 0 0-99.5c70-15.6 120.3-81.2 113.5-155.8L288 0 32 0z"]
};
const faForwardFast = {
  prefix: 'fass',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M448 96l0-32 64 0 0 32 0 320 0 32-64 0 0-32 0-136L224 448l0-168L0 448 0 64 224 232l0-168L448 232l0-136z"]
};
const faFastForward = faForwardFast;
const faFaceMehBlank = {
  prefix: 'fass',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faMehBlank = faFaceMehBlank;
const faUserRobot = {
  prefix: 'fass',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M240 0l0 16 0 48 128 0 0 256L80 320 80 64l128 0 0-48 0-16 32 0zM16 128l32 0 0 128-32 0 0-128zm384 0l32 0 0 128-32 0 0-128zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80l-32 0 0 32 32 0 0-32zM400 352l48 160-96 0 0-96L96 416l0 96L0 512 48 352l352 0zM176 464l0 48-32 0 0-48 0-16 32 0 0 16zm64 0l0 48-32 0 0-48 0-16 32 0 0 16zM176 240l-32 0 0 32 32 0 0-32zm96 0l0 32 32 0 0-32-32 0zm32 224l0 48-32 0 0-48 0-16 32 0 0 16z"]
};
const faSquareParking = {
  prefix: 'fass',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M448 32L0 32 0 480l448 0 0-448zM160 128l80 0c53 0 96 43 96 96l0 32-5.5 0c-13.2 37.3-48.7 64-90.5 64l-48 0 0 32 0 32-64 0 0-32 0-32 0-64 0-96 0-32 32 0zm80 128c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64 48 0z"]
};
const faParking = faSquareParking;
const faCardDiamond = {
  prefix: 'fass',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M384 0L0 0 0 512l384 0L384 0zM80 256L192 144 304 256 192 368 80 256z"]
};
const faFaceZipper = {
  prefix: 'fass',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M512 256c0 40-9.2 77.8-25.5 111.5l-88.2-44.1-20.6-10.3-16.3 16.3L336 354.7l0-18.7 0-16-32 0 0 16 0 32 0 16 12.2 0 7.2 14.3 44.1 88.2C333.8 502.8 296 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144 336l0-16-32 0 0 16 0 32 0 16 32 0 0-16 0-32zm64 0l0-16-32 0 0 16 0 32 0 16 32 0 0-16 0-32zm64 0l0-16-32 0 0 16 0 32 0 16 32 0 0-16 0-32zm240 80l0 32-64 64-32 0L352 384l32-32 128 64zm-63.5 16.5L457 424l-17-17-8.5 8.5-16 16L407 440l17 17 8.5-8.5 16-16z"]
};
const faFaceRaisedEyebrow = {
  prefix: 'fass',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 336l0 32 16 0 192 0 16 0 0-32-16 0-192 0-16 0zM328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4 8.9 13.3 26.6-17.8-8.9-13.3-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5L265.4 160 288 182.6l11.3-11.3 29.5-29.5zM128 144l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z"]
};
const faHouseSignal = {
  prefix: 'fass',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M336 0L96 208l0 32.4c81.8 28.9 146.7 93.8 175.6 175.6L512 416l0-160 64 0 0-48L336 0zM288 192l96 0 0 96-96 0 0-96zM0 304c114.9 0 208 93.1 208 208l48 0C256 370.6 141.4 256 0 256l0 48zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0l48 0c0-88.4-71.6-160-160-160l0 48c61.9 0 112 50.1 112 112z"]
};
const faSquareChevronUp = {
  prefix: 'fass',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M448 32L0 32 0 480l448 0 0-448zM241 167L345 271l17 17L328 321.9l-17-17-87-87-87 87-17 17L86.1 288l17-17L207 167l17-17 17 17z"]
};
const faChevronSquareUp = faSquareChevronUp;
const faNfcSymbol = {
  prefix: 'fass',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M163.1 40.2L145.8 24.7 125.7 36.3C50.3 79.9 0 163.2 0 256s50.3 176.1 125.7 219.7l32-55.4C101.9 388 64 325.7 64 256c0-61.4 29.5-117.2 74.8-151.7L298.6 247.8l23.8 21.4 42.7-47.6-23.8-21.4L163.1 40.2zM348.9 471.8l17.3 15.5 20.1-11.6C461.6 432.1 512 348.8 512 256s-50.3-176.1-125.7-219.7l-32 55.4C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2l-23.8-21.4-42.7 47.6 23.8 21.4 178.3 160z"]
};
const faBarsProgress = {
  prefix: 'fass',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M448 128l0 32-128 0 0-32 128 0zM64 64L0 64l0 64 0 32 0 64 64 0 384 0 64 0 0-64 0-32 0-64-64 0L64 64zM448 384l-256 0 0-32 256 0 0 32zM64 288L0 288l0 64 0 32 0 64 64 0 384 0 64 0 0-64 0-32 0-64-64 0L64 288z"]
};
const faTasksAlt = faBarsProgress;
const faFaucetDrip = {
  prefix: 'fass',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M256 0l0 44.8L384 32l0 64L256 83.2l-31.2-3.1L224 80s0 0 0 0s0 0 0 0l-.8 .1L192 83.2 64 96l0-64L192 44.8 192 0l64 0zM128 192l32-32 32 0 0-44.6 32-3.2 32 3.2 0 44.6 32 0 32 32 32 0c88.4 0 160 71.6 160 160l0 32-128 0 0-32c0-17.7-14.3-32-32-32l-36.1 0c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48L0 320 0 192l128 0zM448 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7L448 416z"]
};
const faArrowsToLine = {
  prefix: 'fass',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M256 32l0-32L192 0l0 32 0 32-64 0 0 32 96 96 96-96 0-32-64 0 0-32zM192 448l0 32 0 32 64 0 0-32 0-32 64 0 0-32-96-96-96 96 0 32 64 0zM32 224L0 224l0 64 32 0 384 0 32 0 0-64-32 0L32 224z"]
};
const faDolphin = {
  prefix: 'fass',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M176 0l30.5 0c46.1 0 89.7 10.2 128.9 28.6L464 0l16 16L427.4 94.8c52.4 55 84.6 129.4 84.6 211.3c0 94.2-79.2 169.5-173.3 164.3l-72.5-4L248 512l-88 0 32-80-32-80 88 0 21.5 53.7 60-3C360 401.2 384 376 384 345.4c0-31.7-25.7-57.4-57.4-57.4l-6.6 0 0 64-32 0-80-64-16 0-16 0L32 288 0 288l0-32 0-16 0-18.1 15.5-9.3L42 196.7c-6.4-16.3-10-34.1-10-52.7C32 64.5 96.5 0 176 0zm0 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faArrowUpRight = {
  prefix: 'fass',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M320 96l32 0 0 32 0 224 0 32-64 0 0-32 0-146.7L86.6 406.6 64 429.3 18.7 384l22.6-22.6L242.7 160 96 160l-32 0 0-64 32 0 224 0z"]
};
const faCircleR = {
  prefix: 'fass',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128l24 0 104 0c44.2 0 80 35.8 80 80c0 37.8-26.3 69.5-61.6 77.9L369.1 384l-57 0-61.3-96L208 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 112l56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64z"]
};
const faCartFlatbed = {
  prefix: 'fass',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M32 0L0 0 0 64l32 0 32 0 0 352 0 32 32 0 66.7 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0 32 0 0-64-32 0-480 0 0-352 0-32L96 0 32 0zM192 32l0 288 416 0 0-288L464 32l0 160-64-48-64 48 0-160L192 32z"]
};
const faDollyFlatbed = faCartFlatbed;
const faBanSmoking = {
  prefix: 'fass',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32 82.7 0 0 32-50.7 0zm32 32l34.7 0 16 0 0-16 0-64 0-16-16 0-130.7 0L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM288 96l-32 0 0 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 16 32 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16l0-16zM229.5 320l-96-96L112 224l-16 0 0 16 0 64 0 16 16 0 117.5 0z"]
};
const faSmokingBan = faBanSmoking;
const faCircleSortUp = {
  prefix: 'fass',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-64l0 32 224 0 0-32L256 96 144 192zm0 96l0 32 112 96 112-96 0-32-32 0-160 0-32 0zm112 85.9L193.2 320l125.7 0L256 373.9z"]
};
const faSortCircleUp = faCircleSortUp;
const faTerminal = {
  prefix: 'fass',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M22.2 99.4L-.5 76.8 44.8 31.5 67.4 54.2 246.6 233.4 269.3 256l-22.6 22.6L67.4 457.8 44.8 480.5-.5 435.2l22.6-22.6L178.7 256 22.2 99.4zM256 416l288 0 32 0 0 64-32 0-288 0-32 0 0-64 32 0z"]
};
const faMobileButton = {
  prefix: 'fass',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M368 0L16 0l0 512 352 0L368 0zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHouseMedicalFlag = {
  prefix: 'fass',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M512 0l0 32 128 0 0 160-128 0 0 320-64 0 0-320 0-160 0-32 64 0zM256.4 32L416 165.2 416 512 64.1 512l0-224.4L0 287.6 0 240 256.4 32zM224 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faBasketShopping = {
  prefix: 'fass',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M245.3 51.1l11.1-21.3L213.8 7.6 202.7 28.9 117.6 192 0 192l0 64 32 0L96 512l384 0 64-256 32 0 0-64-117.6 0L373.3 28.9 362.2 7.6 319.6 29.8l11.1 21.3L404.2 192l-232.5 0L245.3 51.1zM192 304l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16zm112-16l0 16 0 96 0 16-32 0 0-16 0-96 0-16 32 0zm112 16l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16z"]
};
const faShoppingBasket = faBasketShopping;
const faTape = {
  prefix: 'fass',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l320 0 32 0 0-64-32 0-163.2 0zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faChestnut = {
  prefix: 'fass',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M0 416l64 64 320 0 64-64 0-32L0 384l0 32zm448-64c0-134.3-101.7-213.8-168.4-265.8C251 63.8 228.8 46.4 224 32c-4.8 14.4-27 31.8-55.6 54.2C101.7 138.2 0 217.7 0 352l448 0z"]
};
const faBusSimple = {
  prefix: 'fass',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M224 0C348.8 0 448 48 448 48l0 48 0 352-32 0 0 64-96 0 0-64-192 0 0 64-96 0 0-64L0 448 0 96 0 48S99.2 0 224 0zM64 288l320 0 0-192L64 96l0 192zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBusAlt = faBusSimple;
const faEye = {
  prefix: 'fass',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 32C129.6 32 30 181.3 0 256c30 74.7 129.6 224 288 224s258-149.3 288-224C546 181.3 446.4 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm48 0c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8L288 256l-94.2-18.8c-1.2 6.1-1.8 12.4-1.8 18.8z"]
};
const faFaceSadCry = {
  prefix: 'fass',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6L160 288l0-16-32 0 0 16 0 189.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8L384 288l0-16-32 0 0 16 0 205.4zM208 336l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-91.2-98.4c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm278.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0z"]
};
const faSadCry = faFaceSadCry;
const faHeat = {
  prefix: 'fass',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M208 32l0 32 0 80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400l0 48 0 32-64 0 0-32 0-48c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144l0-80 0-32 64 0zM64 96l0 32 0 32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416l0 32 0 32-64 0 0-32 0-32c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160l0-32L0 96l64 0zm288 32l0 32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416l0 32 0 32-64 0 0-32 0-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160l0-32 0-32 64 0 0 32z"]
};
const faTicketAirline = {
  prefix: 'fass',
  iconName: 'ticket-airline',
  icon: [640, 512, ["ticket-perforated-plane", "ticket-plane"], "e29a", "M640 64L0 64 0 448l640 0 0-144c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-144zM432 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM176 224l-32-96 56 0 56 96 46.9 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288L256 288l-56 96-56 0 32-96-56 0L96 320l-32 0 16-64L64 192l32 0 24 32 56 0z"]
};
const faTicketPerforatedPlane = faTicketAirline;
const faTicketPlane = faTicketAirline;
const faBootHeeled = {
  prefix: 'fass',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M128 0L32 0l0 64L64 256 32 384l0 128 128 0 0-48 144 48 16 0 24 0 136 0 8 0 24 0 0-48-24 0-8 0 0-80L288 288 288 0 160 0l0 240 0 16-32 0 0-16L128 0z"]
};
const faArrowsMinimize = {
  prefix: 'fass',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M48 2.7L70.6 25.4 160 114.7 160 80l0-32 64 0 0 32 0 112 0 32-32 0L80 224l-32 0 0-64 32 0 34.7 0L25.4 70.6 2.7 48 48 2.7zM509.3 48L486.6 70.6 397.3 160l34.7 0 32 0 0 64-32 0-112 0-32 0 0-32 0-112 0-32 64 0 0 32 0 34.7 89.4-89.4L464 2.7 509.3 48zM48 288l32 0 112 0 32 0 0 32 0 112 0 32-64 0 0-32 0-34.7L70.6 486.6 48 509.3 2.7 464l22.6-22.6L114.7 352 80 352l-32 0 0-64zm240 0l32 0 112 0 32 0 0 64-32 0-34.7 0 89.4 89.4L509.3 464 464 509.3l-22.6-22.6L352 397.3l0 34.7 0 32-64 0 0-32 0-112 0-32z"]
};
const faCompressArrows = faArrowsMinimize;
const faAudioDescription = {
  prefix: 'fass',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M576 32L0 32 0 480l576 0 0-448zM328 160l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0-24 0 0-24 0-144 0-24 24 0zm24 144l32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0 0 96zM173.9 287.8l36.3 0L192 245.2l-18.1 42.6zm-17 40L146.5 352l-52.2 0 75.6-177.4 6.2-14.6 31.7 0 6.2 14.6L289.6 352l-52.2 0-10.3-24.2-70.4 0z"]
};
const faPersonMilitaryToPerson = {
  prefix: 'fass',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M200 0L56 14.1l0 32 144 0L200 0zM189.5 78.1l-122.9 0C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM192 192L83.8 192 217.8 295 192 192zM32 320l165.8 0L58.7 213.1 32 320zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96 160L448 192l-128 0L288 320l192 0zM272 432l96 80 16 0 0-56 104 0 24 0 0-48-24 0-104 0 0-56-16 0-96 80zM128 352l0 56L24 408 0 408l0 48 24 0 104 0 0 56 16 0 96-80-96-80-16 0z"]
};
const faFileShield = {
  prefix: 'fass',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M0 0L224 0l0 160 160 0 0 48.3L256 257.8l0 38.2c0 76.6 34.3 164.8 106.1 216L0 512 0 0zM384 128l-128 0L256 0 384 128zM527.3 312.4L432 275.5l0 184.9c56.5-26.3 90.2-87 95.3-148zM432 512c-96-32-144-130.2-144-216l0-16.2L432 224l144 55.8 0 16.2c0 85.9-48 184-144 216z"]
};
const faHexagon = {
  prefix: 'fass',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M128 32L0 256 128 480l256 0L512 256 384 32 128 32z"]
};
const faManhole = {
  prefix: 'fass',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 128c16.6 0 30.3-12.6 31.8-28.8C361 113.9 416 178.5 416 256s-55 142.1-128.2 156.8C286.3 396.6 272.6 384 256 384s-30.3 12.6-31.8 28.8C151 398.1 96 333.5 96 256s55-142.1 128.2-156.8c1.6 16.2 15.2 28.8 31.8 28.8zm-80 48l0 32 32 0 0-32-32 0zm0 64l0 32 32 0 0-32-32 0zm32 64l-32 0 0 32 32 0 0-32zm64-128l-32 0 0 32 32 0 0-32zm-32 64l0 32 32 0 0-32-32 0zm32 64l-32 0 0 32 32 0 0-32zm64-128l-32 0 0 32 32 0 0-32zm-32 64l0 32 32 0 0-32-32 0zm32 64l-32 0 0 32 32 0 0-32z"]
};
const faUserSlash = {
  prefix: 'fass',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M544 512l-16 0L264 304l-104 0L96 512l448 0s0 0 0 0zM353.4 251.6C407.9 236.9 448 187.1 448 128C448 57.3 390.7 0 320 0C249.9 0 192.9 56.4 192 126.3L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L353.4 251.6z"]
};
const faPen = {
  prefix: 'fass',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M0 512L32 352 292.7 91.3l128 128L160 480 0 512zM443.3 196.7l-128-128L384 0 512 128l-68.7 68.7z"]
};
const faTowerObservation = {
  prefix: 'fass',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M64 96L256 0 448 96l0 32-32 0 0 128-36.9 0 32 192 68.9 0 32 0 0 64-32 0-95.5 0c-.4 0-.8 0-1.1 0l-254.8 0c-.4 0-.8 0-1.1 0L32 512 0 512l0-64 32 0 68.9 0 32-192L96 256l0-128-32 0 0-32zM314.5 448L256 399.2 197.5 448l117 0zM193.1 284.3L256 336.8l62.9-52.5L314.2 256l-116.5 0-4.7 28.3zm-9.1 54.9l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM352 128l-192 0 0 32 192 0 0-32z"]
};
const faFloppyDisks = {
  prefix: 'fass',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M96 0l24 0L384 0l9.9 0 7 7L505 111l7 7 0 9.9 0 264 0 24-24 0-368 0-24 0 0-24L96 24 96 0zM384 64L160 64l0 96 224 0 0-96zM368 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM48 120l0 344 344 0 24 0 0 48-24 0L24 512 0 512l0-24L0 120 0 96l48 0 0 24z"]
};
const faToiletPaperBlankUnder = {
  prefix: 'fass',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M348.2 0L96 0C43 0 0 86 0 192S43 384 96 384l252.2 0c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9c35.5 0 66.6-38.6 83.2-96c8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9zM416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM160 512l352 0 0-168.9c-19.1 37.8-51.2 72.9-96 72.9l-256 0 0 96z"]
};
const faToiletPaperReverseAlt = faToiletPaperBlankUnder;
const faFileCode = {
  prefix: 'fass',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM153 289l-31 31 31 31 17 17L136 401.9l-17-17L71 337l-17-17 17-17 48-48 17-17L169.9 272l-17 17zM265 255l48 48 17 17-17 17-48 48-17 17L214.1 368l17-17 31-31-31-31-17-17L248 238.1l17 17z"]
};
const faSignal = {
  prefix: 'fass',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M608 0l0 32 0 448 0 32-64 0 0-32 0-448 0-32 64 0zM480 96l0 32 0 352 0 32-64 0 0-32 0-352 0-32 64 0zM352 224l0 256 0 32-64 0 0-32 0-256 0-32 64 0 0 32zM224 288l0 32 0 160 0 32-64 0 0-32 0-160 0-32 64 0zM96 416l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z"]
};
const faSignal5 = faSignal;
const faSignalPerfect = faSignal;
const faPump = {
  prefix: 'fass',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M128 0l0 64 32 0 160 0 32 0 0-64L320 0 160 0 128 0zM64 176L0 176l0 32L0 384l0 32 64 0 0-32 0-176 0-32zm96 48l-64 0 0 160 224 0 0-288L160 96l0 128zM448 96l-96 64 0 288 96 64 192 0 0-416L448 96zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z"]
};
const faBus = {
  prefix: 'fass',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M288 0C412.8 0 512 48 512 48l0 48 0 32 32 0 0 128-32 0 0 192-32 0 0 64-96 0 0-64-192 0 0 64-96 0 0-64-32 0L64 96s0 0 0 0l0-48s99.2-48 224-48zM64 256l-32 0 0-128 32 0 0 128zM304 128l0 160 144 0 0-160-144 0zm-32 0l-144 0 0 160 144 0 0-160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 96l0-32-16 0L208 64l-16 0 0 32 16 0 160 0 16 0z"]
};
const faHeartCircleXmark = {
  prefix: 'fass',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z"]
};
const faArrowUpLeftFromCircle = {
  prefix: 'fass',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M32 0L0 0 0 32 0 192l0 32 64 0 0-32 0-82.7L297.4 342.6 320 365.3 365.3 320l-22.6-22.6L109.3 64 192 64l32 0 0-64L192 0 32 0zM288 128c88.4 0 160 71.6 160 160s-71.6 160-160 160s-160-71.6-160-160l-64 0c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64l0 64z"]
};
const faHouseChimney = {
  prefix: 'fass',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M576 287.6l-64.2 0 1 224.4L472 512l-16 0-104 0 0-160-128 0 0 160-104 0-16 0-39.9 0 0-37.2c-.1-.9-.1-1.8-.1-2.8l0-112c0-.9 0-1.9 .1-2.8l0-69.7L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6z"]
};
const faHomeLg = faHouseChimney;
const faWindowMaximize = {
  prefix: 'fass',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M512 32L0 32 0 480l512 0 0-448zM448 96l0 64L64 160l0-64 384 0z"]
};
const faDryer = {
  prefix: 'fass',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M0 0L448 0l0 512L0 512 0 0zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM336 304c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l62.9 0 16 0 0-32-16 0-62.9 0c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112z"]
};
const faFaceFrown = {
  prefix: 'fass',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7L154.5 404 124 394.5l4.7-15.3C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3l4.7 15.3L357.5 404l-4.7-15.3C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFrown = faFaceFrown;
const faChessBishopPiece = {
  prefix: 'fass',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M80 32l96 0 0 48-20.7 0c6.7 6.4 14.3 14.5 21.7 24.4l-44.3 44.3L121.4 160 144 182.6l11.3-11.3 38.8-38.8c8.2 17.1 13.9 37 13.9 59.5c0 26.3-13.6 40.5-26.3 48l2.3 0 24 0 0 48-24 0-5.7 0L192 384 64 384l13.7-96L72 288l-24 0 0-48 24 0 2.3 0C61.6 232.5 48 218.3 48 192c0-52.8 31.4-91.7 52.7-112L80 80l0-48zM43.9 416l4.1 0 160 0 4.1 0 2.4 3.4 40 56 1.5 2.1 0 2.6 0 24 0 8-8 0L8 512l-8 0 0-8 0-24 0-2.6 1.5-2.1 40-56 2.4-3.4z"]
};
const faChessBishopAlt = faChessBishopPiece;
const faShirtTankTop = {
  prefix: 'fass',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 32l0-32L48 0l0 32 0 32 0 16 0 48L0 256 0 512l384 0 0-256L336 128l0-48 0-16 0-32 0-32L272 0l0 32 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48z"]
};
const faDiploma = {
  prefix: 'fass',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M208 144l0-31 0-.5c.3-18 14.9-32.5 33-32.5c9.5 0 18.6 4.1 24.8 11.3L312 144l-72 0-32 0zm120 0l46.1-52.7C380.4 84.1 389.5 80 399 80l1 0c17.7 0 32 14.3 32 32l0 .5 0 .5 0 31-32 0-72 0zm-72 64l0 108.2L97.7 347.8 64 280.4 64 208l192 0zM384 316.2L384 208l192 0 0 72.4-33.7 67.4L384 316.2zm0 65.3l169.7 33.9 24 4.8 10.9-21.9 48-96 3.4-6.8 0-7.6 0-112 0-32-32 0-128 0 0-31c0-44.7-36.3-81-81-81c-23.4 0-45.6 10.1-61 27.7L320 80.3 302 59.7C286.6 42.1 264.4 32 241 32c-44.7 0-81 36.3-81 81l0 31L32 144 0 144l0 32L0 288l0 7.6 3.4 6.8 48 96 10.9 21.9 24-4.8L256 381.4l0 98.6 64-40 64 40 0-98.6z"]
};
const faScrollRibbon = faDiploma;
const faScreencast = {
  prefix: 'fass',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 96L64 96l0 103.1C43.4 194.5 22 192 0 192L0 96 0 32l64 0 448 0 64 0 0 64 0 320 0 64-64 0-224 0c0-22-2.5-43.4-7.1-64L512 416l0-320zM0 272l0-48c141.4 0 256 114.6 256 256l-48 0c0-114.9-93.1-208-208-208zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 64c0-61.9-50.1-112-112-112l0-48c88.4 0 160 71.6 160 160l-48 0z"]
};
const faWalker = {
  prefix: 'fass',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M118.7 0L144 0 384 0l32 0 0 32 0 360.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4L352 224l-220.5 0L71.1 479.4l-7.4 31.1L1.5 495.8l7.4-31.1 104-440L118.7 0zm27.9 160L352 160l0-96L169.3 64l-22.7 96zM384 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faPrescription = {
  prefix: 'fass',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M32 0L0 0 0 32 0 192l0 96 0 32 64 0 0-32 0-64 50.7 0 128 128-89.4 89.4L130.7 464 176 509.3l22.6-22.6L288 397.3l89.4 89.4L400 509.3 445.3 464l-22.6-22.6L333.3 352l89.4-89.4L445.3 240 400 194.7l-22.6 22.6L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0L32 0zM176 160L64 160l0-96 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
};
const faShop = {
  prefix: 'fass',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M0 192l640 0 0-64L544 0 96 0 0 128l0 64zM64 384l0 128 320 0 0-128 0-160-64 0 0 160-192 0 0-160-64 0 0 160zM512 512l64 0 0-288-64 0 0 288z"]
};
const faStoreAlt = faShop;
const faFloppyDisk = {
  prefix: 'fass',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 32L0 32 0 64 0 448l0 32 32 0 384 0 32 0 0-32 0-288 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32zM64 96l256 0 0 128L64 224 64 96zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faSave = faFloppyDisk;
const faVihara = {
  prefix: 'fass',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M320 0s96 80 176 80l16 0 0 48-24 0-8 0 0 64 21.3 16c27.7 20.8 61.4 32 96 32l10.7 0 0 48-64 0 0 64 38.4 28.8C599 393.3 619.2 400 640 400l0 48-64 0 0 32 0 32-64 0 0-32 0-32-160 0 0 32 0 32-64 0 0-32 0-32-160 0 0 32 0 32-64 0 0-32 0-32L0 448l0-48c20.8 0 41-6.7 57.6-19.2L96 352l0-64-64 0 0-48 10.7 0c34.6 0 68.3-11.2 96-32L160 192l0-64-8 0-24 0 0-48 16 0C224 80 320 0 320 0zM160 352l320 0 0-64-320 0 0 64zM416 128l-72 0-24 0-24 0-72 0 0 64 192 0 0-64z"]
};
const faFaceKissClosedEyes = {
  prefix: 'fass',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448l-3.9-15s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0-13.9s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-85.5-76.1c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zm73.6 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z"]
};
const faScaleUnbalanced = {
  prefix: 'fass',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M388.9 39.3l113-37.7 20.2 60.7-125.9 42c-7 22-23.3 39.9-44.2 49L352 448l160 0 32 0 0 64-32 0-192 0-32 0 0-32 0-326.7c-5.1-2.2-9.9-5-14.4-8.2L138.1 190.4l-30.4 10.1L87.5 139.8l30.4-10.1L240.5 88.8c-.3-2.9-.5-5.8-.5-8.8c0-44.2 35.8-80 80-80c29.3 0 55 15.8 68.9 39.3zM112 224l32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0L64 512l-9.9 0-7-7L7 465l-7-7L0 448l0-32 0-5.9 2.7-5.2 88-168L97.5 224l14.5 0zM51.1 416l153.8 0L129.5 272l-3 0L51.1 416zM481.5 96L496 96l32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0-128 0-9.9 0-7-7-40-40-7-7 0-9.9 0-32 0-5.9 2.7-5.2 88-168L481.5 96zm29 48L435.1 288l153.8 0L513.5 144l-3 0z"]
};
const faBalanceScaleLeft = faScaleUnbalanced;
const faFileUser = {
  prefix: 'fass',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96L80 448l32-96 160 0z"]
};
const faUserPoliceTie = {
  prefix: 'fass',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M80 99.2L80 128c16 10.7 67.2 32 144 32s128-21.3 144-32l0-28.8L400 80l0-32L224 0 48 48l0 32L80 99.2zM227 48.6l32 12.8 5 2 0 5.4c0 17.2-7 46.1-36.9 58.6l-3.1 1.3-3.1-1.3C191 114.9 184 86 184 68.8l0-5.4 5-2 32-12.8 3-1.2 3 1.2zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm97.7 296.1L128 352l-80 0L0 512l192 0 64 0 192 0L400 352l-80 0L252.2 464.9 240 416l32-64-96 0 32 64-12.2 48.9zm160.8-50.4l6.1 18.8 19.8 0 14.9 0L385.2 442l-16 11.6 6.2 18.8 4.6 14.1-12-8.8-16-11.7-16 11.7-12 8.8 4.6-14.1 6.2-18.8-16-11.6-12.1-8.7 14.9 0 19.8 0 6.1-18.8 4.6-14.2 4.6 14.2z"]
};
const faFaceTongueMoney = {
  prefix: 'fass',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432l0-13.7c-26-25.5-43.4-59.9-47.2-98.3l318.4 0c-3.8 38.4-21.2 72.7-47.2 98.3l0 13.7c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM192.4 102.6l0 7.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c0 0 0 0 0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.3 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16-32 0 0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c-1.6-.5-3.1-1-4.5-1.4L120 228.3l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16 32 0 0 16zm160-16l0 16 0 7.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c0 0 0 0 0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.4 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16-32 0 0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c0 0 0 0 0 0s0 0 0 0c-1.6-.5-3.1-1-4.5-1.4L280 228.3l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16 32 0zM336 352l-160 0 0 80c0 44.2 35.8 80 80 80s80-35.8 80-80l0-80zm-67.3 16l0 15.6c3.1 .5 6.2 1.2 9 1.9l11.6 2.9-5.8 23.3-11.6-2.9c-5.5-1.4-10.7-2.3-15.3-2.4c-3.5-.1-7.5 .7-10.1 2.1c-1.2 .6-1.6 1.2-1.7 1.3c0 0 0 .1 0 .1s0 .1 0 .3c.2 .2 .8 .6 1.7 1.1c3.1 1.7 7.5 2.9 13.9 4.7l.2 .1s0 0 0 0c5.5 1.6 12.9 3.6 18.8 7.1c6.6 3.9 13.2 10.6 13.5 21.4c.3 12.1-6.4 20.1-14.3 24.4c-3.1 1.7-6.4 2.9-9.7 3.6l0 16.6-24 0 0-17c-4.6-1-9-2.4-12.7-3.6c-1-.3-2-.7-3-.9l-11.5-3.6 7.1-22.9 11.5 3.6c1.2 .4 2.4 .8 3.5 1.1c0 0 0 0 0 0s0 0 0 0c6.9 2.2 12 3.8 17.3 3.9c3.8 .1 7.6-.6 9.9-1.9c1-.6 1.4-1 1.5-1.2c.1-.1 .3-.4 .2-1.4l0-.1c-.1-.1-.5-.6-1.7-1.3c-2.9-1.7-7.1-3-13.4-4.8l-1.1-.3s0 0 0 0c-5.3-1.5-12.1-3.4-17.7-6.4c-6.3-3.4-13.6-9.6-14.2-20.4c-.8-12.5 6.7-20.6 14.4-24.7c3.1-1.6 6.4-2.8 9.6-3.6l0-15.8 24 0z"]
};
const faTennisBall = {
  prefix: 'fass',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M.2 245.1C.1 248.7 0 252.3 0 256C0 397.4 114.6 512 256 512c3.7 0 7.3-.1 10.9-.2c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c.2-3.6 .2-7.2 .2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3 .1-10.9 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zM445.4 293.4c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6c101.9-19.8 182.2-100.2 202.1-202.1c-19.6-8.1-40.6-12.1-61.9-11.8z"]
};
const faSquareL = {
  prefix: 'fass',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M448 32L0 32 0 480l448 0 0-448zM176 152l0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24 48 0 0 24z"]
};
const faSortUp = {
  prefix: 'fass',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M0 176L160 32 320 176v48H0V176z"]
};
const faSortAsc = faSortUp;
const faCalendarArrowUp = {
  prefix: 'fass',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM248 424l0-102.1 39 39 17 17L337.9 344l-17-17-80-80-17-17-17 17-80 80-17 17L144 377.9l17-17 39-39L200 424l0 24 48 0 0-24z"]
};
const faCalendarUpload = faCalendarArrowUp;
const faCommentDots = {
  prefix: 'fass',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM128 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCommenting = faCommentDots;
const faPlantWilt = {
  prefix: 'fass',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56l0 13c-29.3 10-48 34.5-48 70.1c0 29.3 35.8 79.4 80 116.9c44.2-37.5 80-88 80-116.9c0-35.6-18.7-60.2-48-70.1l0-13C464 53.7 410.3 0 344 0S224 53.7 224 120l0 21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120l0 13c-29.3 10-48 34.5-48 70.1C0 360.4 35.8 410.5 80 448c44.2-37.5 80-88 80-116.9c0-35.6-18.7-60.2-48-70.1l0-13c0-30.9 25.1-56 56-56s56 25.1 56 56l0 32 0 200 0 32 64 0 0-32 0-200 0-32 0-128z"]
};
const faScarf = {
  prefix: 'fass',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M184 0l-8.7 0-4.7 7.3-72 112-2.5 4 0 4.7 0 80 0 6.6 4.7 4.7 176 176 112 112 22.6-22.6L310.6 384 336 358.6 436.7 459.3l22.6-22.6L358.6 336 384 310.6 484.7 411.3l22.6-22.6-112-112L384 265.4l-9.4-9.4L256 137.4 214.6 96 256 96l41.4 0-18.7 18.7L397.3 233.4l14.1-14.1 4.7-4.7 0-6.6 0-80 0-4.7-2.5-4-72-112L336.7 0 328 0 184 0zM4.7 388.7l22.6 22.6 112-112-22.6-22.6-112 112zm48 48l22.6 22.6 112-112-22.6-22.6-112 112zm48 48l22.6 22.6 112-112-22.6-22.6-112 112z"]
};
const faAlbumCirclePlus = {
  prefix: 'fass',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M0 32l448 0 0 160.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4L0 480 0 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faUserNurseHairLong = {
  prefix: 'fass',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 48l0 80 .3 0c-.2 2.6-.3 5.3-.3 8l0 24 0 16s0 0 0 0l0 48L48 272l0 32 176 0 176 0 0-32-48-48 0-48 0-16 0-24c0-2.7-.1-5.4-.3-8l.3 0 0-80L224 0 96 48zm48 128l64 0 32-32 16 16 48 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80zM208 40l32 0 0 24 24 0 0 32-24 0 0 24-32 0 0-24-24 0 0-32 24 0 0-24zm16 384l-82.8-88L64 336 0 512l448 0L384 336l-77.2 0L224 424z"]
};
const faDiamond = {
  prefix: 'fass',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M0 256L256 0 512 256 256 512 0 256z"]
};
const faSquareLeft = {
  prefix: 'fass',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M0 32L0 480l448 0 0-448L0 32zm224 96l0 80 128 0 0 96-128 0 0 80-16 0L80 256 208 128l16 0z"]
};
const faArrowAltSquareLeft = faSquareLeft;
const faFaceGrinSquint = {
  prefix: 'fass',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zM112 144l118.9 64L112 272l45.7-64L112 144zm169.1 64L400 144l-45.7 64L400 272 281.1 208z"]
};
const faGrinSquint = faFaceGrinSquint;
const faCircleEllipsisVertical = {
  prefix: 'fass',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320l-64 0 0-64 64 0 0 64zm0 192l-64 0 0-64 64 0 0 64zm0-160l0 64-64 0 0-64 64 0z"]
};
const faHandHoldingDollar = {
  prefix: 'fass',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 32l0-24L264 8l0 24 0 2.8c-4.7 1.2-9.3 2.7-13.6 4.7c-15.8 7.2-30 20.7-33.4 40.7c-1.9 10.9-.9 21.6 3.7 31.4c4.5 9.6 11.6 16.3 18.7 21.1c12.1 8.2 28 13 39.6 16.5l2.3 .7c14.1 4.3 22.8 7.3 28.1 11.1c2 1.5 2.4 2.3 2.4 2.4c0 0 0 0 0 0c0 .1 .1 .3 .2 .9c.1 .6 .1 1.7-.2 3.5c-.3 1.9-1.2 3.9-5.6 5.8c-5.2 2.2-14.3 3.5-26.6 1.6c-5.7-.9-15.9-4.4-25.4-7.6c0 0 0 0 0 0c-2.3-.8-4.5-1.5-6.6-2.2l-22.8-7.6-15.2 45.5 22.8 7.6c1.1 .4 2.6 .9 4.2 1.4c0 0 0 0 0 0s0 0 0 0c7 2.4 18 6.2 27.3 8.5l0 3.2 0 24 48 0 0-24 0-2.2c4.5-1 8.9-2.4 13-4.2c16.7-7.2 30.5-21.1 34-41.7c1.9-11 1.1-21.8-3.2-31.7c-4.3-9.8-11.1-16.9-18.2-22.1c-12.7-9.2-29.4-14.3-41.4-17.9l-1-.3c-14.4-4.3-23.3-7.2-28.8-10.9c-1.5-1-2.1-1.7-2.2-1.9c-.1-.3-.1-1.1 .2-2.7c0 0 0 0 0 0c.1-.3 .5-2.6 5.9-5.1c5.6-2.5 14.7-4.1 26.4-2.3c4.3 .7 17.6 3.3 21.3 4.3L341 91.4 353.4 45l-23.2-6.2c-3.9-1-11.8-2.6-18.2-3.9l0-2.9zM264.1 91.1l0-.1c0 .1 0 .1 0 .1s0 0 0 0zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faHandHoldingUsd = faHandHoldingDollar;
const faGridDividers = {
  prefix: 'fass',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 0L512 0l0 48L0 48 0 0zM160 96l0 128L32 224 32 96l128 0zm0 288l0 128L32 512l0-128 128 0zM192 96l128 0 0 128-128 0 0-128zM320 384l0 128-128 0 0-128 128 0zM352 96l128 0 0 128-128 0 0-128zM480 384l0 128-128 0 0-128 128 0zm32-96l0 48L0 336l0-48 512 0z"]
};
const faBacterium = {
  prefix: 'fass',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M422.8 39.6l7.6-22.8L384.8 1.6l-7.6 22.8-2.6 7.8c-10.4-.6-21.1 .2-31.8 2.7c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7L292.6 8.5 248.5 27.4l9.5 22.1 4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7l-13.3-20L142.7 89.3l13.3 20 7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3l-18.7-15-30 37.5 18.7 15 15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9-22.3-8.9L8.8 293.4l22.3 8.9 11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7c0 0 0 0 0 0l-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2-23.1 6.6L7.5 429.7l23.1-6.6 13.8-3.9C54.7 439.3 71 456 91.1 466.8l-1.9 5.6-7.6 22.8 45.5 15.2 7.6-22.8 2.6-7.8c24.5 1.5 47.7-5.1 67-17.5L215 473l17 17L265.9 456l-17-17-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4 22.1 9.5 18.9-44.1-22.1-9.5-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5 6.6 23.1 46.2-13.2-6.6-23.1L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249l17 17L489.9 232l-17-17-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2 23.1-6.6L504.5 82.3l-23.1 6.6-13.7 3.9c-10.5-20.6-27-37-46.8-47.6l1.9-5.7zM99.2 363.9s0 0 0 0L144 368l-44.8-4.1zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHandPointer = {
  prefix: 'fass',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M128 0l80 0 0 176 80 0 0 32 80 0 0 32 80 0 0 80 0 48 0 16c0 70.7-57.3 128-128 128l-16 0-64 0-.1 0-5.2 0c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L24.1 357.4l-24-32 64-48 24 32L128 362.7 128 0zM240 304l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm64-16l-32 0 0 16 0 96 0 16 32 0 0-16 0-96 0-16zm64 16l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96z"]
};
const faDrumSteelpan = {
  prefix: 'fass',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M473 209.8c-22.2 9.4-49.7 17-81 22.2L353.9 176l57.4-84.3c23.4 4.9 44.2 11.2 61.7 18.6c47.1 19.9 55 39.9 55 49.8s-8 29.9-55 49.8zM340.7 238.1c-16.9 1.3-34.5 1.9-52.7 1.9s-35.8-.7-52.7-1.9L249.9 192l76.2 0 14.6 46.1zm-156.6-6.1c-31.4-5.2-58.8-12.8-81-22.2C56 189.9 48 169.9 48 160s8-29.9 55-49.8c17.5-7.4 38.3-13.7 61.7-18.6L222.1 176l-38 55.9zM225.5 82.8C245.3 81 266.2 80 288 80s42.7 1 62.5 2.8L326.1 160l-76.2 0L225.5 82.8zM576 160C576 80 447.1 32 288 32S0 80 0 160L0 352c0 80 128.9 128 288 128s288-48 288-128l0-192z"]
};
const faHandScissors = {
  prefix: 'fass',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M40 208L0 208l0 80 40 0 168 0 0 80 32 0 0 80 80 0 48 0 16 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L288 64l0 32.3 76.9 24.5 15.2 4.9-9.7 30.5-15.2-4.9L288 129.9c0 0 0 .1 0 .1L108 73.4l-38.2-12-24 76.3 38.2 12L269.5 208 40 208z"]
};
const faHandsPraying = {
  prefix: 'fass',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M117 206.8L245 6.8l55 32.6L208 208.2 208 320l32 0 0-112 64 0 0 112 0 112L48 512 0 512 0 368l112-42 0-102 0-9.4 5-7.9zm405.9 0l5 7.9 0 9.4 0 102 112 42 0 144-48 0L336 432l0-112 0-112 64 0 0 112 32 0 0-111.8L339.9 39.3 395 6.8l128 200z"]
};
const faPrayingHands = faHandsPraying;
const faFacePensive = {
  prefix: 'fass',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 384l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM72.8 193.7l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18 25 20-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3 72.8 193.7zm236 72.7c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zm-105.6 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm213.1-84.1l22.9 11.4-14.3 28.6L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18 25-20 14.4 18c10.1 12.7 22.9 23 37.4 30.2z"]
};
const faUserMusic = {
  prefix: 'fass',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zm64 463.8c0 19.1 7.8 35.6 19.1 48.2L0 512 64 304l304 0 0 80.9c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5zM640 152l0 33.3 0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48 0 150.7c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-121.5 0-48 0-17.3 16.4-5.5 192-64L640 152z"]
};
const faArrowRotateRight = {
  prefix: 'fass',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M464 224l32 0 0-32 0-128 0-32-64 0 0 32 0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0l-45.3-45.3c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160 336 160l-32 0 0 64 32 0 128 0z"]
};
const faArrowRightRotate = faArrowRotateRight;
const faArrowRotateForward = faArrowRotateRight;
const faRedo = faArrowRotateRight;
const faMessagesDollar = {
  prefix: 'fass',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M416 0L0 0 0 320l96 0 0 64 106.7-64L416 320 416 0zM256 352l0 96 181.3 0L544 512l0-64 96 0 0-320-192 0 0 224-192 0zM228 64l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c0 0 0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z"]
};
const faCommentsAltDollar = faMessagesDollar;
const faSensorOn = {
  prefix: 'fass',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M0 32l448 0 0 448L0 480 0 32zM112 96L64 96l0 24 0 144 0 24 48 0 0-24 0-144 0-24zm96 0l-48 0 0 24 0 144 0 24 48 0 0-24 0-144 0-24zm389.3 12l-48 32-20 13.3-26.6-39.9 20-13.3 48-32 20-13.3 26.6 39.9-20 13.3zM536 232l80 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm13.3 140l48 32 20 13.3-26.6 39.9-20-13.3-48-32-20-13.3 26.6-39.9 20 13.3z"]
};
const faBalloon = {
  prefix: 'fass',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M0 192C0 86 86 0 192 0S384 86 384 192c0 128-160 240-160 240l32 80-128 0 32-80S0 320 0 192zm96 0c0-53 43-96 96-96l0-32C121.3 64 64 121.3 64 192l32 0z"]
};
const faWebAwesome = {
  prefix: 'fass',
  iconName: 'web-awesome',
  icon: [640, 512, [], "e682", "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l104.4-20.9c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48L464 480l-288 0L46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52z"]
};
const faBiohazard = {
  prefix: 'fass',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M167.2 3.2C138 33.4 120 74.6 120 120c0 26.1 6 50.8 16.6 72.9c-22.4 2.3-44.6 9-65.3 20.6c-33.7 18.8-58 47.3-71.3 79.7c57.1-48 153.9-53.7 204.4 30.8s-2.9 162.6-74.6 186.3c35.7 5.1 73.5-.9 107.2-19.7c20.6-11.5 37.7-26.6 50.9-44c13.2 17.4 30.3 32.6 50.9 44c33.7 18.8 71.5 24.8 107.2 19.7C374.5 486.6 321 408.6 371.6 324s147.4-78.8 204.4-30.8c-13.3-32.4-37.6-60.9-71.3-79.7c-20.7-11.5-43-18.3-65.3-20.6C450 170.8 456 146.1 456 120c0-45.4-18-86.6-47.2-116.8C433.9 77.9 393.6 176 288 176S142.1 77.9 167.2 3.2zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM288 64c-32.2 0-62.6 7.3-89.8 20.3c2.1 5.9 4.8 11.6 7.9 16.9c8.3 13.9 20.5 26 37.3 33.8c14-4.6 29-7 44.6-7s30.6 2.5 44.6 7c16.8-7.7 29-19.8 37.3-33.8c3.2-5.3 5.8-11 7.9-16.9C350.6 71.3 320.2 64 288 64zM191.4 378.8c-20.5-18.6-35.6-42.9-42.8-70.5c-14.6-10.8-30.6-16.1-46.6-17.5c-7-.6-14.1-.4-21.1 .5c5.9 63.9 40.7 119.5 91.2 153.5c4.8-5.8 8.9-12.1 12.1-18.7c6.6-13.7 9.9-29.6 7.2-47.2zm303.7-87.5c-7-.9-14.1-1-21.1-.5c-16 1.3-32.1 6.7-46.6 17.5c-7.2 27.6-22.3 52-42.8 70.5c-2.7 17.6 .6 33.5 7.2 47.2c3.2 6.6 7.3 12.9 12.1 18.7c50.5-34 85.3-89.5 91.2-153.5z"]
};
const faChessQueenPiece = {
  prefix: 'fass',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M152 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM48 416l-4.1 0-2.4 3.4-40 56L0 477.4 0 480l0 24 0 8 8 0 240 0 8 0 0-8 0-24 0-2.6-1.5-2.1-40-56-2.4-3.4-4.1 0L48 416zM66.5 192L48 192l0 48 24 0 5.1 0L59.8 384l136.3 0L178.9 240l5.1 0 24 0 0-48-18.5 0L240 92 219 78l-4.6 4.6c-6 6-14.5 10.3-22.3 7.1c-11-4.5-15-15.1-15-25.7l-28 0s0 21-21 21s-21-21-21-21L79 64c0 10.6-4 21.2-15 25.7c-7.8 3.2-16.3-1.1-22.3-7.1L37 78 16 92 66.5 192z"]
};
const faChessQueenAlt = faChessQueenPiece;
const faLocationCrosshairs = {
  prefix: 'fass',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M288 0l0 32 0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0 32 0 0 64-32 0-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7 0 32-64 0 0-32 0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288 0 288l0-64 32 0 34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32l0-32 64 0zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faLocation = faLocationCrosshairs;
const faMarsDouble = {
  prefix: 'fass',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M320 32l128 0 0 128-32 32-41.4-41.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l53.6-53.6L288 64l32-32zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm16 164c18.9-14.8 35.2-32.8 48.1-53.1c5.2 .7 10.6 1.1 16 1.1c61.9 0 112-50.1 112-112c0-35.7-16.7-67.5-42.7-88L480 173.3l0-26.5 41.4-41.4L480 64l32-32 128 0 0 128-32 32-41.4-41.4L513 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12z"]
};
const faLeftFromBracket = {
  prefix: 'fass',
  iconName: 'left-from-bracket',
  icon: [512, 512, [], "e66c", "M160 416L0 256 160 96l32 0 0 96 160 0 0 128-160 0 0 96-32 0zm192 0l96 0 0-320-96 0-32 0 0-64 32 0 128 0 32 0 0 32 0 384 0 32-32 0-128 0-32 0 0-64 32 0z"]
};
const faHousePersonLeave = {
  prefix: 'fass',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M375.7 117.6L240 0 0 208l0 48 64 0 0 160 253.5 0 44-44L384 315.7l3.9-9.7-9.7-3.2-60.7-20.2L287 272.5l10.1-30.4 30.6-91.7 4.5-13.4 12.9-5.7 30.6-13.6zM128 192l96 0 0 96-96 0 0-96zM528 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-75.7 30.6l-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-10.1 30.4 60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2zm-38.6 209l-25 62.4-43.4 43.4L322.7 464 368 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"]
};
const faHouseLeave = faHousePersonLeave;
const faHousePersonDepart = faHousePersonLeave;
const faRulerTriangle = {
  prefix: 'fass',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M0 0L0 512l512 0 0-48-60.7-60.7-24 24L416 438.6 393.4 416l11.3-11.3 24-24-57.4-57.4-24 24L336 358.6 313.4 336l11.3-11.3 24-24-57.4-57.4-24 24L256 278.6 233.4 256l11.3-11.3 24-24-57.4-57.4-24 24L176 198.6 153.4 176l11.3-11.3 24-24L131.3 83.3l-24 24L96 118.6 73.4 96 84.7 84.7l24-24L48 0 0 0zM128 256L256 384l-128 0 0-128z"]
};
const faCardClub = {
  prefix: 'fass',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M384 0L0 0 0 512l384 0L384 0zM256 192c0 5.6-.7 11.1-2.1 16.3c28.2 2.9 50.1 26.8 50.1 55.7c0 30.9-25.1 56-56 56c-15.7 0-29.8-6.4-40-16.8l0 32.8 16 0 16 0 0 32-16 0-16 0-32 0-16 0-16 0 0-32 16 0 16 0 0-32.8c-10.2 10.4-24.3 16.8-40 16.8c-30.9 0-56-25.1-56-56c0-28.9 21.9-52.7 50.1-55.7c-1.4-5.2-2.1-10.7-2.1-16.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
const faChildDress = {
  prefix: 'fass',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm4.9 96l16 0 86.2 0 16 0 9.6 12.8 72.1 96L320 294.4l-51.2 38.4-19.2-25.6-15.3-20.4L272 400l-40 0 0 80 0 32-64 0 0-32 0-80-16 0 0 80 0 32-64 0 0-32 0-80-40 0L85.7 286.8 70.4 307.2 51.2 332.8 0 294.4l19.2-25.6 72.1-96 9.6-12.8z"]
};
const faUsersBetweenLines = {
  prefix: 'fass',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M0 0L0 48l24 0 592 0 24 0 0-48L616 0 24 0 0 0zM0 464l0 48 24 0 592 0 24 0 0-48-24 0L24 464 0 464zM211.2 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 256L32 352l135.4 0 28.2-75.2 7.8-20.8L64 256zm411.8 96L608 352l-32-96-136.2 0 7.8 20.8L475.8 352zm-10.2 64l-24-64-24-64-12.3 0-170.7 0-9.1 0-24 64-24 64 288 0zm97.6-256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faLungsVirus = {
  prefix: 'fass',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M352 32l0 32 0 80-64 0 0-80 0-32 0-32 64 0 0 32zm-96 96l0 60.1-26.5-26.5-67.9 67.9 32.7 32.7c3.6 3.6 1.1 9.8-4.1 9.8L144 272l0 96 46.2 0c5.1 0 7.7 6.2 4.1 9.8l-32.7 32.7 68.9 68.9-119.9 30c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c8.8-70.6 45.5-147.2 78-203.9c16.5-28.9 32.4-53.6 44.3-71.1c5.9-8.8 10.8-15.7 14.3-20.6c1.7-2.4 3.1-4.3 4.1-5.6l1.1-1.5 .3-.4 .1-.1c0 0 0 0 0 0c0 0 0 0 0 0L168 128l-25.6-19.2L152 96l16 0 56 0 32 0 0 32zM529.4 509.3l-119.9-30 68.9-68.9-32.7-32.7c-3.6-3.6-1.1-9.8 4.1-9.8l46.2 0 0-96-46.2 0c-5.1 0-7.7-6.2-4.1-9.8l32.7-32.7-67.9-67.9L384 188.1l0-60.1 0-32 32 0 56 0 16 0 9.6 12.8L472 128c25.6-19.2 25.6-19.2 25.6-19.2s0 0 0 0c0 0 0 0 0 0l.1 .1 .3 .4 1.1 1.5c1 1.3 2.3 3.2 4.1 5.6c3.5 4.8 8.4 11.8 14.3 20.6c11.8 17.5 27.8 42.2 44.3 71.1c32.4 56.7 69.1 133.3 78 203.9c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7zM410.5 206.9l11.3 11.3 11.3 11.3-11.3 11.3C398.5 264.1 415 304 448 304l16 0 0 16 0 16-16 0c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C375.9 398.5 336 415 336 448l0 16-16 0-16 0 0-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-11.3-11.3s0 0 0 0l-11.3-11.3 11.3-11.3C241.5 375.9 225 336 192 336l-16 0 0-16 0-16 16 0c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 11.3-11.3s0 0 0 0l11.3-11.3 11.3 11.3C264.1 241.5 304 225 304 192l0-16 16 0 16 0 0 16c0 33 39.9 49.5 63.2 26.2l11.3-11.3zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faSpinnerThird = {
  prefix: 'fass',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z"]
};
const faFaceGrinTears = {
  prefix: 'fass',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M576 254.5c-2.3-.5-4.6-.9-6.9-1.3c-13.2-2.4-25.4-4.1-33.1-5.1c1.1 7.6 2.8 19.9 5.3 33.1c4.3 23.1 10.8 48.9 19.5 57.7c.4 .4 .7 .7 1.1 1.1c17.9 16.8 46.4 16.1 64.2-1.8c18.2-18.3 18.6-47.6 .7-65.6c-7.9-7.9-29.7-13.9-50.8-18zM549 370.5c-3.8-2.6-7.5-5.7-10.9-9.1c-8.7-8.7-13.7-20.5-16.6-28.7c-3.4-9.3-6.2-19.8-8.4-29.6c-4.4-19.7-7.4-40.1-8.8-50.6l-5.9-42 42 5.8 .1 0c7.4 1 19.7 2.7 33.2 5.1C556.8 96.4 449.7 0 320 0S83.2 96.4 66.3 221.5c13.5-2.4 25.8-4.1 33.2-5.1l.1 0 42-5.8-5.9 42c-1.5 10.5-4.4 30.9-8.8 50.6c-2.2 9.8-5 20.3-8.4 29.6c-3 8.2-8 20-16.6 28.7c-3.4 3.4-7.1 6.5-10.9 9.1C133 454.4 219.8 512 320 512s187-57.6 229-141.5zM78 339.8s0 0 0 0c.4-.4 .8-.7 1.1-1.1c8.7-8.8 15.2-34.6 19.5-57.7c2.5-13.2 4.2-25.4 5.3-33.1c0 0 0 0 0 0s0 0 0 0c-21 2.9-77.1 10.7-90.8 24.5c-17.9 18-17.5 47.3 .7 65.6C31.7 356 60.1 356.7 78 339.8zm242.2-8.1c59.1 0 114.1-10.6 160.2-29C464.3 376.7 398.7 432 320.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zM240 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faGrinTears = faFaceGrinTears;
const faPhone = {
  prefix: 'fass',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448C200.6 512 0 311.4 0 64L0 32z"]
};
const faComputerMouseScrollwheel = {
  prefix: 'fass',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M384 0L0 0 0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160L384 0zM224 128l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32z"]
};
const faMouseAlt = faComputerMouseScrollwheel;
const faCalendarXmark = {
  prefix: 'fass',
  iconName: 'calendar-xmark',
  icon: [448, 512, ["calendar-times"], "f273", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM305 305l17-17L288 254.1l-17 17-47 47-47-47-17-17L126.1 288l17 17 47 47-47 47-17 17L160 449.9l17-17 47-47 47 47 17 17L321.9 416l-17-17-47-47 47-47z"]
};
const faCalendarTimes = faCalendarXmark;
const faChildReaching = {
  prefix: 'fass',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M192 0a64 64 0 1 1 0 128A64 64 0 1 1 192 0zM176 384l0 96 0 32-64 0 0-32 0-241.2-8.6-10.3-80-96L2.9 107.9l49.2-41L72.6 91.5 143 176l1 0 96 0 2.3 0 68.9-84.3L331.5 67 381 107.5l-20.3 24.8-78.5 96L272.7 240l-.7 0 0 240 0 32-64 0 0-32 0-96-32 0z"]
};
const faTableLayout = {
  prefix: 'fass',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M512 32L0 32 0 480l512 0 0-448zM448 96l0 64L64 160l0-64 384 0zM64 224l64 0 0 192-64 0 0-192zm384 0l0 192-256 0 0-192 256 0z"]
};
const faNarwhal = {
  prefix: 'fass',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M640 336c0-49-20.2-93.2-52.7-125.2L640 0 511.7 166.8c-15.5-4.4-31.8-6.8-48.6-6.8c-50.9 0-100.7 17.5-140.2 49.6L128 368l0-112 64-32 0-128L96 144 0 96 0 224l64 32 0 96c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faRampLoading = {
  prefix: 'fass',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M32 0L64 0 384 0l32 0 0 32 0 408.4-64-128L352 64 96 64l0 248.4-64 128L32 32 32 0zM352 384l52.4 104.8L416 512l-25.9 0-6.1 0L64 512l-6.1 0L32 512l11.6-23.2L96 384l32-64 192 0 32 64z"]
};
const faCalendarCirclePlus = {
  prefix: 'fass',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M160 0L96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64zm96 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 512l330.8 0C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16z"]
};
const faToothbrush = {
  prefix: 'fass',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M0 160c0-35.3 28.7-64 64-64l224 0c37.7 0 40-33.2 40-64c57.4 0 120 31.6 120 96c0 53-43 96-96 96L64 224 0 224l0-64zm80 96l0 24 0 136 32 0 0-136 0-24 48 0 0 24 0 136 32 0 0-136 0-24 48 0 0 24 0 136 32 0 0-136 0-24 48 0 0 24 0 136 32 0 0-136 0-24 48 0 0 24 0 136 144 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0 0-136 0-24 48 0z"]
};
const faBorderInner = {
  prefix: 'fass',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M0 416l64 0 0 64L0 480l0-64zm96 0l64 0 0 64-64 0 0-64zM96 32l64 0 0 64L96 96l0-64zM352 480l-64 0 0-64 64 0 0 64zm0-448l0 64-64 0 0-64 64 0zm96 448l-64 0 0-64 64 0 0 64zM0 32l64 0 0 64L0 96 0 32zM384 384l0-64 64 0 0 64-64 0zm0-288l0-64 64 0 0 64-64 0zM0 320l64 0 0 64L0 384l0-64zM384 192l0-64 64 0 0 64-64 0zM0 128l64 0 0 64L0 192l0-64zm0 96l32 0 160 0 0-160 0-32 64 0 0 32 0 160 160 0 32 0 0 64-32 0-160 0 0 160 0 32-64 0 0-32 0-160L32 288 0 288l0-64z"]
};
const faPawClaws = {
  prefix: 'fass',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M373.1 58.4L320 0l0 71.2c-18.3 9.8-34.3 28.9-42.5 53.6c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0 0 0 0 0 0c0-25.7-9.6-50.6-26.9-69.6zM64 196.8L64 128 12.2 199.2C4.3 210.1 0 223.3 0 236.8L0 240s0 0 0 0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1C91.1 214.7 77.9 203 64 196.8zm384 0c-13.9 6.1-27.1 17.8-36.4 33.7c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4c0 0 0 0 0 0l0-3.2c0-13.5-4.3-26.7-12.2-37.6L448 128l0 68.8zM192 0L138.9 58.4C121.6 77.4 112 102.3 112 128c0 0 0 0 0 0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2L192 0zm64 256c-64 0-192 80-192 256l192-48 192 48c0-176-128-256-192-256z"]
};
const faKiwiFruit = {
  prefix: 'fass',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176S100.3 32 224 32s224 64.5 224 144zM224 64l-16 0 0 16 0 24 0 16 16 0 16 0 0-16 0-24 0-16-16 0zM64 176l0 16 16 0 32 0 16 0 0-16 0-16-16 0-32 0-16 0 0 16zm256 0l0 16 16 0 32 0 16 0 0-16 0-16-16 0-32 0-16 0 0 16zm-96 56l-16 0 0 16 0 24 0 16 16 0 16 0 0-16 0-24 0-16-16 0zM139.3 92.7L128 81.4 105.4 104l11.3 11.3 8 8L136 134.6 158.6 112l-11.3-11.3-8-8zm192 22.6L342.6 104 320 81.4 308.7 92.7l-8 8L289.4 112 312 134.6l11.3-11.3 8-8zm-184 136L158.6 240 136 217.4l-11.3 11.3-8 8L105.4 248 128 270.6l11.3-11.3 8-8zm176-22.6L312 217.4 289.4 240l11.3 11.3 8 8L320 270.6 342.6 248l-11.3-11.3-8-8zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24zM224 480C102.4 480 3.4 383.1 .1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480z"]
};
const faTrafficLightSlow = {
  prefix: 'fass',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM136 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-128a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faRectangleCode = {
  prefix: 'fass',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M512 32L0 32 0 480l512 0 0-448zM209 209l-47 47 47 47 17 17L192 353.9l-17-17-64-64-17-17 17-17 64-64 17-17L225.9 192l-17 17zM337 175l64 64 17 17-17 17-64 64-17 17L286.1 320l17-17 47-47-47-47-17-17L320 158.1l17 17z"]
};
const faHeadSideVirus = {
  prefix: 'fass',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM314.5 94.9l-11.3 11.3C279.9 129.5 240 113 240 80l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2L133.5 94.9l-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C145.5 152.1 129 192 96 192l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C168.1 286.5 208 303 208 336l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C302.5 263.9 319 224 352 224l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3L314.5 94.9zM200 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faKeyboardBrightness = {
  prefix: 'fass',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M352 64l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zM112 130.7l22.6 22.6 64 64L221.3 240 176 285.3l-22.6-22.6-64-64L66.7 176 112 130.7zM573.3 176l-22.6 22.6-64 64L464 285.3 418.7 240l22.6-22.6 64-64L528 130.7 573.3 176zM0 352l32 0 64 0 32 0 0 64-32 0-64 0L0 416l0-64zm192 0l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64zm320 64l0-64 32 0 64 0 32 0 0 64-32 0-64 0-32 0z"]
};
const faBooksMedical = {
  prefix: 'fass',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M419.4 398.3L384 268.3l0-125.5 93.7-25.1 67.2 247L419.4 398.3zM469.3 86.8L384 109.6l0-93.4L445.7 0l23.6 86.8zM427.8 429.2l125.5-33.6L576 478.9 450.3 512l-22.5-82.8zM64 0L192 0l0 96L64 96 64 0zm0 416l128 0 0 96L64 512l0-96zM224 0L352 0l0 96L224 96l0-96zm0 128l128 0 0 256-128 0 0-256zm0 288l128 0 0 96-128 0 0-96zM64 160l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64L0 288l0-64 64 0 0-64z"]
};
const faLightbulbSlash = {
  prefix: 'fass',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l108.1 0L152.4 229.8zM240 416l0 96 160 0 0-87.1L388.7 416 240 416zM160.4 101.7l-112-87L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L436.2 315.9c4.3-6.1 8.7-12.1 13.1-18.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.3 0 188.4 41.7 160.4 101.7zm52.7 40.9C227.3 97.1 269.8 64 320 64l0 32c-40.2 0-73.4 29.6-79.1 68.2l-27.8-21.6z"]
};
const faHouseBlank = {
  prefix: 'fass',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M576 287.6H511.8l1 224.4H64.1V287.6H0V240L288.4 0 576 240v47.6z"]
};
const faHomeBlank = faHouseBlank;
const faSquare5 = {
  prefix: 'fass',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M448 32L0 32 0 480l448 0 0-448zM176 128l104 0 24 0 0 48-24 0-82.1 0L194 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L142 261.1l2.1-23.2 8-88 2-21.8 21.9 0z"]
};
const faSquareHeart = {
  prefix: 'fass',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M448 32L0 32 0 480l448 0 0-448zM103.2 287.1c-14.9-14.9-23.2-35-23.2-56l0-3.6c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L320 311.9l-96 96-96-96-24.8-24.8z"]
};
const faHeartSquare = faSquareHeart;
const faPuzzle = {
  prefix: 'fass',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M304 0L512 0l0 208-80 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-64 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-80zM0 272L0 64l208 0 0 64 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 80-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 272zM0 512L0 304l208 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 80L0 512zM240 304l64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 80 0 0 208-208 0 0-208z"]
};
const faUserGear = {
  prefix: 'fass',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM404 484.3l0 27.7L0 512 64 304l241.4 0-15.5 26.9L326 351.7l-36.1 20.8 77 133.2L404 484.3zm32-277.9l88.1 0 0 42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8l0 42.4L436 497l0-42.2c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9l0-42.2zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
const faUserCog = faUserGear;
const faPipeCircleCheck = {
  prefix: 'fass',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M64 96l0 32 0 256 0 32L0 416l0-32L0 128 0 96l64 0zm448 0l0 32 0 64.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6l0-70.6 0-32 64 0zM320 368c0 5.4 .2 10.7 .7 16L96 384l0-256 320 0 0 83.2c-57 29.1-96 88.4-96 156.8zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z"]
};
const faArrowUp19 = {
  prefix: 'fass',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M352 32l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64zm-192 .6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6zM432 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88-32c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L453.5 480l-74.9 0 10.1-16.6 25.1-41.3C373.9 413.7 344 378.3 344 336z"]
};
const faSortNumericUp = faArrowUp19;
const faOctagonExclamation = {
  prefix: 'fass',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zm280-32l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 320l48 0 0 48-48 0 0-48z"]
};
const faDialLow = {
  prefix: 'fass',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zM287.6 447.6c-80.2 0-146.6-59-158.2-136l158.2 0 24 0 0-48-24 0-158.2 0c11.6-77 78-136 158.2-136c88.4 0 160 71.6 160 160s-71.6 160-160 160z"]
};
const faDoorClosed = {
  prefix: 'fass',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M96 0L480 0l0 448 64 0 32 0 0 64-32 0-64 0L96 512l-64 0L0 512l0-64 32 0 64 0L96 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faLaptopMobile = {
  prefix: 'fass',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M96 0L64 0l0 32 0 256L0 288l0 48 48 48 304 0 0-96-224 0 0-224 320 0 0 32 64 0 0-64 0-32L480 0 96 0zM448 448l0-256 128 0 0 256-128 0zM384 128l0 64 0 256 0 64 64 0 128 0 64 0 0-64 0-256 0-64-64 0-128 0-64 0z"]
};
const faPhoneLaptop = faLaptopMobile;
const faConveyorBeltBoxes = {
  prefix: 'fass',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M64 0L320 0l0 256L64 256 64 0zM384 64l192 0 0 192-192 0 0-192zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faConveyorBeltAlt = faConveyorBeltBoxes;
const faShieldVirus = {
  prefix: 'fass',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zm90.5 137.2l-11.3 11.3C311.9 177.5 272 161 272 128l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C177.5 200.1 161 240 128 240l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C200.1 334.5 240 351 240 384l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C334.5 311.9 351 272 384 272l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3-11.3-11.3zM232 208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faStarfighterTwinIonEngineAdvanced = {
  prefix: 'fass',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M576 148.5L488.5 53.7l47-43.4 96 104 8.5 9.2 0 12.5 0 224 0 11.2-7 8.8L537 500l-50-40 89-111.2 0-54.4L468.4 315.9C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4l0 61.8 88.3 103-48.6 41.7-96-112-7.7-9L0 368 0 144l0-11.8 7.7-9 96-112 48.6 41.7L64 155.8l0 61.8 107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6l0-69.1zM304 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM375.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L382 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM342.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32c0 0 0 0 0 0s0 0 0 0c-17.7 0-32 14.3-32 32c0 17.7 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
const faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
const faDiceSix = {
  prefix: 'fass',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M0 32l448 0 0 448L0 480 0 32zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faStarfighterTwinIonEngine = {
  prefix: 'fass',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M64 32l0 32 0 147.2 75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1L512 211.2 512 64l0-32 64 0 0 32 0 160 0 64 0 160 0 32-64 0 0-32 0-147.2-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8 64 448l0 32L0 480l0-32L0 288l0-64L0 64 0 32l64 0zM272 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L350 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM310.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z"]
};
const faStarfighterAlt = faStarfighterTwinIonEngine;
const faRocketLaunch = {
  prefix: 'fass',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M384 305l0 127L224 512l0-142c0-21.8-8.6-42.6-24-58c-15.3-15.3-36.1-24-57.9-24L0 287.6 80 128l127 0C294.1-15.5 431.8-8.4 502.7 9.3C520.4 80.2 527.5 217.9 384 305zm40-177a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM166.5 470C117 519.5 .5 511.5 .5 511.5s-8-116.5 41.5-166c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-16.5 16.5-13.8 55.2-13.8 55.2s38.7 2.7 55.2-13.8z"]
};
const faMosquitoNet = {
  prefix: 'fass',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M256 242.2l0 23.1-59.3 59.3-4.7 4.7 0 6.6 0 44.2-30.3 60.6-7.2 14.3 28.6 14.3 7.2-14.3 32-64 1.7-3.4 0-3.8 0-41.4 32-32 0 50 0 32 64 0 0-32 0-50 32 32 0-45.3-32-32 0-23.1 32 27.9 0-14.1 32 0 0-32 80 0 16 0 67 0c-11.7-9.9-26.3-16.5-42.4-18.5L344.7 181.6l49.6-41.3 8.4-7-3.5-10.4L385.4 81.6 414 30.2l7.8-14L393.8 .6l-7.8 14L354 72.2l-3.4 6.2 2.2 6.7 12.5 37.6L320 160.5l0-22.6 0-32-23.8 0 0-34.2 0-8.2-16.3 0 0 8.2 0 34.2-23.8 0 0 32 0 22.6-45.4-37.8 12.5-37.6 2.2-6.7L222 72.2 190 14.6l-7.8-14-28 15.5 7.8 14 28.6 51.4-13.8 41.3-3.5 10.4 8.4 7 49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L256 242.2zM362.9 353.5c.4-.5 .9-1 1.3-1.5l-2.8 0 1.5 1.5zM528 256l-32 0 0 16 0 16-48 0 0-16 0-16-32 0 0 16 0 16-16 0-16 0 0 32 16 0 16 0 0 48-16 0-16 0 0 32 16 0 16 0 0 48-16 0-16 0 0 32 16 0 16 0 0 16 0 16 32 0 0-16 0-16 48 0 0 16 0 16 32 0 0-16 0-16 48 0 0 16 0 16 32 0 0-16 0-16 16 0 16 0 0-32-16 0-16 0 0-48 16 0 16 0 0-32-16 0-16 0 0-48 16 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0 0 16 0 16-48 0 0-16 0-16zm0 64l48 0 0 48-48 0 0-48zm0 80l48 0 0 48-48 0 0-48zm-80-80l48 0 0 48-48 0 0-48zm0 80l48 0 0 48-48 0 0-48z"]
};
const faVentDamper = {
  prefix: 'fass',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M64 64l512 0 0 96 64 0 0 192-64 0 0 96L64 448l0-96L0 352 0 160l64 0 0-96zm120 80l-24 0 0 48 24 0 272 0 24 0 0-48-24 0-272 0zm0 88l-24 0 0 48 24 0 272 0 24 0 0-48-24 0-272 0zm0 88l-24 0 0 48 24 0 272 0 24 0 0-48-24 0-272 0z"]
};
const faBridgeWater = {
  prefix: 'fass',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M0 64l576 0 0 96c-53 0-96 43-96 96l0 80-19.7 14.2s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C411.6 378.7 397 383 384 383l0-127c0-53-43-96-96-96s-96 43-96 96l0 127c-13 0-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0s0 0 0 0l-1.1-.8L96 336s0 0 0 0l0-80c0-53-43-96-96-96L0 64zM272.4 461.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 470.1 31.9 480 0 480l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faBanBug = {
  prefix: 'fass',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm89-148.3l19.9 4 15.7 3.1 6.3-31.4-15.7-3.1-35.1-7 0-18.6 35.1-7 15.7-3.1-6.3-31.4-15.7 3.1L336 214.1l0-30.6 16.2-9.7 13.7-8.2L349.5 138l-13.7 8.2-18.4 11.1L288 128l-64 0-25.4 25.4L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3l-15.7 3.1 6.3 31.4 15.7-3.1 28.9-5.8 0 30.6-16.2 9.7L146 346.5 162.5 374l13.7-8.2 18.4-11.1L224 384l64 0 2.7-2.7L175 265.5l-34.1 6.8z"]
};
const faDebug = faBanBug;
const faPersonBooth = {
  prefix: 'fass',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M256 0L192 0l0 32 0 160 64 0 0-160 0-32zM192 480l0 32 64 0 0-32 0-160-64 0 0 160zM576 0L512 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32zM320 0L283.1 0l5.2 36.5 31.2 218.6L288.6 409.7 281 448l39 0 32 0 64 0 32 0 32 0 0-32 0-384 0-32L448 0 320 0zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zM0 160l0 32 0 96 0 10.7s0 0 0 0L0 480l0 32 64 0 0-32 0-96 32 42.7L96 480l0 32 64 0 0-32 0-64 0-10.7-6.4-8.5L112 341.3l0-72.1 9.4 9.4 9.4 9.4 13.3 0 80 0 32 0 0-64-32 0-66.7 0-54.6-54.6L93.3 160 80 160l-48 0L0 160z"]
};
const faTextWidth = {
  prefix: 'fass',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M32 32L0 32 0 64l0 64 0 32 64 0 0-32 0-32 128 0 0 128-32 0 0 64 32 0 64 0 32 0 0-64-32 0 0-128 128 0 0 32 0 32 64 0 0-32 0-64 0-32-32 0L224 32 32 32zM0 384l96 96 32 0 0-64 192 0 0 64 32 0 96-96-96-96-32 0 0 64-192 0 0-64-32 0L0 384z"]
};
const faGarageCar = {
  prefix: 'fass',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M0 512L0 128 320 0 640 128l0 384-96 0 0-320L96 192l0 320L0 512zM224 240l192 0 16.4 0 6 15.3 40 102.2 1.7 4.2 0 4.5 0 25.8 0 24 0 64 0 32-64 0 0-32 0-16-192 0 0 16 0 32-64 0 0-32 0-64 0-24 0-24 0-4.5 1.6-4.2 40-104 5.9-15.4 16.5 0zm194.4 96l-18.8-48-159.1 0L222 336l196.4 0zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faSquareKanban = {
  prefix: 'fass',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M448 32L0 32 0 480l448 0 0-448zM288 384l0-256 64 0 0 256-64 0zM256 256l-64 0 0-128 64 0 0 128zM96 320l0-192 64 0 0 192-64 0z"]
};
const faHatWizard = {
  prefix: 'fass',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M64 416L192 128 416 0 352 192l96 224-217.1 0L248 376l56-24-56-24-24-56-24 56-56 24 56 24 17.1 40L64 416zM256 192l16 32 16-32 32-16-32-16-16-32-16 32-32 16 32 16zM32 448l448 0 32 0 0 64-32 0L32 512 0 512l0-64 32 0z"]
};
const faChartKanban = {
  prefix: 'fass',
  iconName: 'chart-kanban',
  icon: [448, 512, [], "e64f", "M448 480l-128 0 0-448 128 0 0 448zM0 416L0 32l128 0 0 384L0 416zM160 288l0-256 128 0 0 256-128 0z"]
};
const faPenFancy = {
  prefix: 'fass',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M97.1 392.3c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-88 88L224 448l37.5-99.9-97.6-97.6L64 288 9.1 480.3l88-88zm178.3-75.5L512 96 416 0 195.2 236.6l80.2 80.2z"]
};
const faCoffeePot = {
  prefix: 'fass',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M32 32L0 32 0 64 0 192l0 32 64 0 0-32 0-96 53.3 0 27.8 83.3C96 214 64 271.3 64 336l0 8c0 80 72 136 72 136l304 0s72-56 72-136l0-8c0-64.7-32-122-81.1-156.7L480 32 224 32l-32 0L96 32 32 32zM194 224l188 0c34.9 19.4 59.8 54.6 65 96l-318 0c5.2-41.4 30.1-76.6 65-96z"]
};
const faMouseField = {
  prefix: 'fass',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M396.2 113.6c2.5-8.1 3.8-16.7 3.8-25.6c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.8 14.8 56.1 37.4 72l-5.4 0c-88.4 0-160 71.6-160 160l0 48-24 0c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0 24 0 0-48-24 0L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 136 0 8 0 19 0 133 0 24 0 0-24 0-16 0-16.8-15.8-5.7-49.9-18.2 23.8-63.5c2 .1 4 .2 6 .2L512 272l0-23.1c0-43-19.8-81.4-50.8-106.5C473 127.4 480 108.5 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 14.5-2.8 28.4-7.8 41.1c-8.9-3.4-18.3-6-28-7.5zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40l0 40-40 0c-22.1 0-40-17.9-40-40s17.9-40 40-40z"]
};
const faPersonDigging = {
  prefix: 'fass',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M256 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM41.2 201.8l-22.2-9.2L.6 236.9l22.2 9.2 347.9 145L352 416l-64 0-32 96 320 0 0-48L448 288l-47.6 63.5-91.9-38.3L253.6 179.8l-5.1-12.5-12.6-5-80-32-22-8.8L119 140 62.5 210.7l-21.2-8.8zm17.1 90.1L49 328 1.3 512l66.1 0 34.2-131.9 58.4 25 0 74.9 0 32 64 0 0-32 0-96 0-21.1-19.4-8.3-112-48L58.4 291.9z"]
};
const faDigging = faPersonDigging;
const faShowerDown = {
  prefix: 'fass',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M224 0l0 32 0 3.2C297 50 352 114.6 352 192l32 0 0 64-32 0L32 256 0 256l0-64 32 0C32 114.6 87 50 160 35.2l0-3.2 0-32 64 0zm32 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7L256 416zm36.2-79.3L320 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7zM128 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0C110.2 512 96 497.8 96 480.4c0-5.5 1.4-10.9 4.2-15.7L128 416zm36.2-79.3L192 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7zM64 288l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C96 369.8 81.8 384 64.4 384l-.8 0C46.2 384 32 369.8 32 352.4c0-5.5 1.4-10.9 4.2-15.7L64 288z"]
};
const faShowerAlt = faShowerDown;
const faBoxCircleCheck = {
  prefix: 'fass',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M208 32l0 128L0 160 64 32l144 0zm32 0l144 0 64 128-32 0-176 0 0-128zM0 480L0 192l416 0 0 .7c-89.7 8.1-160 83.5-160 175.3c0 42.5 15.1 81.6 40.2 112L0 480zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z"]
};
const faBrightness = {
  prefix: 'fass',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M288 32l0-32L224 0l0 32 0 48 0 32 64 0 0-32 0-48zM118.6 73.4L96 50.7 50.7 96l22.6 22.6 32 32L128 173.3 173.3 128l-22.6-22.6-32-32zm320 45.3L461.3 96 416 50.7 393.4 73.4l-32 32L338.7 128 384 173.3l22.6-22.6 32-32zM32 224L0 224l0 64 32 0 48 0 32 0 0-64-32 0-48 0zm448 0l-48 0-32 0 0 64 32 0 48 0 32 0 0-64-32 0zM150.6 406.6L173.3 384 128 338.7l-22.6 22.6-32 32L50.7 416 96 461.3l22.6-22.6 32-32zm256-45.3L384 338.7 338.7 384l22.6 22.6 32 32L416 461.3 461.3 416l-22.6-22.6-32-32zM288 480l0-48 0-32-64 0 0 32 0 48 0 32 64 0 0-32zM256 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faCarSideBolt = {
  prefix: 'fass',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M96 64L42.7 224 0 224 0 432l65.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l65.3 0 0-208-117.3 0L416 64 96 64zM480 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM114.7 400a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM208 240L336 112l-24 96 88 0L272 336l24-96-88 0z"]
};
const faFileXml = {
  prefix: 'fass',
  iconName: 'file-xml',
  icon: [512, 512, [], "e654", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zm32 224l0 16 0 128 0 16-32 0 0-16 0-74.2-17.9 33.7-13.9 26.2-14.3-26L320 423l0 73 0 16-32 0 0-16 0-128 0-16 16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0zm-224 0l0 16c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4l0-16 32 0 0 16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496l0 16-32 0 0-16c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4l0 16-32 0 0-16c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368l0-16 32 0zM448 512l0-16 0-128 0-16 32 0 0 16 0 112 16 0 16 0 0 32-16 0-32 0-16 0z"]
};
const faOrnament = {
  prefix: 'fass',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M224 96l-64 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32zm32 0l0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 32L96 96l0 57.7C66.9 170.5 42.5 194.9 25.7 224l332.6 0c-16.9-29.1-41.2-53.5-70.3-70.3L288 96l-32 0zM0 320c0 22.4 3.8 44 10.9 64l362.2 0c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64L10.9 256C3.8 276 0 297.6 0 320zm25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96L25.7 416z"]
};
const faPhoneArrowDownLeft = {
  prefix: 'fass',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M144 0L0 32 0 64C0 311.4 200.6 512 448 512l32 0 32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0zM489 57l17-17L472 6.1 455 23l-119 119L336 88l0-24-48 0 0 24 0 112 0 24 24 0 112 0 24 0 0-48-24 0-54.1 0L489 57z"]
};
const faPhoneArrowDown = faPhoneArrowDownLeft;
const faPhoneIncoming = faPhoneArrowDownLeft;
const faCloudWord = {
  prefix: 'fass',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336L0 480zM512 352l0 32-16 0-192 0-16 0 0-32 16 0 192 0 16 0zm-272 0l16 0 0 32-16 0-96 0-16 0 0-32 16 0 96 0zM128 288l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm272 0l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z"]
};
const faHandFingersCrossed = {
  prefix: 'fass',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M101 35.6L87.5 6.6l-58 27.1L43 62.6l32 68.7 35.3-75.7L101 35.6zM165.6 240l26.4 0 0-9.4L181 207l-15.4 33zM288 320l-64 0 0 48 0 16-16 0L96 384l-16 0 0-32 16 0 96 0 0-32 0-48-41.4 0-35.3 0L80 272 0 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32zM212.8 63l13.5-29-58-27.1-13.5 29L59.6 240l70.6 0L212.8 63zM224 160l0 128 64 0 0-128-64 0zm96 32l0 128 64 0 0-128-64 0z"]
};
const faTrash = {
  prefix: 'fass',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM416 128L32 128 56 512l336 0 24-384z"]
};
const faGaugeSimple = {
  prefix: 'fass',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88l0-24-48 0 0 24 0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faGaugeSimpleMed = faGaugeSimple;
const faTachometerAverage = faGaugeSimple;
const faArrowDownSmallBig = {
  prefix: 'fass',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M320 32l160 0 0 160-160 0 0-160zm0 224l224 0 0 224-224 0 0-224zM183.7 453.5l-23.7 26-23.7-26-80-88L34.8 341.8l47.4-43 21.5 23.7L128 349.2 128 80l0-32 64 0 0 32 0 269.2 24.3-26.8 21.5-23.7 47.4 43-21.5 23.7-80 88z"]
};
const faSortSizeDownAlt = faArrowDownSmallBig;
const faBookMedical = {
  prefix: 'fass',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM208 96l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faFaceMelting = {
  prefix: 'fass',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M571.4 304.8c-4.5 23.1 11.8 47.2 35.3 47.2c0 0 0 0 0 0l1.3 0 32 0 0 32 0 32-32 0c0 0 0 0 0 0l-48 0c-8.8 0-16 7.2-16 16s7.1 16 16 16c0 0 0 0 0 0l16 0 32 0 0 32 0 32-32 0-256 0L32 512 0 512l0-32 0-32 32 0 12.9 0c0 0 0 0 0 0c36.8 0 58.4-50.7 42.8-84.1C72.5 331.1 64 294.5 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 16.7-1.6 33-4.6 48.8zM247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zM441 238.7a32 32 0 1 0 -61.8-16.6A32 32 0 1 0 441 238.7zM213.2 299.4l-7-14.4-28.8 14 7 14.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7l13.3-9L404 338l-13.3 9c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"]
};
const faPoo = {
  prefix: 'fass',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M256 48c0 44.2-35.8 80-80 80l-10.5 0-5.5 0c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72c0 25.6 13.4 48.2 33.6 60.9C27.5 385.6 0 421.6 0 464l0 48 512 0 0-48c0-42.4-27.5-78.4-65.6-91.1C466.6 360.2 480 337.6 480 312c0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96c-5.1 0-10.2 .4-15.1 1.2C250.4 14.3 256 30.5 256 48zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 448c-64 0-96-64-96-64l192 0s-32 64-96 64z"]
};
const faPenClipSlash = {
  prefix: 'fass',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M409.1 294.9L447 257l33-33 1-1L305 47l-17-17L271 47l-79.2 79.2L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L409.1 294.9zm-179.1-139L288 97.9l31 31-54 54-34.9-27.1zm110 208.1L196.9 251.1 96 352 64 512l160-32L340.1 363.9zM576 128L448 0 375.6 72.4l128 128L576 128z"]
};
const faPenAltSlash = faPenClipSlash;
const faQuoteRight = {
  prefix: 'fass',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M192 296c0 66.3-53.7 120-120 120l-8 0-32 0 0-64 32 0 8 0c30.9 0 56-25.1 56-56l0-8L0 288 0 96l192 0 0 96 0 96 0 8zm256 0c0 66.3-53.7 120-120 120l-8 0-32 0 0-64 32 0 8 0c30.9 0 56-25.1 56-56l0-8-128 0 0-192 192 0 0 96 0 96 0 8z"]
};
const faQuoteRightAlt = faQuoteRight;
const faScrollOld = {
  prefix: 'fass',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M48 32c26.5 0 48 21.5 48 48l0 80-48 0L0 160 0 80C0 53.5 21.5 32 48 32zm80 48c0-18-6-34.6-16-48l272 0c53 0 96 43 96 96l-32 32 32 32 0 16 0 16-32 32 32 32 0 16 0 16-208 0-16 0 0 16 0 48c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-112 0-16 32-32-32-32 0-16 0-96zM576 368c0 61.9-50.1 112-112 112l-96 0-176 0c53 0 96-43 96-96l0-32 48 0 16 0 32 32 32-32 16 0 144 0 0 16z"]
};
const faGuitars = {
  prefix: 'fass',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M104 0l48 0 24 0 0 24 0 56 0 5.7-2.5 5.1L152 133.7l0 44.4c50.3 8.6 88 43.8 88 86c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-8.8 16.3-15 35.6-15 56.5c0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86l0-44.4L82.5 90.7 80 85.7 80 80l0-56L80 0l24 0zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM360 148.6L328 112 352 0l32 0c22.1 0 40 17.9 40 40l0 4.4c0 12.4-6.4 23.3-16 29.7l0 164.7c48-7.2 48-46.9 48-46.9l32 0 0 37.5c0 12.9-4.3 25.4-8.5 37.8c-1.4 4-2.7 7.9-3.9 11.8c-2.1 6.8-3.6 15.1-3.6 24.8c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8l-108.4 0C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-9.8-1.5-18-3.6-24.8c-1.2-3.9-2.5-7.9-3.9-11.8c-4.2-12.4-8.5-25-8.5-37.8l0-53.5 32 0s0 52.8 48 62.5l0-89.9zM336 304l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0z"]
};
const faPhoneXmark = {
  prefix: 'fass',
  iconName: 'phone-xmark',
  icon: [576, 512, [], "e227", "M176 0L32 32l0 32c0 247.4 200.6 448 448 448l32 0 32-144L400 288l-67 83.8C264.5 335.7 208.3 279.5 172.2 211L256 144 176 0zm362 40L504 6.1 487 23l-47 47L393 23l-17-17L342.1 40l17 17 47 47-47 47-17 17L376 201.9l17-17 47-47 47 47 17 17L537.9 168l-17-17-47-47 47-47 17-17z"]
};
const faHose = {
  prefix: 'fass',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M288 104l0 24 48 0 0-24 0-2.3 80-11.4 0 13.7 32 0 0-16 0-48 0-16-32 0 0 13.7L336 26.3l0-2.3 0-24L288 0l0 24 0 80zM64 176c0-44.2 35.8-80 80-80l112 0 0-64L144 32C64.5 32 0 96.5 0 176s64.5 144 144 144l272 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-272 0c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 352zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z"]
};
const faClockSix = {
  prefix: 'fass',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 240 0 24-48 0 0-24 0-240 0-24 48 0 0 24z"]
};
const faShirt = {
  prefix: 'fass',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M225.3 0L176 0 0 144 88 256l72-58.9L160 512l320 0 0-314.9L552 256l88-112L464 0 414.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80z"]
};
const faTShirt = faShirt;
const faTshirt = faShirt;
const faBillboard = {
  prefix: 'fass',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M448 32l0-32L384 0l0 32L256 32l0-32L192 0l0 32L96 32 32 32l0 64 0 256L0 352l0 64 32 0 64 0 192 0 0 64 0 32 64 0 0-32 0-64 192 0 64 0 32 0 0-64-32 0 0-256 0-64-64 0-96 0zM352 352l-64 0L96 352 96 96l96 0 0 32-32 0 0 64 32 0 32 0 32 0 32 0 0-64-32 0 0-32 128 0 0 32-32 0 0 64 32 0 32 0 32 0 32 0 0-64-32 0 0-32 96 0 0 256-192 0z"]
};
const faSquareR = {
  prefix: 'fass',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M448 32L0 32 0 480l448 0 0-448zM128 128l24 0 104 0c44.2 0 80 35.8 80 80l0 24-3.7 0c-8.4 26.7-30.4 47.4-57.9 53.9L337.1 384l-57 0-61.3-96L176 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 112l56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64z"]
};
const faCubes = {
  prefix: 'fass',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M288 4.2l8.5 3.2L424.5 56 440 61.9l0 16.6 0 126.1 120.5 45.7 15.5 5.9 0 16.6 0 154.1 0 15.7-14.3 6.3L433.7 505l-9.7 4.2-9.7-4.2L288 449.5 161.7 505l-9.7 4.2-9.7-4.2-128-56.3L0 442.4l0-15.7L0 272.6l0-16.6 15.5-5.9L136 204.5l0-126.1 0-16.6L151.5 56l128-48.5L288 4.2zm21.6 237.6L392 210.6l0-89.6-82.4 31.6 0 89.2zM288 55.6L217.3 82.4 288 109.5l70.7-27.1L288 55.6zM173.6 447.3L256 411.1l0-87.9-82.4 31.6 0 92.5zM152 249.8L70.8 280.6 152 311.7l81.2-31.1L152 249.8zM528 411.1l0-87.9-82.4 31.6 0 92.5L528 411.1zM505.2 280.6L424 249.8l-81.2 30.8L424 311.7l81.2-31.1z"]
};
const faEnvelopeOpenDollar = {
  prefix: 'fass',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M512 448l0 64-64 0L64 512 0 512l0-64L0 244.8l4.1 2.9L246.7 421l9.3 6.6 9.3-6.6L507.9 247.7l4.1-2.9L512 448zm0-256l0 13.5-22.7 16.2L416 274.1l0-74.1 0-56 0-24 0-24-32 0-16 0-90.7 0-42.7 0L144 96l-16 0L96 96l0 24 0 24 0 56 0 74.1L22.7 221.7 0 205.5 0 192l48-36 0-60 0-48 48 0 96 0L256 0l64 48 96 0 48 0 0 48 0 60 48 36zM276 144l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z"]
};
const faDivide = {
  prefix: 'fass',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M176 48l0 96 96 0 0-96-96 0zm0 320l0 96 96 0 0-96-96 0zm224-80l32 0 0-64-32 0L48 224l-32 0 0 64 32 0 352 0z"]
};
const faSunCloud = {
  prefix: 'fass',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M256 73.1L150 0 126.7 126.7 0 150 73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l11.8-64L288 448l0-68c-10.2 2.6-21 4-32 4c-70.7 0-128-57.3-128-128s57.3-128 128-128c61.3 0 112.6 43.1 125.1 100.7c20.5-22.5 50-36.7 82.9-36.7c6.1 0 12.2 .5 18 1.4L512 150 385.3 126.7 362 0 256 73.1zm32.2 273.4c2.2-39.3 28.1-72.3 63.7-85c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c11.3 0 22.1-1.9 32.2-5.5zM568 416l72 0 0-72c0-39.8-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64l0 64 64 0 184 0z"]
};
const faLampFloor = {
  prefix: 'fass',
  iconName: 'lamp-floor',
  icon: [384, 512, [], "e015", "M0 224L64 0 320 0l64 224L0 224zm160 32l64 0 0 192 64 0 32 0 0 64-32 0-96 0-96 0-32 0 0-64 32 0 64 0 0-192z"]
};
const faSquare7 = {
  prefix: 'fass',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M448 32L0 32 0 480l448 0 0-448zM296 128l24 0 0 29.4-2.3 4.9L213.5 384l-53 0 3.9-8.2L258.2 176 152 176l-24 0 0-48 24 0 144 0z"]
};
const faTengeSign = {
  prefix: 'fass',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 32l384 0 0 64L0 96 0 32zM224 160l160 0 0 64-160 0 0 256-64 0 0-256L0 224l0-64 160 0 64 0z"]
};
const faTenge = faTengeSign;
const faHeadphones = {
  prefix: 'fass',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M256 80C152 80 65.8 156.3 50.4 256l77.6 0 0 224L0 480l0-96 0-96C0 146.6 114.6 32 256 32s256 114.6 256 256l0 96 0 96-128 0 0-224 77.6 0C446.2 156.3 360 80 256 80z"]
};
const faHandsHolding = {
  prefix: 'fass',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M80 104l0 8 0 32 0 80 0 66.7 84.1 84.1L205.8 347l-36.4-36.4L146.7 288l-9.4-9.4L114.7 256 160 210.7l22.6 22.6 9.4 9.4 22.6 22.6 64 64 9.4 9.4 0 13.3 0 64 0 32 0 32 0 32-32 0-96 0-13.3 0-9.4-9.4-128-128L0 365.3 0 352 0 224l0-64 0-32 0-24L0 64l80 0 0 40zm480 0l0-40 80 0 0 40 0 24 0 32 0 64 0 128 0 13.3-9.4 9.4-128 128-9.4 9.4L480 512l-96 0-32 0 0-32 0-32 0-32 0-64 0-13.3 9.4-9.4 64-64L448 242.7l9.4-9.4L480 210.7 525.3 256l-22.6 22.6-9.4 9.4-22.6 22.6L434.2 347l41.7 27.8L560 290.7l0-66.7 0-80 0-32 0-8z"]
};
const faCampfire = {
  prefix: 'fass',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M228.4 0C189.6 24.2 112 93.1 112 174.5C112 254.9 177.1 320 257.5 320s145.5-65.1 145.5-145.5c0-24.2-17.5-87.3-87.3-145.5L286.5 58.2 228.4 0zm87.3 218.3c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-43.6 58.2-87.3 58.2-87.3s58.2 43.6 58.2 87.3zm154.8 80.8L256 366.5 41.6 299.1 22.4 360.1 149.3 400 22.4 439.9l19.2 61.1L256 433.5l214.4 67.4 19.2-61.1L362.7 400l126.9-39.9-19.2-61.1z"]
};
const faCircleAmpersand = {
  prefix: 'fass',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128l24 0 96 0 24 0 0 24 0 35.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9-10.8 15.6L284.6 384 272 384l-16 0-88 0-24 0 0-24 0-39.7c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-36.7 0-24zm66.4 89.6l23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0 0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6l-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4l0 15.7 67.4 0 9.2-13.3-39.8-41.5z"]
};
const faSnowflakes = {
  prefix: 'fass',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M256 32l0-32L192 0l0 32 0 30.1-8.6-8.6-17-17L132.4 70.4l17 17L192 129.9l0 70.6-61.2-35.3-15.6-58.2L109 83.9 62.7 96.3l6.2 23.2L72 131.3l-12.2-7-27.7-16L.1 163.7l27.7 16 12.2 7-11.8 3.2L5.1 196.1l12.4 46.4 23.2-6.2 58.2-15.6L160 256 98.8 291.3 40.7 275.7l-23.2-6.2L5.1 315.9l23.2 6.2L40 325.3l-12.2 7L.1 348.3l32 55.4 27.7-16 12.2-7-3.2 11.8-6.2 23.2L109 428.1l6.2-23.2 15.6-58.2L192 311.4l0 70.6-42.6 42.6-17 17 33.9 33.9 17-17 8.6-8.6 0 30.1 0 32 64 0 0-32 0-30.1 8.6 8.6 17 17 33.9-33.9-17-17L256 382.1l0-70.6 61.2 35.3 15.6 58.2 6.2 23.2 46.4-12.4-6.2-23.2-3.2-11.8 12.2 7 27.7 16 32-55.4-27.7-16-12.2-7 11.8-3.2 23.2-6.2-12.4-46.4-23.2 6.2-58.2 15.6L288 256l61.2-35.3 58.2 15.6 23.2 6.2 12.4-46.4-23.2-6.2-11.8-3.2 12.2-7 27.7-16-32-55.4-27.7 16-12.2 7 3.2-11.8 6.2-23.2L338.9 83.9l-6.2 23.2-15.6 58.2L256 200.6l0-70.6 42.6-42.6 17-17L281.6 36.5l-17 17L256 62.1 256 32zM510.1 64L482.2 91.8l33.9 33.9L544 97.9l27.8 27.8 33.9-33.9L577.9 64l27.8-27.8L571.8 2.2 544 30.1 516.2 2.2 482.2 36.2 510.1 64zm37.1 129.3l-33.9 33.9 17 17L542.1 256l-11.8 11.8-17 17 33.9 33.9 17-17L576 289.9l11.8 11.8 17 17 33.9-33.9-17-17L609.9 256l11.8-11.8 17-17-33.9-33.9-17 17L576 222.1l-11.8-11.8-17-17z"]
};
const faHandsClapping = {
  prefix: 'fass',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M336 16l0 64 0 16-32 0 0-16 0-64 0-16 32 0 0 16zm-98.7 7.1l32 48 8.9 13.3-26.6 17.8-8.9-13.3-32-48-8.9-13.3L228.4 9.8l8.9 13.3zM152 102.1l17 17 151 151 0-86.1 0-24 24 0 16 0 24 0 0 24 0 161.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361l-17-17L24 310.1l17 17 64 64L127 369 23 265l-17-17L40 214.1l17 17L161 335 183 313 55 185l-17-17L72 134.1l17 17L217 279 239 257 135 153l-17-17L152 102.1zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-91.5 16 16 0-86.1 0-24 24 0 16 0 24 0 0 24 0 161.6c0 57.1-30 110-78.9 139.4zM411.6 9.8l26.6 17.8-8.9 13.3-32 48-8.9 13.3L361.8 84.4l8.9-13.3 32-48 8.9-13.3z"]
};
const faRepublican = {
  prefix: 'fass',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M0 192C0 103.6 71.6 32 160 32l224 0c88.4 0 160 71.6 160 160l0 64L0 256l0-64zm127.8-64l-15.7 32-36.3 4.6 26.5 24.4L95.7 224l32.1-16.9L160 224l-6.7-34.9 26.5-24.4L143.6 160l-15.7-32zm159.7 32l-15.7-32-15.7 32-36.3 4.6 26.5 24.4L239.7 224l32.1-16.9L304 224l-6.7-34.9 26.5-24.4L287.6 160zm128.3-32l-15.7 32-36.3 4.6 26.5 24.4L383.7 224l32.1-16.9L448 224l-6.7-34.9 26.5-24.4L431.6 160l-15.7-32zM128 288l192 0 96 0 32 0 64 0 32 0 0 32 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-32 64 0 0 32 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48-32 0 0 32 0 96-128 0 0-96-192 0 0 96L0 480l0-96 0-96 128 0z"]
};
const faLeafMaple = {
  prefix: 'fass',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M368 64L480 32 448 144l64 32L384 272l80 0-16 64 56 48-56 48 8 64L272 448l-32 48L183.6 394.4 90.2 487.7l-17 17L39.3 470.7l17-17L247.7 262.3l-22.3-22.3-11.3 11.3-84 84L16 272l48-32L16 56l64 8L128 8l48 56 64-16 0 80L336 0l32 64z"]
};
const faArrowLeft = {
  prefix: 'fass',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M25.4 278.6L2.7 256l22.6-22.6 144-144L192 66.7 237.2 112l-22.6 22.6L125.2 224 416 224l32 0 0 64-32 0-290.7 0 89.4 89.4L237.2 400 192 445.3l-22.6-22.6-144-144z"]
};
const faPersonCircleXmark = {
  prefix: 'fass',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z"]
};
const faRuler = {
  prefix: 'fass',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M160 512L512 160 352 0 283.3 68.7l48 48L342.6 128 320 150.6l-11.3-11.3-48-48-41.4 41.4 48 48L278.6 192 256 214.6l-11.3-11.3-48-48-41.4 41.4 48 48L214.6 256 192 278.6l-11.3-11.3-48-48L91.3 260.7l48 48L150.6 320 128 342.6l-11.3-11.3-48-48L0 352 160 512z"]
};
const faArrowLeftFromBracket = {
  prefix: 'fass',
  iconName: 'arrow-left-from-bracket',
  icon: [512, 512, [], "e668", "M22.6 233.4L0 256l22.6 22.6 128 128 22.6 22.6L218.5 384l-22.6-22.6L122.5 288 320 288l32 0 0-64-32 0-197.5 0 73.4-73.4L218.5 128 173.3 82.7l-22.6 22.6-128 128zM352 416l-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0 0 64 32 0 96 0 0 320-96 0z"]
};
const faCupStrawSwoosh = {
  prefix: 'fass',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M205 0l-4.4 18.5L174.9 128 32 128 0 128l0 64 32 0 320 0 32 0 0-64-32 0-127.8 0L243 48l37 0 24 0 0-48L280 0 224 0 205 0zM40 224L64 512l256 0 24-288L40 224zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6L303 331.2c-20.8 3.1-35.2 8.2-45.8 13.9c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z"]
};
const faTemperatureSun = {
  prefix: 'fass',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M104 104L0 121.3 60.7 208 0 294.7 104 312l17.3 104L208 355.3 294.7 416l.8-5c-4.9-16.1-7.5-33.3-7.5-51c0-37.7 11.8-72.6 32-101.2l0-153.4-8-1.3L294.7 0 208 60.7 121.3 0 104 104zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM401.8 317.8L416 300.2l0-22.7L416 64l96 0 0 213.5 0 22.7 14.2 17.6C537.4 331.5 544 348.9 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM576 0L512 0 416 0 352 0l0 64 0 213.5c-20 24.7-32 56.2-32 90.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L576 64l0-64zM464 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L480 112l0-16-32 0 0 16 0 210.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faTemperatureHot = faTemperatureSun;
const faAlignLeft = {
  prefix: 'fass',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M288 32l0 64L0 96 0 32l288 0zm0 256l0 64L0 352l0-64 288 0zM0 160l448 0 0 64L0 224l0-64zM448 416l0 64L0 480l0-64 448 0z"]
};
const faDiceD6 = {
  prefix: 'fass',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M432 112L224 240 16 112 224 0 432 112zM208 272l0 240L0 384 0 144 208 272zM448 144l0 240L240 512l0-240L448 144z"]
};
const faRestroom = {
  prefix: 'fass',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zM53.4 128l23.5 0 102.2 0 23.5 0 7 22.5 44.9 144-54.5 17L200 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-168.5-54.5-17 44.9-144 7-22.5zM344 0l0 24 0 464 0 24-48 0 0-24 0-464 0-24 48 0zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-26.6 80l23.5 0 102.2 0 23.5 0 7 22.5 44.9 144L598.3 307 624 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0 25.7-77-40.2-12.5 44.9-144 7-22.5z"]
};
const faHighDefinition = {
  prefix: 'fass',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M0 32l576 0 0 448L0 480 0 32zM304 160l0 24 0 144 0 24 24 0 56 0c53 0 96-43 96-96s-43-96-96-96l-56 0-24 0zm80 48c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96 32 0zM160 184l0-24-48 0 0 24 0 72 0 72 0 24 48 0 0-24 0-48 64 0 0 48 0 24 48 0 0-24 0-72 0-72 0-24-48 0 0 24 0 48-64 0 0-48z"]
};
const faRectangleHd = faHighDefinition;
const faJ = {
  prefix: 'fass',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M320 32l0 32 0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32 0-32 64 0 0 32 0 32c0 53 43 96 96 96s96-43 96-96l0-256 0-32 64 0z"]
};
const faGalaxy = {
  prefix: 'fass',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M336 0l32 0L355.4 7.8C303.8 39.5 270.6 93.4 264.9 153c16.5-5.8 34.8-9 55.1-9c2.9 0 5.8 .1 8.7 .2c.9-.1 1.9-.2 2.8-.2c1.9 0 3.7 .3 5.5 .7C435 153.3 512 235.7 512 336l0 32-7.8-12.6c-31.7-51.5-85.7-84.8-145.2-90.5c5.8 16.5 9 34.8 9 55.1c0 2.9-.1 5.8-.2 8.7c.1 .9 .2 1.9 .2 2.8c0 1.9-.3 3.7-.7 5.5C358.7 435 276.3 512 176 512l-32 0 12.6-7.8c51.5-31.7 84.8-85.7 90.5-145.2c-16.5 5.8-34.8 9-55.1 9c-2.9 0-5.8-.1-8.7-.2c-.9 .1-1.9 .2-2.8 .2c-1.9 0-3.7-.3-5.5-.7C77 358.7 0 276.3 0 176l0-32 7.8 12.6c31.7 51.5 85.7 84.8 145.2 90.5c-5.8-16.5-9-34.8-9-55.1c0-2.9 .1-5.8 .2-8.7c-.1-.9-.2-1.9-.2-2.8c0-1.9 .3-3.7 .7-5.5C153.3 77 235.7 0 336 0zM256 296l40-40-40-40-40 40 40 40z"]
};
const faUsersViewfinder = {
  prefix: 'fass',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M0 0L24 0 136 0l24 0 0 48-24 0L48 48l0 88 0 24L0 160l0-24L0 24 0 0zM175.8 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm41.1 128l-7.3 21.9L190.3 336 96 336l24-80 96.9 0zM544 336l-94.3 0-19.4-58.1L423.1 256l96.9 0 24 80zm-128 0l16 48-224 0 16-48 16-48 17.6 0 124.8 0 17.6 0 16 48zm48-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM616 0l24 0 0 24 0 112 0 24-48 0 0-24 0-88-88 0-24 0 0-48 24 0L616 0zM0 512l0-24L0 376l0-24 48 0 0 24 0 88 88 0 24 0 0 48-24 0L24 512 0 512zm616 0l-112 0-24 0 0-48 24 0 88 0 0-88 0-24 48 0 0 24 0 112 0 24-24 0z"]
};
const faFileVideo = {
  prefix: 'fass',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM64 256l160 0 0 160L64 416l0-160zM320 400l-64-32 0-64 64-32 0 128z"]
};
const faCherries = {
  prefix: 'fass',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 40l12.5-20.5L269.1 .3l-4.9 36.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l0 .1-.1 .8c-.1 .7-.3 1.9-.6 3.5c-.6 3.1-1.5 7.9-2.9 13.9c-2.8 12.2-7.5 29.7-15.2 50.7c-13.9 38.3-37.3 87.6-76 136.4C152.3 233.5 126.6 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.2 0-38.2 4.1-53.1 9.5c26.5-40.4 44.1-79.4 55.7-111.2c5.7-15.6 9.9-29.6 13.1-41.3c11.9 9.5 26.3 22.2 41 37.6c29.1 30.7 58.2 71.2 72.2 119.6c-12-5.3-27-10.3-44.1-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.3 10.6-76.3 19.6c-14.3-67.2-52.9-120.9-88.3-158.2C359.3 64.4 339.8 48 325.3 36.9c-7.3-5.6-13.3-9.8-17.6-12.7c-2.2-1.5-3.9-2.6-5.1-3.4c-.6-.4-1.1-.7-1.4-.9l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 40z"]
};
const faUpRightFromSquare = {
  prefix: 'fass',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M512 176l-32 32-65.4-65.4-168 168L224 333.3 178.7 288l22.6-22.6 168-168L304 32 336 0 512 0l0 176zM0 32l32 0 128 0 32 0 0 64-32 0L64 96l0 352 352 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 64 0 32z"]
};
const faExternalLinkAlt = faUpRightFromSquare;
const faCircleSort = {
  prefix: 'fass',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-64l0 32 224 0 0-32L256 96 144 192zM256 416l112-96 0-32-224 0 0 32 112 96z"]
};
const faSortCircle = faCircleSort;
const faTableCells = {
  prefix: 'fass',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M512 32L0 32 0 480l512 0 0-448zM152 96l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zm64 0l88 0 0 64-88 0 0-64zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0z"]
};
const faTh = faTableCells;
const faBagShoppingMinus = {
  prefix: 'fass',
  iconName: 'bag-shopping-minus',
  icon: [448, 512, [], "e650", "M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 112 0 0 352L0 512 0 160l112 0zm8 152l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0z"]
};
const faFilePdf = {
  prefix: 'fass',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0-16 0 0-16 0-128 0-16 16 0zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-128l16 0 48 0 16 0 0 32-16 0-32 0 0 32 32 0 16 0 0 32-16 0-32 0 0 48 0 16-32 0 0-16 0-64 0-64 0-16z"]
};
const faSiren = {
  prefix: 'fass',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M80 96L48 352l57.9 0 22.2-178 1.8-14 32.2 0-2.2 18L138.1 352 400 352 368 96 80 96zM448 384L0 384l0 96 448 0 0-96z"]
};
const faArrowUpToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M64 32L0 32 0 96l64 0 0-64zm96 0L96 32l0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM246.6 169.4L224 146.7l-22.6 22.6-128 128L50.7 320 96 365.3l22.6-22.6L192 269.3l0 66.7 0 112 0 32 64 0 0-32 0-112 0-66.7 73.4 73.4L352 365.3 397.3 320l-22.6-22.6-128-128z"]
};
const faImageLandscape = {
  prefix: 'fass',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M576 64L0 64 0 448l576 0 0-384zM128 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm200-16l19.2 25.6L484 384 80.8 384l12.8-15.4 80-96L192 250.5l18.4 22.1 23.7 28.5 74.6-99.5L328 176z"]
};
const faLandscape = faImageLandscape;
const faTankWater = {
  prefix: 'fass',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M206.4 32L64 32 0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L241.6 32 251 46.8 282.3 96 384 96l0 202c-8.3-3-16.2-6.8-23.4-10.8c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.8 9-35.5 16.8-55.1 16.9l-.5 0c-19.6-.1-39.3-7.9-55.1-16.9c-15.4-8.7-27-19.1-40-30.7c0 0 0 0 0 0l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-7.1 4-15 7.8-23.3 10.8L64 96l101.7 0L197 46.8 206.4 32zm-2.8 64l-26.9 42.3c-5.7 8.9-8.7 19.3-8.7 29.9c0 30.8 25.2 55.8 56 55.8s56-25 56-55.8c0-10.6-3-21-8.7-29.9L244.4 96 243 93.8 224 64 205 93.8 203.6 96z"]
};
const faCurlingStone = {
  prefix: 'fass',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M192 32l-32 0 0 32 0 96-64 0 0 64-32 0L0 288l0 48 576 0 0-48-64-64-32 0 0-64-256 0 0-64 160 0 32 0 0-64-32 0L192 32zM0 368l0 48 64 64 448 0 64-64 0-48L0 368z"]
};
const faCurling = faCurlingStone;
const faGamepadModern = {
  prefix: 'fass',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M0 480l200 0 16-96 208 0 16 96 200 0L597.2 96 480 32 320 32 160 32 42.8 96 0 480zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8l0 32 32 0 24 0 0 48-24 0-32 0 0 32 0 24-48 0 0-24 0-32-32 0-24 0 0-48 24 0 32 0 0-32 0-24 48 0 0 24z"]
};
const faGamepadAlt = faGamepadModern;
const faMessagesQuestion = {
  prefix: 'fass',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M416 0L0 0 0 320l96 0 0 64 106.7-64L416 320 416 0zM256 352l0 96 181.3 0L544 512l0-64 96 0 0-320-192 0 0 224-192 0zM134.7 108c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 234.7l40 0 0 40-40 0 0-40z"]
};
const faBookBible = {
  prefix: 'fass',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0L448 0 416 0 384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 64l64 0 0 64 64 0 0 64-64 0 0 128-64 0 0-128-64 0 0-64 64 0 0-64z"]
};
const faBible = faBookBible;
const faO = {
  prefix: 'fass',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
const faSuitcaseMedical = {
  prefix: 'fass',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M128 0l24 0L360 0l24 0 0 24 0 72 0 32 0 352-256 0 0-352 0-32 0-72 0-24zM336 48L176 48l0 48 160 0 0-48zM96 96l0 384L0 480 0 96l96 0zM416 480l0-384 96 0 0 384-96 0zM224 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faMedkit = faSuitcaseMedical;
const faBriefcaseArrowRight = {
  prefix: 'fass',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M128 0l24 0L360 0l24 0 0 24 0 72 128 0 0 384L0 480 0 96l128 0 0-72 0-24zM336 48L176 48l0 48 160 0 0-48zM297 191l-17-17L246.1 208l17 17 39 39L152 264l-24 0 0 48 24 0 150.1 0-39 39-17 17L280 401.9l17-17 80-80 17-17-17-17-80-80z"]
};
const faExpandWide = {
  prefix: 'fass',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M32 64L0 64 0 96l0 96 0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0L32 64zM64 320l0-32L0 288l0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64zM384 64l-32 0 0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0zM512 320l0-32-64 0 0 32 0 64-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-96z"]
};
const faClockElevenThirty = {
  prefix: 'fass',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-128.7-60-90-13.3-20 39.9-26.6 13.3 20 64 96 4 6 0 7.3 0 136 0 24-48 0 0-24z"]
};
const faRv = {
  prefix: 'fass',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 0L384 0l0 32 224 0 0 128-224 0 0 256-129.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L96 416 0 320 0 32l224 0 0-32zm32 128L96 128l0 96 160 0 0-96zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48l0-16 0-80 0-32 0-72 0-24 24 0 88 0 8.6 0 6.6 5.4 88 72 8.8 7.2 0 11.4 0 32 0 96-65.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16zM578.1 288l-58.7-48L464 240l0 48 114.1 0z"]
};
const faUserSecret = {
  prefix: 'fass',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M121.1 87.5L160 0l64 32L288 0l38.9 87.5C380.5 96 416 111 416 128c0 14.3-25 27.1-64.6 35.9c.4 4 .6 8 .6 12.1c0 17-3.3 33.2-9.3 48l73.3 0L375.3 336l40.7 0 32 176L0 512 32 336l40.7 0L32 224l73.3 0c-6-14.8-9.3-31-9.3-48c0-4.1 .2-8.1 .6-12.1C57 155.1 32 142.3 32 128c0-17 35.5-32 89.1-40.5zM144 224l64 0 8-32 16 0 8 32 64 0 13.5-54.1C289.8 173.8 258 176 224 176s-65.8-2.2-93.5-6.1L144 224zm-16 64l48 192 32-128-16-32-64-32zM272 480l48-192-64 32-16 32 32 128z"]
};
const faOtter = {
  prefix: 'fass',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M188.8 193.6L208 208l16 0 32 0 0-16 0-32 0-16c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 56 0 8 32 0 16 0 19.2-14.4 7.9-5.9-7.5-5-3.6-2.4 0-4.3 0-24 0-8 8 0 48 0 8 0 0 8 0 24 0 4.3-3.6 2.4-7.5 5 7.9 5.9zM256 320l0 64 128 0 0-32 0-32 32-32 32-32 0-32 0-32 64 0 0 48 0 16 0 64 32 0 0-115.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8 8.2-30.9 19.9 4C576 86.1 640 164.2 640 254.9l0 1.1s0 0 0 0c0 123.7-100.3 224-224 224l-1.1 0L256 480l-.6 0C132 480 32 380 32 256.6l0-.6-16 0 0-48 0-64L0 144 0 96l24 0 2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0 24 0 0 48-16 0 0 16 48 0 32 0 0 64-32 0-32 0 0 32 80 0-48 48 0 16-32 0c-41.8 0-77.4-26.7-90.5-64L192 256l-32-24-32 24-32 0c0 35.3 28.7 64 64 64l64 0 32 0zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faDreidel = {
  prefix: 'fass',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M422.6 102.6L445.3 80 400 34.7 377.4 57.4 288 146.7 214.6 73.4 192 50.7 169.4 73.4l-68.7 68.7L337.9 379.3l68.7-68.7L429.3 288l-22.6-22.6L333.3 192l89.4-89.4zM315.3 401.9L78.1 164.7 9.4 233.4 0 242.7 0 256 0 448l0 32 32 0 192 0 13.3 0 9.4-9.4 68.7-68.7z"]
};
const faPersonDress = {
  prefix: 'fass',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-42-65.8L272 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0L96.2 239.4l-42 65.8L.2 270.8 82 142.8 91.4 128z"]
};
const faFemale = faPersonDress;
const faCommentDollar = {
  prefix: 'fass',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM276 144l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3z"]
};
const faBusinessTime = {
  prefix: 'fass',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M128 0l24 0L360 0l24 0 0 24 0 72 128 0 0 96.7c-5.3-.5-10.6-.7-16-.7c-54.7 0-103.5 24.9-135.8 64l-8.2 0-160 0L0 256 0 96l128 0 0-72 0-24zM320 368c0 42.5 15.1 81.6 40.2 112L0 480 0 288l192 0 0 64 128.7 0c-.5 5.3-.7 10.6-.7 16zM336 48L176 48l0 48 160 0 0-48zm16 320a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16z"]
};
const faBriefcaseClock = faBusinessTime;
const faFlowerTulip = {
  prefix: 'fass',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M176 80L96 32l0 96c0 70.7 57.3 128 128 128l0 138.8C192.1 349.5 139.5 320 80 320L0 320l0 16c0 97.2 78.8 176 176 176l48 0 32 0 32 0 48 0c97.2 0 176-78.8 176-176l0-16-80 0c-59.5 0-112.1 29.5-144 74.8L288 256c70.7 0 128-57.3 128-128l0-96L336 80 256 0 176 80z"]
};
const faPeoplePantsSimple = {
  prefix: 'fass',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM232 352l-8-192L32 160 24 352l40 0 0 160 128 0 0-160 40 0zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM488 352l-8-192-192 0-8 192 40 0 0 160 128 0 0-160 40 0z"]
};
const faCloudDrizzle = {
  prefix: 'fass',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm-8 56l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm96 64l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm192-24l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0zm-96-40l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm192-24l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0z"]
};
const faTableCellsLarge = {
  prefix: 'fass',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M448 96l0 128-160 0 0-128 160 0zm0 192l0 128-160 0 0-128 160 0zM224 224L64 224 64 96l160 0 0 128zM64 288l160 0 0 128L64 416l0-128zM64 32L0 32 0 96 0 416l0 64 64 0 384 0 64 0 0-64 0-320 0-64-64 0L64 32z"]
};
const faThLarge = faTableCellsLarge;
const faBookTanakh = {
  prefix: 'fass',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0L0 512l0-64 32 0 0-64L0 384 0 0 32 0 64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM208 40L194.1 64l-27.7 48L111 112l-27.7 0 13.9 24 27.7 48L97.1 232 83.3 256l27.7 0 55.4 0 27.7 48L208 328l13.9-24 27.7-48 55.4 0 27.7 0-13.9-24-27.7-48 27.7-48 13.9-24L305 112l-55.4 0L221.9 64 208 40zm13.9 72l-27.7 0L208 88l13.9 24zm-41.6 24l55.4 0 27.7 48-27.7 48-55.4 0-27.7-48 27.7-48zm-27.7 0l-13.9 24-13.9-24 27.7 0zm-13.9 72l13.9 24-27.7 0 13.9-24zm55.4 48l27.7 0L208 280l-13.9-24zm69.3-24l13.9-24 13.9 24-27.7 0zm13.9-72l-13.9-24 27.7 0-13.9 24z"]
};
const faTanakh = faBookTanakh;
const faSolarSystem = {
  prefix: 'fass',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M448 256c0 41.9-13.4 80.6-36.2 112.2C387.3 370.3 368 390.9 368 416c0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192zM256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2C124.7 141.7 144 121.1 144 96c0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448zM360 256c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4c.2 20.6 16 37.6 36.2 39.5c7.5 14.4 11.8 30.8 11.8 48.2zm32-88c0-22.1-17.9-40-40-40c-4 0-7.8 .6-11.5 1.7C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152s68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3c1.8-4.6 2.8-9.5 2.8-14.7zM256 320l64-64-64-64-64 64 64 64z"]
};
const faSealQuestion = {
  prefix: 'fass',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M256 0l75 75 106 0 0 106 75 75-75 75 0 106-106 0-75 75-75-75L75 437l0-106L0 256l75-75L75 75l106 0L256 0zM168 184l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 236.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c12.4-7.1 21.7-18 27-30.8l4.7 0 0-24c0-34.9-28.3-63.1-63.1-63.1L224 128c-30.9 0-56 25.1-56 56zm64 152l0 48 48 0 0-48-48 0z"]
};
const faPhoneVolume = {
  prefix: 'fass',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448C200.6 512 0 311.4 0 64L0 32zM464 256c0-114.9-93.1-208-208-208l0-48C397.4 0 512 114.6 512 256l-48 0zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-80l0-48c88.4 0 160 71.6 160 160l-48 0c0-61.9-50.1-112-112-112z"]
};
const faVolumeControlPhone = faPhoneVolume;
const faDiscDrive = {
  prefix: 'fass',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M32 32l448 0 0 384 32 0 0 64-32 0L32 480 0 480l0-64 32 0L32 32zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z"]
};
const faHatCowboySide = {
  prefix: 'fass',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M160 96l-17.7 97.1c6.8-.7 13.6-1.1 20.5-1.1l10.7 0c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L464 32l-64 0L160 96zM0 448l544 0L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9l-10.7 0c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2L0 448z"]
};
const faTableRows = {
  prefix: 'fass',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M0 32l512 0 0 448L0 480 0 32zM128 96l0 128 320 0 0-128L128 96zM448 288l-320 0 0 128 320 0 0-128z"]
};
const faRows = faTableRows;
const faLocationExclamation = {
  prefix: 'fass',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM216 96l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM168 336l0-48 48 0 0 48-48 0z"]
};
const faMapMarkerExclamation = faLocationExclamation;
const faFaceFearful = {
  prefix: 'fass',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80l0 16-160 0 0-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8L95.2 150.6 73.4 127.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm173 .9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faClipboardUser = {
  prefix: 'fass',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M192 0c-41.8 0-77.4 26.7-90.5 64L0 64 0 512l384 0 0-448L282.5 64C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96L80 448l32-96 160 0z"]
};
const faBusSchool = {
  prefix: 'fass',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M256 0C371.9 0 464 48 464 48l0 48 0 16 48 0 0 128-48 0 0 16 16 0 0 192-32 0 0 64-96 0 0-64-192 0 0 64-96 0 0-64-32 0 0-192 16 0L48 96s0 0 0 0l0-48s92.1-48 208-48zM48 240L0 240 0 112l48 0 0 128zM272 128l0 128 128 0 0-128-128 0zm-32 0l-128 0 0 128 128 0 0-128zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 96l0-32-16 0L176 64l-16 0 0 32 16 0 160 0 16 0z"]
};
const faFilmSlash = {
  prefix: 'fass',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M29.4 .1l19 14.7L70.5 32 576 32l0 392.4 44.9 34.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1zM317.9 224l98.1 0 0-128L224 96l0 55.1L317.9 224zm88.3 192l81.2 64L64 480l0-333.6L162.5 224 112 224l0 64 64 0 0-53.3L243.7 288 224 288l0 128 182.2 0zM176 352l-64 0 0 64 64 0 0-64zM528 224l-64 0 0 64 64 0 0-64zM464 96l0 64 64 0 0-64-64 0z"]
};
const faSquareArrowDownRight = {
  prefix: 'fass',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M0 480l448 0 0-448L0 32 0 480zM312 368l-152 0-24 0 0-48 24 0 94.1 0L119 185l-17-17L136 134.1l17 17 135 135L288 184l0-24 48 0 0 24 0 160 0 24-24 0z"]
};
const faBookSparkles = {
  prefix: 'fass',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0L448 0 416 0 384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zM264 200l24-56 24 56 56 24-56 24-24 56-24-56-56-24 56-24zM176 64l16 32 32 16-32 16-16 32-16-32-32-16 32-16 16-32z"]
};
const faBookSpells = faBookSparkles;
const faWashingMachine = {
  prefix: 'fass',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M0 0L448 0l0 512L0 512 0 0zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"]
};
const faWasher = faWashingMachine;
const faChild = {
  prefix: 'fass',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm4.9 96l16 0 86.2 0 16 0 9.6 12.8 72.1 96L320 294.4l-51.2 38.4-19.2-25.6L240 294.4 240 480l0 32-64 0 0-32 0-96-32 0 0 96 0 32-64 0 0-32 0-185.6-9.6 12.8L51.2 332.8 0 294.4l19.2-25.6 72.1-96 9.6-12.8z"]
};
const faLiraSign = {
  prefix: 'fass',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M112 159.2c0-34.9 28.3-63.2 63.2-63.2c7.4 0 14.7 1.3 21.6 3.8l72.2 26.3L299.1 137 321 76.9 290.9 65.9 218.7 39.7c-13.9-5.1-28.6-7.7-43.5-7.7C105 32 48 89 48 159.2L48 192 0 192l0 64 48 0 0 32L0 288l0 64 40.2 0L3.4 425.7 0 432.4 0 440l0 8 0 32 32 0 256 0 32 0 0-64-32 0L79.8 416l28.8-57.7 3.2-6.3L256 352l0-64-144 0 0-32 144 0 0-64-144 0 0-32.8z"]
};
const faUserVisor = {
  prefix: 'fass',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M342.7 176c-19 46.9-65 80-118.7 80s-99.7-33.1-118.7-80L80 176 80 48l44.1 0C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L368 48l0 128-25.3 0zM384 304l64 208L0 512 64 304l320 0zM328 440l24 24 8-8-40-88-40 88 8 8 40-24zM144 96l-16 0 0 32 16 0 160 0 16 0 0-32-16 0L144 96z"]
};
const faFilePlusMinus = {
  prefix: 'fass',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM208 208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16zM128 384l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0z"]
};
const faChessClockFlip = {
  prefix: 'fass',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M384 32l160 0 0 48-56 0 0 48 152 0 0 352L0 480 0 128l96 0 0-32 160 0 0 32 184 0 0-48-56 0 0-48zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm-41.4-48l-11.3 11.3-48 48L176 326.6 153.4 304l11.3-11.3 48-48L224 233.4 246.6 256zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm16-176l0 64 0 16-32 0 0-16 0-64 0-16 32 0 0 16z"]
};
const faChessClockAlt = faChessClockFlip;
const faSatellite = {
  prefix: 'fass',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M384 416l33.9-33.9 60.1-60.1L512 288l-33.9-33.9L416 192l80-80L400 16 320 96 257.9 33.9 224 0 190.1 33.9 129.9 94.1 96 128l33.9 33.9L192 224l-17 17c-24.1-10.9-50.9-17-79-17c-34.5 0-66.9 9.1-94.9 25.1L120.7 368.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l24.4-24.4L262.9 510.9c16-28 25.1-60.4 25.1-94.9c0-28.2-6.1-54.9-17-79l17-17 62.1 62.1L384 416zM321.9 286.1l60.1-60.1L444.1 288 384 348.1l-62.1-62.1zm-96-96L163.9 128 224 67.9l62.1 62.1-60.1 60.1z"]
};
const faTruckFire = {
  prefix: 'fass',
  iconName: 'truck-fire',
  icon: [640, 512, [], "e65a", "M0 0L0 48l32 0 0 48L0 96 0 224l384 0 0-128 0-16 0-32 256 0 0-48L0 0zM0 256L0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l64 0 0-160 0-128 0-32-32 0-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0-32 0 0 144 0 16-16 0L0 256zM280 48l56 0 0 48-56 0 0-48zM232 96l-48 0 0-48 48 0 0 48zM80 48l56 0 0 48L80 96l0-48zM576 160l0 96-96 0 0-96 96 0zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faPlaneLock = {
  prefix: 'fass',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3 104.3 69.5C419 242.6 416 257 416 272l0 16-32 0 0 53.3L320 320l0 80 64 48 0 64L256 480 128 512l0-64 64-48 0-80L0 384l0-96L192 160l0-66.3zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faSteeringWheel = {
  prefix: 'fass',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M224 358.9l0 86.5C143.6 431.9 80.1 368.4 66.7 288l102.2 0L224 358.9zm64 0L343.1 288l102.2 0C431.9 368.4 368.4 431.9 288 445.3l0-86.5zM352 224l-16-32-160 0-16 32-93.3 0C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160L352 224zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faTag = {
  prefix: 'fass',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M0 32L0 256 224 480 448 256 224 32 0 32zm112 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faStretcher = {
  prefix: 'fass',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M70.8 63.5L189.1 192 640 192l0 96-472 0-21.1 0-14.3-15.5L.2 128.5l70.6-65zM263.2 320l81.6 0L368 336.9 391.2 320l81.6 0-64 46.5 37.3 27.1c9.8-6.1 21.4-9.7 33.9-9.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.3 .7-10.5 1.9-15.5L368 396.2l-49.9 36.3c1.2 5 1.9 10.2 1.9 15.5c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c12.4 0 24 3.5 33.9 9.7l37.3-27.1-64-46.5zM272 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faBookSection = {
  prefix: 'fass',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM235.9 243.2c37.9 9.8 46.1 15 43.6 27.7c-2.5 13.2-23.7 19.6-51.7 15.7c-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9-9.8 30.5 5.8 1.9s0 0 0 0c12 3.9 25.7 8.3 38.6 10.1c7 1 13.8 1.5 20.2 1.5c36.5 0 62.2-15.8 67.3-42.8c4.1-21.2-4-34.9-16.7-44.4c8.7-7.1 14.5-16.4 16.7-27.6c8.6-45.1-36.9-56.9-67-64.7c0 0 0 0 0 0l-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8c2.5-13.2 23.8-19.7 51.6-15.7c6.6 .9 14.6 2.9 25.2 6.2l9.5-30.6c-12.2-3.8-21.9-6.2-30.2-7.3c-47.1-6.7-81.5 9.6-87.5 41.3c-4.1 21.3 4.4 35.1 16.7 44.5c-8.7 7.1-14.5 16.4-16.7 27.5c-8.5 44.6 37.4 56.8 59.5 62.7l7.5 2zm0-72c37.9 9.8 46.1 15 43.6 27.7c-2.2 11.3-16.5 14.9-25.2 16.1c-3.6-1-17.7-4.7-17.7-4.7c-36.5-9.7-38-16.5-36.3-25.8c2.2-11.3 16.5-14.9 25.2-16.1c.9 .2 10.3 2.7 10.3 2.7z"]
};
const faBookLaw = faBookSection;
const faInboxes = {
  prefix: 'fass',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M74.3 0L96 0 416 0l21.7 0 8 20.1 64 160 2.3 5.7 0 6.2 0 96 0 32-32 0L32 320 0 320l0-32 0-96 0-6.2 2.3-5.7 64-160L74.3 0zm43.3 64L79.3 160l64.7 0 32 64 160 0 32-64 64.7 0L394.3 64 117.7 64zM0 352l144 0 32 64 160 0 32-64 144 0 0 160L0 512 0 352z"]
};
const faCoffeeBean = {
  prefix: 'fass',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M400.3 74c1 .9 1.9 1.8 2.9 2.8c74.2 74.2 54.2 214.6-44.8 313.6C271.2 477.5 152 503.5 74 457.8l68.4-124.3L331.2 207.6l3.5-2.4 1.9-3.8L400.3 74zM48.2 438.4c-1.1-1.1-2.2-2.1-3.3-3.2C-29.4 361-9.4 220.6 89.6 121.6C176.9 34.3 296.4 8.4 374.3 54.4L309.9 183.3 121.4 309l-3.3 2.2-1.9 3.4L48.2 438.4z"]
};
const faCircleYen = {
  prefix: 'fass',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM137.5 144l61 0L256 217.2 313.5 144l61 0-11.7 14.8L286.5 256l33.5 0 16 0 0 32-16 0-40 0 0 32 40 0 16 0 0 32-16 0-40 0 0 25 0 24-48 0 0-24 0-25-40 0-16 0 0-32 16 0 40 0 0-32-40 0-16 0 0-32 16 0 33.5 0-76.4-97.2L137.5 144z"]
};
const faBracketsCurly = {
  prefix: 'fass',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M64 32l32 0 96 0 32 0 0 64-32 0-64 0 0 96 0 13.3-9.4 9.4L77.3 256l41.4 41.4 9.4 9.4 0 13.3 0 96 64 0 32 0 0 64-32 0-96 0-32 0 0-32 0-114.7L9.4 278.6 0 269.3l0-26.5 9.4-9.4L64 178.7 64 64l0-32zm448 0l0 32 0 114.7 54.6 54.6 9.4 9.4 0 26.5-9.4 9.4L512 333.3 512 448l0 32-32 0-96 0-32 0 0-64 32 0 64 0 0-96 0-13.3 9.4-9.4L498.7 256l-41.4-41.4-9.4-9.4 0-13.3 0-96-64 0-32 0 0-64 32 0 96 0 32 0z"]
};
const faEllipsisStrokeVertical = {
  prefix: 'fass',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M112 80l0 32-32 0 0-32 32 0zM80 32L32 32l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0L80 32zm32 208l0 32-32 0 0-32 32 0zM80 192l-48 0 0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0zm0 208l32 0 0 32-32 0 0-32zM32 352l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0z"]
};
const faEllipsisVAlt = faEllipsisStrokeVertical;
const faComment = {
  prefix: 'fass',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1z"]
};
const faSquare1 = {
  prefix: 'fass',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M0 32l448 0 0 448L0 480 0 32zM144 336l0 48 24 0 56 0 56 0 24 0 0-48-24 0-32 0 0-184 0-24-24 0-8 0-6.2 0-5.4 3L144 164.5l0 54.9 11.7-6.5L200 188.3 200 336l-32 0-24 0z"]
};
const faCakeCandles = {
  prefix: 'fass',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M96 0L63.9 44.9C58.8 52.1 56 60.8 56 69.6L56 72c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L96 0zM224 0L191.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6l0 2.4c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L224 0zm95.9 44.9c-5.1 7.2-7.9 15.8-7.9 24.6l0 2.4c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.4c0-8.8-2.8-17.5-7.9-24.6L352 0 319.9 44.9zM128 176l0-32-64 0 0 32 0 48L0 224 0 350.8l29.2 15.3 60-28.6 7.1-3.4 7 3.5L160 366.1l56.8-28.4 7.2-3.6 7.2 3.6L288 366.1l56.8-28.4 7-3.5 7 3.4 60 28.6L448 350.8 448 224l-64 0 0-48 0-32-64 0 0 32 0 48-64 0 0-48 0-32-64 0 0 32 0 48-64 0 0-48zM448 386.9l-21.3 11.2-7.1 3.7-7.2-3.4-60.2-28.6-57 28.5-7.2 3.6-7.2-3.6L224 369.9l-56.8 28.4-7.2 3.6-7.2-3.6-57-28.5L35.7 398.4l-7.2 3.4-7.1-3.7L0 386.9 0 512l448 0 0-125.1z"]
};
const faBirthdayCake = faCakeCandles;
const faCake = faCakeCandles;
const faHeadSide = {
  prefix: 'fass',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zm352-.3a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTruckLadder = {
  prefix: 'fass',
  iconName: 'truck-ladder',
  icon: [640, 512, [], "e657", "M0 0L0 48l32 0 0 96L0 144l0 48 352 0 0-48-32 0 0-96 32 0 0-48L0 0zM272 144l-32 0 0-96 32 0 0 96zM160 48l32 0 0 96-32 0 0-96zm-48 96l-32 0 0-96 32 0 0 96zM416 96l-32 0 0 32 0 96L0 224 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l64 0 0-128 0-32 0-32 0-13.3-9.4-9.4-96-96L525.3 96 512 96l-96 0zM576 256l-128 0 0-32 0-64 50.7 0L576 237.3l0 18.7zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faEnvelope = {
  prefix: 'fass',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M0 64l512 0 0 80L256 320 0 144 0 64zM0 448L0 182.8 237.9 346.4 256 358.8l18.1-12.5L512 182.8 512 448 0 448z"]
};
const faDollyEmpty = {
  prefix: 'fass',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M32 0L0 0 0 64l32 0 72.9 0L197 340.2c-22.5 17.6-37 45-37 75.8c0 53 43 96 96 96c52.4 0 95.1-42 96-94.3l202.1-67.4 30.4-10.1-20.2-60.7-30.4 10.1L331.8 357c-17.2-22.1-43.9-36.5-74-37L158.4 21.9 151.1 0 128 0 32 0z"]
};
const faFaceTissue = {
  prefix: 'fass',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 15.9 1.5 31.5 4.2 46.7l205.9-38.1 45.8-8.5-8.5 45.8-9.4 51 18 12 39.1-26.1 8.9-5.9 8.9 5.9 40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 371.2l-39.1 26.1-8.9 5.9-8.9-5.9L231.7 387 209.3 507.8c15.1 2.8 30.7 4.2 46.7 4.2zM230.9 192L112 256l45.7-64L112 128l118.9 64zM400 128l-45.7 64L400 256 281.1 192 400 128zM216 296L0 336l64 48L32 480l96-32 48 64 40-216z"]
};
const faAnglesUp = {
  prefix: 'fass',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M246.6 41.4L224 18.7 201.4 41.4l-160 160L18.7 224 64 269.3l22.6-22.6L224 109.3 361.4 246.6 384 269.3 429.3 224l-22.6-22.6-160-160zm0 192L224 210.7l-22.6 22.6-160 160L18.7 416 64 461.3l22.6-22.6L224 301.3 361.4 438.6 384 461.3 429.3 416l-22.6-22.6-160-160z"]
};
const faAngleDoubleUp = faAnglesUp;
const faBinRecycle = {
  prefix: 'fass',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 32l576 0 0 64L0 96 0 32zm32 96l512 0L512 480 64 480 32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l33.8 48.3 40.8-25.5-35.2-50.3c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-35.2 50.3 40.8 25.5 33.8-48.3c1.3-1.8 3.3-2.9 5.5-2.9zM180.4 281l-34.5 49.3c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4l73.6 0 0-48-73.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l36-51.4L180.4 281zM312 416l73.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2L395.6 281l-40.8 25.5 36 51.4c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L312 368l0 48z"]
};
const faPaperclip = {
  prefix: 'fass',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M325.5 60c-16.6 0-32.5 6.6-44.2 18.3L91.6 268C71.4 288.2 60 315.7 60 344.2C60 403.8 108.2 452 167.8 452c28.6 0 56-11.4 76.2-31.6L404.2 260.2l39.6 39.6L283.6 460c-30.7 30.7-72.4 48-115.8 48C77.3 508 4 434.7 4 344.2c0-43.4 17.3-85.1 48-115.8L241.7 38.7C263.9 16.5 294.1 4 325.5 4C390.9 4 444 57.1 444 122.5c0 31.4-12.5 61.6-34.7 83.8L225.1 390.5c-13.7 13.7-32.4 21.5-51.8 21.5c-40.5 0-73.3-32.8-73.3-73.3c0-19.4 7.7-38.1 21.5-51.8L284.2 124.2l39.6 39.6L161.1 326.5c-3.2 3.2-5.1 7.6-5.1 12.2c0 9.5 7.7 17.3 17.3 17.3c4.6 0 9-1.8 12.2-5.1L369.7 166.7C381.4 155 388 139.1 388 122.5C388 88 360 60 325.5 60z"]
};
const faChartLineDown = {
  prefix: 'fass',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zM304 98.7l-22.6 22.6L208 194.7l-57.4-57.4-45.3 45.3 80 80L208 285.3l22.6-22.6L304 189.3l57.4 57.4L320 288l32 32 128 0 0-128-32-32-41.4 41.4-80-80L304 98.7z"]
};
const faArrowRightToCity = {
  prefix: 'fass',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M288 0L480 0l0 192 40 0 0-72 0-24 48 0 0 24 0 72 72 0 0 320-160 0-96 0-96 0L288 0zm64 64l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm224 0l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM150.6 153.4l80 80L253.3 256l-22.6 22.6-80 80L128 381.3 82.7 336l22.6-22.6L130.7 288 32 288 0 288l0-64 32 0 98.7 0-25.4-25.4L82.7 176 128 130.7l22.6 22.6z"]
};
const faLockA = {
  prefix: 'fass',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 80 0 0 320L0 512 0 192l80 0zM268.7 408l16.7 40 34.7 0L240 256l-32 0L128 448l34.7 0 16.7-40 89.3 0zm-13.3-32l-62.7 0L224 300.8 255.3 376z"]
};
const faRibbon = {
  prefix: 'fass',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M333.2 322.8s0 0 0 0l-133.9-146s0 0 0 0L146 118.6c7.8-5.1 78-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4L384 216l0-96L304 0 144 0 64 112l0 88 79.6 91.3s0 0 0 0l83.3 95.6s0 0 0 0l19.6 22.5L336 512l112-64L333.2 322.8zM205.2 410.6l-83.3-95.6L0 448l112 64 93.2-101.4z"]
};
const faLungs = {
  prefix: 'fass',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M352 32l0-32L288 0l0 32 0 32 0 126.4-32 20.4 0-82.8 0-32-32 0-56 0-16 0-9.6 12.8L168 128c-25.6-19.2-25.6-19.2-25.6-19.2s0 0 0 0c0 0 0 0 0 0l-.1 .1-.3 .4-1.1 1.5c-1 1.3-2.3 3.2-4.1 5.6c-3.5 4.8-8.4 11.8-14.3 20.6c-11.8 17.5-27.8 42.2-44.3 71.1C45.8 264.9 9.1 341.4 .2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7L231.8 479 256 473l0-25 0-123.4L151.4 391.2l-17.2-27 27-17.2L320 245.9 478.8 347l26.5 16.9L488 391.2 384 325l0 123 0 25 24.2 6.1 121.2 30.3c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-8.8-70.6-45.5-147.2-78-203.9c-16.5-28.9-32.4-53.6-44.3-71.1c-5.9-8.8-10.8-15.7-14.3-20.6c-1.7-2.4-3.1-4.3-4.1-5.6l-1.1-1.5-.3-.4-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L472 128l25.6-19.2L488 96l-16 0-56 0-32 0 0 32 0 82.8-32-20.4L352 64l0-32z"]
};
const faPersonPinball = {
  prefix: 'fass',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM0 128l32 0 48 0 17.1 0 9.5 14.3L161.1 224l62.9 0 32 0 0 18.2 292.1-48.7L513.6 90.1 512 85.2l0-5.2 0-48 0-32 32 0 64 0 32 0 0 32 0 146.2 0 37.8 0 8 0 32 0 224 0 32-64 0 0-32 0-96-320 0 0 96 0 32-64 0 0-32 0-192-48 0-17.1 0-9.5-14.3L96 241.7l0 65.1 54.6 54.6 9.4 9.4 0 13.3 0 96 0 32-64 0 0-32 0-82.7L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7L0 160l0-32zM0 480L0 346.5l64 64L64 480s0 0 0 0l0 32L0 512l0-32zM280 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faArrowUp91 = {
  prefix: 'fass',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M432 152a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88-32c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L458.3 256l-74.9 0 5.2-8.6 25.1-41.3C373.9 197.7 344 162.3 344 120zM160 32.6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6zM352 288l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64z"]
};
const faSortNumericUpAlt = faArrowUp91;
const faAppleCore = {
  prefix: 'fass',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M176 96l0-16c0-44.2 35.8-80 80-80l16 0 16 0 0 16 0 16c0 44.2-35.8 80-80 80l-16 0-16 0 0-16zM14.2 155.3C31.2 138.4 53.1 128 80 128l112 32 112-32c26.9 0 48.8 10.4 65.8 27.3C320.6 186.5 288 241.4 288 304c0 60.4 30.5 113.8 76.9 145.5C335 488.6 295.5 512 256 512l-64-16-64 16c-39.5 0-79-23.4-108.9-62.5C65.5 417.8 96 364.4 96 304c0-62.6-32.6-117.5-81.8-148.7z"]
};
const faCircleY = {
  prefix: 'fass',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 295.9L120.6 144l59.5 0L256 247.4 331.8 144l59.5 0L280 295.9l0 80.1 0 24-48 0 0-24 0-80.1z"]
};
const faH6 = {
  prefix: 'fass',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M64 64l0 32 0 128 192 0 0-128 0-32 64 0 0 32 0 160 0 160 0 32-64 0 0-32 0-128L64 288l0 128 0 32L0 448l0-32L0 256 0 96 0 64l64 0zM496 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM352 304c0-38 12.1-75 34.6-105.6L485.1 64l79.4 0-70.4 96c.6 0 1.3 0 1.9 0c79.5 0 144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144z"]
};
const faLitecoinSign = {
  prefix: 'fass',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M128 64l0-32L64 32l0 32 0 149.6L23.2 225.2-7.6 234 10 295.6l30.8-8.8L64 280.1 64 448l0 32 32 0 256 0 32 0 0-64-32 0-224 0 0-154.1 136.8-39.1 30.8-8.8L278 152.4l-30.8 8.8L128 195.3 128 64z"]
};
const faBottleBaby = {
  prefix: 'fass',
  iconName: 'bottle-baby',
  icon: [512, 512, [], "e673", "M192 96l0-32 32-16 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 16 0 32 32 0 0 64-192 0 0-64 32 0zm32 176l-108.4 0c4.5-19.6 13-38.1 25.2-54.4L160 192l192 0 19.2 25.6C389.9 242.5 400 272.8 400 304l0 208-288 0 0-80 112 0 0-48-112 0 0-64 112 0 0-48z"]
};
const faCircleSmall = {
  prefix: 'fass',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
const faBorderNone = {
  prefix: 'fass',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M0 416l0 64 64 0 0-64L0 416zm96 64l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zm0 128l0 64 64 0 0-64-64 0zM288 480l64 0 0-64-64 0 0 64zm0-448l0 64 64 0 0-64-64 0zm0 256l64 0 0-64-64 0 0 64zM192 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zm0 128l0 64 64 0 0-64-64 0zM384 480l64 0 0-64-64 0 0 64zm0-384l64 0 0-64-64 0 0 64zM0 32L0 96l64 0 0-64L0 32zM384 288l64 0 0-64-64 0 0 64zM0 224l0 64 64 0 0-64L0 224zM192 384l64 0 0-64-64 0 0 64zm192-64l0 64 64 0 0-64-64 0zM0 384l64 0 0-64L0 320l0 64zM384 128l0 64 64 0 0-64-64 0zM0 192l64 0 0-64L0 128l0 64zm192-64l0 64 64 0 0-64-64 0z"]
};
const faArrowTurnDownLeft = {
  prefix: 'fass',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M445.3 64l0-32 64 0 0 32 0 224 0 32-32 0-354.7 0 73.4 73.4L218.5 416l-45.3 45.3-22.6-22.6-128-128L0 288l22.6-22.6 128-128 22.6-22.6L218.5 160l-22.6 22.6L122.5 256l322.7 0 0-192z"]
};
const faCircleWifiCircleWifi = {
  prefix: 'fass',
  iconName: 'circle-wifi-circle-wifi',
  icon: [640, 512, ["circle-wifi-group"], "e67e", "M256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-15.7 2.1-30.9 5.9-45.4c-16.1-21-41.4-34.6-69.9-34.6c-30.4 0-57.3 15.5-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6c34.9 0 66.7 13.1 90.7 34.7c8.9-14.2 19.8-27.1 32.2-38.2C345.7 208.7 302.8 192 256 192c-57.1 0-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144c63.6 0 121.4 24.7 164.3 65.1C443.2 198.1 468.9 192 496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-31.5-20.4l-25.6 19.2C564.3 338.6 532.3 320 496 320s-68.3 18.6-86.9 46.8l-25.6-19.2c24.5-36 65.7-59.6 112.5-59.6s88.1 23.6 112.5 59.6zM496 352c26.2 0 49.4 12.6 64 32l-25.6 19.2C525.6 391.5 511.7 384 496 384s-29.6 7.5-38.4 19.2L432 384c14.6-19.4 37.8-32 64-32zm0 60a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"]
};
const faCircleWifiGroup = faCircleWifiCircleWifi;
const faCircleNodes = {
  prefix: 'fass',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"]
};
const faParachuteBox = {
  prefix: 'fass',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16L240 192l0 128-55.5 0L68.2 192l28.3 0c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C50.3 53.5 8.3 142.1 0 192l24.9 0L160 340.6 160 512l192 0 0-171.4L487.1 192l24.9 0c-8.3-49.9-50.3-138.5-153.1-175.3C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16l28.3 0L327.5 320 272 320l0-128 111.5 0z"]
};
const faReflectHorizontal = {
  prefix: 'fass',
  iconName: 'reflect-horizontal',
  icon: [512, 512, [], "e664", "M280 0L232 0l0 24 0 464 0 24 48 0 0-24 0-464 0-24zM32 416L192 256 32 96 0 96 0 416l32 0zM320 256L480 416l32 0 0-320-32 0L320 256z"]
};
const faMessageMedical = {
  prefix: 'fass',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM224 112l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faCommentAltMedical = faMessageMedical;
const faRugbyBall = {
  prefix: 'fass',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M226.2 105.9l-2.3 1.2-1.8 1.8L108.9 222.1l-1.8 1.8-1.2 2.3L16 406.1 16 336C16 159.3 159.3 16 336 16l70.1 0L226.2 105.9zm16.6 27.5L447.2 31.2l33.6 33.6L378.6 269.2 269.2 378.6 64.8 480.8 31.2 447.2 133.4 242.8 242.9 133.4zM105.9 496l179.8-89.9 2.3-1.2 1.8-1.8L403.1 289.9l1.8-1.8 1.2-2.3L496 105.9l0 70.1c0 176.7-143.3 320-320 320l-70.1 0z"]
};
const faCommentMusic = {
  prefix: 'fass',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM352 128l0-23.1L330.4 113l-128 48L192 164.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faIndent = {
  prefix: 'fass',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 32l448 0 0 64L0 96 0 32zM192 160l256 0 0 64-256 0 0-64zM448 288l0 64-256 0 0-64 256 0zM0 416l448 0 0 64L0 480l0-64zm0-64L0 160l128 96L0 352z"]
};
const faTreeDeciduous = {
  prefix: 'fass',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M384 80l-33.3 0C343.1 34.6 303.6 0 256 0s-87.1 34.6-94.7 80L128 80c-44.2 0-80 35.8-80 80l0 44.8C19.3 221.4 0 252.5 0 288l0 96 224 0 0 96 0 32 64 0 0-32 0-96 224 0 0-96c0-35.5-19.3-66.6-48-83.2l0-44.8c0-44.2-35.8-80-80-80z"]
};
const faTreeAlt = faTreeDeciduous;
const faPuzzlePieceSimple = {
  prefix: 'fass',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M256 144c0-17.8 12.9-33.3 32-41.6L288 64 128 64l0 160-38.4 0c-8.3-19.1-23.8-32-41.6-32c-26.5 0-48 28.7-48 64s21.5 64 48 64c17.8 0 33.3-12.9 41.6-32l38.4 0 0 160 160 0 0-38.4c-19.1-8.3-32-23.8-32-41.6c0-26.5 28.7-48 64-48s64 21.5 64 48c0 17.8-12.9 33.3-32 41.6l0 38.4 160 0 0-160 38.4 0c8.3 19.1 23.8 32 41.6 32c26.5 0 48-28.7 48-64s-21.5-64-48-64c-17.8 0-33.3 12.9-41.6 32L512 224l0-160L352 64l0 38.4c19.1 8.3 32 23.8 32 41.6c0 26.5-28.7 48-64 48s-64-21.5-64-48z"]
};
const faPuzzlePieceAlt = faPuzzlePieceSimple;
const faTruckFieldUn = {
  prefix: 'fass',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M384 32L32 32l0 96L0 128 0 288l32 0 0 32L0 320l0 64 32 0 32 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-96-68.1 0L477.2 83l-8.4-19L448 64l-64 0 0-32zm0 96l43.2 0 42.7 96L384 224l0-96zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm320 96a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16 32 0 0 16zm112-16l8 0 9.9 0 4.4 8.8L288 188.2l0-44.2 0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L256 195.8l0 44.2 0 16-32 0 0-16 0-96 0-16 16 0z"]
};
const faNfcTrash = {
  prefix: 'fass',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M0 32l448 0 0 128-13.7 0-16 32L384 192l0-80 0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 64 0 96 0 96L96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96l0 16 0 288 0 16 16 0 288 0 9.1 0 4.6 64L0 480 0 32zM454.1 192l9.9 0 96 0 9.9 0 4.4 8.8L585.9 224l38.1 0 16 0 0 32-16 0-48 0-128 0-48 0-16 0 0-32 16 0 38.1 0 11.6-23.2 4.4-8.8zM608 512l-192 0L400 288l224 0L608 512z"]
};
const faHourglass = {
  prefix: 'fass',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M32 0L0 0 0 64l32 0 0 64 0 13.3 9.4 9.4L146.7 256 41.4 361.4 32 370.7 32 384l0 64L0 448l0 64 32 0 320 0 32 0 0-64-32 0 0-64 0-13.3-9.4-9.4L237.3 256 342.6 150.6l9.4-9.4 0-13.3 0-64 32 0 0-64L352 0 32 0zM288 64l0 50.7-96 96-96-96L96 64l192 0zM192 301.3l96 96 0 50.7L96 448l0-50.7 96-96z"]
};
const faHourglassEmpty = faHourglass;
const faMountain = {
  prefix: 'fass',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M0 416l0 64 64 0 384 0 64 0 0-64L294.5 89.7 256 32 217.5 89.7 0 416zM307.1 224L256 224l-48 64-24.2-32.3L256 147.4 307.1 224z"]
};
const faFileXmark = {
  prefix: 'fass',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm33.9 256l-17 17-47 47 47 47 17 17L256 417.9l-17-17-47-47-47 47-17 17L94.1 384l17-17 47-47-47-47-17-17L128 222.1l17 17 47 47 47-47 17-17L289.9 256z"]
};
const faFileTimes = faFileXmark;
const faHouseHeart = {
  prefix: 'fass',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 224.4 448.7 0-1-224.4zM176 267.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 400.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z"]
};
const faHomeHeart = faHouseHeart;
const faHouseChimneyBlank = {
  prefix: 'fass',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M511.8 287.6l64.2 0 0-47.6-64-53.4L512 32l-96 0 0 74.5L288.4 0 0 240l0 47.6 64.1 0 0 224.4 448.7 0-1-224.4z"]
};
const faMeterBolt = {
  prefix: 'fass',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M256 512c80.8 0 152.9-37.5 199.9-96L384 416l0-71.7 127.9-97.1C507.2 109.9 394.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zM504 384L464 512 640 376l0-24-88 0 40-128L416 360l0 24 88 0z"]
};
const faUserDoctor = {
  prefix: 'fass',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l64 0 0 66.3c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-66.3 128 0 0 58c-27.6 7.1-48 32.2-48 62l0 40 0 16 16 0 16 0 16 0 0-32-16 0 0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24-16 0 0 32 16 0 16 0 16 0 0-16 0-40c0-29.8-20.4-54.9-48-62l0-58 64 0zM144 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faUserMd = faUserDoctor;
const faSlashBack = {
  prefix: 'fass',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M.1 0L71.2 0 319.9 512l-71.2 0L.1 0z"]
};
const faCircleInfo = {
  prefix: 'fass',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0-24 0 0-48 24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zm72-144l-64 0 0-64 64 0 0 64z"]
};
const faInfoCircle = faCircleInfo;
const faFishingRod = {
  prefix: 'fass',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M284.6 0L288 0l64 0 24 0 0 24 0 112 0 24-48 0 0-24 0-88-36.6 0L88 106.1 88 288l40 0 0 224L0 512 0 288l40 0L40 88l0-18.1 17.4-5 224-64 3.2-.9zM256 344c0-76.8 64-136 96-152c32 16 96 75.2 96 152c0 32-16 80-64 112l32 40 0 16-128 0 0-16 32-40c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faHammerCrash = {
  prefix: 'fass',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M318.3 338.9l-25.1-12.5-16.9 72.7 112.1-54.6 77.4 97.8 27.3-121.7 124.7 .5L539.6 224l78.2-97.2-124.7 .5L465.8 5.6 400.4 88.4l5.9 3 28.6 14.3-14.3 28.6-88 176-14.3 28.6zM304 296l88-176L184 16 64 16 0 144 304 296zM109.2 234.4L.1 452.5l85.9 42.9L195 277.3l-85.9-42.9z"]
};
const faMessageHeart = {
  prefix: 'fass',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM368 171.2c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 304.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7z"]
};
const faCloudMeatball = {
  prefix: 'fass',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M0 320l96 0 36.4 0 10.5-10.5 22.6-22.6 12.1-12.1 16.8 3.4 12.1 2.4 6.9-10.3 9.5-14.2 17.1 0 32 0 17.1 0 9.5 14.2 6.9 10.3 12.1-2.4 16.8-3.4 12.1 12.1 22.6 22.6L379.6 320l36.4 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96zM172.1 434.7l-6.6 33.1 22.6 22.6 33.1-6.6L240 512l32 0 18.7-28.1 33.1 6.6 22.6-22.6-6.6-33.1L368 416l0-32-28.1-18.7 6.6-33.1-22.6-22.6-33.1 6.6L272 288l-32 0-18.7 28.1-33.1-6.6-22.6 22.6 6.6 33.1L144 384l0 32 28.1 18.7zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faCameraPolaroid = {
  prefix: 'fass',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M64 32l32 0 384 0 32 0 0 32 0 182.3 58.6 87.9 5.4 8.1 0 9.7 0 96 0 32-32 0L32 480 0 480l0-32 0-96 0-9.7 5.4-8.1L64 246.3 64 64l0-32zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM384 96l0 64 64 0 0-64-64 0zM112 384l-16 0 0 32 16 0 352 0 16 0 0-32-16 0-352 0z"]
};
const faCamera = {
  prefix: 'fass',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M160 32L138.7 96 0 96 0 480l512 0 0-384L373.3 96 352 32 160 32zm96 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faCameraAlt = faCamera;
const faSquareVirus = {
  prefix: 'fass',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M448 32L0 32 0 480l448 0 0-448zM303.9 140.9l.1-.1 16.8-16.8 33.9 33.9-17 17-.2 .2c-20.5 20.7-5.8 55.9 23.4 55.9c0 0 0 0 0 0l24 0 0 48-24 0s0 0 0 0c-29.2 0-43.8 35.2-23.4 55.9l.2 .2 17 17-33.9 33.9L304 369l-.1-.1c-20.6-20.6-55.9-6.1-56.1 23l0 .3 0 24-24 0-24 0 0-23.8 0-.2c0-29.2-35.2-43.8-55.9-23.4l-.2 .2-17 17L110 369l-.1-.1-.1-.1L92.9 351.9l16.8-16.8 .1-.1c20.7-20.7 6-56.1-23.2-56.1l-24 0 0-23.8 0-.2 0-.2 0-23.8 24 0c29.3 0 43.9-35.4 23.2-56.1l-.1-.1L92.9 157.8 109.7 141l.1-.1 .1-.1 16.8-16.8 17 17 .2 .2c20.7 20.5 55.9 5.8 55.9-23.4l0-.2 0-23.8 24 0 24 0 0 24 0 .3c.2 29.1 35.4 43.6 56.1 23zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCartArrowUp = {
  prefix: 'fass',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L496 288l-136 0 0-110.1 23 23 17 17L433.9 184l-17-17-64-64-17-17-17 17-64 64-17 17L272 217.9l17-17 23-23L312 288l-141.3 0 9.1 48L312 336l48 0 128 0 24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faMeteor = {
  prefix: 'fass',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M512 0L299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L496 208l-59.9 4.6L512 0zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faCarOn = {
  prefix: 'fass',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280 24l0 80 0 24-48 0 0-24 0-80 0-24 48 0 0 24zM138.9 160l21.1 0 192 0 21.1 0 8.3 19.4L428 288l36 0 0 96 0 64 0 64-80 0 0-64-256 0 0 64-80 0 0-64 0-64 0-96 36 0 46.5-108.6 8.3-19.4zm192 64l-149.8 0-27.4 64 204.7 0-27.4-64zM128 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM56 22.1L73 39l48 48 17 17L104 137.9 87 121 39 73l-17-17L56 22.1zM439 39l17-17L489.9 56 473 73l-48 48-17 17L374.1 104l17-17 48-48z"]
};
const faSleigh = {
  prefix: 'fass',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M32 32L0 32 0 96l32 0 0 160c0 53 43 96 96 96l0 32 64 0 0-32 192 0 0 32 64 0 0-32c53 0 96-43 96-96l0-96 32 0 0-64-32 0-32 0-32 0-32 0 0 128-46.6 0c-80.5 0-155.3-41.5-198-109.7C173 65.7 120.9 35.2 64 32.2l0-.2-9 0L32 32zM640 384l0-32-64 0 0 32 0 32L64 416l-32 0 0 64 32 0 544 0 32 0 0-32 0-64z"]
};
const faArrowDown19 = {
  prefix: 'fass',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M160 479.4l23.6-25.7 88-96L293.2 334 246 290.8l-21.6 23.6L192 349.7 192 64l0-32-64 0 0 32 0 285.7L95.6 314.4 74 290.8 26.8 334l21.6 23.6 88 96L160 479.4zM414.3 309.3a32 32 0 1 1 35.3 53.4 32 32 0 1 1 -35.3-53.4zm-.6 112.8l-25.1 41.3L378.5 480l74.9 0L502 400.1c11.7-19.3 18-41.5 18-64.1c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.3 29.9 77.7 69.8 86.1zM384 32l-32 0 0 64 32 0 16 0 0 64-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-96 0-32-32 0-48 0z"]
};
const faSortNumericAsc = faArrowDown19;
const faSortNumericDown = faArrowDown19;
const faBuoyMooring = {
  prefix: 'fass',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M256 0l64 0 0 64 32 0 26.2 0 5.1 25.7 60.8 303.8c-6.5 4.4-12.6 8-19.4 11.1C411.6 410.7 397 415 384 415s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0L288 368l-18.6 13.4-1.1 .8s0 0 0 0s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 410.7 205 415 192 415s-27.6-4.3-40.7-10.3c-6.8-3.1-12.9-6.7-19.4-11.1L192.6 89.7 197.8 64 224 64l32 0 0-64zM218.2 288l139.5 0-32-160-75.5 0-32 160zm54.2 205.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faSquare4 = {
  prefix: 'fass',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M0 32l448 0 0 448L0 480 0 32zM288 192l-48 0 0 24 0 56-64.4 0 40-144-49.8 0L120.9 289.6 112.4 320l31.6 0 96 0 0 40 0 24 48 0 0-24 0-40 8 0 24 0 0-48-24 0-8 0 0-56 0-24z"]
};
const faHandHoldingDroplet = {
  prefix: 'fass',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M288 0L211.2 102.4C198.7 119 192 139.2 192 160c0 53 43 96 96 96s96-43 96-96c0-20.8-6.7-41-19.2-57.6L288 0zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faHandHoldingWater = faHandHoldingDroplet;
const faFileEps = {
  prefix: 'fass',
  iconName: 'file-eps',
  icon: [512, 512, [], "e644", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM160 352l16 0 64 0 16 0 0 32-16 0-48 0 0 32 32 0 16 0 0 32-16 0-32 0 0 32 48 0 16 0 0 32-16 0-64 0-16 0 0-16 0-64 0-64 0-16zm144 0l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm117.7-80l26.3 0 16 0 0 32-16 0-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L424 512l-16 0 0-32 16 0 34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z"]
};
const faTricycleAdult = {
  prefix: 'fass',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M312 64l-24 0 0 48 24 0 35.5 0 81.5 115.9L372 304l-33.2 0L37.5 232.6l-23.4-5.5L3.1 273.8l23.4 5.5 5.3 1.3C12.3 298.2 0 323.7 0 352c0 53 43 96 96 96c18.2 0 35.3-5.1 49.8-13.9c-.6 .4-1.2 .7-1.8 1.1c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-3.7-.2-7.3-.6-10.8l43.1 10.2 2.7 .6 2.8 0 48 0 12 0 7.2-9.6 54.9-73.2 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L379.6 74.2 372.5 64 360 64l-48 0zM222.1 325.7c6.1 7 9.9 16.2 9.9 26.3c0 22.1-17.9 40-40 40c-2.9 0-5.6-.3-8.3-.9c5.3-12 8.3-25.2 8.3-39.1c0-12.3-2.3-24.2-6.6-35l36.7 8.7zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM92.6 113.7L78.3 85.1 21.1 113.7l14.3 28.6 32 64 6.5 13L88 223l96 24.8 31 8 16-62-31-8-81.9-21.1-25.5-51z"]
};
const faWaveform = {
  prefix: 'fass',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M429 64l38.5 0 4.3 28.4L500.2 282l20.4-95 5.8-27 30.4 0 9.5 22.8L600 264l8 0 24 0 0 48-24 0-24 0-16 0-6.2-14.8-10.5-25.1L519.5 421l-5.8 27-37.2 0-4.3-28.4L446.8 249.5 407.7 483.9 403 512l-38.7 0-4.1-28.6L320 201.7 279.8 483.4 275.7 512 237 512l-4.7-28.1L193.2 249.5 167.7 419.6 163.5 448l-37.2 0-5.8-27L88.6 272.1 78.2 297.2 72 312l-16 0-24 0L8 312l0-48 24 0 8 0 33.8-81.2L83.3 160l30.4 0 5.8 27 20.4 95L168.3 92.4 172.5 64 211 64l4.7 28.1 38.5 231L296.2 28.6 300.3 0l39.3 0 4.1 28.6 42.1 294.5 38.5-231L429 64z"]
};
const faWater = {
  prefix: 'fass',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M288 133.4c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 150.1 31.9 160 0 160L0 96c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7L96 56.7l2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c0 0 0 0 0 0l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c0 0 0 0 0 0l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7zm0 288c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 438.1 31.9 448 0 448l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7zM272.4 285.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 294.1 31.9 304 0 304l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faStarSharpHalfStroke = {
  prefix: 'fass',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M317.5 90.6l34.1 105 110.4 0 95.3 0-77.1 56-89.3 64.9 34.1 105L454.4 512l-77.1-56-89.3-64.9L198.8 456l-77.1 56 29.4-90.6 34.1-105L96 251.6l-77.1-56 95.3 0 110.4 0 34.1-105L288.1 0l29.4 90.6zm34.1 161l-40.7 0-12.6-38.7-10.3-31.7-.1 .2L288 322c0 0 0 0 .1 0L321 345.8l26.9 19.6-10.3-31.7L325 295 358 271.1l26.9-19.6-33.3 0zm-159.6 0l-.8 0 .8 .6 0-.6z"]
};
const faStarSharpHalfAlt = faStarSharpHalfStroke;
const faNfcSignal = {
  prefix: 'fass',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M0 32l448 0 0 199.1c-22.4 5.1-43.9 12.8-64 22.8L384 112l0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 144.5c-41.6 27.9-75.6 66.3-98.1 111.5L96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96l0 16 0 288 0 16 16 0 160.4 0c-7.2 20.4-12.2 41.8-14.6 64L0 480 0 32zM512 304c-114.9 0-208 93.1-208 208l-48 0c0-141.4 114.6-256 256-256l0 48zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 64l-48 0c0-88.4 71.6-160 160-160l0 48c-61.9 0-112 50.1-112 112z"]
};
const faPlaneProp = {
  prefix: 'fass',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M256 0l64 0 8 64 40 0 0-16 0-16 32 0 0 16 0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32 0 16-32 0 0-16 0-16-32 0 8 64 138.3 0c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L344 320l-8 64 32 0 0-16 0-16 32 0 0 16 0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32 0 16-32 0 0-16 0-16-40 0-8 64-64 0-8-64-56 0 0-64 48 0-8.3-66.4-110-11L112 384l-64 0L36 287.8c-1.3 .2-2.6 .2-4 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7 .1 4 .2L48 128l64 0 9.7 77.4 110-11L240 128l-48 0 0-64 56 0 8-64z"]
};
const faCalendarCheck = {
  prefix: 'fass',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM329 305l17-17L312 254.1l-17 17-95 95-47-47-17-17L102.1 336l17 17 64 64 17 17 17-17L329 305z"]
};
const faClockDesk = {
  prefix: 'fass',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M0 224a224 224 0 1 1 448 0A224 224 0 1 1 0 224zM248 96l-48 0 0 24 0 104 0 9.9 7 7 48 48 17 17L305.9 272l-17-17-41-41 0-94.1 0-24zM224 480c96.4 0 180.3-53.3 224-132l0 164L0 512 0 348c43.7 78.7 127.6 132 224 132z"]
};
const faCalendarClock = {
  prefix: 'fass',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192l-16 0L0 192 0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7l0-.7zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288l0 16 0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0z"]
};
const faCalendarTime = faCalendarClock;
const faBraille = {
  prefix: 'fass',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faPrescriptionBottleMedical = {
  prefix: 'fass',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M0 0L384 0l0 96L0 96 0 0zM32 128l320 0 0 384L32 512l0-384zm128 96l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faPrescriptionBottleAlt = faPrescriptionBottleMedical;
const faPlateUtensils = {
  prefix: 'fass',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M56 16L40 16 0 152c0 41.5 31.6 75.6 72 79.6L72 472l0 24 48 0 0-24 0-240.4c40.4-4 72-38.1 72-79.6L152 16l-16 0 0 136-16 0L104 16 88 16 72 152l-16 0L56 16zm584 0s-128 16-128 144l0 160 80 0 0 152 0 24 48 0 0-24 0-152 0-104 0-24 0-176zM336 32c-49.8 0-95.9 16.3-133.1 43.8L222.7 143c0 0 0 0 0 0c29-29 69-47 113.3-47c63.3 0 118.1 36.8 144 90.2l0-26.2c0-25.1 4.2-46.8 11.2-65.5C450.9 55.8 396.2 32 336 32zm0 384c-88.4 0-160-71.6-160-160c0-4.2 .2-8.3 .5-12.4c-7.5 5.3-15.7 9.7-24.5 13.1l0 127.1C192.5 441.9 259.8 480 336 480c89.4 0 166.5-52.3 202.4-128L512 352l-32 0 0-26.2C454.1 379.2 399.3 416 336 416zM464 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
const faFamilyPants = {
  prefix: 'fass',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm48 48c0-5.5 .6-10.8 1.6-16L32 160 24 352l40 0 0 160 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48zM336 448l0 64 112 0 0-160 40 0-8-192-145.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48l16 0 32 0 0 32 0 160 0 32-32 0zm48-320A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 192l0-160-160 0 0 160 32 0 0 96 96 0 0-96 32 0z"]
};
const faHoseReel = {
  prefix: 'fass',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4l36.6 52.5C424.8 495 374.3 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256l0 96 8 0 24 0 0 48-24 0-2.3 0-11.4 80 13.7 0 0 32-16 0-48 0-16 0 0-32 13.7 0-11.4-80-2.3 0-24 0 0-48 24 0 8 0 0-96c0-106-86-192-192-192zM224 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faHouseWindow = {
  prefix: 'fass',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 224.4 448.7 0-1-224.4zM352 192l0 128-128 0 0-128 128 0z"]
};
const faLandmark = {
  prefix: 'fass',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M0 144l0 48 512 0 0-48L256 0 0 144zm128 80l-64 0 0 192L0 464l0 48 512 0 0-48-64-48 0-192-64 0 0 192-40 0 0-192-64 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192z"]
};
const faTruck = {
  prefix: 'fass',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96L0 416 0 0zM544 237.3L466.7 160l-2.7 0-48 0 0 96 128 0 0-16 0-2.7zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faMusicMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'music-magnifying-glass',
  icon: [640, 512, [], "e662", "M504 330.7c25.2-34.4 40-76.8 40-122.7C544 93.1 450.9 0 336 0C230.5 0 143.4 78.5 129.8 180.2L352 106.2l0 285.7c0 1.3 0 2.5-.1 3.8c.1 1.4 .1 2.8 .1 4.2c0 5.5-.6 10.7-1.8 15.7c40.4-2.7 77.7-17 108.5-39.6L569.4 486.6 592 509.3 637.3 464l-22.6-22.6L504 330.7zM320 152l-31.6 10.5-192 64L80 232l0 17.3 0 48 0 120.3c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c32.5 0 59.3-18.1 63.4-41.6c.4-1.7 .6-3.4 .6-5.2l0-1.2 0-149.5 144-48 0 87c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.3-.1-2.5-.2-3.7c.1-1 .2-2 .2-3l0-160 0-48 0-33.3z"]
};
const faCrosshairs = {
  prefix: 'fass',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M288 0l0 32 0 10.4c93.7 13.9 167.7 88 181.6 181.6l10.4 0 32 0 0 64-32 0-10.4 0c-13.9 93.7-88 167.7-181.6 181.6l0 10.4 0 32-64 0 0-32 0-10.4C130.3 455.7 56.3 381.7 42.4 288L32 288 0 288l0-64 32 0 10.4 0C56.3 130.3 130.3 56.3 224 42.4L224 32l0-32 64 0zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6l0-20.6 0-32 64 0 0 32 0 20.6c58.3-12.5 104.1-58.4 116.6-116.6L384 288l-32 0 0-64 32 0 20.6 0C392.1 165.7 346.3 119.9 288 107.4l0 20.6 0 32-64 0 0-32 0-20.6C165.7 119.9 119.9 165.7 107.4 224l20.6 0 32 0 0 64-32 0-20.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCloudRainbow = {
  prefix: 'fass',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M336.5 192l-.5 0c-19.7 0-38.3 5.1-54.4 14.1c-5.5-6-11.5-11.4-18-16.4C322.3 77 440.1 0 576 0l0 64c-99.9 0-187.8 50.8-239.5 128zM424 234.7c-13.4-16.9-31.5-29.9-52.3-36.9C418.4 136 492.5 96 576 96l0 64c-61.9 0-116.9 29.3-152 74.7zm23.4 57.2c-1-9.1-3.1-17.9-6.1-26.2C469.7 221.4 519.4 192 576 192l0 64c-38.3 0-71.4 22.5-86.8 55c-12.5-8.7-26.6-15.3-41.8-19.1zM96 512L0 512l0-96c0-41.8 26.7-77.4 64-90.5L64 304c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 512z"]
};
const faPersonCane = {
  prefix: 'fass',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1 20.4 24.6 49.3-40.9-20.4-24.6-92.9-112L258.1 128l-15 0-102.2 0-18.1 0-9.3 15.5-76.9 128L20.1 298.9l54.9 33 16.5-27.4L120 256.9 120 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-244.7zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8l0 112 0 24 48 0 0-24 0-112c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 8 0 24 48 0 0-24 0-8z"]
};
const faAlien = {
  prefix: 'fass',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M224 0C100.3 0 0 100.3 0 224C0 400 224 512 224 512s224-112 224-288C448 100.3 347.7 0 224 0zm32 304c0-44.2 35.8-80 80-80l48 0 0 16c0 44.2-35.8 80-80 80l-48 0 0-16zM112 224c44.2 0 80 35.8 80 80l0 16-48 0c-44.2 0-80-35.8-80-80l0-16 48 0z"]
};
const faTent = {
  prefix: 'fass',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M32 160L0 512H288V288L416 512H576L544 176 288 0 32 160z"]
};
const faLaptopBinary = {
  prefix: 'fass',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M64 32l32 0 448 0 32 0 0 32 0 288-64 0 0-256L128 96l0 256-64 0L64 64l0-32zM0 432l0-48 640 0 0 48-48 48L48 480 0 432zM176 128l64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16 16 0zm16 80l32 0 0-48-32 0 0 48zm112-80l16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32 16 0zm80 0l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16zm32 32l0 48 32 0 0-48-32 0zM192 272l16 0 16 0 0 16 0 64-32 0 0-48-16 0 0-32 16 0zm256 16l0 64-32 0 0-48-16 0 0-32 16 0 16 0 16 0 0 16zm-80 0l0 64-32 0 0-48-32 0 0 48-32 0 0-64 0-16 16 0 64 0 16 0 0 16z"]
};
const faVestPatches = {
  prefix: 'fass',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M151.2 69.7l55.9 167.7-13.5 40.5-1.6 4.9 0 5.2 0 224L0 512 0 256l64-96 0-32L64 24 64 0 88 0l40 0 7 0 13.3 0 6.9 11.1 .3 .4c.4 .6 1.2 1.5 2.3 2.8c2.3 2.6 6.1 6.3 11.5 10.1C179.9 31.8 197.4 40 224 40s44.1-8.2 54.7-15.6c5.4-3.8 9.2-7.5 11.5-10.1c1.1-1.3 1.9-2.3 2.3-2.8l.3-.4L299.6 0 313 0l7 0 40 0 24 0 0 24 0 104 0 32 64 96 0 256-224 0 0-224L296.8 69.7C279.3 79.8 255.3 88 224 88s-55.3-8.2-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM72 247L55 264l8.5 8.5L79 288 63.5 303.5 55 312l17 17 8.5-8.5L96 305l15.5 15.5L120 329l17-17-8.5-8.5L113 288l15.5-15.5L137 264l-17-17-8.5 8.5L96 271 80.5 255.5 72 247zm232 33l0 8 0 48 48 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faPeopleDressSimple = {
  prefix: 'fass',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM256 384L192 160 64 160 0 384l64 0 0 128 128 0 0-128 64 0zm0 0l64 0 0 128 128 0 0-128 64 0L448 160l-128 0L256 384zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128z"]
};
const faCheckDouble = {
  prefix: 'fass',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M342.6 86.6L365.3 64 320 18.7 297.4 41.4 160 178.7l-57.4-57.4L80 98.7 34.7 144l22.6 22.6 80 80L160 269.3l22.6-22.6 160-160zm82.1 141.8l23.2-22-44-46.5-23.2 22L159 392 67.2 305.1 44 283.1 0 329.6l23.2 22L137 459.3l22 20.8 22-20.8L424.7 228.5z"]
};
const faArrowDownAZ = {
  prefix: 'fass',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M183.6 453.6L160 479.4l-23.6-25.7-88-96L26.8 334 74 290.8l21.6 23.6L128 349.7 128 64l0-32 64 0 0 32 0 285.7 32.4-35.4L246 290.8 293.2 334l-21.6 23.6-88 96zM352 288l128 0 32 0 0 32 0 8 0 14.5-10.9 9.6L428 416l52 0 32 0 0 64-32 0-128 0-32 0 0-32 0-8 0-14.5 10.9-9.6L404 352l-52 0-32 0 0-64 32 0zM395.5 32l41.1 0 8.6 18.7 88 192 6.1 13.3-70.4 0-14.7-32-76.3 0-14.7 32-70.4 0 6.1-13.3 88-192L395.5 32zm4.4 144l32.3 0L416 140.8 399.9 176z"]
};
const faSortAlphaAsc = faArrowDownAZ;
const faSortAlphaDown = faArrowDownAZ;
const faBowlingBallPin = {
  prefix: 'fass',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1l-83.1 0c-.5-2.7-1.1-5.4-1.8-8.1L418.9 87.1c-2-7.2-2.9-14.6-2.9-22l0-1.1zm23.1 128l81.7 0c.8 6 2.2 11.9 4.1 17.6L576 367.3 536.1 512l-112.3 0L404 442.5c27.7-39.1 44-86.9 44-138.5c0-30.2-5.6-59.2-15.8-85.8l2.9-8.6c1.9-5.7 3.3-11.6 4.1-17.6zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0z"]
};
const faBellSchoolSlash = {
  prefix: 'fass',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M528 512l24 0s0 0 0 0l-24 0-112 0-32 0-256 0 0-112c40.1 30.1 90 48 144 48c47 0 90.9-13.5 127.9-36.9L416 423.8l0 40.2 51.1 0L528 512zm43.3-91.2l49.6 38.5 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 69.3 53.8C155.7 26.5 210.8 0 272 0C386.9 0 480 93.1 480 208c0 42.5-12.8 82-34.6 115l51.8 40.2c8.3-7 19.1-11.2 30.8-11.2c26.5 0 48 21.5 48 48c0 7.4-1.7 14.5-4.7 20.8zM343.5 243.9c5.4-10.8 8.5-23 8.5-35.9c0-44.2-35.8-80-80-80c-20.1 0-38.5 7.4-52.5 19.6l26.1 20.3c7.6-5 16.6-7.9 26.4-7.9c26.5 0 48 21.5 48 48c0 5.5-.9 10.7-2.6 15.6l26.1 20.3zM64 208c0-19.3 2.6-37.9 7.5-55.6L373 389.9C343.1 406.5 308.7 416 272 416C157.1 416 64 322.9 64 208z"]
};
const faPlusLarge = {
  prefix: 'fass',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M288 32l0-32L224 0l0 32 0 192L32 224 0 224l0 64 32 0 192 0 0 192 0 32 64 0 0-32 0-192 192 0 32 0 0-64-32 0-192 0 0-192z"]
};
const faMoneyBillWheat = {
  prefix: 'fass',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0zM56 16l48 0 24 0 0 48-24 0L56 64 32 64l0-48 24 0zM24 88l112 0 24 0 0 48-24 0L24 136 0 136 0 88l24 0zm8 72l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM272 0l16 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16zM400 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0zm80 128l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm-128 0l16 0 0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80zm-96 0l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zM0 512L0 256l512 0 0 256L0 512zm48-96l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faCameraViewfinder = {
  prefix: 'fass',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M0 0L0 24 0 136l0 24 48 0 0-24 0-88 88 0 24 0 0-48L136 0 24 0 0 0zM192 96l-12 32-84 0 0 256 320 0 0-256-84 0L320 96 192 96zm64 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM488 0L376 0 352 0l0 48 24 0 88 0 0 88 0 24 48 0 0-24 0-112 0-24L488 0zM0 512l24 0 112 0 24 0 0-48-24 0-88 0 0-88 0-24L0 352l0 24L0 488l0 24zm488 0l24 0 0-24 0-112 0-24-48 0 0 24 0 88-88 0-24 0 0 48 24 0 112 0z"]
};
const faScreenshot = faCameraViewfinder;
const faMessageMusic = {
  prefix: 'fass',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM352 96l0-23.1L330.4 81l-128 48L192 132.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faCommentAltMusic = faMessageMusic;
const faCarBuilding = {
  prefix: 'fass',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M0 0L352 0l0 128-32 0-23.1 0-23.1 0-7.3 21.9-7.3 21.9L252.5 192 192 192l0 64 0 32 0 160 0 32L0 480 0 0zM289.6 181.9l7.3-21.9 23.1 0 32 0 192 0 23.1 0 7.3 21.9L609.7 288l30.3 0 0 160 0 64-80 0 0-64-256 0 0 64-80 0 0-32 0-32s0 0 0 0l0-32 0-16 0-64 0-16 0-32 30.3 0 35.4-106.1zM352 224l-8.9 0-10.7 32-10.7 32 30.3 0 190.3 0-21.3-64L352 224zM64 96l0 64 64 0 0-64L64 96zm0 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zM192 96l0 64 64 0 0-64-64 0zM304 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBorderBottomRight = {
  prefix: 'fass',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 64l0-32-64 0 0 32 0 352L32 416 0 416l0 64 32 0 384 0 32 0 0-32 0-384zM288 96l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zm96-64l0 64 64 0 0-64-64 0zM0 96l64 0 0-64L0 32 0 96zM64 224L0 224l0 64 64 0 0-64zm0-32l0-64L0 128l0 64 64 0zm0 128L0 320l0 64 64 0 0-64z"]
};
const faBorderStyleAlt = faBorderBottomRight;
const faOctagon = {
  prefix: 'fass',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M0 352V160L160 0H352L512 160V352L352 512H160L0 352z"]
};
const faCommentArrowUpRight = {
  prefix: 'fass',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM200 160l-24 0 0 48 24 0 54.1 0-87 87-17 17L184 345.9l17-17 87-87 0 54.1 0 24 48 0 0-24 0-112 0-24-24 0-112 0z"]
};
const faOctagonDivide = {
  prefix: 'fass',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M0 160L0 352 160 512l192 0L512 352l0-192L352 0 160 0 0 160zm288-32l0 64-64 0 0-64 64 0zM168 232l176 0 24 0 0 48-24 0-176 0-24 0 0-48 24 0zm56 88l64 0 0 64-64 0 0-64z"]
};
const faCookie = {
  prefix: 'fass',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M362.2 37L213.9 16 81.7 86.7 16 222.1 42 370.4 149.8 475l148.3 21 132.3-70.7L496 289.9 470 141.6 362.2 37zM176 368l-32-32 32-32 32 32-32 32zm0-192l32-32 32 32-32 32-32-32zM368 336l-32-32 32-32 32 32-32 32z"]
};
const faArrowRotateLeft = {
  prefix: 'fass',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M48 224l-32 0 0-32L16 64l0-32 64 0 0 32 0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0l45.3-45.3c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160l50.3 0 32 0 0 64-32 0L48 224z"]
};
const faArrowLeftRotate = faArrowRotateLeft;
const faArrowRotateBack = faArrowRotateLeft;
const faArrowRotateBackward = faArrowRotateLeft;
const faUndo = faArrowRotateLeft;
const faTvMusic = {
  prefix: 'fass',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 64l0 288L64 352 64 64l512 0zM64 0L0 0 0 64 0 352l0 64 64 0 512 0 64 0 0-64 0-288 0-64L576 0 64 0zM96 448l0 64 32 0 384 0 32 0 0-64-32 0-384 0-32 0zM416 112l0-23.1L394.4 97l-128 48L256 148.9l0 11.1 0 48 0 49.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-68.9 96-36 0 42.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-96 0-48z"]
};
const faHardDrive = {
  prefix: 'fass',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M0 32l512 0 0 224L0 256 0 32zM512 288l0 192L0 480 0 288l512 0zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faHdd = faHardDrive;
const faReel = {
  prefix: 'fass',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M0 0L32 0 416 0l32 0 0 64-32 0-32 0 0 48L64 112l0-48L32 64 0 64 0 0zM0 448l32 0 32 0 0-48 320 0 0 48 32 0 32 0 0 64-32 0L32 512 0 512l0-64zM64 176l0-32 320 0 0 32L64 176zm0 64l0-32 368 0 16 0 0 32-16 0L64 240zm0 64l0-32 320 0 0 32L64 304zm0 64l0-32 320 0 0 32L64 368z"]
};
const faFaceGrinSquintTears = {
  prefix: 'fass',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M441.1 98.9c-13.2 2.4-25.4 4.1-33.1 5.1c1-7.2 2.6-18.6 4.9-30.9c.1-.7 .3-1.4 .4-2.1c.8-4.4 1.7-8.9 2.7-13.3c.1-.4 .2-.9 .3-1.3c4.1-18.5 9.6-36.2 16.6-43.1c17.9-17.9 47.1-17.6 65.3 .7s18.6 47.6 .7 65.6c-6.9 6.9-24.5 12.4-43 16.4zm14.7-2.9l-13.5 2.7c4.4-.8 9-1.7 13.5-2.7zm-79.5 3.6l-5.9 42 42-5.8 .1 0c10.5-1.4 30.8-4.3 50.5-8.6c4.1-.9 8.3-1.9 12.5-3c59.2 98.4 46.4 228-38.5 312.9c-84.9 84.9-214.7 97.7-313.2 38.3c1.1-4.1 2.1-8.2 3-12.2c4.4-19.7 7.4-40.1 8.8-50.6l5.9-42-42 5.8-.1 0c-10.5 1.4-30.8 4.3-50.5 8.6c-4.1 .9-8.3 1.9-12.5 3C-22.7 289.5-9.9 159.9 75 75C159.9-10 289.7-22.7 388.1 36.7c-1.1 4.1-2.1 8.2-3 12.2c-4.4 19.7-7.4 40.1-8.8 50.6zM70.9 413.1c13.2-2.4 25.5-4.1 33.1-5.1c0 0 0 0 0 0c-1.1 7.6-2.8 19.9-5.3 33.1c-.9 4.8-1.9 9.7-3 14.6c0 0 0 0 0 0c-4.1 18.5-9.6 36.2-16.6 43.1c-17.9 17.9-47.1 17.6-65.3-.7s-18.6-47.6-.7-65.6c6.9-6.9 24.5-12.4 43-16.4c4.9-1.1 9.9-2 14.7-2.9zM309.8 309.4C268 351.2 221.6 382.5 176 402.2c63.7 40.8 149.2 33.5 204.7-21.9s62.7-140.9 21.9-204.7c-19.7 45.6-51 92-92.8 133.8zM75 278.6l77.6 12.9 12.9 77.6 38.8-129.3L75 278.6zm164.9-74.3l129.3-38.8-77.6-12.9L278.6 75 239.8 204.3z"]
};
const faGrinSquintTears = faFaceGrinSquintTears;
const faDumbbell = {
  prefix: 'fass',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M192 32L96 32l0 96-64 0 0 96L0 224l0 64 32 0 0 96 64 0 0 96 96 0 0-160 0-32 0-64 0-32 0-160zm32 192l0 64 192 0 0-64-192 0zm224-32l0 32 0 64 0 32 0 160 96 0 0-96 64 0 0-96 32 0 0-64-32 0 0-96-64 0 0-96-96 0 0 160z"]
};
const faRectangleList = {
  prefix: 'fass',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M0 32l576 0 0 448L0 480 0 32zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248l-24 0 0 48 24 0 224 0 24 0 0-48-24 0-224 0zm0 96l-24 0 0 48 24 0 224 0 24 0 0-48-24 0-224 0zm0 96l-24 0 0 48 24 0 224 0 24 0 0-48-24 0-224 0z"]
};
const faListAlt = faRectangleList;
const faTarpDroplet = {
  prefix: 'fass',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M288 160c-35.3 0-64-25.6-64-57.1S288 0 288 0s64 71.3 64 102.9s-28.7 57.1-64 57.1zM0 128l197.5 0c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64L576 128l0 224-160 0 0 160L0 512 0 128zM576 384L448 512l0-128 128 0zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faAlarmExclamation = {
  prefix: 'fass',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6l-19.2 19.2L80 509.3 34.7 464l22.6-22.6 19.2-19.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l19.2 19.2L477.3 464 432 509.3l-22.6-22.6-19.2-19.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM280 160l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zm0 248l0-48-48 0 0 48 48 0z"]
};
const faHouseMedicalCircleCheck = {
  prefix: 'fass',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M320 368.7c.2 59.2 29.7 111.6 74.8 143.3L64.1 512l0-224.4L0 287.6 0 240 288.4 0 520.5 193.7c-8-1.1-16.2-1.7-24.5-1.7c-54.7 0-103.5 24.9-135.8 64L320 256l0-64-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-15.3zm32-.7a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z"]
};
const faTrafficCone = {
  prefix: 'fass',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M173.7 128L224 0l64 0 50.3 128-164.6 0zm-25.1 64l214.9 0 37.7 96-290.3 0 37.7-96zM48 448l37.7-96 340.6 0L464 448l48 0 0 64L0 512l0-64 48 0z"]
};
const faGrate = {
  prefix: 'fass',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M32 32L0 32 0 64 0 256 0 448l0 32 32 0 96 0 96 0 96 0 96 0 32 0 0-32 0-192 0-192 0-32-32 0-96 0-96 0-96 0L32 32zM64 224L64 96l32 0 0 128-32 0zm0 64l32 0 0 128-32 0 0-128zm96 128l0-128 32 0 0 128-32 0zm96 0l0-128 32 0 0 128-32 0zm96 0l0-128 32 0 0 128-32 0zm32-192l-32 0 0-128 32 0 0 128zM288 96l0 128-32 0 0-128 32 0zm-96 0l0 128-32 0 0-128 32 0z"]
};
const faArrowDownRight = {
  prefix: 'fass',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M320 416l32 0 0-32 0-224 0-32-64 0 0 32 0 146.7L86.6 105.4 64 82.7 18.7 128l22.6 22.6L242.7 352 96 352l-32 0 0 64 32 0 224 0z"]
};
const faPersonSkiingNordic = {
  prefix: 'fass',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M336 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM178.7 96L192 96l48 0 4.8 0 4.6 1.4 104 32 14.4 4.4 5.8 13.9L405.3 224l42.7 0 32 0 0 64-18.3 0L434.6 464l93.4 0 0-32 0-24 48 0 0 24 0 56 0 24-24 0-231.3 0c-.5 0-1 0-1.4 0l-158.6 0c-.4 0-.9 0-1.4 0L24 512 0 512l0-48 24 0 43 0 55.6-264.1L98.7 176l22.6-22.6 48-48 9.4-9.4zM402.3 464l27.1-176L384 288l-21.3 0-8.2-19.7-21.5-51.7L302 299 369 340.9l20.4 12.8-6.6 23.2L357.8 464l44.4 0zm-270.1 0l58.7-125.7c5.9 6.6 12.8 12.5 20.6 17.3l32.4 20.3L202.8 464l88.5 0 23.3-81.6-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.3-94-27.7 0-38.6 38.6-14 14L99.7 464l32.4 0z"]
};
const faSkiingNordic = faPersonSkiingNordic;
const faCalendarPlus = {
  prefix: 'fass',
  iconName: 'calendar-plus',
  icon: [448, 512, [], "f271", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320zM248 248l0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24 0-56-56 0-24 0 0-48 24 0 56 0 0-56 0-24 48 0z"]
};
const faPersonFromPortal = {
  prefix: 'fass',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18-.6-35.5-1.7-52.4L176 221.3l22.6-22.6L237.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L309.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L401 340.9 334 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L294.2 96 288 96l-64 0-13.3 0-9.4 9.4-48 48c0 0 0 0-.1 .1C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96l65.5 0 20.8 0 8.4-19L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352l-33 0zM416 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faPortalExit = faPersonFromPortal;
const faPlaneArrival = {
  prefix: 'fass',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M32.3 196.1L32 64l72 16 24 64 96.8 26.9L176 0l80 0L375.7 212.9l104.6 29.1c16.7 4.6 32.2 12.6 45.7 23.4l34.1 27.3c23.8 19.1 17.9 56.8-10.6 67.6c-41.5 15.8-87 18-129.8 6.4L120.7 285.4 32.3 196.1zM32 448l576 0 32 0 0 64-32 0L32 512 0 512l0-64 32 0zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCowbellCirclePlus = {
  prefix: 'fass',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M128 0l24 0L296 0l24 0 0 24 0 72 64 0 19.7 98.3C319.9 207.8 256 280.4 256 368c0 16.6 2.3 32.7 6.6 48L0 416 64 96l64 0 0-72 0-24zM285.5 465.6C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64l115.2 0c3.1 6.1 6.6 12 10.3 17.6zM272 48l-96 0 0 48 96 0 0-48zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faCowbellMore = faCowbellCirclePlus;
const faCircleLeft = {
  prefix: 'fass',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM256 128l0 80 128 0 0 96-128 0 0 80-16 0L112 256 240 128l16 0z"]
};
const faArrowAltCircleLeft = faCircleLeft;
const faDistributeSpacingVertical = {
  prefix: 'fass',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 32l512 0 0 48L0 80 0 32zM96 160l320 0 0 192L96 352l0-192zM512 432l0 48L0 480l0-48 512 0z"]
};
const faSignalBarsFair = {
  prefix: 'fass',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M288 256l-96 0 0 256 96 0 0-256zM128 384l-96 0 0 128 96 0 0-128z"]
};
const faSignalAlt2 = faSignalBarsFair;
const faSportsball = {
  prefix: 'fass',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M487.6 48.9l-.3-1.5L365.3 169.3c34.8 30.2 79 49.8 127.6 53.9c9.3-63 4.7-125.5-5.4-174.3zM465 24.4l-3.5-.6c-65.6-11-122.9-12.5-172.8-6c3.9 49.1 23.6 93.7 54 128.8L465 24.4zm-19 334c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5zM320 169.4c-35-39.7-57.9-90.3-63-146.1c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM93.4 116.1C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6c55.1 5.3 105.1 28.1 144.4 62.8l64-64L93.4 116.1zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3 .1c-34.8-30.2-79-49.8-127.6-53.9c-9.3 63-4.7 125.5 5.4 174.3l.3 1.5L146.7 342.7zm22.6 22.6L47 487.6l3.5 .6c65.6 11 122.9 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8z"]
};
const faGameConsoleHandheldCrank = {
  prefix: 'fass',
  iconName: 'game-console-handheld-crank',
  icon: [576, 512, [], "e5b9", "M0 32l448 0 0 448L0 480 0 32zM384 96L64 96l0 160 320 0 0-160zM128 336l0-16-32 0 0 16 0 16-16 0-16 0 0 32 16 0 16 0 0 16 0 16 32 0 0-16 0-16 16 0 16 0 0-32-16 0-16 0 0-16zm144 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144l24 0 48 0 24 0 0 24 0 32 0 24-24 0-24 0 0 72 0 24-24 0-24 0 0-48 0-16 0-56 0-32 0-24z"]
};
const faTrainSubway = {
  prefix: 'fass',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M448 0L0 0 0 448l66.7 0L25.4 489.4 2.8 512l90.5 0 64-64 133.5 0 64 64 90.5 0-22.6-22.6L381.3 448l66.7 0L448 0zM208 96l0 160L64 256 64 96l144 0zm32 0l144 0 0 160-144 0 0-160zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSubway = faTrainSubway;
const faChartGantt = {
  prefix: 'fass',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zm64 64l32 0 96 0 32 0 0 64-32 0-96 0-32 0 0-64zm96 96l128 0 32 0 0 64-32 0-128 0-32 0 0-64 32 0zm160 96l64 0 32 0 0 64-32 0-64 0-32 0 0-64 32 0z"]
};
const faFaceSmileUpsideDown = {
  prefix: 'fass',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM382.3 184.8l-28.6 14.3C344.9 181.7 312.4 144 256 144s-88.9 37.7-97.7 55.2l-28.6-14.3C142.3 159.7 184.4 112 256 112s113.7 47.7 126.3 72.8zM367.6 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faBallPile = {
  prefix: 'fass',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", "M288 160A80 80 0 1 0 288 0a80 80 0 1 0 0 160zM176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM160 432A80 80 0 1 0 0 432a80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM400 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faBadgeDollar = {
  prefix: 'fass',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 149.3l0-20-40 0 0 20 0 8.5c-6.7 1.3-13.1 3.2-19.1 5.9c-16.1 7.3-29.9 20.8-33.3 40.2c-1.9 10.9-.9 21.4 3.6 30.9c4.4 9.3 11.3 15.9 18.5 20.8c12.6 8.5 29.3 13.6 42.4 17.5l2.3 .7c15.4 4.6 26.3 8.3 33.2 13.3c3 2.2 4.3 4 4.9 5.4c.6 1.3 1.2 3.9 .4 8.7c-.8 4.7-3.5 8.6-10.2 11.4c-7.3 3.1-18.7 4.5-33.2 2.3c-6.9-1.1-19-5.3-29.6-8.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-2.4-.8-4.7-1.6-6.9-2.3l-19-6.3-12.6 38 19 6.3c1.4 .5 3.1 1 5 1.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c9.3 3.2 24 8.2 34.6 10.4l0 8.9 0 20 40 0 0-20 0-8c6.5-1.1 12.7-2.8 18.5-5.3c16.9-7.2 30.3-21.1 33.8-41.4c1.9-11.2 1.1-21.8-3.1-31.4c-4.2-9.6-10.9-16.6-18.1-21.8c-13.2-9.6-30.8-14.9-44.4-19l-.8-.2c-15.6-4.7-26.7-8.2-33.8-13c-3.1-2.1-4.3-3.7-4.8-4.8c-.4-.9-1.1-2.8-.3-6.9c.5-3.1 2.9-7.2 10.4-10.6c7.6-3.4 19.1-5.2 33.1-3c4.9 .8 20 3.7 24.3 4.9l19.3 5.1 10.3-38.7L302 163.3c-5.3-1.4-18-3.9-25.1-5.2l0-8.8z"]
};
const faMoneyBillsSimple = {
  prefix: 'fass',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M96 32l0 352 544 0 0-352L96 32zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faMoneyBillsAlt = faMoneyBillsSimple;
const faListTimeline = {
  prefix: 'fass',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM64 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 48l240 0 0 96-240 0L144 96l64-48zM144 256l64-48 304 0 0 96-304 0-64-48zm0 160l64-48 240 0 0 96-240 0-64-48z"]
};
const faIndianRupeeSign = {
  prefix: 'fass',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 32l32 0 32 0 32 0 16 0 176 0 32 0 0 64-32 0-56.2 0c9.6 14.4 16.7 30.6 20.7 48l35.6 0 32 0 0 64-32 0-35.6 0c-13.7 60.5-65.6 106.6-129 111.6L257.2 405l27 17.2-34.5 53.9-27-17.2L14.8 326 0 316.6l0-17.5L0 288l0-32 32 0 80 0c32.8 0 61-19.7 73.3-48L32 208 0 208l0-64 32 0 153.3 0C173 115.7 144.8 96 112 96L96 96 64 96 32 96 0 96 0 32z"]
};
const faIndianRupee = faIndianRupeeSign;
const faInr = faIndianRupeeSign;
const faCropSimple = {
  prefix: 'fass',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 32l0-32L64 0l0 32 0 32L32 64 0 64l0 64 32 0 32 0 0 288 0 32 32 0 224 0 32 0 0-64-32 0-192 0 0-256 0-64 0-32zM384 480l0 32 64 0 0-32 0-32 32 0 32 0 0-64-32 0-32 0 0-288 0-32-32 0L160 64l0 64 224 0 0 256 0 64 0 32z"]
};
const faCropAlt = faCropSimple;
const faMoneyBill1 = {
  prefix: 'fass',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M576 64L0 64 0 448l576 0 0-384zM128 384l-64 0 0-64c35.3 0 64 28.7 64 64zM64 192l0-64 64 0c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-68l0 40 16 0 0 48-4 0-20 0 0 40 20 0 24 0 24 0 20 0 0-40-20 0-4 0 0-68 0-20-20 0-16 0-20 0z"]
};
const faMoneyBillAlt = faMoneyBill1;
const faLeftLong = {
  prefix: 'fass',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M0 256L160 96l32 0 0 96 320 0 0 128-320 0 0 96-32 0L0 256z"]
};
const faLongArrowAltLeft = faLeftLong;
const faKeyboardDown = {
  prefix: 'fass',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M576 0L0 0 0 288l576 0L576 0zM128 64l0 64-64 0 0-64 64 0zM64 160l64 0 0 64-64 0 0-64zm352 0l0 64-256 0 0-64 256 0zm32 0l64 0 0 64-64 0 0-64zM224 64l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM160 352l0 32L288 512 416 384l0-32-256 0z"]
};
const faCircleUpRight = {
  prefix: 'fass',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 320l0-160-160 0-24 24 52 52-76 76 56 56 76-76 52 52 24-24z"]
};
const faCloudBoltMoon = {
  prefix: 'fass',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M509.2 8.4c-37.3 13.1-64 48.7-64 90.6c0 53 42.8 96 95.6 96c12.4 0 24.3-2.4 35.1-6.7c-19.3 36.2-55.4 62-97.9 66.8c-5.6-37.5-29.7-68.8-62.6-84.5c-2-43.8-29.1-81-67.2-97.5C368.8 29.9 412.7 0 463.6 0c16.1 0 31.5 3 45.7 8.5zM447.9 351.9l-80 0-15.9 0 0-31.9-76.5 0 40-128-51 0L64 344.3l0 7.6-64 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80zM144 512l40-128-88 0 0-24L272 224 232 352l88 0 0 24L144 512z"]
};
const faThunderstormMoon = faCloudBoltMoon;
const faTurnLeftUp = {
  prefix: 'fass',
  iconName: 'turn-left-up',
  icon: [384, 512, [], "e638", "M192 0L32 160l0 32 112 0 0 320 240 0 0-96-144 0 0-224 112 0 0-32L192 0z"]
};
const faDna = {
  prefix: 'fass',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M448 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5l118.5 0c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480l0 32-64 0 0-32L64 480l0 32-32 0L0 512l0-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32L0 0 64 0l0 32 320 0 0-32 32 0 32 0 0 32zM338.6 384l-229.2 0c-10.1 10.6-18.6 21.3-25.5 32l280.2 0c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128l229.2 0c10.1-10.7 18.6-21.3 25.5-32L83.9 96c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5l-118.5 0z"]
};
const faVirusSlash = {
  prefix: 'fass',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M476.4 347.1c-1.4-29.7 21.2-59.1 56-59.1l11.5 0 32 0 0-32 0-32-32 0-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 22.6-22.6L501 75 478.4 52.4 455.8 75l-8.2 8.2c0 0 0 0 0 0C412.3 118.4 352 93.4 352 43.5L352 32l0-32L320 0 288 0l0 32 0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75 161.6 52.4 139 75s0 0 0 0s0 0 0 0l-5.7 5.7L48.4 14.8 29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L476.4 347.1zM264.2 182.3c7-4 15.2-6.3 23.8-6.3c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.8l-70.1-54.4zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14L96 224l-32 0 0 32 0 32 32 0 11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2-22.6 22.6L139 437s0 0 0 0l22.6 22.6L184.2 437l8.2-8.2c0 0 0 0 0 0c35.3-35.2 95.6-10.3 95.6 39.6l0 11.5 0 32 32 0 32 0 0-32 0-11.5c0-31.2 23.6-52.7 50-55.7z"]
};
const faBracketRoundRight = {
  prefix: 'fass',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M192 256C192 140.2 120.1 62.9 81.8 37.4L46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4l35.5 53.3C120.1 449 192 371.8 192 256z"]
};
const faCircleSterling = {
  prefix: 'fass',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5 40.5 0 16 0 0 32-16 0-40.3 0 .3 41.2 0 5.9-2.7 5.3-6 11.6L328 320l24 0 0 48-24 0-144 0-39.3 0 18-35L184 291.6l-.3-35.6-7.7 0-16 0 0-32 16 0 7.5 0-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1 22.3 8.9-17.8 44.6-22.3-8.9-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"]
};
const faCircle5 = {
  prefix: 'fass',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128l104 0 24 0 0 48-24 0-82.1 0L226 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L174 261.1l2.1-23.2 8-88 2-21.8 21.9 0z"]
};
const faMinus = {
  prefix: 'fass',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 288l-32 0L48 288l-32 0 0-64 32 0 352 0 32 0 0 64z"]
};
const faSubtract = faMinus;
const faFireFlame = {
  prefix: 'fass',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M203.1 9.7L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258C3.7 277.8 0 299 0 320.2C0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2c-34.8-95.8-93.3-181.2-170-248.3zM208 144l0 15.9c0 12.9 5.2 25.2 14.3 34.2l47.1 46.4C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109l-3 0c-61.9 0-112-50.6-112-112.4c0-25.5 12-49.6 32.4-64.9L128 243l0 55c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-16.8-16.8c-11.7-11.7-18.3-27.7-18.3-44.3c0-19 8.6-37 23.5-48.9L208 144z"]
};
const faFlame = faFireFlame;
const faRightToLine = {
  prefix: 'fass',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M192 96L352 256 192 416l-32 0 0-96L0 320 0 192l160 0 0-96 32 0zM384 416l0-320 0-32 64 0 0 32 0 320 0 32-64 0 0-32z"]
};
const faArrowAltToRight = faRightToLine;
const faGif = {
  prefix: 'fass',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M0 32l576 0 0 448L0 480 0 32zM320 160l-48 0 0 24 0 144 0 24 48 0 0-24 0-144 0-24zm32 0l0 24 0 80 0 64 0 24 48 0 0-24 0-40 40 0 24 0 0-48-24 0-40 0 0-32 64 0 24 0 0-48-24 0-88 0-24 0zM128 256c0-26.5 21.5-48 48-48c12.3 0 23.5 4.6 32 12.2l32-35.8c-17-15.2-39.4-24.5-64-24.5c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8l11.2-7.1 0-13.2 0-35.9 0-24-48 0 0 24 0 21.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z"]
};
const faChess = {
  prefix: 'fass',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 0l0 16 0 16 16 0 16 0 0 32-16 0-16 0 0 32 72 0 0 24-29.3 88 21.3 0 0 48-24 0-5.8 0 17.5 128L60.4 384 77.8 256 72 256l-24 0 0-48 21.3 0L40 120l0-24 72 0 0-32L96 64 80 64l0-32 16 0 16 0 0-16 0-16 32 0zM48 416l160 0 4.1 0 2.4 3.4 40 56 1.5 2.1 0 2.6 0 24 0 8-8 0L8 512l-8 0 0-8 0-24 0-2.6 1.5-2.1 40-56 2.4-3.4 4.1 0zM304 272l0-80 40 0 0 32 24 0 0-32 64 0 0 32 24 0 0-32 40 0 0 80-36.8 40 3.3 72L337 384l2.2-72L304 272zm80 64l32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32zm-48 80l128 0 4.1 0 2.4 3.4 40 56 1.5 2.1 0 2.6 0 24 0 8-8 0-208 0-8 0 0-8 0-24 0-2.6 1.5-2.1 40-56 2.4-3.4 4.1 0z"]
};
const faTrashSlash = {
  prefix: 'fass',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M497.3 363.3L512 128l-317.8 0L153 96l391 0 0-64L416 32 400 0 240 0 224 32 96 32l0 19.8-47.6-37L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-123.6-96zM489.9 482L132.5 200.4 152 512l336 0 1.9-30z"]
};
const faArrowLeftLong = {
  prefix: 'fass',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M22.6 278.6L0 256l22.6-22.6 128-128 22.6-22.6L218.5 128l-22.6 22.6L122.5 224 480 224l32 0 0 64-32 0-357.5 0 73.4 73.4L218.5 384l-45.3 45.3-22.6-22.6-128-128z"]
};
const faLongArrowLeft = faArrowLeftLong;
const faPlugCircleCheck = {
  prefix: 'fass',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z"]
};
const faFontCase = {
  prefix: 'fass',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M153 32l-7.3 21.8L2.6 480l67.5 0 37.6-112 136.6 0 37.6 112 67.5 0L206.3 53.8 199 32l-46 0zm69.8 272l-93.6 0L176 164.6 222.8 304zM640 192l0-32-64 0 0 17.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128l0 64c0 70.7 57.3 128 128 128c23.3 0 45.2-6.2 64-17.1l0 17.1 64 0 0-32 0-95.9 0-.1 0-64 0-.1 0-95.9zM512 224c35.3 0 64 28.6 64 63.9c0 0 0 .1 0 .1l0 64c0 0 0 .1 0 .1c0 35.3-28.7 63.9-64 63.9c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64z"]
};
const faStreetView = {
  prefix: 'fass',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M192 64a64 64 0 1 1 128 0A64 64 0 1 1 192 64zm32 96l64 0c35.3 0 64 28.7 64 64l0 80-33.8 0L304 432l-96 0L193.8 304 160 304l0-80c0-35.3 28.7-64 64-64zM55.3 419.2c-3.6 2.4-3.6 7.2 0 9.6c8.8 5.7 23.1 11.8 43 17.3C137.7 457 193.5 464 256 464s118.3-7 157.7-17.9c19.9-5.5 34.2-11.6 43-17.3c3.6-2.4 3.6-7.2 0-9.6c-2.1-1.4-4.8-2.9-7.9-4.5c-15.3-7.7-38.8-14.9-69-20.5l8.6-47.2c32.4 5.9 60.9 14.2 82 24.8c10.5 5.3 20.3 11.7 27.8 19.6c7.6 8.1 14 19.1 14 32.6c0 21.4-15.5 36.1-29.1 45c-14.7 9.6-34.3 17.3-56.4 23.4C381.8 504.7 321.6 512 256 512s-125.8-7.3-170.4-19.6c-22.1-6.1-41.8-13.8-56.4-23.4C15.5 460.1 0 445.4 0 424c0-13.5 6.4-24.5 14-32.6c7.5-7.9 17.3-14.3 27.8-19.6c21-10.6 49.5-18.9 82-24.8l8.6 47.2c-30.2 5.5-53.7 12.8-69 20.5c-3.2 1.6-5.8 3.1-7.9 4.5z"]
};
const faArrowDownLeft = {
  prefix: 'fass',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M64 416l-32 0 0-32 0-224 0-32 64 0 0 32 0 146.7L297.4 105.4 320 82.7 365.3 128l-22.6 22.6L141.3 352 288 352l32 0 0 64-32 0L64 416z"]
};
const faFrancSign = {
  prefix: 'fass',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M320 32L112 32 48 32l0 64 0 96 0 64 0 64L0 320l0 64 48 0 0 96 64 0 0-96 112 0 0-64-112 0 0-64 176 0 0-64-176 0 0-96 208 0 0-64z"]
};
const faFlaskRoundPoison = {
  prefix: 'fass',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M320 167.4C386.6 202.1 432 271.8 432 352c0 64.3-29.2 121.8-75.1 160L91.1 512C45.2 473.8 16 416.3 16 352c0-80.2 45.4-149.9 112-184.6L128 64 96 64 96 0l32 0 64 0 64 0 64 0 32 0 0 64-32 0 0 103.4zM336 312c0-48.6-50.1-88-112-88s-112 39.4-112 88c0 29.9 19 56.3 48 72.2l0 47.8 128 0 0-47.8c29-15.9 48-42.3 48-72.2zM184 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faFlaskPoison = faFlaskRoundPoison;
const faVolumeOff = {
  prefix: 'fass',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M0 352V160H128L272 32h48V480H272L128 352H0z"]
};
const faBookCircleArrowRight = {
  prefix: 'fass',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 10.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l224.7 0c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4L448 0 416 0 384 0 96 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 289.4l11.3 11.3 56 56L582.6 368l-11.3 11.3-56 56L504 446.6 481.4 424l11.3-11.3L521.4 384 432 384l-16 0 0-32 16 0 89.4 0-28.7-28.7L481.4 312 504 289.4z"]
};
const faChartUser = {
  prefix: 'fass',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M160 0l32 0L608 0l32 0 0 32 0 352 0 32-32 0-283.4 0-19.2-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-64 0-32zM473 201l-72 72-17 17-17-17-64-64-17-17L320 158.1l17 17 47 47 55-55-39-39 16-16 112 0 0 112-16 16-39-39zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM272 352l48 160L0 512 48 352l224 0z"]
};
const faUserChart = faChartUser;
const faHandsAslInterpreting = {
  prefix: 'fass',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M260.5 69.9l24.6-20.5L244.1 .3 219.5 20.7 133.6 92.3l15-30 14.3-28.6L105.7 5.1 91.4 33.7 13.5 189.4C4.6 207.2 0 226.8 0 246.7L0 256c0 70.7 57.3 128 128 128l72 0 8 0 0-.3c46.2-3.5 83.8-37.1 93.6-81.2l-62.5-13.8c-4 17.9-20 31.3-39.1 31.3c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.1 0 35.1 13.4 39.1 31.3l62.5-13.8c-8-36.3-34.9-65.5-69.9-76.7l64.8-17.7 30.9-8.4L310.5 93.1l-30.9 8.4-84.7 23.1 65.6-54.7zM378.8 442.3l-24.6 20.5 41 49.2 24.6-20.5 85.9-71.6-15 30-14.3 28.6 57.2 28.6 14.3-28.6 77.9-155.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0 0 .3c-46.2 3.5-83.8 37.1-93.6 81.2l62.5 13.8c4-17.9 20-31.3 39.1-31.3c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.1 0-35.1-13.4-39.1-31.3l-62.5 13.8c8 36.3 34.9 65.5 69.9 76.7L342.9 349 312 357.4l16.8 61.7 30.9-8.4 84.7-23.1-65.6 54.7z"]
};
const faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faAslInterpreting = faHandsAslInterpreting;
const faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faPresentationScreen = {
  prefix: 'fass',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M32 0L0 0 0 64l32 0 0 256 0 32 32 0 192 0 0 34.7-54.6 54.6L178.7 464 224 509.3l22.6-22.6L288 445.3l41.4 41.4L352 509.3 397.3 464l-22.6-22.6L320 386.7l0-34.7 192 0 32 0 0-32 0-256 32 0 0-64L544 0 480 0 96 0 32 0zM96 64l384 0 0 224-160 0-64 0L96 288 96 64z"]
};
const faPresentation = faPresentationScreen;
const faCircleBolt = {
  prefix: 'fass',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 272l-88 0 0-24L320 112 280 240l88 0 0 24L192 400l40-128z"]
};
const faFaceSmileHalo = {
  prefix: 'fass',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272zm148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5zm53.5-56.7s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 260.4 120 278.1 120 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 260.4 280 278.1 280 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z"]
};
const faCartCircleArrowDown = {
  prefix: 'fass',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-136l-11.3 11.3-56 56L496 454.6l-11.3-11.3-56-56L417.4 376 440 353.4l11.3 11.3L480 393.4l0-89.4 0-16 32 0 0 16 0 89.4 28.7-28.7L552 353.4 574.6 376z"]
};
const faHousePersonReturn = {
  prefix: 'fass',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M380.6 121.8l-5.8 11.5-37.5 74.9-28.9 14.5-28.6 14.3 14.3 28.6 28.6 57.2 14.3 28.6 28.6-14.3 13.7-6.8-14.7 16.1-5.2 5.7-2 7.5L342 416 64 416l0-160L0 256l0-48L240 0 380.6 121.8zM128 192l0 96 96 0 0-96-96 0zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm75.7 126.6l9.3 4.1 72 32 12.9 5.7 4.5 13.4 16 48 10.1 30.4-60.7 20.2-10.1-30.4-11.5-34.6-36.7-16.3 17 63.6c5.6 21.1 .1 43.6-14.7 59.7l-70.9 77.4-22 80.5-8.4 30.9-61.7-16.8 8.4-30.9 24-88 2-7.5 5.2-5.7 52.3-57-18.4-62.4-13.7 27.4-4.8 9.5-9.5 4.8-48 24-28.6-57.2 38.5-19.2 35.2-70.5 7-14 15.3-3.1 80-16 10-2zm38.6 209l25 62.4 43.4 43.4L637.3 464 592 509.3l-22.6-22.6-48-48-4.6-4.6-2.4-6.1-15.7-39.3 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z"]
};
const faHousePersonArrive = faHousePersonReturn;
const faHouseReturn = faHousePersonReturn;
const faMessageXmark = {
  prefix: 'fass',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM353.9 144L320 110.1l-17 17-47 47-47-47-17-17L158.1 144l17 17 47 47-47 47-17 17L192 305.9l17-17 47-47 47 47 17 17L353.9 272l-17-17-47-47 47-47 17-17z"]
};
const faCommentAltTimes = faMessageXmark;
const faMessageTimes = faMessageXmark;
const faFileCertificate = {
  prefix: 'fass',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M352 0L128 0l0 134.7 23.6-9.7 22.5-9.2L189 135.1l15.6 20.2 25.3 3.4 24.1 3.3 3.3 24.1 3.4 25.3L280.9 227l19.2 14.9L291 264.4 281.3 288l9.7 23.6 9.2 22.5L280.9 349l-20.2 15.6-3.4 25.3L254 414l-24.1 3.3-5.9 .8 0 93.9s0 0 0 0l288 0 0-352-160 0L352 0zm32 0l0 128 128 0L384 0zM92.3 154.6l-3.7 4.8L68.6 185.2l-32.2 4.4-6 .8-.8 6-4.4 32.2L-.5 248.5l-4.8 3.7 2.3 5.6L9.3 288-3 318.1l-2.3 5.6 4.8 3.7 25.7 19.9 4.4 32.2 .8 6 6 .8L64 390.2 64 512l64-40 64 40 0-121.8 27.6-3.8 6-.8 .8-6 4.4-32.2 25.7-19.9 4.8-3.7-2.3-5.6L246.7 288 259 257.9l2.3-5.6-4.8-3.7-25.7-19.9-4.4-32.2-.8-6-6-.8-32.2-4.4-19.9-25.7-3.7-4.8-5.6 2.3L128 169.3 97.9 157l-5.6-2.3zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z"]
};
const faFileAward = faFileCertificate;
const faUserDoctorHairLong = {
  prefix: 'fass',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zM160 370.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-50.3-80 0L0 512l448 0L400 320l-80 0 0 42c27.6 7.1 48 32.2 48 62l0 40 0 16-16 0-16 0-16 0 0-32 16 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24 16 0 0 32-16 0-16 0-16 0 0-16 0-40c0-29.8 20.4-54.9 48-62l0-42-128 0 0 50.3zm8 53.7a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCameraSecurity = {
  prefix: 'fass',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M0 0L448 0l0 416-144 0 80 56 0 40L64 512l0-40 80-56L0 416 0 0zM128 208a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 208a128 128 0 1 0 256 0z"]
};
const faCameraHome = faCameraSecurity;
const faGear = {
  prefix: 'fass',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M200 0L312 0l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512l-112 0-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm56 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faCog = faGear;
const faDropletSlash = {
  prefix: 'fass',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M209.9 140.2L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L505.5 369.7c4.2-15.8 6.5-32.5 6.5-49.7C512 214 320 0 320 0s-57.9 64.5-110.1 140.2zM456.1 455.4L159.8 221.9c-19 36.2-31.8 70.8-31.8 98.1c0 106 86 192 192 192c53.2 0 101.4-21.6 136.1-56.6zM224 336c0 44.2 35.8 80 80 80l16 0 0 32-16 0c-61.9 0-112-50.1-112-112l0-16 32 0 0 16z"]
};
const faTintSlash = faDropletSlash;
const faBookHeart = {
  prefix: 'fass',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zm64-260.8c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L240 288.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z"]
};
const faMosque = {
  prefix: 'fass',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M0 512L0 160l160 0 0 128-32 0 0 32 0 192L0 512zM80 0s80 32 80 128L0 128C0 32 80 0 80 0zM216.6 288c-13.2-15.6-24.6-37-24.6-64c0-74 53.5-105.2 107.9-137C339.6 63.9 379.8 40.5 400 0c20.2 40.5 60.4 63.9 100.1 87C554.5 118.8 608 150 608 224c0 27-11.4 48.4-24.6 64l-366.7 0zM288 512l0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-80 0 0-192 480 0 0 192-80 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454l0 58-64 0z"]
};
const faDuck = {
  prefix: 'fass',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M431.5 125.9C426.5 73.2 382 32 328 32c-57.4 0-104 46.6-104 104c0 36.8 19.1 69.2 48 87.7l0 4.9L64 288 32 256 0 256l0 32C0 394 86 480 192 480l120 0c70.7 0 128-57.3 128-128c0-36.6-15.4-69.6-40-93l0-35 16 0c53 0 96-43 96-96l-64 0-16.5-2.1zM320 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM308.6 295.1l31.9 1.9c-3.2 55.6-43.5 104.9-101.5 119.3c-52.4 13.1-105.3-5.8-136.4-44.5l25-20c23.2 28.9 63.3 43.6 103.7 33.5c44.7-11.2 74.9-48.9 77.3-90.1z"]
};
const faMosquito = {
  prefix: 'fass',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M154.6 387.8L288 266l0 .2-67 87-5 6.5 0 8.2 0 53.5-40.4 37.9-17.5 16.4 32.9 35 17.5-16.4 48-45.1 7.6-7.1 0-10.4 0-55.7 24-31.2 0 62.9 0 32 64 0 0-32 0-62.9L376 376l0 55.7 0 10.4 7.6 7.1 48 45.1 17.5 16.4 32.9-35-17.5-16.4L424 421.4l0-53.5 0-8.2-5-6.5-67-87 0-.2L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9L449 161.1l13-13-9.1-15.9L429.5 91.4l36.3-40.1 16.1-17.8L446.3 1.3 430.2 19.1l-48 53L370.5 85l8.6 15.1 22.9 40L352 190.3l0-38.2 0-32-24 0 0-48.2 0-8-16 0 0 8 0 48.2-24 0 0 32 0 38.1-50.1-50.1 22.9-40L269.5 85 257.8 72.1l-48-53L193.7 1.3 158.1 33.5l16.1 17.8 36.3 40.1-23.3 40.8-9.1 15.9 13 13 41.3 41.4-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1z"]
};
const faStarOfDavid = {
  prefix: 'fass',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M16 400l56 0 91.3 0L232 512l48 0 68.7-112 91.3 0 56 0 0-48-4.9-8-54-88 54-88 4.9-8 0-48-56 0-91.3 0L280 0 232 0 163.3 112 72 112l-56 0 0 48 4.9 8 54 88-54 88L16 352l0 48zm91.8-90.5L128.9 344l-42.3 0 21.1-34.5zM194.6 344l-54-88 54-88 122.8 0 54 88-54 88-122.8 0zM229 400l54 0-27 44-27-44zm154.1-56l21.1-34.5L425.4 344l-42.3 0zm21.1-141.5L383.1 168l42.3 0-21.1 34.5zM283 112l-54 0 27-44 27 44zM128.9 168l-21.1 34.5L86.6 168l42.3 0z"]
};
const faFlagSwallowtail = {
  prefix: 'fass',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-128 384 0L352 192 448 32 64 32z"]
};
const faFlagAlt = faFlagSwallowtail;
const faPersonMilitaryRifle = {
  prefix: 'fass',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160 16l0 48 192 0 0-64L160 16zm17.6 80c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16L177.6 96zM176 224l-6.1 0L352 484.1l0-114.4 53.6 90.6 20.3 34.4 68.9-40.7-20.3-34.4-81.6-138 52.4-90.8L416 173.9 479.4 64l-13.9-8L437.9 40 424 32 408 59.7l13.9 8L331.6 224 176 224zm-34.4 19.7l-104 176L17.2 454.1l68.9 40.7 20.3-34.4L160 369.7 160 512l172.5 0L143 241.3l-1.4 2.4zM296 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faCarGarage = {
  prefix: 'fass',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M335 11.7l272 144 28.3 15-29.9 56.6-28.3-15L320 76.2 63 212.3l-28.3 15L4.7 170.7l28.3-15 272-144 15-7.9 15 7.9zM202.9 160l21.1 0 192 0 21.1 0 8.3 19.4L492 288l36 0 0 96 0 64 0 64-80 0 0-64-256 0 0 64-80 0 0-64 0-64 0-96 36 0 46.5-108.6 8.3-19.4zm192 64l-149.8 0-27.4 64 204.7 0-27.4-64zM192 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCartShopping = {
  prefix: 'fass',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0-9.1-48L496 288 576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faShoppingCart = faCartShopping;
const faBookFont = {
  prefix: 'fass',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM250.1 64l-20.2 0-4.4 9.1-61.2 128-40.2 84-1.4 2.9 35.5 0 30.6-64 102.3 0 30.6 64 35.5 0-1.4-2.9-40.2-84-61.2-128L250.1 64zm25.7 128l-71.7 0L240 117.1 275.8 192z"]
};
const faShieldPlus = {
  prefix: 'fass',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM232 368l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faVials = {
  prefix: 'fass',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M0 32l32 0 56 0 48 0 56 0 32 0 0 64-32 0 0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96 0 96 0 32zM136 96L88 96l0 160 48 0 0-160zM288 32l32 0 56 0 48 0 56 0 32 0 0 64-32 0 0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-304-32 0 0-64zM424 96l-48 0 0 160 48 0 0-160z"]
};
const faEyeDropperFull = {
  prefix: 'fass',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M341.6 29.2L240.1 130.8l-9.4-9.4L208 98.7 162.7 144l22.6 22.6 160 160L368 349.3 413.3 304l-22.6-22.6-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM32 344l0 88L0 472l40 40 40-32 88 0L310.7 337.3l-136-136L32 344z"]
};
const faDistributeSpacingHorizontal = {
  prefix: 'fass',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M32 0L80 0l0 512-48 0L32 0zM160 96l192 0 0 320-192 0 0-320zM480 0l0 512-48 0L432 0l48 0z"]
};
const faTabletRugged = {
  prefix: 'fass',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M352 64l0 384L96 448 96 64l256 0zM96 0L32 0l0 48L0 64l0 96 32 16 0 16L0 208l0 96 32 16 0 16L0 352l0 96 32 16 0 48 64 0 256 0 64 0 0-48 32-16 0-96-32-16 0-16 32-16 0-96-32-16 0-16 32-16 0-96L416 48l0-48L352 0 96 0z"]
};
const faTemperatureSnow = {
  prefix: 'fass',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M369.8 317.8L384 300.2l0-22.7L384 64l96 0 0 213.5 0 22.7 14.2 17.6C505.4 331.5 512 348.9 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM544 0L480 0 384 0 320 0l0 64 0 213.5c-20 24.7-32 56.2-32 90.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L544 64l0-64zM432 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.8 0-16-32 0 0 16 0 50.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 96.9l-22.6-6.1-4.1 15.5-12.9 48.2L200 182.4l0-55.8 35.3-35.3L246.6 80 224 57.4 212.7 68.7 200 81.4 200 56l0-24-48 0 0 24 0 25.4L139.3 68.7 128 57.4 105.4 80l11.3 11.3L152 126.6l0 55.8-48.3-27.9L90.7 106.3 86.6 90.8 55.7 99.1l4.1 15.5 4.6 17.3-15-8.7-20.8-12-24 41.6 20.8 12 15 8.7-17.3 4.6L7.7 182.3 16 213.2 31.4 209l48.2-12.9L128 224 79.7 251.9 31.4 239 16 234.8 7.7 265.7l15.5 4.1 17.3 4.6-15 8.7-20.8 12 24 41.6 20.8-12 15-8.7-4.6 17.3-4.1 15.5 30.9 8.3 4.1-15.5 12.9-48.2L152 265.6l0 55.8-35.3 35.3L105.4 368 128 390.6l11.3-11.3L152 366.6l0 25.4 0 24 48 0 0-24 0-25.4 12.7 12.7L224 390.6 246.6 368l-11.3-11.3L200 321.4l0-55.8 48.3 27.9 10.9 40.7c4.8-24.7 14.8-47.6 28.8-67.4l0-19.1-15.7 4.2L224 224l48.3-27.9 15.7 4.2 0-68.7-.5 .3 .5-1.8 0-33.2z"]
};
const faTemperatureFrigid = faTemperatureSnow;
const faMoped = {
  prefix: 'fass',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M328 32l24 0 64 0 17.1 0 5.6 16.1 15.6 44.8L512 64l32 0 0 96-32 0-41.7-20.8L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8l-33.6 34.2C570.2 284.2 542.6 272 512 272c-52.7 0-97 36.5-108.9 85.6c-2 8.4-3.1 17.3-3.1 26.4l-32 0-16 0-96 0c0 53-43 96-96 96s-96-43-96-96L0 384l0-64c0-70.7 57.3-128 128-128l128 0 0 128 109.3 0c16.8-38.5 48.4-69.2 87.6-84.7L398.9 80 352 80l-24 0 0-48zM256 96l0 64L96 160l0-64 160 0zM160 432c26.5 0 48-21.5 48-48l-96 0c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faFaceSmilePlus = {
  prefix: 'fass',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M568 0L520 0l0 24 0 48-48 0-24 0 0 48 24 0 48 0 0 48 0 24 48 0 0-24 0-48 48 0 24 0 0-48-24 0-48 0 0-48 0-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 384c33.4 0 63.5-14.6 84-37.9l24 21.2C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7l24-21.2c20.5 23.3 50.6 37.9 84 37.9z"]
};
const faSmilePlus = faFaceSmilePlus;
const faRadioTuner = {
  prefix: 'fass',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2 0 128l0 16L0 304l0 24L0 512l512 0 0-384-322.2 0 296-72.7zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336l128 0 16 0 0 32-16 0L80 368l-16 0 0-32 16 0zm16 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM64 192l32 0 320 0 32 0 0 64-32 0L96 256l-32 0 0-64z"]
};
const faRadioAlt = faRadioTuner;
const faFaceSwear = {
  prefix: 'fass',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320 0C178.6 0 64 114.6 64 256l512 0C576 114.6 461.4 0 320 0zM240.4 224c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM0 512l640 0 0-224L0 288 0 512zM400 384l-16 0 0 32 16 0 16 0 0 32-16 0-16 0 0 16 0 16-32 0 0-16 0-16-32 0 0 16 0 16-32 0 0-16 0-16-16 0-16 0 0-32 16 0 16 0 0-32-16 0-16 0 0-32 16 0 16 0 0-16 0-16 32 0 0 16 0 16 32 0 0-16 0-16 32 0 0 16 0 16 16 0 16 0 0 32-16 0zm-80 0l0 32 32 0 0-32-32 0zm262.6-41.7l-10.4 12.1-96 112-10.4 12.1-24.3-20.8 10.4-12.1 96-112 10.4-12.1 24.3 20.8zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 320l0 16 0 64 0 16-32 0 0-16 0-64 0-16 32 0zM192 448l32 0 0 32-32 0 0-32zM96.4 335.5l0-15.5 32 0 0 15.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c0 0 0 0 0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.3 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 13.7-32 0 0-14.3c-7.5-1.6-14.5-3.8-20.6-5.8c0 0 0 0 0 0s0 0 0 0c-1.6-.5-3.1-1-4.5-1.4L56 453.7l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c0 0 0 0 0 0c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5s0 0 0 0c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1C59 358.5 69.7 347 80.8 341.1c5-2.7 10.4-4.5 15.6-5.6z"]
};
const faWaterArrowDown = {
  prefix: 'fass',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M256 222.2l0 1.8 2 0 8.4 7.7L288 251.2l21.5-19.6L318 224l2 0 0-1.8 77.5-70.5 23.7-21.5-43-47.4-23.7 21.5L320 135.7 320 32l0-32L256 0l0 32 0 103.7-34.5-31.3L197.8 82.8l-43.1 47.4 23.7 21.5L256 222.2zm32 263.2c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7zM272.4 365.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 313.9 19.3 320 0 320l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faWaterLower = faWaterArrowDown;
const faScannerTouchscreen = {
  prefix: 'fass',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M192 0l0 64-64 0 0-64 64 0zM352 0l0 64-64 0 0-64 64 0zM224 0l32 0 0 64-32 0 0-64zM416 0l0 288-32 0L384 0l32 0zm32 0l64 0 0 288-64 0L448 0zM0 96l352 0 0 416L0 512 0 96zm64 64l0 288 224 0 0-288L64 160z"]
};
const faCircle7 = {
  prefix: 'fass',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72-384l24 0 0 29.4-2.3 4.9L245.5 384l-53 0 3.9-8.2L290.2 176 184 176l-24 0 0-48 24 0 144 0z"]
};
const faPlugCirclePlus = {
  prefix: 'fass',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16z"]
};
const faPersonSkiJumping = {
  prefix: 'fass',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 96l32 0 160 0 13.3 0 9.4 9.4 13.8 13.8 25.9 25.9-29.2 22.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.8 380 464 233.4l0-41.4 0-24 48 0 0 24 0 56 0 14.6-13 6.7L50.5 500.7l-21.3 11L7.1 469l21.3-11 66.6-34.4 63-168.3c3.9-10.5 9.7-20.3 17-28.8L232.1 160 160 160l-32 0 0-64z"]
};
const faSkiJump = faPersonSkiJumping;
const faPlaceOfWorship = {
  prefix: 'fass',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M224 96l0 89.6L160 224l0 288 96 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 96 0 0-288-64-38.4L416 96 320 0 224 96zM0 344L0 512l128 0 0-238.4L0 344zM640 512l0-168L512 273.6 512 512l128 0z"]
};
const faWaterArrowUp = {
  prefix: 'fass',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M320 123.5l34.5 31.3 23.7 21.5 43-47.4-23.7-21.5-88-80L288 8 266.5 27.5l-88 80L154.8 129l43.1 47.4 23.7-21.5L256 123.5l0 84.5 0 32 64 0 0-32 0-84.5zM288 485.4c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.6 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.6 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.6 11.1-5.3 15.6-7.7zM272.4 365.1c5.8-2.6 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.6 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 313.9 19.3 320 0 320l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.6 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faWaterRise = faWaterArrowUp;
const faWaveformLines = {
  prefix: 'fass',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M352 32l0-32L288 0l0 32 0 448 0 32 64 0 0-32 0-448zM544 96l0-32-64 0 0 32 0 320 0 32 64 0 0-32 0-320zM256 128l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256zm192 32l0-32-64 0 0 32 0 192 0 32 64 0 0-32 0-192zM160 224l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zM0 224l0 64 64 0 0-64L0 224zm576 0l0 64 64 0 0-64-64 0z"]
};
const faWaveformPath = faWaveformLines;
const faSplit = {
  prefix: 'fass',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M416 32l96 96-96 96-32 0 0-64-50.7 0-96 96 96 96 50.7 0 0-64 32 0 96 96-96 96-32 0 0-64-64 0-13.3 0-9.4-9.4L178.7 288 32 288 0 288l0-64 32 0 146.7 0L297.4 105.4l9.4-9.4L320 96l64 0 0-64 32 0z"]
};
const faFilmCanister = {
  prefix: 'fass',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M256 0L96 0l0 32L32 32 0 32 0 96l32 0 0 352L0 448l0 64 32 0 288 0 32 0 0-64-32 0 0-352 32 0 0-64-32 0-64 0 0-32zm96 128l0 288 160 0 0-96 64 0 0-192-224 0zm88 40l0 48-48 0 0-48 48 0zm48 0l48 0 0 48-48 0 0-48zM440 328l0 48-48 0 0-48 48 0z"]
};
const faFilmCannister = faFilmCanister;
const faFolderXmark = {
  prefix: 'fass',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM353.9 224L320 190.1l-17 17-47 47-47-47-17-17L158.1 224l17 17 47 47-47 47-17 17L192 385.9l17-17 47-47 47 47 17 17L353.9 352l-17-17-47-47 47-47 17-17z"]
};
const faFolderTimes = faFolderXmark;
const faToiletPaperBlank = {
  prefix: 'fass',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M444.2 0C397.2 49.6 384 126.5 384 192c0 109.9-8 217.7-50.7 320L8 512l18.4-44.2C60.1 382.6 64 281.9 64 192C64 86 107 0 160 0L444.2 0zM608 192c0 106-43 192-96 192s-96-86-96-192S459 0 512 0s96 86 96 192zm-64 0c0-35.3-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64s32-28.7 32-64z"]
};
const faToiletPaperAlt = faToiletPaperBlank;
const faTabletScreen = {
  prefix: 'fass',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 0L448 0l0 512L0 512 0 0zM160 432l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zM384 64L64 64l0 320 320 0 0-320z"]
};
const faTabletAndroidAlt = faTabletScreen;
const faHexagonVerticalNftSlanted = {
  prefix: 'fass',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M0 128L0 384 224 512 448 384l0-256L224 0 0 128zM192 92l31.8-18.2L272 101.4l0 36.9-48-27.5L224 240l32 0 16 0 0 32-16 0-32 0 0 160 0 6.3L192 420l0-164 0-164zM320 383.4l0-217.7L296 152l0-36.9 47.9 27.4s0 0 0 0L384 165.4l0 36.8L352 184l0 181.1-32 18.3zM160 384l0 17.7L127.2 383 96 266.1 96 360l0 5.1L64 346.9l0-181.7 33.1-18.9L128 261.9l0-133.3 32-18.3 0 1.7 0 269.9 0 2.1z"]
};
const faFolderMusic = {
  prefix: 'fass',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM352 192l0-23.1L330.4 177l-128 48L192 228.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faDisplayMedical = {
  prefix: 'fass',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M0 0L576 0l0 416-240 0 10.7 32 69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416 0 416 0 0zM64 64l0 288 448 0 0-288L64 64zm192 48l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faDesktopMedical = faDisplayMedical;
const faShareAll = {
  prefix: 'fass',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M469.6 184.4L352 76.6 352 32l32 0L576 208 384 384l-32 0 0-44.6L469.6 231.6 495.4 208l-25.7-23.6zM352 120l72.3 66.3L448 208l-23.7 21.7L352 296l-96 88-32 0 0-96-16 0c-61.9 0-112 50.1-112 112c0 48 32 80 32 80s-128-48-128-176c0-97.2 78.8-176 176-176l48 0 0-96 32 0 96 88z"]
};
const faPeapod = {
  prefix: 'fass',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M512 0L416 0C186.2 0 0 186.2 0 416l0 96 96 0c229.8 0 416-186.2 416-416l0-96zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faChessClock = {
  prefix: 'fass',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M256 32L96 32l0 48 56 0 0 48L0 128 0 480l640 0 0-352-96 0 0-32L384 96l0 32-184 0 0-48 56 0 0-48zM576 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-41.4-48L512 233.4l-11.3 11.3-48 48L441.4 304 464 326.6l11.3-11.3 48-48L534.6 256zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-16 48l0 64 0 16 32 0 0-16 0-64 0-16-32 0 0 16z"]
};
const faAxe = {
  prefix: 'fass',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M64 512L313.4 262.6l-64-64L0 448l64 64zM400 48L352 0 224 128 384 288l0 96 0 32 32 0c123.7 0 224-100.3 224-224l0-32-32 0-96 0-48-48 48-48L448 0 400 48zm48 300.8l0-32.8c45-11.6 80.4-47 92-92l32.8 0C560.1 286.7 510.7 336.1 448 348.8z"]
};
const faSquareD = {
  prefix: 'fass',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M448 32L0 32 0 480l448 0 0-448zM152 128l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24 24 0zm24 208l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z"]
};
const faGripVertical = {
  prefix: 'fass',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M0 352l128 0 0 128L0 480 0 352zm192 0l128 0 0 128-128 0 0-128zM0 320L0 192l128 0 0 128L0 320zM192 192l128 0 0 128-128 0 0-128zM0 160L0 32l128 0 0 128L0 160zM192 32l128 0 0 128-128 0 0-128z"]
};
const faMobileSignalOut = {
  prefix: 'fass',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M64 64l160 0 0-64L64 0 0 0 0 64 0 448l0 64 64 0 224 0 64 0 0-64 0-160-64 0 0 160L64 448 64 64zm80 320l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zM256 48c114.9 0 208 93.1 208 208l48 0C512 114.6 397.4 0 256 0l0 48zm32 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0l48 0c0-88.4-71.6-160-160-160l0 48c61.9 0 112 50.1 112 112z"]
};
const faArrowTurnUp = {
  prefix: 'fass',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M32 448L0 448l0 64 32 0 160 0 32 0 0-32 0-357.5 73.4 73.4L320 218.5l45.3-45.3-22.6-22.6-128-128L192 0 169.4 22.6l-128 128L18.7 173.3 64 218.5l22.6-22.6L160 122.5 160 448 32 448z"]
};
const faLevelUp = faArrowTurnUp;
const faU = {
  prefix: 'fass',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M64 32l0 32 0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224 0-32 64 0 0 32 0 224c0 106-86 192-192 192S0 394 0 288L0 64 0 32l64 0z"]
};
const faArrowUpFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M246.6 57.4L224 34.7 201.4 57.4l-128 128L50.7 208 96 253.3l22.6-22.6L192 157.3 192 320l0 32 64 0 0-32 0-162.7 73.4 73.4L352 253.3 397.3 208l-22.6-22.6-128-128zM64 416L0 416l0 64 64 0 0-64zm96 0l-64 0 0 64 64 0 0-64zm32 64l64 0 0-64-64 0 0 64zm160-64l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0z"]
};
const faSquareRootVariable = {
  prefix: 'fass',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M296 32l24 0 224 0 32 0 0 64-32 0L344 96 238.7 457 232 480l-42.4 0-9.3-15.9L77.6 288 32 288 0 288l0-64 32 0 64 0 18.4 0 9.3 15.9 74.5 127.7L289.3 55 296 32zM528 226.7L573.3 272l-22.6 22.6L525.3 320l25.4 25.4L573.3 368 528 413.3l-22.6-22.6L480 365.3l-25.4 25.4L432 413.3 386.7 368l22.6-22.6L434.7 320l-25.4-25.4L386.7 272 432 226.7l22.6 22.6L480 274.7l25.4-25.4L528 226.7z"]
};
const faSquareRootAlt = faSquareRootVariable;
const faLightSwitchOn = {
  prefix: 'fass',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M384 0L0 0 0 512l384 0L384 0zM96 96l192 0 0 320L96 416 96 96zm96-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64-320l-128 0 0 128 128 0 0-128z"]
};
const faArrowDownArrowUp = {
  prefix: 'fass',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M438.6 57.4l96 96L557.3 176 512 221.3l-22.6-22.6L448 157.3 448 448l0 32-64 0 0-32 0-290.7-41.4 41.4L320 221.3 274.7 176l22.6-22.6 96-96L416 34.7l22.6 22.6zm-256 397.3L160 477.3l-22.6-22.6-96-96L18.7 336 64 290.7l22.6 22.6L128 354.7 128 64l0-32 64 0 0 32 0 290.7 41.4-41.4L256 290.7 301.3 336l-22.6 22.6-96 96z"]
};
const faSortAlt = faArrowDownArrowUp;
const faRaindrops = {
  prefix: 'fass',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M105.5 122.8c-6.2 10.4-9.5 22.3-9.5 34.4l0 2.8c0 35.3 28.7 64 64 64s64-28.7 64-64l0-2.8c0-12.1-3.3-24-9.5-34.4L160 32l-54.5 90.8zm-96 192C3.3 325.2 0 337.1 0 349.2L0 352c0 35.3 28.7 64 64 64s64-28.7 64-64l0-2.8c0-12.1-3.3-24-9.5-34.4L64 224 9.5 314.8zM320 128L211.7 293.5c-12.8 19.6-19.7 42.6-19.7 66C192 426 246 480 312.5 480l15 0C394 480 448 426 448 359.5c0-23.4-6.8-46.4-19.7-66L320 128z"]
};
const faDash = {
  prefix: 'fass',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 224l32 0 448 0 32 0 0 64-32 0L32 288 0 288l0-64z"]
};
const faMinusLarge = faDash;
const faClock = {
  prefix: 'fass',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136 0 12.8 10.7 7.1 96 64 20 13.3 26.6-39.9-20-13.3L280 243.2 280 120l0-24-48 0 0 24z"]
};
const faClockFour = faClock;
const faInputNumeric = {
  prefix: 'fass',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 128l0 256L64 384l0-256 512 0zM64 64L0 64l0 64L0 384l0 64 64 0 512 0 64 0 0-64 0-256 0-64-64 0L64 64zm40 96l0 48 24 0 8 0 0 96-16 0-24 0 0 48 24 0 80 0 24 0 0-48-24 0-16 0 0-120 0-24-24 0-32 0-24 0zm221.4 51.8c5.9 6.7 5.7 16.7-.3 23.3L256 309.9l0 42.1 16 0 88 0 24 0 0-48-24 0-33.2 0 33.6-36.4c17-18.4 21.5-44.1 13.5-66.4l3.4-3-15.8-18.1c-26.2-30-73-29.7-98.9 .5l-16.9 19.7 36.4 31.2 16.9-19.7c6.9-8.1 19.3-8.1 26.3-.1z"]
};
const faTruckTow = {
  prefix: 'fass',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M64 16L64 0l96 0L384 252l0-124 0-32 32 0 96 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 128-64 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96L0 416 0 256l192 0L96 64l0 112c0 20.9-13.4 38.7-32 45.3l0 2.7-16 0c-26.5 0-48-21.5-48-48l0-16 0-16 32 0 0 16 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16L64 32l0-16zM576 256l0-18.7L498.7 160 448 160l0 96 128 0zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faBackwardStep = {
  prefix: 'fass',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M64 96l0-32L0 64 0 96 0 416l0 32 64 0 0-32 0-160L320 448l0-384L64 256 64 96z"]
};
const faStepBackward = faBackwardStep;
const faPallet = {
  prefix: 'fass',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M32 320L0 320l0 64 32 0 32 0 0 64-32 0L0 448l0 64 32 0 32 0 32 0 32 0 160 0 32 0 32 0 160 0 32 0 32 0 32 0 32 0 0-64-32 0-32 0 0-64 32 0 32 0 0-64-32 0-32 0-32 0-32 0-160 0-32 0-32 0-160 0-32 0-32 0-32 0zm96 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z"]
};
const faCarBolt = {
  prefix: 'fass',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M120 32L97.3 32 89.8 53.4 41.3 192 0 192 0 400l0 80 96 0 0-80 320 0 0 80 96 0 0-80 0-208-41.3 0L422.2 53.4 414.7 32 392 32 120 32zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 224L288 96l-24 96 88 0L224 320l24-96-88 0z"]
};
const faArrowsMaximize = {
  prefix: 'fass',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M320 32l-32 0 0 64 32 0 50.7 0L256 210.7 141.3 96 192 96l32 0 0-64-32 0L64 32 32 32l0 32 0 128 0 32 64 0 0-32 0-50.7L210.7 256 96 370.7 96 320l0-32-64 0 0 32 0 128 0 32 32 0 128 0 32 0 0-64-32 0-50.7 0L256 301.3 370.7 416 320 416l-32 0 0 64 32 0 128 0 32 0 0-32 0-128 0-32-64 0 0 32 0 50.7L301.3 256 416 141.3l0 50.7 0 32 64 0 0-32 0-128 0-32-32 0L320 32z"]
};
const faExpandArrows = faArrowsMaximize;
const faFaucet = {
  prefix: 'fass',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M192 64l0 44.8L64 96l0 64 128-12.8 31.2-3.1 .8-.1s0 0 0 0s0 0 0 0l.8 .1 31.2 3.1L384 160l0-64L256 108.8 256 64l-64 0zM160 224l-32 32L0 256 0 384l132.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-88.4-71.6-160-160-160l-32 0-32-32-32 0 0-44.6-32-3.2-32 3.2 0 44.6-32 0z"]
};
const faCloudSleet = {
  prefix: 'fass',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm24 32L48 512 0 512 72 352l48 0zm256 0L304 512l-48 0 72-160 48 0zm-160 0l0 24 0 16 16 0 24 0 0 48-24 0-16 0 0 16 0 24-48 0 0-24 0-16-16 0-24 0 0-48 24 0 16 0 0-16 0-24 48 0zm256 0l0 24 0 16 16 0 24 0 0 48-24 0-16 0 0 16 0 24-48 0 0-24 0-16-16 0-24 0 0-48 24 0 16 0 0-16 0-24 48 0z"]
};
const faLampStreet = {
  prefix: 'fass',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M64 176c0-61.9 50.1-112 112-112c57.4 0 104.7 43.2 111.2 98.8C196.8 178.3 128 257.1 128 352l384 0c0-95.3-69.4-174.4-160.5-189.4C344.6 71.6 268.7 0 176 0C78.8 0 0 78.8 0 176L0 512l64 0 0-336zM320 448c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z"]
};
const faListRadio = {
  prefix: 'fass',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zM192 64l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faPenNibSlash = {
  prefix: 'fass',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M212.8 142.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L446.7 324 480 224l.7-.7-128-128L352 96 212.8 142.4zM64 448l20.7 20.7 144-144c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-87.8-69.2L64 448zm345.1-29.7L306.4 337.4c-8.7 9-20.9 14.6-34.4 14.6c-7.4 0-14.4-1.7-20.7-4.7l-144 144L128 512l281.1-93.7zM375.3 72.7l128 128L576 128 448 0 375.3 72.7z"]
};
const faBaseballBatBall = {
  prefix: 'fass',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M408.9 7.1l-5.7-5.7-5.7 5.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L504.9 114.5l5.7-5.7-5.7-5.7-96-96zM512 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM33.9 384L0 417.9l17 17 60.2 60.2 17 17L128 478.1l-17-17L50.9 401l-17-17z"]
};
const faSquareUpLeft = {
  prefix: 'fass',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M448 32L0 32 0 480l448 0 0-448zM128 320l0-160 160 0 16 16-52 52 84 84-56 56-84-84-52 52-16-16z"]
};
const faOverline = {
  prefix: 'fass',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M32 32L0 32 0 96l32 0 384 0 32 0 0-64-32 0L32 32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM336 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z"]
};
const faS = {
  prefix: 'fass',
  iconName: 's',
  icon: [320, 512, [115], "53", "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0s0 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3L-8.5 436.3l20.2-60.7 30.4 10.1c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4l30.9 8.2-16.5 61.8-30.9-8.2c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"]
};
const faTimeline = {
  prefix: 'fass',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M152 72l0 48-48 0 0-48 48 0zM104 16L48 16l0 56 0 48 0 56 48 0 0 48-64 0L0 224l0 64 32 0 256 0 0 48-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-48 256 0 32 0 0-64-32 0-64 0 0-48 48 0 0-56 0-48 0-56-56 0-48 0-56 0 0 56 0 48 0 56 48 0 0 48-320 0 0-48 48 0 0-56 0-48 0-56-56 0-48 0zM488 72l48 0 0 48-48 0 0-48zM344 392l0 48-48 0 0-48 48 0z"]
};
const faKeyboard = {
  prefix: 'fass',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M576 64L0 64 0 448l576 0 0-384zM128 128l0 64-64 0 0-64 64 0zM64 224l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm32-192l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-64 96l256 0 0 64-256 0 0-64zM320 128l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z"]
};
const faArrowsFromDottedLine = {
  prefix: 'fass',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M128 96L224 0l96 96 0 32-64 0 0 32 0 32-64 0 0-32 0-32-64 0 0-32zM256 352l0 16 0 16 64 0 0 32-96 96-96-96 0-32 64 0 0-16 0-16 0-32 64 0 0 32zM64 224l0 64L0 288l0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z"]
};
const faUsbDrive = {
  prefix: 'fass',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M448 96L0 96 0 416l448 0 0-320zm192 32l-160 0 0 256 160 0 0-256zm-56 56l0 48-48 0 0-48 48 0zm-48 96l48 0 0 48-48 0 0-48z"]
};
const faBallot = {
  prefix: 'fass',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M448 0L0 0 0 512l448 0L448 0zM64 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zm64 128l0 64-64 0 0-64 64 0zm64 16l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm16-256l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zM192 240l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z"]
};
const faCaretDown = {
  prefix: 'fass',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M320 240L160 384 0 240l0-48 320 0 0 48z"]
};
const faLocationDotSlash = {
  prefix: 'fass',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M457.5 332.4C488.3 282.6 512 231.4 512 192C512 86 426 0 320 0C248.8 0 186.6 38.8 153.5 96.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L457.5 332.4zM257.7 177.3c6.6-28.3 32-49.3 62.3-49.3c35.3 0 64 28.7 64 64c0 24.6-13.9 46-34.3 56.7l-92-71.4zM402.1 412.8L128.1 196.9C133.5 310 320 512 320 512s39.1-42.4 82.1-99.2z"]
};
const faMapMarkerAltSlash = faLocationDotSlash;
const faCards = {
  prefix: 'fass',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M210.9 512l254-146.7L254 0 0 146.7 210.9 512zm12.9-345.2l76.1 20.4c26 7 41.4 33.7 34.4 59.7s-33.7 41.4-59.7 34.4l-10-2.7 17.7 30.7 12.1-7 12.1-7 13.9 24.1-12.1 7-12.1 7-24.1 13.9-12.1 7-12.1 7-13.9-24.1 12.1-7 12.1-7-17.8-30.7-2.7 10c-7 26-33.7 41.4-59.7 34.4s-41.4-33.7-34.4-59.7l20.4-76.1 12.6-47.1 47.1 12.6zM320 512l320 0 0-448L327.9 64 492.7 349.4l16 27.7-27.7 16L320 486l0 26zM476.4 135.7c13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2c15.5 13.5 16.2 37.5 2.2 51.9l-54 55.8-54.1-55.8c-14-14.5-13.2-38.5 2.5-51.9z"]
};
const faHouseChimneyMedical = {
  prefix: 'fass',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M576 287.6l-64.2 0 1 224.4L64.1 512l0-224.4L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6zM320 192l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z"]
};
const faClinicMedical = faHouseChimneyMedical;
const faBoxingGlove = {
  prefix: 'fass',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M0 0L384 0l0 128-96 0-16 0 0 16 0 16-154.7 0L89.6 139.2l-12.8-9.6L57.6 155.2l12.8 9.6 32 24 4.3 3.2 5.3 0 160 0 0 80 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-64 0-32 80 0 48 0 16 0 0 128-96 96 0 128L32 512l0-128L0 352 0 0zM152.9 354.7l-13.3-8.9-17.8 26.6 13.3 8.9 28 18.7-28 18.7-13.3 8.9 17.8 26.6 13.3-8.9L192 419.2l39.1 26.1 13.3 8.9 17.8-26.6-13.3-8.9-28-18.7 28-18.7 13.3-8.9-17.8-26.6-13.3 8.9L192 380.8l-39.1-26.1z"]
};
const faGloveBoxing = faBoxingGlove;
const faTemperatureThreeQuarters = {
  prefix: 'fass',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M112 300.2L97.8 317.8C86.6 331.5 80 348.9 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-19.1-6.6-36.5-17.8-50.3L208 300.2l0-22.7L208 64l-96 0 0 213.5 0 22.7zM208 0l64 0 0 64 0 213.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5L48 64 48 0l64 0 96 0zm0 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 144l0-16 32 0 0 16 0 178.8c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature3 = faTemperatureThreeQuarters;
const faThermometer3 = faTemperatureThreeQuarters;
const faThermometerThreeQuarters = faTemperatureThreeQuarters;
const faBellSchool = {
  prefix: 'fass',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 448c-54 0-103.9-17.9-144-48l0 112 256 0 32 0 112 0 24 0 0-24 0-46.4c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 22.4-88 0 0-64c-40.1 30.1-90 48-144 48z"]
};
const faMobileScreen = {
  prefix: 'fass',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 0L368 0l0 512L16 512 16 0zM144 432l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zM304 64L80 64l0 320 224 0 0-320z"]
};
const faMobileAndroidAlt = faMobileScreen;
const faPlaneUp = {
  prefix: 'fass',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L512 288l0 96L320 320l0 80 64 48 0 64L256 480 128 512l0-64 64-48 0-80L0 384l0-96L192 160l0-66.3z"]
};
const faFolderHeart = {
  prefix: 'fass',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM144 251.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 384.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z"]
};
const faCircleLocationArrow = {
  prefix: 'fass',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM233.4 278.6L86.3 244.7 369.1 142.9 267.3 425.7 233.4 278.6z"]
};
const faLocationCircle = faCircleLocationArrow;
const faFaceHeadBandage = {
  prefix: 'fass',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2l-12.4 3c-2.3 3.3-4.5 6.7-6.6 10.1l-.8 1.2C26.9 130.6 15 158.9 7.8 189l-.4 1.8c-3.8 16.4-6.2 33.3-7 50.6c0 0 0 0 0 0c-.1 1.3-.1 2.6-.2 3.8l0 .5c-.1 3.1-.2 6.2-.2 9.3l0 .9 0 .5 0 .7c.1 31 5.1 60.9 14.4 88.9l.7 2.1c6.3 18.7 14.5 36.5 24.2 53.2l20.2-29.9C101.7 454.9 188.2 512 288 512c141.4 0 256-114.6 256-256c0-8.2-.4-16.4-1.1-24.4l32.8 9.9c-.9-17.2-3.2-34.1-7-50.4l-.5-2.1c-5.2-21.6-12.8-42.3-22.5-61.8c0 0 0 0 0 0c-4.1-8.1-8.5-16-13.3-23.7c-2-3.1-4-6.2-6-9.3c-4.1-6-8.4-11.8-12.9-17.5l-.6-.7c-21.2-26.5-47-49.1-76.2-66.8l-1.5-.9c-2.8-1.6-5.5-3.2-8.4-4.8L416.2 4.9c-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0zm12.6 64.1c38.3-13 78.3-22.3 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2C419.3 71.1 360.6 64.9 300.6 64.1zm15.6 96.4s0 0 0 0c-9.4-.3-18.8-.5-28.2-.5c-17.1 0-34.1 .5-51 1.5c0 0 0 0 0 0c-47.8 2.8-94.6 9.4-140 19.7c0 0 0 0 0 0c-19.6 4.4-39 9.5-58.1 15.3l.1-.6c.4-1.8 .9-3.6 1.4-5.4c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38C139.9 104.9 212.9 96 288 96s148.1 8.9 218 25.8c7.4 12 13.9 24.8 19.3 38c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26zM176.4 240c13.5-10.8 27.6-20.9 42.1-30.4c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32zm-126-13.6c41-12.2 83.3-21.3 126.6-27.1c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5zM373.2 397.5C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3l-15.3 4.8-9.6-30.5 15.3-4.8c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9l11.8 10.8-21.5 23.7-11.8-10.8zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSushiRoll = {
  prefix: 'fass',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M448 368l0-224C448 82.1 347.7 32 224 32S0 82.1 0 144L0 368s48 112 224 112s224-112 224-112zM209.4 80.3l8.4 18.3-75.3 26.5-3.9 1.4-3 2.8L85.2 175.9C71.7 166.5 64 155.6 64 144c0-33.4 63.9-60.8 145.4-63.7zm-49.8 81.2l74.9-26.4 8.9 19.4 3.4 7.5 7.7 2.9 73.7 27.6c-28 9.6-64.5 15.5-104.3 15.5c-37.6 0-72.2-5.2-99.5-13.9l35.2-32.6zm94.1-80.4C327.9 86.7 384 112.7 384 144c0 8-3.7 15.7-10.4 22.8l-97.2-36.4L253.8 81.1z"]
};
const faMakiRoll = faSushiRoll;
const faMakizushi = faSushiRoll;
const faCarBump = {
  prefix: 'fass',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M65.1 75.8l21.1-5.7L318.1 8l21.1-5.7L352.2 20 430.6 127l40.7-10.9L521 301.5l20.7 77.3-92.7 24.8-20.7-77.3L150 400.9l20.7 77.3L78 503 57.3 425.8 7.6 240.3l40.7-10.9L62.7 97.6l2.4-21.8zm248.4-.3L124 126.3l-9.3 85.3 249.6-66.9L313.5 75.5zm-180 263.6a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8zM434.3 225.4a32 32 0 1 0 -61.8 16.6 32 32 0 1 0 61.8-16.6zM510.9 416c56.4 0 103.1 41.7 110.9 96L400 512c7.8-54.3 54.4-96 110.9-96z"]
};
const faPiggyBank = {
  prefix: 'fass',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7L256 96c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96l32 0-18.8 75.1c15.8 14.8 28.7 32.8 37.5 52.9l45.3 0 0 160-64 0c-9.1 12.1-19.9 22.9-32 32l0 96-96 0 0-64-128 0 0 64-96 0 0-96c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l12 0 0 48-12 0c-11 0-20 9-20 20s9 20 20 20l31.2 0c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2l128 0zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faRacquet = {
  prefix: 'fass',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-68.2 68.2-172.3 88.9-245.7 40.8l-48.8 48.8L160 416 64 512 0 448l96-96 9.4 9.4 48.8-48.8C136.4 285.2 128 253.3 128 221c0-54.2 23.4-110.5 66.9-154z"]
};
const faCarMirrors = {
  prefix: 'fass',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M152 32l-22.7 0-7.5 21.4L84.5 160 0 160l0 64 32 0 0 176 0 80 96 0 0-80 320 0 0 80 96 0 0-80 0-176 32 0 0-64-84.5 0L454.2 53.4 446.7 32 424 32 152 32zM434.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM96 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faIndustryWindows = {
  prefix: 'fass',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M32 32l128 0 0 192 192-96 0 96 192-96 0 96 0 256L32 480l0-96 0-160L32 32zM328 312l-80 0 0 80 80 0 0-80zm-128 0l-80 0 0 80 80 0 0-80zm256 0l-80 0 0 80 80 0 0-80z"]
};
const faIndustryAlt = faIndustryWindows;
const faBoltAuto = {
  prefix: 'fass',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M304 0L0 288l162.2 23.2L112 512 416 224 253.8 200.8 304 0zM506.4 512l69.6 0L480 288l-64 0L320 512l69.6 0 13.7-32 89.3 0 13.7 32zM448 375.8L465.2 416l-34.5 0L448 375.8z"]
};
const faBatteryHalf = {
  prefix: 'fass',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M480 160l0 192L64 352l0-192 416 0zM64 96L0 96l0 64L0 352l0 64 64 0 416 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L64 96zm224 96L96 192l0 128 192 0 0-128z"]
};
const faBattery3 = faBatteryHalf;
const faFluxCapacitor = {
  prefix: 'fass',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M0 32l448 0 0 448L0 480 0 32zM148.7 237.3l-49-49L71.4 160 128 103.4l28.3 28.3 49 49c1.8-6.6 2.7-13.6 2.7-20.7c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zM184 282.7c-23.9 13.8-40 39.7-40 69.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3l0 69.3 0 40-80 0 0-40 0-69.3zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 7.2 .9 14.1 2.7 20.7l49-49L320 103.4 376.6 160l-28.3 28.3-49 49zm-160-88.6L128 137.4 105.4 160l11.3 11.3L208 262.6l0 89.4 0 16 32 0 0-16 0-89.4 91.3-91.3L342.6 160 320 137.4l-11.3 11.3L224 233.4l-84.7-84.7z"]
};
const faMountainCity = {
  prefix: 'fass',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M288 0l0 144.4L357.7 256l58.3 0 0 64-18.3 0L507.1 495l10.6 17L640 512l0-320-72 0 0-72 0-24-48 0 0 24 0 72-40 0L480 0 288 0zm64 64l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm160 96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zM480 512l-30-48L268.3 173.3 240 128l-28.3 45.3L30 464 0 512l56.6 0 366.8 0 56.6 0zM240 218.6L303.4 320 240 320l-48 64-30.2-40.3L240 218.6z"]
};
const faCoins = {
  prefix: 'fass',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"]
};
const faHoneyPot = {
  prefix: 'fass',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M128 32L64 32 32 32l0 64 32 0C25.1 125.2 0 171.7 0 224C0 400 128 480 128 480l192 0s128-80 128-256c0-52.3-25.1-98.8-64-128l32 0 0-64-32 0L176 32l0 104 0 24-48 0 0-24 0-104zM96.9 352C78.7 320.3 64 278.1 64 224l320 0c0 54.1-14.7 96.3-32.9 128L96.9 352z"]
};
const faOlive = {
  prefix: 'fass',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 87.8 21.9 87.8 21.9s8.4-57.5-21.9-87.8s-87.8-21.9-87.8-21.9s-8.4 57.5 21.9 87.8z"]
};
const faKhanda = {
  prefix: 'fass',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M192 48L256 0l64 48s-6.6 10.6-14.5 27.5C342.5 93.8 368 131.9 368 176s-25.5 82.2-62.5 100.5C313.4 293.4 320 304 320 304l-48 36 0 22.6 34.5-23.7 .1-.1C363.8 299.5 416 256 416 180.6c0-47.6-14.7-106.7-32-132.6c0 0 128 54.5 128 176c0 96-112 192-112 192l-83.4-45.3L284.2 393l46.1 31.7c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.9L199.8 451c-1.5 11.8-11.6 21-23.8 21c-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9 .2 5.7 .7L227.8 393l-32.4-22.3L112 416s-112-96-112-192C0 102.5 128 48 128 48c-17.3 25.9-32 85.1-32 132.6c0 75.4 52.2 118.9 109.4 158.2l.1 .1L240 362.6l0-22.6-48-36s6.6-10.6 14.5-27.5C169.5 258.2 144 220.1 144 176s25.5-82.2 62.5-100.5C198.6 58.6 192 48 192 48zm0 128c0 23.5 12.7 44.1 31.6 55.2c4.9-17.3 8.4-36.2 8.4-55.2s-3.5-37.9-8.4-55.2C204.7 131.9 192 152.5 192 176zm88 0c0 18.9 3.5 37.9 8.4 55.2C307.3 220.1 320 199.5 320 176s-12.7-44.1-31.6-55.2c-4.9 17.3-8.4 36.2-8.4 55.2z"]
};
const faFilterList = {
  prefix: 'fass',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M112 256l0 128 128 96 0-224L352 128l0-64L0 64l0 64L112 256zM352 384l-32 0 0 64 32 0 128 0 32 0 0-64-32 0-128 0zM320 224l0 64 32 0 128 0 32 0 0-64-32 0-128 0-32 0zM416 64l-32 0 0 64 32 0 64 0 32 0 0-64-32 0-64 0z"]
};
const faOutlet = {
  prefix: 'fass',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M448 32L0 32 0 480l448 0 0-448zM64 256c0-88 64-128 64-128l192 0s64 40 64 128s-64 128-64 128l-192 0s-64-40-64-128zm112-64l-32 0 0 16 0 48 0 16 32 0 0-16 0-48 0-16zm128 0l-32 0 0 16 0 48 0 16 32 0 0-16 0-48 0-16zm-80 96c-13.3 0-24 10.7-24 24l0 24 48 0 0-24c0-13.3-10.7-24-24-24z"]
};
const faSliders = {
  prefix: 'fass',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 384l0 64 32 0 32 0 0 48 48 0 64 0 48 0 0-48 256 0 32 0 0-64-32 0-256 0 0-48-48 0-64 0-48 0 0 48-32 0L0 384zM0 224l0 64 32 0 256 0 0 48 48 0 64 0 48 0 0-48 32 0 32 0 0-64-32 0-32 0 0-48-48 0-64 0-48 0 0 48L32 224 0 224zM32 64L0 64l0 64 32 0 64 0 0 48 48 0 64 0 48 0 0-48 224 0 32 0 0-64-32 0L256 64l0-48-48 0-64 0L96 16l0 48L32 64zm80 384l0-64 64 0 0 64-64 0zM336 224l64 0 0 64-64 0 0-64zM144 128l0-64 64 0 0 64-64 0z"]
};
const faSlidersH = faSliders;
const faCauldron = {
  prefix: 'fass',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5L32 512l48 0 0-39c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 39 48 0 0-82.1c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4l35.1 0 0-64-80 0-144 0L80 160 0 160l0 64 35.1 0z"]
};
const faPeople = {
  prefix: 'fass',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L82 142.8 .2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L238 142.8 228.6 128l-17.5 0-102.2 0zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0-9.4 14.8-81.7 128 53.9 34.4 42-65.8L368 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0L543.8 239.4l42 65.8 53.9-34.4L558 142.8 548.6 128l-17.5 0-102.2 0z"]
};
const faFolderTree = {
  prefix: 'fass',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M64 32L64 0 0 0 0 32l0 96L0 416l0 32 32 0 224 0 0-64L64 384l0-224 192 0 0-64L64 96l0-64zM288 224l288 0 0-192L432 32 400 0 288 0l0 224zm0 288l288 0 0-192-144 0-32-32-112 0 0 224z"]
};
const faNetworkWired = {
  prefix: 'fass',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M384 64l0 64-32 0-64 0-32 0 0-64 128 0zM352 192l32 0 64 0 0-64 0-64 0-64L384 0 256 0 192 0l0 64 0 64 0 64 64 0 32 0 0 32-96 0-64 0-96 0L0 224l0 64 32 0 96 0 0 32-32 0-64 0 0 64 0 64 0 64 64 0 128 0 64 0 0-64 0-64 0-64-64 0-32 0 0-32 96 0 64 0 96 0 0 32-32 0-64 0 0 64 0 64 0 64 64 0 128 0 64 0 0-64 0-64 0-64-64 0-32 0 0-32 96 0 32 0 0-64-32 0-96 0-64 0-96 0 0-32zM512 384l32 0 0 64-128 0 0-64 32 0 64 0zm-320 0l32 0 0 64L96 448l0-64 32 0 64 0z"]
};
const faCroissant = {
  prefix: 'fass',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M6.3 227.9l231.9 98.9L60.7 464.8C22.6 416 0 354.7 0 288c0-20.6 2.2-40.7 6.3-60.1zm320.4 10.3L227.9 6.3C247.3 2.2 267.4 0 288 0c66.7 0 128 22.6 176.8 60.7L326.7 238.2zM468.6 108C487 130 501.8 155.3 512 182.7L480 224l-90-15 78.6-101zM209 390l15 90-41.3 32c-27.4-10.2-52.7-25-74.7-43.4L209 390zM0 190.4C30.2 100.9 100.9 30.3 190.4 0L306.4 272 272 306.4 0 190.4z"]
};
const faMapPin = {
  prefix: 'fass',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80l0-32c-53 0-96 43-96 96l32 0c0-35.3 28.7-64 64-64zM128 480l0-162.9c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9L192 480l0 32-64 0 0-32z"]
};
const faHamsa = {
  prefix: 'fass',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M0 288l96 0L96 32l80 0 0 192 40 0L216 0l80 0 0 224 40 0 0-192 80 0 0 256 96 0 0 48L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L0 336l0-48zm256 0c-48 0-96 64-96 64s48 64 96 64s96-64 96-64s-48-64-96-64zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCentSign = {
  prefix: 'fass',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M256 0l0 32 0 34.7c49.6 8.3 92.7 35.6 121.6 74.1l-51.2 38.4C303 148.1 265.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79-20.1 102.4-51.2l51.2 38.4c-28.9 38.5-72 65.8-121.6 74.1l0 34.7 0 32-64 0 0-32 0-34.7C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3L192 32l0-32 64 0z"]
};
const faSwordsLaser = {
  prefix: 'fass',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M352 279.6l0-105.9L160 0 128 32 352 279.6zM621.7 450.3L640 432l-98.3-98.3L523.3 352l98.3 98.3zm-11.3 11.3L512 363.3 491.3 384l98.3 98.3 20.7-20.7zm-32 32L480 395.3l-18.3 18.3L560 512l18.3-18.3zm-128-91.3l24-24 32-32 24-24L384 176l0 160 66.3 66.3zM247 210.8l-27.4 24.8L208 224l-33.4 33.4-8.2-8.2c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l8 8L0 432l80 80L224 368l0-17.7 74.9-82.8L247 210.8zm143.5-44.5L512 32 480 0 343.6 123.4l46.9 42.9zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faFlask = {
  prefix: 'fass',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M288 0L160 0 128 0 96 0l0 64 32 0 0 150.9L4.7 415.2 0 422.9 0 432l0 48 0 32 32 0 384 0 32 0 0-32 0-48 0-9.1-4.7-7.7L320 214.9 320 64l32 0 0-64L320 0 288 0zM192 224l0-160 64 0 0 160 0 9.1 4.7 7.7L309.5 320l-171 0 48.8-79.2 4.7-7.7 0-9.1z"]
};
const faPersonPregnant = {
  prefix: 'fass',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 384l-24 0 0-87.1-4.6 7.6L74.9 331.9l-54.9-33 16.5-27.4 76.9-128 9.3-15.5 18.1 0 35.1 0 16 0 32 0 32 0 18.3 97.7c44.3 8.6 77.7 47.5 77.7 94.3l0 64-48 0-40 0 0 96 0 32-64 0 0-32 0-96-8 0-8 0 0 96 0 32-64 0 0-32 0-96z"]
};
const faSquareU = {
  prefix: 'fass',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M448 32L0 32 0 480l448 0 0-448zM160 168l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 53.6-37.7 98.4-88 109.4l0 2.6-24 0c-61.9 0-112-50.1-112-112l0-120 0-24 48 0 0 24z"]
};
const faWandSparkles = {
  prefix: 'fass',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M0 432l80 80L368 192l48 0 0-53.3L512 32 480 0 195.6 256 128 256l0 60.8L0 432zm432 16l24-56 56-24-56-24-24-56-24 56-56 24 56 24 24 56zM56 168l24 56 24-56 56-24-56-24L80 64 56 120 0 144l56 24zM208 96l16-32 32-16L224 32 208 0 192 32 160 48l32 16 16 32z"]
};
const faRouter = {
  prefix: 'fass',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M352 48c58.8 0 112.5 21.8 153.4 57.9l31.7-36C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9l31.7 36C239.5 69.8 293.2 48 352 48zm24 200l0-24-48 0 0 24 0 72L0 320 0 512l576 0 0-192-200 0 0-72zM128 384l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM276.5 186.7C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7l30.2-37.3C428.8 126 392 112 352 112s-76.8 14-105.7 37.4l30.2 37.3z"]
};
const faEllipsisVertical = {
  prefix: 'fass',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M16 48l96 0 0 96-96 0 0-96zm0 160l96 0 0 96-96 0 0-96zm96 160l0 96-96 0 0-96 96 0z"]
};
const faEllipsisV = faEllipsisVertical;
const faSwordLaserAlt = {
  prefix: 'fass',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M480 0L232.4 224l105.9 0L512 32 480 0zM80 512l98.3-98.3L160 395.3 61.7 493.7 80 512zm68.7-128L128 363.3 29.7 461.7l20.7 20.7L148.7 384zM0 432l18.3 18.3L116.7 352 98.3 333.7 0 432zm133.7-85.7l32 32 24 24L336 256l-160 0-66.3 66.3 24 24z"]
};
const faTicket = {
  prefix: 'fass',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M576 64L0 64 0 208c26.5 0 48 21.5 48 48s-21.5 48-48 48L0 448l576 0 0-144c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-144zM128 160l0 192 320 0 0-192-320 0zM96 128l32 0 320 0 32 0 0 32 0 192 0 32-32 0-320 0-32 0 0-32 0-192 0-32z"]
};
const faPowerOff = {
  prefix: 'fass',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M288 32l0-32L224 0l0 32 0 224 0 32 64 0 0-32 0-224zM80 256c0-54.4 24.7-103.1 63.5-135.4L102.6 71.4C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6l-40.9 49.2c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176z"]
};
const faCoin = {
  prefix: 'fass',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144zM86.6 248.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2zM96 200c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64zM0 290.1c13.2 15.6 29.7 29.3 48 40.9l0 63.7C17.8 373.6 0 347.9 0 320l0-29.9zM80 413l0-64.7c28.4 13.2 60.9 23 96 29l0 64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1l0-64.3c35.1-6 67.6-15.9 96-29l0 64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9c0 27.9-17.8 53.6-48 74.6z"]
};
const faLaptopSlash = {
  prefix: 'fass',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-4.6-3.6L640 432l0-48-116.1 0L153 96l359 0 0 256 64 0 0-288 0-32-32 0L96 32 70.5 32 48.4 14.8zM128 352l0-155L64 146.6 64 352l64 0zM487.2 480L365.3 384 0 384l0 48 48 48 439.2 0z"]
};
const faRightLong = {
  prefix: 'fass',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M512 256L352 416l-32 0 0-96L0 320 0 192l320 0 0-96 32 0L512 256z"]
};
const faLongArrowAltRight = faRightLong;
const faCircleB = {
  prefix: 'fass',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128l24 0 92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76l-108 0-24 0 0-24 0-80 0-24 0-24 0-80 0-24zm144 76c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM208 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z"]
};
const faPersonDressSimple = {
  prefix: 'fass',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm128 96l64 224-64 0 0 128L64 512l0-128L0 384 64 160l128 0z"]
};
const faPipeCollar = {
  prefix: 'fass',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M512 256c0 46.4-12.3 89.8-33.9 127.4l33.2 32.1L512 512l-96.6-.7-32.1-33.2C345.8 499.7 302.4 512 256 512c-46.5 0-90.2-12.4-127.8-34.1L95.9 511.3 0 511.3l0-95.9 33.6-32.5C12.2 345.5 0 302.2 0 256c0-46.4 12.3-89.9 33.9-127.4L0 95.9 0 0 95.9 0l32.8 33.9C166.1 12.3 209.6 0 256 0c46.2 0 89.5 12.2 126.9 33.6L415.4 0l95.9 0 0 95.9-33.4 32.3C499.6 165.8 512 209.5 512 256zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faLightsHoliday = {
  prefix: 'fass',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M16 64C.1 91.8 .1 91.8 .1 91.8s0 0 0 0c0 0 0 0 .1 0l.1 .1 .4 .2c.3 .2 .8 .4 1.3 .7c1.1 .6 2.6 1.4 4.6 2.4c3.9 2 9.5 4.7 16.8 8c14.6 6.5 35.8 14.9 63.1 23.3C141.2 143.4 220.4 160 320 160c40.5 0 77.6-2.7 111-7.1c2.6-.3 5.1-.7 7.6-1c20.2-2.8 39.1-6.3 56.5-10.1c21.8-4.7 41.2-9.9 58.3-15.2c27.3-8.4 48.5-16.9 63.1-23.3c7.3-3.2 12.9-6 16.8-8c2-1 3.5-1.8 4.6-2.4c.5-.3 1-.5 1.3-.7l.4-.2 .1-.1c0 0 0 0 .1 0c0 0 0 0 0 0L624 64c-15.9-27.8-15.9-27.8-15.9-27.8c0 0 0 0 0 0l-.6 .4c-.6 .3-1.7 .9-3.2 1.7c-3 1.5-7.6 3.8-13.8 6.5c-12.4 5.5-31.2 13.1-55.9 20.7C485.2 80.6 412.4 96 320 96s-165.2-15.4-214.6-30.6C80.7 57.8 61.9 50.3 49.5 44.8c-6.2-2.8-10.8-5-13.8-6.5c-1.5-.8-2.5-1.3-3.2-1.7l-.6-.4c0 0-.1 0-.1 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0L16 64zm98.8 160.5c-30.8 1.9-59 21.7-70.2 52.5C22.7 337.1 76 424.6 76 424.6s97.1-32.8 119-92.9c11.2-30.8 2.3-64.1-20-85.3l22.8-62.7c-23-3.2-44.4-7.2-63.9-11.5l-19 52.3zM320 192c-10.9 0-21.6-.2-32-.6l0 71.2c-28.3 12.3-48 40.5-48 73.3c0 64 80 128 80 128s80-64 80-128c0-32.8-19.7-61-48-73.3l0-71.2c-10.4 .4-21.1 .6-32 .6zm186.1-19.9c-19.6 4.4-40.9 8.3-63.9 11.5l22.8 62.7c-22.3 21.3-31.2 54.5-20 85.3c21.9 60.1 119 92.9 119 92.9s53.3-87.5 31.4-147.6c-11.2-30.8-39.4-50.6-70.2-52.5l-19-52.3z"]
};
const faCitrus = {
  prefix: 'fass',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M288 112l0 16 16 0 80 0c53 0 96-43 96-96l0-16 0-16L464 0 384 0c-53 0-96 43-96 96l0 16zM256 96c0-23.1 6.1-44.7 16.8-63.4c-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160l-80 0-16 0-32 0 0-32 0-16 0-16z"]
};
const faFlagUsa = {
  prefix: 'fass',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M64 0l0 32 0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0L448 16l0 86.2-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3l0 55.7-55.5 20.8c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400l0 80 0 32L0 512l0-32 0-64 0-70.5 0-32.7 0-63.3 0-32.7 0-63.3 0-32.7L0 64 0 32 0 0 64 0zm48 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faLaptopFile = {
  prefix: 'fass',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M96 0L64 0l0 32 0 256L0 288l0 48 48 48 272 0 0-96-192 0 0-224 320 0 0 32 64 0 0-64 0-32L480 0 96 0zM512 128l-160 0 0 384 288 0 0-256-128 0 0-128zm32 96l96 0-96-96 0 96z"]
};
const faTty = {
  prefix: 'fass',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M51.2 264L0 174C29.9 132 122.9 48 256 48s226.1 84 256 126l-51.2 90-128-42 0-78c-49.6-18.1-104-18.1-153.6 0l0 78-128 42zM32 320l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zm-352 0l256 0 0 64-256 0 0-64z"]
};
const faTeletype = faTty;
const faChartTreeMap = {
  prefix: 'fass',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M0 32l224 0 0 208L0 240 0 32zM0 272l224 0 0 208L0 480 0 272zM512 32l0 128-256 0 0-128 256 0zM256 192l256 0 0 128-256 0 0-128zM512 352l0 128-256 0 0-128 256 0z"]
};
const faDiagramNext = {
  prefix: 'fass',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M512 32l0 192-232 0 0 64 40 0 32 0 0 32-32 32-64 64-64-64-32-32 0-32 32 0 40 0 0-64L0 224 0 32l512 0zM64 288l64 0 0 32 0 13.3 9.4 9.4 9.4 9.4L64 352l0 64 146.7 0 22.6 22.6L256 461.3l22.6-22.6L301.3 416 448 416l0-64-82.7 0 9.4-9.4 9.4-9.4 0-13.3 0-32 64 0 64 0 0 64 0 64 0 64-64 0L64 480 0 480l0-64 0-64 0-64 64 0z"]
};
const faPersonRifle = {
  prefix: 'fass',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M320 192l16 0 0 320-192 0 0-174.3L90.4 428.3 70.1 462.8 1.2 422.1l20.3-34.4 104-176L137.2 192l22.8 0 160 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM464 0l0 128 16 0 0 141.3 16-5.3 0-72 48 0 0 112-64 21.3 0 26.7 64 0 0 48-60 0 28 112-96 0 0-112-48 0 0-208 32 0 0-64 16 0 0-96-16 0 0-32 16 0 32 0 16 0z"]
};
const faClockFiveThirty = {
  prefix: 'fass',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-56.7 20 30 13.3 20 39.9-26.6-13.3-20-64-96L232 256l0 136 0 24 48 0 0-24z"]
};
const faPipeValve = {
  prefix: 'fass',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 12.8L96 64l0 64 160-16 160 16 0-64L288 76.8 288 64zm0 84.2l-32-4-32 4 0 43.8L96 192l0 256 320 0 0-256-128 0 0-43.8zM64 160L0 160l0 32L0 448l0 32 64 0 0-32 0-256 0-32zm448 32l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256z"]
};
const faLightbulbMessage = {
  prefix: 'fass',
  iconName: 'lightbulb-message',
  icon: [576, 512, [], "e687", "M256 224l0 160-144 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 16.6-2.3 32.7-6.6 48L256 224zM112 416l144 0 0 96-144 0 0-96zm0-240c0-44.2 35.8-80 80-80l0-32C130.1 64 80 114.1 80 176l32 0zm464 80l0 192-96 0 0 64-74.7-64L288 448l0-192 288 0z"]
};
const faArrowUpFromArc = {
  prefix: 'fass',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 448C150 448 64 362 64 256l0-32L0 224l0 32C0 397.4 114.6 512 256 512s256-114.6 256-256l0-32-64 0 0 32c0 106-86 192-192 192zM121.4 137.4L98.7 160 144 205.3l22.6-22.6L224 125.3 224 320l0 32 64 0 0-32 0-194.7 57.4 57.4L368 205.3 413.3 160l-22.6-22.6-112-112L256 2.7 233.4 25.4l-112 112z"]
};
const faFaceSpiralEyes = {
  prefix: 'fass',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm39.1-98.7L256 387.2l-39.1 26.1-8.9 5.9-8.9-5.9-40.3-26.8-23.7 11.8-14.3 7.2-14.3-28.6 14.3-7.2 32-16 8.3-4.2 7.7 5.2L208 380.8l39.1-26.1 8.9-5.9 8.9 5.9L304 380.8l39.1-26.1 7.7-5.2 8.3 4.2 32 16 14.3 7.2-14.3 28.6-14.3-7.2-23.7-11.8-40.3 26.8-8.9 5.9-8.9-5.9zM154.4 124c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5l1 24zm281.3 83.7l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5l-1-24c46.9-1.9 82.2-45 78.1-84.3z"]
};
const faCompressWide = {
  prefix: 'fass',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 96l0-32L96 64l0 32 0 64-64 0L0 160l0 64 32 0 96 0 32 0 0-32 0-96zM32 288L0 288l0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0zM416 96l0-32-64 0 0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64zM384 288l-32 0 0 32 0 96 0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0-96 0z"]
};
const faCirclePhoneHangup = {
  prefix: 'fass',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM378.7 320L304 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L133.3 320 96 262.8l10.7-10.4c82.5-80.5 216.2-80.5 298.7 0L416 262.8 378.7 320z"]
};
const faPhoneCircleDown = faCirclePhoneHangup;
const faGearComplexCode = {
  prefix: 'fass',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M302.7 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.6 41 39.7 108.9l35 45c-8.3 14.7-14.8 30.4-19.4 47L-1.3 208 0 304l55.3 7c4.5 16.6 11.1 32.4 19.4 47.1l-35 45L107.6 471l44.6-34.7c14.8 8.5 30.7 15.3 47.5 20l7 55.7 96 0 6.9-55c17.2-4.6 33.6-11.3 48.7-19.9L401.8 471l67.9-67.9L436.2 360c8.9-15.3 15.8-31.8 20.6-49.3l54-6.7 0-96-54-6.7c-4.7-17.4-11.7-34-20.6-49.3l33.5-43.1L401.8 41 358.3 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L302.7 0zM287.8 162.6l-32 192-2.6 15.8-31.6-5.3 2.6-15.8 32-192 2.6-15.8 31.6 5.3-2.6 15.8zM187.3 227.3L158.6 256l28.7 28.7L198.6 296 176 318.6l-11.3-11.3-40-40L113.4 256l11.3-11.3 40-40L176 193.4 198.6 216l-11.3 11.3zm160-22.6l40 40L398.6 256l-11.3 11.3-40 40L336 318.6 313.4 296l11.3-11.3L353.4 256l-28.7-28.7L313.4 216 336 193.4l11.3 11.3z"]
};
const faHouseMedicalCircleExclamation = {
  prefix: 'fass',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M320 368.7c.2 59.2 29.7 111.6 74.8 143.3L64.1 512l0-224.4L0 287.6 0 240 288.4 0 520.5 193.7c-8-1.1-16.2-1.7-24.5-1.7c-54.7 0-103.5 24.9-135.8 64L320 256l0-64-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-15.3zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faBadminton = {
  prefix: 'fass',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M240.2 112.2C272.6 79.8 312.9 64 349 64c28.2 0 53.2 9.6 71.3 27.7S448 134.9 448 163c0 36-15.8 76.4-48.2 108.8c-59.4 59.4-139.7 60.9-180.1 20.5C201.6 274.1 192 249.1 192 221c0-36 15.8-76.4 48.2-108.8zM349 0c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 32.4 8.4 64.2 26.2 91.6l-48.8 48.8L96 352 0 448l64 64 96-96-9.4-9.4 48.8-48.8c73.3 48.1 177.5 27.4 245.7-40.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM509.8 352c-26.4 0-47.8 21.5-47.8 48l0 32 95.6 0 0-32c0-26.5-21.4-48-47.8-48zm-46.8 96l-11.2 39-4.4 15.4 30.8 8.8 4.4-15.4 13.2-46 0 46.2 0 16 32 0 0-16 0-46.2 13.2 46 4.4 15.4 30.8-8.8L571.7 487l-11.2-39-97.6 0z"]
};
const faClosedCaptioning = {
  prefix: 'fass',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M0 32l576 0 0 448L0 480 0 32zM200 208c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C232 295.1 217 304 200 304c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-47-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C424 295.1 409 304 392 304c-26.5 0-48-21.5-48-48z"]
};
const faPersonHiking = {
  prefix: 'fass',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-23.5 69.1l31.3 7.8 48 12 12 3 6.9 10.3L305.1 208l30.9 0 0-24 0-24 48 0 0 24 0 24s0 0 0 0l0 64s0 0 0 0l0 216 0 24-48 0 0-24 0-216-48 0-17.1 0-9.5-14.2-18.1-27.1L224.2 307l54.4 54.4 9.4 9.4 0 13.3 0 96 0 32-64 0 0-32 0-82.7-69.7-69.7-1.1-.3 .2-.7-3.3-3.3c-15.8-15.8-22.2-38.6-16.9-60.3l27.8-114.5 7.6-31.3zM117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L136.7 512l-66.2 0 46.8-178zM144 96L96 288 0 272 48 96l96 0z"]
};
const faHiking = faPersonHiking;
const faRightFromLine = {
  prefix: 'fass',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M288 96L448 256 288 416l-32 0 0-96L96 320l0-128 160 0 0-96 32 0zM64 96l0 320 0 32L0 448l0-32L0 96 0 64l64 0 0 32z"]
};
const faArrowAltFromLeft = faRightFromLine;
const faVenusDouble = {
  prefix: 'fass',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32-32 0-32 0 0-64 32 0 32 0 0-34.9C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32-32 0-32 0 0-64 32 0 32 0 0-34.9c-26.6-4.9-51.1-15.7-72-31.1z"]
};
const faImages = {
  prefix: 'fass',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M576 32L96 32l0 352 480 0 0-352zM395.6 139.8l96 136L496 282l0 7.6 0 8 0 24-24 0-120 0-24 0-48 0-24 0-56 0-24 0 0-24 0-8 0-9.1 6.1-6.8 64-72L264 181.5l17.9 20.2L299.1 221l57.3-81.2L376 112l19.6 27.8zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faCalculator = {
  prefix: 'fass',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M384 0L0 0 0 512l384 0L384 0zM320 64l0 96L64 160l0-96 256 0zM64 192l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zM64 384l160 0 0 64L64 448l0-64zM224 192l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z"]
};
const faShuttlecock = {
  prefix: 'fass',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M320 0l0 48-16 0-41 0L250.6 87.1l-31.3 99.2L176 208l-40 80 27 27 71.9-71.9L281.1 96.8 286.4 80 304 80l104 0 24 0 0 24 0 104 0 17.6-16.8 5.3L268.8 277.1 197 349l27 27 80-40 21.6-43.3 99.2-31.3L464 249l0-41 0-16 48 0 0 96L240 416l-36.7 36.7-144-144L96 272 224 0l96 0zM36.7 331.3l144 144-6.9 6.9c-19.1 19.1-45 29.8-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72l6.9-6.9z"]
};
const faUserHair = {
  prefix: 'fass',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zM448 512L384 320 64 320 0 512l448 0z"]
};
const faEyeEvil = {
  prefix: 'fass',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M258.1 111.4L320 0l61.9 111.4c11 2.7 21.7 6.2 31.8 10.3L550 82.7l-59 94.5c7.1 8.9 13 18.4 17.7 28.3L640 256 508.7 306.5c-4.6 10-10.6 19.4-17.7 28.3l59 94.5-136.3-39c-10.1 4.1-20.7 7.5-31.8 10.3L320 512 258.1 400.6c-11-2.7-21.7-6.2-31.8-10.2L90 429.3l59-94.5c-7.1-8.9-13-18.4-17.7-28.3L0 256l131.3-50.5c4.6-10 10.6-19.4 17.7-28.3L90 82.7l136.3 39c10.1-4.1 20.7-7.5 31.8-10.3zM320 352c53 0 96-43 96-96c0-19.7-6-38.1-16.2-53.3c-16.9 9.7-35.7 16.5-55.8 19.5c4.6 9.3 7.9 20.7 7.9 33.8c0 40.4-32 64-32 64s-32-23.6-32-64c0-13.1 3.4-24.5 7.9-33.8c-20.1-3-38.9-9.8-55.8-19.5C230 217.9 224 236.3 224 256c0 53 43 96 96 96z"]
};
const faPeoplePulling = {
  prefix: 'fass',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zm10.8 304l29.8 134.1 3.9 23.2 .5 2.7 64.9 0-2.2-13.3-4-24c-.1-.6-.2-1.1-.3-1.7L174.3 216.8l115.6 56.7 33.8 16.6 10.9-36 11.8-38.8L369 205.2l13.6-6-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-6.8 3-29.2 13-36 16-12.9 5.7-.5 .2-4.1 13.6-5.7 17-138.7-68-6.7-3.3-7.4 0L32 128 0 128l0 32L0 320l0 32 58.2 0L84.4 509.3l.5 2.7 64.9 0-2.2-13.3L123.1 352l15.7 0zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-43.4 43.4L258.7 464 304 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"]
};
const faN = {
  prefix: 'fass',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M0 32l47 0 9.6 11.5L320 359.6 320 64l0-32 64 0 0 32 0 384 0 32-47 0-9.6-11.5L64 152.4 64 448l0 32L0 480l0-32L0 64 0 32z"]
};
const faSwap = {
  prefix: 'fass',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M16 120L128 0 240 120l0 40-80 0 0 256 128 0 0-352 0-32 32 0 192 0 32 0 0 32 0 288 80 0 0 40L512 512 400 392l0-40 80 0 0-256L352 96l0 352 0 32-32 0-192 0-32 0 0-32 0-288-80 0 0-40z"]
};
const faGarage = {
  prefix: 'fass',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M0 128L0 512l96 0 0-320 448 0 0 320 96 0 0-384L320 0 0 128zm512 96l-384 0 0 96 384 0 0-96zM128 512l384 0 0-160-384 0 0 160zm128-96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z"]
};
const faCableCar = {
  prefix: 'fass',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm261 47.5l23.5-5L498.4 51.5l-23.5 5-224 48-224 48-23.5 5 10.1 46.9 23.5-5 195-41.8 0 66.3L32 224l0 288 448 0 0-288-200 0 0-76.6 205-43.9zM80 288l96 0 0 96-96 0 0-96zm224 0l0 96-96 0 0-96 96 0zm32 0l96 0 0 96-96 0 0-96z"]
};
const faTram = faCableCar;
const faShovelSnow = {
  prefix: 'fass',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M400 0L366.1 33.9l-6.9 6.9c-14.9 14.9-23.2 35-23.2 56c0 13.1 3.2 25.5 8.8 36.4L255 223l-63-63L0 304 208 512 352 320l-63-63 89.8-89.8c10.9 5.7 23.3 8.8 36.4 8.8c21 0 41.1-8.3 56-23.2l6.9-6.9L512 112 478.1 78.1 433.9 33.9 400 0zm0 67.9L444.1 112l-6.9 6.9c-5.8 5.9-13.8 9.1-22.1 9.1C398 128 384 114 384 96.8c0-8.3 3.3-16.2 9.1-22.1l6.9-6.9zM203.3 267.3l-72 72L120 350.6 97.4 328l11.3-11.3 72-72L192 233.4 214.6 256l-11.3 11.3zm64 64l-72 72L184 414.6 161.4 392l11.3-11.3 72-72L256 297.4 278.6 320l-11.3 11.3z"]
};
const faCloudRain = {
  prefix: 'fass',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm0 48l40.9 68.1c4.7 7.8 7.1 16.7 7.1 25.8l0 2.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-2.1c0-9.1 2.5-18 7.1-25.8L96 368zm160 0l40.9 68.1c4.7 7.8 7.1 16.7 7.1 25.8l0 2.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-2.1c0-9.1 2.5-18 7.1-25.8L256 368zm119.1 68.1L416 368l40.9 68.1c4.7 7.8 7.1 16.7 7.1 25.8l0 2.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-2.1c0-9.1 2.5-18 7.1-25.8z"]
};
const faFaceLying = {
  prefix: 'fass',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M494 350.5c-4.5 1-9.2 1.5-14 1.5l-128 0-16 0 0-32 16 0 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0-16 0 0-32 16 0 192 0c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM188.8 393.6l-9.6 12.8-25.6-19.2 9.6-12.8C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8l14.7 6.4-12.8 29.3-14.7-6.4c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6z"]
};
const faSprinkler = {
  prefix: 'fass',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M24 0a24 24 0 1 1 0 48A24 24 0 1 1 24 0zM0 128a24 24 0 1 1 48 0A24 24 0 1 1 0 128zM0 232a24 24 0 1 1 48 0A24 24 0 1 1 0 232zM64 72a24 24 0 1 1 48 0A24 24 0 1 1 64 72zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM448 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM288 64l0 32 0 160 128 0 0 40-96 88 0 128-128 0 0-128L96 296l0-40 128 0 0-160 0-32 64 0z"]
};
const faBuildingCircleXmark = {
  prefix: 'fass',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0 0-8.2c-39.1-32.3-64-81.1-64-135.8s24.9-103.5 64-135.8L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z"]
};
const faPersonSledding = {
  prefix: 'fass',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M352 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM13.8 215.6l21.3 11.1L172.4 298c-12.8-20.3-10.5-49.8 13.8-66L246.3 192 160 192l-32 0 0-64 32 0 160 0 13.3 0 9.4 9.4 12.8 12.8 3.2 3.2L381.3 176l-22.6 22.6L301.3 256l50.7 0 32 0 0 32 0 96 0 23.9 56.2 29.2 37.1-18.5 21.5-10.7 21.5 42.9-21.5 10.7-48 24-10.9 5.5-10.9-5.6-416-216L-8.4 258.2l22.1-42.6zM320 374.6l0-54.6-105.3 0L320 374.6z"]
};
const faSledding = faPersonSledding;
const faGameConsoleHandheld = {
  prefix: 'fass',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M0 0L384 0l0 512L0 512 0 0zM96 64l0 160 192 0 0-160L96 64zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 288l0 32-32 0 0 32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-32-32 0z"]
};
const faShip = {
  prefix: 'fass',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M192 0L384 0l0 64 64 0 32 0 0 32 0 144 96 32L441.4 395.3c-5.5 3.6-10.9 6.6-16.7 9.3C411.6 410.7 397 415 384 415s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0s0 0 0 0L288 368l-18.6 13.4-1.1 .8s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 410.7 205 415 192 415s-27.6-4.3-40.7-10.3c-5.9-2.7-11.2-5.7-16.7-9.3L0 272l96-32L96 96l0-32 32 0 64 0 0-64zM160 218.7L288 176l128 42.7 0-90.7-256 0 0 90.7zM272.4 493.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faClockSixThirty = {
  prefix: 'fass',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136 0-24-48 0 0 24 0 136 0 24 48 0 0-24z"]
};
const faBatterySlash = {
  prefix: 'fass',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416l10.8 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L153 96 48.4 14.8zM235.4 160L512 160l0 192-29.3 0L235.4 160zM406.2 416l-81.2-64L96 352l0-180.4L32 121.2 32 160l0 192 0 64 64 0 310.2 0z"]
};
const faTugrikSign = {
  prefix: 'fass',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M32 32L0 32 0 96l32 0 128 0 0 103L56.2 225l-31 7.8 15.5 62.1 31-7.8L160 265l0 30L56.2 321l-31 7.8 15.5 62.1 31-7.8L160 361l0 87 0 32 64 0 0-32 0-103L327.8 319l31-7.8-15.5-62.1-31 7.8L224 279l0-30L327.8 223l31-7.8-15.5-62.1-31 7.8L224 183l0-87 128 0 32 0 0-64-32 0L192 32 32 32z"]
};
const faArrowsDownToLine = {
  prefix: 'fass',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M544 416L32 416 0 416l0 64 32 0 512 0 32 0 0-64-32 0zM528 226.7l-22.6 22.6L480 274.7 480 64l0-32-64 0 0 32 0 210.7-25.4-25.4L368 226.7 322.7 272l22.6 22.6 80 80L448 397.3l22.6-22.6 80-80L573.3 272 528 226.7zm-320 0l-22.6 22.6L160 274.7 160 64l0-32L96 32l0 32 0 210.7L70.6 249.4 48 226.7 2.7 272l22.6 22.6 80 80L128 397.3l22.6-22.6 80-80L253.3 272 208 226.7z"]
};
const faDownload = {
  prefix: 'fass',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M288 32l0-32L224 0l0 32 0 242.7-73.4-73.4L128 178.7 82.7 224l22.6 22.6 128 128L256 397.3l22.6-22.6 128-128L429.3 224 384 178.7l-22.6 22.6L288 274.7 288 32zM0 512l512 0 0-160-165.5 0-45.3 45.3L256 442.5l-45.3-45.3L165.5 352 0 352 0 512zM432 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faAnglesUpDown = {
  prefix: 'fass',
  iconName: 'angles-up-down',
  icon: [448, 512, [], "e60d", "M243.2 14.4L224 0 204.8 14.4l-160 120L19.2 153.6l38.4 51.2 25.6-19.2L224 80 364.8 185.6l25.6 19.2 38.4-51.2-25.6-19.2-160-120zm0 483.2l160-120 25.6-19.2-38.4-51.2-25.6 19.2L224 432 83.2 326.4 57.6 307.2 19.2 358.4l25.6 19.2 160 120L224 512l19.2-14.4z"]
};
const faShelves = {
  prefix: 'fass',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M64 0l0 32 0 128 512 0 0-128 0-32 64 0 0 32 0 128 0 32 0 32 0 192 0 32 0 32 0 32-64 0 0-32L64 480l0 32L0 512l0-32 0-32 0-32L0 224l0-32 0-32L0 32 0 0 64 0zm0 416l512 0 0-192L64 224l0 192zM352 0L480 0l0 128-128 0L352 0zM224 256l0 128L96 384l0-128 128 0zm160 0l0 128-128 0 0-128 128 0z"]
};
const faInventory = faShelves;
const faCloudSnow = {
  prefix: 'fass',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm-8 32l0 24 0 16 16 0 24 0 0 48-24 0-16 0 0 16 0 24-48 0 0-24 0-16-16 0L0 440l0-48 24 0 16 0 0-16 0-24 48 0zm192 32l0 24 0 16 16 0 24 0 0 48-24 0-16 0 0 16 0 24-48 0 0-24 0-16-16 0-24 0 0-48 24 0 16 0 0-16 0-24 48 0zm192-8l0 16 16 0 24 0 0 48-24 0-16 0 0 16 0 24-48 0 0-24 0-16-16 0-24 0 0-48 24 0 16 0 0-16 0-24 48 0 0 24z"]
};
const faFaceGrin = {
  prefix: 'fass',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGrin = faFaceGrin;
const faDeleteLeft = {
  prefix: 'fass',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M576 64l0 384-400 0L0 256 176 64l400 0zM254.1 192l17 17 47 47-47 47-17 17L288 353.9l17-17 47-47 47 47 17 17L449.9 320l-17-17-47-47 47-47 17-17L416 158.1l-17 17-47 47-47-47-17-17L254.1 192z"]
};
const faBackspace = faDeleteLeft;
const faOven = {
  prefix: 'fass',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M0 0L0 160l448 0L448 0 0 0zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200l0 192L64 448l0-192 320 0zM64 192L0 192l0 64L0 448l0 64 64 0 320 0 64 0 0-64 0-192 0-64-64 0L64 192zm272 96l-224 0-16 0 0 32 16 0 224 0 16 0 0-32-16 0z"]
};
const faCloudBinary = {
  prefix: 'fass',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336L0 480zM288 160l16 0 16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32zm-112 0l64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16 16 0zm16 80l32 0 0-48-32 0 0 48zm192-80l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16zm32 32l0 48 32 0 0-48-32 0zM192 304l16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32 16 0zm80 0l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16zm32 32l0 48 32 0 0-48-32 0zm112-32l16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32 16 0z"]
};
const faEyeDropper = {
  prefix: 'fass',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M341.6 29.2L240.1 130.8l-9.4-9.4L208 98.7 162.7 144l22.6 22.6 160 160L368 349.3 413.3 304l-22.6-22.6-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM32 344l0 88-9.9 12.3L4 467l-4 5 40 40 5-4 22.7-18.1L80 480l88 0L310.7 337.3 265.5 292l-124 124L96 416l0-45.5 124-124-45.3-45.3L32 344z"]
};
const faEyeDropperEmpty = faEyeDropper;
const faEyedropper = faEyeDropper;
const faCommentCaptions = {
  prefix: 'fass',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM120 208l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0zm224 0l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zM120 288l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zm128 0l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faCommentsQuestion = {
  prefix: 'fass',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352zm23.5 31C255.8 457.4 336.4 512 432 512c36.2 0 70.3-7.8 99.9-21.6L640 512l-37.6-75.1C626.1 408.3 640 373.5 640 336c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5c0 112.3-99.1 196.9-216.5 207zM134.7 124c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 250.7l40 0 0 40-40 0 0-40z"]
};
const faScribble = {
  prefix: 'fass',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M170 23.3C186.5 8.3 208 0 230.3 0l1.1 0C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.9 8.9-13.8 20.9-13.8 33.4c0 26.1 21.1 47.2 47.2 47.2l4.4 0c4.8 0 9.5-.8 14.1-2.3l12.2-4.1 30.4-10.1 20.2 60.7-30.4 10.1-12.2 4.1c-11.1 3.7-22.6 5.6-34.3 5.6l-4.4 0C369.8 512 320 462.2 320 400.8c0-29.5 11.7-57.8 32.6-78.6l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64l-1.1 0c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7 10.5 168.3 170 23.3z"]
};
const faRotateExclamation = {
  prefix: 'fass',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0l40 40L352 240l160 0 0-160-57.6 57.6-40-40c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4l60.4 21.3zm37.8 166.5l-40-40L160 272 0 272 0 432l57.6-57.6 40 40c87.5 87.5 229.3 87.5 316.8 0c24.4-24.4 42.1-53.1 52.9-83.7l-60.4-21.3c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0zM280 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 320l0 48 48 0 0-48-48 0z"]
};
const faFileCircleCheck = {
  prefix: 'fass',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z"]
};
const faGlass = {
  prefix: 'fass',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M74.2 128l-5-64 245.6 0-5 64L74.2 128zM40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0 5 64 40 512z"]
};
const faLoader = {
  prefix: 'fass',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M288 32l0-32L224 0l0 32 0 64 0 32 64 0 0-32 0-64zm0 384l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zM0 224l0 64 32 0 64 0 32 0 0-64-32 0-64 0L0 224zm416 0l-32 0 0 64 32 0 64 0 32 0 0-64-32 0-64 0zM97.6 52.4L52.4 97.6 75 120.2l45.3 45.3 22.6 22.6 45.3-45.3-22.6-22.6L120.2 75 97.6 52.4zM391.8 346.5l-22.6-22.6-45.3 45.3 22.6 22.6L391.8 437l22.6 22.6 45.3-45.3L437 391.8l-45.3-45.3zM52.4 414.4l45.3 45.3L120.2 437l45.3-45.3 22.6-22.6-45.3-45.3-22.6 22.6L75 391.8 52.4 414.4zM346.5 120.2l-22.6 22.6 45.3 45.3 22.6-22.6L437 120.2l22.6-22.6L414.4 52.3 391.8 75l-45.3 45.3z"]
};
const faForward = {
  prefix: 'fass',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M512 256L256 448l0-384L512 256zM0 448L0 64 224 232l0 48L0 448z"]
};
const faUserPilot = {
  prefix: 'fass',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M80 99.2L80 128c16 10.7 67.2 32 144 32s128-21.3 144-32l0-28.8L400 80l0-32L224 0 48 48l0 32L80 99.2zm88.8-40.7l14.3 7.2L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zM224 416l-85.3-64L48 352 0 512l448 0L400 352l-90.7 0L224 416zm112 0l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0z"]
};
const faMobile = {
  prefix: 'fass',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M368 0L16 0l0 512 352 0L368 0zM160 432l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0z"]
};
const faMobileAndroid = faMobile;
const faMobilePhone = faMobile;
const faCodePullRequestClosed = {
  prefix: 'fass',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M305.4 62.6L354.7 112l-49.4 49.4 45.3 45.3L400 157.3l49.4 49.4 45.3-45.3L445.3 112l49.4-49.4L449.4 17.4 400 66.7 350.6 17.4 305.4 62.6zM136 88l0 48-48 0 0-48 48 0zM88 32L32 32l0 56 0 48 0 56 48 0 0 160-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-160 48 0 0-56 0-48 0-56-56 0L88 32zM432 288l0-32-64 0 0 32 0 64-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-64zm-8 168l-48 0 0-48 48 0 0 48zM88 408l48 0 0 48-48 0 0-48z"]
};
const faFaceMeh = {
  prefix: 'fass',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336l192 0 16 0 0 32-16 0-192 0-16 0 0-32 16 0z"]
};
const faMeh = faFaceMeh;
const faAlignCenter = {
  prefix: 'fass',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M352 32L96 32l0 64 256 0 0-64zm96 128L0 160l0 64 448 0 0-64zM0 416l0 64 448 0 0-64L0 416zM352 288L96 288l0 64 256 0 0-64z"]
};
const faBookSkull = {
  prefix: 'fass',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2l0 28.8 96 0 0-28.8c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3L119.6 203 107 232.4l14.7 6.3L199.4 272l-77.7 33.3L107 311.6 119.6 341l14.7-6.3L240 289.4l105.7 45.3 14.7 6.3L373 311.6l-14.7-6.3L280.6 272l77.7-33.3 14.7-6.3L360.4 203l-14.7 6.3L240 254.6 134.3 209.3z"]
};
const faBookDead = faBookSkull;
const faIdCard = {
  prefix: 'fass',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 32L0 96l576 0 0-64L0 32zm0 96L0 480l576 0 0-352L0 128zM64 416l32-64 160 0 32 64L64 416zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 0l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32z"]
};
const faDriversLicense = faIdCard;
const faFaceDotted = {
  prefix: 'fass',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M163 88C131.5 105.5 105.5 131.5 88 163L28.2 139C52.7 91.5 91.5 52.7 139 28.2L163 88zM304.5 70.2C289 66.1 272.7 64 256 64s-33 2.1-48.5 6.2L183.6 10.4C206.6 3.6 230.9 0 256 0s49.4 3.6 72.4 10.4L304.5 70.2zM424 163C406.5 131.5 380.5 105.5 349 88L373 28.2C420.5 52.7 459.3 91.5 483.8 139L424 163zm17.8 141.5c4-15.5 6.2-31.7 6.2-48.5s-2.1-33-6.2-48.5l59.8-23.9c6.8 23 10.4 47.3 10.4 72.4s-3.6 49.4-10.4 72.4l-59.8-23.9zM349 424c31.5-17.5 57.5-43.5 74.9-74.9L483.8 373c-24.4 47.5-63.3 86.4-110.8 110.8L349 424zM207.5 441.8c15.5 4 31.7 6.2 48.5 6.2s33-2.1 48.5-6.2l23.9 59.8c-23 6.8-47.3 10.4-72.4 10.4s-49.4-3.6-72.4-10.4l23.9-59.8zM88 349c17.5 31.5 43.5 57.5 74.9 74.9L139 483.8C91.5 459.3 52.7 420.5 28.2 373L88 349zM70.2 304.5L10.4 328.4C3.6 305.4 0 281.1 0 256s3.6-49.4 10.4-72.4l59.8 23.9C66.1 223 64 239.3 64 256s2.1 33 6.2 48.5zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 328l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faFaceWorried = {
  prefix: 'fass',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-.4-112c-38.7 0-74.5 11.4-103.6 30.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 411.4 294.3 400 255.6 400zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm141 .9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faOutdent = {
  prefix: 'fass',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 32l448 0 0 64L0 96 0 32zM192 160l256 0 0 64-256 0 0-64zM448 288l0 64-256 0 0-64 256 0zM0 416l448 0 0 64L0 480l0-64zm128-64L0 256l128-96 0 192z"]
};
const faDedent = faOutdent;
const faCourtSport = {
  prefix: 'fass',
  iconName: 'court-sport',
  icon: [640, 512, [], "e643", "M640 480l-304 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l304 0 0 96-96 0-32 0 0 32 0 192 0 32 32 0 96 0 0 96zM304 145.1c-54.3 7.8-96 54.4-96 110.9s41.7 103.1 96 110.9L304 480 0 480l0-96 96 0 32 0 0-32 0-192 0-32-32 0L0 128 0 32l304 0 0 113.1zm0 189.3c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4l0 156.8zm32 0l0-156.8c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4zM544 160l96 0 0 192-96 0 0-192zM96 352L0 352 0 160l96 0 0 192z"]
};
const faHeartCircleExclamation = {
  prefix: 'fass',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faHouse = {
  prefix: 'fass',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 128 0 0 160 160.8 0-1-224.4z"]
};
const faHome = faHouse;
const faHomeAlt = faHouse;
const faHomeLgAlt = faHouse;
const faVectorCircle = {
  prefix: 'fass',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M192 0L320 0l0 41.3C392.2 62.8 449.2 119.8 470.7 192l41.3 0 0 128-41.3 0C449.2 392.2 392.2 449.2 320 470.7l0 41.3-128 0 0-41.3C119.8 449.2 62.8 392.2 41.3 320L0 320 0 192l41.3 0C62.8 119.8 119.8 62.8 192 41.3L192 0zM402.7 192c-16.1-36.9-45.8-66.6-82.7-82.7l0 18.7-128 0 0-18.7c-36.9 16.1-66.6 45.8-82.7 82.7l18.7 0 0 128-18.7 0c16.1 36.9 45.8 66.6 82.7 82.7l0-18.7 128 0 0 18.7c36.9-16.1 66.6-45.8 82.7-82.7L384 320l0-128 18.7 0zM240 48l0 32 32 0 0-32-32 0zm32 384l-32 0 0 32 32 0 0-32zM432 240l0 32 32 0 0-32-32 0zM80 240l-32 0 0 32 32 0 0-32z"]
};
const faCarCircleBolt = {
  prefix: 'fass',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M120 32L97.3 32 89.8 53.4 41.3 192 0 192 0 400l0 80 96 0 0-80 226.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7l0-.7-16 0-25.3 0L422.2 53.4 414.7 32 392 32 120 32zM402.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24-224l-10.7 64 66.7 0L472 448l10.7-64L416 384l104-96z"]
};
const faCalendarWeek = {
  prefix: 'fass',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zm384 64L64 256l0 96 320 0 0-96z"]
};
const faFlyingDisc = {
  prefix: 'fass',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", "M23.7 456.3C-1.5 431.1-5.9 389.6 7.1 341.4c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.8-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6c55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3zM235.1 267.1C161.4 340.9 76.7 375.8 46 345s4.1-115.4 77.9-189.2S282.3 47.2 313 77.9s-4.1 115.4-77.9 189.2z"]
};
const faLaptopMedical = {
  prefix: 'fass',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M64 32l32 0 448 0 32 0 0 32 0 288-64 0 0-256L128 96l0 256-64 0L64 64l0-32zM0 432l0-48 640 0 0 48-48 48L48 480 0 432zM288 144l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faSquareDownRight = {
  prefix: 'fass',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M0 480l448 0 0-448L0 32 0 480zM320 192l0 160-160 0-16-16 52-52-84-84 56-56 84 84 52-52 16 16z"]
};
const faB = {
  prefix: 'fass',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 32 0 160 0c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128L32 32zM160 224l-96 0L64 96l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l96 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 416l0-128z"]
};
const faSeatAirline = {
  prefix: 'fass',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M64 32L64 0 0 0 0 32 0 160l0 6.6 2.6 6 96 224 8.3 19.4 21.1 0 88 0 0 48-96 0-24 0 0 48 24 0 240 0 24 0 0-48-24 0-96 0 0-48 112 0 22.2 0 7.8-20.8 24-64L446.2 288 400 288l-278.3 0L108 256l212 0 32 0 0-64-32 0L80.5 192 64 153.4 64 32z"]
};
const faMoonOverSun = {
  prefix: 'fass',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M256 73.1L150 0 126.7 126.7 0 150 73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l23.3-126.7L512 362 438.9 256 512 150 385.3 126.7 362 0 256 73.1zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm213 65.7c-50.5 0-91.4-40.5-91.4-90.5c0-36.9 22.3-68.6 54.2-82.7c-10.1-3-20.8-4.6-31.8-4.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c38.7 0 72.8-19.6 92.9-49.4c-7.6 2-15.6 3.1-23.9 3.1z"]
};
const faEclipseAlt = faMoonOverSun;
const faPipe = {
  prefix: 'fass',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M64 0l0 32 0 448 0 32L0 512l0-32L0 32 0 0 64 0z"]
};
const faFileMedical = {
  prefix: 'fass',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM160 224l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faPotato = {
  prefix: 'fass',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M43.1 260.9L96 208l48-80 80-48 36.9-36.9C288.5 15.5 325.9 0 364.9 0C446.2 0 512 65.8 512 147.1c0 39-15.5 76.4-43.1 104L464 256 384 400 272 448l-20.9 20.9c-27.6 27.6-65 43.1-104 43.1C65.8 512 0 446.2 0 364.9c0-39 15.5-76.4 43.1-104zM408 168l-48 0 0 48 48 0 0-48zM216 200l-48 0 0 48 48 0 0-48zM136 392l0 48 48 0 0-48-48 0z"]
};
const faDiceOne = {
  prefix: 'fass',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M448 32L0 32 0 480l448 0 0-448zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleA = {
  prefix: 'fass',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM234.3 125.8l6.5-13.8 30.5 0 6.5 13.8L391.4 368l-53 0-22.5-48-119.7 0-22.5 48-53 0L234.3 125.8zM256 192.5L218.7 272l74.6 0L256 192.5z"]
};
const faHelmetBattle = {
  prefix: 'fass',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M64 256L64 0 0 224l0 32 64 0zm32-32c0 80-32 192-32 192l192 96 0-256-96-32 0-32 256 0 0 32-96 32 0 256 192-96s-32-112-32-192C480 80 288 0 288 0S96 80 96 224zM512 0l0 256 64 0 0-32L512 0z"]
};
const faButter = {
  prefix: 'fass',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M64 64l384 0 0 224L64 288 64 64zM32 320l576 0 32 0 0 64-32 0 0 64L32 448l0-64L0 384l0-64 32 0zM576 64l0 224-96 0 0-224 96 0z"]
};
const faBlanketFire = {
  prefix: 'fass',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M0 32l32 0 384 0 32 0 0 32 0 58.1-17 10.6c-24.1 15-58.9 43-88.1 79.6c-17.1 21.5-33.2 47-43.4 75.7L64 288l0 64 0 64 235 0c8.5 23.9 21.5 45.5 38 64L32 480 0 480l0-32 0-96 0-96 0-32L0 64 0 32zM288 351.8c0 11 .9 21.7 2.7 32.2L128 384l-32 0 0-64 32 0 162.9 0c-1.9 10.3-2.9 21-2.9 31.8zM448 160l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192zm96 240.2c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faKiwiBird = {
  prefix: 'fass',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M208 415.3c-5.3 .4-10.6 .7-16 .7c-16.6 0-32.7-2.1-48-6l0 46 0 24-48 0 0-24 0-65.7C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c56.9 0 108 24.7 143.1 64L448 96c70.7 0 128 57.3 128 128l0 128 0 128L464 352l-128.9 0c-21.3 23.8-48.4 42.2-79.1 53.1l0 50.9 0 24-48 0 0-24 0-40.7zM448 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faCastle = {
  prefix: 'fass',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M128 0l64 0 0 64 48 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 48 0 0-64 64 0 0 112 0 112 64 0 0-64 64 0 0 64 0 64 0 224-256 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L0 512 0 288l0-64 0-64 64 0 0 64 64 0 0-112L128 0z"]
};
const faGolfClub = {
  prefix: 'fass',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M224 512L0 512l0-40 48 0 16 0 0-32-16 0L0 440l0-32 48 0 16 0 0-32-16 0L0 376l0-72 264 88 0 .5L451.4 17.7l57.2 28.6-224 448L275.8 512 256 512l-32 0z"]
};
const faArrowRightArrowLeft = {
  prefix: 'fass',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M25.4 406.6l80 80L128 509.3 173.3 464l-22.6-22.6L125.3 416 416 416l32 0 0-64-32 0-290.7 0 25.4-25.4L173.3 304 128 258.7l-22.6 22.6-80 80L2.7 384l22.6 22.6zm397.3-256L445.3 128l-22.6-22.6-80-80L320 2.7 274.7 48l22.6 22.6L322.7 96 32 96 0 96l0 64 32 0 290.7 0-25.4 25.4L274.7 208 320 253.3l22.6-22.6 80-80z"]
};
const faExchange = faArrowRightArrowLeft;
const faRotateRight = {
  prefix: 'fass',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M369.1 142.9L312 200l24 24 160 0 0-160L472 40 414.4 97.6s0 0 0 0c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0l-45.3-45.3c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0c0 0 0 0 0 0z"]
};
const faRedoAlt = faRotateRight;
const faRotateForward = faRotateRight;
const faUtensils = {
  prefix: 'fass',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M64 160L64 0 32 0 0 160c0 47.6 34.6 87.1 80 94.7L80 480l0 32 64 0 0-32 0-225.3c45.4-7.6 80-47.1 80-94.7L192 0 160 0l0 160-16 0L128 0 96 0 80 160l-16 0zM448 0C416 0 288 32 288 176l0 176 96 0 0 128 0 32 64 0 0-32 0-128 0-112 0-32L448 0z"]
};
const faCutlery = faUtensils;
const faArrowUpWideShort = {
  prefix: 'fass',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M320 480l32 0 32 0 0-64-32 0-32 0-32 0 0 64 32 0zm0-128l96 0 32 0 0-64-32 0-96 0-32 0 0 64 32 0zm0-128l160 0 32 0 0-64-32 0-160 0-32 0 0 64 32 0zm0-128l224 0 32 0 0-64-32 0L320 32l-32 0 0 64 32 0zM151.7 58.5L128 32.4l-23.7 26-80 88L2.8 170.2l47.4 43.1 21.5-23.7L96 162.8 96 448l0 32 64 0 0-32 0-285.2 24.3 26.8 21.5 23.7 47.4-43.1-21.5-23.7-80-88z"]
};
const faSortAmountUp = faArrowUpWideShort;
const faChartPieSimpleCircleDollar = {
  prefix: 'fass',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-5.4 0-10.7 .2-16 .6L272 240l103.2 0c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80L224 288l0-255.5C98.9 40.8 0 144.8 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
const faBalloons = {
  prefix: 'fass',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368L96 448l128 0-32-80s128-96 128-208zM160 96c-35.3 0-64 28.7-64 64l-32 0c0-53 43-96 96-96l0 32zM448 432l-32 80 128 0-32-80s128-96 128-208c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.4 9.5 2.2 19.2 2.2 29c0 37-11.4 71.6-27.3 101.9C347.7 356.8 448 432 448 432zM416 224l-32 0c0-53 43-96 96-96l0 32c-35.3 0-64 28.7-64 64z"]
};
const faMillSign = {
  prefix: 'fass',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M160 250.5L81.9 469.2l60.3 21.5 17.9-50 0 7.3 64 0 0-32 0-154.5 35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48l0 208 0 32 64 0 0-32 0-208c0-58.2-44.3-106-101.1-111.5l19.2-53.8L241.9 21.2 208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-17.2 0-33.5 3.9-48 10.8L64 96 0 96 0 208 0 416l0 32 64 0 0-32 0-208c0-26.5 21.5-48 48-48s48 21.5 48 48l0 42.5z"]
};
const faBowlRice = {
  prefix: 'fass',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M200 32l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zm-24 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zM56 176l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zm192 0l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zm-96 0l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zM80 104l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm264 72l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zm-72-72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm168 72l16 0 24 0 0 48-24 0-16 0-24 0 0-48 24 0zm-72-72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zM272 32l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zM0 256l512 0 0 24c0 67-39.2 124.9-96 151.8l0 48.2L96 480l0-48.2C39.2 404.9 0 347 0 280l0-24z"]
};
const faTimelineArrow = {
  prefix: 'fass',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M152 72l0 48-48 0 0-48 48 0zM104 16L48 16l0 56 0 48 0 56 48 0 0 48-64 0L0 224l0 64 32 0 160 0 0 48-48 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-48 258.7 0-33.4 33.4L458.7 344 504 389.3l22.6-22.6 88-88L637.3 256l-22.6-22.6-88-88L504 122.7 458.7 168l22.6 22.6L514.7 224 384 224l0-48 48 0 0-56 0-48 0-56-56 0-48 0-56 0 0 56 0 48 0 56 48 0 0 48-160 0 0-48 48 0 0-56 0-48 0-56-56 0-48 0zM328 72l48 0 0 48-48 0 0-48zM248 392l0 48-48 0 0-48 48 0z"]
};
const faSkull = {
  prefix: 'fass',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9L96 512l96 0 0-48 0-16 32 0 0 16 0 48 64 0 0-48 0-16 32 0 0 16 0 48 96 0 0-113.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faGameBoardSimple = {
  prefix: 'fass',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M0 32l448 0 0 448L0 480 0 32zM224 96l0 160 160 0 0-160L224 96zm0 160L64 256l0 160 160 0 0-160z"]
};
const faGameBoardAlt = faGameBoardSimple;
const faCircleVideo = {
  prefix: 'fass',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 160l192 0 0 192-192 0 0-192zM416 336l-64-48 0-64 64-48 0 160z"]
};
const faVideoCircle = faCircleVideo;
const faChartScatterBubble = {
  prefix: 'fass',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zm64 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faHouseTurret = {
  prefix: 'fass',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M0 0L96 0l0 96 32 0 0-96 96 0 0 96 32 0 0-96 96 0 0 96 0 32 0 6.3L235.5 231.4 224 241l0 15 0 256L64 512l0-224L0 224l0-96L0 96 0 0zM256 256l96-80 96-80L640 256l0 256-352 0-32 0 0-32 0-224zM176 128c-22.1 0-40 17.9-40 40l0 40 80 0 0-40c0-22.1-17.9-40-40-40zM496 272l-96 0 0 96 96 0 0-96z"]
};
const faBanana = {
  prefix: 'fass',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M353.2 10.4C411.4 63.1 448 139.3 448 224c0 12.3-.8 24.4-2.3 36.3L329.8 284.7 279 254.6c16.1-33.5 25-71 25-110.6c0-31.4-5.6-61.3-15.9-89l65.1-44.6zm-29 308.2l115.1-24.2 27.7-5.8 13.6-2.9 9.3 10.4 64 72L569.9 386 534 417.9l-15.9-17.9-54.7-61.6-43 9.1C374.1 444.7 274.9 512 160 512L0 512 0 400l48 0c72.9 0 138.7-30.5 185.4-79.4l-22.1-13.1-80.2 41.8-21.3 11.1L87.6 317.8l21.3-11.1 92-48 11.8-6.2 11.5 6.8 39.1 23.2 60.9 36.1z"]
};
const faHandHoldingSkull = {
  prefix: 'fass',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 47.4 29 88.9 72.2 111L208 288l160 0-8.2-49C403 216.9 432 175.4 432 128zM240 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faPeopleDress = {
  prefix: 'fass',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L82 142.8 .2 270.8l53.9 34.4 42-65.8L48 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0L223.8 239.4l42 65.8 53.9-34.4L238 142.8 228.6 128l-17.5 0-102.2 0zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0-9.4 14.8-81.7 128 53.9 34.4 42-65.8L368 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0L543.8 239.4l42 65.8 53.9-34.4L558 142.8 548.6 128l-17.5 0-102.2 0z"]
};
const faLoveseat = {
  prefix: 'fass',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M64 32l0 160 32 0 32 0 0 32 0 96 256 0 0-96 0-32 32 0 32 0 0-160L64 32zm0 192L0 224 0 480l96 0 0-32 320 0 0 32 96 0 0-256-64 0-32 0 0 32 0 64 0 32-32 0-256 0-32 0 0-32 0-64 0-32-32 0z"]
};
const faCouchSmall = faLoveseat;
const faTowerBroadcast = {
  prefix: 'fass',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M64 128c0 35.6 8.3 69.3 23.1 99.2L29.7 255.5C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L87.1 28.8C72.3 58.7 64 92.4 64 128zm38.5 49.7C90 130.8 95.9 83.3 115.8 43l57.4 28.3c-13.3 26.9-17.2 58.5-8.9 89.8c2.2 8.3 5.2 16.2 8.8 23.6L115.8 213c-5.5-11.1-9.9-22.9-13.3-35.3zM460.2 43c5.5 11.1 9.9 22.9 13.3 35.3c12.6 46.9 6.6 94.4-13.3 134.7l-57.4-28.3c13.3-26.9 17.2-58.5 8.9-89.8c-2.2-8.3-5.2-16.2-8.8-23.6L460.2 43zM512 128c0-35.6-8.3-69.3-23.1-99.2L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-57.4-28.3C503.7 197.3 512 163.6 512 128zm-160 0c0 23.7-12.9 44.4-32 55.4L320 480l0 32-64 0 0-32 0-296.6c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
const faBroadcastTower = faTowerBroadcast;
const faTruckPickup = {
  prefix: 'fass',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M256 32l-32 0 0 32 0 128L32 192l0 96L0 288l0 64 32 0 33.1 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l66.3 0c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16l33.1 0 32 0 0-64-32 0 0-96-80.6 0L409 44l-9.6-12L384 32 256 32zM445.4 192L288 192l0-96 80.6 0 76.8 96zM224 368a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faBlockQuote = {
  prefix: 'fass',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M448 64L0 64l0 64 448 0 0-64zm0 160l-320 0 0 64 320 0 0-64zM128 384l0 64 320 0 0-64-320 0zM64 224L0 224 0 448l64 0 0-224z"]
};
const faUpLong = {
  prefix: 'fass',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M160 0L320 160l0 32-96 0 0 320L96 512l0-320L0 192l0-32L160 0z"]
};
const faLongArrowAltUp = faUpLong;
const faStop = {
  prefix: 'fass',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M0 64H384V448H0V64z"]
};
const faCodeMerge = {
  prefix: 'fass',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 48 0 0 192L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-80c26.7 20.1 60 32 96 32l80 0 0 48 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0 0 48-80 0c-47.6 0-87.1-34.6-94.7-80l46.7 0 0-56 0-48 0-56L104 0 56 0zm48 408l0 48-48 0 0-48 48 0zM344 248l48 0 0 48-48 0 0-48z"]
};
const faMoneyCheckDollarPen = {
  prefix: 'fass',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M576 64L0 64 0 448l326.6 0 4.4-30.6L564.4 184s0 0 0 0L576 172.4 576 64zM352 288l0 32-96 0 0-32 96 0zm-96-96l192 0 0 32-192 0 0-32zm-92-32l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20zm405 63.8l-41.3 41.3 71 71L640 294.8l-71-71zm-63.9 63.9L363.9 429 352 511.9 434.9 500 576.1 358.7l-71-71z"]
};
const faMoneyCheckEditAlt = faMoneyCheckDollarPen;
const faUpFromLine = {
  prefix: 'fass',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M32 192L192 32 352 192l0 32-96 0 0 160-128 0 0-160-96 0 0-32zm0 224l320 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z"]
};
const faArrowAltFromBottom = faUpFromLine;
const faUpload = {
  prefix: 'fass',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M288 352l0 32-64 0 0-32 0-226.7-65.4 65.4L136 213.3 90.7 168l22.6-22.6 120-120L256 2.7l22.6 22.6 120 120L421.3 168 376 213.3l-22.6-22.6L288 125.3 288 352zm32 64l0-64 192 0 0 160L0 512 0 352l192 0 0 64 128 0zm112 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHurricane = {
  prefix: 'fass',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M0 208C0 98.5 84.6 8.8 192 .6L192 96c107.4 8.2 192 97.9 192 207.4s-84.6 199.2-192 207.4l0-95.4C84.6 407.2 0 317.5 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGridRound2Plus = {
  prefix: 'fass',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z"]
};
const faPeoplePants = {
  prefix: 'fass',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L82 142.8 .2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L238 142.8 228.6 128l-17.5 0-102.2 0zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L402 142.8l-81.7 128 53.9 34.4 33.8-53L408 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L558 142.8 548.6 128l-17.5 0-102.2 0z"]
};
const faMound = {
  prefix: 'fass',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M142.6 178.3C173.3 127.2 228.4 96 288 96s114.7 31.2 145.4 82.3L576 416H0L142.6 178.3z"]
};
const faWindsock = {
  prefix: 'fass',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-160 64 0 0 48 80-16.7 0-286.7L128 48l0 48L64 96l0-64zm64 112l0 128-64 0 0-128 64 0zM272 78l0 260 96-20 0-220L272 78zM512 288l0-160-80-16.7 0 193.3L512 288z"]
};
const faCircleHalf = {
  prefix: 'fass',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z"]
};
const faBrakeWarning = {
  prefix: 'fass',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zM344 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zM296 320l0 48 48 0 0-48-48 0zM91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147l13 20.2-40.4 26L50.7 429C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83l13-20.2 40.4 26L91.1 109zM589.3 83C621.4 132.9 640 192.3 640 256s-18.6 123.1-50.7 173l-13 20.2-40.4-26 13-20.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147l-13-20.2 40.4-26 13 20.2z"]
};
const faToiletPortable = {
  prefix: 'fass',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M0 0L0 64l320 0 0-64L0 0zM24 96L0 96l0 24L0 488l0 24 48 0 0-24 0-8 224 0 0 8 0 24 48 0 0-24 0-368 0-24-24 0L24 96zM256 240l0 64 0 16-32 0 0-16 0-64 0-16 32 0 0 16z"]
};
const faCompactDisc = {
  prefix: 'fass',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm-64 0c0-88.4 71.6-160 160-160l0-32C150 64 64 150 64 256l32 0z"]
};
const faFileArrowDown = {
  prefix: 'fass',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM216 232l0 102.1 31-31 17-17L297.9 320l-17 17-72 72-17 17-17-17-72-72-17-17L120 286.1l17 17 31 31L168 232l0-24 48 0 0 24z"]
};
const faFileDownload = faFileArrowDown;
const faSaxophoneFire = {
  prefix: 'fass',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M0 153.6c0 7.6 .7 15.1 2 22.4l77.6 0c10.6-32.3 48.4-60.7 48.4-60.7s37.8 28.3 48.4 60.7l77.6 0c1.3-7.3 2-14.8 2-22.4c0-21.3-15.4-76.8-76.8-128L153.6 51.2 102.4 0C68.3 21.3 0 81.9 0 153.6zM168 344l50.9-88 13.1 0 24 0 0-48-24 0L24 208 0 208l0 48 16.9 0L4.4 309.4C1.5 321.8 0 334.4 0 347.1l0 3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L544 128l96 0 0-32L592 64l-80 0-63 63-8-8-17-17L390.1 136l17 17 8 8L401 175l-8-8-17-17L342.1 184l17 17 8 8L353 223l-8-8-17-17L294.1 232l17 17 8 8L200 376l-32-32zm-24-64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSaxHot = faSaxophoneFire;
const faCameraWebSlash = {
  prefix: 'fass',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M496.1 362.4l124.8 96.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 93.9 72.9C183.2 34.4 247.6 0 320 0C443.7 0 544 100.3 544 224c0 52.2-17.9 100.3-47.9 138.4zM192.8 126.9l25.3 19.6C241.5 115.8 278.4 96 320 96c70.7 0 128 57.3 128 128c0 30.1-10.4 57.7-27.7 79.5l25.3 19.6C467.1 295.9 480 261.5 480 224c0-88.4-71.6-160-160-160c-51.9 0-98 24.7-127.2 62.9zM256 176l25.3 19.6C290 183.7 304.1 176 320 176l0-32c-26.2 0-49.4 12.6-64 32zM512 499.4l0 12.6-384 0 0-40 75.5-56.6C139 376 96 305 96 224c0-16.6 1.8-32.7 5.2-48.3L160 222.1c0 .6 0 1.3 0 1.9c0 88.4 71.6 160 160 160c13.6 0 26.8-1.7 39.4-4.9L512 499.4zM324.8 351.9c-1.6 .1-3.2 .1-4.8 .1c-62.1 0-113.8-44.2-125.5-102.8L324.8 351.9z"]
};
const faWebcamSlash = faCameraWebSlash;
const faFolderMedical = {
  prefix: 'fass',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM224 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faFolderGear = {
  prefix: 'fass',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M512 96l0 384L0 480 0 32l224 0 48 64 240 0zM288 160l-64 0 0 37.5c-11.2 4-21.5 10-30.4 17.6l-32.5-18.7-32 55.4 32.5 18.7c-1.1 5.7-1.6 11.6-1.6 17.6s.5 11.9 1.6 17.5l-32.5 18.7 32 55.4L193.6 361c8.9 7.6 19.2 13.6 30.4 17.6l0 37.5 64 0 0-37.5c11.2-4 21.5-10 30.4-17.6l32.5 18.7 32-55.4-32.5-18.7c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l32.5-18.7-32-55.4L318.4 215c-8.9-7.6-19.1-13.6-30.4-17.6l0-37.5zM216 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faFolderCog = faFolderGear;
const faHandWave = {
  prefix: 'fass',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M352 80c0-26.5-21.5-48-48-48l-8 0-16 0 0-32 16 0 8 0c44.2 0 80 35.8 80 80l0 8 0 16-32 0 0-16 0-8zM185.4 70.6L162.7 48 208 2.7l22.6 22.6 192 192c3.3 3.3 6.4 6.7 9.4 10.2l0-99.5 0-32 32 0 16 0 32 0 0 32 0 184.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6 50.7 320l-9.4-9.4L18.7 288 64 242.7l22.6 22.6 9.4 9.4 22.6 22.6 56 56 18.7-18.7-136-136L34.7 176 80 130.7l22.6 22.6 136 136 18.7-18.7-152-152L82.7 96 128 50.7l22.6 22.6 152 152 18.7-18.7-136-136zM32 344l0 16 0 8c0 26.5 21.5 48 48 48l8 0 16 0 0 32-16 0-8 0c-44.2 0-80-35.8-80-80l0-8 0-16 32 0z"]
};
const faArrowUpArrowDown = {
  prefix: 'fass',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M438.6 454.6l96-96L557.3 336 512 290.7l-22.6 22.6L448 354.7 448 64l0-32-64 0 0 32 0 290.7-41.4-41.4L320 290.7 274.7 336l22.6 22.6 96 96L416 477.3l22.6-22.6zM182.6 57.4L160 34.7 137.4 57.4l-96 96L18.7 176 64 221.3l22.6-22.6L128 157.3 128 448l0 32 64 0 0-32 0-290.7 41.4 41.4L256 221.3 301.3 176l-22.6-22.6-96-96z"]
};
const faSortUpDown = faArrowUpArrowDown;
const faCaravan = {
  prefix: 'fass',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M0 32l416 0c88.4 0 160 71.6 160 160l0 160 32 0 32 0 0 64-32 0-32 0-288 0c0 53-43 96-96 96s-96-43-96-96L0 416 0 32zM320 352l128 0 0-96-32 0-16 0 0-32 16 0 32 0 0-96-128 0 0 224zM256 128L64 128l0 128 192 0 0-128zM192 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faShieldCat = {
  prefix: 'fass',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM224 208l-64-64 0 128c0 53 43 96 96 96s96-43 96-96l0-128-64 64-64 0zm-8 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faMessageSlash = {
  prefix: 'fass',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M565.2 416l10.8 0L576 0 64 0l0 26.9L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416zm-159 0L64 146.4 64 416l160 0 0 96 144-96 38.2 0z"]
};
const faCommentAltSlash = faMessageSlash;
const faBolt = {
  prefix: 'fass',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M16 288L320 0 260.7 197.6 432 224 128 512l59.3-197.6L16 288z"]
};
const faZap = faBolt;
const faTrashCanCheck = {
  prefix: 'fass',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0 0 384L32 512l0-384zM337 265l17-17L320 214.1l-17 17-111 111-47-47-17-17L94.1 312l17 17 64 64 17 17 17-17L337 265z"]
};
const faGlassWater = {
  prefix: 'fass',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M76.6 158.3L69.2 64l245.6 0-7.4 94.3-20.6 10.3c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L76.6 158.3zM40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0 5 64 40 512z"]
};
const faOilWell = {
  prefix: 'fass',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L384 17.1l32.8 122.4L308.5 167.5l-6.3-18.1L294.7 128l-45.4 0-7.5 21.4-13.6 39L96 222.6 96 184l0-24-48 0 0 24 0 264-16 0L0 448l0 64 32 0 512 0 32 0 0-64-32 0-137.3 0L340 257.5l-62.2 16.1L305.3 352l-66.6 0L265 277l-74.6 19.3L137.3 448 96 448l0-159.2 337.4-87.5 33.5 124.9 46.4-12.4c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32 111.4 0 11.2 32-133.8 0zM272.3 64l-.3-.9-.3 .9 .6 0z"]
};
const faTableCellsColumnUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-column-unlock',
  icon: [640, 512, [], "e690", "M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM208 96l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm288-80l0 48 32 0 32 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faPersonSimple = {
  prefix: 'fass',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm160 96l8 192-40 0 0 160L64 512l0-160-40 0 8-192 192 0z"]
};
const faArrowTurnLeftUp = {
  prefix: 'fass',
  iconName: 'arrow-turn-left-up',
  icon: [384, 512, [], "e634", "M342.6 150.6l22.6 22.6L320 218.5l-22.6-22.6L224 122.5l0 328.2 128 0 32 0 0 64-32 0-160 0-32 0 0-32 0-360.2L86.6 195.9 64 218.5 18.7 173.3l22.6-22.6 128-128L192 0l22.6 22.6 128 128z"]
};
const faVault = {
  prefix: 'fass',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M576 0L0 0 0 480l80 0 16 32 64 0 16-32 224 0 16 32 64 0 16-32 80 0L576 0zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3L480 352l-32 0 0-130.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"]
};
const faMars = {
  prefix: 'fass',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M448 32L320 32 288 64l41.4 41.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l53.6-53.6L416 192l32-32 0-128zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
const faToilet = {
  prefix: 'fass',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M24 0L0 0 0 48l24 0 8 0 0 148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c15.1 18.9 33.3 33.1 51.9 43.9L64 512l320 0-24.9-99.6c18.6-10.8 36.8-25 51.9-43.9c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4L416 48l8 0 24 0 0-48L424 0 24 0zM384 256l0 .3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3c0 0 0-.1 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8c0 0 0 .1 0 .1zM112 64l32 0 16 0 0 32-16 0-32 0L96 96l0-32 16 0z"]
};
const faPlaneCircleXmark = {
  prefix: 'fass',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3 85.5 57C354.3 247.8 320 303.9 320 368c0 54.7 24.9 103.5 64 135.8l0 8.2L256 480 128 512l0-64 64-48 0-80L0 384l0-96L192 160l0-66.3zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z"]
};
const faYenSign = {
  prefix: 'fass',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M.7 32L106 224l-58 0-32 0 0 64 32 0 80 0 0 32-80 0-32 0 0 64 32 0 80 0 0 64 0 32 64 0 0-32 0-64 80 0 32 0 0-64-32 0-80 0 0-32 80 0 32 0 0-64-32 0-58 0L319.3 32l-73 0L160 189.4 73.7 32 .7 32z"]
};
const faCny = faYenSign;
const faJpy = faYenSign;
const faRmb = faYenSign;
const faYen = faYenSign;
const faGearCode = {
  prefix: 'fass',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M200 0L312 0l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512l-112 0-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm87.8 162.6l2.6-15.8-31.6-5.3-2.6 15.8-32 192-2.6 15.8 31.6 5.3 2.6-15.8 32-192zM187.3 227.3L198.6 216 176 193.4l-11.3 11.3-40 40L113.4 256l11.3 11.3 40 40L176 318.6 198.6 296l-11.3-11.3L158.6 256l28.7-28.7zm160-22.6L336 193.4 313.4 216l11.3 11.3L353.4 256l-28.7 28.7L313.4 296 336 318.6l11.3-11.3 40-40L398.6 256l-11.3-11.3-40-40z"]
};
const faNotes = {
  prefix: 'fass',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M480 32L96 32l0 384 256 0 0-96 0-32 32 0 96 0 0-256zM384 352l0 45.7 0 18.3 96-96-18.3 0L416 320l-32 0 0 32zM296 464L48 464l0-312 0-24L0 128l0 24L0 488l0 24 24 0 272 0 24 0 0-48-24 0z"]
};
const faRubleSign = {
  prefix: 'fass',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M96 32L64 32l0 32 0 192L0 256l0 64 64 0 0 32L0 352l0 64 64 0 0 64 64 0 0-64 192 0 0-64-192 0 0-32 112 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L96 32zM240 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
const faRouble = faRubleSign;
const faRub = faRubleSign;
const faRuble = faRubleSign;
const faTrashUndo = {
  prefix: 'fass',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0L392 512 56 512 32 128zM209 241l17-17L192 190.1l-17 17-64 64-17 17 17 17 64 64 17 17L225.9 352l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23z"]
};
const faTrashArrowTurnLeft = faTrashUndo;
const faChampagneGlass = {
  prefix: 'fass',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M111.1 128l97.7 0-8.7-64-80.3 0-8.7 64zm173.4 81.3c8.8 64.5-32.8 122.9-92.5 138.6L192 448l48 0 32 0 0 64-32 0-80 0-80 0-32 0 0-64 32 0 48 0 0-100.1C68.2 332.3 26.7 273.8 35.5 209.3L64 0 256 0l28.5 209.3z"]
};
const faGlassChampagne = faChampagneGlass;
const faObjectsAlignCenterHorizontal = {
  prefix: 'fass',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M280 0L232 0l0 64L32 64l0 160 200 0 0 64L96 288l0 160 136 0 0 64 48 0 0-64 136 0 0-160-136 0 0-64 200 0 0-160L280 64l0-64z"]
};
const faSun = {
  prefix: 'fass',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M256 73.1L150 0 126.7 126.7 0 150 73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l23.3-126.7L512 362 438.9 256 512 150 385.3 126.7 362 0 256 73.1zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"]
};
const faTrashCanSlash = {
  prefix: 'fass',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M512 374.7l108.9 84.6 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L96 51.8 96 32l128 0L240 0 400 0l16 32 128 0 0 64L153 96l41.2 32L512 128l0 246.7zM304 213.2l32 24.8 0-30.1 0-16-32 0 0 16 0 5.2zm96 74.5l32 24.8L432 208l0-16-32 0 0 16 0 79.8zM512 499.4l0 12.6-384 0 0-315.2 80 63L208 432l0 16 32 0 0-16 0-146.9 64 50.4 0 96.5 0 16 32 0 0-16 0-71.3 64 50.4 0 20.8 0 16 32 0 0-11.6 80 63z"]
};
const faTrashAltSlash = faTrashCanSlash;
const faScreenUsers = {
  prefix: 'fass',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M32 0L64 0 576 0l32 0 0 32 0 216.4c-17-15.2-39.4-24.4-64-24.4l0-160L96 64l0 160c-24.6 0-47 9.2-64 24.4L32 32 32 0zm0 320a64 64 0 1 1 128 0A64 64 0 1 1 32 320zm224 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm288-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM416 512l-192 0 32-96 128 0 32 96zM32 416l128 0 32 96L0 512l32-96zm608 96l-192 0 32-96 128 0 32 96z"]
};
const faUsersClass = faScreenUsers;
const faGuitar = {
  prefix: 'fass',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M376 64l-8.9 35.7-82.5 82.5c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l82.5-82.5L448 136l64-72L448 0 376 64zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faSquareArrowLeft = {
  prefix: 'fass',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M0 32L0 480l448 0 0-448L0 32zM71 239L183 127l17-17L233.9 144l-17 17-71 71L360 232l24 0 0 48-24 0-214.1 0 71 71 17 17L200 401.9l-17-17L71 273l-17-17 17-17z"]
};
const faArrowSquareLeft = faSquareArrowLeft;
const faSquare8 = {
  prefix: 'fass',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M0 32l448 0 0 448L0 480 0 32zm232 96l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm0 48c0 0 0 0 0 0l16 0c0 0 0 0 0 0l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0z"]
};
const faFaceSmileHearts = {
  prefix: 'fass',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M519.2 95.2L491.6 67.6c-1.8-1.8-3.4-3.7-4.8-5.8c-4.4-6.5-6.8-14.2-6.8-22.2C480 17.7 497.7 0 519.6 0c10.5 0 20.6 4.2 28 11.6L560 24l12.4-12.4C579.8 4.2 589.9 0 600.4 0C622.3 0 640 17.7 640 39.6c0 10.5-4.2 20.6-11.6 28L560 136 519.2 95.2zm44.5 82.3c8 24.7 12.3 51.1 12.3 78.5c0 34.8-6.9 68-19.5 98.2c-11-6.6-23.8-10.2-36.9-10.2c-39.5 0-71.6 32.1-71.6 71.6c0 18.4 7.1 36.1 19.8 49.4c-41.8 29.6-92.8 47-147.8 47c-61.2 0-117.4-21.5-161.4-57.3L171 442.2c13.4-13.4 21-31.6 21-50.6c0-39.5-32.1-71.6-71.6-71.6c-14.5 0-28.6 4.4-40.4 12.5c-1.8-1.2-3.6-2.3-5.4-3.4C67.7 306 64 281.4 64 256C64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.4c-.1 1.7-.2 3.5-.2 5.2c0 19 7.5 37.2 21 50.6l68.4 68.4L560 181.3l3.7-3.7zM89.2 366.8l3.2-3.2c7.4-7.4 17.5-11.6 28-11.6c21.9 0 39.6 17.7 39.6 39.6c0 10.5-4.2 20.6-11.6 28L135 433 80 488 11.6 419.6C4.2 412.2 0 402.1 0 391.6C0 369.7 17.7 352 39.6 352c10.5 0 20.6 4.2 28 11.6L80 376l9.2-9.2zm403.7 78l-1.2-1.2c-7.4-7.4-11.6-17.5-11.6-28c0-21.9 17.7-39.6 39.6-39.6c8.2 0 16.1 2.5 22.7 7.1c1.9 1.3 3.7 2.8 5.3 4.5L560 400l12.4-12.4c7.4-7.4 17.5-11.6 28-11.6c21.9 0 39.6 17.7 39.6 39.6c0 10.5-4.2 20.6-11.6 28L560 512l-67.2-67.2zM320 400c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C408.9 330.3 376.4 368 320 368s-88.9-37.7-97.7-55.2l-28.6 14.3C206.3 352.3 248.4 400 320 400zM196.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm246.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0z"]
};
const faBracketsSquare = {
  prefix: 'fass',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M416 32l32 0 0 32 0 384 0 32-32 0-96 0-32 0 0-64 32 0 64 0 0-320-64 0-32 0 0-64 32 0 96 0zM32 32l96 0 32 0 0 64-32 0L64 96l0 320 64 0 32 0 0 64-32 0-96 0L0 480l0-32L0 64 0 32l32 0z"]
};
const faBrackets = faBracketsSquare;
const faLaptopArrowDown = {
  prefix: 'fass',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M96 32L64 32l0 32 0 288 64 0 0-256 128 0 0-64L96 32zM512 96l0 256 64 0 0-288 0-32-32 0L384 32l0 64 128 0zM0 384l0 48 48 48 544 0 48-48 0-48L0 384zM344 56l0-24-48 0 0 24 0 182.1-39-39-17-17L206.1 216l17 17 80 80 17 17 17-17 80-80 17-17L400 182.1l-17 17-39 39L344 56z"]
};
const faHockeyStickPuck = {
  prefix: 'fass',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M96 352l0 128 0 32 32 0 32 0 64 0 19.8 0 8.8-17.7 224-448L419.4 17.7 252.2 352 96 352zM0 352L0 512l64 0 0-160L0 352zm640 64l-256 0 0 96 256 0 0-96z"]
};
const faHouseTree = {
  prefix: 'fass',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M640 464l0 48-224 0 0-256 0-15-11.5-9.6L277 125.1 416 0 576 144l0 48-64 0 96 112 0 48-64 0 96 112zM0 256L192 96 384 256l0 256L0 512 0 256zm240 16l-96 0 0 96 96 0 0-96z"]
};
const faSignalFair = {
  prefix: 'fass',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M224 320l0-32-64 0 0 32 0 160 0 32 64 0 0-32 0-160zM96 416l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64z"]
};
const faSignal2 = faSignalFair;
const faFaceLaughWink = {
  prefix: 'fass',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-80c-83 0-151.2-63.1-159.2-144l318.4 0c-8 80.9-76.2 144-159.2 144zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm148.4 29.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z"]
};
const faLaughWink = faFaceLaughWink;
const faCircleDollar = {
  prefix: 'fass',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm20.2-362.6c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 36.8L233 400l0-38.9c-11.7-2.6-26.7-7.4-36.6-10.6c0 0 0 0 0 0c-6.6-2.1-13.1-4.2-19.7-6.2c-2.3-.7-4.5-1.4-6.8-2.1l12.9-41.2c2.2 .7 4.4 1.4 6.6 2.1c7.3 2.3 14.6 4.6 21.9 6.9c0 0 0 0 0 0c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7l0-38.3 43.2 0 0 37.4z"]
};
const faDollarCircle = faCircleDollar;
const faUsdCircle = faCircleDollar;
const faHorseHead = {
  prefix: 'fass',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M64 512l0-192.8c0-109.5 69.7-207 173.4-242.3L416 16l32 48L400 96l104 64 72 192-64 64-80 0-58.6-70.4c-11.6 4.1-24.1 6.4-37.1 6.4l-.2 0s0 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3c0 0 0 0 0 0c-28.9-7.8-53.1-26.8-67.8-52.2l-8-13.8-27.7 16 8 13.8c24 41.5 68.3 70 119.3 71.9L416 512 64 512zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faArrowsRepeat = {
  prefix: 'fass',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M0 224l0 32 64 0 0-32 0-64 274.7 0-25.4 25.4L290.7 208 336 253.3l22.6-22.6 80-80L461.3 128l-22.6-22.6-80-80L336 2.7 290.7 48l22.6 22.6L338.7 96 32 96 0 96l0 32 0 96zm512 64l0-32-64 0 0 32 0 64-274.7 0 25.4-25.4L221.3 304 176 258.7l-22.6 22.6-80 80L50.7 384l22.6 22.6 80 80L176 509.3 221.3 464l-22.6-22.6L173.3 416 480 416l32 0 0-32 0-96z"]
};
const faRepeatAlt = faArrowsRepeat;
const faBoreHole = {
  prefix: 'fass',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M288 0L224 0l0 32 0 264.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32l0-32zM160 128L0 128 0 512l512 0 0-384-160 0 0 224c0 53-43 96-96 96s-96-43-96-96l0-224z"]
};
const faIndustry = {
  prefix: 'fass',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M160 32L32 32l0 192 0 160 0 96 512 0 0-256 0-96L352 224l0-96L160 224l0-192z"]
};
const faImagePolaroid = {
  prefix: 'fass',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M0 32l448 0 0 448L0 480 0 32zM64 96l0 256 320 0 0-256L64 96zm64 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 320l-144 0-48 0-64 0 0-32 56-64 30.2 34.5L256 160l96 128 0 32z"]
};
const faWaveTriangle = {
  prefix: 'fass',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M175.6 10.1l26 34.7 262 349.3 102.5-141 18.8-25.9 51.8 37.6-18.8 25.9-128 176-25.5 35-26-34.7-262-349.3L73.9 258.8 55.1 284.7 3.3 247.1l18.8-25.9 128-176 25.5-35z"]
};
const faTurnLeftDown = {
  prefix: 'fass',
  iconName: 'turn-left-down',
  icon: [384, 512, [], "e637", "M192 512L32 352l0-32 112 0L144 0 384 0l0 96L240 96l0 224 112 0 0 32L192 512z"]
};
const faPersonRunningFast = {
  prefix: 'fass',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 96l-13.3 0-9.4 9.4-48 48-8 8 45.3 45.3 8-8L237.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L309.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L401 340.9 334 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L294.2 96 288 96l-64 0zM205.5 310.7L187.2 352 128 352l-32 0 0 64 32 0 80 0 20.8 0 8.4-19L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9zM16 95.8l-16 0 0 32 16 0 112 0 16 0 0-32-16 0-112 0zm-16 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm16 64l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0z"]
};
const faCircleDown = {
  prefix: 'fass',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM384 256l-80 0 0-128-96 0 0 128-80 0 0 16L256 400 384 272l0-16z"]
};
const faArrowAltCircleDown = faCircleDown;
const faGrill = {
  prefix: 'fass',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M0 32l448 0 0 64c0 89.8-52.9 167.3-129.2 203l55.2 128.9 4 9.3 9.5 22.1-44.1 18.9-9.5-22.1-4-9.3L316.7 416 160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 32zM151.8 368l144.3 0-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faArrowsTurnToDots = {
  prefix: 'fass',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M265.4 25.4L288 2.7 333.3 48 310.6 70.6 285.3 96 480 96l32 0 0 32 0 96 0 32-64 0 0-32 0-64-162.7 0 25.4 25.4L333.3 208 288 253.3l-22.6-22.6-80-80L162.7 128l22.6-22.6 80-80zm-18.7 256l80 80L349.3 384l-22.6 22.6-80 80L224 509.3 178.7 464l22.6-22.6L226.7 416 64 416l0 64 0 32L0 512l0-32 0-96 0-32 32 0 194.7 0-25.4-25.4L178.7 304 224 258.7l22.6 22.6zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
};
const faChartMixed = {
  prefix: 'fass',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M340 217L500 89 460 39 319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199l40 50L192.6 136.5l108.2 81.1 19.8 14.9L340 217zm-180 7l0 256 64 0 0-256-64 0zM32 320l0 160 64 0 0-160-64 0zm320-32l-64 0 0 192 64 0 0-192zm64-64l0 256 64 0 0-256-64 0z"]
};
const faAnalytics = faChartMixed;
const faFlorinSign = {
  prefix: 'fass',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224 32 224l0 64 112 0L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7L0 416l0 64 69.3 0c38.8 0 73.7-23.3 88.6-59.1L213.3 288 352 288l0-64-112 0 45.1-108.3c5-11.9 16.6-19.7 29.5-19.7L384 96l0-64-69.3 0z"]
};
const faArrowDownShortWide = {
  prefix: 'fass',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M320 32l32 0 32 0 0 64-32 0-32 0-32 0 0-64 32 0zm0 128l96 0 32 0 0 64-32 0-96 0-32 0 0-64 32 0zm0 128l160 0 32 0 0 64-32 0-160 0-32 0 0-64 32 0zm0 128l224 0 32 0 0 64-32 0-224 0-32 0 0-64 32 0zM151.7 469.5l-23.7 26-23.7-26-80-88L2.8 357.8l47.4-43 21.5 23.7L96 365.2 96 80l0-32 64 0 0 32 0 285.2 24.3-26.8 21.5-23.7 47.4 43-21.5 23.7-80 88z"]
};
const faSortAmountDesc = faArrowDownShortWide;
const faSortAmountDownAlt = faArrowDownShortWide;
const faLessThan = {
  prefix: 'fass',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M384 64.5l-5 2.2L19 226.8 0 235.2l0 41.6 19 8.4 360 160 5 2.2 0-70L110.8 256 384 134.6l0-70z"]
};
const faDisplayCode = {
  prefix: 'fass',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M0 0L576 0l0 416-240 0 10.7 32 69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416 0 416 0 0zM64 64l0 288 448 0 0-288L64 64zM249 177l-31 31 31 31 17 17L232 289.9l-17-17-48-48-17-17 17-17 48-48 17-17L265.9 160l-17 17zM361 143l48 48 17 17-17 17-48 48-17 17L310.1 256l17-17 31-31-31-31-17-17L344 126.1l17 17z"]
};
const faDesktopCode = faDisplayCode;
const faFaceDrooling = {
  prefix: 'fass',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.9 0 66.4-6.6 96-18.6l0-122.4c-9.7 6.4-20.3 12.2-32 16.9l0 60.2 0 16-32 0 0-16 0-50.9c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70l-10-12.5 25-20 10 12.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58l10-12.5 25 20-10 12.5c-3.8 4.7-7.9 9.5-12.5 14.2l0 133.6zM200 176c-39.2 0-58.3 25.6-64.8 45.1l-30.4-10.1c9.5-28.5 38.4-66.9 95.2-66.9l0 32zm176.8 45.1C370.3 201.6 351.2 176 312 176l0-32c56.8 0 85.7 38.4 95.2 66.9l-30.4 10.1z"]
};
const faOilTemperature = {
  prefix: 'fass',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M256 0l32 0 64 0 32 0 0 64-32 0-32 0 0 32 32 0 32 0 0 64-32 0-32 0 0 70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L256 128l0-96 0-32zM400 304l0-1.3c13.7-2.2 26.9-6.8 38-11.8c14.9-6.8 26.9-15.4 40-24.7c0 0 0 0 0 0l2.1-1.5 2.1 1.5s0 0 0 0c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-1.4 0-2.7 0-4-.1c12.6-18.1 20-40.2 20-63.9zM288 416c3.3 0 6.5-.1 9.7-.4c10.3 7.2 20.4 13.9 32.3 19.3c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c0 0 0 0 0 0l2.1-1.5 2.1 1.5s0 0 0 0c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c11.9-5.4 22-12 32.3-19.3c3.2 .3 6.4 .4 9.7 .4zm-96-48c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 358.1 31.9 368 0 368l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c11.1 5 24.2 9.7 38 11.8l0 1.3c0 23.8 7.4 45.8 20 63.9c-1.3 0-2.7 .1-4 .1z"]
};
const faOilTemp = faOilTemperature;
const faSquareQuestion = {
  prefix: 'fass',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M448 32L0 32 0 480l448 0 0-448zM136 184c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4l0 23.6-48 0 0-24 0-13.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L192 176c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 136l48 0 0 48-48 0 0-48z"]
};
const faQuestionSquare = faSquareQuestion;
const faAirConditioner = {
  prefix: 'fass',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M576 0L0 0 0 224l576 0L576 0zM80 128l416 0 16 0 0 32-16 0L80 160l-16 0 0-32 16 0zM256 256l-64 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l-32-55.4C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96l0-160zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1l-32 55.4c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-64 0 0 128z"]
};
const faAngleDown = {
  prefix: 'fass',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M224 397.3l22.6-22.6 160-160L429.3 192 384 146.7l-22.6 22.6L224 306.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 160 160L224 397.3z"]
};
const faMountains = {
  prefix: 'fass',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M256 32L0 416l0 64 320 0 192 0 128 0 0-64L480 160 412.9 267.4 256 32z"]
};
const faOmega = {
  prefix: 'fass',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 96C135.6 96 64 167.6 64 256c0 59.2 32.1 110.9 80 138.6l16 9.2 0 18.5 0 25.7 0 32-32 0-96 0L0 480l0-64 32 0 35.2 0C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160l35.2 0 32 0 0 64-32 0-96 0-32 0 0-32 0-25.7 0-18.5 16-9.2c47.9-27.7 80-79.4 80-138.6c0-88.4-71.6-160-160-160z"]
};
const faCarTunnel = {
  prefix: 'fass',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 0C114.6 0 0 114.6 0 256L0 512l96 0 0-64 0-128 28.4 0 30.2-80.4 5.8-15.6 16.6 0 159 0 16.8 0 5.7 15.8L387.7 320l28.3 0 0 128 0 64 96 0 0-256C512 114.6 397.4 0 256 0zm96 512l0-64-192 0 0 64 192 0zM319.2 272l-125.6 0-18 48 161 0-17.5-48zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faPersonDollyEmpty = {
  prefix: 'fass',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 480l0 32 64 0 0-32s0 0 0 0l0-69.5-64-64L0 480zM32 128L0 128l0 32L0 274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 4 24 4 24s0 0 0 0l4 24 .5 2.7 64.9 0-2.2-13.3-4-24s0 0 0 0l-4-24-4-24-8-48-1.7-10.1-7.3-7.3L96 306.7l0-65.1 21.4 32.1 9.5 14.3 17.1 0 79.3 0 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6 23.3-5.8-11.6-46.6-23.3 5.8L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2l-5.8-23.3-46.6 11.6 5.8 23.3 6.5 26.2-46.1 0-54.5-81.7L97.1 128 80 128l-48 0zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faPanFood = {
  prefix: 'fass',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M320 512A256 256 0 1 0 320 0a256 256 0 1 0 0 512zm0-448c39.8 0 72 32.2 72 72l0 8-144 0 0-8c0-39.8 32.2-72 72-72zM244.3 200l-14.1 14.1-32 32L184 260.3 155.7 232l14.1-14.1 32-32L216 171.7 244.3 200zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM238.6 296l-8 8 16 16 33.4 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-33.4-16-16-8 8L177.4 312l11.3-11.3 8-8 8-8L216 273.4 238.6 296zM464 176l11 11c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1c-10.9 8.7-24.5 13.5-38.5 13.5l-4.1 0c-19.4 0-38-7.7-51.8-21.4L368 272l96-96zM48 160L0 160l0 24L0 328l0 24 48 0 0-24 0-144 0-24zm592 24l0-24-48 0 0 24 0 144 0 24 48 0 0-24 0-144z"]
};
const faHeadSideCough = {
  prefix: 'fass',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 32L320 368l0 40 128 8 0 64-128 0 0 32-32 0-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zm352-.3a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faGripLines = {
  prefix: 'fass',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M0 288l0 64 448 0 0-64L0 288zM0 160l0 64 448 0 0-64L0 160z"]
};
const faThumbsDown = {
  prefix: 'fass',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M240 444.3l0 35.7 96 0 0-35.7c0-38.1-9-75.1-25.8-108.3L464 336l48 0 0-96-16 0 0-80-24 0 0-72-24 0 0-56-48 0L280 32l-14.5 0-12.1 8.1-72 48L160 102.3l0 25.7 0 64 0 96 0 23.1 18 14.4 7.9 6.4c34.2 27.3 54 68.7 54 112.4zM128 384l0-288L0 96 0 384l128 0z"]
};
const faUserLock = {
  prefix: 'fass',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM384 304l0 208L0 512 64 304l320 0zm144-64c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faArrowRightLong = {
  prefix: 'fass',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M489.4 233.4L512 256l-22.6 22.6-128 128-22.6 22.6L293.5 384l22.6-22.6L389.5 288 32 288 0 288l0-64 32 0 357.5 0-73.4-73.4L293.5 128l45.3-45.3 22.6 22.6 128 128z"]
};
const faLongArrowRight = faArrowRightLong;
const faTicketsAirline = {
  prefix: 'fass',
  iconName: 'tickets-airline',
  icon: [640, 512, ["tickets-perforated-plane", "tickets-plane"], "e29b", "M96 32l0 352 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128L96 32zM528 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM256 96l48 0 58.7 88 61.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-61.3 0L304 320l-48 0 33.5-88-47.2 0L224 264l-32 0 16-56-16-56 32 0 18.3 32 47.2 0L256 96zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faTicketsPerforatedPlane = faTicketsAirline;
const faTicketsPlane = faTicketsAirline;
const faTentDoublePeak = {
  prefix: 'fass',
  iconName: 'tent-double-peak',
  icon: [576, 512, [], "e627", "M7.9 142.7L0 146.9 0 192l576 0 0-45.1-7.9-4.2C510.3 112.1 461.3 67.2 425.8 12.3L417.8 0l-8.5 9.5C378.5 44.2 334.4 64 288 64s-90.5-19.8-121.3-54.5L158.2 0l-8 12.3C114.7 67.2 65.7 112.1 7.9 142.7zM576 224L0 224 0 512l288 0 0-224L416 512l160 0 0-288z"]
};
const faAnchorCircleXmark = {
  prefix: 'fass',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z"]
};
const faEllipsis = {
  prefix: 'fass',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M16 304l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zm160-96l96 0 0 96-96 0 0-96z"]
};
const faEllipsisH = faEllipsis;
const faNfcSlash = {
  prefix: 'fass',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6 544 32 96 32l0 19.8-47.6-37zM160 101.4l0-5.4 16 0 64 0 16 0 0 32-16 0-45.8 0L160 101.4zM301.8 211.6c.7-.3 1.4-.6 2.2-.8l0-98.7 0-16 16 0 144 0 16 0 0 16 0 237.9L448 325l0-197-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 2.2-.2 4.4-.4 6.6l-65.7-51zM487.4 480l-81.2-64L176 416l-16 0 0-16 0-177.9L96 171.6 96 480l391.4 0zM192 384l173.5 0L192 247.3 192 384z"]
};
const faChessPawn = {
  prefix: 'fass',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88L96 224l-32 0 0 64 28.4 0L80 400l160 0L227.6 288l28.4 0 0-64-32 0-8.5 0zM16 512l288 0 0-32-48-48L64 432 16 480l0 32z"]
};
const faKitMedical = {
  prefix: 'fass',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M0 32L0 480l96 0L96 32 0 32zm128 0l0 448 320 0 0-448L128 32zM576 480l0-448-96 0 0 448 96 0zM256 160l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faFirstAid = faKitMedical;
const faGrid2Plus = {
  prefix: 'fass',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M224 32l0 192L32 224 32 32l192 0zm0 256l0 192L32 480l0-192 192 0zM288 32l192 0 0 192-192 0 0-192zM408 272l0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0z"]
};
const faBells = {
  prefix: 'fass',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M293.1 41.2c-71.1 42-104.5 130-75.2 210.4l35.3 97.1-11.3 44.4L0 305l12.9-35.6 67.2-48 36.4-100c25.7-70.5 103.6-106.8 174-81.2c.9 .3 1.7 .6 2.5 1zM97.5 374.6l117.9 42.9c-11.3 18.3-31.5 30.4-54.5 30.4c-35.4 0-64.1-28.7-64.1-64c0-3.2 .2-6.3 .7-9.3zm181.3 94.5l-13.7-37.6L286.7 347 248 240.6c-27-74.2 11.2-156.2 85.4-183.2s156.3 11.3 183.3 85.5l38.7 106.4 70.9 50.9L640 337.7 278.8 469.1zm150-16.3L545 410.6c.1 1.8 .2 3.6 .2 5.4c0 35.4-28.7 64-64.1 64c-21.6 0-40.8-10.7-52.4-27.1z"]
};
const faPersonThroughWindow = {
  prefix: 'fass',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M288 64l0 77.9L143.5 228.6 128 237.9l0 18.1 0 128s0 0 0 0l-64 0L64 64l224 0zm64 0l224 0 0 320-67.7 0-3.7-4.5-80-96L415 272l-15 0-78.6 0-35.3-54.4 50.3-30.2 15.5-9.3 0-18.1 0-96zm73 320l-45.8 0 42.7 64L576 448l64 0 0-64 0-320 0-64L576 0 64 0 0 0 0 64 0 384l0 64 64 0 244.2 0 24.9 37.3 17.8 26.6 53.3-35.5-17.8-26.6L310.5 336l74.6 0 40 48zm-159.5 0L192 384s0 0 0 0l0-109.9 .2-.1 73.3 110zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faToolbox = {
  prefix: 'fass',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M152 32l-24 0 0 24 0 72-48 0L0 208 0 320l128 0 0-32 0-32 64 0 0 32 0 32 128 0 0-32 0-32 64 0 0 32 0 32 128 0 0-112-80-80-48 0 0-72 0-24-24 0L152 32zm184 96l-160 0 0-48 160 0 0 48zM0 480l512 0 0-128-128 0 0 32-64 0 0-32-128 0 0 32-64 0 0-32L0 352 0 480z"]
};
const faGlobeWifi = {
  prefix: 'fass',
  iconName: 'globe-wifi',
  icon: [640, 512, [], "e685", "M352 256c0 3.7-.1 7.4-.2 11c-11.2 15.9-19.8 33.8-25.2 53l-160.5 0c-3.9-20.5-6.1-41.9-6.1-64s2.2-43.5 6.1-64l179.7 0c3.9 20.5 6.1 41.9 6.1 64zm14.4 231c-21.5 10.3-44.6 17.7-69 21.6c12.6-17.9 26.4-40 39.3-65.6c7.6 16.2 17.7 31 29.6 44zM320 368c0 10 .8 19.9 2.5 29.5c-9.1 22-19.5 42.1-30 59.9c-13 21.9-25.9 40-36.5 53.5c-10.5-13.5-23.5-31.6-36.5-53.5c-17.4-29.4-34.5-65.1-45.8-105.4l147 0c-.5 5.3-.7 10.6-.7 16zM496.1 192l7.8 0 0 .2c-2.6-.1-5.2-.2-7.8-.2zM383.3 232.8c-.9-14-2.6-27.6-4.9-40.8l117.5 0c-42.8 0-82.1 15.4-112.6 40.8zM493.4 160l-122 0c-17-65.6-48.3-120-74-156.7c89.2 14.5 163 75.2 196 156.7zm-155.1 0l-164.6 0c11.4-40.2 28.4-75.9 45.8-105.4c13-21.9 25.9-40 36.5-53.5c10.5 13.5 23.5 31.6 36.5 53.5c17.4 29.4 34.5 65.1 45.8 105.4zm-197.7 0l-122 0c33-81.5 106.7-142.2 196-156.7c-25.7 36.7-57 91-74 156.7zM8.1 192l125.6 0c-3.6 20.5-5.6 41.9-5.6 64s2 43.5 5.6 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM140.6 352c17 65.6 48.3 120 74 156.7c-89.2-14.5-163-75.2-196-156.7l122 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm256.5-20.4C584.1 311.6 542.8 288 496 288s-88.1 23.6-112.5 59.6l25.6 19.2C427.7 338.6 459.7 320 496 320s68.3 18.6 86.9 46.8l25.6-19.2zM496 352c-26.2 0-49.4 12.6-64 32l25.6 19.2c8.8-11.7 22.7-19.2 38.4-19.2s29.6 7.5 38.4 19.2L560 384c-14.6-19.4-37.8-32-64-32zm0 100a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
const faEnvelopeDot = {
  prefix: 'fass',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 0a80 80 0 1 1 0 160A80 80 0 1 1 496 0zM0 64l385.1 0c-.7 5.2-1.1 10.6-1.1 16c0 47 29 87.3 70 103.9L256 320 0 144 0 64zM274.1 346.4L498.7 192c4.5-.1 8.9-.5 13.3-1.1L512 448 0 448 0 182.8 237.9 346.4 256 358.8l18.1-12.5z"]
};
const faEnvelopeBadge = faEnvelopeDot;
const faMagnifyingGlassWaveform = {
  prefix: 'fass',
  iconName: 'magnifying-glass-waveform',
  icon: [512, 512, [], "e661", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM232 120l0-24-48 0 0 24 0 176 0 24 48 0 0-24 0-176zm-88 32l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm176 32l0-24-48 0 0 24 0 48 0 24 48 0 0-24 0-48z"]
};
const faHandsHoldingCircle = {
  prefix: 'fass',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM80 64l0 40 0 8 0 32 0 80 0 66.7 84.1 84.1L205.8 347l-36.4-36.4L146.7 288l-9.4-9.4L114.7 256 160 210.7l22.6 22.6 9.4 9.4 22.6 22.6 64 64 9.4 9.4 0 13.3 0 64 0 32 0 32 0 32-32 0-96 0-13.3 0-9.4-9.4-128-128L0 365.3 0 352 0 224l0-64 0-32 0-24L0 64l80 0zm480 0l80 0 0 40 0 24 0 32 0 64 0 128 0 13.3-9.4 9.4-128 128-9.4 9.4L480 512l-96 0-32 0 0-32 0-32 0-32 0-64 0-13.3 9.4-9.4 64-64L448 242.7l9.4-9.4L480 210.7 525.3 256l-22.6 22.6-9.4 9.4-22.6 22.6L434.2 347l41.7 27.8L560 290.7l0-66.7 0-80 0-32 0-8 0-40z"]
};
const faBug = {
  prefix: 'fass',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 0c-53 0-96 43-96 96l0 32 192 0 0-32c0-53-43-96-96-96zM86.6 105.4L64 82.7 18.7 128l22.6 22.6L96 205.3 96 256l-64 0L0 256l0 64 32 0 64 0c0 24.2 5.4 47.2 15 67.7L57.4 441.4 34.7 464 80 509.3l22.6-22.6 47.1-47.1c24.5 21.8 55.8 36.2 90.3 39.6L240 240l0-16 32 0 0 16 0 239.2c34.5-3.4 65.8-17.8 90.3-39.6l47.1 47.1L432 509.3 477.3 464l-22.6-22.6L401 387.7c9.6-20.6 15-43.5 15-67.7l64 0 32 0 0-64-32 0-64 0 0-50.7 54.6-54.6L493.3 128 448 82.7l-22.6 22.6L370.7 160l-229.5 0L86.6 105.4z"]
};
const faBowlChopsticks = {
  prefix: 'fass',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M0 96l0 32L512 48l0-48L0 96zm0 48l0 32 512 0 0-48L0 144zm512 80L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224z"]
};
const faCreditCard = {
  prefix: 'fass',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M576 32L0 32l0 96 576 0 0-96zm0 192L0 224 0 480l576 0 0-256zM192 352l0 32-96 0 0-32 96 0zm32 0l160 0 0 32-160 0 0-32z"]
};
const faCreditCardAlt = faCreditCard;
const faCircleS = {
  prefix: 'fass',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7l23.3 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
const faBoxBallot = {
  prefix: 'fass',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M128 0L448 0l0 224-320 0L128 0zM0 352l576 0 0 160L0 512 0 352zM0 160l96 0 0 96 384 0 0-96 96 0 0 160L0 320 0 160z"]
};
const faCar = {
  prefix: 'fass',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M120 32L97.3 32 89.8 53.4 41.3 192 0 192 0 400l0 80 96 0 0-80 320 0 0 80 96 0 0-80 0-208-41.3 0L422.2 53.4 414.7 32 392 32 120 32zM402.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faAutomobile = faCar;
const faHandHoldingHand = {
  prefix: 'fass',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M436 217l71.2-57 68.8 0 0-128-32 0L352 32 192 32l-12.4 0-10.2 7-128 88-33 22.7 45.3 65.9 33-22.7 94.5-65L320 128l0 32-32 0-64 0-32 0 0 64 32 0 64 0 64 0 64 0 11.2 0 8.8-7zM140 295L68.8 352 0 352 0 480l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 384l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faUserTieHair = {
  prefix: 'fass',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144l0-16c0-11.4-2.4-22.2-6.7-32L256 96 240 80l-32 32-62.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16C96 57.3 153.3 0 224 0zM209.1 359.2L176 304l48 0 48 0-33.1 55.2 33.4 123.9L312.2 320l71.8 0 64 192-168 0-14.9 0-82.3 0L168 512 0 512 64 320l71.8 0 39.9 163.1 33.4-123.9z"]
};
const faPodiumStar = {
  prefix: 'fass',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M192 0l96 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-96 0 0-24-24 0c-22.1 0-40 17.9-40 40l0 32 296 0 24 0 0 48-24 0L24 192 0 192l0-48 24 0 56 0 0-32c0-48.6 39.4-88 88-88l24 0 0-24zM80 512L48 224l352 0L368 512 80 512zM253.3 335.6L224 272l-29.3 63.6-69.6 8.2 51.4 47.6-13.7 68.7L224 425.9l61.1 34.2-13.7-68.7 51.4-47.6-69.6-8.2z"]
};
const faUserHairMullet = {
  prefix: 'fass',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0 12 0 7.2-9.6L224 64l28.8 38.4L260 112l12 0 30.4 0c1 5.2 1.6 10.5 1.6 16zm47-16l9 0 0-48-24 0-1.1 0C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64L112 64 88 64l0 48 9 0c-.7 5.2-1 10.6-1 16l0 16c0 21.7 5.4 42.1 14.9 59.9L96 256l32 16 24-16 8 32 32 0 16.9-16.9c5 .6 10 .9 15.1 .9s10.2-.3 15.1-.9L256 288l32 0 8-32 24 16 32-16-14.9-52.1c9.5-17.9 14.9-38.3 14.9-59.9l0-16c0-5.4-.3-10.8-1-16zm97 400L384 320 64 320 0 512l448 0z"]
};
const faBusinessFront = faUserHairMullet;
const faPartyBack = faUserHairMullet;
const faTrianBalbot = faUserHairMullet;
const faMicrophoneStand = {
  prefix: 'fass',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M479.2 191.2c43.7-43.7 43.7-114.7 0-158.4s-114.7-43.7-158.4 0l-4.7 4.7L474.5 195.9l4.7-4.7zm-27.3 27.3L293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89L358.2 255.6c31.8 2.8 64.6-8 89-32.4l4.7-4.7zM339.7 282.3L229.7 172.3 0 448l64 64L224 378.7 224 480l0 32 64 0 0-32 0-154.7 51.7-43z"]
};
const faBookOpenReader = {
  prefix: 'fass',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152l0 264-70.7-29.4c-16.8-7-34.5-11.6-52.6-13.6L0 456 0 192l57.5 0c56.7 0 112.3 15 161.2 43.6L240 248zm32 264l0-264c52.1-36.4 114.1-56 177.7-56l62.3 0 0 264L387.2 468.5c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"]
};
const faBookReader = faBookOpenReader;
const faFamilyDress = {
  prefix: 'fass',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm48 48c0-5.5 .6-10.8 1.6-16L64 160 0 384l64 0 0 128 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48zm272-16l-113.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48l16 0 32 0 0 32 0 160 0 32-32 0 0 64 112 0 0-128 64 0L448 160zm-64-32A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 192l0-160-160 0 0 160 32 0 0 96 96 0 0-96 32 0z"]
};
const faCircleX = {
  prefix: 'fass',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM381.1 128L285.9 256l95.2 128-59.8 0L256 296.2 190.7 384l-59.8 0 95.2-128L130.9 128l59.8 0L256 215.8 321.3 128l59.8 0z"]
};
const faCabin = {
  prefix: 'fass',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M0 176l0 48 384 0 96 0 32 0 0-48-32-22 0-122-96 0 0 56L256 0 0 176zm192 80L32 256l0 64 160 0 0-64zM32 352l0 64 160 0 0-64L32 352zm0 96l0 64 160 0 0-64L32 448zM320 256l0 64 160 0 0-64-160 0zM480 448l-160 0 0 64 160 0 0-64zM320 352l0 64 160 0 0-64-160 0zM256 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faMountainSun = {
  prefix: 'fass',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M560 0a80 80 0 1 1 0 160A80 80 0 1 1 560 0zM0 448L256 64 412.9 299.4 480 192 640 448l0 64-128 0-192 0L0 512l0-64z"]
};
const faChartSimpleHorizontal = {
  prefix: 'fass',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M448 320l0-128L0 192 0 320l448 0zM256 480l0-128L0 352 0 480l256 0zM384 32L0 32 0 160l384 0 0-128z"]
};
const faBluetooth = {
  prefix: 'fass',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M160 0l51.2 38.4 128 96L373.3 160l-34.1 25.6L245.3 256l93.9 70.4L373.3 352l-34.1 25.6-128 96L160 512l0-64 0-128L83.2 377.6 57.6 396.8 19.2 345.6l25.6-19.2L138.7 256 44.8 185.6 19.2 166.4l38.4-51.2 25.6 19.2L160 192l0-128 0-64zm64 320l0 64 42.7-32L224 320zm0-128l42.7-32L224 128l0 64z"]
};
const faArrowsLeftRightToLine = {
  prefix: 'fass',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M64 96l0-32L0 64 0 96 0 416l0 32 64 0 0-32L64 96zm576 0l0-32-64 0 0 32 0 320 0 32 64 0 0-32 0-320zM246.6 182.6L269.3 160 224 114.7l-22.6 22.6-96 96L82.7 256l22.6 22.6 96 96L224 397.3 269.3 352l-22.6-22.6L205.3 288l229.5 0-41.4 41.4L370.7 352 416 397.3l22.6-22.6 96-96L557.3 256l-22.6-22.6-96-96L416 114.7 370.7 160l22.6 22.6L434.7 224l-229.5 0 41.4-41.4z"]
};
const faHandBackPointLeft = {
  prefix: 'fass',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 208l0-80 224 0 13.3 0 2.7 0 80 0 16 0 0-32-16 0-56 0 40-48 68 0c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128l-16 0-48 0-80 0 0-80-32 0 0-80-32 0 0-80L0 208z"]
};
const faMessageDots = {
  prefix: 'fass',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCommentAltDots = faMessageDots;
const faMessaging = faMessageDots;
const faFileHeart = {
  prefix: 'fass',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM80 299.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 432.1l-11.1-10.7L98.2 341.8C86.6 330.7 80 315.3 80 299.2z"]
};
const faBeerMug = {
  prefix: 'fass',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M208 160c-32.5 0-60.5-19.4-73-47.2C123.8 131.5 103.4 144 80 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c23.4 0 43.8 12.5 55 31.2C147.5 19.4 175.5 0 208 0s60.5 19.4 73 47.2C292.2 28.5 312.6 16 336 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-23.4 0-43.8-12.5-55-31.2c-12.5 27.8-40.5 47.2-73 47.2zM32 512l0-348.8C46.1 171.3 62.5 176 80 176c18.8 0 36.2-5.4 51-14.7c20.1 19 47.1 30.7 77 30.7s56.9-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7c19.6 0 37.9-5.9 53.1-16l90.9 0 32 0 0 32 0 176 0 20.8-19 8.4L384 445.7l0 66.3L32 512zM384 375.6l64-28.4L448 224l-64 0 0 151.6zM160 240l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160zm64 0l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160zm64 0l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160z"]
};
const faBeerFoam = faBeerMug;
const faDiceD20 = {
  prefix: 'fass',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M17.9 416.8L240 512l0-66L17.9 416.8zM272 512l222.1-95.2L272 446l0 66zM496 328.4l0-184.9L411.7 194 496 328.4zM484.2 113.2L291.1 1.8 394.7 166.9l89.5-53.7zM220.9 1.8L27.8 113.2l89.5 53.7L220.9 1.8zM16 143.5l0 184.9L100.3 194 16 143.5zM256 6.1L149.4 176l213.2 0L256 6.1zm0 377.6L356.4 208l-200.9 0L256 383.8zM388.2 216.8L276 413.2l217.5-28.6L388.2 216.8zm-264.5 0L18.5 384.6 236 413.2 123.8 216.8z"]
};
const faDrone = {
  prefix: 'fass',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M223 127.2L171.6 88.7C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64c0 27.1 16.9 50.3 40.7 59.6L127.2 223c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2zm-49.6 2.8l39.8 29.9 .1 .1 85.3 0 .1-.1 39.8-29.9L384 96l32 32-34.1 45.4-29.9 39.8-.1 .1 0 85.3 .1 .1 29.9 39.8L416 384l-32 32-45.4-34.1-39.8-29.9-.1-.1-85.3 0-.1 .1-39.8 29.9L128 416 96 384l34.1-45.4 29.9-39.8 .1-.1 0-85.3-.1-.1-29.9-39.8L96 128l32-32 45.4 34.1zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2 .3 15.2 1L88.7 340.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64c27.1 0 50.3-16.9 59.6-40.7L223 384.8c.7 5 1 10.1 1 15.2zm65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112s-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6c0-35.3-28.7-64-64-64c-27.1 0-50.3 16.9-59.6 40.7L289 127.2zM288 400c0-5.2 .3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7c35.3 0 64-28.7 64-64c0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112z"]
};
const faTruckDroplet = {
  prefix: 'fass',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M416 0L0 0 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 240l0 16-128 0 0-96 48 0 2.7 0L544 237.3l0 2.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208 272c-39.8 0-72-29.6-72-66s72-126 72-126s72 89.5 72 126s-32.2 66-72 66z"]
};
const faFileCircleXmark = {
  prefix: 'fass',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z"]
};
const faTemperatureArrowUp = {
  prefix: 'fass',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M113.8 317.8L128 300.1l0-22.7L128 64l96 0 0 213.5 0 22.7 14.2 17.6C249.4 331.5 256 348.9 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-19.1 6.6-36.5 17.8-50.3zM288 0L224 0 128 0 64 0l0 64 0 213.5C44 302.2 32 333.7 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L288 64l0-64zM176 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L192 112l0-16-32 0 0 16 0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160l64 0 0-32L448 32l-96 96 0 32 64 0 0 288 0 32 64 0 0-32 0-288z"]
};
const faTemperatureUp = faTemperatureArrowUp;
const faMedal = {
  prefix: 'fass',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M0 0L144 0l86.4 129.6c-42.2 5.2-80.5 23-111 49.6L0 0zM512 0L392.6 179.1c-30.5-26.6-68.8-44.4-111-49.6L368 0 512 0zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm176-96l-29.7 57.2L160 306.3l48 44.5-11.3 62.8L256 384l59.3 29.7L304 350.8l48-44.5-66.3-9.2L256 240z"]
};
const faPersonFairy = {
  prefix: 'fass',
  iconName: 'person-fairy',
  icon: [640, 512, [], "e608", "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM424 352l-40 0 0 160-128 0 0-160-40 0 8-192 192 0 8 192zM34.9 32c84.9 0 161.1 37.1 213.4 96l-54.9 0L182.6 384l41.4 0 0 63.3C191.7 468 153.2 480 112 480l-16 0-32 0 0-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64 0 32l32 0 2.9 0zm411.8 96l-55 0C444 69.1 520.2 32 605.1 32l2.9 0 32 0 0 32 0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448l0 32-32 0-16 0c-41.2 0-79.7-12-112-32.7l0-63.3 41.4 0L446.7 128z"]
};
const faBed = {
  prefix: 'fass',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M64 32l0 32 0 256 224 0 0-160 0-32 32 0 224 0c53 0 96 43 96 96l0 224 0 32-64 0 0-32 0-32-224 0-32 0L64 416l0 32 0 32L0 480l0-32L0 64 0 32l64 0zm112 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faBookCopy = {
  prefix: 'fass',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M160 96L96 96C43 96 0 139 0 192L0 416c0 53 43 96 96 96l224 0 32 0 32 0 0-64-32 0-32 0-32 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l81.1 0c-10.9-18.8-17.1-40.7-17.1-64l0-224zM320 416l32 0 160 0 32 0 32 0 0-32 0-32-32 0 0-64 32 0 0-256 0-32L544 0 512 0 288 0c-53 0-96 43-96 96l0 224c0 24.6 9.2 47 24.4 64c17.6 19.6 43.1 32 71.6 32l32 0zm-64-96c0-17.7 14.3-32 32-32l96 0 96 0 0 64-96 0-96 0c-17.7 0-32-14.3-32-32z"]
};
const faSquareH = {
  prefix: 'fass',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M448 32L0 32 0 480l448 0 0-448zM336 152l0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24 48 0 0 24 0 80 128 0 0-80 0-24 48 0 0 24z"]
};
const faHSquare = faSquareH;
const faSquareC = {
  prefix: 'fass',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M448 32L0 32 0 480l448 0 0-448zM144 256c0 44.2 35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C310.2 359.8 269.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L292 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80z"]
};
const faClockTwo = {
  prefix: 'fass',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 91.2L338.7 172l20-13.3 26.6 39.9-20 13.3-96 64L232 300.8l0-44.8 0-136 0-24 48 0 0 24z"]
};
const faSquareEllipsisVertical = {
  prefix: 'fass',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M448 32L0 32 0 480l448 0 0-448zM256 192l-64 0 0-64 64 0 0 64zm0 32l0 64-64 0 0-64 64 0zm0 160l-64 0 0-64 64 0 0 64z"]
};
const faCalendarUsers = {
  prefix: 'fass',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M256 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L96 160l0-96 96 0 0-64 64 0zM128 192l384 0 0 1.1c-54.3 7.8-96 54.4-96 110.9c0 31.3 12.9 59.7 33.6 80L424 384 379.2 512l-118.4 0L216 384l-25.6 0c20.7-20.3 33.6-48.7 33.6-80c0-56.4-41.7-103.1-96-110.9l0-1.1zm-16 32a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM224 512L0 512l32-96 160 0 32 96zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM608 416l32 96-224 0 32-96 160 0z"]
};
const faPodcast = {
  prefix: 'fass',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M316 374c50.4-31 84-86.6 84-150c0-97.2-78.8-176-176-176S48 126.8 48 224c0 63.5 33.6 119.1 84 150l8.3 57.8C58 398.6 0 318.1 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 94.1-58 174.6-140.2 207.8L316 374zm3.3-42.1L313 324l-23.7-29.6C308.2 276.9 320 251.8 320 224c0-53-43-96-96-96s-96 43-96 96c0 27.8 11.8 52.9 30.7 70.4L135 324l-6.3 7.9C98.8 305.5 80 267 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 43-18.8 81.5-48.7 107.9zM160 344l32-40 64 0 32 40L264 512l-80 0L160 344zm64-176a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faBee = {
  prefix: 'fass',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M216 1.4l11.3 11.3 26.8 26.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5l26.8-26.8L360 1.4 382.6 24 371.3 35.3 347.8 58.8C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2c0-16.8-2.4-33.1-6.8-48.5c35.2-3.6 54.8-27.9 54.8-47.5c0-21.3-22.9-48-64-48c-34.8 0-56.6 19.2-62.4 38.1c28.6 26.3 46.4 64 46.4 105.9c0 96-144 208-144 208s-144-112-144-208c0-41.9 17.9-79.6 46.4-105.9C184.6 179.2 162.8 160 128 160c-41.1 0-64 26.7-64 48c0 19.6 19.5 43.9 54.8 47.5c-4.4 15.4-6.8 31.7-6.8 48.5c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-20.4 7.6-39 20.2-53.2L204.7 35.3 193.4 24 216 1.4zM248.9 384c4.7 5.8 9.6 11.6 14.7 17.2c8.3 9.2 16.6 17.7 24.4 25.4c7.8-7.6 16.2-16.2 24.4-25.4c5.1-5.6 10-11.4 14.7-17.2l-78.3 0zM368 304l-160 0c0 7.1 2.4 17.8 9.2 32l141.5 0c6.8-14.2 9.2-24.9 9.2-32zm-16-48c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32l128 0z"]
};
const faTemperatureFull = {
  prefix: 'fass',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M112 300.2L97.8 317.8C86.6 331.5 80 348.9 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-19.1-6.6-36.5-17.8-50.3L208 300.2l0-22.7L208 64l-96 0 0 213.5 0 22.7zM208 0l64 0 0 64 0 213.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S16 447.6 16 368c0-34.3 12-65.8 32-90.5L48 64 48 0l64 0 96 0zm0 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 112l0-16 32 0 0 16 0 210.8c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature4 = faTemperatureFull;
const faThermometer4 = faTemperatureFull;
const faThermometerFull = faTemperatureFull;
const faBell = {
  prefix: 'fass',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M256 0L192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0zm32 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
const faCandyBar = {
  prefix: 'fass',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M0 320l128 0 0-96L0 224l0 96zM0 448l128 0 0-96L0 352l0 96zm288 0l0-96-128 0 0 96 128 0zm0-224l-128 0 0 96 128 0 0-96zm0-160L160 64l0 128 128 0 0-128zm352 0L320 64l0 384 320 0 0-384zM33.1 192l94.9 0s0 0 0 0l0-32s0 0 0 0l0-62.9C113.6 111.3 93.8 120 72 120c-6.2 0-12.2-.7-18-2c1.3 5.8 2 11.8 2 18c0 21.8-8.7 41.6-22.9 56z"]
};
const faChocolateBar = faCandyBar;
const faXmarkLarge = {
  prefix: 'fass',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M70.6 57.4L48 34.7 2.7 80l22.6 22.6L178.7 256 25.4 409.4 2.7 432 48 477.3l22.6-22.6L224 301.3 377.4 454.6 400 477.3 445.3 432l-22.6-22.6L269.3 256 422.6 102.6 445.3 80 400 34.7 377.4 57.4 224 210.7 70.6 57.4z"]
};
const faPinata = {
  prefix: 'fass',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M112 318.1l0-64.8 41.8 17.4 6.8 2.8 6.5-3.3L259.8 224l28.2 0 224 0 0 93.2-23.3 9.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3L112 318.1zm0 35.8l8.8 4.4 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 18.1-7.2 0 50.5-24 12-24.8-12.4-7.2-3.6-7.2 3.6-23.7 11.8-16.3-10.8-4-2.7-4.8 0-176 0-4.8 0-4 2.7-16.3 10.8-23.7-11.8-7.2-3.6-7.2 3.6L136 414.1l-24-12 0-48.2zm47.4-115.5L0 172 0 64l176 0 0-64 64 0 0 198.1-80.6 40.3zM112 437.9l16.8 8.4 7.2 3.6 7.2-3.6L168 433.9l24.8 12.4 8.3 4.2 7.7-5.2L224 435.2l0 76.8-112 0 0-74.1zm288-2.7l15.1 10.1 7.7 5.2 8.3-4.2L456 433.9l24.8 12.4 7.2 3.6 7.2-3.6 16.8-8.4 0 74.1-112 0 0-76.8zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faFilePpt = {
  prefix: 'fass',
  iconName: 'file-ppt',
  icon: [512, 512, [], "e64a", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM288 352l16 0 32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16zm32 80l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zM160 352l16 0 32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16zm32 80l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zm224-80l16 0 32 0 32 0 16 0 0 32-16 0-16 0 0 112 0 16-32 0 0-16 0-112-16 0-16 0 0-32z"]
};
const faArrowsFromLine = {
  prefix: 'fass',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M128 96L224 0l96 96 0 32-64 0 0 32 0 32-64 0 0-32 0-32-64 0 0-32zM256 360l0 24 64 0 0 32-96 96-96-96 0-32 64 0 0-24 0-32 64 0 0 32zM32 224l384 0 32 0 0 64-32 0L32 288 0 288l0-64 32 0z"]
};
const faSuperscript = {
  prefix: 'fass',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M384 0l32 0 32 0 32 0 0 32 0 128 32 0 0 64-32 0-64 0-32 0 0-64 32 0 0-96-32 0 0-64zM0 64l32 0 32 0 16.7 0 9.6 13.6L176 200.2 261.8 77.6 271.3 64 288 64l32 0 32 0 0 64-32 0-15.3 0L215.1 256l89.6 128 15.3 0 32 0 0 64-32 0-32 0-16.7 0-9.6-13.6L176 311.8 90.2 434.4 80.7 448 64 448l-32 0L0 448l0-64 32 0 15.3 0 89.6-128L47.3 128 32 128 0 128 0 64z"]
};
const faBowlSpoon = {
  prefix: 'fass',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M0 96C0 43 50.1 0 112 0L224 0l0 64 256 0 32 0 0 64-32 0-256 0 0 64-112 0C50.1 192 0 149 0 96zM0 224l512 0-3.6 61.2C503.5 368.1 454 438.2 384 472.9l0 39.1-256 0 0-39.1C58 438.2 8.5 368.1 3.6 285.2L0 224z"]
};
const faHexagonCheck = {
  prefix: 'fass',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm369-47l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z"]
};
const faPlugCircleXmark = {
  prefix: 'fass',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z"]
};
const faStarOfLife = {
  prefix: 'fass',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M208 0l96 0 0 172.9L453.7 86.4l48 83.1L352 256l149.7 86.4-48 83.1L304 339.1 304 512l-96 0 0-172.9L58.3 425.6l-48-83.1L160 256 10.3 169.6l48-83.1L208 172.9 208 0z"]
};
const faPhoneSlash = {
  prefix: 'fass',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M250.4 279.6L591.5 14.8l19-14.7L639.9 38l-19 14.7L48.4 497.2l-19 14.7L0 474l19-14.7L164.2 346.5C101.5 269.5 63.9 171.1 63.9 64l0-32 144-32 80 144-83.8 67c13 24.6 28.5 47.5 46.3 68.6zm-16.1 136l88.4-69.7c13.4 9.5 27.5 18.1 42.2 25.9l67-83.8 144 80-32 144-32 0c-104.9 0-201.3-36-277.6-96.4z"]
};
const faTrafficLightStop = {
  prefix: 'fass',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM136 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
const faPaintRoller = {
  prefix: 'fass',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M0 0L416 0l0 64 0 64 0 64L0 192 0 0zM256 320l32 0 0 192-128 0 0-192 32 0 0-64 0-32 32 0 224 0 0-64 0-32 0-64 32 0 32 0 0 32 0 160 0 32-32 0-224 0 0 32z"]
};
const faAccentGrave = {
  prefix: 'fass',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M144 0l32 224H112L32 0H144z"]
};
const faHandshakeAngle = {
  prefix: 'fass',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M640 144L496 0 432 64 224 64l0 32 0 32 0 160 80 0 0-112 0-16s0 0 0 0l16 0 96 0 96 0 32 0 0 32 0 48 96-96zM192 128l-96 0 0 144L0 368 144 512l64-64 224 0 0-64 48 0 0-80 32 0 0-112-96 0-80 0 0 112 0 16-16 0-112 0-16 0 0-16 0-176z"]
};
const faHandsHelping = faHandshakeAngle;
const faCircle0 = {
  prefix: 'fass',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
const faDialMedLow = {
  prefix: 'fass',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208L270.8 304.3l17 17 33.9-33.9-17-17L192.8 158.5c62.6-46.2 151.3-41 208 15.7c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0z"]
};
const faLocationDot = {
  prefix: 'fass',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-384a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faMapMarkerAlt = faLocationDot;
const faCrab = {
  prefix: 'fass',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M128 0C57.3 0 0 57.3 0 128l0 64 0 15.4 13.9 6.4 85 39.2c-3.7 6-6.9 12.4-9.6 19l-36.5 0-20-13.3-13.3-8.9L1.8 276.4l13.3 8.9 24 16 4 2.7 4.8 0 33 0c-.7 5.2-1 10.6-1 16l0 9.8-21.1 7L55.4 338l-2.7 2.7-32 32L9.4 384 32 406.6l11.3-11.3L72.6 366l28-9.3 30.7 30.7L90.9 400.8 87.4 402l-2.7 2.7-32 32L41.4 448 64 470.6l11.3-11.3L104.6 430l52-17.3 15.7 15.7-36.6 21.9-7.8 4.7 0 9.1 0 32 0 16 32 0 0-16 0-22.9L201.8 448l108.5 0L352 473.1l0 22.9 0 16 32 0 0-16 0-32 0-9.1-7.8-4.7-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3L448 470.6 470.6 448l-11.3-11.3-32-32-2.7-2.7-3.6-1.2-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3L480 406.6 502.6 384l-11.3-11.3-32-32-2.7-2.7-3.6-1.2-21.1-7 0-9.8c0-5.4-.3-10.8-1-16l33 0 4.8 0 4-2.7 24-16 13.3-8.9-17.8-26.6-13.3 8.9-20 13.3-36.5 0c-2.7-6.6-5.9-13-9.6-19l85-39.2 13.9-6.4 0-15.4 0-64C512 57.3 454.7 0 384 0L320 0l64 64-64 0c0 35.3 28.7 64 64 64l80 0 0 48.6L378.7 216c-16.9-12.2-37-20.3-58.7-23l0-49 0-16-32 0 0 16 0 48-64 0 0-48 0-16-32 0 0 16 0 49c-21.7 2.7-41.7 10.9-58.7 23L48 176.6 48 128l80 0c35.3 0 64-28.7 64-64l-64 0L192 0 128 0z"]
};
const faBoxOpenFull = {
  prefix: 'fass',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M320 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0s128 57.3 128 128c0 1.2 0 2.4 0 3.5L444.6 3.5l86.8 41.1-44.1 93L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6zM576 338.3l0 108.4-256 64-256-64 0-108.4 151.2 43.2 23.6 6.7 12.6-21L320 252.9l68.6 114.3 12.6 21 23.6-6.7L576 338.3zM64 158.7l256 32 256-32 64 128-224 64-96-160-96 160L0 286.7l64-128z"]
};
const faBoxFull = faBoxOpenFull;
const faFile = {
  prefix: 'fass',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM384 128l-128 0L256 0 384 128z"]
};
const faGreaterThan = {
  prefix: 'fass',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M0 64.5l5 2.2 360 160 19 8.4 0 41.6-19 8.4L5 445.2l-5 2.2 0-70L273.2 256 0 134.6l0-70z"]
};
const faQuotes = {
  prefix: 'fass',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M88 0C39.4 0 0 39.4 0 88l0 8 0 72 0 72 144 0 0-144L64 96l0-8c0-13.3 10.7-24 24-24l8 0 32 0 0-64L96 0 88 0zM264 0c-48.6 0-88 39.4-88 88l0 8 0 72 0 72 144 0 0-144-80 0 0-8c0-13.3 10.7-24 24-24l8 0 32 0 0-64L272 0l-8 0zM488 512c48.6 0 88-39.4 88-88l0-8 0-72 0-72-144 0 0 144 80 0 0 8c0 13.3-10.7 24-24 24l-8 0-32 0 0 64 32 0 8 0zm-176 0c48.6 0 88-39.4 88-88l0-8 0-72 0-72-144 0 0 144 80 0 0 8c0 13.3-10.7 24-24 24l-8 0-32 0 0 64 32 0 8 0z"]
};
const faPretzel = {
  prefix: 'fass',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M138.6 32C62.1 32 0 94.1 0 170.6C0 253.3 40.9 326.5 103.7 371L82.5 401l-23 32.7 65.4 46L148 447l28.7-40.8c21.8 6.4 44.9 9.8 68.7 9.8l10.6 0 10.6 0c23.9 0 46.9-3.4 68.7-9.8L364 447l23 32.7 65.4-46-23-32.7-21.1-30C471.1 326.5 512 253.3 512 170.6C512 94.1 449.9 32 373.4 32L364 32c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32l-9.4 0zM216 180l0 7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6l9.4 0c37.6 0 68 30.4 68 68zm40 113.5L285.2 335c-6.1 .7-12.3 1-18.6 1L256 336l-10.6 0c-6.3 0-12.5-.3-18.6-1L256 293.5zm53.7-62.6C300.8 218.2 296 203 296 187.4l0-7.4c0-37.6 30.4-68 68-68l9.4 0c32.4 0 58.6 26.2 58.6 58.6c0 55.7-27.5 105-69.7 134.9l-52.5-74.7z"]
};
const faTRex = {
  prefix: 'fass',
  iconName: 't-rex',
  icon: [640, 512, [], "e629", "M112 288l-32 0L48 192l-16 0-6.3 9.4C9 226.6 0 256.1 0 286.4C0 358 58 416 129.6 416l54.4 0 72 96 128 0 0-16c0-26.5-21.5-48-48-48l-18.6-49.6 41.9-37.7L368 352l0-32c0-35.3-28.7-64-64-64l-16 0-16 0 0-32 16 0 16 0c34.8 0 65.3 18.5 82.1 46.3L432 300.8l0 19.2 0 24 48 0 0-24 0-32 0-12.8L469.3 268l-44.4-29.6L464 208l112 0 21.3-32L552 176l-3.3 0-2.3-2.3L516.7 144 488 144l-8 0 0-16 8 0 32 0 3.3 0 2.3 2.3L555.3 160l52.7 0 24 0 8 0 0-48c0-44.2-35.8-80-80-80l-16 0L528 0 440.3 0 440 0s0 0 0 0c-33.5 .1-63.2 21.6-73.8 53.4L352 96l-32 32-41 0c-70.7 0-132.9 46.3-153.3 114L112 288zM480 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faPersonSwimming = {
  prefix: 'fass',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M312.4 180.9l134.2 115c-7.5 5.1-14.2 9.2-21.9 12.7C411.6 314.7 397 319 384 319s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5L288 272l-18.6 13.4-1.1 .8c-13.9 10-23.6 17-35.5 22.5C219.6 314.7 205 319 192 319c-10.2 0-21.3-2.7-32-6.7l0-56.3 0-13.3 9.4-9.4 128-128 9.4-9.4L320 96l128 0 32 0 0 64-32 0-114.7 0-20.9 20.9zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM272.4 397.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 406.1 31.9 416 0 416l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faSwimmer = faPersonSwimming;
const faArrowDown = {
  prefix: 'fass',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M214.6 454.6L192 477.3l-22.6-22.6-144-144L2.7 288 48 242.8l22.6 22.6L160 354.8 160 64l0-32 64 0 0 32 0 290.7 89.4-89.4L336 242.8 381.3 288l-22.6 22.6-144 144z"]
};
const faUserRobotXmarks = {
  prefix: 'fass',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M240 0l0 16 0 48 128 0 0 256L80 320 80 64l128 0 0-48 0-16 32 0zM16 128l32 0 0 128-32 0 0-128zm384 0l32 0 0 128-32 0 0-128zM240 240l-32 0 0 32 32 0 0-32zM400 352l48 160-96 0 0-96L96 416l0 96L0 512 48 352l352 0zM176 464l0 48-32 0 0-48 0-16 32 0 0 16zm96-224l0 32 32 0 0-32-32 0zm-96 0l-32 0 0 32 32 0 0-32zm64 208l0 16 0 48-32 0 0-48 0-16 32 0zm64 16l0 48-32 0 0-48 0-16 32 0 0 16zM128 111l-17 17 8.5 8.5L143 160l-23.5 23.5L111 192l17 17 8.5-8.5L160 177l23.5 23.5L192 209l17-17-8.5-8.5L177 160l23.5-23.5L209 128l-17-17-8.5 8.5L160 143l-23.5-23.5L128 111zm136.5 8.5L256 111l-17 17 8.5 8.5L271 160l-23.5 23.5L239 192l17 17 8.5-8.5L288 177l23.5 23.5L320 209l17-17-8.5-8.5L305 160l23.5-23.5L337 128l-17-17-8.5 8.5L288 143l-23.5-23.5z"]
};
const faMessageQuote = {
  prefix: 'fass',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM240 112l-112 0 0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40zm144 0l-112 0 0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40z"]
};
const faCommentAltQuote = faMessageQuote;
const faCandyCorn = {
  prefix: 'fass',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M320 128l0-96s32-32 160-32S640 32 640 32l0 96-1 2.2c-7-1.8-15.7-3.9-25.9-5.9c-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-10.2 2-18.8 4.1-25.9 5.9l-1-2.2zm286.9 27.7c7.2 1.4 13.5 2.9 19 4.2L512 416l-64 0L334.2 159.9c5.5-1.3 11.8-2.8 19-4.2c29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7zM446.9 256L480 330.4 513.1 256l-66.2 0zM66.7 400.9L0 334.2s0-44.4 88.9-133.3S222.2 112 222.2 112l66.7 66.7 .9 2.2c-6.2 3.6-13.6 8.2-22.1 13.9c-25.8 17.2-61.3 44.2-101 83.9s-66.7 75.2-83.9 101c-5.7 8.5-10.2 15.9-13.9 22.1l-2.2-.9zm218.4-180c6-4 11.4-7.4 16.1-10.2L400 467.6 355.6 512 98.7 413.2c2.9-4.7 6.3-10.1 10.2-16.1c16.1-24.2 41.9-58.1 80-96.2s72-63.8 96.2-80zM243.7 401.6l74.6 28.7-28.7-74.6-45.9 45.9z"]
};
const faFolderMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1l17 17 33.9-33.9-17-17-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faFolderSearch = faFolderMagnifyingGlass;
const faNotebook = {
  prefix: 'fass',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M64 0l0 104-8 0-32 0L0 104l0 48 24 0 32 0 8 0 0 80-8 0-32 0L0 232l0 48 24 0 32 0 8 0 0 80-8 0-32 0L0 360l0 48 24 0 32 0 8 0 0 104 128 0L192 0 64 0zM480 0L224 0l0 512 256 0L480 0z"]
};
const faCircleWifi = {
  prefix: 'fass',
  iconName: 'circle-wifi',
  icon: [512, 512, [], "e67d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM399.5 256.5C364.4 216.9 313.1 192 256 192s-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144s133.6 30.3 177.5 78.5l-34 34zm-36.1 36.1l-34.4 34.4C313.3 303.5 286.4 288 256 288s-57.3 15.5-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6s82.5 20.6 107.4 52.6zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faDroplet = {
  prefix: 'fass',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 512c106 0 192-86 192-192S192 0 192 0S0 214 0 320S86 512 192 512zM96 336c0 44.2 35.8 80 80 80l16 0 0 32-16 0c-61.9 0-112-50.1-112-112l0-16 32 0 0 16z"]
};
const faTint = faDroplet;
const faBullseyePointer = {
  prefix: 'fass',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 448c106 0 192-86 192-192s-86-192-192-192S64 150 64 256c0 3.9 .1 7.8 .4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9 .2 7.8 .4 11.7 .4zm2.3-48l19.7-67c33.5-9.6 58-40.4 58-76.9c0-44.2-35.8-80-80-80c-36.5 0-67.4 24.5-76.9 58L112 253.7C113.2 175.2 177.2 112 256 112c79.5 0 144 64.5 144 144c0 78.8-63.2 142.8-141.7 144zM0 320l272-80L192 512l-48-96-1.4-1.4-96 96L1.4 465.4l96-96L96 368 0 320z"]
};
const faEraser = {
  prefix: 'fass',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M293.5 416l-5.5 0s0 0 0 0l-101.5 0-80-80L229.3 213.3 362.7 346.7 293.5 416zm90.5 0L514.7 285.3 560 240l-45.3-45.3L381.3 61.3 336 16 290.7 61.3 61.3 290.7 16 336l45.3 45.3L160 480l160 0s0 0 0 0l192 0 32 0 0-64-32 0-128 0z"]
};
const faHexagonImage = {
  prefix: 'fass',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M128 32L0 256 128 480l256 0L512 256 384 32 128 32zm30.3 247.8l17.3-19 17.8 18.6L232.2 320l71.6-86.2 18.5-22.2 18.5 22.2 72.6 87.4L353.5 424.9l-195 0-51.4-89 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faEarthAmericas = {
  prefix: 'fass',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M55.7 199.7L96 240l48 0 48 48 0 64 32 32 0 64 64 0 0-48 64-64 0-80-128 0-32-32 0-32 80 0 0-32-32-32 0-16 32-32 0-31.4c-5.3-.4-10.6-.6-16-.6C160.6 48 80.3 112.2 55.7 199.7zM464 256c0-36.9-9.6-71.5-26.4-101.6L400 192l0 80 63.4 0c.4-5.3 .6-10.6 .6-16zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faEarth = faEarthAmericas;
const faEarthAmerica = faEarthAmericas;
const faGlobeAmericas = faEarthAmericas;
const faFileSvg = {
  prefix: 'fass',
  iconName: 'file-svg',
  icon: [512, 512, [], "e64b", "M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM205.7 352l26.3 0 16 0 0 32-16 0-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L176 512l-16 0 0-32 16 0 34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM320 368l0 35c0 17.3 3.1 34.4 9.2 50.6l6.8 18.2 6.8-18.2c6.1-16.2 9.2-33.3 9.2-50.6l0-35 0-16 32 0 0 16 0 35c0 21.1-3.8 42-11.2 61.8L359 501.6 355.1 512 344 512l-16 0-11.1 0L313 501.6l-13.8-36.8C291.8 445 288 424.1 288 403l0-35 0-16 32 0 0 16zm96 24c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 16-32 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8-16 0 0-32 16 0 16 0 16 0 0 16 0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z"]
};
const faCrateApple = {
  prefix: 'fass',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9C160 24.6 184.6 0 214.9 0L224 0l0 9.1C224 39.4 199.4 64 169.1 64L160 64l0-9.1zm192 0C352 24.6 376.6 0 406.9 0L416 0l0 9.1C416 39.4 391.4 64 361.1 64L352 64l0-9.1zM96 80c27.4 0 64 18.3 64 18.3s36.6-18.3 64-18.3c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6L33.2 192c-.8-6.7-1.2-13.5-1.2-20.6C32 127.8 52.4 80 96 80zm384 91.4c0 7-.4 13.9-1.2 20.6L319 192c.7-6.7 1-13.6 1-20.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7C317.7 81.2 352 98.3 352 98.3s36.6-18.3 64-18.3c43.6 0 64 47.8 64 91.4zM0 224l512 0 0 128L0 352 0 224zM0 384l512 0 0 128L0 512 0 384zm80-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faAppleCrate = faCrateApple;
const faPersonBurst = {
  prefix: 'fass',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M176 0L133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2 100 236.6l-.4 98L176 273.2l76.4 61.4-.4-98L312.8 223l15-23.5-57.1-45.1 42.9-88.1L218.2 88.5 176 0zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L402 142.8l-81.7 128 53.9 34.4 33.8-53L408 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L558 142.8 548.6 128l-17.5 0-102.2 0z"]
};
const faGameBoard = {
  prefix: 'fass',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M0 32H448V480H0V32zM144 96v80h80V96H144zm0 160V176H64v80h80zm80 0H144v80H64v80h80V336h80v80h80V336h80V256H304V176h80V96H304v80H224v80zm0 0h80v80H224V256z"]
};
const faHatChef = {
  prefix: 'fass',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M153.5 51.3C176.9 20.2 214.1 0 256 0s79.1 20.2 102.5 51.3C374.6 39.2 394.7 32 416.4 32C469 32 512 74.6 512 127.2c0 11.1-1.9 22.1-5.7 32.5L448 320l-74.2 0 26-149.3 2.7-15.8L371 149.5l-2.7 15.8L341.3 320 272 320l0-160 0-16-32 0 0 16 0 160-69.3 0L143.8 165.3 141 149.5 109.5 155l2.7 15.8 26 149.3L64 320 5.7 159.8C1.9 149.3 0 138.3 0 127.2C0 74.6 43 32 95.6 32c21.7 0 41.7 7.2 57.9 19.3zM448 352l0 160L64 512l0-160 384 0z"]
};
const faHandBackPointRight = {
  prefix: 'fass',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 208l0-80-224 0-13.3 0-2.7 0-80 0-16 0 0-32 16 0 56 0L208 48l-68 0c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l16 0 48 0 80 0 0-80 32 0 0-80 32 0 0-80 176 0z"]
};
const faDove = {
  prefix: 'fass',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M210.3 138.7c-18-11-34.6-24.4-48.4-40.9c22.8-50.1 59.9-82 75-95c1.2-1.1 2.3-2 3.2-2.8c-3.6 55.7 17.7 103.1 48 140.7l0 29.6c-24-5.8-51.9-15.8-77.7-31.6zM320 174.5l0-30.5c0-44.2 35.8-80 80-80l112 0-32 56 0 168c0 88.4-71.6 160-160 160l-83.2 0L160 512 80 496 0 432l153.8-51.3C117.2 360.4 32 296.6 32 176C32 111.5 69.6 65.1 87.9 42.4c3.5-4.4 6.3-7.8 8.1-10.4c25.6 128 160 170.7 224 176l0-32.1s0 0 0 0l0-1.4s0 0 0 0zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faSnowflakeDroplets = {
  prefix: 'fass',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M352 32l0-32L288 0l0 32 0 30.1-8.6-8.6-17-17L228.5 70.4l17 17L288 129.9l0 70.6-61.2-35.3-15.6-58.2L205 83.9 158.7 96.3l6.2 23.2 3.2 11.8-12.2-7-27.7-16-32 55.4 27.7 16 12.2 7-11.8 3.2-23.2 6.2 12.4 46.4 23.2-6.2 58.2-15.6L256 256l-61.2 35.3-58.2-15.6-23.2-6.2-11.3 42.3 2.6 5.1 19.5 5.2 11.8 3.2-12.2 7-8.6 5 29.3 57 11.3-6.5 12.2-7-3.2 11.8-6.2 23.2L205 428.1l6.2-23.2 15.6-58.2L288 311.4l0 70.6-42.6 42.6-17 17 33.9 33.9 17-17 8.6-8.6 0 30.1 0 32 64 0 0-32 0-30.1 8.6 8.6 17 17 33.9-33.9-17-17L352 382.1l0-70.6 61.2 35.3 15.6 58.2 6.2 23.2 46.4-12.4-6.2-23.2L472 380.7l12.2 7 11.3 6.5 29.3-57-8.6-5-12.2-7 11.8-3.2 19.5-5.2 2.6-5.1-11.3-42.3-23.2 6.2-58.2 15.6L384 256l61.2-35.3 58.2 15.6 23.2 6.2 12.4-46.4-23.2-6.2L504 186.7l12.2-7 27.7-16-32-55.4-27.7 16-12.2 7 3.2-11.8 6.2-23.2L435 83.9l-6.2 23.2-15.6 58.2L352 200.6l0-70.6 42.6-42.6 17-17L377.6 36.5l-17 17L352 62.1 352 32zM520.3 417.4c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L576 320l-55.7 97.4zM64 320L8.3 417.4C2.9 427 0 437.8 0 448.8C0 483.7 28.3 512 63.2 512l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L64 320z"]
};
const faBatteryEmpty = {
  prefix: 'fass',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M64 160l0 192 416 0 0-192L64 160zM0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96z"]
};
const faBattery0 = faBatteryEmpty;
const faGrid4 = {
  prefix: 'fass',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M0 32l89.6 0 0 89.6L0 121.6 0 32zM0 151.5l89.6 0 0 89.6L0 241.1l0-89.6zM89.6 270.9l0 89.6L0 360.5l0-89.6 89.6 0zM0 390.4l89.6 0 0 89.6L0 480l0-89.6zM119.5 32l89.6 0 0 89.6-89.6 0 0-89.6zm0 119.5l89.6 0 0 89.6-89.6 0 0-89.6zm89.6 119.5l0 89.6-89.6 0 0-89.6 89.6 0zM119.5 390.4l89.6 0 0 89.6-89.6 0 0-89.6zM328.5 32l0 89.6-89.6 0 0-89.6 89.6 0zm0 119.5l0 89.6-89.6 0 0-89.6 89.6 0zM238.9 270.9l89.6 0 0 89.6-89.6 0 0-89.6zm89.6 119.5l0 89.6-89.6 0 0-89.6 89.6 0zM358.4 32L448 32l0 89.6-89.6 0 0-89.6zm0 119.5l89.6 0 0 89.6-89.6 0 0-89.6zM448 270.9l0 89.6-89.6 0 0-89.6 89.6 0zM358.4 390.4l89.6 0 0 89.6-89.6 0 0-89.6z"]
};
const faSocks = {
  prefix: 'fass',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M288 0l0 64L128 64l0-64L288 0zm0 96l0 160-76.8 57.6C179 337.8 160 375.7 160 416c0 21.9 5.5 42.6 15.2 60.6l-21.6 16.2C137 505.3 116.8 512 96 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8L128 272l0-176 160 0zm32 0l192 0 0 272L345.6 492.8C329 505.3 308.8 512 288 512c-53 0-96-43-96-96c0-30.2 14.2-58.7 38.4-76.8L320 272l0-176zM512 64L320 64l0-64L512 0l0 64z"]
};
const faFaceSunglasses = {
  prefix: 'fass',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 512c141.4 0 256-114.6 256-256c0-31.8-5.8-62.2-16.4-90.3l.4-1.3 0-4.5 0-32 0-32-32 0-8.1 0C408.9 37.5 336.8 0 256 0S103.1 37.5 56.1 96L48 96 16 96l0 32 0 32 0 4.5 .4 1.3C5.8 193.8 0 224.2 0 256C0 397.4 114.6 512 256 512zM208 272L80 272 48 160l0-32 192 0 0 16 32 0 0-16 192 0 0 32L432 272l-128 0-27.4-96-41.1 0L208 272zm-78.3 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 368.3 327.6 416 256 416s-113.7-47.7-126.3-72.8z"]
};
const faInbox = {
  prefix: 'fass',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M96 32L71 32 65 56.2 1 312.2l-1 3.8L0 320 0 448l0 32 32 0 448 0 32 0 0-32 0-128 0-3.9-1-3.8-64-256L441 32l-25 0L96 32zM73 288L121 96l270 0 48 192-71 0-32 64-160 0-32-64-71 0z"]
};
const faSquare0 = {
  prefix: 'fass',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M448 32L0 32 0 480l448 0 0-448zM224 128c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
const faSection = {
  prefix: 'fass',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M86 70.6C73.7 76.2 67.1 84.4 64.9 96c-.9 9.2 .6 14.8 2.3 18.5c1.9 4 5.3 8.1 11.4 12.4c13.7 9.8 34.1 16.4 61.5 25l1.4 .5s0 0 0 0c24.1 7.6 54.9 17.3 77.7 35c12.4 9.6 23.5 22.2 30.2 39c6.7 16.8 8.1 35.3 4.8 55.1c-4.1 24.9-16.1 44.3-32.7 58.2c11.2 8.8 21.2 20.2 27.6 35.2c7 16.5 8.4 34.6 5 53.9c-6 35-29.2 58.9-58.5 71.4c-28.3 12.1-62.7 14.1-97.2 8.7l-.2 0s0 0 0 0c-18.8-3.1-48.7-13.3-67.3-19.6c-3.5-1.2-6.7-2.3-9.2-3.1L-8.5 476.2l20.2-60.7 30.4 10.1c3.8 1.3 8 2.7 12.3 4.2c0 0 0 0 0 0c19 6.5 41.4 14.1 54.1 16.2c26.6 4.1 48 1.6 62-4.4c13-5.6 18.9-13.4 20.7-23.5c1.6-9.5 .4-14.9-.9-18.1c-1.4-3.3-4.1-6.9-9.5-10.9c-12.5-9.2-32.2-15.6-59.4-23.8l-3.7-1.1c-23.5-7-53-15.8-75.4-31c-12.5-8.5-24.4-19.9-32.3-35.5c-8-15.9-10.7-33.7-8.4-53c.1-.6 .1-1.1 .2-1.7c4.8-27.7 20.4-48.8 41.7-62.5c-.7-.5-1.3-.9-2-1.4c-12.6-9-24.3-20.9-32-36.9C1.8 126-.8 107.8 1.4 88.1c.1-.5 .1-1.1 .2-1.6c5.8-35.5 28.2-60.7 58-74.1C88.3-.6 123-2.7 157.7 3c9.9 1.6 39.8 7.7 50.9 10.8l30.8 8.7L222.1 84.1l-30.8-8.7c-8-2.2-35.3-7.9-44.1-9.3c-26.4-4.4-47.5-1.7-61.2 4.5zm73.2 155.9l-24.6-2c-23.1-1.9-41 1.5-52.5 7.4c-10.3 5.2-15.5 12.1-17.3 21.2c-.8 8.1 .5 12.7 2.1 15.7c1.7 3.3 4.9 7.1 11 11.3c13.8 9.3 34.3 15.6 61.7 23.8l1.4 .4c.7 .2 1.5 .4 2.2 .7l15.5-3.9c20.8-5.2 30.1-15.9 32.4-30c1.7-10.6 .5-16.9-1.1-20.9c-1.6-4-4.5-8-10-12.2c-5.5-4.3-12.5-8-20.9-11.6z"]
};
const faSquareThisWayUp = {
  prefix: 'fass',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M448 32L0 32 0 480l448 0 0-448zM160 320l-64 0 0-128-40 0 0-24 72-72 72 72 0 24-40 0 0 128zM64 384l320 0 0 32L64 416l0-32zM248 192l0-24 72-72 72 72 0 24-40 0 0 128-64 0 0-128-40 0z"]
};
const faBoxUp = faSquareThisWayUp;
const faGaugeHigh = {
  prefix: 'fass',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7l9.7-22-43.9-19.3-9.7 22L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAlt = faGaugeHigh;
const faTachometerAltFast = faGaugeHigh;
const faSquareAmpersand = {
  prefix: 'fass',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M448 32L0 32 0 480l448 0 0-448zM136 128l24 0 96 0 24 0 0 24 0 35.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9-10.8 15.6L252.6 384 240 384l-16 0-88 0-24 0 0-24 0-39.7c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-36.7 0-24zm66.4 89.6l23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0 0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2zm-5.6 63.6l-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4l0 15.7 67.4 0 9.2-13.3-39.8-41.5z"]
};
const faEnvelopeOpenText = {
  prefix: 'fass',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M512 448l0 64-64 0L64 512 0 512l0-64L0 244.8l4.1 2.9L246.7 421l9.3 6.6 9.3-6.6L507.9 247.7l4.1-2.9L512 448zm0-256l0 13.5-22.7 16.2L416 274.1l0-74.1 0-56 0-24 0-24-32 0-16 0-90.7 0-42.7 0L144 96l-16 0L96 96l0 24 0 24 0 56 0 74.1L22.7 221.7 0 205.5 0 192l48-36 0-60 0-48 48 0 96 0L256 0l64 48 96 0 48 0 0 48 0 60 48 36zM176 160l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faLampDesk = {
  prefix: 'fass',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M257.9 0C221.5 0 192 29.5 192 65.9c0 17.5 6.9 34.3 19.3 46.6l3.8 3.8L104.7 234.1 92.7 246.8 97 263.8 143 448 32 448 0 448l0 64 32 0 151.3 0c.5 0 .9 0 1.4 0L352 512l32 0 0-64-32 0-143 0L163.3 265.2 256 166.3 256 272l48 48 80-80 48-48 80-80L464 64 349.3 64 304.6 19.3C292.2 6.9 275.4 0 257.9 0zM480 240c0-14-6-26.5-15.5-35.3l-67.8 67.8C405.5 282 418 288 432 288c26.5 0 48-21.5 48-48z"]
};
const faHospital = {
  prefix: 'fass',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M192 0L448 0l0 512-80 0 0-128-96 0 0 128-80 0L192 0zM160 96l0 416L0 512 0 320l80 0 16 0 0-32-16 0L0 288l0-64 80 0 16 0 0-32-16 0L0 192 0 96l160 0zm320 0l160 0 0 96-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 192-160 0 0-416zM344 64l-48 0 0 40-40 0 0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-40z"]
};
const faHospitalAlt = faHospital;
const faHospitalWide = faHospital;
const faPollPeople = {
  prefix: 'fass',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM576 96l0 32-96 0 0-32 96 0zM288 32l-64 0 0 64 0 32 0 64 64 0 288 0 64 0 0-64 0-32 0-64-64 0L288 32zM576 384l0 32-224 0 0-32 224 0zM288 320l-64 0 0 64 0 32 0 64 64 0 288 0 64 0 0-64 0-32 0-64-64 0-288 0zM160 224l-32-96-96 0L0 224l160 0zM128 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 176l-32-96-96 0L0 512l160 0z"]
};
const faWhiskeyGlassIce = {
  prefix: 'fass',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M438.2 96L412.1 278.8l18.5 18.5L453.3 320l-22.6 22.6-88 88L320 453.3l-22.6-22.6L234.7 368l-32 0L128 368l-32 0 0-32 0-84.5L73.8 96l364.4 0zM64 480l384 0L502.9 96 512 32l-64.6 0L64.6 32 0 32 9.1 96 64 480zM256 250.7l0-42.7-128 0 0 128 74.7 0-16-16 22.6-22.6L256 250.7zM232 320l88 88 88-88-88-88-88 88z"]
};
const faGlassWhiskeyRocks = faWhiskeyGlassIce;
const faWineBottle = {
  prefix: 'fass',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M453 23.8L430.4 1.1 385.1 46.4l11.9 11.9-9.4 9.4-61.8 61.8c-47.3-23.6-106.2-15.7-145.7 23.7L0 333.5 178.5 512 358.7 331.8c39.4-39.4 47.3-98.4 23.7-145.7l61.8-61.8 9.4-9.4 11.9 11.9 45.3-45.3L488.2 59 453 23.8zM112 312L232 192l88 88L200 400l-88-88z"]
};
const faChessRook = {
  prefix: 'fass',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M32 208L32 32l96 0 0 64 48 0 0-64 96 0 0 64 48 0 0-64 96 0 0 176-64 48 16 144L80 400 96 256 32 208zm160 16l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM16 512l0-32 48-48 320 0 48 48 0 32L16 512z"]
};
const faUserBountyHunter = {
  prefix: 'fass',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72L323 120zm5.5 36.4L248 171.5l0 95.9 9.9-1.7c8.4-48.3 43-79.4 71.5-95.4l-.9-13.8zm-209 0l-.9 13.8c28.5 16 63.1 47.1 71.5 95.4l9.9 1.7 0-95.9-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2l8.3 128.2 1.4 21.4-21.2 3.7-136 24c-2.8 .5-5.6 .5-8.3 0l-136-24-21.2-3.7L64 271.2 64 256 64 16 64 0 80 0 96 0l16 0 0 32L96 32l0 38zM48 352l352 0 48 160L0 512 48 352zM160 464l128 0-64-48-64 48z"]
};
const faBarsStaggered = {
  prefix: 'fass',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 64l448 0 0 64L0 128 0 64zM64 224l448 0 0 64L64 288l0-64zM448 384l0 64L0 448l0-64 448 0z"]
};
const faReorder = faBarsStaggered;
const faStream = faBarsStaggered;
const faDiagramSankey = {
  prefix: 'fass',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M304 32l16 0 224 0 32 0 0 64-32 0L336 96 249.6 211.2 240 224l-16 0L32 224 0 224l0-64 32 0 176 0L294.4 44.8 304 32zM141.9 320L32 320 0 320l0-64 32 0 512 0 32 0 0 64-32 0-327.5 0 57.6 96L544 416l32 0 0 64-32 0-288 0-18.1 0-9.3-15.5L141.9 320z"]
};
const faCloudHailMixed = {
  prefix: 'fass',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm8 32L75.2 416l-56 0L48 352l56 0zm120 0L152 512l-56 0 72-160 56 0zm56 0l56 0-28.8 64-56 0L280 352zm176 0L384 512l-56 0 72-160 56 0zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleUpLeft = {
  prefix: 'fass',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 320l0-160 160 0 24 24-52 52 76 76-56 56-76-76-52 52-24-24z"]
};
const faDharmachakra = {
  prefix: 'fass',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M236.5 162l-4.9-64.1c-25.9 4-49.8 14.2-70 29l41.9 48.8c9.9-6.5 21.1-11.2 33.1-13.7zM288 0l-2.6 33.9c39.9 5.2 76.4 20.9 106.9 44.3l22.1-25.8 45.3 45.3-25.8 22.1c23.3 30.4 39 67 44.3 106.9L512 224l0 64-33.9-2.6c-5.2 39.9-20.9 76.4-44.3 106.9l25.8 22.1-45.3 45.3-22.1-25.8c-30.4 23.3-67 39-106.9 44.3L288 512l-64 0 2.6-33.9c-39.9-5.2-76.4-20.9-106.9-44.3L97.6 459.6 52.4 414.4l25.8-22.1c-23.3-30.4-39.1-67-44.3-106.9L0 288l0-64 33.9 2.6c5.2-39.9 20.9-76.4 44.3-106.9L52.4 97.6 97.6 52.4l22.1 25.8c30.4-23.3 67-39.1 106.9-44.3L224 0l64 0zM275.5 162c12 2.5 23.2 7.2 33.1 13.7l41.9-48.8c-20.2-14.8-44.1-25-70-29L275.5 162zm60.7 41.4c6.5 9.9 11.2 21.1 13.7 33.1l64.1-4.9c-4-25.9-14.2-49.8-29-70l-48.8 41.9zM350 275.5c-2.5 12-7.2 23.2-13.7 33.1l48.8 41.9c14.8-20.2 25-44.1 29-70L350 275.5zm-41.4 60.7c-9.9 6.5-21.1 11.2-33.1 13.7l4.9 64.1c25.9-4 49.8-14.2 70-29l-41.9-48.8zM236.5 350c-12-2.5-23.2-7.2-33.1-13.7l-41.9 48.8c20.2 14.8 44.1 25 70 29l4.9-64.1zm-60.7-41.4c-6.5-9.9-11.2-21.1-13.7-33.1l-64.1 4.9c4 25.9 14.2 49.8 29 70l48.8-41.9zM162 236.5c2.5-12 7.2-23.2 13.7-33.1l-48.8-41.9c-14.8 20.2-25 44.1-29 70l64.1 4.9zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faObjectsAlignLeft = {
  prefix: 'fass',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 512l48 0L48 0 0 0 0 512zM128 64l0 160 384 0 0-160L128 64zm0 224l0 160 256 0 0-160-256 0z"]
};
const faOilCanDrip = {
  prefix: 'fass',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 128l-64 0 0 32 96 0 64 32 160-32 32 32L432 416l-48 0L96 416l0-69.3L0 304l0-96 0-48 48 0 48 0 48 0 80 0 0-32-64 0 0-64 192 0 0 64zM48 208l0 64.8 48 21.3L96 208l-48 0zM592 448c-26.5 0-48-21.5-48-48c0-32 48-96 48-96s48 64 48 96s-21.5 48-48 48z"]
};
const faFaceSmilingHands = {
  prefix: 'fass',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M320 512c-32.1 0-62.8-5.9-91.1-16.7c17-21.6 27.1-48.9 27.1-78.5l0-30.8c18.1 8.4 39.4 14 64 14s45.9-5.6 64-14l0 30.8c0 29.6 10.1 56.9 27.1 78.5c-28.3 10.8-59 16.7-91.1 16.7zM320 0C460.1 0 573.9 112.5 576 252.1l-1.3-1.3L552 228.1l-22.6 22.6-51.7 51.7-21.7 0-40 0-32 0 0 32 0 15.2c-16.8 10.6-38.1 18.4-64 18.4s-47.2-7.7-64-18.4l0-15.2 0-32-32 0-40 0-21.7 0-51.7-51.7L88 228.1 65.4 250.7 64 252.1C66.1 112.5 179.9 0 320 0zM240 152c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80zm104 80s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80zM76.7 307.3L65.4 296 88 273.4l11.3 11.3L184 369.4l0-15 0-20 40 0 0 20 0 29.6 0 20 0 12.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L12.7 435.3 1.4 424 24 401.4l11.3 11.3 24 24 9.4-9.4-56-56L1.4 360 24 337.4l11.3 11.3 56 56 9.4-9.4-72-72L17.4 312 40 289.4l11.3 11.3 72 72 9.4-9.4-56-56zm486.6 0l-56 56 9.4 9.4 72-72L600 289.4 622.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L616 337.4 638.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L616 401.4 638.6 424l-11.3 11.3-48.8 48.8C560.7 502 536.4 512 511.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L552 273.4 574.6 296l-11.3 11.3z"]
};
const faBroccoli = {
  prefix: 'fass',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M0 352l96 0 320 0 96 0 0-96c0-45.5-31.6-83.6-74.1-93.5c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64c-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256l0 96zM200 512l112 0c18.4-55.3 44.9-100.1 63.9-128L280 384l-24 48-24-48-95.9 0c19.1 27.9 45.5 72.7 63.9 128z"]
};
const faRouteInterstate = {
  prefix: 'fass',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M273 12.9L256 2.3 239 12.9c-29.7 18.6-53.7 28.5-78.3 32.6c-24.8 4.1-52.6 2.8-90.5-4.8L37.5 34.1 32.4 67.1C16.2 172.4 15 260.3 46.8 333.1c32.6 74.4 96.8 127.1 196.9 168.5l12.9 5.4 12.7-5.9c97.3-44.9 161.1-97.3 194.1-170.4c32.5-71.9 32.3-158 16.1-263.6l-5.1-33.1-32.8 6.6c-37.9 7.6-65.7 8.9-90.5 4.8c-24.6-4.1-48.6-14-78.3-32.6zM85.2 192l341.1 0c-.3 44.7-7 81.2-21.1 112.3c-22.9 50.7-67.7 92.7-149.9 132.6c-83.2-36.6-127.5-78.3-149.9-129.5c-14-31.9-20.4-69.6-20.2-115.4z"]
};
const faEarMuffs = {
  prefix: 'fass',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M96 0l32 0L512 0l32 0 0 32 0 176c-13.4-10-30-16-48-16c-5.5 0-10.8 .6-16 1.6L480 64 160 64l0 129.6c-5.2-1-10.5-1.6-16-1.6c-18 0-34.6 6-48 16L96 32 96 0zm83.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z"]
};
const faHotdog = {
  prefix: 'fass',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M207.2 463.2l256-256L512 256 256 512l-48.8-48.8zM0 256L256 0l48.8 48.8-256 256L0 256zM488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zm-35.4 88.5L439.9 82.8l-14.6 6.6-88 40-5.5 2.5-2.5 5.5-37.5 82.5-82.5 37.5-5.5 2.5-2.5 5.5-37.5 82.5L81.4 385.4l-14.6 6.6 13.2 29.1 14.6-6.6 88-40 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5 14.6-6.6z"]
};
const faTransporterEmpty = {
  prefix: 'fass',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M96 448H416v64H96V448z"]
};
const faPersonWalkingWithCane = {
  prefix: 'fass',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-48 32l-19.8 0-8.8 17.7-64 128L21.1 302.3l57.2 28.6 14.3-28.6L128 231.6l0 43.2c0 17 6.7 33.3 18.7 45.3L224 397.3l0 82.7 0 32 64 0 0-32 0-96 0-13.3-9.4-9.4L224 306.7l0-18.7 0-74.7 70.4 93.9 19.2 25.6 51.2-38.4-19.2-25.6-96-128L240 128l-16 0-96 0zm-7 248.2l-12 48-6 24-6 24-6 24L87 512l66 0 .1-.2 6-24 6-24 6-24 10-40.2-52.8-52.8L121 376.2zM446.5 498.8l9.1 13.2 26.3-18.2-9.1-13.2L360.2 317.9l-25.6 19.2 112 161.7z"]
};
const faBlind = faPersonWalkingWithCane;
const faAngle90 = {
  prefix: 'fass',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 384 0 32 0 0-64-32 0L64 416 64 64zM96 97.6l0 48.3c36.9 4.3 71.6 16 102.4 33.6l27.4-39.6C187 117.1 143 102.2 96 97.6zm129.3 99.4c29.4 21.6 54.2 49.1 72.9 80.5l41.7-23.8c-22.2-37.7-52-70.5-87.2-96.2l-27.3 39.5zM334.1 384l48.3 0c-3.6-36.1-13.2-70.4-27.7-102L312.8 306c10.8 24.3 18.1 50.6 21.3 78z"]
};
const faRectangleTerminal = {
  prefix: 'fass',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M0 32l512 0 0 448L0 480 0 32zM94.1 176l17 17 63 63-63 63-17 17L128 369.9l17-17 80-80 17-17-17-17-80-80-17-17L94.1 176zM248 336l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faKite = {
  prefix: 'fass',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M344 0L318.6 0l-5.8 24.8-80 344-1.4 5.8L142.1 464 120 464l0-107.3-24-10-24 10L72 488l0 24 24 0 56 0 9.9 0 7-7 96.4-96.4 5.8-1.4 344-80 24.8-5.8 0-25.4 0-264 0-32L608 0 344 0zM24 128L0 128l0 48 24 0 48 0 0 110L0 256l0 96 72-30 24-10 24 10 72 30 0-96-72 30 0-134 0-24-24 0-72 0zM427.3 84.7L480 137.4l52.7-52.7L544 73.4 566.6 96l-11.3 11.3L502.6 160l52.7 52.7L566.6 224 544 246.6l-11.3-11.3L480 182.6 363.3 299.3 352 310.6 329.4 288l11.3-11.3L457.4 160l-52.7-52.7L393.4 96 416 73.4l11.3 11.3z"]
};
const faDrum = {
  prefix: 'fass',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M505.1 79.5L484.8 92.3l-47.4 29.8c46.1 18 74.6 46 74.6 85.9l0 32 0 128c0 31.3-27.4 58.8-72 78.7L440 328l0-9.3c-14.3 6.4-30.5 12-48 16.7l0 128c-33 8.9-71.1 14.5-112 16.1l0-128c-7.9 .3-15.9 .5-24 .5s-16.1-.2-24-.5l0 128c-40.9-1.6-79-7.2-112-16.1l0-128c-17.5-4.7-33.7-10.3-48-16.7l0 9.3 0 118.7C27.4 426.8 0 399.3 0 368L0 240l0-32C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2l85-53.5 20.3-12.8 25.6 40.6zM243.2 187.7l66.6-41.9c-17-1.2-35-1.8-53.8-1.8c-68.2 0-125.4 7.9-163.6 22.7C53.6 181.8 48 197.4 48 208c0 .8 2.7 17.2 46 35.9c38.9 16.8 96 28.1 162 28.1s123.1-11.3 162-28.1c43.3-18.7 46-35.1 46-35.9c0-10.6-5.6-26.2-44.4-41.3c-10.6-4.1-22.7-7.7-36-10.7L268.8 228.3l-20.3 12.8-25.6-40.6 20.3-12.8z"]
};
const faScrubber = {
  prefix: 'fass',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faIceCream = {
  prefix: 'fass',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48l0 48 101.5 0 181 0L416 256l0-48c0-26.5-21.5-48-48-48l-.9 0zM96 288L224 512 352 288 96 288z"]
};
const faHeartCircleBolt = {
  prefix: 'fass',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4C483.4 197.8 458.4 192 432 192c-97.2 0-176 78.8-176 176c0 32.2 8.6 62.3 23.7 88.3L256 480 64 288zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24 64L352 384l66.7 0L408 448l104-96-66.7 0L456 288z"]
};
const faFishBones = {
  prefix: 'fass',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M32 96L0 128 64 256 0 384l32 32 64-64 0-48 0-24 40 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 40 0 0 120 32 0L576 256 448 112l-32 0 0 120-40 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72 0-24-48 0 0 24 0 72-40 0 0-24 0-48L32 96z"]
};
const faDeerRudolph = {
  prefix: 'fass',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M256 16l0-16L224 0l0 16 0 24c0 30.9 25.1 56 56 56l16 0 24 0-64 16 0 32 56 0-9.6 32L224 176l-96 0-14.1 0-7.9 0C51.7 176 6.6 217.8 2.4 272L.1 302.2l-1.8 23.9 47.9 3.7 1.8-23.3c2.4 3.3 5.2 6.5 8.1 9.5L72.1 332 46.1 358.1 24.7 379.4 34.7 408 71.5 512l101.8 0L135.3 404.6l26.6-26.6L176 363.9l0-19.9 0-3.4L240 368l48 0 0 144 96 0 0-144 0-64 26.7-80 5.3 0 96 0 0-48.8c2.6 .5 5.3 .8 8 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7L443.4 91.4c-.6-.6-1.1-1.1-1.7-1.6C459.7 80.4 472 61.7 472 40l0-24 0-16L440 0l0 16 0 24c0 13.3-10.7 24-24 24l-38.8 0-30.6 0c3.5-7.3 5.4-15.4 5.4-24l0-24 0-16L320 0l0 16 0 24c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24zM384 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faFax = {
  prefix: 'fass',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M128 0l0 32 0 128 64 0 0-96 194.7 0L416 93.3l0 66.7 64 0 0-80 0-13.3-9.4-9.4-48-48L413.3 0 400 0 160 0 128 0zM0 128L0 512l96 0 0-384L0 128zm512 64l-384 0 0 320 384 0 0-320zM288 256l0 64-64 0 0-64 64 0zM224 384l64 0 0 64-64 0 0-64zM416 256l0 64-64 0 0-64 64 0zM352 384l64 0 0 64-64 0 0-64z"]
};
const faParagraph = {
  prefix: 'fass',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M192 32l64 0 160 0 32 0 0 64-32 0-32 0 0 352 0 32-64 0 0-32 0-352-32 0 0 352 0 32-64 0 0-32 0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
};
const faHeadSideHeart = {
  prefix: 'fass',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zm112-37c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 320.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z"]
};
const faSquareE = {
  prefix: 'fass',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M448 32L0 32 0 480l448 0 0-448zM152 128l144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24 24 0z"]
};
const faMeterFire = {
  prefix: 'fass',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 512c33.5 0 65.5-6.4 94.8-18.1c-38.6-35.1-62.8-85.7-62.8-142c0-49.2 20.9-93.1 46.1-127.8L320 224l0-32 0-32 0-32 64 0 0 32 0 8.8c17.1-15.5 33.7-27.8 47-36.1l21.6-13.5L493.4 160C455.4 66.2 363.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm160 0c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
const faCloudHail = {
  prefix: 'fass',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm0 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faCheckToSlot = {
  prefix: 'fass',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M96 32l384 0 0 352L96 384 96 32zM425.9 144L392 110.1l-17 17-111 111-47-47-17-17L166.1 208l17 17 64 64 17 17 17-17L409 161l17-17zM0 288l64 0 0 128 448 0 0-128 64 0 0 192L0 480 0 288z"]
};
const faVoteYea = faCheckToSlot;
const faMoneyFromBracket = {
  prefix: 'fass',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M32 0L608 0l32 0 0 32 0 128 0 32-64 0 0-32 0-96L64 64l0 96 0 32L0 192l0-32L0 32 0 0 32 0zM512 96l0 416-384 0 0-416 384 0zM256 448c0-35.3-28.7-64-64-64l0 64 64 0zm192-64c-35.3 0-64 28.7-64 64l64 0 0-64zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z"]
};
const faStarHalf = {
  prefix: 'fass',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M288 .1L201.5 164 18.9 195.6 148.1 328.5 121.7 512 288 430.2 288 .1zM454.4 512s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faCarBus = {
  prefix: 'fass',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M384 38.4S299 0 192 0S0 38.4 0 38.4L0 96s0 0 0 0L0 416l48 0 0 64 80 0 0-64 64 0 0-160 39.2 0 10.7-32L208 224l0-128 112 0 0 32 64 0 0-64 0-25.6zM320 160l-23.1 0-7.3 21.9-14 42.1-21.3 64L224 288l0 160s0 0 0 0l0 64 80 0 0-64 256 0 0 64 80 0 0-64 0-160-30.3 0L574.4 181.9 567.1 160 544 160l-160 0-64 0zm64 64l136.9 0 21.3 64L384 288l-62.3 0 21.3-64 40.9 0zM176 96l0 128L64 224 64 96l112 0zM56 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm248 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faSpeaker = {
  prefix: 'fass',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M0 0L384 0l0 512L0 512 0 0zM304 336A112 112 0 1 0 80 336a112 112 0 1 0 224 0zM192 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faTimer = {
  prefix: 'fass',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M256 0L224 0l0 32 0 64 0 32 64 0 0-32 0-29.3C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1L76.8 73.1C29.5 119.6 0 184.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159l-17-17L142.1 176l17 17 80 80 17 17L289.9 256l-17-17-80-80z"]
};
const faBoxesStacked = {
  prefix: 'fass',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M248 0L160 0l0 224 256 0L416 0 328 0l0 96-80 0 0-96zM104 256L0 256 0 512l288 0 0-256-104 0 0 96-80 0 0-96zM576 512l0-256-104 0 0 96-80 0 0-96-72 0 0 256 256 0z"]
};
const faBoxes = faBoxesStacked;
const faBoxesAlt = faBoxesStacked;
const faLandmarkMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'landmark-magnifying-glass',
  icon: [640, 512, [], "e622", "M448 288c-22.8 0-44.4-4.8-64-13.3L384 416l-40 0 0-166.4c-8.9-7.6-17-16.2-24-25.6l-40 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192-64 0 0 192L0 464l0 48 512 0 0-48-64-48 0-128zM288 128c0-34.8 11.1-66.9 29.9-93.2L256 0 0 144l0 48 301.3 0c-8.6-19.6-13.3-41.2-13.3-64zM448 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faGrillHot = {
  prefix: 'fass',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M144 0L96 0l0 24 0 2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6 0 24 48 0 0-24 0-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6 0-24zM256 0L208 0l0 24 0 2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6 0 24 48 0 0-24 0-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6 0-24zm74.1 357.3C400.3 319.5 448 245.3 448 160L0 160c0 85.3 47.7 159.5 117.9 197.3l-11.8 27.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40L327 472l2.9 6.8 4 9.3 9.5 22.1 44.1-18.9-9.5-22.1-4-9.3-44-102.6zM306.5 424l-151.1 0c-2-5-4.7-9.7-7.8-14l14.8-34.6c19.6 5.6 40.3 8.6 61.6 8.6s42.1-3 61.6-8.6L306.5 424zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faBallotCheck = {
  prefix: 'fass',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M448 0L0 0 0 512l448 0L448 0zM64 96l64 0 0 64-64 0 0-64zm64 256l0 64-64 0 0-64 64 0zm80 16l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zM192 112l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm16 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm-41.4-16l-11.3 11.3-48 48L96 294.6 84.7 283.3l-24-24L49.4 248 72 225.4l11.3 11.3L96 249.4l36.7-36.7L144 201.4 166.6 224z"]
};
const faLink = {
  prefix: 'fass',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M580.2 267.3c56.2-56.2 56.2-147.4 0-203.6S432.8 7.4 376.6 63.7L365.3 75l45.3 45.3 11.3-11.3c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1L421.8 335.2c-31.2 31.2-81.9 31.2-113.1 0c-25.6-25.6-30.3-64.3-13.8-94.6c1.8-3.4 3.9-6.7 6.3-9.8l-51.2-38.4c-4.3 5.7-8.1 11.6-11.4 17.8c-29.5 54.6-21.3 124.2 24.9 170.3c56.2 56.2 147.4 56.2 203.6 0L580.2 267.3zM59.8 244.7c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0L274.7 437l-45.3-45.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1L218.2 176.8c31.2-31.2 81.9-31.2 113.1 0c25.6 25.6 30.3 64.3 13.8 94.6c-1.8 3.4-3.9 6.7-6.3 9.8l51.2 38.4c4.3-5.7 8.1-11.6 11.4-17.8c29.5-54.6 21.3-124.2-24.9-170.3c-56.2-56.2-147.4-56.2-203.6 0L59.8 244.7z"]
};
const faChain = faLink;
const faEarListen = {
  prefix: 'fass',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M455.5 48.3C483.5 78.6 512 126 512 192l-64 0c0-46-19.5-78.6-39.5-100.3c-10.1-10.9-20.2-18.9-27.7-24.2c-3.7-2.6-6.8-4.5-8.7-5.6c-1-.6-1.7-1-2.1-1.2l-.3-.2c0 0 0 0 .1 0s0 0 0 0s0 0 0 0L384 32C398.3 3.4 398.3 3.4 398.3 3.4s0 0 0 0c0 0 0 0 .1 0l.2 .1 .4 .2c.3 .2 .7 .4 1.2 .7c1 .5 2.3 1.3 4 2.2c3.3 1.9 7.7 4.7 13 8.3c10.5 7.3 24.4 18.3 38.3 33.3zM160 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm54.6-86.6l64 64L173.3 448 128 493.3l-22.6-22.6-64-64L18.7 384 64 338.7l22.6 22.6zM240 128c-61.9 0-112 50.1-112 112l-64 0c0-97.2 78.8-176 176-176s176 78.8 176 176c0 54.7-25 103.5-64 135.8l0 24.2c0 61.9-50.1 112-112 112l-32 0 0-64 32 0c26.5 0 48-21.5 48-48l0-40.2 0-17.1 14.2-9.5C332.3 313 352 278.8 352 240c0-61.9-50.1-112-112-112zM208 240l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faAssistiveListeningSystems = faEarListen;
const faFileMinus = {
  prefix: 'fass',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM120 304l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z"]
};
const faTreeCity = {
  prefix: 'fass',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M288 0L480 0l0 192 40 0 0-72 0-24 48 0 0 24 0 72 72 0 0 320-160 0-96 0-96 0L288 0zm64 64l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm224 0l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM224 160c0 6-1 11-2 16c20 14 34 38 34 64l0 80-80 0-16 0 0 160 0 32-32 0-32 0 0-32 0-160-16 0L0 320l0-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"]
};
const faPlay = {
  prefix: 'fass',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M384 256L0 32V480L384 256z"]
};
const faFont = {
  prefix: 'fass',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M194 52.8L201.8 32l44.4 0L254 52.8 390.2 416l25.8 0 32 0 0 64-32 0-96 0-32 0 0-64 32 0 1.8 0-18-48-159.6 0-18 48 1.8 0 32 0 0 64-32 0-96 0L0 480l0-64 32 0 25.8 0L194 52.8zM168.2 304l111.6 0L224 155.1 168.2 304z"]
};
const faCupTogo = {
  prefix: 'fass',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M64 0L384 0l32 64 32 0 0 64-32 0L32 128 0 128 0 64l32 0L64 0zM80 512L48 160l352 0L368 512 80 512zM327 256l-206 0 14.5 160 176.9 0L327 256z"]
};
const faCoffeeTogo = faCupTogo;
const faSquareDownLeft = {
  prefix: 'fass',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M448 480L0 480 0 32l448 0 0 448zM128 192l0 160 160 0 16-16-52-52 84-84-56-56-84 84-52-52-16 16z"]
};
const faBurgerLettuce = {
  prefix: 'fass',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M32 192l0 32 448 0 0-32s0-160-224-160S32 192 32 192zm96-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM480 384L32 384l0 96 448 0 0-96zM178.9 257.9L168 254l-10.9 4-76.9 28L27.2 266 4.8 326l64 24 11.1 4.2 11.1-4 77.1-28 77.1 28 10.9 4 10.9-4 77.1-28 77.1 28 11.1 4 11.1-4.2 64-24L484.8 266l-52.9 19.9-76.9-28L344 254l-10.9 4L256 286l-77.1-28z"]
};
const faTableCellsRowLock = {
  prefix: 'fass',
  iconName: 'table-cells-row-lock',
  icon: [640, 512, [], "e67a", "M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faRupiahSign = {
  prefix: 'fass',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 32l32 0 80 0c79.5 0 144 64.5 144 144c0 59.6-36.2 110.7-87.8 132.6l54.3 169.6 .6 1.8-67.2 0L104.6 320 64 320l0 160L0 480 0 288 0 64 0 32zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L64 96l0 160zm224-96l32 0 80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 128-64 0 0-160 0-160 0-32zm64 160l48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0 0 96z"]
};
const faMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
const faSearch = faMagnifyingGlass;
const faTableTennisPaddleBall = {
  prefix: 'fass',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M416 288c-50.1 0-93.6 28.8-114.6 70.8L68.9 126.3l60.7-60.7c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C471.8 297.6 445 288 416 288zM46.3 148.9L290.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.3 6.2 45.2 17.1 64L240 480l-75.4-75.4L64 512 0 448 107.4 347.4 32 272l0-108.8 14.3-14.3zM416 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faPingPongPaddleBall = faTableTennisPaddleBall;
const faTableTennis = faTableTennisPaddleBall;
const faPersonDotsFromLine = {
  prefix: 'fass',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zm-64 32l-10.4 0-9.5 4.3-76.7 34.8C124 270.3 104.1 288 80 288c-9.5 0-18.4-2.8-25.8-7.5l-10 4.6L.4 304.9l39.7 87.4 43.7-19.9L176 330.5 176 432l224 0 0-101.5 92.1 41.9 43.7 19.9 39.7-87.4L531.9 285l-31.1-14.1c-8.8 10.5-22 17.1-36.7 17.1c-26.5 0-48-21.5-48-48c0-2.5 .2-5 .6-7.4l-44.7-20.3-9.5-4.3L352 208l-128 0zM24 464L0 464l0 48 24 0 528 0 24 0 0-48-24 0L24 464zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faDiagnoses = faPersonDotsFromLine;
const faChevronsDown = {
  prefix: 'fass',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M278.6 278.6L256 301.3l-22.6-22.6-192-192L18.7 64 64 18.7 86.6 41.4 256 210.7 425.4 41.4 448 18.7 493.3 64 470.6 86.6l-192 192zm0 192L256 493.3l-22.6-22.6-192-192L18.7 256 64 210.7l22.6 22.6L256 402.7 425.4 233.4 448 210.7 493.3 256l-22.6 22.6-192 192z"]
};
const faChevronDoubleDown = faChevronsDown;
const faTrashCanArrowUp = {
  prefix: 'fass',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0 0 384L32 512l0-384zm209 71l-17-17-17 17-80 80-17 17L144 329.9l17-17 39-39L200 408l0 24 48 0 0-24 0-134.1 39 39 17 17L337.9 296l-17-17-80-80z"]
};
const faTrashRestoreAlt = faTrashCanArrowUp;
const faSignalGood = {
  prefix: 'fass',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M352 192l0 32 0 256 0 32-64 0 0-32 0-256 0-32 64 0zM224 288l0 32 0 160 0 32-64 0 0-32 0-160 0-32 64 0zM96 416l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z"]
};
const faSignal3 = faSignalGood;
const faLocationQuestion = {
  prefix: 'fass',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM104 152c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L160 144c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48z"]
};
const faMapMarkerQuestion = faLocationQuestion;
const faFloppyDiskCircleXmark = {
  prefix: 'fass',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M32 32L0 32 0 64 0 448l0 32 32 0 264.2 0c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7l0-32.7 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32zM64 96l256 0 0 128L64 224 64 96zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z"]
};
const faFloppyDiskTimes = faFloppyDiskCircleXmark;
const faSaveCircleXmark = faFloppyDiskCircleXmark;
const faSaveTimes = faFloppyDiskCircleXmark;
const faNairaSign = {
  prefix: 'fass',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M96 32L64 32l0 32 0 192-32 0L0 256l0 64 32 0 32 0 0 128 0 32 64 0 0-32 0-128 98.9 0 92.8 145.2 9.4 14.8 17.5 0 5.3 0 32 0 0-32 0-128 32 0 32 0 0-64-32 0-32 0 0-192 0-32-64 0 0 32 0 192-58 0L128.3 46.8 118.9 32l-17.5 0L96 32zM302.9 320l17.1 0 0 26.8L302.9 320zM186 256l-58 0 0-90.8L186 256z"]
};
const faPeach = {
  prefix: 'fass',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-10 0-19.9 .7-29.6 2.2C122.1 64.9 112 41.6 112 16l0-16 16 0 32 0c53 0 96 43 96 96c0-53 43-96 96-96l32 0 16 0 0 16c0 25.6-10.1 48.9-26.4 66.2C363.9 80.7 354 80 344 80zM168 112c31.9 0 61.7 8.9 87.1 24.3l.9 .5c48 29.6 80 82.6 80 143.1l32 0c0-64.8-30.8-122.4-78.6-158.9c17.1-5.9 35.5-9.1 54.6-9.1c92.8 0 168 75.2 168 168c0 152-256 232-256 232s-256-80-256-232c0-92.8 75.2-168 168-168z"]
};
const faTaxiBus = {
  prefix: 'fass',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M192 0C299 0 384 38.4 384 38.4L384 64l0 32-64 0L208 96l0 128 33.9 0-10.7 32L192 256l0 160-64 0 0 64-80 0 0-64L0 416 0 96s0 0 0 0L0 38.4S85 0 192 0zM384 224l-40.9 0-21.3 64 62.3 0 158.3 0-21.3-64L384 224zM224 288l30.3 0 21.3-64 14-42.1 7.3-21.9 23.1 0 48 0 0-32 128 0 0 32 48 0 23.1 0 7.3 21.9L609.7 288l30.3 0 0 160 0 64-80 0 0-64-256 0 0 64-80 0 0-64s0 0 0 0l0-160zM64 96l0 128 112 0 0-128L64 96zM80 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm256 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBracketCurly = {
  prefix: 'fass',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M96 32L64 32l0 32 0 114.7L9.4 233.4 0 242.7l0 26.5 9.4 9.4L64 333.3 64 448l0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-96 0-13.3-9.4-9.4L77.3 256l41.4-41.4 9.4-9.4 0-13.3 0-96 64 0 32 0 0-64-32 0L96 32z"]
};
const faBracketCurlyLeft = faBracketCurly;
const faLobster = {
  prefix: 'fass',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 2l0 94 42.9-57.2c3.3 7.7 5.1 16.2 5.1 25.2l0 64c0 14.9-5.1 28.6-13.6 39.4L151.3 192l46.5 0c2.7-7.3 6.2-14 10.2-20.2l0-118.2-34.6-5.8-15.8-2.6 5.3-31.6 15.8 2.6 48 8L240 26.4 240 40l0 98c5.9-4.4 11.4-7.7 16-10c4.6 2.3 10.1 5.6 16 10l0-98 0-13.6 13.4-2.2 48-8 15.8-2.6 5.3 31.6-15.8 2.6L304 53.6l0 118.2c4 6.2 7.5 13 10.2 20.2l46.5 0 36.9-24.6C389.1 156.6 384 142.9 384 128l0-64c0-8.9 1.8-17.4 5.1-25.2L432 96l0-94c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-.7 0-66 44-6 4-7.3 0-48 0 0 16 60.2 0 44.6-22.3 14.3-7.2 14.3 28.6-14.3 7.2-48 24-3.4 1.7-3.8 0-64 0 0 16 77.4 0 45.5-15.2 15.2-5.1 10.1 30.4-15.2 5.1-48 16-2.5 .8-2.6 0-80 0 0 16 32 0 3.8 0 3.4 1.7 32 16 14.3 7.2-14.3 28.6-14.3-7.2L348.2 384 320 384l-21.6 64.8c30.4 5 53.6 31.4 53.6 63.2l-192 0c0-31.8 23.2-58.2 53.6-63.2L192 384l-28.2 0-28.6 14.3-14.3 7.2-14.3-28.6 14.3-7.2 32-16 3.4-1.7 3.8 0 32 0 0-16-80 0-2.6 0-2.5-.8-48-16-15.2-5.1 10.1-30.4 15.2 5.1L114.6 304l77.4 0 0-16-64 0-3.8 0-3.4-1.7-48-24-14.3-7.2 14.3-28.6 14.3 7.2L131.8 256l60.2 0 0-16-48 0-7.3 0-6-4-66-44-.7 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0c5.5 0 10.9 .7 16 2z"]
};
const faCartFlatbedEmpty = {
  prefix: 'fass',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 0L32 0 96 0l32 0 0 32 0 352 480 0 32 0 0 64-32 0-66.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L96 448l-32 0 0-32L64 64 32 64 0 64 0 0z"]
};
const faDollyFlatbedEmpty = faCartFlatbedEmpty;
const faColon = {
  prefix: 'fass',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M160 64L32 64l0 128 128 0 0-128zm0 256L32 320l0 128 128 0 0-128z"]
};
const faCartArrowDown = {
  prefix: 'fass',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M312 32L122 32l-2.4-12.5L115.9 0 96 0 24 0 0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0-9.1-48L496 288 576 32 360 32l0 99.1 24.2-21.2 18.1-15.8 31.6 36.1-18.1 15.8-64 56L336 215.9l-15.8-13.8-64-56-18.1-15.8 31.6-36.1 18.1 15.8L312 131.1 312 32zM224 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faWand = {
  prefix: 'fass',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M80 512L0 432 128 316.8l0-60.8 67.6 0L480 0l32 32L416 138.7l0 53.3-48 0L80 512z"]
};
const faWalkieTalkie = {
  prefix: 'fass',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112 24l0-24L64 0l0 24 0 72L0 96 0 320l32 32 0 160 320 0 0-160 32-32 0-224-64 0 0-32-64 0 0 32-32 0 0-32-64 0 0 32-48 0 0-72zm0 136l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faFilePen = {
  prefix: 'fass',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M0 0L224 0l0 160 160 0 0 140.4-117 117L253.4 512 0 512 0 0zM384 128l-128 0L256 0 384 128zm121 95.8l71 71-41.3 41.3-71-71L505 223.8zm-63.9 63.9l71 71L370.9 500 288 511.9 299.9 429 441.1 287.8z"]
};
const faFileEdit = faFilePen;
const faReceipt = {
  prefix: 'fass',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M0 0L0 512l64-48 64 48 64-48 64 48 64-48 64 48L384 0 320 48 256 0 192 48 128 0 64 48 0 0zM96 144l192 0 16 0 0 32-16 0L96 176l-16 0 0-32 16 0zM80 336l16 0 192 0 16 0 0 32-16 0L96 368l-16 0 0-32zm16-96l192 0 16 0 0 32-16 0L96 272l-16 0 0-32 16 0z"]
};
const faTablePicnic = {
  prefix: 'fass',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M64 64l32 0 320 0 32 0 0 64-32 0-48.7 0 38.4 96 74.3 0 32 0 0 64-32 0-48.7 0-68.9 0-212.7 0-68.9 0L32 288 0 288l0-64 32 0 74.3 0 38.4-96L96 128l-32 0 0-64zm3.9 256l68.9 0-11.2 27.9-32 80-8 20.1-68.9 0 17.6-43.9 32-80 1.6-4.1zm307.2 0l68.9 0 33.6 84.1L495.3 448l-68.9 0-8-20.1L375.1 320zM213.7 128l-38.4 96 161.5 0-38.4-96-84.7 0z"]
};
const faSquarePen = {
  prefix: 'fass',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M448 32L0 32 0 480l448 0 0-448zM112 288L220.7 179.3l80 80L192 368 96 384l16-96zm256-96l-44.7 44.7-80-80L288 112l80 80z"]
};
const faPenSquare = faSquarePen;
const faPencilSquare = faSquarePen;
const faCircleMicrophoneLines = {
  prefix: 'fass',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 96l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16-32 0-16 0 0-32 16 0 32 0 0-32-32 0-16 0 0-32 16 0 32 0 0-48-96 0zM160 240l0-16-32 0 0 16 0 16c0 65.3 48.9 119.1 112 127l0 17 0 16 32 0 0-16 0-17c63.1-7.9 112-61.7 112-127l0-16 0-16-32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16z"]
};
const faMicrophoneCircleAlt = faCircleMicrophoneLines;
const faDisplaySlash = {
  prefix: 'fass',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M608 0L32 0l0 2.1-2.6-2L0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416l42.8 0L608 0zM482.7 352L111.8 64 544 64l0 288-61.3 0zM32 416l240 0-10.7 32L192 448l-32 0 0 64 32 0 256 0 32 0 0-37.7L446.6 448l-67.9 0L368 416l38 0-81.2-64L96 352l0-180.2L32 121.4 32 416z"]
};
const faDesktopSlash = faDisplaySlash;
const faSuitcaseRolling = {
  prefix: 'fass',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M120 0L96 0l0 24 0 104L0 128 0 480l64 0 0 32 64 0 0-32 128 0 0 32 64 0 0-32 64 0 0-352-96 0 0-104 0-24L264 0 120 0zM240 128l-96 0 0-80 96 0 0 80zM112 224l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z"]
};
const faPersonCircleExclamation = {
  prefix: 'fass',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faTransporter2 = {
  prefix: 'fass',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M64 32L48 0 32 32 0 48 32 64 48 96 64 64 96 48 64 32zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-15.4 0-9.6 12-67.3 84 286.7 0L332 140l-9.6-12-15.4 0-102.2 0zM416 512l0-64L96 448l0 64 120 0 80 0 120 0zM96 255.5c0 .3 0 .7 0 1L96 288l16 0 288 0 16 0 0-32-16 0-288 0-16 0 0-.5zM464 320l-16 32-32 16 32 16 16 32 16-32 32-16-32-16-16-32zm-288 0l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z"]
};
const faUserHoodie = {
  prefix: 'fass',
  iconName: 'user-hoodie',
  icon: [448, 512, [], "e68a", "M327.3 282.2C362 252.9 384 209 384 160C384 71.6 312.4 0 224 0S64 71.6 64 160c0 49 22 92.9 56.7 122.2L118 304l-54 0L0 512l448 0L384 304l-54 0-2.7-21.8zM160 384l0 16 0 64 0 16-32 0 0-16 0-64 0-16 32 0zm160 0l0 16 0 64 0 16-32 0 0-16 0-64 0-16 32 0zM160 157.3c0 24 16 48.7 38.3 70.4c9 8.8 18.2 16.2 25.7 21.7c7.5-5.5 16.6-12.9 25.7-21.7C272 206 288 181.3 288 157.3c0-33-27.8-61.3-64-61.3s-64 28.3-64 61.3zm-32 0c0-51.5 43-93.3 96-93.3s96 41.8 96 93.3C320 232 224 288 224 288s-96-56-96-130.7z"]
};
const faHandsHoldingDiamond = {
  prefix: 'fass',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M320 256L448 128 320 0 192 128 320 256zM80 64L0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40zm480 0l0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4 0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0z"]
};
const faHandReceiving = faHandsHoldingDiamond;
const faMoneyBillSimpleWave = {
  prefix: 'fass',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M0 60.3L0 451.7c96 48.9 192 24.5 288 0s192-48.9 288 0l0-391.5c-96-48.9-192-24.5-288 0s-192 48.9-288 0zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
const faChevronDown = {
  prefix: 'fass',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z"]
};
const faBatteryFull = {
  prefix: 'fass',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M480 160l0 192L64 352l0-192 416 0zM64 96L0 96l0 64L0 352l0 64 64 0 416 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L64 96zm384 96L96 192l0 128 352 0 0-128z"]
};
const faBattery = faBatteryFull;
const faBattery5 = faBatteryFull;
const faBellPlus = {
  prefix: 'fass',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M256 0L192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0zm32 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM248 152l0 24 0 40 40 0 24 0 0 48-24 0-40 0 0 40 0 24-48 0 0-24 0-40-40 0-24 0 0-48 24 0 40 0 0-40 0-24 48 0z"]
};
const faBookArrowRight = {
  prefix: 'fass',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0 0-152 94.1 0-39 39-17 17L520 321.9l17-17 80-80 17-17-17-17-80-80-17-17L486.1 128l17 17 39 39L448 184 448 0 416 0 384 0 96 0zM448 184l0 48-200 0-24 0 0-48 24 0 200 0zM96 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
};
const faHospitals = {
  prefix: 'fass',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M576 0L256 0l0 64 64 0 0 448 256 0 0-128-112 0-16 0 0-32 16 0 112 0 0-64-112 0-16 0 0-32 16 0 112 0L576 0zM408 80l48 0 0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40zM0 96L0 384l144 0 16 0 0 32-16 0L0 416l0 96 288 0 0-416L0 96zm120 80l48 0 0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40z"]
};
const faClub = {
  prefix: 'fass',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3l0 75.3-32 0-32 0 0 64 32 0 32 0 64 0 32 0 32 0 0-64-32 0-32 0 0-75.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1z"]
};
const faSkullCrossbones = {
  prefix: 'fass',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M368 128c0 44.4-25.4 83.5-64 106.4l0 53.6-160 0 0-53.6c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM16.7 245.4l29 13.6L224 343l178.4-84 29-13.6 27.3 57.9-29 13.6L299.1 378.4l130.5 61.4 29 13.6-27.3 57.9-29-13.6L224 413.8l-178.4 84-29 13.6-27.3-57.9 29-13.6 130.5-61.4L18.4 317l-29-13.6 27.3-57.9z"]
};
const faDropletDegree = {
  prefix: 'fass',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 512c106 0 192-86 192-192S192 0 192 0S0 214 0 320S86 512 192 512zM400 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faDewpoint = faDropletDegree;
const faCodeCompare = {
  prefix: 'fass',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M288 320l-96 96 96 96 32 0 0-64 16 0c70.7 0 128-57.3 128-128l0-160 48 0 0-56 0-48 0-56L456 0 408 0 352 0l0 56 0 48 0 56 48 0 0 160c0 35.3-28.7 64-64 64l-16 0 0-64-32 0zM408 56l48 0 0 48-48 0 0-48zM224 0L192 0l0 64-16 0C105.3 64 48 121.3 48 192l0 160L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-48 0 0-160c0-35.3 28.7-64 64-64l16 0 0 64 32 0 96-96L224 0zM56 408l48 0 0 48-48 0 0-48z"]
};
const faListUl = {
  prefix: 'fass',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faListDots = faListUl;
const faHandHoldingMagic = {
  prefix: 'fass',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M192 80c0-8.8 7.2-16 16-16l112 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0-32 0 0 32 0 32 0 32 64 0 0-32 32 0c70.7 0 128-57.3 128-128S390.7 0 320 0L208 0c-44.2 0-80 35.8-80 80s35.8 80 80 80l80 0 32 0 0-64-32 0-80 0c-8.8 0-16-7.2-16-16zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faWatermelonSlice = {
  prefix: 'fass',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M391.4 391.4C294.6 488.2 137.9 487.9 41 391L7 425c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7L391 41c96.9 96.9 97.1 253.6 .3 350.4zM63.3 368.7c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1L353.5 48 48 353.5l15.3 15.3zM320 137.4l11.3 11.3 16 16L358.6 176 336 198.6l-11.3-11.3-16-16L297.4 160 320 137.4zm-80 80l11.3 11.3 16 16L278.6 256 256 278.6l-11.3-11.3-16-16L217.4 240 240 217.4zm88 8l11.3 11.3 16 16L366.6 264 344 286.6l-11.3-11.3-16-16L305.4 248 328 225.4zm-168 72l11.3 11.3 16 16L198.6 336 176 358.6l-11.3-11.3-16-16L137.4 320 160 297.4zm88 8l11.3 11.3 16 16L286.6 344 264 366.6l-11.3-11.3-16-16L225.4 328 248 305.4z"]
};
const faCircleEllipsis = {
  prefix: 'fass',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 224l0 64-64 0 0-64 64 0zm192 0l0 64-64 0 0-64 64 0zm-160 0l64 0 0 64-64 0 0-64z"]
};
const faSchoolLock = {
  prefix: 'fass',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M384 288l0 64-64 0c-35.3 0-64 28.7-64 64l0 96L0 512 0 96l160 0L320 0 480 96l160 0 0 176c0-61.9-50.1-112-112-112s-112 50.1-112 112l0 16-32 0zM80 192l0 96 64 0 0-96-64 0zm0 128l0 96 64 0 0-96-64 0zm240-56a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120l0 16 16 0 16 0 0 32-16 0-32 0-16 0 0-16 0-32 0-16 32 0 0 16zm192 96c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0 0-48z"]
};
const faTowerCell = {
  prefix: 'fass',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M87.6 27.8L32 0 17.4 29.2C6.1 60 0 93.3 0 128s6.1 68 17.4 98.8L32 256l55.6-27.8C72.5 198 64 164 64 128s8.5-70 23.6-100.2zm42.9 21.5C118.7 73 112 99.7 112 128s6.7 55 18.5 78.7l42.9-21.5C164.9 168 160 148.6 160 128s4.9-40 13.5-57.3L130.5 49.3zm272 21.5C411.1 88 416 107.4 416 128s-4.9 40-13.5 57.3l42.9 21.5C457.3 183 464 156.3 464 128s-6.7-55-18.5-78.7L402.5 70.7zm85.9 157.5L544 256l14.6-29.2C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0 488.4 27.8C503.5 58 512 92 512 128s-8.5 70-23.6 100.2zM239.1 169.3L80 512l70.6 0 29.7-64 215.4 0 29.7 64 70.6 0L336.9 169.3c9.4-11.1 15.1-25.6 15.1-41.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.7 5.7 30.2 15.1 41.3zM366 384l-156 0 14.9-32 126.3 0L366 384zM288 216l33.4 72-66.9 0L288 216z"]
};
const faSdCards = {
  prefix: 'fass',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M416 0L224 0 210.7 0l-9.4 9.4-96 96L96 114.7 96 128l0 256 0 32 32 0 288 0 32 0 0-32 0-352 0-32L416 0zM304 64l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0zm80 0l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0zM48 120l0-24L0 96l0 24L0 488l0 24 24 0 336 0 24 0 0-48-24 0L48 464l0-344z"]
};
const faJugBottle = {
  prefix: 'fass',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M224 0L96 0l0 48L64 48l0 48 192 0 0-48-32 0 0-48zM128 128C57.3 128 0 185.3 0 256L0 512l384 0 0-384-256 0zm192 96l0 160-64 0 0-160 64 0zM576 64L448 64l0 64 128 0 0-64zM448.3 160L416 175.1 416 512l192 0 32-32 0-64-24-24 24-24 0-64-24-24 24-24 0-65.9L575.7 160l-127.5 0z"]
};
const faDownLong = {
  prefix: 'fass',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M160 512L0 352l0-32 96 0L96 0 224 0l0 320 96 0 0 32L160 512z"]
};
const faLongArrowAltDown = faDownLong;
const faEnvelopes = {
  prefix: 'fass',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M336 299.7l-9.3-6.6L96 128.2 96 384l480 0 0-255.8L345.3 293l-9.3 6.6zm233.3-206l6.7-4.8L576 32 96 32l0 56.9 6.7 4.8L336 260.3 569.3 93.7zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z"]
};
const faPhoneOffice = {
  prefix: 'fass',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M224 0L96 0l0 32 0 352 0 32 32 0 64 0 32 0 0-32 0-352 0-32zM64 32L0 32 0 512l576 0 0-480L256 32l0 384 0 32-32 0L96 448l-32 0 0-32L64 32zM320 96l192 0 0 96-192 0 0-96zm64 160l0 64-64 0 0-64 64 0zm64 0l64 0 0 64-64 0 0-64zm64 128l0 64-64 0 0-64 64 0zm-192 0l64 0 0 64-64 0 0-64z"]
};
const faRankingStar = {
  prefix: 'fass',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M351.8 62.3L320 0 288.2 62.3l-69 11 49.4 49.5L257.7 192 320 160.3 382.3 192l-10.9-69.1 49.4-49.5-69-11zM416 256l-192 0 0 256 192 0 0-256zM192 320L0 320 0 512l192 0 0-192zm256 64l0 128 192 0 0-128-192 0z"]
};
const faChessKing = {
  prefix: 'fass',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M256 0l0 32 0 16 16 0 32 0 0 64-32 0-16 0 0 48 192 0 0 48L368 400 80 400 0 208l0-48 192 0 0-48-16 0-32 0 0-64 32 0 16 0 0-16 0-32 64 0zM32 512l0-32 48-48 288 0 48 48 0 32L32 512z"]
};
const faNfcPen = {
  prefix: 'fass',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M0 32l448 0 0 204.4-64 64L384 112l0-16-16 0L224 96l-16 0 0 16 0 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-82.7 112 0 0 204.4L300.4 384 96 384l0-256 48 0 16 0 0-32-16 0L80 96 64 96l0 16 0 288 0 16 16 0 188.4 0-1.4 1.4L258 480 0 480 0 32zM505 223.8l71 71-41.3 41.3-71-71L505 223.8zm-63.9 63.9l71 71L370.9 500 288 511.9 299.9 429 441.1 287.8z"]
};
const faPersonHarassing = {
  prefix: 'fass',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9 88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-244.4 60.1 72.8 49.3-40.8-105.7-128L226.2 128l-15.1 0-102.2 0-18.1 0-9.3 15.5L4.6 271.5l54.9 33zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm18.7 48l-9.4 9.4-16 16-9.4 9.4 0 13.3 0 66.7-41.4-41.4L372.9 367l-48 76.8-17 27.1 54.3 33.9 17-27.1 26.7-42.7 57.6 57.6c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L576 320l0-32-32 0-32 0-13.3 0zM288 32l0 32 16 0 56 0 16 0 0-32-16 0-56 0-16 0zm-.8 65.7l-14.3-7.2-14.3 28.6 14.3 7.2 48 24 14.3 7.2 14.3-28.6-14.3-7.2-48-24z"]
};
const faMagnifyingGlassPlay = {
  prefix: 'fass',
  iconName: 'magnifying-glass-play',
  icon: [512, 512, [], "e660", "M376 330.7c25.2-34.4 40-76.8 40-122.7C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416c45.9 0 88.3-14.9 122.7-40L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L376 330.7zM145.8 116.2l24 14 110.2 64L303.9 208 280 221.8l-110.2 64-24 14 0-27.8 0-128 0-27.8z"]
};
const faHatWinter = {
  prefix: 'fass',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M256 0l23.3 23.8 33.3-.4-.4 33.3L336 80l-23.8 23.3 .4 33.3-33.3-.4L256 160l-23.3-23.8-33.3 .4 .4-33.3L176 80l23.8-23.3-.4-33.3 33.3 .4L256 0zM0 448l32 0 448 0 32 0 0 64-32 0L32 512 0 512l0-64zM60.8 292.5C80.3 243.2 113 191.7 167.1 164.2L167 169l32.8-.4 19.6-.2 13.7 14L256 205.8l22.9-23.4 13.7-14 19.6 .2L345 169l-.1-4.8c54.1 27.5 86.8 79 106.3 128.3l-18.7 9.4-48.6-27.8-7.9-4.5-7.9 4.5-48.6 27.8-56.3-28.2-7.2-3.6-7.2 3.6-56.3 28.2-48.6-27.8-7.9-4.5-7.9 4.5L79.5 301.9l-18.7-9.4zM50.1 322.9l22.7 11.4 7.7 3.8 7.4-4.2L136 306.4l48.1 27.5 7.4 4.2 7.7-3.8L256 305.9l56.8 28.4 7.7 3.8 7.4-4.2L376 306.4l48.1 27.5 7.4 4.2 7.7-3.8 22.7-11.4C477.5 374 480 416 480 416L32 416s2.5-42 18.1-93.1z"]
};
const faBrazilianRealSign = {
  prefix: 'fass',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M432 32l0-32L368 0l0 32 0 22.2C321.5 70 288 114 288 165.9c0 48.2 29.3 91.5 74.1 109.4l52 20.8c20.5 8.2 33.9 28 33.9 50l0 3.4c0 27.9-22.6 50.5-50.5 50.5c-12.9 0-25.6-3.8-36.3-11l-23.4-15.6-35.5 53.3 23.4 15.6c13 8.6 27.3 14.8 42.3 18.3l0 19.4 0 32 64 0 0-32 0-21.3c46.4-14.6 80-58 80-109.2l0-3.4c0-48.2-29.3-91.5-74.1-109.4l-52-20.8c-20.5-8.2-33.9-28-33.9-50c0-29.7 24.1-53.9 53.9-53.9l1.7 0c11.1 0 22 2.6 32 7.5l10.2 5.1 28.6-57.2-10.1-5.1c-11.5-5.7-23.6-9.8-36.2-12.1L432 32zM0 32L0 64 0 288 0 480l64 0 0-160 40.6 0 51.2 160 67.2 0-.6-1.8L168.2 308.6c51.6-21.9 87.8-73 87.8-132.6c0-79.5-64.5-144-144-144L32 32 0 32zM64 256L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-48 0z"]
};
const faLandmarkDome = {
  prefix: 'fass',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M288 0L224 0l0 34.7C143.6 48.1 80.1 111.6 66.7 192L64 192l-32 0 0 64 32 0 384 0 32 0 0-64-32 0-2.7 0C431.9 111.6 368.4 48.1 288 34.7L288 0zM0 464l0 48 512 0 0-48-64-48 0-128-64 0 0 128-40 0 0-128-64 0 0 128-48 0 0-128-64 0 0 128-40 0 0-128-64 0 0 128L0 464z"]
};
const faLandmarkAlt = faLandmarkDome;
const faBoneBreak = {
  prefix: 'fass',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344 32l0-24L296 8l0 24 0 72 0 24 48 0 0-24 0-72zM201 71l-17-17L150.1 88l17 17 48 48 17 17L265.9 136l-17-17L201 71zM473 105l17-17L456 54.1 439 71l-48 48-17 17L408 169.9l17-17 48-48zM157 250.2c-9.5-33.6-40.4-58.2-77-58.2c-44.2 0-80 35.8-80 80c0 38.6 27.3 70.8 63.7 78.3L66.8 366C45.8 380.4 32 404.6 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-7.6-1-14.9-3-21.8L320 384l131 26.2c-2 6.9-3 14.2-3 21.8c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.4-13.8-51.6-34.8-66l3.1-15.7c36.3-7.5 63.7-39.7 63.7-78.3c0-44.2-35.8-80-80-80c-36.6 0-67.5 24.6-77 58.2L352 224 320 384 288 224 157 250.2z"]
};
const faArrowUp = {
  prefix: 'fass',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M214.6 57.4L192 34.7 169.4 57.4l-144 144L2.7 224 48 269.2l22.6-22.6L160 157.2 160 448l0 32 64 0 0-32 0-290.7 89.4 89.4L336 269.2 381.3 224l-22.6-22.6-144-144z"]
};
const faDownFromDottedLine = {
  prefix: 'fass',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M64 320L224 480 384 320l0-32-96 0 0-160-128 0 0 160-96 0 0 32zM64 96l0-64L0 32 0 96l64 0zm96 0l0-64L96 32l0 64 64 0zm32-64l0 64 64 0 0-64-64 0zM352 96l0-64-64 0 0 64 64 0zm32 0l64 0 0-64-64 0 0 64z"]
};
const faTv = {
  prefix: 'fass',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 64l0 288 512 0 0-288L64 64zM0 0L64 0 576 0l64 0 0 64 0 288 0 64-64 0L64 416 0 416l0-64L0 64 0 0zM128 448l384 0 32 0 0 64-32 0-384 0-32 0 0-64 32 0z"]
};
const faTelevision = faTv;
const faTvAlt = faTv;
const faBorderLeft = {
  prefix: 'fass',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M0 480L0 32l64 0 0 448L0 480zm96 0l0-64 64 0 0 64-64 0zM96 32l64 0 0 64L96 96l0-64zm0 256l0-64 64 0 0 64-64 0zM288 416l64 0 0 64-64 0 0-64zm0-320l0-64 64 0 0 64-64 0zm0 128l64 0 0 64-64 0 0-64zM192 480l0-64 64 0 0 64-64 0zm0-448l64 0 0 64-64 0 0-64zm0 256l0-64 64 0 0 64-64 0zM384 416l64 0 0 64-64 0 0-64zm0-320l0-64 64 0 0 64-64 0zm0 128l64 0 0 64-64 0 0-64zM192 384l0-64 64 0 0 64-64 0zm192-64l64 0 0 64-64 0 0-64zm0-128l0-64 64 0 0 64-64 0zM192 128l64 0 0 64-64 0 0-64z"]
};
const faCircleDivide = {
  prefix: 'fass',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320l-64 0 0-64 64 0 0 64zM168 232l176 0 24 0 0 48-24 0-176 0-24 0 0-48 24 0zm56 152l0-64 64 0 0 64-64 0z"]
};
const faShrimp = {
  prefix: 'fass',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M16 32L0 32 0 48l0 96 0 16 16 0 49 0c3.7 88.9 77 160 167 160l56 0 0-192-24 0L88.8 128 32 128l0-64 432 0 16 0 0-32-16 0L16 32zM320 320l18.3 0c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128l-16 0 0 192zm62.8 35.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1zm-21.2 50c-3 1.8-6.2 3.2-9.6 4.3l0 69.9c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6zM320 407.8l-64.1-22.4L224 374.2l0 33.8 0 48 0 24 24 0 72 0 0-72.2zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faListCheck = {
  prefix: 'fass',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M169.9 54.2L153.8 72.1l-72 80L64.9 170.9 47 153 7 113l-17-17L24 62.1 41 79l22.1 22.1 55.1-61.2 16.1-17.8 35.7 32.1zm0 160l-16.1 17.8-72 80L64.9 330.9 47 313 7 273l-17-17L24 222.1l17 17 22.1 22.1 55.1-61.2 16.1-17.8 35.7 32.1zM224 64l32 0 224 0 32 0 0 64-32 0-224 0-32 0 0-64zm0 160l32 0 224 0 32 0 0 64-32 0-224 0-32 0 0-64zM160 384l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faTasks = faListCheck;
const faDiagramSubtask = {
  prefix: 'fass',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M0 32l512 0 0 192-352 0 0 128 64 0 0-64 64 0 160 0 64 0 0 64 0 64 0 64-64 0-160 0-64 0 0-64-96 0-32 0 0-32 0-160L0 224 0 32zM448 352l-160 0 0 64 160 0 0-64z"]
};
const faJugDetergent = {
  prefix: 'fass',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M96 0L224 0l0 48 32 0 0 48L64 96l0-48 32 0L96 0zM0 256c0-70.7 57.3-128 128-128l256 0 0 384L0 512 0 256zm256-32l0 160 64 0 0-160-64 0z"]
};
const faCircleUser = {
  prefix: 'fass',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M391.9 391.6L368 320l-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448s101.1-21.5 135.9-56.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
const faUserCircle = faCircleUser;
const faSquareY = {
  prefix: 'fass',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M448 32L0 32 0 480l448 0 0-448zM200 295.9L88.6 144l59.5 0L224 247.4 299.8 144l59.5 0L248 295.9l0 80.1 0 24-48 0 0-24 0-80.1z"]
};
const faUserDoctorHair = {
  prefix: 'fass',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 144l0-16c0-11.4-2.4-22.2-6.7-32L256 96 240 80l-32 32-62.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16C96 57.3 153.3 0 224 0zM160 370.3l0-50.3 128 0 0 42c-27.6 7.1-48 32.2-48 62l0 40 0 16 16 0 16 0 16 0 0-32-16 0 0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24-16 0 0 32 16 0 16 0 16 0 0-16 0-40c0-29.8-20.4-54.9-48-62l0-42 80 0 48 192L0 512 48 320l80 0 0 50.3c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faPlanetRinged = {
  prefix: 'fass',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M319.7 319.7C512 127.4 503.9 8.1 503.9 8.1s-58.4-4-159.4 59.6C317.6 55.1 287.6 48 256 48C141.1 48 48 141.1 48 256c0 31.6 7.1 61.6 19.7 88.5C4.1 445.5 8.1 503.9 8.1 503.9s119.3 8.1 311.6-184.2zM256 464c114.9 0 208-93.1 208-208c0-17.5-2.2-34.4-6.2-50.6c-27.7 40.6-65 86.5-115.5 137s-96.3 87.8-137 115.5c16.2 4.1 33.2 6.2 50.6 6.2z"]
};
const faMushroom = {
  prefix: 'fass',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M16 272C16 139.5 123.5 32 256 32s240 107.5 240 240l0 24 0 24-24 0L40 320l-24 0 0-24 0-24zM413.3 161.9c-4.2-1.2-8.7-1.9-13.3-1.9c-26.5 0-48 21.5-48 48s21.5 48 48 48c19 0 35.4-11 43.2-27c-5.6-24.5-15.9-47.2-29.9-67.1zM146.2 114.5c8.4 35.3 40 61.5 77.8 61.5c44.2 0 80-35.8 80-80c0-3.4-.2-6.8-.6-10.1C288.2 82 272.3 80 256 80c-40.9 0-78.7 12.8-109.8 34.5zM160 480l32-128 128 0 32 128-192 0zm0-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faUserShield = {
  prefix: 'fass',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zm96.1 304c2.3 74.7 36.7 158.5 106 208L0 512 64 304l256.1 0zm271.2 8.4L496 275.5l0 184.9c56.5-26.3 90.2-87 95.3-148zM496 512c-96-32-144-130.2-144-216l0-16.2L496 224l144 55.8 0 16.2c0 85.8-48 184-144 216z"]
};
const faMegaphone = {
  prefix: 'fass',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M576 32l0 448-64 0 0-448 64 0zM64 190.3L480 64l0 384L348.9 408.2C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96c0-11 1.9-21.7 5.3-31.5L64 321.7 64 352 0 352l0-32L0 192l0-32 64 0 0 30.3zm238.9 204l-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6c0 26.5 21.5 48 48 48c23 0 42.2-16.2 46.9-37.8z"]
};
const faWreathLaurel = {
  prefix: 'fass',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M144 112C144 50.1 194.1 0 256 0l32 0 0 32c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176l72 0 5.7 0 5.1 2.5 64 32-21.5 42.9L386.3 480 320 480s0 0 0 0l-66.3 0-58.9 29.5-21.5-42.9 33.9-17c-5.1-3-10.1-6.1-14.9-9.5c-59.6 28.2-131.9 6.3-165.4-51.8l-16-27.7 13.9-8c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224l0-32 16 0c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l16-27.7 13.9 8C115 63.7 133.8 86.8 144 113l0-1zm315 31.9C399.5 141.3 352 92.2 352 32l0-32 32 0c61.9 0 112 50.1 112 112l0 1c10.2-26.2 29-49.2 55.3-64.4l13.9-8 16 27.7c24.5 42.4 21.9 93.1-2.3 131.9c14.1-5.3 29.3-8.2 45.2-8.2l16 0 0 32c0 49-27.5 91.6-68 113.1c14.8 2.4 29.5 7.5 43.3 15.5l13.9 8-16 27.7c-22.4 38.8-62.1 61.4-103.7 63.8L481 437.9l-18.4-9.2-30.4-15.2-17.9-9C463.4 373.3 496 318.5 496 256c0-40.6-13.1-79.9-37-112.1z"]
};
const faCircleExclamationCheck = {
  prefix: 'fass',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M506.5 203L480 229.5l-18.7-18.7L416 165.5 325.5 256l45.3 45.3 64 64 33.7 33.7C422.4 467.1 344.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C379.2 0 482.1 87 506.5 203zM280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zM232 320l0 48 48 0 0-48-48 0zM617 209L489 337l-17 17-17-17-64-64-17-17L408 222.1l17 17 47 47L583 175l17-17L633.9 192l-17 17z"]
};
const faWind = {
  prefix: 'fass',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 0l0 64 32 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128 0 128l0 64 32 0 320 0c53 0 96-43 96-96s-43-96-96-96L320 0 288 0zm64 416l32 0 32 0c53 0 96-43 96-96s-43-96-96-96L32 224 0 224l0 64 32 0 384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0 0 64zM128 512l32 0c53 0 96-43 96-96s-43-96-96-96L32 320 0 320l0 64 32 0 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0 0 64 32 0z"]
};
const faBoxDollar = {
  prefix: 'fass',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M208 32l0 128L0 160 64 32l144 0zm32 0l144 0 64 128-208 0 0-128zM0 192l448 0 0 288L0 480 0 192zm244 48l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.2l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3z"]
};
const faBoxUsd = faBoxDollar;
const faCarBurst = {
  prefix: 'fass',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M218.2 88.5L176 0 133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2 100 236.6l-.4 98 58.4-47 4.2-15.5 24.8-92.7 8.3-30.9 30.9 8.3 14.4 3.9 60-76.3 10.8-13.7 2.1-4.4L218.2 88.5zM280.3 162l-27.5 35s0 0 0 0L218 187.6s0 0 0 0l-8.3 30.9-16.6 61.8-1.4 5.4-15.1 56.4L160 404l77.3 20.7 16.6-61.8 247.3 66.3L484.6 491l77.3 20.7 16.6-61.8L595 388l24.8-92.7L585 286 568.1 169l-3-20.9-20.4-5.5L359.3 93l-20.4-5.5-13 16.6L280.3 162zM507.8 199l9.9 68.9L320 215l43.1-54.7L507.8 199zm-227 63.4a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"]
};
const faCarCrash = faCarBurst;
const faY = {
  prefix: 'fass',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M1.1 32L160 296.9 160 448l0 32 64 0 0-32 0-151.1L382.9 32l-74.6 0L192 225.8 75.7 32 1.1 32z"]
};
const faUserHeadset = {
  prefix: 'fass',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192l0 32-32 0 0-32C32 86 118 0 224 0S416 86 416 192l0 112 0 16-16 0-128 0-48 0-48 0 0-64 96 0 0 32 112 0 0-96c0-88.4-71.6-160-160-160zM0 512L48 352l96 0 32 0 48 0 48 0 128 0 48 160L0 512zM144 291.9c-29.3-23.5-48-59.5-48-99.9c0-70.7 57.3-128 128-128s128 57.3 128 128c0 23.3-6.2 45.2-17.1 64L304 256l0-32-32 0-96 0-32 0 0 32 0 35.9z"]
};
const faArrowsRetweet = {
  prefix: 'fass',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M150.6 73.4L128 50.7 105.4 73.4l-80 80L2.7 176 48 221.3l22.6-22.6L96 173.3 96 384l0 32 32 0 176 0 32 0 0-64-32 0-144 0 0-178.7 25.4 25.4L208 221.3 253.3 176l-22.6-22.6-80-80zM336 96l-32 0 0 64 32 0 144 0 0 178.7-25.4-25.4L432 290.7 386.7 336l22.6 22.6 80 80L512 461.3l22.6-22.6 80-80L637.3 336 592 290.7l-22.6 22.6L544 338.7 544 128l0-32-32 0L336 96z"]
};
const faRetweetAlt = faArrowsRetweet;
const faPersonSnowboarding = {
  prefix: 'fass',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM227.4 110.3l-40-80L244.6 1.7l33 66 64.7 12.9 7.4 1.5 6 4.6 144 112 25.3 19.6-39.3 50.5-25.3-19.6-72.1-56.1-71.5 31.8 55.8 46.5L387.6 284l-4.4 19.2-24 104-5.8 25 83 31.8 35.6 0 24 0 0 48-24 0-40 0-4.4 0-4.1-1.6-376-144-4.8-1.8L39 361 7 329l-17-17L24 278.1l17 17 28.4 28.4 29.9 11.4L87.5 299.8l30.4-10.1L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-22.8-4.6-15.3-3.1-7-14zM139 350.1l154.1 59 3.8-16.3L316.4 308 256 257.7l0 30.3 0 23.1-21.9 7.3L139 350.1z"]
};
const faSnowboarding = faPersonSnowboarding;
const faSquareChevronRight = {
  prefix: 'fass',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M448 480l0-448L0 32 0 480l448 0zM313 273L209 377l-17 17L158.1 360l17-17 87-87-87-87-17-17L192 118.1l17 17L313 239l17 17-17 17z"]
};
const faChevronSquareRight = faSquareChevronRight;
const faLacrosseStickBall = {
  prefix: 'fass',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M336 64s0 0 0 0l.3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3c0 0 0 0 0 0c0 33.1-21.9 62.1-53.7 71.2l-35.1 10L353 259l-5 4-54 43.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2L249 164l4-5 1.8-6.2 10-35.1C273.9 85.9 302.9 64 336 64zm0-64s0 0 0 0C274.4 0 220.2 40.9 203.3 100.1L195 129l-39.2 49c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-120 120L2.7 464 48 509.3l22.6-22.6 120-120c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8L383 317l28.9-8.3C471.1 291.8 512 237.6 512 176c0 0 0 0 0 0l0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0L336 0zM496 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faTruckFast = {
  prefix: 'fass',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M416 0L64 0l0 96L0 96l0 32 64 0 224 0 0 32L64 160l-32 0 0 32 32 0 192 0 0 32L64 224 0 224l0 32 64 0 160 0 0 32L64 288l0 128c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 237.3l0 18.7-128 0 0-96 50.7 0L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faShippingFast = faTruckFast;
const faUserMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512l-9.9-32.3C354.3 474.6 288 405 288 320c0-5.4 .3-10.7 .8-16L64 304 0 512l448 0zm0-271.9a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faStarSharp = {
  prefix: 'fass',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M288.1 0l63.5 195.6H557.2L390.9 316.4 454.4 512 288.1 391.1 121.7 512l63.5-195.6L18.9 195.6H224.5L288.1 0z"]
};
const faCommentHeart = {
  prefix: 'fass',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM368 203.2c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 336.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7z"]
};
const faCircle1 = {
  prefix: 'fass',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 80l0 48 24 0 56 0 56 0 24 0 0-48-24 0-32 0 0-184 0-24-24 0-8 0-6.2 0-5.4 3L176 164.5l0 54.9 11.7-6.5L232 188.3 232 336l-32 0-24 0z"]
};
const faCircleStar = {
  prefix: 'fass',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm47-320.7l105.1 15.3-76.1 74.2 18 104.7L256 336l-94 49.4 18-104.7-76.1-74.2L209 191.3 256 96l47 95.3z"]
};
const faStarCircle = faCircleStar;
const faFish = {
  prefix: 'fass',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M336 80c-89.4 0-153.8 54.9-193.2 103.4L32 128 0 160l48 96L0 352l32 32 110.8-55.4C182.2 377.1 246.6 432 336 432c160 0 240-176 240-176s-80-176-240-176zm80 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCloudFog = {
  prefix: 'fass',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M160 320l-96 0 0-96c0-41.8 26.7-77.4 64-90.5l0-21.5C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0-320 0zM0 368l24 0 528 0 24 0 0 48-24 0L24 416 0 416l0-48zm64 96l24 0 112 0 24 0 0 48-24 0L88 512l-24 0 0-48zm208 0l24 0 320 0 24 0 0 48-24 0-320 0-24 0 0-48z"]
};
const faFog = faCloudFog;
const faWaffle = {
  prefix: 'fass',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-64 80 0 16 0 0-32-16 0-80 0 0-64 48 0 16 0 0-32-16 0-48 0 0-48 0-16-32 0 0 16 0 48-64 0 0-80 0-16-32 0 0 16 0 80-64 0 0-48 0-16zm0 256l0-64 64 0 0 64-64 0zm96 0l0-64 64 0 0 64-64 0zm64-160l0 64-64 0 0-64 64 0zm-96 0l0 64-64 0 0-64 64 0z"]
};
const faMusicNote = {
  prefix: 'fass',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 44.8l0-41-39.8 9.9-128 32L192 51.8l0 25 0 64 0 218.9c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-266.2 103.8-25.9 24.2-6.1 0-25 0-64z"]
};
const faMusicAlt = faMusicNote;
const faHexagonExclamation = {
  prefix: 'fass',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zM280 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 320l0 48 48 0 0-48-48 0z"]
};
const faCartShoppingFast = {
  prefix: 'fass',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64 0L88 0l72 0 19.9 0 3.7 19.5L186 32l454 0L560 288l-325.3 0 9.1 48L552 336l24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L140.1 48 88 48 64 48 64 0zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 144L0 96l112 0 0 48L0 144zm0 80l0-48 128 0 0 48L0 224zm0 80l0-48 144 0 0 48L0 304z"]
};
const faObjectUnion = {
  prefix: 'fass',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M352 0L0 0 0 352l160 0 0 160 352 0 0-352-160 0L352 0z"]
};
const faUserGraduate = {
  prefix: 'fass',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M448 48L224 0 0 48 0 80l16 3.4L16 168 0 256l64 0L48 168l0-77.7 48 10.3L96 160c0 70.7 57.3 128 128 128s128-57.3 128-128l0-59.4L448 80l0-32zM126.1 320L64 320 0 512l448 0L384 320l-62.1 0L224 424 126.1 320z"]
};
const faStarfighter = {
  prefix: 'fass',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M352 0l32 256 0 224-128 0 0-224L288 0l64 0zM288 256l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM72 72l0 24 0 24 24 0 0 48-24 0 0 184 56 0 0-64 96 0 0 64 0 64 0 32 0 32 0 32-64 0 0-32 0-12.8L72 432l0 16 0 24-48 0 0-24 0-280L0 168l0-48 24 0 0-24 0-24 48 0zm544 0l0 24 0 24 24 0 0 48-24 0 0 280 0 24-48 0 0-24 0-16-88 35.2 0 12.8 0 32-64 0 0-32 0-32 0-32 0-64 0-64 96 0 0 64 56 0 0-184-24 0 0-48 24 0 0-24 0-24 48 0z"]
};
const faCircleHalfStroke = {
  prefix: 'fass',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faAdjust = faCircleHalfStroke;
const faArrowRightLongToLine = {
  prefix: 'fass',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 96l0-32-64 0 0 32 0 320 0 32 64 0 0-32 0-320zM512 256l-22.6-22.6-128-128L338.7 82.7 293.5 128l22.6 22.6L389.5 224 32 224 0 224l0 64 32 0 357.5 0-73.4 73.4L293.5 384l45.3 45.3 22.6-22.6 128-128L512 256z"]
};
const faSquareArrowDown = {
  prefix: 'fass',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M448 480L0 480 0 32l448 0 0 448zM241 409L353 297l17-17L336 246.1l-17 17-71 71L248 120l0-24-48 0 0 24 0 214.1-71-71-17-17L78.1 280l17 17L207 409l17 17 17-17z"]
};
const faArrowSquareDown = faSquareArrowDown;
const faDiamondHalfStroke = {
  prefix: 'fass',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M0 256l45.3 45.3L210.7 466.7 256 512l45.3-45.3L466.7 301.3 512 256l-45.3-45.3L301.3 45.3 256 0 210.7 45.3 45.3 210.7 0 256zM256 421.5l0-331L421.5 256 256 421.5z"]
};
const faClapperboard = {
  prefix: 'fass',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M361.9 32l-1 1-127 127 92.1 0 1-1 127-127-92.1 0zM512 160l0-118.1L393.9 160 512 160zM294.1 32l-92.1 0-1 1L73.9 160l92.1 0 1-1 127-127zM0 32L0 160l6.1 0 1-1 127-127L0 32zM512 192L0 192 0 480l512 0 0-288z"]
};
const faSquareChevronLeft = {
  prefix: 'fass',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M0 32L0 480l448 0 0-448L0 32zM135 239L239 135l17-17L289.9 152l-17 17-87 87 87 87 17 17L256 393.9l-17-17L135 273l-17-17 17-17z"]
};
const faChevronSquareLeft = faSquareChevronLeft;
const faPhoneIntercom = {
  prefix: 'fass',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M128 32l0 448L0 480 0 32l128 0zm32 0l352 0 0 448-352 0 0-448zM320 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-48l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm0 64l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zM224 96l0 160 224 0 0-160L224 96z"]
};
const faLinkHorizontal = {
  prefix: 'fass',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M144 64C64.5 64 0 128.5 0 208s64.5 144 144 144l16 0 0-64-16 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l160 0c44.2 0 80 35.8 80 80c0 36.2-24.1 66.8-57.1 76.7c-3.7 1.1-7.5 1.9-11.4 2.5l9.1 63.4c7-1 13.9-2.5 20.6-4.5C404.6 328.3 448 273.3 448 208c0-79.5-64.5-144-144-144L144 64zM496 448c79.5 0 144-64.5 144-144s-64.5-144-144-144l-16 0 0 64 16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-160 0c-44.2 0-80-35.8-80-80c0-36.2 24.1-66.8 57.1-76.7c3.7-1.1 7.5-1.9 11.4-2.5l-9.1-63.4c-7 1-13.9 2.5-20.6 4.5C235.4 183.7 192 238.7 192 304c0 79.5 64.5 144 144 144l160 0z"]
};
const faChainHorizontal = faLinkHorizontal;
const faMango = {
  prefix: 'fass',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M184.2 152.2C221.7 114.7 270.9 96 320 96l0-72 0-24 32 0 16 0 8 0 64 0c39.8 0 72 32.2 72 72l0 24-24 0-40 0c-33.4 0-62.8-17-80-42.9l0 49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3L0 448l0-64 24.7-18.5c34.3-25.7 52.1-59.4 71.1-95.4c20.6-38.9 42.6-80.6 88.4-117.9zM400 288c0 61.9-50.1 112-112 112l0 32c79.5 0 144-64.5 144-144l-32 0z"]
};
const faMusicNoteSlash = {
  prefix: 'fass',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M48.4 14.8L29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7L384 275.4l0-109.6 103.8-25.9 24.2-6.1 0-25 0-64 0-41-39.8 9.9-128 32L320 51.8l0 25 0 64 0 84.9L48.4 14.8zM384 411.2L317.8 359c-14-4.5-29.5-7-45.8-7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-20.9z"]
};
const faMusicAltSlash = faMusicNoteSlash;
const faCircleRadiation = {
  prefix: 'fass',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-52-90.1C128.2 145.1 96 196.8 96 256l104 0zm28 48.5l-52 90.1c23.5 13.6 50.9 21.4 80 21.4s56.5-7.8 80-21.4l-52-90.1c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l104 0c0-59.2-32.2-110.9-80-138.6l-52 90.1c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faRadiationAlt = faCircleRadiation;
const faFaceTongueSweat = {
  prefix: 'fass',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448l0-31.3c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7l0 31.3c0 18.6 5.3 36 14.5 50.8c-41.4-13.9-78.1-38.1-107-69.5C116.9 414.5 128 392.6 128 368c0-17.3-5.6-34.2-16-48L73.6 268.8 48 234.7 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256zM96 368c0 14.5-6.5 27.6-16.7 36.4C70.9 411.6 60 416 48 416c-26.5 0-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8l26.8-35.7L48 288l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8zm239.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm31-144L216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4L238.6 160zm110.1 11.3l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160l11.3 11.3zM352 384l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0z"]
};
const faGlobeStand = {
  prefix: 'fass',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M23 359l-17 17L40 409.9l17-17 10.5-10.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3L64 464l0 48 288 0 0-48-120 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L393 57l17-17L376 6.1 359 23 332.5 49.6l-17 17 17 17c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0l-17-17-17 17L23 359zm185-7a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
const faBaseball = {
  prefix: 'fass',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M77.4 221.6C67.8 223.2 58 224 48 224c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 10-.8 19.8-2.4 29.4l31.6 5.3C255 71.4 256 59.8 256 48c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-11.8 0-23.4 1-34.6 2.9l5.3 31.6c9.5-1.6 19.3-2.4 29.4-2.4c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-10 .8-19.8 2.4-29.4l-31.6-5.3C257 440.6 256 452.2 256 464c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c11.8 0 23.4-1 34.6-2.9l-5.3-31.6zM214 106.7c-17.3 48.9-55.6 87.9-104.1 106.1l11.3 30c57.3-21.5 102.6-67.6 123-125.4L214 106.7zM402.1 299.2l-11.3-30c-57.3 21.5-102.6 67.6-123 125.4L298 405.3c17.3-48.9 55.6-87.9 104.1-106.1z"]
};
const faBaseballBall = faBaseball;
const faCircleP = {
  prefix: 'fass',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24 24 0zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z"]
};
const faAwardSimple = {
  prefix: 'fass',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M192 0l44.2 26.9L288 25.7l24.8 45.4L358.3 96l-1.2 51.8L384 192l-26.9 44.2 1.2 51.8-45.4 24.8L288 358.3l-51.8-1.2L192 384l-44.2-26.9L96 358.3 71.2 312.8 25.7 288l1.2-51.8L0 192l26.9-44.2L25.7 96 71.2 71.2 96 25.7l51.8 1.2L192 0zm80 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64 512L92.6 388l42.8-1 39.9 24.3L192 421.5l16.6-10.1L248.5 387l42.8 1L320 512 192 480 64 512z"]
};
const faJetFighterUp = {
  prefix: 'fass',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M0 392l0 24 48 0 0-24 0-8 144 0 0 32-64 64 0 32 112 0 0-48 0-16 32 0 0 16 0 48 112 0 0-32-64-64 0-32 144 0 0 8 0 24 48 0 0-24 0-112 0-24-48 0 0 24 0 16L320 216l0-88L272 0 240 0 192 128l0 88L48 296l0-16 0-24L0 256l0 24L0 392z"]
};
const faDiagramProject = {
  prefix: 'fass',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M0 32l192 0 0 64 192 0 0-64 192 0 0 192-192 0 0-64-192 0 0 21.3L272 288l144 0 0 192-192 0 0-149.3L144 224 0 224 0 32z"]
};
const faProjectDiagram = faDiagramProject;
const faPedestal = {
  prefix: 'fass',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M416 0L32 0l0 416 384 0L416 0zM120 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 448L0 448l0 64 32 0 384 0 32 0 0-64-32 0L32 448z"]
};
const faChartPyramid = {
  prefix: 'fass',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M91.4 320l329.1 0L347.4 192l-182.9 0L91.4 320zM73.1 352L0 480l512 0L438.9 352 73.1 352zM256 32L182.9 160l146.3 0L256 32z"]
};
const faSidebar = {
  prefix: 'fass',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M0 32l512 0 0 448L0 480 0 32zM224 96l0 320 224 0 0-320L224 96zm-64 0L64 96l0 48 96 0 0-48zM64 192l0 48 96 0 0-48-96 0zm96 96l-96 0 0 48 96 0 0-48z"]
};
const faSnowmanHead = {
  prefix: 'fass',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M64 0L384 0l0 160-160 0L64 160 64 0zM330.2 192l85.8 0 32 0 0 64-32 0-25.7 0c16.3 28.2 25.7 61 25.7 96c0 66.8-34.1 125.6-85.8 160l-212.3 0C66.1 477.6 32 418.8 32 352c0-35 9.3-67.8 25.7-96L32 256 0 256l0-64 32 0 85.8 0 212.3 0zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 448l27.8-48.7c2.7-4.8 4.2-10.2 4.2-15.7c0-17.5-14.2-31.6-31.6-31.6l-.8 0c-17.5 0-31.6 14.2-31.6 31.6c0 5.5 1.4 10.9 4.2 15.7L224 448z"]
};
const faFrostyHead = faSnowmanHead;
const faCopy = {
  prefix: 'fass',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M352 0l96 96 0 288-288 0L160 0 352 0zM64 128l64 0 0 64-64 0 0 256 192 0 0-32 64 0 0 32 0 64-64 0L64 512 0 512l0-64L0 192l0-64 64 0z"]
};
const faBurgerGlass = {
  prefix: 'fass',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M76.7 160L69.2 64l245.6 0-7.5 96L76.7 160zM40 512l216 0 0-229.4c3-9.1 6.7-17.5 11.6-25.9c6.6-11.3 17-25.9 32.7-40.4c17.2-15.9 40.1-31 70.1-41.6L379 64l5-64L319.8 0 64.2 0 0 0 5 64 40 512zM640 287.8s-32-96-176-96s-176 96-176 96l0 32 352 0 0-32zm-256-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-256 112l0 64 352 0 0-64-352 0zm0 96l0 64 352 0 0-64-352 0z"]
};
const faVolumeXmark = {
  prefix: 'fass',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M0 160L0 352l128 0L272 480l48 0 0-448-48 0L128 160 0 160zm441 23l-17-17L390.1 200l17 17 39 39-39 39-17 17L424 345.9l17-17 39-39 39 39 17 17L569.9 312l-17-17-39-39 39-39 17-17L536 166.1l-17 17-39 39-39-39z"]
};
const faVolumeMute = faVolumeXmark;
const faVolumeTimes = faVolumeXmark;
const faHandSparkles = {
  prefix: 'fass',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M352 32l0-32L288 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6l-43.6-41.5-29-27.6L64.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c44.4 0 84.9-16.4 115.9-43.5L448 453.1l0-42.2 63.6-27.3L544 308.1 544 128l0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224zM288 352l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16zM56 120L0 144l56 24 24 56 24-56 56-24-56-24L80 64 56 120zM560 352l-24 56-56 24 56 24 24 56 24-56 56-24-56-24-24-56z"]
};
const faBarsFilter = {
  prefix: 'fass',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 64l448 0 0 64L0 128 0 64zM64 224l320 0 0 64L64 288l0-64zM288 384l0 64-128 0 0-64 128 0z"]
};
const faPaintbrushPencil = {
  prefix: 'fass',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M297.8 153.8L224 80 144 0 32 112 176 256c6.2 0 12.4 .4 18.4 1.2L297.8 153.8zM320 400l80 80 144 32L512 368l-89.8-89.8L318.8 381.6c.8 6 1.2 12.2 1.2 18.4zM535.6 119.6L575.2 80 496 .8 456.4 40.4 227.7 269.1l79.2 79.2L535.6 119.6zM205 291.8c-9.3-2.5-19-3.8-29-3.8c-61.9 0-112 50.1-112 112l0 48L0 448l0 64 176 0c61.9 0 112-50.1 112-112c0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1 .1z"]
};
const faPartyBell = {
  prefix: 'fass',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M65.6 382.4c-87.5-87.5-87.5-229.3 0-316.8s229.3-87.5 316.8 0L65.6 382.4zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM376 150.1l17 17 8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3-5.3 47.7-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201l-17-17L376 150.1zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4-47.7 5.3-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393l-17-17L184 342.1l17 17zM469.7 503.5l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8c.2-7.6-2.4-15-7.3-20.7l-8.5-10-15.5-18.3 36.6-31 15.5 18.3 8.5 10c12.5 14.8 19.1 33.7 18.6 53c-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8c-.2 7.6 2.4 15 7.3 20.7l8.5 10-36.6 31z"]
};
const faUserVneckHair = {
  prefix: 'fass',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zm0 424L150.6 320 64 320 0 512l448 0L384 320l-86.6 0L224 424z"]
};
const faJackOLantern = {
  prefix: 'fass',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M288 96c-18.1 0-35.5 2.7-51.9 7.8L288 0l64 32 0 76c-19.8-7.7-41.4-12-64-12zm146 77.7c-10.9-16.1-24.3-30.3-39.8-42c9.6-2.4 19.6-3.7 29.8-3.7c83.9 0 152 86 152 192s-68.1 192-152 192c-24.4 0-47.5-7.3-68-20.2c-20.5 12.9-43.6 20.2-68 20.2s-47.5-7.3-68-20.2c-20.5 12.9-43.6 20.2-68 20.2C68.1 512 0 426 0 320S68.1 128 152 128c10.2 0 20.1 1.3 29.8 3.7c-15.4 11.7-28.9 25.9-39.8 42c41.4-28.8 91.7-45.7 146-45.7s104.6 16.9 146 45.7zM208 208l-48 80 96 0-48-80zm160 0l-48 80 96 0-48-80zm0 228.2l0-36.2 48 0 0 12.4c53.8-37.9 64-92.4 64-92.4s-80 48-192 48l0 32-48 0 0-34.9C153.8 354.7 96 320 96 320s10.2 54.6 64 92.4l0-12.4 48 0 0 36.2c22.1 7.3 48.5 11.8 80 11.8s57.9-4.5 80-11.8z"]
};
const faGrip = {
  prefix: 'fass',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M128 96L0 96 0 224l128 0 0-128zm0 192L0 288 0 416l128 0 0-128zM160 96l0 128 128 0 0-128L160 96zM288 288l-128 0 0 128 128 0 0-128zM320 96l0 128 128 0 0-128L320 96zM448 288l-128 0 0 128 128 0 0-128z"]
};
const faGripHorizontal = faGrip;
const faShareFromSquare = {
  prefix: 'fass',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M416 320l-32 0 0-96-16 0-17.5 0c-52.2 0-94.5 42.3-94.5 94.5c0 39.3 32 65.5 32 65.5s-128-39.3-128-144c0-79.5 64.5-144 144-144l80 0 0-96 32 0L576 160 416 320zM0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 352 352 0 0-32 0-32 64 0 0 32 0 64 0 32-32 0L32 512 0 512l0-32L0 64 0 32z"]
};
const faShareSquare = faShareFromSquare;
const faKeynote = {
  prefix: 'fass',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M304 0L208 0l0 24-24 0c-48.6 0-88 39.4-88 88l0 48-32 0L0 288l0 64 512 0 0-64L448 160l-304 0 0-48c0-22.1 17.9-40 40-40l24 0 0 24 96 0c26.5 0 48-21.5 48-48s-21.5-48-48-48zM224 448l-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-64-64 0 0 64z"]
};
const faChildCombatant = {
  prefix: 'fass',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-43.1 32l-16 0-9.6 12.8-72.1 96L16 294.4l51.2 38.4 19.2-25.6L96 294.4 96 480l0 32 64 0 0-32 0-96 32 0 0 96 0 32 64 0 0-32 0-185.6 9.6 12.8 19.2 25.6L336 294.4l-19.2-25.6-72.1-96L235.1 160l-16 0-86.2 0zM464 0L448 0 416 0 400 0l0 32 16 0 0 96-16 0 0 64-32 0 0 208 48 0 0 112 96 0L484 400l60 0 0-48-64 0 0-26.7L544 304l0-112-48 0 0 72-16 5.3L480 128l-16 0L464 0z"]
};
const faChildRifle = faChildCombatant;
const faGun = {
  prefix: 'fass',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 32l0 24 0 8 48 0 0 144-96 0-32 32-47.1 0-34.3 96.1L360.9 352 344 352l-120 0L192 480 32 480 92 240 0 240 0 64l480 0 0-8 0-24 48 0zM327.1 304l22.9-64L252 240l-16 64 91.1 0zM480 128L64 128l0 32 416 0 0-32z"]
};
const faSquarePhone = {
  prefix: 'fass',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M448 32L0 32 0 480l448 0 0-448zM168 128l40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L280 272l72 40-16 72-16 0C196.3 384 96 283.7 96 160l0-16 72-16z"]
};
const faPhoneSquare = faSquarePhone;
const faHatBeach = {
  prefix: 'fass',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M320 448c176.7 0 320-57.3 320-128l0-32-65.1-26c.7 4.2 1.1 8.5 1.1 12.8c0 42.7-34.6 77.3-77.3 77.3c-12.2 0-24.1-2.9-34.7-8.3c-10.7 5.4-22.6 8.3-34.7 8.3c-38.6 0-70.6-28.3-76.3-65.4c-10.6 .9-21.6 1.4-32.9 1.4c-88.4 0-160-28.7-160-64c0 0 0 0 0 0L0 288l0 32c0 70.7 143.3 128 320 128zm32-242.7c0-42.7 34.6-77.3 77.3-77.3c7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2C174.7 201.3 240.1 224 320 224c11.7 0 23-.5 34-1.4c-1.3-5.6-2-11.5-2-17.3zM473.1 168l-9.1 6.3-9.1-6.3c-7.5-5.2-16.4-8-25.7-8c-25 0-45.3 20.3-45.3 45.3c0 9.2 2.8 18.2 8 25.7l6.2 9.1-6.2 9.1c-5.2 7.5-8 16.4-8 25.7c0 25 20.3 45.3 45.3 45.3c9.2 0 18.2-2.8 25.7-8l9.1-6.3 9.1 6.3c7.5 5.2 16.4 8 25.7 8c25 0 45.3-20.3 45.3-45.3c0-9.2-2.8-18.2-8-25.7l-6.2-9.1 6.2-9.1c5.2-7.5 8-16.4 8-25.7c0-25-20.3-45.3-45.3-45.3c-9.2 0-18.2 2.8-25.7 8zM464 272l-32-32 32-32 32 32-32 32z"]
};
const faPlus = {
  prefix: 'fass',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z"]
};
const faAdd = faPlus;
const faExpand = {
  prefix: 'fass',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M32 32L0 32 0 64l0 96 0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0L32 32zM64 352l0-32L0 320l0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64zM320 32l-32 0 0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0zM448 352l0-32-64 0 0 32 0 64-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-96z"]
};
const faComputer = {
  prefix: 'fass',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 96l0 224L64 320 64 96l320 0zM64 32L0 32 0 96 0 320l0 64 64 0 117.3 0-10.7 32L64 416l0 64 320 0 0-64-106.7 0-10.7-32L384 384l64 0 0-64 0-224 0-64-64 0L64 32zm576 0L480 32l0 448 160 0 0-448zM544 96l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zm-16 64l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zm32 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFort = {
  prefix: 'fass',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M0 0L64 0l0 64 32 0L96 0l64 0 0 64 32 0 0-64 64 0 0 64 0 64 0 32 128 0 0-32 0-64 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 0 64 0 64-32 32 0 288-224 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L32 512l0-288L0 192l0-64L0 64 0 0z"]
};
const faCloudCheck = {
  prefix: 'fass',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zM433 241l17-17L416 190.1l-17 17-111 111-47-47-17-17L190.1 288l17 17 64 64 17 17 17-17L433 241z"]
};
const faXmark = {
  prefix: 'fass',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M326.6 166.6L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4z"]
};
const faClose = faXmark;
const faMultiply = faXmark;
const faRemove = faXmark;
const faTimes = faXmark;
const faFaceSmirking = {
  prefix: 'fass',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-64l0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0-16 0zM375.8 338.6l2.6-15.8-31.6-5.3-2.6 15.8-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4L192 368l-16 0 0 32 16 0 112.6 0c35.2 0 65.2-25.4 71-60.2l.2-1.2zM288 192l0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0-16 0z"]
};
const faArrowsUpDownLeftRight = {
  prefix: 'fass',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M278.6 25.4L256 2.7 233.4 25.4l-56 56L154.7 104 200 149.3l22.6-22.6 1.4-1.4 0 98.7-98.7 0 1.4-1.4L149.3 200 104 154.7 81.4 177.4l-56 56L2.7 256l22.6 22.6 56 56L104 357.3 149.3 312l-22.6-22.6-1.4-1.4 98.7 0 0 98.7-1.4-1.4L200 362.7 154.7 408l22.6 22.6 56 56L256 509.3l22.6-22.6 56-56L357.3 408 312 362.7l-22.6 22.6-1.4 1.4 0-98.7 98.7 0-1.4 1.4L362.7 312 408 357.3l22.6-22.6 56-56L509.3 256l-22.6-22.6-56-56L408 154.7 362.7 200l22.6 22.6 1.4 1.4L288 224l0-98.7 1.4 1.4L312 149.3 357.3 104 334.6 81.4l-56-56z"]
};
const faArrows = faArrowsUpDownLeftRight;
const faChalkboardUser = {
  prefix: 'fass',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M192 0L160 0l0 32 0 64c23.3 0 45.2 6.2 64 17.1L224 64l352 0 0 288-64 0 0-64-128 0 0 64-78.6 0 19.2 64L608 416l32 0 0-32 0-352 0-32L608 0 192 0zM160 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM320 512L272 352 48 352 0 512l320 0z"]
};
const faChalkboardTeacher = faChalkboardUser;
const faRhombus = {
  prefix: 'fass',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M0 256L224 512 448 256 224 0 0 256z"]
};
const faClawMarks = {
  prefix: 'fass',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M80 2.7l22.6 22.6 80 80 64 64 160 160 64 64 48 48L541.3 464 496 509.3l-22.6-22.6L434.7 448 384 448l-32 0 0-32 0-50.7L210.7 224 160 224l-32 0 0-32 0-50.7L57.4 70.6 34.7 48 80 2.7zm0 224l22.6 22.6 48 48 96 96 48 48L317.3 464 272 509.3l-22.6-22.6L210.7 448 128 448l-32 0 0-32 0-82.7L57.4 294.6 34.7 272 80 226.7zM326.6 25.4l16 16 64 64 64 64 64 64 16 16L573.3 272 528 317.3l-22.6-22.6-6.6-6.6L448 288l-32 0 0-32 0-50.7L370.7 160 320 160l-32 0 0-32 0-50.7-6.6-6.6L258.7 48 304 2.7l22.6 22.6z"]
};
const faPesoSign = {
  prefix: 'fass',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M64 32L32 32l0 32 0 64L0 128l0 64 32 0 0 32L0 224l0 64 32 0 0 64 0 128 64 0 0-96 80 0c68.4 0 127.7-39 156.8-96l51.2 0 0-64-32.7 0c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16l32.7 0 0-64-51.2 0C303.7 71 244.4 32 176 32L64 32zm190.4 96L96 128l0-32 80 0c30.5 0 58.2 12.2 78.4 32zM96 192l190.9 0c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16L96 224l0-32zm158.4 96c-20.2 19.8-47.9 32-78.4 32l-80 0 0-32 158.4 0z"]
};
const faFaceSmileTongue = {
  prefix: 'fass',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M418.1 454.1c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9l30.9-8.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1l5.4-20.2L424 274.1l65.7 37.9c5 2.9 9.6 6.2 13.7 10c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c61.5 0 118-21.7 162.1-57.9zm8.1-31.8c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6l55.7 33.1zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z"]
};
const faCartCircleXmark = {
  prefix: 'fass',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 160.7 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-143 0-9.1-48 168.5 0c29.1-57 88.4-96 156.8-96c10 0 19.7 .8 29.2 2.4L576 32 122 32l-2.4-12.5L115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z"]
};
const faBuildingShield = {
  prefix: 'fass',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M0 0L384 0l0 208.3L343.4 224 320 224l-48 0-16 0 0 16 0 17.8 0 30.2 0 8 0 8c0 .9 .1 1.8 .2 2.7c3 74 37.4 156.5 105.9 205.3L240 512l0-128-96 0 0 128L0 512 0 0zM128 224l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM64 96l0 64 64 0 0-64L64 96zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM527.3 312.4L432 275.5l0 184.9c56.5-26.3 90.2-87 95.3-148zM432 512c-96-32-144-130.2-144-216l0-16.2L432 224l144 55.8 0 16.2c0 85.8-48 184-144 216z"]
};
const faCirclePhoneFlip = {
  prefix: 'fass',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm56 128l-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L200 272l-72 40 16 72 16 0c123.7 0 224-100.3 224-224l0-16-72-16z"]
};
const faPhoneCircleAlt = faCirclePhoneFlip;
const faBaby = {
  prefix: 'fass',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM63.2 112.1l32.3 23.5L173 192l102 0 77.5-56.3 32.3-23.5 47.1 64.7-32.3 23.5L320 258.2l0 29.8-35.8 0-.9 0-118.5 0-.9 0L128 288l0-29.8L48.5 200.3 16.1 176.8l47.1-64.7zm65.3 216.3l60.2 52.7L165 408.2l17.3 20.1 26.1 30.3-60.6 52.2-26.1-30.3-40-46.4L59 407.8l22.9-26.1 46.6-53.2zm130.8 52.7l60.2-52.7 46.6 53.2L389 407.8l-22.7 26.3-40 46.4-26.1 30.3-60.6-52.2 26.1-30.3L283 408.2l-23.7-27.1z"]
};
const faUsersLine = {
  prefix: 'fass',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 192L32 288l135.4 0 28.2-75.2 7.8-20.8L64 192zm411.8 96L608 288l-32-96-136.2 0 7.8 20.8L475.8 288zm-10.2 64l-24-64-24-64-12.3 0-170.7 0-9.1 0-24 64-24 64 288 0zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416L0 416l0 64 32 0 576 0 32 0 0-64-32 0L32 416z"]
};
const faQuoteLeft = {
  prefix: 'fass',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192L0 416l0-96 0-96 0-8zm256 0c0-66.3 53.7-120 120-120l8 0 32 0 0 64-32 0-8 0c-30.9 0-56 25.1-56 56l0 8 128 0 0 192-192 0 0-96 0-96 0-8z"]
};
const faQuoteLeftAlt = faQuoteLeft;
const faTractor = {
  prefix: 'fass',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M96 0l32 0L288 0l21.7 0 8 20.1 56 139.9L480 160l0-64 0-7.6 3.4-6.8 16-32 14.3-28.6 57.2 28.6L556.6 78.3 544 103.6l0 56.4 96 0 0 96-66.4 57c-14-5.8-29.4-9-45.6-9c-39.3 0-74.1 18.9-96 48l-80 0 0 32-40.2 0c-1.7 4.8-3.7 9.5-5.8 14.1l28.4 28.4-67.9 67.9L238.1 466c-4.6 2.2-9.3 4.1-14.1 5.8l0 40.2-96 0 0-40.2c-4.8-1.7-9.5-3.7-14.1-5.8L85.5 494.4 17.6 426.5 46 398.1c-2.2-4.6-4.1-9.3-5.8-14.1L0 384l0-96 40.2 0c1.7-4.8 3.7-9.5 5.8-14.1L17.6 245.5l67.9-67.9L96 188.1 96 160 96 32 96 0zM266.3 64L160 64l0 96 64 0 80.7 0L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c5.7 0 11.3 .5 16.7 1.6l.1 0c40.6 7.8 71.2 43.5 71.2 86.4c0 48.6-39.4 88-88 88z"]
};
const faDownFromBracket = {
  prefix: 'fass',
  iconName: 'down-from-bracket',
  icon: [448, 512, [], "e66b", "M64 352L224 512 384 352l0-32-96 0 0-160-128 0 0 160-96 0 0 32zm0-192l0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0 0 32 0 160l0 32 64 0 0-32z"]
};
const faKeySkeleton = {
  prefix: 'fass',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L25.4 377.4 2.7 400l22.6 22.6 64 64L112 509.3 157.3 464l-22.6-22.6L93.3 400 112 381.3l41.4 41.4L176 445.3 221.3 400l-22.6-22.6L157.3 336l70.1-70.1c22.2 14 48.5 22.1 76.7 22.1z"]
};
const faTrashArrowUp = {
  prefix: 'fass',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0L392 512 56 512 32 128zm209 71l-17-17-17 17-80 80-17 17L144 329.9l17-17 39-39L200 408l0 24 48 0 0-24 0-134.1 39 39 17 17L337.9 296l-17-17-80-80z"]
};
const faTrashRestore = faTrashArrowUp;
const faArrowDownUpLock = {
  prefix: 'fass',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M128 509.3l22.6-22.6 80-80L253.3 384 208 338.7l-22.6 22.6L160 386.7l0-98.7 224 0 0-.3 32 0 0-15.7c0-17.2 3.9-33.5 10.8-48L352 224l0-98.7 25.4 25.4L400 173.3 445.3 128l-22.6-22.6-80-80L320 2.7 297.4 25.4l-80 80L194.7 128 240 173.3l22.6-22.6L288 125.3l0 98.7-128 0-64 0-64 0L0 224l0 64 32 0 64 0 0 98.7L70.6 361.4 48 338.7 2.7 384l22.6 22.6 80 80L128 509.3zM96 64l0 128 64 0 0-128 0-32L96 32l0 32zM288 448l0 32 64 0 0-32 0-128-64 0 0 128zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faArrowDownToBracket = {
  prefix: 'fass',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M246.6 342.6L224 365.3l-22.6-22.6-128-128L50.7 192 96 146.7l22.6 22.6L192 242.7 192 32l0-32 64 0 0 32 0 210.7 73.4-73.4L352 146.7 397.3 192l-22.6 22.6-128 128zM64 352l0 96 320 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 352l0-32 64 0 0 32z"]
};
const faLinesLeaning = {
  prefix: 'fass',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.5 73.5L200.1 43 139 23.9l-9.5 30.5-120 384L-.1 469 61 488.1l9.5-30.5 120-384zM292.8 37.7L229.7 27.2l-5.3 31.6-64 384-5.3 31.6 63.1 10.5 5.3-31.6 64-384 5.3-31.6zM384 32l-64 0 0 32 0 384 0 32 64 0 0-32 0-384 0-32z"]
};
const faSquareQ = {
  prefix: 'fass',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M448 32L0 32 0 480l448 0 0-448zM224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L206.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80zm0 208c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L369.9 384l-61.5 0-15.9-19.9C272.7 376.7 249.2 384 224 384z"]
};
const faRulerCombined = {
  prefix: 'fass',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M0 512L0 320 0 0 192 0l0 96-80 0L96 96l0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 96 0 0 192-320 0L0 512z"]
};
const faSymbols = {
  prefix: 'fass',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M32 0L192 0l32 0 0 64-32 0L32 64 0 64 0 0 32 0zM484.1 361.2l-128 128-22.6 22.6-45.3-45.3 22.6-22.6 128-128 22.6-22.6 45.3 45.3-22.6 22.6zM0 96l32 0 48 0 64 0 48 0 32 0 0 64-32 0-48 0 0 32 0 32-64 0 0-32 0-32-48 0L0 160 0 96zM288 328a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM472 432a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM512 1l0 39 0 136c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-49L352 98.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-88 0-26.2 25.7-5.1 160-32L512 1zM16 320l0-72 72 0 72 0 0 72c0 21.6-9.5 41-24.5 54.2l14.8 15.7L162.8 376l21.4-23.8 47.5 42.9-21.4 23.7-16 17.7 7.5 8 21.9 23.3-46.6 43.9-21.9-23.3-4-4.2-15.5 17.2L126.2 512 112 512l-80 0L0 512l0-32 0-45.3 0-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320zM67.7 424.3c-2.4 2.6-3.7 6-3.7 9.5l0 .9L64 448l33.8 0 9.5-10.5L81 409.7 67.7 424.3zM88 336c8.8 0 16-7.2 16-16l0-16-32 0 0 16c0 8.8 7.2 16 16 16z"]
};
const faIconsAlt = faSymbols;
const faCopyright = {
  prefix: 'fass',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80z"]
};
const faFlaskGear = {
  prefix: 'fass',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M160 0L288 0l32 0 32 0 0 64-32 0 0 150.9 19 30.9-36.4 63-41.9-68.1-4.7-7.7 0-9.1 0-160-64 0 0 160 0 9.1-4.7 7.7L118.8 352l206.7 0-35.6 20.5L360 493.8l0 18.2L32 512 0 512l0-32 0-48 0-9.1 4.7-7.7L128 214.9 128 64 96 64 96 0l32 0 32 0zM436 206.4l88.1 0 0 42.4c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 45 77.8-35.2 20.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l35.2 20.3-45 77.8-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8l0 42.4L436 497l0-42.2c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-45-77.8 34.9-20.1c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-34.9-20.2 44.9-77.8 34.9 20.2c6.9-5.1 14.5-9.4 22.5-12.9l0-42.2zm92.1 145.3a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
const faHighlighterLine = {
  prefix: 'fass',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M231.1 231.1L448.3 82.8l13 13L312.9 312.9l-81.8-81.8zM128 224l0 96s0 0 0 0L80 368l96 96 48-48 96 0L544 88 456 0 128 224zM70 403.3L4.6 468.7l-4.7 4.7 0 6.7 .1 16L.1 512 16 512l79.9 0 6.6 0 4.7-4.7 33.4-33.4L70 403.3zM248 464l-24 0 0 48 24 0 304 0 24 0 0-48-24 0-304 0z"]
};
const faBracketSquare = {
  prefix: 'fass',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 320 64 0 32 0 0 64-32 0-96 0L0 480l0-32L0 64 0 32z"]
};
const faBracket = faBracketSquare;
const faBracketLeft = faBracketSquare;
const faIslandTropical = {
  prefix: 'fass',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M112 96L62.2 96c0-36 38.4-96 128-96c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c89.6 0 128 60 128 96l-64 0L416 96l-32 32-82.5 0c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480l0 32L32 512l0-32c0-70.7 57.3-128 128-128l64 0c29.7-79.3 29.4-150.9 22.8-194l-98.9 98.9c-25.5-25.5-40.7-95 22.6-158.4c1.3-1.3 2.7-2.7 4.1-3.9L144 64 112 96z"]
};
const faIslandTreePalm = faIslandTropical;
const faArrowRightFromLine = {
  prefix: 'fass',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M64 96l0-32L0 64 0 96 0 416l0 32 64 0 0-32L64 96zM422.6 278.6L445.3 256l-22.6-22.6-128-128L272 82.7 226.7 128l22.6 22.6L322.7 224 160 224l-32 0 0 64 32 0 162.7 0-73.4 73.4L226.7 384 272 429.3l22.6-22.6 128-128z"]
};
const faArrowFromLeft = faArrowRightFromLine;
const faH2 = {
  prefix: 'fass',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M64 96l0-32L0 64 0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 61.7 0s0 0 0 0l2.3 0s0 0 0 0l0-2.1 0-29.9 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96zm427.5 32l4.5 0c35.3 0 64 28.7 64 64l0 5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4 368 401.9l0 46.1 32 0 208 0 32 0 0-64-32 0-125.7 0 100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4l0-5.8c0-70.7-57.3-128-128-128l-4.5 0c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9-24.3 20.8 41.6 48.6 24.3-20.8 29-24.9c11.6-9.9 26.4-15.4 41.7-15.4z"]
};
const faEquals = {
  prefix: 'fass',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M48 128l-32 0 0 64 32 0 352 0 32 0 0-64-32 0L48 128zm0 192l-32 0 0 64 32 0 352 0 32 0 0-64-32 0L48 320z"]
};
const faCakeSlice = {
  prefix: 'fass',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M284.9 32L296 32c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256l0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1c0 0 0 .1 0 .1l0 .1 0 .1c0 0 0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1l0 32-32 0L32 480 0 480l0-32L0 272l0-15.5 12.2-9.6 264-208 8.7-6.9zM448 288L64 288l0 48 384 0 0-.2 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7 0-.7c0 0 0 0 0 0zM64 416l384 0 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.4 0-.5 0-.5 0-.4L64 368l0 48z"]
};
const faShortcake = faCakeSlice;
const faBuildingMagnifyingGlass = {
  prefix: 'fass',
  iconName: 'building-magnifying-glass',
  icon: [640, 512, [], "e61c", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0 0-45.3C327.5 442 288 385.6 288 320c0-11 1.1-21.7 3.2-32L256 288l0-64 64 0c16.5-22 38.5-39.6 64-50.7L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.5-8.2 72-22.1l63.1 62.7 17 16.9 33.8-34-17-16.9-63-62.6c13.9-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faPeanut = {
  prefix: 'fass',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M512 0L364 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364L0 512l148 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148L512 0zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]
};
const faWrenchSimple = {
  prefix: 'fass',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M128 160l64 64 64-64L256 0c74.6 26.4 128 92.4 128 176c0 71.1-38.6 133.1-96 166.3L288 512 96 512l0-169.7C38.6 309.1 0 247.1 0 176C0 92.4 53.4 26.4 128 0l0 160z"]
};
const faBlender = {
  prefix: 'fass',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 0L32 0l96 0 32 0L512 0 494.5 64 336 64l-16 0 0 32 16 0 149.8 0-17.5 64L336 160l-16 0 0 32 16 0 123.6 0-17.5 64L336 256l-16 0 0 32 16 0 97.5 0L416 352l-256 0-8.7-96L32 256 0 256l0-32L0 32 0 0zM145.5 192L133.8 64 64 64l0 128 81.5 0zM480 384l0 128L96 512l0-128 384 0zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTeeth = {
  prefix: 'fass',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M0 32l576 0 0 448L0 480 0 32zM176 176l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48l0 80 96 0 0-80c0-26.5-21.5-48-48-48zM48 208l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0 0 48zm176 48c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48zm80-176l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48z"]
};
const faTally2 = {
  prefix: 'fass',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M160 64l0-32L96 32l0 32 0 384 0 32 64 0 0-32 0-384zm128 0l0-32-64 0 0 32 0 384 0 32 64 0 0-32 0-384z"]
};
const faShekelSign = {
  prefix: 'fass',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M32 32L0 32 0 64 0 480l64 0L64 96l128 0c35.3 0 64 28.7 64 64l0 192 64 0 0-192c0-70.7-57.3-128-128-128L32 32zM320 480c70.7 0 128-57.3 128-128l0-320-64 0 0 320c0 35.3-28.7 64-64 64l-128 0 0-256-64 0 0 288 0 32 32 0 160 0z"]
};
const faIls = faShekelSign;
const faShekel = faShekelSign;
const faSheqel = faShekelSign;
const faSheqelSign = faShekelSign;
const faCars = {
  prefix: 'fass',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M72.9 0L96 0 320 0l23.1 0 7.3 21.9L385.7 128 320 128l-1.7 0L296.9 64 119.1 64 97.7 128l176.1 0-7.3 21.9-7.3 21.9L231.2 256l-7.2 0-32 0 0 32L80 288l0 64L0 352l0-64s0 0 0 0L0 128l30.3 0L65.6 21.9 72.9 0zM332.4 256l-10.7 32 220.5 0-21.3-64L416 224l-72.9 0-10.7 32zm-78.1 32l35.4-106.1 7.3-21.9 23.1 0 96 0 128 0 23.1 0 7.3 21.9L609.7 288l30.3 0 0 160 0 64-80 0 0-64-256 0 0 64-80 0 0-64s0 0 0 0l0-160 30.3 0zM80 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM304 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faAxeBattle = {
  prefix: 'fass',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M0 192C0 64 88 0 88 0s26.2 83.8 104 115.8l0 152.4C114.2 300.2 88 384 88 384s-88-64-88-192zm320 76.2l0-152.4C397.8 83.8 424 0 424 0s73.7 53.6 86.2 160.9L448 192l62.2 31.1C497.7 330.4 424 384 424 384s-26.2-83.8-104-115.8zM288 64l0 416 0 32-64 0 0-32 0-416 0-32 64 0 0 32z"]
};
const faUserHairLong = {
  prefix: 'fass',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l62.4 0 32-32 16 16 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zM448 512L384 320 64 320 0 512l448 0z"]
};
const faMap = {
  prefix: 'fass',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M0 96L0 480l160-64 0-384L0 96zm416 0l0 384 160-64 0-384L416 96zM384 480l0-384L192 32l0 384 192 64z"]
};
const faArrowLeftFromArc = {
  prefix: 'fass',
  iconName: 'arrow-left-from-arc',
  icon: [512, 512, [], "e615", "M445.3 256c0-106-86-192-192-192l-32 0 0-64 32 0c141.4 0 256 114.6 256 256s-114.6 256-256 256l-32 0 0-64 32 0c106 0 192-86 192-192zM134.6 121.4l22.6-22.6L202.5 144l-22.6 22.6L122.5 224l194.7 0 32 0 0 64-32 0-194.7 0 57.4 57.4L202.5 368l-45.3 45.3-22.6-22.6-112-112L0 256l22.6-22.6 112-112z"]
};
const faFileCircleInfo = {
  prefix: 'fass',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm15.3 64l-32 0 0 32 32 0 0-32zm1.2 64l-16 0L416 352l-16 0 0 32 16 0 .5 0 0 48-.5 0-16 0 0 32 16 0 32 0 .5 0 15.5 0 0-32-15.5 0 0-64 0-16z"]
};
const faFaceDisappointed = {
  prefix: 'fass',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 233.4 222.6 256l-11.3 11.3zM289.4 256L312 233.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L289.4 256zm26.7 154.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9z"]
};
const faLassoSparkles = {
  prefix: 'fass',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M0 176C0 81.4 122.1 4.3 275.2 .2L247.5 55.5 220.1 69.2C129.6 83.6 64 126 64 176c0 61.9 100.3 112 224 112s224-50.1 224-112c0-23.6-14.6-45.5-39.5-63.5l.9-.5-5.7-2.9c-13-8.7-28.5-16.5-46-23L360.5 55.5 333.8 2.2C471.1 15.6 576 88.3 576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121l-71 0-32 0 0-64 32 0 71 0c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4c-1.5-.7-2.8-1.6-4.1-2.5C42.8 281.9 0 232 0 176zM277.3 85.3L304 32l26.7 53.3L384 112l-53.3 26.7L304 192l-26.7-53.3L224 112l53.3-26.7zm192 320L496 352l26.7 53.3L576 432l-53.3 26.7L496 512l-26.7-53.3L416 432l53.3-26.7z"]
};
const faClockEleven = {
  prefix: 'fass',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 56.7-20-30-13.3-20-39.9 26.6 13.3 20 64 96L280 256l0-136 0-24-48 0 0 24z"]
};
const faRocket = {
  prefix: 'fass',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M111.9 340.2l58.2 58.2s22.4-6.8 53.9-17.7L224 512l160-80 0-120c4-2.4 7.8-4.8 11.3-7.2C527.1 215.4 519.9 78.3 502.7 9.3c-68.9-17.2-206-24.5-295.4 107.4c-2.4 3.5-4.8 7.3-7.2 11.3L80 128 0 287.6l129.8 .3c-11 30.7-17.9 52.3-17.9 52.3zM384 88a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faSirenOn = {
  prefix: 'fass',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l48 32 20 13.3-26.6 39.9L90.7 108l-48-32-20-13.3L49.3 22.7 69.3 36zM597.3 76l-48 32-20 13.3L502.7 81.3l20-13.3 48-32 20-13.3 26.6 39.9L597.3 76zM24 192l64 0 24 0 0 48-24 0-64 0L0 240l0-48 24 0zm528 0l64 0 24 0 0 48-24 0-64 0-24 0 0-48 24 0zM144 352L176 96l288 0 32 256-261.9 0 21.8-174 2.2-18-32.2 0-1.8 14L201.9 352 144 352zM96 384l448 0 0 96L96 480l0-96z"]
};
const faClockTen = {
  prefix: 'fass',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 91.2L173.3 172l-20-13.3-26.6 39.9 20 13.3 96 64L280 300.8l0-44.8 0-136 0-24-48 0 0 24z"]
};
const faCandleHolder = {
  prefix: 'fass',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M240 112C240 64 160 0 160 0s-80 64-80 112c0 44.2 35.8 80 80 80s80-35.8 80-80zM128 224l-64 0 0 240-40 0L0 464l0 48 24 0 352 0c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72c0 8.4 1.4 16.5 4.1 24L256 464l0-240-96 0 0 48 0 16-32 0 0-16 0-48zM352 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faVideoArrowDownLeft = {
  prefix: 'fass',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M0 64l384 0 0 384L0 448 0 64zm576 0l0 384L416 337.1l0-162.3L576 64zM232 352l24 0 0-48-24 0-54.1 0L281 201l17-17L264 150.1l-17 17-103 103 0-54.1 0-24-48 0 0 24 0 112 0 24 24 0 112 0z"]
};
const faPhotoFilm = {
  prefix: 'fass',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M640 0l0 352-448 0L192 0 640 0zM475.6 106.2L456 78.4l-19.6 27.8-57.3 81.2-17.1-19.3L344 147.9l-17.9 20.2-64 72-6.1 6.8 0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 128l160 0 0 256 0 64 192 0 0-64 160 0 0 128L0 512 0 128zm104 64l-48 0 0 48 48 0 0-48zm0 104l-48 0 0 48 48 0 0-48zm0 104l-48 0 0 48 48 0 0-48zm304 0l0 48 48 0 0-48-48 0z"]
};
const faPhotoVideo = faPhotoFilm;
const faFloppyDiskCircleArrowRight = {
  prefix: 'fass',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M32 32L0 32 0 64 0 448l0 32 32 0 264.2 0c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7l0-32.7 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32zM64 96l256 0 0 128L64 224 64 96zM336 368c0-53 43-96 96-96s96 43 96 96l0 16-16 0c-8.8 0-16-7.2-16-16c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14l40 0 24 0 0-24 0-40c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144l16 0 0-48-16 0c-53 0-96-43-96-96zm96 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
};
const faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
const faFolderMinus = {
  prefix: 'fass',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM184 272l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faPlanetMoon = {
  prefix: 'fass',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zM256 114.9c-10.4-1.9-21.1-2.9-32-2.9c-86.3 0-158 62.1-173.1 144l77.1 0 64 64 0 64 32 0 0 72 40 0 56-104 0-64-112 0-32-32 80-96 0-45.1z"]
};
const faFaceEyesXmarks = {
  prefix: 'fass',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM112 121.4L89.4 144l11.3 11.3L137.4 192l-36.7 36.7L89.4 240 112 262.6l11.3-11.3L160 214.6l36.7 36.7L208 262.6 230.6 240l-11.3-11.3L182.6 192l36.7-36.7L230.6 144 208 121.4l-11.3 11.3L160 169.4l-36.7-36.7L112 121.4zm192 0L281.4 144l11.3 11.3L329.4 192l-36.7 36.7L281.4 240 304 262.6l11.3-11.3L352 214.6l36.7 36.7L400 262.6 422.6 240l-11.3-11.3L374.6 192l36.7-36.7L422.6 144 400 121.4l-11.3 11.3L352 169.4l-36.7-36.7L304 121.4zM256 304c-44.2 0-80 35.8-80 80l0 16 160 0 0-16c0-44.2-35.8-80-80-80z"]
};
const faChartScatter = {
  prefix: 'fass',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M64 64l0-32L0 32 0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64zm160 64l-64 0 0 64 64 0 0-64zM192 288l-64 0 0 64 64 0 0-64zm128-64l-64 0 0 64 64 0 0-64zm32 128l64 0 0-64-64 0 0 64zM448 96l-64 0 0 64 64 0 0-64z"]
};
const faCircleGf = {
  prefix: 'fass',
  iconName: 'circle-gf',
  icon: [512, 512, [], "e67f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c39.8 0 72 32.2 72 72l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8-24 0 0-48 24 0 24 0 24 0 0 24 0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 0l24 0 64 0 24 0 0 48-24 0-40 0 0 64 24 0 24 0 0 48-24 0-24 0 0 72 0 24-48 0 0-24 0-72 0-48 0-88 0-24z"]
};
const faDisplayArrowDown = {
  prefix: 'fass',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M576 0L352 0l0 64 160 0 0 288L64 352 64 64l160 0 0-64L0 0 0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0L336 416l240 0L576 0zM312 24l0-24L264 0l0 24 0 174.1-39-39-17-17L174.1 176l17 17 80 80 17 17 17-17 80-80 17-17L368 142.1l-17 17-39 39L312 24z"]
};
const faStore = {
  prefix: 'fass',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M547.6 103.8L480 0 96 0 28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3L448 384l-320 0 0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 384l0 128 448 0 0-128 0-131.4c-4 1-8 1.8-12.3 2.3z"]
};
const faArrowTrendUp = {
  prefix: 'fass',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M544 96l32 0 0 32 0 160 0 32-64 0 0-32 0-82.7L342.6 374.6 320 397.3l-22.6-22.6L192 269.3 54.6 406.6 9.4 361.4l160-160L192 178.7l22.6 22.6L320 306.7 466.7 160 384 160l-32 0 0-64 32 0 160 0s0 0 0 0z"]
};
const faPlugCircleMinus = {
  prefix: 'fass',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 16l-16 0-128 0-16 0 0-32 16 0 128 0 16 0 0 32z"]
};
const faOliveBranch = {
  prefix: 'fass',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M128 0C48 0 0 64 0 64s31.2 36.4 85.2 50.5C34.5 141.4 0 194.6 0 256l0 16 0 16 16 0 16 0c86.6 0 157.1-68.7 159.9-154.6L373.4 48 616 48l24 0 0-48L616 0 368 0c-3.5 0-7 .8-10.2 2.3L247.4 54.2C230.3 36.3 188.2 0 128 0zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9C494 205.8 512 260.7 512 320c0 57.8-17.1 111.4-46.3 151.8z"]
};
const faAngle = {
  prefix: 'fass',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M0 480l0-61.1L195.7 49l15-28.3 56.6 29.9L252.3 79 73.9 416 416 416l32 0 0 64-32 0L20.8 480 0 480zM315.5 253.2l-40.8 25.3c-16.5-23.6-36.3-44.6-58.8-62.5l22.8-43c29.7 22.4 55.7 49.5 76.8 80.2zm-23.9 52.5l40.8-25.3c17.8 31.8 30.6 66.7 37.6 103.7l-49 0c-6.1-27.8-16.1-54.1-29.4-78.3z"]
};
const faVacuumRobot = {
  prefix: 'fass',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM356.7 356.7c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0l-22.6-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6l-22.6-22.6zM224 201.4l11.3 11.3 64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4zm-80 16l11.3 11.3 128 128L294.6 368 272 390.6l-11.3-11.3-128-128L121.4 240 144 217.4zm-16 80l11.3 11.3 64 64L214.6 384 192 406.6l-11.3-11.3-64-64L105.4 320 128 297.4z"]
};
const faSignHanging = {
  prefix: 'fass',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M128 0l0 32 0 32 352 0 32 0 0 64-32 0-352 0 0 352 0 32-64 0 0-32 0-352-32 0L0 128 0 64l32 0 32 0 0-32L64 0l64 0zM480 160l0 224-320 0 0-224 320 0z"]
};
const faSign = faSignHanging;
const faSquareDivide = {
  prefix: 'fass',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M448 32L0 32 0 480l448 0 0-448zM256 128l0 64-64 0 0-64 64 0zM136 232l176 0 24 0 0 48-24 0-176 0-24 0 0-48 24 0zm56 88l64 0 0 64-64 0 0-64z"]
};
const faFolderCheck = {
  prefix: 'fass',
  iconName: 'folder-check',
  icon: [512, 512, [], "e64e", "M512 480L0 480 0 32l224 0 48 64 240 0 0 384zM241 369L385 225 351 191l-127 127-63-63L127 289l80 80 17 17 17-17z"]
};
const faSignalStreamSlash = {
  prefix: 'fass',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-81.3-63.1C562.8 354.7 576 306.9 576 256c0-67.4-23.2-129.4-61.9-178.5l-50.2 39.7C494 155.4 512 203.5 512 256c0 36.1-8.5 70.2-23.7 100.3l-38.9-30.2c9.4-21.5 14.6-45.2 14.6-70.2c0-41.2-14.2-79.1-37.9-109.1l-50.2 39.7C391 205.7 400 229.8 400 256c0 10-1.3 19.7-3.7 28.9l-53.7-41.7c-5.8-24.7-28-43.1-54.5-43.1c-.3 0-.7 0-1 0L48.4 14.8zm75.1 178.5C116.1 212.8 112 233.9 112 256c0 41.2 14.2 79.1 37.9 109.1l50.2-39.7C185 306.3 176 282.2 176 256c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 67.4 23.2 129.4 61.9 178.5l50.2-39.7C82 356.6 64 308.5 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122z"]
};
const faBezierCurve = {
  prefix: 'fass',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M344 88l0 48-48 0 0-48 48 0zM296 32l-56 0 0 52L121.6 84C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180L32 320l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-51.3 0c5.6-63.8 44.6-118.1 99.3-145.3l0 17.3 56 0 48 0 56 0 0-17.3c54.7 27.2 93.7 81.5 99.3 145.3L448 320l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-52.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36L400 84l0-52-56 0-48 0zM136 376l0 48-48 0 0-48 48 0zm368 0l48 0 0 48-48 0 0-48z"]
};
const faEyeDropperHalf = {
  prefix: 'fass',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4L413.3 304 368 349.3l-22.6-22.6-160-160L162.7 144 208 98.7l22.6 22.6 9.4 9.4zm-65.3 70.5L220 246.5 146.5 320l91 0 28-28 45.3 45.3L168 480l-88 0-12.3 9.9L45 508l-5 4L0 472l4-5 18.1-22.7L32 432l0-88L174.7 201.3z"]
};
const faStoreLock = {
  prefix: 'fass',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M579.6 103.8L512 0 128 0 60.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c19.4 0 37.1-6.3 51.5-16.7C456.8 178.7 490.2 160 528 160c21.4 0 41.3 6 58.3 16.4c8.9-22.7 7.7-49.8-6.7-72.6zM160 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 384l0 128 288 0 0-128-224 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faBellSlash = {
  prefix: 'fass',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M544 399.6l0-31.6-64-72 0-88c0-77.4-55-142-128-156.8L352 0 288 0l0 51.2c-42.9 8.7-79.5 34.5-102.5 70.1L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L544 399.6zM406.2 416L160 222.1l0 73.9L96 368l0 48 310.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
const faCloudBoltSun = {
  prefix: 'fass',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M121.3 0L208 60.7 294.7 0l13.2 79c-20.5 10.9-37.7 27.3-49.6 47.2c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2l0 97.8L121.3 416 104 312 0 294.7 60.7 208 0 121.3 104 104 121.3 0zM294.7 416l-.1-.1 .2 0 0 .1zM242.1 168.4c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6zM639.9 383.9l-80 0-15.9 0 0-63.9-76.5 0 40-128-51 0L256 344.3l0 39.6-64 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80zM512 376L336 512l40-128-88 0 0-24L464 224 424 352l88 0 0 24z"]
};
const faThunderstormSun = faCloudBoltSun;
const faCameraSlash = {
  prefix: 'fass',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L576 424.4 576 96 437.3 96 416 32 224 32 202.7 96 153 96 48.4 14.8zM285.1 198.6c10.8-4.2 22.6-6.6 34.9-6.6c53 0 96 43 96 96c0 3.9-.2 7.8-.7 11.7L285.1 198.6zM224 288c0-5 .4-9.9 1.1-14.6L64 146.4 64 480l423.4 0L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96z"]
};
const faCommentQuote = {
  prefix: 'fass',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM240 144l-112 0 0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40zm144 0l-112 0 0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40z"]
};
const faTablet = {
  prefix: 'fass',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M448 0L0 0 0 512l448 0L448 0zM176 432l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z"]
};
const faTabletAndroid = faTablet;
const faSchoolFlag = {
  prefix: 'fass',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M320 0l96 0 0 96-95.3 0 89.6 64L544 160l32 0 0 32 0 288 0 32-32 0-208 0 0-112c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 112L32 512 0 512l0-32L0 192l0-32 32 0 133.7 0L256 95.5 256 32l0-32 32 0 32 0zm16 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 224l-64 0 0 96 64 0 0-96zm320 0l0 96 64 0 0-96-64 0zM128 352l-64 0 0 96 64 0 0-96zm384 0l-64 0 0 96 64 0 0-96z"]
};
const faMessageCode = {
  prefix: 'fass',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM217 161l17-17L200 110.1l-17 17-64 64-17 17 17 17 64 64 17 17L233.9 272l-17-17-47-47 47-47zM329 127l-17-17L278.1 144l17 17 47 47-47 47-17 17L312 305.9l17-17 64-64 17-17-17-17-64-64z"]
};
const faGlassHalf = {
  prefix: 'fass',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M81.7 224L69.2 64l245.6 0L302.3 224 81.7 224zM40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0 5 64 40 512z"]
};
const faGlassHalfEmpty = faGlassHalf;
const faGlassHalfFull = faGlassHalf;
const faFill = {
  prefix: 'fass',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M45.3 317.3L0 272l45.3-45.3 76.1-76.1-80-80L18.7 48 64 2.7 86.6 25.4l80 80 60.1-60.1L272 0l45.3 45.3L466.7 194.7 512 240l-45.3 45.3L285.3 466.7 240 512l-45.3-45.3L45.3 317.3zM166.6 195.9L90.5 272l16 16 267 0 48-48L272 90.5l-60.1 60.1 18.7 18.7L253.3 192 208 237.3l-22.6-22.6-18.7-18.7z"]
};
const faMessageMinus = {
  prefix: 'fass',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM184 184l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faCommentAltMinus = faMessageMinus;
const faAngleUp = {
  prefix: 'fass',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M224 114.7l22.6 22.6 160 160L429.3 320 384 365.3l-22.6-22.6L224 205.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 160-160L224 114.7z"]
};
const faDinosaur = {
  prefix: 'fass',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M448 0L424 0 408 32 368 48l0 80 80 0 32 0c35.3 0 64 28.7 64 64l0 64-53.3 0-66.1-49.6c-40.2-30.1-89-46.4-139.2-46.4c-57.7 0-113.4 21.5-156.1 60.3L10.5 328.3 0 337.8 0 352 0 480l0 32 32 0 160 0 32 0 16 0 16 0 32 0 0-50.4L109.4 431.8 96 429.6 96 416l0-48 0-16 32 0 0 16 0 34.4 178.6 29.8 13.4 2.2 0 13.6 0 15.3c5.3 .4 10.6 .7 16 .7c16.6 0 32.7-2.1 48-6l0 54 128 0 0-87.9c76.5-35.9 128-113.5 128-201.5l0-30.6C640 86 554 0 448 0zm0 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faDrumstickBite = {
  prefix: 'fass',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M160 176l0 102.5-58.4 58.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60l12 0 0 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L233.5 352 336 352c34.3 0 66.3-9.8 93.4-26.8C420.9 309.4 416 291.3 416 272c0-56.2 41.4-102.8 95.4-110.8C503.9 70.9 428.2 0 336 0C238.8 0 160 78.8 160 176z"]
};
const faLinkHorizontalSlash = {
  prefix: 'fass',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-45.4-35.2C614.4 398.3 640 354.1 640 304c0-79.5-64.5-144-144-144l-16 0 0 64 16 0c44.2 0 80 35.8 80 80c0 36-23.8 66.5-56.6 76.5l-104.3-81C435.7 274.7 448 242.8 448 208c0-79.5-64.5-144-144-144L144 64c-9.8 0-19.3 1-28.6 2.8l-67-52zM194.2 128L304 128c44.2 0 80 35.8 80 80c0 20-7.3 38.2-19.4 52.3L194.2 128zM446.8 448l-81.2-64L336 384c-44.2 0-80-35.8-80-80c0-2.1 .1-4.1 .2-6.1l-55.4-43.6c-5.7 15.5-8.8 32.3-8.8 49.8c0 79.5 64.5 144 144 144l110.8 0zM30.2 119.8C11.3 144.2 0 174.8 0 208c0 79.5 64.5 144 144 144l16 0 0-64-16 0c-44.2 0-80-35.8-80-80c0-18.3 6.1-35.1 16.5-48.6L30.2 119.8z"]
};
const faChainHorizontalSlash = faLinkHorizontalSlash;
const faHollyBerry = {
  prefix: 'fass',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 343.1L16 353.8l33.8 69.3L32 512l81.8-39.1 75.5 15.7L176 392.9l94.7-9L240 310.6 256 224l-80 36.8L97.4 249.1l14.6 94zm222.7 49.8l-13.3 95.7 75.5-15.7L478.7 512l-17.8-88.9 33.8-69.3-96-10.7 14.6-94-78.6 11.7-48.8-22.5-12.7 68.7 27 64.5 7.9 18.8 26.6 2.5z"]
};
const faNose = {
  prefix: 'fass',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M448 368l0 144-96 0-67.2 0L208 448l-33.6 0c-25.6 0-46.4 20.8-46.4 46.4l0 17.6-16 0C50.8 512 1.1 462.9 0 401.9C1 345.3 44.3 298 100.9 292.4l44.7-4.5 15.9-1.6-3.2-31.8-15.9 1.6-44.7 4.5c-11.7 1.2-23 3.7-33.7 7.5L64 0 176 0 448 368z"]
};
const faArrowLeftToArc = {
  prefix: 'fass',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M64 256C64 150 150 64 256 64l0-64C114.6 0 0 114.6 0 256S114.6 512 256 512l0-64C150 448 64 362 64 256zM281.4 121.4l-112 112L146.7 256l22.6 22.6 112 112L304 413.3 349.3 368l-22.6-22.6L269.3 288 480 288l32 0 0-64-32 0-210.7 0 57.4-57.4L349.3 144 304 98.7l-22.6 22.6z"]
};
const faChevronLeft = {
  prefix: 'fass',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z"]
};
const faBacteria = {
  prefix: 'fass',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M323 15L289 3l-6 17-1.5 4.2c-8-.5-16.2 .1-24.4 2c-9 2.1-17.8 4.4-26.2 7l-4.4-10.3L219.5 6.4 186.4 20.5l7.1 16.5 3.6 8.5c-16.5 7.1-31.5 15.1-45.2 23.9L147 62 137 47 107 67l10 15 5.8 8.7c-13.5 11.2-25.3 23.1-35.5 35.3l-10.1-8.1L63.2 106.7 40.7 134.8l14.1 11.2L66 155c-1.6 2.4-3.1 4.8-4.5 7.3c-7.1 11.8-12.8 23.2-17.4 34l-7.4-3L20 186.6 6.6 220l16.7 6.7 8.7 3.5c-.2 .8-.4 1.6-.7 2.3c-2.6 9.4-4.2 17.4-5.3 23.5c-.5 3.1-.9 5.7-1.2 7.7c-.1 1-.2 2-.3 2.7l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.5 2.8c0 0 0 0 0 0l-29.5-2.7c-.4 4.4-.5 8.8-.2 13.2L20 283 3 289 15 323l17-6 2.2-.8c8 14.7 20.3 26.8 35.4 34.6L66.7 361l-4.9 17.3 34.6 9.9 4.9-17.3 3.1-11c17.8 .8 34.7-4.1 48.8-13.2l8 8L174 367.5 199.5 342l-12.7-12.7-8-8c6.8-10.6 11.3-22.9 12.7-36.2l.1-.6c.2-1.3 .7-3.8 1.7-7.4l.2-.6 9.4 4 16.5 7.1 14.2-33.1-16.5-7.1-8.5-3.6c7.5-11.1 18.7-23.7 36.5-34.5l1.6 5.6 4.9 17.3 34.6-9.9-4.9-17.3-3-10.6c5.2-1.7 10.7-3.2 16.6-4.6c9.7-2.2 18.5-6 26.4-11.1l8 8L342 199.5 367.4 174l-12.7-12.7-8-8c9.1-14.3 14-31.2 13.2-48.8l11-3.1 17.3-4.9-9.9-34.6L361 66.7l-10.3 2.9c-7.8-15.2-20-27.5-34.6-35.4L317 32l6-17zM106.2 275.8l-32.4-2.9s0 0 0 0l32.4 3zM128 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM323 480l-6 17L351 509l6-17 1.5-4.2c8 .5 16.2-.1 24.4-2c9-2.1 17.8-4.4 26.2-7l4.4 10.3 7.1 16.5 33.1-14.2-7.1-16.5-3.6-8.5c16.5-7.1 31.5-15.1 45.2-23.9l5 7.4 10 15 30-20-10-15-5.8-8.7c13.5-11.2 25.3-23.1 35.5-35.3l10.1 8.1 14.1 11.2 22.5-28.1-14.1-11.2L574 357c1.6-2.4 3.1-4.8 4.5-7.3c7.1-11.8 12.8-23.2 17.4-34l7.4 3 16.7 6.7L633.4 292l-16.7-6.7-8.7-3.5c.2-.8 .4-1.6 .7-2.3c2.6-9.4 4.2-17.4 5.3-23.5c.5-3.1 .9-5.7 1.2-7.7c.1-1 .2-2 .3-2.7l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.5-2.8c0 0 0 0 0 0l29.5 2.7c.4-4.4 .5-8.8 .2-13.2L620 229l17-6L625 189l-17 6-2.2 .8c-8-14.7-20.3-26.8-35.4-34.6l2.9-10.3 4.9-17.3-34.6-9.9-4.9 17.3-3.1 11c-17.8-.8-34.7 4.1-48.8 13.2l-8-8L466 144.5 440.5 170l12.7 12.7 8 8c-6.8 10.6-11.3 22.9-12.7 36.2l-.1 .6c-.2 1.3-.7 3.8-1.7 7.4l-.2 .6-9.4-4-16.5-7.1-14.2 33.1 16.5 7.1 8.5 3.6c-7.5 11.1-18.7 23.7-36.5 34.5l-1.6-5.6-4.9-17.3-34.6 9.9 4.9 17.3 3 10.6c-5.2 1.7-10.7 3.2-16.6 4.6c-9.7 2.2-18.5 6-26.4 11.1l-8-8L298 312.5 272.5 338l12.7 12.7 8 8c-9.1 14.2-14 31.2-13.2 48.8l-11 3.1-17.3 4.9 9.9 34.6 17.3-4.9 10.3-2.9c7.8 15.2 20 27.5 34.6 35.4L323 480zM566.2 239.1s0 0 0 0l-32.4-3 32.4 2.9zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faClouds = {
  prefix: 'fass',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M304 160c-74.1 0-135.2 56-143.1 128L96 288 0 288l0-96c0-53 43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 12.1-2.2 23.6-6.3 34.2c-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160zM224 512l-96 0 0-96c0-41.8 26.7-77.4 64-90.5l0-21.5c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0-320 0z"]
};
const faMoneyBillSimple = {
  prefix: 'fass',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M576 64L0 64 0 448l576 0 0-384zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faHandLizard = {
  prefix: 'fass',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M0 64l48 0 112 0 80 0 80 0 25.1 0 14.3 20.7 144 208L512 305l0 15 0 32 0 16 0 80-160 0 0-45.8L273.9 352 240 352l-80 0-48 0-48 0 0-96 48 0 48 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0L48 160 0 160 0 64z"]
};
const faTablePivot = {
  prefix: 'fass',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M0 32l128 0 0 128L0 160 0 32zM160 160l0-128 352 0 0 448L0 480 0 192l128 0 0 224 320 0 0-256-288 0zm208 32l48 48 0 16-32 0 0 80 0 16-16 0-80 0 0 32-16 0-48-48 48-48 16 0 0 32 64 0 0-64-32 0 0-16 48-48z"]
};
const faFilterSlash = {
  prefix: 'fass',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L407 293.2 576 96l0-64L70.5 32 48.4 14.8zM384 398.5L256 297.7 256 416l128 96 0-113.5z"]
};
const faTrashCanUndo = {
  prefix: 'fass',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0 0 384L32 512l0-384zM209 241l17-17L192 190.1l-17 17-64 64-17 17 17 17 64 64 17 17L225.9 352l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23z"]
};
const faTrashCanArrowTurnLeft = faTrashCanUndo;
const faTrashUndoAlt = faTrashCanUndo;
const faNotdef = {
  prefix: 'fass',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M0 0L32 0 352 0l32 0 0 32 0 448 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM64 390.3L153.5 256 64 121.7l0 268.6zM102.5 448l179.1 0L192 313.7 102.5 448zm128-192L320 390.3l0-268.6L230.5 256zM281.5 64L102.5 64 192 198.3 281.5 64z"]
};
const faDisease = {
  prefix: 'fass',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M227 75.5l9.4-14.1C248.7 43 269.2 32 291.3 32c30.8 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3l-10 0c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1zM120 224l40 40 40-40-40-40-40 40zm128 96l40 40 40-40-40-40-40 40zm56-88l24-24-24-24-24 24 24 24z"]
};
const faPersonToDoor = {
  prefix: 'fass',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM114.7 96L128 96l64 0 6.2 0 5.7 2.3 80 32 11.3 4.5 5.4 10.9L339.8 224l28.2 0 32 0 0 64-32 0-48 0-19.8 0-8.8-17.7L267 221.7 238 299 305 340.9l20.4 12.8-6.6 23.2-16 56-16 56L280.1 512l-66.6 0 11.7-40.8 16-56 9.4-32.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.3-94-27.7 0-38.6 38.6L80 221.3 34.7 176l22.6-22.6 48-48 9.4-9.4zM91.2 352l18.3-41.3c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6L141.2 397l-8.4 19L112 416l-80 0L0 416l0-64 32 0 59.2 0zM384 0L576 0l0 512-192 0 0-192 48 0 0-128-48 0L384 0z"]
};
const faTurntable = {
  prefix: 'fass',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M0 32l576 0 0 448L0 480 0 32zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM512 112l0-16-32 0 0 16 0 164.2-22.3 44.6-14.3-7.2-24 48-14.3 28.6 57.2 28.6 14.3-28.6 24-48-14.3-7.2 24-48 1.7-3.4 0-3.8 0-168zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBriefcaseMedical = {
  prefix: 'fass',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M128 0l24 0L360 0l24 0 0 24 0 72 128 0 0 384L0 480 0 96l128 0 0-72 0-24zM336 48L176 48l0 48 160 0 0-48zM224 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faGenderless = {
  prefix: 'fass',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
const faChevronRight = {
  prefix: 'fass',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z"]
};
const faSignalWeak = {
  prefix: 'fass',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M96 384l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0z"]
};
const faSignal1 = faSignalWeak;
const faClockFive = {
  prefix: 'fass',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 128.7 60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6 0-7.3 0-136 0-24 48 0 0 24z"]
};
const faRetweet = {
  prefix: 'fass',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M96 64L0 160l0 32 64 0 0 192 0 32 32 0 176 0 32 0 0-64-32 0-144 0 0-160 64 0 0-32L96 64zM480 448l96-96 0-32-64 0 0-192 0-32-32 0L304 96l-32 0 0 64 32 0 144 0 0 160-64 0 0 32 96 96z"]
};
const faCarRear = {
  prefix: 'fass',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M97.3 32L120 32l272 0 22.7 0 7.5 21.4L470.7 192l41.3 0 0 208-32 0 0 80-96 0 0-80-256 0 0 80-96 0 0-80L0 400 0 192l41.3 0L89.8 53.4 97.3 32zm272 64L142.7 96l-33.6 96 293.8 0L369.3 96zM128 256l-80 0 0 48 80 0 0-48zm256 0l0 48 80 0 0-48-80 0zm-64 16l-128 0 0 64 128 0 0-64z"]
};
const faCarAlt = faCarRear;
const faPumpSoap = {
  prefix: 'fass',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M128 0l0 128 128 0 0-32 82.7 0 38.6 38.6L400 157.3 445.3 112 422.6 89.4l-48-48L365.3 32 352 32l-96 0 0-32L128 0zM56 160L32 512l320 0L328 160 56 160zM192 416c-35.3 0-64-20.7-64-56c0-40 64-120 64-120s64 80 64 120c0 35.3-28.7 56-64 56z"]
};
const faComputerClassic = {
  prefix: 'fass',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M0 0L448 0l0 416L0 416 0 0zM32 512l0-64 384 0 0 64L32 512zM384 64L64 64l0 192 320 0 0-192zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-40l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0z"]
};
const faFrame = {
  prefix: 'fass',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 160l0-64-64 0 0-64-64 0 0 64L128 96l0-64L64 32l0 64L0 96l0 64 64 0 0 192L0 352l0 64 64 0 0 64 64 0 0-64 192 0 0 64 64 0 0-64 64 0 0-64-64 0 0-192 64 0zM128 352l0-192 192 0 0 192-192 0z"]
};
const faVideoSlash = {
  prefix: 'fass',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-28-21.8L608 448l0-384L448 174.9 448 325l-32-24.8L416 64 111.8 64 48.4 14.8zM416 423.8L32 121.2 32 448l384 0 0-24.2z"]
};
const faBatteryQuarter = {
  prefix: 'fass',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M480 160l0 192L64 352l0-192 416 0zM64 96L0 96l0 64L0 352l0 64 64 0 416 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L64 96zm128 96l-96 0 0 128 96 0 0-128z"]
};
const faBattery2 = faBatteryQuarter;
const faEllipsisStroke = {
  prefix: 'fass',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M80 240l32 0 0 32-32 0 0-32zM32 272l0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0 0 48 0 32zm208-32l32 0 0 32-32 0 0-32zm-48 32l0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0 0 48 0 32zm208 0l0-32 32 0 0 32-32 0zm-48 48l48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0 0 48 0 32 0 48z"]
};
const faEllipsisHAlt = faEllipsisStroke;
const faRadio = {
  prefix: 'fass',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2 0 128l0 16L0 304l0 24L0 512l512 0 0-384-322.2 0 296-72.7zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 240l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zM64 304l16 0 128 0 16 0 0 32-16 0L80 336l-16 0 0-32zm16 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z"]
};
const faBabyCarriage = {
  prefix: 'fass',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M256 192L.1 192C3.1 108 52.3 35.8 123 0L256 192zM384 96l32 0 64 0 32 0 0 64-32 0-32 0 0 64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0 0-96 0-32zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faCarriageBaby = faBabyCarriage;
const faFaceExpressionless = {
  prefix: 'fass',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 336l192 0 16 0 0 32-16 0-192 0-16 0 0-32 16 0zM128 192l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm176 0l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0z"]
};
const faDownToDottedLine = {
  prefix: 'fass',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M64 480l0-64L0 416l0 64 64 0zm96 0l0-64-64 0 0 64 64 0zm32 0l64 0 0-64-64 0 0 64zm160 0l0-64-64 0 0 64 64 0zm32 0l64 0 0-64-64 0 0 64zM64 224L224 384 384 224l0-32-96 0 0-160L160 32l0 160-96 0 0 32z"]
};
const faCloudMusic = {
  prefix: 'fass',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zM416 184l0-23.1L394.4 169l-128 48L256 220.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faTrafficLight = {
  prefix: 'fass',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
const faCloudMinus = {
  prefix: 'fass',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zM248 264l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faThermometer = {
  prefix: 'fass',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M96 382.1L96 280l0-9.9 7-7 36.7-36.7 57 57L208 294.6 230.6 272l-11.3-11.3-57-57 41.4-41.4 57 57L272 230.6 294.6 208l-11.3-11.3-57-57 41.4-41.4 57 57L336 166.6 358.6 144l-11.3-11.3-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L249 409l-7 7-9.9 0-102.1 0L52.2 493.8l-17 17L1.3 476.8l17-17L96 382.1z"]
};
const faShieldMinus = {
  prefix: 'fass',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM184 232l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z"]
};
const faVrCardboard = {
  prefix: 'fass',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M640 64L0 64 0 448l224 0 64-128 64 0 64 128 224 0 0-384zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faCarTilt = {
  prefix: 'fass',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M65.1 75.8l21.1-5.7L318.1 8l21.1-5.7L352.2 20 430.6 127l40.7-10.9L521 301.5l20.7 77.3-92.7 24.8-20.7-77.3L150 400.9 162.7 448 640 448l0 64L0 512l0-64 63.3 0-6-22.2L7.6 240.3l40.7-10.9L62.7 97.6l2.4-21.8zm248.4-.3L124 126.3l-9.3 85.3 249.6-66.9L313.5 75.5zm-180 263.6a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8zM434.3 225.4a32 32 0 1 0 -61.8 16.6 32 32 0 1 0 61.8-16.6z"]
};
const faGaugeCircleMinus = {
  prefix: 'fass',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 16l-16 0-128 0-16 0 0-32 16 0 128 0 16 0 0 32z"]
};
const faBrightnessLow = {
  prefix: 'fass',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M224 48l0 64 64 0 0-64-64 0zM128 82.7L82.7 128 128 173.3 173.3 128 128 82.7zM48 224l0 64 64 0 0-64-64 0zM173.3 384L128 338.7 82.7 384 128 429.3 173.3 384zM288 464l0-64-64 0 0 64 64 0zm50.7-80L384 429.3 429.3 384 384 338.7 338.7 384zM464 224l-64 0 0 64 64 0 0-64zm-34.7-96L384 82.7 338.7 128 384 173.3 429.3 128zM256 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faHandMiddleFinger = {
  prefix: 'fass',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M272 0L192 0l0 192-80 0 0 32 0 13.3 0 2.7 0 80 0 16-32 0 0-16 0-56L32 304l0 57.5c0 44.7 19.8 87 54.1 115.6c27 22.5 61.1 34.9 96.3 34.9L304 512c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0L272 0z"]
};
const faPercent = {
  prefix: 'fass',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M358.6 134.6L381.3 112 336 66.7 313.4 89.4l-288 288L2.7 400 48 445.3l22.6-22.6 288-288zM8 72L8 184l112 0 0-112L8 72zM264 328l0 112 112 0 0-112-112 0z"]
};
const faPercentage = faPercent;
const faTruckMoving = {
  prefix: 'fass',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M480 32L0 32 0 304l0 80 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L416 384l33.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l33.6 0 0-96 0-32 0-9.9-7-7-72-72-7-7-9.9 0-64 0 0-128zM582.1 256L480 256l0-48 54.1 0 48 48zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGlassWaterDroplet = {
  prefix: 'fass',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M-.1 0L34.9 0 351.3 0l35 0-3.1 34.8-39.6 448L341.1 512l-29.3 0L74.4 512l-29.3 0-2.6-29.2L3 34.8-.1 0zM69.8 64l21 237.4L96 304c20.1 10.1 43.9 10.1 64 0s43.9-10.1 64 0s43.9 10.1 64 0l7.5-3.8L316.4 64 69.8 64zM192 96l47.9 53.9c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4L192 96z"]
};
const faConveyorBelt = {
  prefix: 'fass',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M128 0L256 0l0 128 64-48 64 48L384 0 512 0l0 256-384 0L128 0zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faLocationCheck = {
  prefix: 'fass',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm-9.7-249.7l-17 17-17-17L81.7 195.6l33.9-33.9 49.7 49.7 103-103 33.9 33.9-120 120z"]
};
const faMapMarkerCheck = faLocationCheck;
const faCoinVertical = {
  prefix: 'fass',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256S64.5 0 144 0s144 114.6 144 256zM184.2 425.4c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6zM136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160s-28.7 160-64 160zm90.1 96c15.6-13.2 29.3-29.7 40.9-48l63.7 0c-21 30.2-46.8 48-74.6 48l-29.9 0zM349 432l-64.7 0c13.2-28.4 23-60.9 29-96l64.3 0c-6 36.2-15.9 68.9-28.7 96zm32.8-128l-64.1 0c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48l64.1 0c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128l-64.3 0c-6-35.1-15.9-67.6-29-96L349 80c12.8 27.1 22.7 59.8 28.7 96zm-47-128L267 48c-11.5-18.3-25.2-34.8-40.9-48L256 0c27.9 0 53.6 17.8 74.6 48z"]
};
const faDisplay = {
  prefix: 'fass',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M576 0L0 0 0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0L336 416l240 0L576 0zM512 64l0 288L64 352 64 64l448 0z"]
};
const faPersonSign = {
  prefix: 'fass',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M96 48a48 48 0 1 1 96 0A48 48 0 1 1 96 48zM84.7 128l19.3 0 88 0 14.4 0 9.5 10.7 58.7 66.1 43.6 16.3 15.9-43.7L256 148.4 308.8 0 388 29.5l9.9-27.1L443 18.8 433 46.2l79 29.4L459.2 224l-80-29.8-45 123.7-8.2 22.6L280.8 324l8.2-22.6 7.3-20.1L244.8 262l-7.4-2.8-5.3-5.9L216 235.2l0 77.3 36.6 73.2 3.4 6.8 0 7.6 0 80 0 32-64 0 0-32 0-72.4L164.2 352 144 352l0 128 0 32-64 0 0-32 0-206.3L60.3 311 3.7 281l72-136 9-17z"]
};
const faFaceSmile = {
  prefix: 'fass',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM129.7 327.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSmile = faFaceSmile;
const faPhoneHangup = {
  prefix: 'fass',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M0 240L64 384l160-32V224c62.3-20.8 129.7-20.8 192 0V352l160 32 64-144C602.7 192 486.4 96 320 96S37.3 192 0 240z"]
};
const faSignatureSlash = {
  prefix: 'fass',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L565.2 416l50.8 0 24 0 0-48-24 0-112.7 0-61.8-48L544 320l32 0 0-64-32 0-83.6 0 18-53.9 19.5-58.5-59 17.7L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96c-37.4 0-69.8 21.4-85.7 52.6L48.4 14.8zM192 126.3c.9-16.9 14.8-30.3 32-30.3c17.7 0 32 14.3 32 32l0 7.8c0 13-.5 26-1.6 39L192 126.3zM355.4 253.2l42.7-12.8L386 276.9l-30.5-23.7zm-236.6 4.2L96 264.2 96 288l0 160 0 32 32 0 64 0 18.6 0 9.2-16.1 25.5-44.7c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-62.3 18.7zm113 32.9c-10.4 33.8-24.5 66.4-42.1 97.2L173.4 416 160 416l0-104.2 71.8-21.5zM24 368L0 368l0 48 24 0 40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0z"]
};
const faThumbtack = {
  prefix: 'fass',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M64 0L32 0l0 64 32 0 29.5 0L82.1 212.1C23.7 240.7 0 293 0 320l0 32 384 0 0-32c0-22.5-23.7-76.5-82.1-106.7L290.5 64 320 64l32 0 0-64L320 0 64 0zm96 480l0 32 64 0 0-32 0-96-64 0 0 96z"]
};
const faThumbTack = faThumbtack;
const faWheatSlash = {
  prefix: 'fass',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M362.6 258.7l28.6-28.6 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L358.2 16 335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-3.5 3.5-6.6 7.1-9.4 10.9L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L362.6 258.7zm-68.8 68.8l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L89.4 441.4 66.7 464 112 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88l0 40 40 0c48.6 0 88-39.4 88-88l0-40L536 0z"]
};
const faTrophy = {
  prefix: 'fass',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M129.6 64c-1-20.1-1.6-41.4-1.6-64L448 0c0 22.6-.6 43.9-1.6 64L552 64l24 0 0 24c0 134.5-70.4 207.7-140.5 246.1c-34.5 18.9-68.8 29.3-94.3 35c-5.9 1.3-11.3 2.4-16.2 3.3c-1.7 .9-3.4 1.8-5.1 2.6l0 73.1 72 0 24 0 0 24 0 16 0 24-24 0-208 0-24 0 0-24 0-16 0-24 24 0 72 0 0-73.1c-1.7-.8-3.3-1.7-5.1-2.6c-4.9-.9-10.3-1.9-16.2-3.3c-25.5-5.7-59.8-16.1-94.3-35C70.4 295.7 0 222.5 0 88L0 64l24 0 105.6 0zm3.6 48l-84.4 0c7.5 97.9 60.9 150.6 114.6 179.9c7.2 4 14.5 7.5 21.7 10.7c-22.7-40.3-42.8-100.5-51.9-190.6zM390.8 302.6c7.2-3.2 14.4-6.7 21.7-10.7c53.7-29.4 107.1-82 114.6-179.9l-84.4 0c-9.1 90.1-29.2 150.3-51.9 190.6z"]
};
const faCloudsSun = {
  prefix: 'fass',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M121.3 0L104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96c36.6 0 68.5 20.5 84.7 50.7c7.5-23.3 23.7-42.8 44.7-54.5L312 104 294.7 0 208 60.7 121.3 0zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm325.2 80.1l42.8 0 0-72c0-39.8-32.2-72-72-72c-3.2 0-6.4 .2-9.5 .6C551.4 107.9 519 80.1 480 80.1c-34.2 0-63.3 21.4-74.8 51.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c14.6-5.8 30.6-9 47.3-9c35.7 0 68 14.6 91.2 38.2c11.5-4 23.9-6.2 36.8-6.2c44.7 0 83.3 26.2 101.3 64.1zm42.7 223.8l0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 242.6 402.8 224 368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0 80 0z"]
};
const faPersonPraying = {
  prefix: 'fass',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M224 64a64 64 0 1 1 128 0A64 64 0 1 1 224 64zm-72.1 80l24.1 0 48 0 20.4 0 12 16.5 39.1 53.8L334.8 182l31-25.3 50.7 61.9-31 25.3-72.1 59-32.8 26.8-24.9-34.2L232.7 264l-45 90 116.1 85.8L280 512 72 512l-40 0 0-80 40 0 86.6 0-53.2-39.3c-34.9-25.8-45.8-73.3-25.6-111.8l60.8-115.5L151.9 144z"]
};
const faPray = faPersonPraying;
const faHammer = {
  prefix: 'fass',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M225.6 18.2L176 48l96 48 0 48L384 256l24-24 24 24-24 24 48 48L576 208l-48-48-24 24-24-24 24-24L405.5 37.5C381.5 13.5 348.9 0 315 0L291.5 0c-23.2 0-46 6.3-65.9 18.2zM0 416l96 96L330.7 248 264 181.3 0 416z"]
};
const faFaceVomit = {
  prefix: 'fass',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9c16.7-12.6 26.4-27.7 26.4-44c0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44c-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256zM262.9 192L144 128l45.7 64L144 256l118.9-64zM432 128L313.1 192 432 256l-45.7-64L432 128zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3L480 480l0 32L96 512l0-32 46.8-15.6c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faSpeakers = {
  prefix: 'fass',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M0 0L256 0l0 257.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 97.6L0 512 0 0zM352 512l-32 0-32 0 0-32 0-144 0-304 0-32 32 0 32 0L640 0l0 512-288 0zm0-176a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM176 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faTtyAnswer = {
  prefix: 'fass',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M144 0L0 32 0 64C0 311.4 200.6 512 448 512l32 0 32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0zM352 64l-64 0 0 64 64 0 0-64zm0 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-256 0l0 64 160 0 0-64-160 0z"]
};
const faTeletypeAnswer = faTtyAnswer;
const faMugTeaSaucer = {
  prefix: 'fass',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M208 96l0-64L96 32l0 352 384 0 0-96 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0-32 0L240 32l0 64 48 48 0 112-128 0 0-112 48-48zm272 0l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128zM32 416L0 416l0 64 32 0 512 0 32 0 0-64-32 0L32 416z"]
};
const faDiagramLeanCanvas = {
  prefix: 'fass',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 96l0 208 64 0 0-208-64 0zm-48 0l-64 0 0 80 64 0 0-80zM352 96l-64 0 0 208 64 0 0-208zM240 96l-64 0 0 80 64 0 0-80zM128 96L64 96l0 208 64 0 0-208zM64 352l0 64 232 0 0-64L64 352zm280 64l232 0 0-64-232 0 0 64zM0 32l64 0 512 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM240 304l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z"]
};
const faAlt = {
  prefix: 'fass',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M448 64l-15.4 0L423 76 176.6 384 32 384 0 384l0 64 32 0 160 0 15.4 0 9.6-12L463.4 128 608 128l32 0 0-64-32 0L448 64zm0 320l-32 0 0 64 32 0 160 0 32 0 0-64-32 0-160 0z"]
};
const faDial = {
  prefix: 'fass',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M320 0l0 64-64 0 0-64 64 0zM128 64l0 64-64 0 0-64 64 0zm384 0l0 64-64 0 0-64 64 0zm0 192l64 0 0 64-64 0 0-64zm0 192l0 64-64 0 0-64 64 0zM64 448l64 0 0 64-64 0 0-64zM0 256l64 0 0 64L0 320l0-64zm175.1-81.8c56.7-56.7 145.4-62 208-15.7L271.3 270.4l-17 17 33.9 33.9 17-17L417.1 192.4c46.2 62.6 41 151.3-15.7 208c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3z"]
};
const faDialMedHigh = faDial;
const faHandPeace = {
  prefix: 'fass',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M256 0l0 240-64 0L192 0l64 0zm96 160l0 128-64 0 0-128 64 0zm32 32l64 0 0 128-64 0 0-128zM101.5 69.8L175.9 240l-69.9 0L42.8 95.4 30 66.1 88.6 40.5l12.8 29.3zM64 363l0-91 56.1 0 69.9 0 66.1 0 0 48 0 32-96 0-16 0 0 32 16 0 112 0 16 0 0-16 0-48 64 0 0 32 96 0c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363z"]
};
const faCircleTrash = {
  prefix: 'fass',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128l41.4 0 11.3-11.3 4.7-4.7 6.6 0 64 0 6.6 0 4.7 4.7L310.6 128l41.4 0 16 0 0 32-16 0-192 0-16 0 0-32 16 0zm0 64l192 0L336 384l-160 0L160 192z"]
};
const faTrashCircle = faCircleTrash;
const faRotate = {
  prefix: 'fass',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8L44.8 181.4C55.6 150.7 73.2 122 97.6 97.6c87.5-87.5 229.3-87.5 316.8 0c0 0 0 0 0 0L472 40l24 24 0 160-160 0-24-24 57.1-57.1s0 0 0 0c-62.5-62.5-163.8-62.5-226.3 0zm0 226.3c62.5 62.5 163.8 62.5 226.3 0c17.5-17.5 30.1-38 37.8-59.8l60.4 21.3c-10.8 30.6-28.4 59.3-52.9 83.8c-87.5 87.5-229.3 87.5-316.7 0c0 0 0 0 0 0L40 472 16 448l0-160 160 0 24 24-57.1 57.1z"]
};
const faSyncAlt = faRotate;
const faCircleQuarters = {
  prefix: 'fass',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M120.2 391.8L256 256 391.8 391.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faSpinner = {
  prefix: 'fass',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M208 0l0 96 96 0 0-96L208 0zM0 208l0 96 96 0 0-96L0 208zM208 512l96 0 0-96-96 0 0 96zM512 208l-96 0 0 96 96 0 0-96zM41 403.1L108.9 471l67.9-67.9-67.9-67.9L41 403.1zm362 67.9L471 403.1l-67.9-67.9-67.9 67.9L403.1 471zM41 108.9l67.9 67.9 67.9-67.9L108.9 41 41 108.9z"]
};
const faTowerControl = {
  prefix: 'fass',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M184 0L160 0l0 48 24 0 16 0 0 48-56 0-16 0 0 16 0 16-88 0-41 0L9 167.8 47 320l-31 0 0 64 32 0 32 0 0 128 288 0 0-128 32 0 32 0 0-64-31 0L439 167.8 449 128l-41 0-88 0 0-16 0-16-16 0-56 0 0-48 16 0 24 0 0-48L264 0 224 0 184 0zM128 320l-15 0-1.9-7.8L81 192l47 0 0 128zm48 0l0-128 96 0 0 128-96 0zm159 0l-15 0 0-128 47 0L337 312.2 335 320z"]
};
const faArrowUpTriangleSquare = {
  prefix: 'fass',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M416 32L528 224l-224 0L416 32zm-256 .4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26zM512 480l-192 0 0-192 192 0 0 192z"]
};
const faSortShapesUp = faArrowUpTriangleSquare;
const faWhale = {
  prefix: 'fass',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M160 0l24 104 104 24-80 80-80.8-11.5L90.6 255c-6.7 10.7-8.3 23.9-4.3 35.9c5.8 17.3 22 29 40.3 29l1.1 0c10.5 0 20.7-3.8 28.6-10.6l103.8-89C329.7 160.8 418.4 128 510.1 128L640 128l0 352-477.6 0C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2L92 164 80 80 160 0zM400 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faRobot = {
  prefix: 'fass',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M352 0l0 32 0 64 192 0 0 416L96 512 96 96l192 0 0-64 0-32 64 0zM208 384l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0zm96 0l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0zm96 0l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM64 224l0 192L0 416 0 224l64 0zm576 0l0 192-64 0 0-192 64 0z"]
};
const faPeace = {
  prefix: 'fass',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M224 445.3l0-121.8-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8l0-174.2C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5l0 121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3l0 174.2L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faPartyHorn = {
  prefix: 'fass',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.1 136l17-17 8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4 47.7 5.3-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153l-17 17L150.1 136zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3 5.3 47.7-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345l-17 17L342.1 328l17-17zM503.5 42.3l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5-18.3 15.5-31-36.6 18.3-15.5 10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5 31 36.6zM32 512L0 480l38.5-98.9 92.4 92.4L32 512zm131.5-51.1L51.1 348.5l23.2-59.6L223.1 437.7l-59.6 23.2zM255.7 425L87 256.3 112 192 320 400l-64.3 25z"]
};
const faGears = {
  prefix: 'fass',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M125 8l70 0 10 48.1c13.8 5.2 26.5 12.7 37.5 22L285.6 64 320 123.4l-33.9 30.3c1.3 7.3 1.9 14.7 1.9 22.3s-.7 15.1-1.9 22.3L320 228.6 285.6 288l-43.1-14.2c-11.1 9.3-23.7 16.8-37.5 22L195 344l-70 0-10-48.1c-13.8-5.2-26.5-12.7-37.5-22L34.4 288 0 228.6l33.9-30.3C32.7 191.1 32 183.6 32 176s.7-15.1 1.9-22.3L0 123.4 34.4 64 77.5 78.2c11.1-9.3 23.7-16.8 37.5-22L125 8zm83 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM632 386.4l-47.8 9.8c-4.9 13.4-12 25.8-20.9 36.7l15 44.8L517.7 512l-30.9-34c-7.4 1.3-15 2-22.7 2s-15.4-.7-22.7-2l-30.9 34-60.6-34.4 15-44.8c-8.9-10.9-16-23.3-20.9-36.7L296 386.4l0-68.7 47.8-9.8c4.9-13.4 12-25.8 20.9-36.7l-15-44.8L410.3 192l30.9 34c7.4-1.3 15-2 22.7-2s15.4 .7 22.7 2l30.9-34 60.6 34.4-15 44.8c8.9 10.9 16 23.3 20.9 36.7l47.8 9.8 0 68.7zM464 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faCogs = faGears;
const faSunBright = {
  prefix: 'fass',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M280 24l0-24L232 0l0 24 0 64 0 24 48 0 0-24 0-64zm157 84.9l17-17L420 58l-17 17-45.3 45.3-17 17 33.9 33.9 17-17L437 108.9zM108.9 75L92 58 58 92l17 17 45.3 45.3 17 17 33.9-33.9-17-17L108.9 75zM24 232L0 232l0 48 24 0 64 0 24 0 0-48-24 0-64 0zm400 0l-24 0 0 48 24 0 64 0 24 0 0-48-24 0-64 0zM154.2 391.8l17-17-33.9-33.9-17 17L75 403.1 58 420 92 454l17-17 45.3-45.3zm237.6-33.9l-17-17-33.9 33.9 17 17L403.1 437l17 17L454 420l-17-17-45.3-45.3zM280 424l0-24-48 0 0 24 0 64 0 24 48 0 0-24 0-64zm-24-56a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
const faSunAlt = faSunBright;
const faWarehouse = {
  prefix: 'fass',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M0 512L0 128 320 0 640 128l0 384-96 0 0-320L96 192l0 320L0 512zm128-80l384 0 0 80-384 0 0-80zm0-96l384 0 0 64-384 0 0-64zm0-112l384 0 0 80-384 0 0-80z"]
};
const faConveyorBeltArm = {
  prefix: 'fass',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M128 0l32 0L320 0l32 0 0 64-32 0-52.9 0-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3 11.8 1.6 0 64.6 0 13.6 0 16s0 0 0 0l-32 0 0-16 0-17.9L255.2 164.4c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64 160 64l-32 0 0-64zm96 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM416 256l96 0 0 64 32 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96s43-96 96-96l0-64 96 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faLockKeyholeOpen = {
  prefix: 'fass',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M432 64c-44.2 0-80 35.8-80 80l0 48 96 0 0 320L0 512 0 192l288 0 0-48C288 64.5 352.5 0 432 0s144 64.5 144 144l0 48 0 32-64 0 0-32 0-48c0-44.2-35.8-80-80-80zM256 384l32 0 0-64-32 0-64 0-32 0 0 64 32 0 64 0z"]
};
const faLockOpenAlt = faLockKeyholeOpen;
const faSquareFragile = {
  prefix: 'fass',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M448 32L0 32 0 480l448 0 0-448zM128 96l48 0 32 64-32 32 80 64-32-64 48-32L240 96l80 0 0 112c0 47.6-34.6 87.1-80 94.7l0 81.3 64 0 0 32-160 0 0-32 64 0 0-81.3c-45.4-7.6-80-47.1-80-94.7l0-112z"]
};
const faBoxFragile = faSquareFragile;
const faSquareWineGlassCrack = faSquareFragile;
const faArrowUpRightDots = {
  prefix: 'fass',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M160 0L128 0l0 64 32 0 50.7 0L25.4 249.4 2.7 272 48 317.3l22.6-22.6L256 109.3l0 50.7 0 32 64 0 0-32 0-128 0-32L288 0 160 0zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faSquareN = {
  prefix: 'fass',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M448 32L0 32 0 480l448 0 0-448zM288 128l48 0 0 24 0 208 0 24-35.1 0-7.2-8.5L160 217.5 160 360l0 24-48 0 0-24 0-208 0-24 35.1 0 7.2 8.5L288 294.5 288 152l0-24z"]
};
const faSplotch = {
  prefix: 'fass',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M256 0h80l30.9 103c10.8 35.9 37.7 64.7 72.8 77.9L512 208v64l-73.2 54.9c-34 25.5-52 67-47.3 109.3L400 512H304l-73.3-58.6c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L16 464V376l24.3-29.1c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L0 160V80L101.1 97.2c44 7.5 88.5-10.1 115.5-45.5L256 0z"]
};
const faFaceGrinHearts = {
  prefix: 'fass',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm.3-180.2c59.1 0 114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2c46.2 18.3 101.2 29 160.2 29zm-57-202.6c17.8 4.8 28.4 23.1 23.6 40.8l-21.6 80.5-80.6-21.6c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-80.6 21.6L289.1 170c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]
};
const faGrinHearts = faFaceGrinHearts;
const faMeter = {
  prefix: 'fass',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32z"]
};
const faMandolin = {
  prefix: 'fass',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M448 0L368 48l-25.4 76.1-65.7 65.7C189.6 188.3 0 200.5 0 336c0 97.2 78.8 176 176 176c135.5 0 147.7-189.6 146.2-276.9l65.7-65.7L464 144l48-80L448 0zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faDiceFour = {
  prefix: 'fass',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M0 32l448 0 0 448L0 480 0 32zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faSimCard = {
  prefix: 'fass',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M0 0L32 0 256 0l13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 352 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM64 192l0 64 64 0 0-64-64 0zm0 160l80 0 96 0 80 0 0-64-80 0-96 0-80 0 0 64zM320 192l-64 0 0 64 64 0 0-64zm-160 0l0 64 64 0 0-64-64 0zm96 192l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64zm-96 0l-64 0 0 64 64 0 0-64z"]
};
const faTransgender = {
  prefix: 'fass',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M0 112L0 0 112 0l16 16L89 55l23 23 7-7 17-17L169.9 88l-17 17-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2L423 55 384 16 400 0 512 0l0 112-16 16L457 89l-72.1 72.1C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2l0 17.8 16 0 24 0 0 48-24 0-16 0 0 8 0 24-48 0 0-24 0-8-16 0-24 0 0-48 24 0 16 0 0-17.8C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7-17 17L54.1 136l17-17 7-7L55 89 16 128 0 112zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
const faTransgenderAlt = faTransgender;
const faMercury = {
  prefix: 'fass',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M39.3 0c9.8 31.3 29 58.4 54.2 78.1C46.7 109.7 16 163.3 16 224c0 89.1 66.2 162.7 152 174.4l0 25.6-32 0-24 0 0 48 24 0 32 0 0 16 0 24 48 0 0-24 0-16 32 0 24 0 0-48-24 0-32 0 0-25.6c85.8-11.7 152-85.3 152-174.4c0-60.7-30.7-114.3-77.5-145.9C315.7 58.4 334.9 31.3 344.7 0L275.2 0C258.6 28.7 227.5 48 192 48s-66.6-19.3-83.2-48L39.3 0zM304 224A112 112 0 1 1 80 224a112 112 0 1 1 224 0z"]
};
const faUpFromBracket = {
  prefix: 'fass',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M64 160L224 0 384 160l0 32-96 0 0 160-128 0 0-160-96 0 0-32zm0 192l0 96 320 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 352l0-32 64 0 0 32z"]
};
const faKnifeKitchen = {
  prefix: 'fass',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M480 0l88 88L448 208l0 64-55.5 43.2L278.6 201.4 480 0zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm40-40a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM0 480L256 224 400 368s-128 144-288 144C48 512 0 480 0 480z"]
};
const faBorderRight = {
  prefix: 'fass',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M448 32l0 448-64 0 0-448 64 0zm-96 0l0 64-64 0 0-64 64 0zm0 448l-64 0 0-64 64 0 0 64zm0-256l0 64-64 0 0-64 64 0zM160 96L96 96l0-64 64 0 0 64zm0 320l0 64-64 0 0-64 64 0zm0-128l-64 0 0-64 64 0 0 64zM256 32l0 64-64 0 0-64 64 0zm0 448l-64 0 0-64 64 0 0 64zm0-256l0 64-64 0 0-64 64 0zM64 96L0 96 0 32l64 0 0 64zm0 320l0 64L0 480l0-64 64 0zm0-128L0 288l0-64 64 0 0 64zM256 128l0 64-64 0 0-64 64 0zM64 192L0 192l0-64 64 0 0 64zm0 128l0 64L0 384l0-64 64 0zm192 64l-64 0 0-64 64 0 0 64z"]
};
const faArrowTurnDown = {
  prefix: 'fass',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M32 64L0 64 0 0 32 0 192 0l32 0 0 32 0 357.5 73.4-73.4L320 293.5l45.3 45.3-22.6 22.6-128 128L192 512l-22.6-22.6-128-128L18.7 338.7 64 293.5l22.6 22.6L160 389.5 160 64 32 64z"]
};
const faLevelDown = faArrowTurnDown;
const faSpade = {
  prefix: 'fass',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M33.1 222.9L96 160 256 0 416 160l62.9 62.9c21.2 21.2 33.1 50 33.1 80C512 365.3 461.3 416 398.9 416c-30 0-58.8-11.9-80-33.1L288 352l0 96 32 0 32 0 0 64-32 0-32 0-64 0-32 0-32 0 0-64 32 0 32 0 0-96-30.9 30.9c-21.2 21.2-50 33.1-80 33.1C50.7 416 0 365.3 0 302.9c0-30 11.9-58.8 33.1-80z"]
};
const faCardSpade = {
  prefix: 'fass',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M384 0L0 0 0 512l384 0L384 0zM192 120.8l39.6 39.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-8.4-8.4 0 40.8 16 0 16 0 0 32-16 0-16 0-32 0-16 0-16 0 0-32 16 0 16 0 0-40.8-8.4 8.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L192 120.8z"]
};
const faLineColumns = {
  prefix: 'fass',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M224 32L0 32 0 96l224 0 0-64zm0 128L0 160l0 64 224 0 0-64zM0 288l0 64 224 0 0-64L0 288zM224 416L0 416l0 64 224 0 0-64zM288 32l0 64 224 0 0-64L288 32zM512 160l-224 0 0 64 224 0 0-64zM288 288l0 64 224 0 0-64-224 0zM512 416l-224 0 0 64 224 0 0-64z"]
};
const faAnt = {
  prefix: 'fass',
  iconName: 'ant',
  icon: [640, 512, [], "e680", "M498.4 0L512 0l72 0 24 0 0 48-24 0-58.4 0L513.4 68.4C567.9 83.1 608 132.8 608 192l0 64-128 0c-14.8 0-28.8-3.3-41.3-9.3c6 12.5 9.3 26.5 9.3 41.3l0 .2 5.9 4.2 112 80 6.5 4.7 2.4 7.7 40 127.2-50.3 0-33-105.1-97.2-69.4c-1.9 3.1-3.9 6-6.1 8.9L473 391l3.6 3.6 1.8 4.8L521.1 512l-51.3 0-34.4-90.7-45.2-45.2c-11.7 5.1-24.6 7.9-38.2 7.9c-5.5 0-10.8-.5-16-1.3l-7.5 12.6L261.7 512l-55.3 0 2.2-3.9 78.2-136.9 .3-.4 4.7-7.9c-5.8-4.7-11.1-10-15.7-15.9L181.9 512l-55.3 0 2.2-3.8L212.4 362c-8.9 3-18.3 5-28 5.7L101.9 512l-55.3 0 2.1-3.7L128.9 368 0 368l0-79.3C0 200 72 128 160.7 128c58.2 0 107.3 39.6 122.4 93.1C300.6 203.1 325 192 352 192c14.8 0 28.8 3.3 41.3 9.3c-6-12.5-9.3-26.5-9.3-41.3c0-45.7 31.9-83.9 74.6-93.6l32.9-54.7 7-11.7zM536 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faArrowRightToLine = {
  prefix: 'fass',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 96l0-32-64 0 0 32 0 320 0 32 64 0 0-32 0-320zM310.6 278.6L333.3 256l-22.6-22.6-128-128L160 82.7 114.7 128l22.6 22.6L210.7 224 32 224 0 224l0 64 32 0 178.7 0-73.4 73.4L114.7 384 160 429.3l22.6-22.6 128-128z"]
};
const faArrowToRight = faArrowRightToLine;
const faPersonFallingBurst = {
  prefix: 'fass',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M256 32l0-32L192 0l0 32 0 76.2L49.7 179.4 32 188.2 32 208l0 144 0 32 64 0 0-32 0-109.8L253.1 484.9l17.4 26.9L324.2 477l-17.4-26.9L222.6 320l1.4 0 96 0 38.4 51.2 19.2 25.6 51.2-38.4-19.2-25.6-48-64L352 256l-16 0-95.5 0L188 181.8l50.3-25.2 17.7-8.8 0-19.8 0-96zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 273.2l76.4 61.4-.4-98 95.6-21.4-76.9-60.8 42.9-88.1L506.2 88.5 464 0 421.8 88.5 326.4 66.3l42.9 88.1-76.9 60.8 39.5 8.8 4.1 0 32 0 7.3 9.7 12.8 2.9-.1 14.1 39.1 52.2L464 273.2z"]
};
const faFlagPennant = {
  prefix: 'fass',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-128L448 192 64 32z"]
};
const faPennant = faFlagPennant;
const faConveyorBeltEmpty = {
  prefix: 'fass',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faUserGroupSimple = {
  prefix: 'fass',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM256 288l64 192L0 480 64 288l192 0zm384 0L576 480l-192 0L320 288l320 0z"]
};
const faAward = {
  prefix: 'fass',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M192 0l43.7 28.8L288 25.7l23.5 46.8L358.3 96l-3.1 52.3L384 192l-28.8 43.7 3.1 52.3-46.8 23.5L288 358.3l-52.3-3.1L192 384l-43.7-28.8L96 358.3 72.5 311.5 25.7 288l3.1-52.3L0 192l28.8-43.7L25.7 96 72.5 72.5 96 25.7l52.3 3.1L192 0zm80 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM0 456L49.8 337.6l17.6 35 9.4 18.8 21-1.2 41.7-2.4 31.9 21L128 512 75.8 456 0 456zm256 56L212.5 408.8l31.9-21 41.7 2.4 21 1.2 9.4-18.8 17.6-35L384 456l-75.8 0L256 512z"]
};
const faTicketSimple = {
  prefix: 'fass',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 64l576 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144L0 448 0 304c26.5 0 48-21.5 48-48s-21.5-48-48-48L0 64z"]
};
const faTicketAlt = faTicketSimple;
const faBuilding = {
  prefix: 'fass',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M384 0L0 0 0 512l144 0 0-128 96 0 0 128 144 0L384 0zM64 224l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z"]
};
const faAnglesLeft = {
  prefix: 'fass',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M41.4 278.6L18.7 256l22.6-22.6 160-160L224 50.7 269.3 96l-22.6 22.6L109.3 256 246.6 393.4 269.3 416 224 461.3l-22.6-22.6-160-160zm192 0L210.7 256l22.6-22.6 160-160L416 50.7 461.3 96l-22.6 22.6L301.3 256 438.6 393.4 461.3 416 416 461.3l-22.6-22.6-160-160z"]
};
const faAngleDoubleLeft = faAnglesLeft;
const faCamcorder = {
  prefix: 'fass',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M32 32l32 0 224 0 32 0 0 64-32 0L96 96l0 64 288 0 0 320L0 480 0 160l32 0 0-96 0-32zM576 160l0 320L416 400l0-160 160-80zM80 224l-16 0 0 32 16 0 224 0 16 0 0-32-16 0L80 224z"]
};
const faVideoHandheld = faCamcorder;
const faPancakes = {
  prefix: 'fass',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 160c123.7 0 224-28.7 224-64s-100.3-64-224-64S32 60.7 32 96c0 17.4 24.4 33.2 64 44.8L96 272l0 32 64 0 0-32 0-118.2c10.3 1.4 21 2.6 32 3.5l0 66.7 0 32 64 0 0-32 0-64zM192 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zM14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9l0-48.1c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8zM288 239.4c126.3-4.9 224-38.6 224-79.4c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5c-.1 .1-.1 .2-.1 .2l0 32 0 15.4zM7.2 221.1C2.5 227.2 0 233.5 0 240c0 20.3 24.2 38.8 64 52.9L64 272l0-25.3c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-42.7 13.4-97.9 22-158.5 24.3l0 16.6L192 288l0 29.5c20.5 1.6 41.9 2.5 64 2.5zm256 0c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80zm0 80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80z"]
};
const faAlbumCircleUser = {
  prefix: 'fass',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M0 32l448 0 0 160.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4L0 480 0 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L488 416l-112 0-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faSubtitlesSlash = {
  prefix: 'fass',
  iconName: 'subtitles-slash',
  icon: [640, 512, [], "e610", "M29.4 .1l19 14.7L70.5 32 608 32l0 417.3 12.9 10 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1zM384 275.4L400.3 288l7.7 0 80 0 24 0 0-48-24 0-80 0-24 0 0 35.4zm128 99.4l0-38.7-24 0-25.9 0L512 374.7zM32 121.2L182.8 240 152 240l-24 0 0 48 24 0 91.7 0 60.9 48L288 336l0 48 24 0 53.5 0 121.8 96L32 480l0-358.8zM128 336l0 48 24 0 80 0 24 0 0-48-24 0-80 0-24 0z"]
};
const faQrcode = {
  prefix: 'fass',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M192 32L0 32 0 224l192 0 0-192zM128 96l0 64-64 0 0-64 64 0zm64 192L0 288 0 480l192 0 0-192zm-64 64l0 64-64 0 0-64 64 0zM256 32l0 192 192 0 0-192L256 32zm64 64l64 0 0 64-64 0 0-64zm32 352l0 32 32 0 0-32-32 0zm96 0l-32 0 0 32 32 0 0-32zM416 288l0 32-64 0 0-32-96 0 0 96 0 96 64 0 0-96 32 0 0 32 96 0 0-64 0-32 0-32-32 0z"]
};
const faDiceD10 = {
  prefix: 'fass',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M215.1 0L192 0 0 256l0 1.4 139.7-31L215.1 0zM1.9 289.8L240 512l0-191.6-91.4-63.2L1.9 289.8zM272 512L510.1 289.8 363.4 257.1 272 320.4 272 512zM512 257.4l0-1.4L320 0 296.9 0l75.4 226.3 139.7 31zM248.9 0L171 233.7l85 58.9 85-58.9L263.1 0 248.9 0z"]
};
const faFireplace = {
  prefix: 'fass',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M0 0L0 96l640 0 0-96L0 0zM608 128L32 128l0 384 128 0 0-160c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160 128 0 0-384zM297.5 265.6c-29.9 18.7-89.6 71.7-89.6 134.4c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.7-13.4-67.2-67.2-112l-22.4 22.4-44.8-44.8zm67.2 168.1c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8c0-33.6 44.8-67.2 44.8-67.2s44.8 33.6 44.8 67.2z"]
};
const faBrowser = {
  prefix: 'fass',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M0 32l512 0 0 448L0 480 0 32zm160 72l0 48 288 0 0-48-288 0zm-32-8L64 96l0 64 64 0 0-64z"]
};
const faPenPaintbrush = {
  prefix: 'fass',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M118.8 39.6L79.2 0 0 79.2l39.6 39.6L146.3 225.5l79.2-79.2L118.8 39.6zM399.2 511.2l176 0 0-64-64 0 0-48c0-53.6-37.7-98.5-88.1-109.4L289.8 423.1c11 50.4 55.8 88.1 109.4 88.1zM64 352L32 512l160-32L452.7 219.3l-128-128L64 352zM544 128L416 0 347.3 68.7l128 128L544 128z"]
};
const faPencilPaintbrush = faPenPaintbrush;
const faFishCooked = {
  prefix: 'fass',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M320 64c176 0 256 192 256 192s-80 192-256 192c-80.3 0-167.8-57.4-216.9-114.5L0 416l0-48L32 256 0 144 0 96l108.7 76.1C158.7 117.2 242.7 64 320 64zm6.6 96L304 137.4l-11.3 11.3-64 64L217.4 224 240 246.6l11.3-11.3 64-64L326.6 160zm112 16L416 153.4l-11.3 11.3-160 160L233.4 336 256 358.6l11.3-11.3 160-160L438.6 176zm16 112L432 265.4l-11.3 11.3-64 64L345.4 352 368 374.6l11.3-11.3 64-64L454.6 288z"]
};
const faChairOffice = {
  prefix: 'fass',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M352 0L96 0l0 256 256 0L352 0zM64 160l0-32L0 128l0 32 0 64 0 32 64 0 0-32 0-64zm384 0l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zM256 384l160 0 0-32-32-64L64 288 32 352l0 32 160 0 0 64-32 0-32 0 0 64 32 0 64 0 64 0 32 0 0-64-32 0-32 0 0-64z"]
};
const faMagnifyingGlassMusic = {
  prefix: 'fass',
  iconName: 'magnifying-glass-music',
  icon: [512, 512, [], "e65f", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 86.7L256.4 97.2l-48 16L192 118.7l0 17.3 0 32 0 57.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-86.7 31.6-10.5 16.4-5.5 0-17.3 0-32 0-33.3z"]
};
const faNestingDolls = {
  prefix: 'fass',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M192 0c61.9 0 112 50.1 112 112l0 112L80 224l0-112C80 50.1 130.1 0 192 0zM128 95.6c-.1 16.5 6.1 33.1 18.7 45.6c25 25 65.5 25 90.5 0c12.6-12.6 18.8-29.1 18.7-45.6c-28.2-2.8-52.1-20.3-64-44.7c-11.9 24.4-35.8 41.9-64 44.7zM288 512s48-80 48-128l0-32c0-70.7 57.3-128 128-128s128 57.3 128 128l0 32c0 48 48 128 48 128l-352 0zM392 352c-2.7 0-5.4-.1-8-.4c-.1 20.6 7.7 41.2 23.4 57c31.2 31.2 81.9 31.2 113.1 0c15.7-15.7 23.5-36.4 23.4-57c-2.6 .3-5.3 .4-8 .4c-31.7 0-59-18.4-72-45.1c-13 26.7-40.3 45.1-72 45.1zM260.6 495.5L250.7 512 48 512s-48-48-48-128c0-44.4 20.2-84.4 37.9-119.4c0 0 0 0 0 0s0 0 0 0c1.5-2.9 2.9-5.8 4.3-8.6L336 256c-20.1 26.7-32 60-32 96l0 32c0 16.3-9 42.5-21.1 68.6c-5.6 12.2-11.3 23-15.5 30.8c-2.1 3.9-3.9 7-5.1 9.1c-.6 1-1.1 1.8-1.4 2.4l-.3 .6-.1 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faClockRotateLeft = {
  prefix: 'fass',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M67.2 83.2L0 16 0 192l176 0-63.5-63.5C147.7 88.9 198.9 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4l-36.6 52.5C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C181.2 0 113.9 32.1 67.2 83.2zM280 128l-48 0 0 24 0 104 0 9.9 7 7 64 64 17 17L353.9 320l-17-17-57-57 0-94.1 0-24z"]
};
const faHistory = faClockRotateLeft;
const faTrumpet = {
  prefix: 'fass',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M512 285.5c38.4 25.4 71.5 63.4 96 98.5l32 0 0-320-32 0c-41.7 59.7-108.4 128-184 128l-24 0 0-32 0-24-48 0 0 24 0 32-40 0 0-32 0-24-48 0 0 24 0 32-40 0 0-32 0-24-48 0 0 24 0 32L48 192l0-16L0 176l0 24 0 48 0 24 48 0 0-16 33.1 0C70.2 274.8 64 296.7 64 320c0 70.7 57.3 128 128 128l96 0c0 0 0 0 .1 0l95.9 0c69 0 125.2-54.6 127.9-122.9c-1-.8-1.9-1.6-2.9-2.3C488.8 307 468.3 296 448 291l0 29c0 29.8-20.4 54.9-48 62l0-126 24 0c8.1 0 16.1 .8 24 2.3c1.3 .2 2.6 .5 3.9 .8c21.1 4.6 41.2 14 60.1 26.5zM352 384l-40 0 0-128 40 0 0 128zM176 258l0 124c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62zm48-2l40 0 0 128-40 0 0-128z"]
};
const faFaceGrinBeamSweat = {
  prefix: 'fass',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5.2 2.3-11.9 6-19.3l.2-.4c9.4-18.9 27.4-42.4 38.1-56.4c1.4-1.8 2.6-3.4 3.7-4.9c1.3 1.7 2.8 3.7 4.5 5.9C483.7 25.9 512 63 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.8 0 100 15.4 140.2 41.8c-1.2 2.2-2.3 4.4-3.4 6.6c-3.9 8-8.8 20-8.8 32.6c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zm.3 331.8c-59.1 0-114.1-10.6-160.2-29C112.3 376.7 177.9 432 256.3 432s144-55.3 160.2-129.2c-46.2 18.3-101.2 29-160.2 29zM176 152c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80zm104 80s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80z"]
};
const faGrinBeamSweat = faFaceGrinBeamSweat;
const faFireSmoke = {
  prefix: 'fass',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M288 .2s-128 103.6-128 192c0 30.2 8.3 58.4 22.9 82.5c4.5 2.6 8.9 5.3 13.1 8.4c13.7-16.8 30.7-30.8 50.1-40.9c-3.9-9.4-6-20.2-6-32.1c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c11.3 20.7 12.3 44.9 4.2 65.2c19.3 10.1 36.2 24 49.9 40.8c4.2-3 8.6-5.8 13.1-8.4c14.5-24.1 22.9-52.3 22.9-82.5c0-73.6-96-160-96-160s-13.9 12.5-31 32c-32.3-37.5-65-64-65-64zM0 512l112 0 208 0 208 0 112 0 0-112c0-61.9-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288C50.1 288 0 338.1 0 400L0 512z"]
};
const faPhoneMissed = {
  prefix: 'fass',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M96 0l0 128 32 32 47-47 88 88 7 7 9.9 0 80 0 9.9 0 7-7L521 57l17-17L504 6.1 487 23l-137 137-60.1 0L209 79l47-47L224 0 96 0zM0 400L64 512l160-48 0-80c62.3-20.8 129.7-20.8 192 0l0 80 160 48 64-112c-37.3-48-153.6-144-320-144S37.3 352 0 400z"]
};
const faFileExport = {
  prefix: 'fass',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M0 0L224 0l0 160 160 0 0 128-168 0-24 0 0 48 24 0 168 0 0 176L0 512 0 0zM384 336l0-48 110.1 0-39-39-17-17L472 198.1l17 17 80 80 17 17-17 17-80 80-17 17L438.1 392l17-17 39-39L384 336zm0-208l-128 0L256 0 384 128z"]
};
const faArrowRightFromFile = faFileExport;
const faShield = {
  prefix: 'fass',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M267.6 4.5L256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5z"]
};
const faShieldBlank = faShield;
const faArrowUpShortWide = {
  prefix: 'fass',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M320 32l-32 0 0 64 32 0 32 0 32 0 0-64-32 0-32 0zm0 128l-32 0 0 64 32 0 96 0 32 0 0-64-32 0-96 0zm0 128l-32 0 0 64 32 0 160 0 32 0 0-64-32 0-160 0zm0 128l-32 0 0 64 32 0 224 0 32 0 0-64-32 0-224 0zM151.7 58.5L128 32.4l-23.7 26-80 88L2.8 170.2l47.4 43.1 21.5-23.7L96 162.8 96 448l0 32 64 0 0-32 0-285.2 24.3 26.8 21.5 23.7 47.4-43.1-21.5-23.7-80-88z"]
};
const faSortAmountUpAlt = faArrowUpShortWide;
const faArrowsRepeat1 = {
  prefix: 'fass',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M0 224l0 32 64 0 0-32 0-64 352 0 32 0 0-45.3-9.4-9.4-80-80L336 2.7 290.7 48l22.6 22.6L338.7 96 32 96 0 96l0 32 0 96zm512 64l0-32-64 0 0 32 0 64L96 352l-32 0 0 45.3 9.4 9.4 80 80L176 509.3 221.3 464l-22.6-22.6L173.3 416 480 416l32 0 0-32 0-96zM216 192l0 48 24 0 0 56 0 24 48 0 0-24 0-80 0-24-24 0-24 0-24 0z"]
};
const faRepeat1Alt = faArrowsRepeat1;
const faGunSlash = {
  prefix: 'fass',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L412.4 297.4 432.9 240l47.1 0 32-32 96 0 0-144-48 0 0-8 0-24-48 0 0 24 0 8L111.8 64 48.4 14.8zM194.2 128L512 128l0 32-276.6 0-41.2-32zM338.5 240l43.5 0-9.4 26.4-34-26.4zM324.9 352L32 121.2 32 240l92 0L64 480l160 0 32-128 68.9 0z"]
};
const faAvocado = {
  prefix: 'fass',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M469.8 245.8c56.2-56.2 56.2-147.4 0-203.6s-147.4-56.2-203.6 0L212.3 96c-54.7-1.1-109.7 19.2-151.4 60.9c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c41.7-41.7 62-96.7 60.9-151.4l53.9-53.9zM283.2 347.2c-41.7 41.7-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8s102.1-49.1 134.8-16.4s25.3 93-16.4 134.8z"]
};
const faBinary = {
  prefix: 'fass',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M256 0l48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-96-16 0-32 0 0-64 32 0zM32 288l48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0L0 512l0-64 32 0 16 0 0-96-16 0L0 352l0-64 32 0zM0 0L32 0 160 0l32 0 0 32 0 160 0 32-32 0L32 224 0 224l0-32L0 32 0 0zM64 64l0 96 64 0 0-96L64 64zM224 288l128 0 32 0 0 32 0 160 0 32-32 0-128 0-32 0 0-32 0-160 0-32 32 0zm32 160l64 0 0-96-64 0 0 96z"]
};
const faGlassesRound = {
  prefix: 'fass',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-5.3 19-10.6 38-16.5 60.9C80.4 217 107.2 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c28.8 0 55.6 9 77.6 24.3c-5.9-22.9-11.1-41.9-16.5-60.9l-.3-1s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8 0 48 0 24s0 0 0 0c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0 0 0 0 0 0l0-24 0-48 0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm376-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
const faGlassesAlt = faGlassesRound;
const faPhonePlus = {
  prefix: 'fass',
  iconName: 'phone-plus',
  icon: [576, 512, [], "f4d2", "M176 0L32 32l0 32c0 247.4 200.6 448 448 448l32 0 32-144L400 288l-67 83.8C264.5 335.7 208.3 279.5 172.2 211L256 144 176 0zM424 224l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24L424 0l0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z"]
};
const faDitto = {
  prefix: 'fass',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M0 32L32 288l64 0L128 32 0 32zm192 0l32 256 64 0L320 32 192 32z"]
};
const faPersonSeat = {
  prefix: 'fass',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32l-32 0 0 32 0 96c0 35.3 28.7 64 64 64l99.8 0 12.5 100 3.5 28 28.2 0 48 0 32 0 0-64-32 0-19.8 0L319.8 316l-3.5-28L288 288l-96 0 0-32 64 0 32 0 0-64-32 0-64 0 0-32-32 0-32 0zm-64 0l0-32L0 128l0 32L0 416l0 32 32 0 160 0 32 0 0-64-32 0L64 384l0-224z"]
};
const faHouseMedical = {
  prefix: 'fass',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M511.8 287.6l64.2 0 0-47.6L288.4 0 0 240l0 47.6 64.1 0 0 224.4 448.7 0-1-224.4zM256 192l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z"]
};
const faGolfBallTee = {
  prefix: 'fass',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M384 192c0 66.8-34.1 125.6-85.8 160L85.8 352C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zm-52.3-49.3c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zM96 448l0-64 192 0 0 64-64 0 0 64-64 0 0-64-64 0z"]
};
const faGolfBall = faGolfBallTee;
const faCircleChevronLeft = {
  prefix: 'fass',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM167 239L271 135l17-17L321.9 152l-17 17-87 87 87 87 17 17L288 393.9l-17-17L167 273l-17-17 17-17z"]
};
const faChevronCircleLeft = faCircleChevronLeft;
const faHouseChimneyWindow = {
  prefix: 'fass',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M576 287.6l-64.2 0 1 224.4L64.1 512l0-224.4L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6zM352 192l-128 0 0 128 128 0 0-128z"]
};
const faScythe = {
  prefix: 'fass',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M540.7 0L499.5 192 0 192S80 0 352 0L540.7 0zm32.7 0l64 0L527.7 512l-64 0L498 352l-82 0-32 0 0-64 32 0 95.7 0L573.4 0z"]
};
const faPenNib = {
  prefix: 'fass',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M43.3 491.3L64 512l288-96 64-192 .7-.7-128-128L288 96 96 160 0 448l20.7 20.7 144-144c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7l-144 144zm268-418.6l128 128L512 128 384 0 311.3 72.7z"]
};
const faBanParking = {
  prefix: 'fass',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M412.5 367.2L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96l-80 0-26.7 0L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5zM296.6 251.4L237.3 192l42.7 0c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 261.3l0 26.7 0 64 0 32 64 0 0-32 0-26.7-64-64z"]
};
const faParkingCircleSlash = faBanParking;
const faTentArrowTurnLeft = {
  prefix: 'fass',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M109.8 52.2L89.9 72 456 72c66.3 0 120 53.7 120 120l0 40 0 24-48 0 0-24 0-40c0-39.8-32.2-72-72-72L89.9 120l19.8 19.8 17 17L92.8 190.7l-17-17L15 113l-17-17L15 79 75.8 18.2l17-17 33.9 33.9-17 17zM64 512L96 288 288 160 480 288l32 224-128 0L288 352l0 160L64 512z"]
};
const faFaceDiagonalMouth = {
  prefix: 'fass',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM372.4 319.4l-224 64L133 387.8 124.2 357l15.4-4.4 224-64 15.4-4.4 8.8 30.8-15.4 4.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faDiagramCells = {
  prefix: 'fass',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M512 32l0 192L0 224 0 32l512 0zM448 416l0-64L64 352l0 64 384 0zm64 64l-64 0L64 480 0 480l0-64 0-64 0-64 64 0 384 0 64 0 0 64 0 64 0 64z"]
};
const faCricketBatBall = {
  prefix: 'fass',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M509.3 48L486.6 70.6l-119 119L425.9 248l-40 40L224 288l0-161.9 40-40 58.3 58.3 119-119L464 2.7 509.3 48zM352 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM111 508.2c-21.4-4-51.4-13.1-71.9-35.2C16.9 452.4 7.8 422.4 3.8 401c-3.2-17-4-34-3.6-51.2L192 158.1 192 304l0 16 16 0 145.9 0L162.2 511.8c-17.2 .4-34.2-.4-51.2-3.6z"]
};
const faCricket = faCricketBatBall;
const faTents = {
  prefix: 'fass',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M640 352l-182.5 0-9.8-68.5-2-14.2-11.9-7.9-192-128-12.9-8.6L416 0 608 128l32 224zM0 512L32 288 224 160 416 288l32 224-128 0L224 352l0 160L0 512z"]
};
const faWandMagic = {
  prefix: 'fass',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M112 512l39.6-39.6L472.4 151.6 512 112 472.4 72.4 439.6 39.6 400 0 360.4 39.6 39.6 360.4 0 400l39.6 39.6 32.8 32.8L112 512zM400 79.2L432.8 112l-80.4 80.4-32.8-32.8L400 79.2z"]
};
const faMagic = faWandMagic;
const faDog = {
  prefix: 'fass',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M309.6 158.5L336 0l32 0 24 32 72 0 32 32 80 0 0 48c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0-5.1 30.5-112-64zM416 256.1L416 512l-96 0 0-147.2c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2L160 512l-96 0 0-264.9c-29.1-13.6-50.5-41.4-54.8-75.1l-1-7.9-4-31.8 63.5-7.9 4 31.8 1 7.9c2 16 15.6 28 31.8 28l39.5 0 16 0 16 0 127.8 0L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faPenLine = {
  prefix: 'fass',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M32 352L0 512l160-32L420.7 219.3l-128-128L32 352zM512 128L384 0 315.3 68.7l128 128L512 128zM248 464l-24 0 0 48 24 0 304 0 24 0 0-48-24 0-304 0z"]
};
const faAtomSimple = {
  prefix: 'fass',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM256 296l40-40-40-40-40 40 40 40z"]
};
const faAtomAlt = faAtomSimple;
const faAmpersand = {
  prefix: 'fass',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M112 32L80 32l0 32 0 65c0 28 10.5 54.9 29.3 75.5l31.2 34.1L76.8 286.4C48.6 307.6 32 340.7 32 376l0 72 0 32 32 0 192 0 17.1 0 9.5-14.2 27.6-41.4L361 480l86.7 0-16.1-17.6-84.9-92.9 63.9-95.8 17.8-26.6-53.3-35.5-17.8 26.6-55.1 82.6-67-73.3 39.9-29.9C303.4 196.4 320 163.3 320 128l0-64 0-32-32 0L112 32zM236.8 166.4l-44.9 33.7-35.4-38.7c-8.1-8.8-12.6-20.4-12.6-32.4l0-33 112 0 0 32c0 15.1-7.1 29.3-19.2 38.4zM115.2 337.6l68.7-51.5 81.9 89.6L238.9 416 96 416l0-40c0-15.1 7.1-29.3 19.2-38.4z"]
};
const faCarrot = {
  prefix: 'fass',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M360 0s-40 40-40 80s7.3 55.3 32 80s40 32 80 32s80-40 80-40s-32-40-80-40c-32 0-40 8-40 8s8-8 8-40c0-48-40-80-40-80zM127.2 219.5L0 512l162.7-70.7-46-46L105.4 384 128 361.4l11.3 11.3 54.9 54.9 98.3-42.7c45.9-19.9 75.5-65.2 75.5-115.2C368 200.2 311.8 144 242.4 144c-37.4 0-72.1 16.6-95.6 44.1l56.6 56.6L214.6 256 192 278.6l-11.3-11.3L129 215.6c-.6 1.3-1.2 2.6-1.8 4z"]
};
const faArrowUpFromLine = {
  prefix: 'fass',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M214.6 57.4L192 34.7 169.4 57.4l-128 128L18.7 208 64 253.3l22.6-22.6L160 157.3 160 320l0 32 64 0 0-32 0-162.7 73.4 73.4L320 253.3 365.3 208l-22.6-22.6-128-128zM32 416L0 416l0 64 32 0 320 0 32 0 0-64-32 0L32 416z"]
};
const faArrowFromBottom = faArrowUpFromLine;
const faMoon = {
  prefix: 'fass',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M287.6 41.2c-82.8 21.2-144 96.5-144 186c0 106 85.8 192 191.5 192c16.8 0 33.1-2.2 48.6-6.2c-40.6 41.4-97.2 67-159.8 67C100.3 480 0 379.7 0 256S100.3 32 224 32c22.1 0 43.5 3.2 63.6 9.2z"]
};
const faPenSlash = {
  prefix: 'fass',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M409.1 294.9l75.6-75.6-128-128L265 183 48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L409.1 294.9zm-69.1 69.1L196.9 251.1 96 352 64 512l160-32L340.1 363.9zM507.3 196.7L576 128 448 0 379.3 68.7l128 128z"]
};
const faWineGlassEmpty = {
  prefix: 'fass',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M78.2 198.5C73.9 246.5 111.7 288 160 288s86.1-41.5 81.8-89.5L229.6 64 90.4 64 78.2 198.5zm-63.7-5.8L32 0 288 0l17.5 192.7C312.3 267.3 262 332.9 192 348.5l0 99.5 80 0 0 64-112 0L48 512l0-64 80 0 0-99.5C58 332.9 7.7 267.3 14.5 192.7z"]
};
const faWineGlassAlt = faWineGlassEmpty;
const faSquareStar = {
  prefix: 'fass',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M448 32L0 32 0 480l448 0 0-448zM271 191.3l105.1 15.3-76.1 74.2 18 104.7L224 336l-94 49.4 18-104.7L71.8 206.6 177 191.3 224 96l47 95.3z"]
};
const faCheese = {
  prefix: 'fass',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M0 256L288 32c123.7 0 224 100.3 224 224L0 256zm512 32l0 192L0 480 0 288l512 0z"]
};
const faSendBackward = {
  prefix: 'fass',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M352 0L0 0 0 352l128 0 0-192 0-32 32 0 192 0L352 0zM224 224l224 0 0 224-224 0 0-224zm-64-64l0 64 0 224 0 64 64 0 224 0 64 0 0-64 0-224 0-64-64 0-224 0-64 0z"]
};
const faYinYang = {
  prefix: 'fass',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 160l40 40 40-40-40-40-40 40zm0 192l40-40 40 40-40 40-40-40z"]
};
const faMusic = {
  prefix: 'fass',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M512 5l0 43 0 72 0 248c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L448 163 192 239.8 192 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L128 216l0-72 0-23.8 22.8-6.8 320-96L512 5z"]
};
const faCompassSlash = {
  prefix: 'fass',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M320 512C178.6 512 64 397.4 64 256c0-33.6 6.5-65.8 18.3-95.2L228.1 275.7 192 384l121.9-40.6L468.1 464.8C426.3 494.5 375.2 512 320 512zM536 393.4l84.9 65.9 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7 85 66C180.1 31.1 246.4 0 320 0C461.4 0 576 114.6 576 256c0 50.6-14.7 97.7-40 137.4zM270.4 187.2l125.4 97.3L448 128 270.4 187.2z"]
};
const faClockOne = {
  prefix: 'fass',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 56.7 20-30 13.3-20 39.9 26.6-13.3 20-64 96L232 256l0-136 0-24 48 0 0 24z"]
};
const faFileMusic = {
  prefix: 'fass',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm32 224l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L160 416c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1 0 23.1z"]
};
const faCodeCommit = {
  prefix: 'fass',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M256 192l0 128 128 0 0-128-128 0zm-80-80l80 0 128 0 80 0 0 80 0 32 144 0 32 0 0 64-32 0-144 0 0 32 0 80-80 0-128 0-80 0 0-80 0-32L32 288 0 288l0-64 32 0 144 0 0-32 0-80z"]
};
const faTemperatureLow = {
  prefix: 'fass',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM96 300.2L81.8 317.8C70.6 331.5 64 348.9 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-19.1-6.6-36.5-17.8-50.3L192 300.2l0-22.7L192 64 96 64l0 213.5 0 22.7zM192 0l64 0 0 64 0 213.5c20 24.7 32 56.2 32 90.5c0 79.5-64.5 144-144 144S0 447.6 0 368c0-34.3 12-65.8 32-90.5L32 64 32 0 96 0l96 0zm0 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3c0 0 0 0 0 0z"]
};
const faPersonBiking = {
  prefix: 'fass',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64L336 88 223.2 175.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 448l64 0 0-177.1-57-38 60.3-48.5L404.8 224 512 224l0-64-84.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
};
const faBiking = faPersonBiking;
const faDisplayChartUpCircleCurrency = {
  prefix: 'fass',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M0 0L576 0l0 211.2c-19.5-10-41.1-16.4-64-18.5L512 64 64 64l0 288 256.7 0c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144L160 512l-32 0 0-64 32 0 69.3 0L240 416 0 416 0 0zM480 120l0 72.7c-16.8 1.5-32.9 5.4-48 11.3l0-4 0-22.1L321 289l-17 17-17-17-63-63-87 87L103 279 207 175l17-17 17 17 63 63L398.1 144 376 144l-24 0 0-48 24 0 80 0 24 0 0 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l25.3 25.3 22.6-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6L460.7 426c21.6 13.2 49.1 13.2 70.7 0z"]
};
const faSkeleton = {
  prefix: 'fass',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M288 0l0 32 0 32 128 0 32 0 0 64-32 0-128 0 0 32 192 0 32 0 0 64-32 0-192 0 0 32 96 0 32 0 0 64-32 0-96 0 0 64 0 2.3L368 352l80 0 0 96-64 64-256 0L64 448l0-96 80 0 80 34.3 0-2.3 0-64-96 0-32 0 0-64 32 0 96 0 0-32L32 224 0 224l0-64 32 0 192 0 0-32L96 128l-32 0 0-64 32 0 128 0 0-32 0-32 64 0zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCircleG = {
  prefix: 'fass',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z"]
};
const faCircleArrowUpLeft = {
  prefix: 'fass',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 144l152 0 24 0 0 48-24 0-94.1 0L361 327l17 17L344 377.9l-17-17-135-135L192 328l0 24-48 0 0-24 0-160 0-24 24 0z"]
};
const faCoinBlank = {
  prefix: 'fass',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208zm0 82.1L0 320c0 27.9 17.8 53.6 48 74.6L48 331c-18.3-11.5-34.8-25.2-48-40.9zM80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29L80 413zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29l0 64.3zm128-47c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7z"]
};
const faBroom = {
  prefix: 'fass',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M416 288l-40-40L576 48 528 0 328 200l-40-40-32 0 0 51.7L364.3 320l51.7 0 0-32zm-74.9 65.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3C79.4 304.6 64 341.8 64 380.5l0 3.5 96-48L0 480l0 32 195.5 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"]
};
const faVacuum = {
  prefix: 'fass',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M249.9 64L512 64c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8C513.8 148.1 467.2 128 416 128l-64 0 0 164c10.2-2.6 21-4 32-4c70.7 0 128 57.3 128 128c0 38.2-16.8 72.5-43.3 96L608 512l0-192c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0L224 0 198.1 0l-5.4 25.3L150.1 224l65.5 0L249.9 64zM208.7 256l-65.5 0L109 416l-61 0L0 464l0 48 127.4 0c.4 0 .9 0 1.3 0l95.3 0 0-96-49.6 0 34.3-160zM480 416a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faShieldHeart = {
  prefix: 'fass',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7L256 358.6l11.3-11.3 82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
const faCardHeart = {
  prefix: 'fass',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M384 0L0 0 0 512l384 0L384 0zM80 219.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 352.1l-11.1-10.7L98.2 261.8C86.6 250.7 80 235.3 80 219.2z"]
};
const faLightbulbCflOn = {
  prefix: 'fass',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M294.8 69L320 64l0-25.7L320 0 282.5 7.5 160 32l0 64L294.8 69zM160 224l0 64 320-64 0-64L160 224zm0-96l0 64 320-64 0-64L160 128zm64 256l0 96 64 0 0 32 64 0 0-32 64 0 0-96-32 0 0-44.8L480 320l0-64L336 284.8l0 35.2 0 28.8 0 35.2-32 0 0-92.2-48 9.6 0 82.6-32 0zM63.3 16L43.3 2.7 16.7 42.7 36.7 56l6 4 24 16 20 13.3 26.6-39.9L93.3 36l-24-16-6-4zM603.3 56l20-13.3L596.7 2.7 576.7 16l-6 4-24 16-20 13.3 26.6 39.9 20-13.3 24-16 6-4zM24 160L0 160l0 48 24 0 48 0 24 0 0-48-24 0-48 0zm544 0l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zM93.3 332l20-13.3L86.7 278.7 66.7 292l-24 16-6 4-20 13.3 26.6 39.9 20-13.3 6-4 24-16zm480-39.9l-20-13.3-26.6 39.9 20 13.3 24 16 6 4 20 13.3 26.6-39.9-20-13.3-6-4-24-16z"]
};
const faMelon = {
  prefix: 'fass',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M256 512c141.4 0 256-114.6 256-256c0-50.8-14.8-98.1-40.3-137.9c.4 65-16.1 164.5-102.6 251s-186 103-251 102.6C157.9 497.2 205.2 512 256 512zM47.6 404.8c3.2-70.3 20.6-187.3 95.2-261.9C224.8 61 332 44.8 399.4 43.9C358.5 16.2 309.1 0 256 0C114.6 0 0 114.6 0 256c0 55.5 17.7 106.8 47.6 148.8zm34.2 32.7c17.2 2.1 41.6 3.5 70.1 .8c56.9-5.3 129.5-26.8 194.5-91.8s86.4-137.7 91.8-194.5c2.7-28.5 1.3-53-.8-70.1c-.2-1.7-.4-3.3-.6-4.8c-2.1-.2-4.4-.3-6.8-.5c-18.6-1.1-44.7-1.3-74.5 2.2c-59.9 7.1-132.4 29-190.1 86.7c-49 49-71.3 121.1-80.6 184.7c-4.6 31.3-5.8 59.4-5.9 79.6c0 2.6 0 5 0 7.3c.9 .1 1.9 .2 2.9 .4z"]
};
const faGopuram = {
  prefix: 'fass',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M144 0l0 24 0 8 40 0 0-8 0-24 48 0 0 24 0 8 48 0 0-8 0-24 48 0 0 24 0 8 40 0 0-8 0-24 48 0 0 24 0 8 0 32 0 24 0 40 32 0 0 96 32 0 0 128 32 0 0 160-96 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160L0 512 0 352l32 0 0-128 32 0 0-96 32 0 0-40 0-24 0-32 0-8L96 0l48 0zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faEarthOceania = {
  prefix: 'fass',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 379.3l-32 32L368 422.6 345.4 400l11.3-11.3 32-32L400 345.4 422.6 368l-11.3 11.3zM288 416l0 32-64 0 0-32 64 0zM448 256l0 64-32 0 0-64 32 0zM192 160l0-32 96 0 0 64-64 0-32-32zM96 352l0-64 64-64 32 0 0 32 32 0 0-32 32 0 64 64 0 96-96 0-32-32-96 0z"]
};
const faGlobeOceania = faEarthOceania;
const faContainerStorage = {
  prefix: 'fass',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M608 416l0-320 32 0 0-64-32 0L32 32 0 32 0 96l32 0 0 320L0 416l0 64 32 0 576 0 32 0 0-64-32 0zM176 152l0 208 0 24-48 0 0-24 0-208 0-24 48 0 0 24zm112 0l0 208 0 24-48 0 0-24 0-208 0-24 48 0 0 24zm112 0l0 208 0 24-48 0 0-24 0-208 0-24 48 0 0 24zm112 0l0 208 0 24-48 0 0-24 0-208 0-24 48 0 0 24z"]
};
const faFacePouting = {
  prefix: 'fass',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32zM152 414.6c29.1-19.3 64.9-30.6 103.6-30.6s74.5 11.4 103.6 30.6c-4.7-53-49.3-94.6-103.6-94.6s-98.8 41.6-103.6 94.6z"]
};
const faSquareXmark = {
  prefix: 'fass',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M448 32L0 32 0 480l448 0 0-448zM321.9 192l-17 17-47 47 47 47 17 17L288 353.9l-17-17-47-47-47 47-17 17L126.1 320l17-17 47-47-47-47-17-17L160 158.1l17 17 47 47 47-47 17-17L321.9 192z"]
};
const faTimesSquare = faSquareXmark;
const faXmarkSquare = faSquareXmark;
const faFaceExplode = {
  prefix: 'fass',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M204.8 242.9L213 248l34.5 21.6 8.5 5.3 8.5-5.3L299 248s0 0 0 0l8.2-5.1 8.2 5.1s0 0 0 0l34.5 21.6 8.5 5.3 8.5-5.3 42.7-26.7 42.7 26.7 6.8 4.2 7.5-2.9L512 253.5c0 .8 0 1.7 0 2.5c0 141.4-114.6 256-256 256S0 397.4 0 256c0-.8 0-1.7 0-2.5l45.4 17.5 7.5 2.9 6.8-4.2 42.7-26.7 42.7 26.7 8.5 5.3 8.5-5.3L196.6 248l8.2-5.1zM192 160l-32 0-40 0c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0-32 0 0 53.1-4.3-2.7-8.5-5.3-8.5 5.3L256 237.1l-42.7-26.7-8.5-5.3-8.5 5.3-4.3 2.7 0-53.1zm16.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 448l128 0c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
const faExplodingHead = faFaceExplode;
const faHashtag = {
  prefix: 'fass',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M308.9 32l64.9 0-16 96 74.2 0 12.9 0-10.7 64-2.2 0-84.9 0L325.8 320l74.2 0 12.9 0-10.7 64-2.2 0-84.9 0-16 96-64.9 0 16-96-95.1 0-16 96-64.9 0 16-96L16 384 3.1 384l10.7-64 2.2 0 84.9 0 21.3-128L48 192l-12.9 0 10.7-64 2.2 0 84.9 0 16-96 64.9 0-16 96 95.1 0 16-96zM165.8 320l95.1 0 21.3-128-95.1 0L165.8 320z"]
};
const faUpRightAndDownLeftFromCenter = {
  prefix: 'fass',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M512 160l-32 32-52-52L328 240l-56-56L372 84 320 32 352 0 512 0l0 160zM0 352l32-32 52 52L184 272l56 56L140 428l52 52-32 32L0 512 0 352z"]
};
const faExpandAlt = faUpRightAndDownLeftFromCenter;
const faOilCan = {
  prefix: 'fass',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M288 128l64 0 0-64L160 64l0 64 64 0 0 32-80 0-48 0-48 0L0 160l0 48 0 96 96 42.7L96 416l288 0 48 0L640 192l-32-32L448 192l-64-32-96 0 0-32zM96 208l0 86.1L48 272.8 48 208l48 0z"]
};
const faT = {
  prefix: 'fass',
  iconName: 't',
  icon: [384, 512, [116], "54", "M32 32L0 32 0 96l32 0 128 0 0 352 0 32 64 0 0-32 0-352 128 0 32 0 0-64-32 0L224 32l-32 0-32 0L32 32z"]
};
const faTransformerBolt = {
  prefix: 'fass',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24l0 8 24 0 16 0 0 32-16 0-24 0L88 64 64 64 48 64l0-32 16 0 24 0 0-8L88 0l48 0 0 24zm160 0l0 8 24 0 16 0 0 32-16 0-24 0-48 0-24 0-16 0 0-32 16 0 24 0 0-8 0-24 48 0 0 24zM48 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm160 0l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zM0 160l32 0 320 0 32 0 0 64-32 0 0 224 32 0 0 64-32 0L32 512 0 512l0-64 32 0 0-224L0 224l0-64zm240 48L96 352l70.5 5L144 464 288 320l-70.5-5L240 208z"]
};
const faHippo = {
  prefix: 'fass',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M424 30.1l17 17 17.2 17.2c1.9-.1 3.9-.2 5.8-.2l32 0c11.2 0 21.9 2.3 31.6 6.5L543 55l17-17L593.9 72 577 89 564 101.9c7.6 12.2 12 26.7 12 42.1l0 17.6c36.5 7.4 64 39.7 64 78.4c0 26.2-12.6 49.4-32 64l0 48-64 0 0-32-64 0 0 32-64 0 0-33.6c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5l0-16-32 0 0 16c0 44.7 26.2 83.2 64 101.2l0 42.8 64 0 0 96-128 0 0-108c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12l0 108L64 480l0-150.9L45.9 369.7 2.1 350.3 32 282.9 32 264C32 156.3 117.1 68.5 223.8 64.2l.2-.2 8 0 24 0 32 0 109 36.3c3.8-5.9 8.4-11.2 13.6-15.8L407 81l-17-17L424 30.1zM480 232a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faChartColumn = {
  prefix: 'fass',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M64 32l0 32 0 352 416 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0zM192 224l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0zm96-64l0 160 0 32-64 0 0-32 0-160 0-32 64 0 0 32zm96 32l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zm96-96l0 224 0 32-64 0 0-32 0-224 0-32 64 0 0 32z"]
};
const faCassetteVhs = {
  prefix: 'fass',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M0 32l0 96 576 0 0-96L0 32zM0 160L0 480l576 0 0-320L0 160zM467.9 384L416 384l0-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3l0-34.7 51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM160 349.3l0 34.7-51.9 0C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80l51.9 0 0 34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3zM352 224l0 160-128 0 0-160 128 0z"]
};
const faVhs = faCassetteVhs;
const faInfinity = {
  prefix: 'fass',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 96l205.3 0L320 210.7 434.7 96 640 96l0 320-205.3 0L320 301.3 205.3 416 0 416 0 96zM274.7 256l-96-96L64 160l0 192 114.7 0 96-96zm90.5 0l96 96L576 352l0-192-114.7 0-96 96z"]
};
const faVialCircleCheck = {
  prefix: 'fass',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 32l32 0 64 0 64 0 64 0 32 0 0 64-32 0 0 170.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 96 0 96 0 32zM96 96l0 96 64 0 0-96L96 96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L424 313.4l-11.3 11.3L352 385.4l-28.7-28.7L312 345.4 289.4 368l11.3 11.3 40 40L352 430.6l11.3-11.3 72-72L446.6 336z"]
};
const faChimney = {
  prefix: 'fass',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M0 32l448 0 0 128L0 160 0 32zM32 192l96 0 0 128-96 0 0-128zm384 0l0 128-256 0 0-128 256 0zM288 352l0 128L32 480l0-128 256 0zm128 0l0 128-96 0 0-128 96 0z"]
};
const faObjectIntersect = {
  prefix: 'fass',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M288 64l0 96-64 0-64 0 0 64 0 64-96 0L64 64l224 0zM64 352l96 0 0 96 0 64 64 0 224 0 64 0 0-64 0-224 0-64-64 0-96 0 0-96 0-64L288 0 64 0 0 0 0 64 0 288l0 64 64 0zM448 224l0 224-224 0 0-96 64 0 64 0 0-64 0-64 96 0z"]
};
const faPersonArrowDownToLine = {
  prefix: 'fass',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-51.1 32l-17.5 0L114 142.8l-81.7 128 53.9 34.4 33.8-53L120 448l-88 0L0 448l0 64 32 0 88 0 64 0 16 0 64 0 344 0 32 0 0-64-32 0-344 0 0-195.8 33.8 53 53.9-34.4L270 142.8 260.6 128l-17.5 0-102.2 0zM200 448l-16 0 0-96 16 0 0 96zM464 306.7l-25.4-25.4L416 258.7 370.7 304l22.6 22.6 80 80L496 429.3l22.6-22.6 80-80L621.3 304 576 258.7l-22.6 22.6L528 306.7 528 64l0-32-64 0 0 32 0 242.7z"]
};
const faVoicemail = {
  prefix: 'fass',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
};
const faBlockBrick = {
  prefix: 'fass',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M96 32l0 80 256 0 0-80L96 32zM64 112l0-80L0 32l0 80 64 0zM0 144l0 96 208 0 0-96L0 144zM0 368l64 0 0-96L0 272l0 96zm0 32l0 80 208 0 0-80L0 400zm240 0l0 80 208 0 0-80-208 0zm208-32l0-96-64 0 0 96 64 0zm-96 0l0-96L96 272l0 96 256 0zm96-224l-208 0 0 96 208 0 0-96zm0-32l0-80-64 0 0 80 64 0z"]
};
const faWallBrick = faBlockBrick;
const faFan = {
  prefix: 'fass',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M273.2 148.3L288 0C197.1 0 127.6 70.8 128 160c.1 28 7.4 55 20.3 78.8L0 224c0 90.9 70.8 160.4 160 160c28-.1 55-7.4 78.8-20.3L224 512c90.9 0 160.4-70.8 160-160c-.1-28-7.4-55-20.3-78.8L512 288c0-90.9-70.8-160.4-160-160c-28 .1-55 7.4-78.8 20.3zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBagsShopping = {
  prefix: 'fass',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 96l0 64 96 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-48 64l0-64c0-53 43-96 96-96s96 43 96 96l0 64 128 0 0 64-288 0 0 256L0 480 0 160l128 0zm448 96l0 256-384 0 0-256 384 0zM320 336l0-16-32 0 0 16 0 16c0 53 43 96 96 96s96-43 96-96l0-16 0-16-32 0 0 16 0 16c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16z"]
};
const faParagraphLeft = {
  prefix: 'fass',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M320 64l32 0 0-64L320 0 160 0 144 0C82.1 0 32 50.1 32 112s50.1 112 112 112l16 0 0 64 0 32 64 0 0-32 0-224 32 0 0 224 0 32 64 0 0-32 0-224zM128 384l0-64-32 0L0 416l96 96 32 0 0-64 224 0 32 0 0-64-32 0-224 0z"]
};
const faParagraphRtl = faParagraphLeft;
const faPersonWalkingLuggage = {
  prefix: 'fass',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM356.3 126.6l10 2 80 16 15.3 3.1 7 14 35.2 70.5 38.5 19.2-28.6 57.2-48-24-9.5-4.8-4.8-9.5-13.7-27.4-18.4 62.4 52.3 57 5.2 5.7 2 7.5 24 88 8.4 30.9-61.7 16.8-8.4-30.9-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l17-63.6-36.7 16.3-11.5 34.6-10.1 30.4-60.7-20.2 10.1-30.4 16-48 4.5-13.4 12.9-5.7 72-32 9.3-4.1zm-38.6 209c2.1 3 4.5 5.8 7 8.6l40.7 44.4-15.7 39.3-2.4 6.1-4.6 4.6-48 48L272 509.3 226.7 464l22.6-22.6L292.7 398l25-62.4zM142.9 511.9L32 447.9l96-166.3 84.4 48.7 29.8-50.5 27.6 16.3L171.5 462.4l-5.6 9.5-23.1 40z"]
};
const faCaravanSimple = {
  prefix: 'fass',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M416 32L0 32 0 416l96 0c0 53 43 96 96 96s96-43 96-96l288 0 32 0 32 0 0-64-32 0-32 0 0-160c0-88.4-71.6-160-160-160zM64 128l192 0 0 128L64 256l0-128zm384 0l0 128-128 0 0-128 128 0zM144 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faCaravanAlt = faCaravanSimple;
const faTurtle = {
  prefix: 'fass',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M384 288L32 288l0-80c0-97.2 78.8-176 176-176s176 78.8 176 176l0 80zm192 0l-96 0 0 64 0 32-32 0-96 0 0 96-128 0 0-96-32 0 0 96L64 480l0-96-32 0L0 384l0-64 32 0 32 0 128 0 32 0 128 0 64 0 0-96 0-32 0-80 64 0c53 0 96 43 96 96l0 80zm-80-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faPencilMechanical = {
  prefix: 'fass',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M470.6 121.4L512 80 432 0 390.6 41.4l80 80zM265 31l-17-17L231 31 103 159l-17 17L120 209.9l17-17 111-111 35 35L64 336 32 448 0 480l32 32 32-32s0 0 0 0l112-32L430.1 193.9 464 160l-33.9-33.9L385.9 81.9 352 48 318.1 81.9 317 83 265 31zM89.1 422.9l17.3-60.5 43.2 43.2L89.1 422.9z"]
};
const faUpDown = {
  prefix: 'fass',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M0 128L128 0 256 128l0 32-80 0 0 192 80 0 0 32L128 512 0 384l0-32 80 0 0-192L0 160l0-32z"]
};
const faArrowsAltV = faUpDown;
const faCloudMoonRain = {
  prefix: 'fass',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M428 107.1c0 53 43 96 96 96c18.9 0 36.5-5.5 51.4-14.9c-20.8 39-61.1 65.9-108 67.8c-11.1-23.3-30-42.2-53.3-53.2c-2.2-47.4-33.8-87-77-101.2C349.3 43.5 400.8 0 462.4 0c18.9 0 36.9 4.1 53 11.5C466.4 15.8 428 57 428 107.1zM64 416l56 0L56 512 0 512l64-96zm96 0l56 0-64 96-56 0 64-96zm152 0l-64 96-56 0 64-96 56 0zm40 0l56 0-64 96-56 0 64-96zm95.9-32.1l-80 0L96 383.9l-96 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z"]
};
const faBoothCurtain = {
  prefix: 'fass',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M32 0l96 0 0 64L64 64l0 416 0 32L0 512l0-32L0 32 0 0 32 0zM448 480l0-80c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48L160 0l96 0 96 0 96 0 32 0 32 0 0 32 0 448 0 32-64 0 0-32z"]
};
const faCalendar = {
  prefix: 'fass',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320z"]
};
const faBoxHeart = {
  prefix: 'fass',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M208 32l0 128L0 160 64 32l144 0zm32 0l144 0 64 128-208 0 0-128zM0 192l448 0 0 288L0 480 0 192zM224 432l88.6-88.6c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3L224 432z"]
};
const faTrailer = {
  prefix: 'fass',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M544 32L0 32 0 384l65.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L480 384l32 0 32 0 64 0 32 0 0-64-32 0-64 0 0-288zM480 320l-32 0 0-16 0-192 0-16 32 0 0 16 0 192 0 16zM96 96l0 16 0 131.2c-11.4 5.9-22.2 12.9-32 21L64 112l0-16 32 0zm80 128c-5.4 0-10.7 .2-16 .7L160 112l0-16 32 0 0 16 0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112l0-16 32 0 0 16 0 152.2c-9.8-8.1-20.6-15.2-32-21zM384 96l0 16 0 192 0 16-32 0 0-16 0-192 0-16 32 0zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faUserDoctorMessage = {
  prefix: 'fass',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512L384 304l-64 0 0 58c27.6 7.1 48 32.2 48 62l0 40 0 16-16 0-16 0-16 0 0-32 16 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24 16 0 0 32-16 0-16 0-16 0 0-16 0-40c0-29.8 20.4-54.9 48-62l0-58-128 0 0 66.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-66.3-64 0L0 512l448 0zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM384 0l0 224 64 0 0 64 96-64 96 0L640 0 384 0z"]
};
const faUserMdChat = faUserDoctorMessage;
const faBahai = {
  prefix: 'fass',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M316.5 101.2l-3.5-12.6L288 0 263.1 88.6l-3.5 12.6-13.7 48.7-41.9-28.4-11.2-7.6L115.7 61.8l39.1 84.4 5 10.9 21.4 46.2L130.5 208 118 209.2l-94 8.9 85.5 40.1 10.9 5.1L166.6 285l-36 36.1-8.3 8.4L55.8 395.9l91-23.2 12.8-3.3L208.7 357l-4.1 50.6-1 12.4-7.4 92 54.1-74.8 7.9-10.9L288 385.4l29.6 40.9 7.9 10.9L379.7 512l-7.4-92-1-12.4L367.3 357l49.2 12.5 12.8 3.3 91 23.2-66.3-66.4-8.3-8.4-36-36.1 46.2-21.7 10.9-5.1L552 218.1l-94-8.9L445.5 208l-50.7-4.8 21.4-46.2 5-10.9 39.1-84.4-77.1 52.2-11.2 7.6-41.9 28.4-13.7-48.7zm27.7 97.2l-21.4 46.3 49.8 4.7-45.3 21.3 35.6 35.7-48.8-12.4 4.1 51.3L288 303.5l-30.2 41.7 4.1-51.3-48.8 12.4 35.6-35.7-45.3-21.3 49.8-4.7-21.4-46.3L274 226.9l14-49.7 14 49.7 42.2-28.5z"]
};
const faHaykal = faBahai;
const faLighthouse = {
  prefix: 'fass',
  iconName: 'lighthouse',
  icon: [640, 512, [], "e612", "M192 64l32-16L320 0l96 48 32 16 0 48-24 0-8 0 0 7.6 0 40.4 32 0 0 64-20.4 0 40.7 224 11.6 0 32 0 0 64-32 0-128 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-128 0-32 0 0-64 32 0 11.6 0 40.7-224L192 224l0-64 32 0 0-40.4 0-7.6-8 0-24 0 0-48zm160 48l0-24.4-32-16-32 16 0 24.4 0 48 64 0 0-48zM145.5 49.9l22.1 9.5-18.9 44.1-22.1-9.5-112-48L33.5 1.9l112 48zm0 156.1l-112 48L14.5 209.9l112-48 22.1-9.5 18.9 44.1-22.1 9.5zM606.6 1.9l18.9 44.1-112 48-22.1 9.5L472.5 59.4l22.1-9.5 112-48zM472.5 196.6l18.9-44.1 22.1 9.5 112 48-18.9 44.1-112-48-22.1-9.5z"]
};
const faAmpGuitar = {
  prefix: 'fass',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9L0 96 0 512l512 0 0-416-92.5 0c-1.7-2.1-3.8-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0zm96.9 96L159.1 96c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 272L64 448l0-192 384 0 0 192zM144 288l-32 0 0 32 32 0 0-32zm0 96l-32 0 0 32 32 0 0-32zm64-96l-32 0 0 32 32 0 0-32zm-32 96l0 32 32 0 0-32-32 0zm-32-48l0 32 32 0 0-32-32 0zm128-16l0-32-32 0 0 32 32 0zm-32 96l32 0 0-32-32 0 0 32zm0-80l-32 0 0 32 32 0 0-32zm96-48l-32 0 0 32 32 0 0-32zm-32 96l0 32 32 0 0-32-32 0zm-32-48l0 32 32 0 0-32-32 0zm128-48l-32 0 0 32 32 0 0-32zm-32 96l0 32 32 0 0-32-32 0zm0-48l-32 0 0 32 32 0 0-32z"]
};
const faSdCard = {
  prefix: 'fass',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M384 0L352 0 128 0 114.7 0l-9.4 9.4-96 96L0 114.7 0 128 0 480l0 32 32 0 320 0 32 0 0-32 0-448 0-32zM160 88l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm80 0l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm80 0l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24z"]
};
const faVolumeSlash = {
  prefix: 'fass',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M48.4 14.8L29.4 .1 0 38l19 14.7L591.5 497.2l19 14.7L639.9 474l-19-14.7-95.1-73.8C557 351.3 576 305.9 576 256c0-62.8-30.2-118.6-76.8-153.6l-28.8 38.4c35 26.3 57.6 68.1 57.6 115.2c0 38.8-15.3 74-40.3 99.9l-38.2-29.7C468.3 308.7 480 283.7 480 256c0-31.4-15.1-59.3-38.4-76.8l-28.8 38.4c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l5.9 7.9L352 250.5 352 32l-48 0L195.2 128.7 48.4 14.8zM352 373.3L81.2 160 32 160l0 192 128 0L304 480l48 0 0-106.7z"]
};
const faBorderBottom = {
  prefix: 'fass',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 480L0 480l0-64 448 0 0 64zm0-96l-64 0 0-64 64 0 0 64zM0 384l0-64 64 0 0 64L0 384zm256 0l-64 0 0-64 64 0 0 64zM384 192l0-64 64 0 0 64-64 0zM64 192L0 192l0-64 64 0 0 64zm128 0l0-64 64 0 0 64-64 0zm256 96l-64 0 0-64 64 0 0 64zM0 288l0-64 64 0 0 64L0 288zm256 0l-64 0 0-64 64 0 0 64zM384 96l0-64 64 0 0 64-64 0zM64 96L0 96 0 32l64 0 0 64zm128 0l0-64 64 0 0 64-64 0zM352 288l-64 0 0-64 64 0 0 64zM288 96l0-64 64 0 0 64-64 0zM160 96L96 96l0-64 64 0 0 64zM96 288l0-64 64 0 0 64-64 0z"]
};
const faWifiWeak = {
  prefix: 'fass',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faWifi1 = faWifiWeak;
const faDragon = {
  prefix: 'fass',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M448 160l32 0 32 32 96 0 0-64L512 0 416 0 384 0 288 0l0 32 48 24L288 80l0 32 64 16 0 120 0 26.6 0 5.4 0 13.3 9.4 9.4L448 389.3l0 21.5L30.6 448 0 448l0 31.6 0 .7L0 512l31.6 0 .7 0L432 512l64 0 96 0 48 0 0-48 0-96 0-26.6-22.6-14.1L448 221.4l0-61.4zm64-87.7l0-.6c0 .1 0 .2 0 .3s0 .2 0 .3zm-1.3 7.4C507.5 89.2 498.6 96 488 96c-13.3 0-24-10.7-24-24c0-1.3 .1-2.6 .3-3.9l46.4 11.6zM160 96L0 256l176-16L96 320l224 0 0-128L160 96z"]
};
const faShoePrints = {
  prefix: 'fass',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M320 160l-64 0 0-128L448 0 640 64l0 112L448 224 320 160zM128 32l96 0 0 128-96 0 0-128zm64 320l128-64 192 48 0 112L320 512 128 480l0-128 64 0zM0 480L0 352l96 0 0 128L0 480z"]
};
const faCirclePlus = {
  prefix: 'fass',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 368l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"]
};
const faPlusCircle = faCirclePlus;
const faFaceGrinTongueWink = {
  prefix: 'fass',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448l0-46.9c32.2-23.3 55.7-58 64.5-98.3c-46.2 18.3-101.2 29-160.2 29s-114.1-10.6-160.2-29c8.8 40 32 74.6 64 97.9l0 47.3c0 18.6 5.3 36 14.5 50.8zM400 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM116.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zM320 384l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0zm16-200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faGrinTongueWink = faFaceGrinTongueWink;
const faHandHolding = {
  prefix: 'fass',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M68.8 384L140 327l8.8-7 11.2 0 64 0 64 0 64 0 32 0 0 64-32 0-64 0-32 0 0 32 138.8 0 94.5-65 33-22.7 45.3 65.9-33 22.7-128 88-10.2 7L384 512l-160 0L32 512 0 512 0 384l68.8 0z"]
};
const faPlugCircleExclamation = {
  prefix: 'fass',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M128 0L64 0l0 32 0 96 64 0 0-96 0-32zM320 0L256 0l0 32 0 96 64 0 0-96 0-32zM32 160L0 160l0 64 32 0 0 32c0 77.4 55 142 128 156.8l0 99.2 64 0 0-99.2c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.6 54.1-148.5 128-169.4l0-38.6-32 0L32 160zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z"]
};
const faLinkSlash = {
  prefix: 'fass',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-131-101.7 90.3-90.3c56.2-56.2 56.2-147.4 0-203.6S432.8 7.4 376.6 63.7L365.3 75l45.3 45.3 11.3-11.3c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-96 96-32.9-25.5c23.8-53 14-117.4-29.5-160.9c-52.4-52.4-135.1-56-191.6-10.7L48.4 14.8zM238.2 162.2c30.1-15.4 67.9-10.6 93.1 14.6c20.1 20.1 27.3 48.4 21.5 74.3L238.2 162.2zM116.6 187.9L59.8 244.7c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0L274.7 437l-45.3-45.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l62.2-62.2-50.6-39.9zm104.9 82.6c-2.2 39.5 11.7 79.7 41.9 109.9c38.8 38.8 94.3 50.8 143.4 36.1l-185.3-146z"]
};
const faChainBroken = faLinkSlash;
const faChainSlash = faLinkSlash;
const faUnlink = faLinkSlash;
const faClone = {
  prefix: 'fass',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M288 448L64 448l0-224 64 0 0-64-64 0L0 160l0 64L0 448l0 64 64 0 224 0 64 0 0-64 0-64-64 0 0 64zm224-96L512 0 160 0l0 352 352 0z"]
};
const faPersonWalkingArrowLoopLeft = {
  prefix: 'fass',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-75.7 30.6l-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48L7.5 260.2l60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2zm-38.6 209L68.7 398 25.4 441.4 2.7 464 48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119L464 477.3 509.3 432l-22.6-22.6L461.3 384 608 384l32 0 0-32 0-256 0-32-32 0L352 64l-32 0 0 64 32 0 224 0 0 192-114.7 0 25.4-25.4L509.3 272 464 226.7l-22.6 22.6-80 80L338.7 352l22.6 22.6 80 80z"]
};
const faArrowUpZA = {
  prefix: 'fass',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M320 32l32 0 128 0 32 0 0 32 0 8 0 14.5-10.9 9.6L428 160l52 0 32 0 0 64-32 0-128 0-32 0 0-32 0-8 0-14.5 10.9-9.6L404 96l-52 0-32 0 0-64zm-160 .6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6zM395.5 256l41.1 0 8.6 18.7 88 192 6.1 13.3-70.4 0-14.7-32-76.3 0-14.7 32-70.4 0 6.1-13.3 88-192 8.6-18.7zM416 364.8L399.9 400l32.3 0L416 364.8z"]
};
const faSortAlphaUpAlt = faArrowUpZA;
const faFireFlameCurved = {
  prefix: 'fass',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M168.3 31.8L208 0V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H179.8C80.5 512 0 431.5 0 332.2c0-57.6 28.8-111.4 76.7-143.4L96 176V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-44.7-44.7C139.3 171.3 128 144 128 115.6c0-32.6 14.8-63.4 40.3-83.8z"]
};
const faFireAlt = faFireFlameCurved;
const faTornado = {
  prefix: 'fass',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M0 0L0 45.6C0 62.7 1.7 79.6 5 96l352.8 0c3.2-6.9 7.5-13.3 13-18.8L416 32l0-32L0 0zM352.2 128L13.6 128c12.2 35.9 32.3 68.7 58.8 96L412 224l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3l178.6 0c2.8-11 4.3-22.5 4.3-34.1c0-21.6-5.1-42.8-14.7-61.9l-323.1 0c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69L288 512l108.4-86.7c14.4-11.5 26.1-25.6 34.7-41.3L288 384z"]
};
const faFileCirclePlus = {
  prefix: 'fass',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM384 128l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48z"]
};
const faDeleteRight = {
  prefix: 'fass',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M0 64L0 448l400 0L576 256 400 64 0 64zM177 175l47 47 47-47 17-17L321.9 192l-17 17-47 47 47 47 17 17L288 353.9l-17-17-47-47-47 47-17 17L126.1 320l17-17 47-47-47-47-17-17L160 158.1l17 17z"]
};
const faBookQuran = {
  prefix: 'fass',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96L64 512l-32 0L0 512l0-64 32 0 0-64L0 384 0 0 32 0 64 0 352 0zm0 384L96 384l0 64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zM301.7 90.3C280.1 73.8 253.2 64 224 64C153.3 64 96 121.3 96 192s57.3 128 128 128c29.2 0 56.1-9.8 77.7-26.3c-7 1.5-14.3 2.3-21.7 2.3c-57.4 0-104-46.6-104-104s46.6-104 104-104c7.4 0 14.7 .8 21.7 2.3zm-6.9 81.3L280 136l-14.8 35.6-38.4 3.1L256 199.8l-8.9 37.5L280 217.2l32.9 20.1L304 199.8l29.3-25.1-38.4-3.1z"]
};
const faQuran = faBookQuran;
const faCircleQuarter = {
  prefix: 'fass',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M0 256C0 114.6 114.6 0 256 0l0 256L0 256z"]
};
const faAnchor = {
  prefix: 'fass',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352l64 0 0 128 0 32 32 0 192 0 192 0 32 0 0-32 0-128 64 0-96-96-96 96 64 0 0 96-128 0 0-208 32 0 32 0 0-64-32 0-10.9 0z"]
};
const faBorderAll = {
  prefix: 'fass',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 96l0 128-128 0 0-128 128 0zm0 192l0 128-128 0 0-128 128 0zM192 224L64 224 64 96l128 0 0 128zM64 288l128 0 0 128L64 416l0-128zM64 32L0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L64 32z"]
};
const faFunction = {
  prefix: 'fass',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M64 0L96 0l96 0 32 0 0 64-32 0-64 0 0 128 32 0 32 0 0 64-32 0-32 0 0 192 0 32-32 0L0 480l0-64 64 0 0-160-32 0L0 256l0-64 32 0 32 0L64 32 64 0zM288 320c0 52.7 15.7 101.6 42.7 142.3l-53.4 35.3C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7l53.4 35.3C303.7 218.4 288 267.3 288 320zm288 0c0-52.7-15.7-101.6-42.7-142.3l53.4-35.3C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7l-53.4-35.3c27-40.7 42.7-89.6 42.7-142.3zM398.6 241.4L432 274.7l33.4-33.4L488 218.7 533.3 264l-22.6 22.6L477.3 320l33.4 33.4L533.3 376 488 421.3l-22.6-22.6L432 365.3l-33.4 33.4L376 421.3 330.7 376l22.6-22.6L386.7 320l-33.4-33.4L330.7 264 376 218.7l22.6 22.6z"]
};
const faFaceAngry = {
  prefix: 'fass',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32zM316.1 394.7l10.7 11.9 23.8-21.4-10.7-11.9C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3l-10.7 11.9 23.8 21.4 10.7-11.9c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7z"]
};
const faAngry = faFaceAngry;
const faPeopleSimple = {
  prefix: 'fass',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM232 352l-8-192L32 160 24 352l40 0 0 160 128 0 0-160 40 0zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM512 384L448 160l-128 0L256 384l64 0 0 128 128 0 0-128 64 0z"]
};
const faCookieBite = {
  prefix: 'fass',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M256.8 22.1L213.9 16 81.7 86.7 16 222.1 42 370.4 149.8 475l148.3 21 132.3-70.7L496 289.9l-6.1-34.7c-61.5-6.7-109.9-57.1-113.7-119.5C313.8 132 263.5 83.6 256.8 22.1zM176 368l-32-32 32-32 32 32-32 32zm0-192l32-32 32 32-32 32-32-32zM368 336l-32-32 32-32 32 32-32 32z"]
};
const faArrowTrendDown = {
  prefix: 'fass',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M544 416l32 0 0-32 0-160 0-32-64 0 0 32 0 82.7L342.6 137.4 320 114.7l-22.6 22.6L192 242.7 54.6 105.4 9.4 150.6l160 160L192 333.3l22.6-22.6L320 205.3 466.7 352 384 352l-32 0 0 64 32 0 160 0s0 0 0 0z"]
};
const faRss = {
  prefix: 'fass',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M448 480C448 232.6 247.4 32 0 32L0 96c212.1 0 384 171.9 384 384l64 0zM0 160l0 64c141.4 0 256 114.6 256 256l64 0C320 303.3 176.7 160 0 160zM128 416A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
const faFeed = faRss;
const faFaceMonocle = {
  prefix: 'fass',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M427.2 446.3C381.9 487.2 321.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 62.8-22.6 120.3-60.1 164.9c-2.5-8.6-3.9-17.7-3.9-26.9L448 224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 336l0 32 16 0c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4l28.6-14.3c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336l-16 0zM305.2 89.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7 17.8-26.6L376.3 61c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 83.5l-12.5 10 20 25 12.5-10 23.2-18.6z"]
};
const faDrawPolygon = {
  prefix: 'fass',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M64 32C28.7 32 0 60.7 0 96c0 23.7 12.9 44.4 32 55.4l0 209.1C12.9 371.6 0 392.3 0 416c0 35.3 28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l209.1 0c11.1 19.1 31.7 32 55.4 32c35.3 0 64-28.7 64-64c0-35.3-28.5-63.8-63.7-64l-4.5-7.9-32-56-2.3-4c4.2-8.5 6.5-18 6.5-28.1s-2.3-19.6-6.5-28.1l2.3-4 32-56 4.5-7.9c35.2-.2 63.7-28.7 63.7-64c0-35.3-28.7-64-64-64c-23.7 0-44.4 12.9-55.4 32L119.4 64C108.4 44.9 87.7 32 64 32zM292.2 192.1c-1.4-.1-2.8-.1-4.2-.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c1.4 0 2.8 0 4.2-.1c0 0 0 0 0 0l32 56 4.5 7.9-.1 .3-209.1 0c-5.6-9.7-13.7-17.8-23.4-23.4l0-209.1c9.7-5.6 17.8-13.7 23.4-23.4l209.1 0 .1 .3-4.5 7.9-32 56s0 0 0 0z"]
};
const faScaleBalanced = {
  prefix: 'fass',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 32l128 0 32 0 0 64-32 0L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3L352 448l160 0 32 0 0 64-32 0-192 0-192 0-32 0 0-64 32 0 160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96 96 96l0-64 32 0 128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM112 128l32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0L64 416l-9.9 0-7-7L7 369l-7-7L0 352l0-32 0-5.9 2.7-5.2 88-168L97.5 128l14.5 0zM51.1 320l153.8 0L129.5 176l-3 0L51.1 320zM481.5 128l14.5 0 32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0-128 0-9.9 0-7-7-40-40-7-7 0-9.9 0-32 0-5.9 2.7-5.2 88-168 6.7-12.9zm29 48L435.1 320l153.8 0L513.5 176l-3 0z"]
};
const faBalanceScale = faScaleBalanced;
const faCalendarLines = {
  prefix: 'fass',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M96 0l0 64L0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0zM448 192L0 192 0 512l448 0 0-320zM96 272l256 0 0 48L96 320l0-48zm160 96l0 48L96 416l0-48 160 0z"]
};
const faCalendarNote = faCalendarLines;
const faArrowDownBigSmall = {
  prefix: 'fass',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M320 32l224 0 0 224-224 0 0-224zm0 288l160 0 0 160-160 0 0-160zM183.7 469.5l-23.7 26-23.7-26-80-88L34.8 357.8l47.4-43.1 21.5 23.7L128 365.2 128 80l0-32 64 0 0 32 0 285.2 24.3-26.8 21.5-23.7 47.4 43.1-21.5 23.7-80 88z"]
};
const faSortSizeDown = faArrowDownBigSmall;
const faGaugeSimpleHigh = {
  prefix: 'fass',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4 11.1-21.3-42.6-22.1-11.1 21.3L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"]
};
const faTachometer = faGaugeSimpleHigh;
const faTachometerFast = faGaugeSimpleHigh;
const faDoNotEnter = {
  prefix: 'fass',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM432 208l0 96L80 304l0-96 352 0z"]
};
const faShower = {
  prefix: 'fass',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M32 32L0 32 0 64 0 448l0 32 64 0 0-32L64 96l50.7 0 26.7 26.7c-21 38.9-17.4 87.5 10.9 123L151 247l-17 17L168 297.9l17-17L345 121l17-17L328 70.1 311 87l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L150.6 41.4 141.3 32 128 32 32 32zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faDiceD8 = {
  prefix: 'fass',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M240 0l0 336L0 248 240 0zm0 368l0 144L32 291.7 240 368zm240-76.3L272 512l0-144 208-76.3zM272 0L512 248 272 336 272 0z"]
};
const faDesktop = {
  prefix: 'fass',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M576 0L0 0 0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0L336 416l240 0L576 0zM512 64l0 224L64 288 64 64l448 0z"]
};
const faDesktopAlt = faDesktop;
const faM = {
  prefix: 'fass',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M0 32L0 64 0 448l0 32 64 0 0-32 0-278.3L197.4 369.8 224 409.7l26.6-39.9L384 169.7 384 448l0 32 64 0 0-32 0-384 0-32-49.1 0-9.5 14.2L224 294.3 58.6 46.2 49.1 32 0 32z"]
};
const faSpinnerScale = {
  prefix: 'fass',
  iconName: 'spinner-scale',
  icon: [512, 512, [], "e62a", "M308 12l0 52c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-52 104 0zM256 416c17.7 0 32 14.3 32 32l0 32-64 0 0-32c0-17.7 14.3-32 32-32zM480 288l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0 64zM96 256c0 17.7-14.3 32-32 32l-32 0 0-64 32 0c17.7 0 32 14.3 32 32zM391.8 41L471 120.2l-39.6 39.6c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2L391.8 41zM142.9 369.1c12.5 12.5 12.5 32.8 0 45.3L120.2 437 75 391.8l22.6-22.6c12.5-12.5 32.8-12.5 45.3 0zM391.8 437l-22.6-22.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L437 391.8 391.8 437zM154.2 154.2c-18.7 18.7-49.1 18.7-67.9 0L52.4 120.2l67.9-67.9 33.9 33.9c18.7 18.7 18.7 49.1 0 67.9z"]
};
const faGripDotsVertical = {
  prefix: 'fass',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faFaceViewfinder = {
  prefix: 'fass',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M24 0L136 0l24 0 0 48-24 0L48 48l0 88 0 24L0 160l0-24L0 24 0 0 24 0zM376 0L488 0l24 0 0 24 0 112 0 24-48 0 0-24 0-88-88 0-24 0 0-48 24 0zM48 376l0 88 88 0 24 0 0 48-24 0L24 512 0 512l0-24L0 376l0-24 48 0 0 24zm464 0l0 112 0 24-24 0-112 0-24 0 0-48 24 0 88 0 0-88 0-24 48 0 0 24zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zm128-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192.5 292.9l-23.1 22.2C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9l-23.1-22.2C303.5 309.6 281 320 256 320s-47.5-10.4-63.5-27.1z"]
};
const faSoftServe = {
  prefix: 'fass',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M320 128c0 11.8-3.2 22.9-8.8 32.4c32 3.6 56.8 30.7 56.8 63.6l0 64L16 288l0-64c0-32.9 24.8-60 56.8-63.6C67.2 150.9 64 139.8 64 128c0-35.3 28.7-64 64-64l46.1 0C192.8 64 208 48.8 208 30.1c0-9-3.6-17.6-9.9-24L192 0c70.7 0 128 57.3 128 128zM48 384l0-64 288 0 0 64-33.8 0L288 512 96 512 81.8 384 48 384z"]
};
const faCreemee = faSoftServe;
const faH5 = {
  prefix: 'fass',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M64 96l0-32L0 64 0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96zM432 64l-28.8 0-3 28.7-16 152L380.5 280l35.5 0 108 0c28.7 0 52 23.3 52 52s-23.3 52-52 52l-64.3 0c-11 0-20.6-7.5-23.3-18.2L431 344.2 369 359.8l5.4 21.6c9.8 39.2 45 66.7 85.4 66.7l64.3 0c64.1 0 116-51.9 116-116s-51.9-116-116-116l-72.5 0 9.3-88L576 128l32 0 0-64-32 0L432 64z"]
};
const faHandBackPointDown = {
  prefix: 'fass',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M176 512l-80 0 0-224 0-13.3 0-2.7 0-80 0-16-32 0 0 16 0 56L16 208l0-68c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0L288 0c70.7 0 128 57.3 128 128l0 16 0 48 0 80-80 0 0 32-80 0 0 32-80 0 0 176z"]
};
const faTableList = {
  prefix: 'fass',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M0 32l512 0 0 448L0 480 0 32zM64 96l0 64 64 0 0-64L64 96zm384 0L192 96l0 64 256 0 0-64zM64 224l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64zM64 352l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64z"]
};
const faThList = faTableList;
const faBasketShoppingMinus = {
  prefix: 'fass',
  iconName: 'basket-shopping-minus',
  icon: [576, 512, [], "e652", "M245.3 51.1l11.1-21.3L213.8 7.6 202.7 28.9 117.6 192 0 192l0 64 32 0L96 512l384 0 64-256 32 0 0-64-117.6 0L373.3 28.9 362.2 7.6 319.6 29.8l11.1 21.3L404.2 192l-232.5 0L245.3 51.1zM208 328l160 0 24 0 0 48-24 0-160 0-24 0 0-48 24 0z"]
};
const faCommentSms = {
  prefix: 'fass',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM152 176l-19.2 0C112.5 176 96 192.5 96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-8 0s0 0 0 0l-8 0zm40 16l0 96 0 16 32 0 0-16 0-48 19.2 25.6L256 282.7l12.8-17.1L288 240l0 48 0 16 32 0 0-16 0-96 0-16-24 0-4.8 6.4L256 229.3l-35.2-46.9L216 176l-24 0 0 16zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-16 0-8 0s0 0 0 0l-11.3 0c-20.3 .1-36.7 16.6-36.7 36.8z"]
};
const faSms = faCommentSms;
const faRectangle = {
  prefix: 'fass',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M0 64H512V448H0V64z"]
};
const faRectangleLandscape = faRectangle;
const faClipboardListCheck = {
  prefix: 'fass',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M101.5 64C114.6 26.7 150.2 0 192 0s77.4 26.7 90.5 64L384 64l0 448L0 512 0 64l101.5 0zM224 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM198.6 208L176 185.4l-11.3 11.3L112 249.4 91.3 228.7 80 217.4 57.4 240l11.3 11.3 32 32L112 294.6l11.3-11.3 64-64L198.6 208zm9.4 48l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm-48 96l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zM96 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faTurkey = {
  prefix: 'fass',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M584 56c0 5.6-.8 11-2.3 16c.8 0 1.6 0 2.3 0c30.9 0 56 25.1 56 56s-25.1 56-56 56c-20.3 0-38-10.8-47.9-26.9l-47.6 33.6c-30 21.2-46.5 55.8-63 90.3c0 0 0 0 0 0c-8.7 18.2-17.3 36.4-28 52.5c-6.2 9.4-13.9 18.1-23.2 25.6c-48.1 38.9-118.6 31.5-157.5-16.6c-1.2-1.5-2.4-3-3.5-4.6c-8.9-12.2-15-25.7-18.3-39.6c-.8-3.4-1.5-6.8-2-10.3l-32.3 0c2.9 26.4 13.2 52.4 31.2 74.6c50 61.8 140.7 71.4 202.5 21.4c11.8-9.6 21.8-20.7 29.8-32.9c11.8-18 21.3-37.8 29.7-55.4l.4-.9c17.3-36.3 30.6-62.5 52.5-77.9l1.7-1.2C548.7 262.9 576 321 576 384l0 128-288 0L0 512 0 384C0 224 176 96 288 96c39.9 0 87.9 16.2 133.1 44.3L486.8 94C477.6 84 472 70.7 472 56c0-30.9 25.1-56 56-56s56 25.1 56 56z"]
};
const faBook = {
  prefix: 'fass',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0 0-64 32 0L448 0 416 0 384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-256l224 0 0 32-224 0 0-32zm224 64l0 32-224 0 0-32 224 0z"]
};
const faUserPlus = {
  prefix: 'fass',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM384 304l64 208L0 512 64 304l320 0zm120 32l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z"]
};
const faIceSkate = {
  prefix: 'fass',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M512 240l0 144L32 384 32 96 256 32l0-32 64 0 0 96-48 0-16 0 0 32 16 0 48 0 0 32-48 0-16 0 0 32 16 0 48 0 192 48zm64 168l0 24 0 56 0 24-24 0-144 0-288 0-96 0L0 512l0-48 24 0 72 0 0-24 0-24 48 0 0 24 0 24 240 0 0-24 0-24 48 0 0 24 0 24 96 0 0-32 0-24 48 0z"]
};
const faCheck = {
  prefix: 'fass',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"]
};
const faBatteryThreeQuarters = {
  prefix: 'fass',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M480 160l0 192L64 352l0-192 416 0zM64 96L0 96l0 64L0 352l0 64 64 0 416 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L64 96zm288 96L96 192l0 128 256 0 0-128z"]
};
const faBattery4 = faBatteryThreeQuarters;
const faTomato = {
  prefix: 'fass',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M235.4 1.4L198.2 31.8l15.1 18.5 .1 .2c.1 .2 .4 .5 .7 .9c.7 .9 1.7 2.3 3 4.2c2.6 3.7 6 9.2 9.5 15.9c1.6 3 3.1 6.2 4.5 9.6C147.8 88.1 87.5 128 87.5 128L144 144l-16 48 128-48s0 0 0 0l128 48-16-48 56.5-16s-59.6-39.5-142.4-46.8c-3.6-12.2-8.3-22.9-12.8-31.7c-4.5-8.8-9.1-16-12.5-21c-1.7-2.5-3.2-4.5-4.3-6c-.5-.7-1-1.3-1.3-1.7l-.4-.5-.1-.2c0 0 0 0-.1-.1c0 0 0 0 0 0s0 0 0 0L232 35.2 250.6 20 235.4 1.4zM78.8 158.8l-10.1-2.9C26.1 191.4 0 241.6 0 304C0 434.9 114.6 512 256 512s256-77.1 256-208c0-62.4-26.1-112.6-68.7-148.1l-10.1 2.8L409 165.7l5.4 16.2 21.2 63.6L372.8 222 256 178.2 139.2 222 76.4 245.5l21.2-63.6 5.4-16.2-24.3-6.9z"]
};
const faSwordLaser = {
  prefix: 'fass',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M480 0L230 226.2 285.8 282 512 32 480 0zM184 225.4L161.4 248 264 350.6 286.6 328l-11.3-11.3-80-80L184 225.4zm-22.6 45.2l-23.7 23.7 80 80 23.7-23.7-80-80zm-35 35l-20.7 20.7 80 80 20.7-20.7-80-80zM80 336L0 416l0 48 32 32 16 16 48 0 80-80L80 336z"]
};
const faHouseCircleCheck = {
  prefix: 'fass',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M520.5 193.7L288.4 0 0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-65.4-32l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z"]
};
const faBuildings = {
  prefix: 'fass',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M512 0L192 0l0 128L0 128 0 512l192 0 320 0 0-384L512 0zM64 288l64 0 0 64-64 0 0-64zm256 32l-64 0 0-64 64 0 0 64zm64 0l0-64 64 0 0 64-64 0zM128 192l0 64-64 0 0-64 64 0zM256 64l64 0 0 64-64 0 0-64zm192 0l0 64-64 0 0-64 64 0zM256 224l0-64 64 0 0 64-64 0zm192 0l-64 0 0-64 64 0 0 64z"]
};
const faAngleLeft = {
  prefix: 'fass',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M18.7 256l22.6 22.6 160 160L224 461.3 269.3 416l-22.6-22.6L109.3 256 246.6 118.6 269.3 96 224 50.7 201.4 73.4l-160 160L18.7 256z"]
};
const faCartFlatbedBoxes = {
  prefix: 'fass',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M32 0L0 0 0 64l32 0 32 0 0 352 0 32 32 0 66.7 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0 32 0 0-64-32 0-480 0 0-352 0-32L96 0 32 0zM384 32L192 32l0 288 192 0 0-288zm160 0L416 32l0 128 128 0 0-128zM416 192l0 128 192 0 0-128-192 0z"]
};
const faDollyFlatbedAlt = faCartFlatbedBoxes;
const faDiagramSuccessor = {
  prefix: 'fass',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M512 288L0 288 0 480l512 0 0-192zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 96 0 0 32-64 0 0 32 96 96 96-96 0-32-64 0 0-64 0-32-32 0L288 32l-64 0-16 0L64 32 0 32 0 96l0 64 0 64 64 0 160 0 64 0 0-64z"]
};
const faTruckArrowRight = {
  prefix: 'fass',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M416 0L0 0 0 416l64 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zM544 240l0 16-128 0 0-96 48 0 2.7 0L544 237.3l0 2.7zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM257 95l80 80 17 17-17 17-80 80-17 17L206.1 272l17-17 39-39L96 216l-24 0 0-48 24 0 166.1 0-39-39-17-17L240 78.1l17 17z"]
};
const faSquareW = {
  prefix: 'fass',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M448 32L0 32 0 480l448 0 0-448zM377.5 152L311.1 382.6l-5 17.4-35.6 0-5.3-16.7L224 254.7 182.9 383.3 177.5 400l-35.6 0-5-17.4L70.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L327.5 152l50 0z"]
};
const faArrowsSplitUpAndLeft = {
  prefix: 'fass',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M342.6 25.4L320 2.7 297.4 25.4l-80 80L194.7 128 240 173.3l22.6-22.6L288 125.3 288 256l-162.7 0 25.4-25.4L173.3 208 128 162.7l-22.6 22.6-80 80L2.7 288l22.6 22.6 80 80L128 413.3 173.3 368l-22.6-22.6L125.3 320 288 320l0 64 0 32 0 64 0 32 32 0 160 0 32 0 0-64-32 0-128 0 0-32 0-32 0-96 0-32 0-130.7 25.4 25.4L400 173.3 445.3 128l-22.6-22.6-80-80z"]
};
const faLamp = {
  prefix: 'fass',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M96 0L0 256l448 0L352 0 96 0zm64 288l0 32s-64 50.5-64 112c0 48 32 80 32 80l192 0s32-32 32-80c0-61.5-64-112-64-112l0-32-128 0z"]
};
const faAirplay = {
  prefix: 'fass',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M512 96L64 96l0 256 105 0-62.5 56.2L97.9 416 64 416 0 416l0-64L0 96 0 32l64 0 448 0 64 0 0 64 0 256 0 64-64 0-33.9 0-8.7-7.8L407 352l105 0 0-256zM288 288L448 432l0 48-320 0 0-48L288 288z"]
};
const faHandFist = {
  prefix: 'fass',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M224 0l0 144-64 0L160 0l64 0zM64 32l64 0 0 112-64 0L64 32zm192 0l64 0 0 160-64 0 0-160zm96 64l64 0 0 128-64 0 0-128zM32 253.7L32 176l192 0 0 48 0 32-96 0-16 0 0 32 16 0 112 0 16 0 0-16 0-48 64 0 0 32 96 0c0 52.3-25.1 98.8-64 128l0 128-224 0 0-110.4c-17.3-7.9-33.2-18.8-46.9-32.5l-2.3-2.3c-30-30-46.9-70.7-46.9-113.1z"]
};
const faFistRaised = faHandFist;
const faShieldQuartered = {
  prefix: 'fass',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M256 5.7l11.5 4.4L475 90.1l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM80 142.2c.3 23.4 3.2 51.7 10.1 81.8L256 224l0-149.7L80 142.2zM256 444.8c72.9-35.3 117.3-92.6 143.5-152.5c10-23 17.3-46.1 22.4-68.3L256 224l0 220.8z"]
};
const faSlashForward = {
  prefix: 'fass',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M319.9 0L248.8 0 .1 512l71.2 0L319.9 0z"]
};
const faLocationPen = {
  prefix: 'fass',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zM240.8 96l47.3 47.3L259 172.4l-47.3-47.3L240.8 96zm-51.7 51.7L236.4 195l-85.2 85.2L96 288.1l7.9-55.3 85.2-85.2z"]
};
const faMapMarkerEdit = faLocationPen;
const faCloudMoon = {
  prefix: 'fass',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M550.4 24.7c-61.2 16.6-106.2 72.5-106.2 139c0 79.5 64.5 144 144 144c16.3 0 32-2.7 46.7-7.7c-32.1 41.6-82.5 68.4-139.1 68.4c-13.3 0-26.3-1.5-38.8-4.3c-10.8-14.2-24.9-25.7-41.2-33.4c-2.5-52.9-41.6-96.2-92.6-105.1c-2.1-10.8-3.2-22-3.2-33.4C320 94.9 398.7 16 495.8 16c19.1 0 37.4 3 54.6 8.7zM447.9 511.9l-80 0L96 511.9l-96 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z"]
};
const faPotFood = {
  prefix: 'fass',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24l0-24L64 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C117.5 129.3 128 141.5 128 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24zm112 0l0-24L176 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C229.5 129.3 240 141.5 240 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24zm208 88c-50.7 0-93.6 33.7-107.4 80l214.7 0c-13.8-46.3-56.6-80-107.4-80zM576 224L64 224l1.9 32L48 256l-32 0 0 64 32 0 24.4 0C87.1 387.5 132.1 443.2 192 472.9l0 39.1 256 0 0-39.1c59.9-29.7 104.9-85.4 119.6-152.9l24.4 0 32 0 0-64-32 0-17.9 0 1.9-32z"]
};
const faBriefcase = {
  prefix: 'fass',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M128 0l24 0L360 0l24 0 0 24 0 72 128 0 0 160-192 0-128 0L0 256 0 96l128 0 0-72 0-24zM0 288l192 0 0 64 128 0 0-64 192 0 0 192L0 480 0 288zM336 48L176 48l0 48 160 0 0-48z"]
};
const faPersonFalling = {
  prefix: 'fass',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320 0l0 32 0 96 0 19.8-17.7 8.8L252 181.8 304.5 256l95.5 0 16 0 9.6 12.8 48 64 19.2 25.6-51.2 38.4-19.2-25.6L384 320l-96 0-1.4 0 84.2 130.1L388.2 477l-53.7 34.8-17.4-26.9L160 242.2 160 352l0 32-64 0 0-32 0-144 0-19.8 17.7-8.8L256 108.2 256 32l0-32 64 0zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faImagePortrait = {
  prefix: 'fass',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M384 0L0 0 0 512l384 0L384 0zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96L80 384l32-96 160 0z"]
};
const faPortrait = faImagePortrait;
const faUserTag = {
  prefix: 'fass',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512l-8.3-27.1L320 365.3l0-61.3L64 304 0 512l448 0zm64 0L640 384 480 224l-96 0-32 32 0 96L512 512zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faRug = {
  prefix: 'fass',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M24 64l32 0 24 0 0 24 0 64 0 48 0 32 0 48 0 32 0 48 0 64 0 24-24 0-32 0L0 448l0-48 24 0 8 0 0-40-8 0L0 360l0-48 24 0 8 0 0-32-8 0L0 280l0-48 24 0 8 0 0-32-8 0L0 200l0-48 24 0 8 0 0-40-8 0L0 112 0 64l24 0zm88 0l416 0 0 384-416 0 0-384zm528 0l0 48-24 0-8 0 0 40 8 0 24 0 0 48-24 0-8 0 0 32 8 0 24 0 0 48-24 0-8 0 0 32 8 0 24 0 0 48-24 0-8 0 0 40 8 0 24 0 0 48-24 0-32 0-24 0 0-24 0-64 0-48 0-32 0-48 0-32 0-48 0-64 0-24 24 0 32 0 24 0z"]
};
const faPrintSlash = {
  prefix: 'fass',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M523.9 384l52.1 0 0-192-299.4 0L192 126.3 192 64l226.7 0L448 93.3l0 66.7 64 0 0-80 0-13.3-9.4-9.4-48-48L445.3 0 432 0 160 0 128 0l0 32 0 44.6L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-97-75.3zM512 499.4L446.8 448 192 448l0-64 0-16 0-16 132.9 0L121.8 192 64 192l0 192 64 0 0 96 0 32 32 0 320 0 32 0 0-12.6zM472 248l48 0 0 48-48 0 0-48z"]
};
const faEarthEurope = {
  prefix: 'fass',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M454 320l-22 0-48-48 0-80 32 0 0-32-64 0 0 48-80 0-16 0 0 32-64 0 0-32 80-80 0-16-48 0 0-32 32-32c114.9 0 208 93.1 208 208c0 22.3-3.5 43.8-10 64zm-13.4 32C408.2 414.1 345.4 457.8 272 463.4l0-31.4-64 0-48-48 0-112 144 0 48 48 32 0 32 32 24.6 0zM256 512c8.8 0 17.6-.4 26.2-1.3L256 512zm26.2-1.3C411.3 497.6 512 388.6 512 256C512 114.6 397.4 0 256 0c0 0 0 0 0 0C114.6 0 0 114.6 0 256C0 383.5 93.2 489.3 215.3 508.8c13.3 2.1 26.9 3.2 40.7 3.2zM187.3 123.3l-32 32L144 166.6 121.4 144l11.3-11.3 32-32L176 89.4 198.6 112l-11.3 11.3z"]
};
const faGlobeEurope = faEarthEurope;
const faCartFlatbedSuitcase = {
  prefix: 'fass',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 0L32 0 96 0l32 0 0 32 0 352 480 0 32 0 0 64-32 0-66.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L96 448l-32 0 0-32L64 64 32 64 0 64 0 0zM432 96l0-48-96 0 0 48 96 0zM288 96l0-72 0-24 24 0L456 0l24 0 0 24 0 72 0 224-192 0 0-224zM512 320l0-224 64 0 0 224-64 0zM192 96l64 0 0 224-64 0 0-224z"]
};
const faLuggageCart = faCartFlatbedSuitcase;
const faHandBackPointRibbon = {
  prefix: 'fass',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M192 0l0 48 0 64 0 16-16 0-64 0-80 0L75.6 80 32 32l80 0 0-32 80 0zM112 224l0-64 80 0 0 16 80 0 0 32 80 0 0 32 80 0 0 80 0 48 0 16c0 70.7-57.3 128-128 128l-118.1 0c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372l0-68 48-40 0 56 0 16 32 0 0-16 0-80 0-2.7 0-13.3z"]
};
const faRectangleXmark = {
  prefix: 'fass',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M512 32L0 32 0 480l512 0 0-448zM353.9 192l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"]
};
const faRectangleTimes = faRectangleXmark;
const faTimesRectangle = faRectangleXmark;
const faWindowClose = faRectangleXmark;
const faTireRugged = {
  prefix: 'fass',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M320 0L192 0l0 41.3c-14.9 4.4-29.1 10.4-42.6 17.6L120.2 29.7 29.7 120.2l29.2 29.2c-7.3 13.4-13.2 27.7-17.6 42.6L0 192 0 320l41.3 0c4.4 14.9 10.4 29.1 17.6 42.6L29.7 391.8l90.5 90.5 29.2-29.2c13.4 7.3 27.7 13.2 42.6 17.6l0 41.3 128 0 0-41.3c14.9-4.4 29.1-10.4 42.6-17.6l29.2 29.2 90.5-90.5-29.2-29.2c7.3-13.4 13.2-27.7 17.6-42.6l41.3 0 0-128-41.3 0c-4.4-14.9-10.4-29.1-17.6-42.6l29.2-29.2L391.8 29.7 362.6 58.9c-13.4-7.3-27.7-13.2-42.6-17.6L320 0zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-61.1 2.9a24 24 0 1 0 -14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0 -45.7 14.8zm-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0 -38.8 28.2zm-51.1-33.5a24 24 0 1 0 -28.2 38.8 24 24 0 1 0 28.2-38.8z"]
};
const faLightbulbDollar = {
  prefix: 'fass',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM112 416l0 96 160 0 0-96-160 0zM212 96l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c0 0 0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z"]
};
const faCowbell = {
  prefix: 'fass',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M128 0l24 0L296 0l24 0 0 24 0 72 64 0 64 320L0 416 64 96l64 0 0-72 0-24zM272 48l-96 0 0 48 96 0 0-48zm16 400c0 35.3-28.7 64-64 64s-64-28.7-64-64l128 0z"]
};
const faBahtSign = {
  prefix: 'fass',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M176 0L112 0l0 64L64 64 0 64l0 64 0 96 0 64 0 96 0 64 64 0 48 0 0 64 64 0 0-64 32 0c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112l0-64zM112 128l0 96-48 0 0-96 48 0zm64 96l0-96c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64l0 96-48 0 0-96 48 0zm64 96l0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0z"]
};
const faCorner = {
  prefix: 'fass',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 160l32 0 384 0 32 0 0 32 0 160 0 32-64 0 0-32 0-128L32 224 0 224l0-64z"]
};
const faChevronsRight = {
  prefix: 'fass',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M278.6 278.6L301.3 256l-22.6-22.6-192-192L64 18.7 18.7 64 41.4 86.6 210.7 256 41.4 425.4 18.7 448 64 493.3l22.6-22.6 192-192zm192 0L493.3 256l-22.6-22.6-192-192L256 18.7 210.7 64l22.6 22.6L402.7 256 233.4 425.4 210.7 448 256 493.3l22.6-22.6 192-192z"]
};
const faChevronDoubleRight = faChevronsRight;
const faBookOpen = {
  prefix: 'fass',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M272 480l0-408c-16-16-64-40-128-40S21.3 53.3 0 64L0 480c21.3-10.7 92.8-32 144-32s128 32 128 32zm32 0s76.8-32 128-32s122.7 21.3 144 32l0-416c-21.3-10.7-80-32-144-32s-112 24-128 40l0 408z"]
};
const faBookJournalWhills = {
  prefix: 'fass',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zm69.1-255.6c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226l-10.5 12-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238l-10.5-12 37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2-11.3-11.2 26.4-26.5c-10-20.7-26.1-38-46.4-49.2c17 27.1 11 62.8-14 82.6c14.1 14.6 19.1 35.9 13.1 55.2c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6 5.6-5.4L260 225.4l18-3.6 0-7.9-18-3.7 8.5-14.3-5.6-5.4-14.1 9.6L244 84.2l-8 0-4.6 114.5-12-8.1-5.8 5.4 8.6 14.3-18 3.7 0 7.9 18 3.8-7.9 14.2 5.8 5.4 9.6-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-6-19.4-1-40.5 13.1-55.2c-25-19.9-31-55.5-14-82.6c-20.1 11.2-36.4 28.5-46.4 49.2l26.4 26.5-11.2 11.2-21.2-21.2z"]
};
const faJournalWhills = faBookJournalWhills;
const faInhaler = {
  prefix: 'fass',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M576 72L416 32l-20.8 78L528.7 243.4 576 72zM536.6 296.6L364.2 124.2 337.3 224 192 224l0 256 294.6 0 50-183.4zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zm0 96A32 32 0 1 0 0 352a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faHandcuffs = {
  prefix: 'fass',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M234.9 14L298 2.9l11.1 63L246 77.1 234.9 14zM96 160l34.7 0L160 130.7 189.3 160l34.7 0 0 45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7L96 160zm64 288a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.8-32.7 44.5-58.8 78.4-73.6l0-45.3 34.7 0L480 130.7 509.3 160l34.7 0 0 45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM201.4 43.7l34.9 53.7-53.7 34.9L147.7 78.6l53.7-34.9zm237.2 0l53.7 34.9-34.9 53.7L403.7 97.4l34.9-53.7zM405.1 14L394 77.1 330.9 66 342 2.9l63 11.1z"]
};
const faSnake = {
  prefix: 'fass',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M512 80L352 16 288 64 176 64C96.5 64 32 128.5 32 208s64.5 144 144 144l144 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-63.9 0-.1 0L96 416 0 464l96 48 79.9 0 .1 0 144 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-144 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l112 0 64 48 160-64 0-64zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faTriangleExclamation = {
  prefix: 'fass',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32L0 480l512 0L256 32zm24 160l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 384l48 0 0 48-48 0 0-48z"]
};
const faExclamationTriangle = faTriangleExclamation;
const faWarning = faTriangleExclamation;
const faNoteMedical = {
  prefix: 'fass',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M0 32l448 0 0 288-128 0-32 0 0 32 0 128L0 480 0 32zM402.7 352l45.3 0-32 32-64 64-32 32 0-45.3 0-50.7 0-32 32 0 50.7 0zM192 128l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z"]
};
const faDatabase = {
  prefix: 'fass',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M448 80l0 32 0 16 0 16L320 224l-192 0L0 144l0-16 0-16L0 80 128 0 320 0 448 80zM0 432l0-90.3L118.8 416l210.4 0L448 341.7l0 90.3L320 512l-192 0L0 432zM448 288l0 16L320 384l-192 0L0 304l0-16L0 181.7 118.8 256l210.4 0L448 181.7 448 288z"]
};
const faDownLeft = {
  prefix: 'fass',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M16 432l0-288 32-32L152 216 304 64l80 80L232 296 336 400l-32 32L16 432z"]
};
const faShare = {
  prefix: 'fass',
  iconName: 'share',
  icon: [512, 512, ["mail-forward"], "f064", "M512 208L320 384l-32 0 0-96-80 0c-61.9 0-112 50.1-112 112c0 48 32 80 32 80s-128-48-128-176c0-97.2 78.8-176 176-176l112 0 0-96 32 0L512 208z"]
};
const faMailForward = faShare;
const faFaceThinking = {
  prefix: 'fass',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13 52.6-19.1-22.1-60.7-10.2-40.6-2.2-8.9-8.8-2.6-136-40-15.3-4.5-9 30.7 15.4 4.5 108.6 31.9-11.2 4.1L144 355l0-3 0-56L32 296l0 56 0 28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3 12.1 10.4 20.8-24.3-12.1-10.4-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4L106.2 106 122 133.8l13.9-7.9 7.1-4zM112 352l0 48.6 151.8-55.2 22.6-8.2 16.4 45.1-22.6 8.2-49.8 18.1-31.8 87.5L192.8 512 176 512l-88 0-24 0 0-24 0-136 0-24 48 0 0 24z"]
};
const faTurnDownRight = {
  prefix: 'fass',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M512 288L352 448l-32 0 0-112L0 336 0 32l96 0 0 208 224 0 0-112 32 0L512 288z"]
};
const faBottleDroplet = {
  prefix: 'fass',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M96 0L72 0l0 48 24 0 8 0 0 92.9C61.4 161.6 32 205.4 32 256l0 256 256 0 0-256c0-50.6-29.4-94.4-72-115.1L216 48l8 0 24 0 0-48L224 0l-8 0s0 0 0 0L104 0s0 0 0 0L96 0zm64 384c-26.5 0-48-21.5-48-48c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48z"]
};
const faMaskFace = {
  prefix: 'fass',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M304 64l-9.7 0-8.1 5.4L198.3 128 144 128l-16 0L24 128 0 128l0 24L0 344l0 18.7 18.2 4.5 180.7 45.2C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l180.7-45.2 18.2-4.5 0-18.7 0-192 0-24-24 0-104 0-16 0-54.3 0L353.8 69.4 345.7 64 336 64l-32 0zM132.3 346.3L48 325.3 48 176l48 0 0 48c0 45.1 13.4 87.2 36.3 122.3zM592 325.3l-84.3 21.1c23-35.2 36.3-77.2 36.3-122.3l0-48 48 0 0 149.3zM422.3 192l9.7 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0 9.7 0 204.6 0zM192 256l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm32 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z"]
};
const faHillRockslide = {
  prefix: 'fass',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M0 512l480 0L0 32 0 512zM160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 0l36 64 72 0 36-64L356 32l-72 0L248 96zM576 372l0-72-64-36-64 36 0 72 64 36 64-36zM416 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faScannerKeyboard = {
  prefix: 'fass',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M192 0l0 64-64 0 0-64 64 0zM352 0l0 64-64 0 0-64 64 0zM224 0l32 0 0 64-32 0 0-64zM416 0l0 288-32 0L384 0l32 0zm32 0l64 0 0 288-64 0L448 0zM0 96l352 0 0 416L0 512 0 96zm64 64l0 64 224 0 0-64L64 160zm0 128l0 64 96 0 0-64-96 0zm96 96l-96 0 0 64 96 0 0-64zm32-96l0 64 96 0 0-64-96 0zm96 96l-96 0 0 64 96 0 0-64z"]
};
const faCircleO = {
  prefix: 'fass',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
const faGridHorizontal = {
  prefix: 'fass',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M128 128L0 128 0 256l128 0 0-128zm0 160L0 288 0 416l128 0 0-128zm32-160l0 128 128 0 0-128-128 0zM288 288l-128 0 0 128 128 0 0-128zm32-160l0 128 128 0 0-128-128 0zM448 288l-128 0 0 128 128 0 0-128z"]
};
const faMessageDollar = {
  prefix: 'fass',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM276 112l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3z"]
};
const faCommentAltDollar = faMessageDollar;
const faRightLeft = {
  prefix: 'fass',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M384 0L512 128 384 256l-32 0 0-96L32 160 0 160 0 96l32 0 320 0 0-96 32 0zM128 256l32 0 0 96 320 0 32 0 0 64-32 0-320 0 0 96-32 0L0 384 128 256z"]
};
const faExchangeAlt = faRightLeft;
const faColumns3 = {
  prefix: 'fass',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M640 32L0 32 0 480l640 0 0-448zM192 96l0 320L64 416 64 96l128 0zm64 0l128 0 0 320-128 0 0-320zm320 0l0 320-128 0 0-320 128 0z"]
};
const faPaperPlane = {
  prefix: 'fass',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M0 288L512 0 448 480 271.8 404.5 208 512l-48-16 0-80 0-32L384 160 133 345 0 288z"]
};
const faRoadCircleExclamation = {
  prefix: 'fass',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M160 32l128 0 0 64 0 32 64 0 0-32 0-64 128 0 46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-59.5 0-112.1 29.6-144 74.8l0-42.8 0-32-64 0 0 32 0 64 0 32 38.6 0c-4.3 15.3-6.6 31.4-6.6 48c0 5.4 .2 10.7 .7 16L288 384l0 32 0 64L32 480 160 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 224l0-32-32 0 0 32 32 0zm0-176l-32 0 0 16 0 80 0 16 32 0 0-16 0-80 0-16z"]
};
const faDungeon = {
  prefix: 'fass',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M355.7 175.7l106.7-71.2C437.7 70.9 405 43.6 367.1 25.3L319.3 144.7c14 8 26.3 18.5 36.3 30.9zm-65.9-43.2L337.5 13.2C311.9 4.7 284.5 0 256 0s-55.9 4.7-81.5 13.2l47.7 119.3c10.8-2.9 22.1-4.5 33.8-4.5s23 1.6 33.8 4.5zM144.9 25.3C107 43.6 74.3 70.9 49.6 104.5l106.7 71.2c10-12.4 22.4-23 36.3-30.9L144.9 25.3zM384 256l128 0c0-45.2-11.7-87.7-32.3-124.6L372.5 202.9c7.4 16.2 11.5 34.2 11.5 53.1zM139.5 202.9L32.3 131.4C11.7 168.3 0 210.8 0 256l128 0c0-18.9 4.1-36.9 11.5-53.1zM0 288l0 96 128 0 0-96L0 288zm512 0l-128 0 0 96 128 0 0-96zM128 416L0 416l0 96 128 0 0-96zm384 0l-128 0 0 96 128 0 0-96zM272 192l0-16-32 0 0 16 0 272 0 16 32 0 0-16 0-272zm-64 32l0-16-32 0 0 16 0 240 0 16 32 0 0-16 0-240zm128 0l0-16-32 0 0 16 0 240 0 16 32 0 0-16 0-240z"]
};
const faHandHoldingBox = {
  prefix: 'fass',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M224 128L224 0 96 0l0 256 384 0L480 0 352 0l0 128L288 96l-64 32zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faInputText = {
  prefix: 'fass',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 128l0 256 512 0 0-256L64 128zM0 64l64 0 512 0 64 0 0 64 0 256 0 64-64 0L64 448 0 448l0-64L0 128 0 64zm312 96l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0-24 0 0-24 0-8 0-64 0-64 0-8 0-24 24 0zm24 72l28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0 0 24zm44 72c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24 44 0zM198.3 167.1l72 180 2 4.9-51.7 0L211 328 141 328l-9.6 24-51.7 0 2-4.9 72-180 2.8-7.1 38.9 0 2.8 7.1zM191.8 280L176 240.6 160.2 280l31.5 0z"]
};
const faWindowFlip = {
  prefix: 'fass',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M0 32l512 0 0 448L0 480 0 32zM384 96l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64zM192 96l0 64 64 0 0-64-64 0z"]
};
const faWindowAlt = faWindowFlip;
const faAlignRight = {
  prefix: 'fass',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M448 32l0 64L160 96l0-64 288 0zm0 256l0 64-288 0 0-64 288 0zM0 160l448 0 0 64L0 224l0-64zM448 416l0 64L0 480l0-64 448 0z"]
};
const faScannerGun = {
  prefix: 'fass',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M576 32L416 32l0 64 160 0 0-64zM261.4 256l90.6 0 0-224L112 32C50.1 32 0 82.1 0 144c0 50.9 33.9 93.8 80.3 107.5L0 392l136 80L261.4 256zM416 192l0 64 160 0 0-64-160 0zM576 416l-160 0 0 64 160 0 0-64zM416 128l0 32 160 0 0-32-160 0zM576 288l-160 0 0 32 160 0 0-32zM416 352l0 32 160 0 0-32-160 0z"]
};
const faScanner = faScannerGun;
const faTire = {
  prefix: 'fass',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-16.1 62l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-40.2-63.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zM168.3 162.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zm33.7 127.7l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"]
};
const faEngine = {
  prefix: 'fass',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M400 112l24 0 0-48-24 0L208 64l-24 0 0 48 24 0 72 0 0 16 0 16-72 0-48 0-64 0 0 88-48 0 0-72 0-24L0 136l0 24L0 352l0 24 48 0 0-24 0-72 48 0 0 104 76.8 0L224 448l288 0 0-240-80-64-104 0 0-16 0-16 72 0zM224 224l0 64-64 0 0-64 64 0zm96 0l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm288-32l-96 0 0 256 96 0 0-256z"]
};
const faMoneyBill1Wave = {
  prefix: 'fass',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M0 60.3L0 451.7c96 48.9 192 24.5 288 0s192-48.9 288 0l0-391.5c-96-48.9-192-24.5-288 0s-192 48.9-288 0zM128 416l-64 0 0-64c35.3 0 64 28.7 64 64zM64 224l0-64 64 0c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64l0 64-64 0zm64-192c-35.3 0-64-28.7-64-64l64 0 0 64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 188l0 40 16 0 0 48-4 0-20 0 0 40 20 0 24 0 24 0 20 0 0-40-20 0-4 0 0-68 0-20-20 0-16 0-20 0z"]
};
const faMoneyBillWaveAlt = faMoneyBill1Wave;
const faLifeRing = {
  prefix: 'fass',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm91 .5c33.7-43.3 53.8-97.8 53.8-157s-20.1-113.6-53.8-157l19-19L432 34.7l-19 19C369.6 20.1 315.2 0 256 0S142.4 20.1 99 53.8l-19-19L34.7 80l19 19C20.1 142.4 0 196.8 0 256s20.1 113.6 53.8 157l-19 19L80 477.3l19-19c43.3 33.7 97.8 53.8 157 53.8s113.6-20.1 157-53.8l19 19L477.3 432l-19-19zm-45.7-45.7l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faHands = {
  prefix: 'fass',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", "M544 128l0 32-.1 72.6c-.1 52.2-23.9 101-63.9 133c-.8-80.9-42.8-155.8-111.5-198.8l-46.6-29.1-34.2-21.4-39-67.5L236.7 28 278.3 4l12 20.8 84 145.5 20.8-12L331.8 48.8 319.8 28 361.4 4l12 20.8 63.2 109.5s0 0 0 0l43.3 75 0-49.3 0-32 64 .1zM259.9 116.2l-28.8 46.1-28.7-49.8-12-20.8 41.6-24 12 20.8 16 27.7zm-43.2 69.1L200 212l-23.4 0L156 176.2l-12-20.8 41.6-24 12 20.8 19.1 33.1zm61.1-37.4l27.1 17 60.2 37.6C416.7 234.7 448 291.2 448 352l0 8c0 83.9-68.1 152-152 152l-176 0-24 0 0-48 24 0 104 0 0-24L88 440l-24 0 0-48 24 0 136 0 0-24L56 368l-24 0 0-48 24 0 168 0 0-24L88 296l-24 0 0-48 24 0 136 0s0 0 0 0l93.2 0L271 219.1l-27.1-17 33.9-54.3z"]
};
const faSignLanguage = faHands;
const faSigning = faHands;
const faCircleCaretRight = {
  prefix: 'fass',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 128L368 256 240 384l-32 0 0-256 32 0z"]
};
const faCaretCircleRight = faCircleCaretRight;
const faTurnLeft = {
  prefix: 'fass',
  iconName: 'turn-left',
  icon: [512, 512, [], "e636", "M0 224L160 64l32 0 0 112 320 0 0 304-96 0 0-208-224 0 0 112-32 0L0 224z"]
};
const faWheat = {
  prefix: 'fass',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M472 0c-48.6 0-88 39.4-88 88l0 40 40 0c48.6 0 88-39.4 88-88l0-40L472 0zM316.8 38.6L294.2 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L25.4 441.4 2.7 464 48 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L396 321.5l-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9z"]
};
const faFileSpreadsheet = {
  prefix: 'fass',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM72 224l240 0 16 0 0 16 0 32 0 80 0 80 0 16-16 0-80 0-80 0-80 0-16 0 0-16 0-80 0-80 0-32 0-16 16 0zM88 336l48 0 0-48-48 0 0 48zm80 0l48 0 0-48-48 0 0 48zm80 0l48 0 0-48-48 0 0 48zm0 32l0 48 48 0 0-48-48 0zm-32 0l-48 0 0 48 48 0 0-48zm-80 0l-48 0 0 48 48 0 0-48z"]
};
const faAudioDescriptionSlash = {
  prefix: 'fass',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7-12.9-10L608 32 70.5 32 48.4 14.8zM336 238.1l0-54.1 0-24 24 0 56 0c53 0 96 43 96 96c0 35-18.7 65.7-46.8 82.4l-44.6-34.6C445 301.5 464 281 464 256c0-26.5-21.5-48-48-48l-32 0 0 67.4-48-37.3zM233.3 279.8l-18-14.2-6 14.2 24.1 0zM126.4 352l49.9-117.1L32 121.2 32 480l455.4 0L320 348.1l1.7 3.9-52.2 0-13.7-32.2-63.5 0L178.5 352l-52.2 0z"]
};
const faBellRing = {
  prefix: 'fass',
  iconName: 'bell-ring',
  icon: [512, 512, [], "e62c", "M288 0L224 0l0 51.2C151 66 96 130.6 96 208l0 88L32 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L288 0zm32 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM112.6 49.4L79.4 14.6C30.5 61.2 0 127.1 0 200l48 0c0-59.3 24.8-112.7 64.6-150.6zM464 200l48 0c0-72.9-30.5-138.8-79.4-185.4L399.4 49.4C439.2 87.3 464 140.7 464 200z"]
};
const faCalendarDay = {
  prefix: 'fass',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zm192 64L64 256l0 128 128 0 0-128z"]
};
const faWaterLadder = {
  prefix: 'fass',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 128c0-53 43-96 96-96s96 43 96 96l0 32-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96 192 0 0-96c0-53 43-96 96-96s96 43 96 96l0 32-64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 230.9c-8.1 5.6-15.2 10-23.3 13.7C411.6 378.7 397 383 384 383l0-95-192 0 0 95c-13 0-27.6-4.3-40.7-10.3c-8.1-3.7-15.2-8.1-23.3-13.7L128 128zM272.4 461.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 470.1 31.9 480 0 480l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z"]
};
const faLadderWater = faWaterLadder;
const faSwimmingPool = faWaterLadder;
const faArrowsUpDown = {
  prefix: 'fass',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M182.6 25.4L160 2.7 137.4 25.4l-96 96L18.7 144 64 189.3l22.6-22.6L128 125.3l0 261.5L86.6 345.4 64 322.7 18.7 368l22.6 22.6 96 96L160 509.3l22.6-22.6 96-96L301.3 368 256 322.7l-22.6 22.6L192 386.7l0-261.5 41.4 41.4L256 189.3 301.3 144l-22.6-22.6-96-96z"]
};
const faArrowsV = faArrowsUpDown;
const faChessPawnPiece = {
  prefix: 'fass',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64l-8 0-24 0 0 48 24 0 5.7 0L64 384l128 0-13.7-96 5.7 0 24 0 0-48-24 0-8 0zM0 512l256 0 0-32-48-64L48 416 0 480l0 32z"]
};
const faChessPawnAlt = faChessPawnPiece;
const faFaceGrimace = {
  prefix: 'fass',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM400 400l-56 0 0-40 56 0 0 40zm0-56l-56 0 0-40 56 0 0 40zm-72 0l-64 0 0-40 64 0 0 40zm0 56l-64 0 0-40 64 0 0 40zm-80-96l0 40-64 0 0-40 64 0zm0 56l0 40-64 0 0-40 64 0zm-80-16l-56 0 0-40 56 0 0 40zm0 56l-56 0 0-40 56 0 0 40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGrimace = faFaceGrimace;
const faWheelchairMove = {
  prefix: 'fass',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM198.2 42.8l16.9 9 120 64 34 18.1L345 164l-48 60 111 0 37.2 0-5.5 36.7-24 160-4.7 31.6-63.3-9.5 4.7-31.6L370.8 288l-64.2 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-44.8-23.9-56.1 37.4-26.6 17.8L83.6 119.1l26.6-17.8 72-48 15.9-10.6zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faWheelchairAlt = faWheelchairMove;
const faTurnDown = {
  prefix: 'fass',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M192 512L352 352l0-32-112 0L240 0 0 0 0 96l144 0 0 224L32 320l0 32L192 512z"]
};
const faLevelDownAlt = faTurnDown;
const faSquareS = {
  prefix: 'fass',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M448 32L0 32 0 480l448 0 0-448zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6s0 0 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7l23.2 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
const faRectangleBarcode = {
  prefix: 'fass',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M576 32L0 32 0 480l576 0 0-448zM144 128l0 256-48 0 0-256 48 0zm32 0l32 0 0 256-32 0 0-256zm112 0l0 256-48 0 0-256 48 0zm64 0l48 0 0 256-48 0 0-256zm128 0l0 256-32 0 0-256 32 0z"]
};
const faBarcodeAlt = faRectangleBarcode;
const faPersonWalkingArrowRight = {
  prefix: 'fass',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM132.3 126.6l10 2 80 16 15.3 3.1 7 14 35.2 70.5 38.5 19.2-28.6 57.2-48-24-9.5-4.8-4.8-9.5-13.7-27.4-18.4 62.4 52.3 57 5.2 5.7 2 7.5 24 88 8.4 30.9-61.7 16.8-8.4-30.9-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l17-63.6L89.9 215.5 78.4 250.1 68.2 280.5 7.5 260.2l10.1-30.4 16-48 4.5-13.4L51 162.8l72-32 9.3-4.1zm-38.6 209c2.1 3 4.5 5.8 7 8.6l40.7 44.4-15.7 39.3-2.4 6.1-4.6 4.6-48 48L48 509.3 2.7 464l22.6-22.6L68.7 398l25-62.4zM534.6 153.4l80 80L637.3 256l-22.6 22.6-80 80L512 381.3 466.7 336l22.6-22.6L514.7 288 384 288l-32 0 0-64 32 0 130.7 0-25.4-25.4L466.7 176 512 130.7l22.6 22.6z"]
};
const faSquareEnvelope = {
  prefix: 'fass',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M448 32L0 32 0 480l448 0 0-448zM64 144l320 0 0 33.4L224 277.1 64 177.4 64 144zM232.5 309.6L384 215.1 384 368 64 368l0-152.9 151.5 94.5 8.5 5.3 8.5-5.3z"]
};
const faEnvelopeSquare = faSquareEnvelope;
const faDice = {
  prefix: 'fass',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M0 224L224 0 448 224 224 448 0 224zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm128-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96 325.3L470.6 246.6 493.3 224l-22.6-22.6-9.4-9.4L640 192l0 320-320 0 0-114.7zM504 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faUnicorn = {
  prefix: 'fass',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M448 160l0 78.1 0 1.9s0 0 0 0c-.5 30-12.8 56.4-32 75.7L416 512l-96 0 0-165.3c-4.1-.7-8.2-1.6-12.3-2.8L224 320l0 16 0 19.9-14.1 14.1-27 27 38.3 115-101.2 0L82.5 399.2 73.1 371l21-21 26.6-26.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256l0 56 0 24L0 336l0-24 0-56c0-44.6 33.2-81.5 76.3-87.2c14.9-24.4 41.8-40.8 72.5-40.8l54.4 0 52.8 0 64 0C320 57.3 377.3 0 448 0l32 0 64 0 16 0 0 32-16 0-16 0 16 16 96 0 0 16L560 90.7 560 192l-80 32-32-64zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faBowlingBall = {
  prefix: 'fass',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPompebled = {
  prefix: 'fass',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M295.2 216.3c48.2-58.4 118.9-77.5 165.1-44.3c59 41.8 68.8 131.8 22.6 200.2c-85.5 126.3-260.4 185.6-381.8 98.6C-20.8 383.8-28.6 196.7 56.9 70.4c46.2-68.9 131.7-91 190.7-49.3c46.7 32.2 54.5 106.6 17.7 173.5L254.7 210l30 21.6 10.6-15.3z"]
};
const faBrain = {
  prefix: 'fass',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M240 0l0 56 0 400 0 56-56 0c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0l56 0zm32 0l56 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1l-56 0 0-56 0-400 0-56z"]
};
const faWatchSmart = {
  prefix: 'fass',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M64 0l0 48 256 0 0-48L64 0zM384 80L0 80 0 432l384 0 0-352zM216 160l0 86.1 41 41 17 17L240 337.9l-17-17-48-48-7-7 0-9.9 0-96 0-24 48 0 0 24zM320 512l0-48L64 464l0 48 256 0z"]
};
const faBookUser = {
  prefix: 'fass',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0 0 64 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM304 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96l-160 0-32 96 224 0-32-96z"]
};
const faSensorCloud = {
  prefix: 'fass',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M448 32L0 32 0 480l224 0 0-48c0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8L448 32zM112 120l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm96 0l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zm48 312l0 80 80 0 16 0 192 0 16 0 80 0 0-80c0-38.7-27.5-71-64-78.4l0-9.6c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80l0 17.6c-36.5 7.4-64 39.7-64 78.4z"]
};
const faSensorSmoke = faSensorCloud;
const faClapperboardPlay = {
  prefix: 'fass',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M454.1 32L327 159l-1 1-92.1 0L361 33l1-1 92.1 0zM393.9 160L512 41.9 512 160l-118.1 0zM201.9 32l92.1 0L167 159l-1 1-92.1 0L201 33l1-1zm-67.9 0L7 159l-1 1L0 160 0 32l134.1 0zM0 192l512 0 0 288L0 480 0 192zM344 336L208 248l0 176 136-88z"]
};
const faBandage = {
  prefix: 'fass',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 416l160 0 0-320L480 96l0 320zM448 96L192 96l0 320 256 0 0-320zM0 96L0 416l160 0 0-320L0 96zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faBandAid = faBandage;
const faCalendarMinus = {
  prefix: 'fass',
  iconName: 'calendar-minus',
  icon: [448, 512, [], "f272", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM312 376l24 0 0-48-24 0-176 0-24 0 0 48 24 0 176 0z"]
};
const faCircleXmark = {
  prefix: 'fass',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"]
};
const faTimesCircle = faCircleXmark;
const faXmarkCircle = faCircleXmark;
const faCircle4 = {
  prefix: 'fass',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320-64l-48 0 0 24 0 56-64.4 0 40-144-49.8 0L152.9 289.6 144.4 320l31.6 0 96 0 0 40 0 24 48 0 0-24 0-40 8 0 24 0 0-48-24 0-8 0 0-56 0-24z"]
};
const faGifts = {
  prefix: 'fass',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M200.6 40l8-22.6-45.2-16-8 22.6L144.7 54.2l-9.9-29.8L127.2 1.6 81.6 16.8l7.6 22.8 8.3 25-27.4-20L50.7 30.5 22.5 69.3 41.9 83.4 59.2 96 0 96 0 512l192 0 0-320 48.3 0c2.6-33.5 21-62.5 47.7-79.6L288 96l-59.2 0 17.3-12.6 19.4-14.1L237.3 30.5 217.9 44.6 192.5 63.1 200.6 40zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24L224 224l0 128 192 0 0-96 32 0 0 96 192 0 0-128-52.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 512l192 0 0-128-192 0 0 128zm224 0l192 0 0-128-192 0 0 128zm96-312c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"]
};
const faAlbumCollection = {
  prefix: 'fass',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M32 0L56 0 456 0l24 0 0 48-24 0L56 48 32 48 32 0zm8 512L0 160l512 0L472 512 40 512zM440 344c0-75.1-82.4-136-184-136S72 268.9 72 344s82.4 136 184 136s184-60.9 184-136zM256 376c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zM40 80l432 0 24 0 0 48-24 0L40 128l-24 0 0-48 24 0z"]
};
const faHotel = {
  prefix: 'fass',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M0 0L512 0l0 64-32 0 0 384 32 0 0 64-208 0 0-96-96 0 0 96L0 512l0-64 32 0L32 64 0 64 0 0zM96 96l0 64 64 0 0-64L96 96zm192 0l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM160 192l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM352 384c0-53-43-96-96-96s-96 43-96 96l192 0z"]
};
const faEarthAsia = {
  prefix: 'fass',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M50.4 288l77.6 0 32 32 64 0 0-96 48 0 0-80 32-32 0-58.4c-15.4-3.6-31.5-5.6-48-5.6C141.1 48 48 141.1 48 256c0 10.9 .8 21.6 2.4 32zM454 320l-38 0 0-32-64 0-64 64 0 64 64 0 15.6 15.6C408 405.8 439 366.5 454 320zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 96l0 32 64 0 0-32-64 0zm160-96l-32 0 0 64 32 0 0-64zm32-128l0 64 32 0 0-64-32 0z"]
};
const faGlobeAsia = faEarthAsia;
const faIdCardClip = {
  prefix: 'fass',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M352 0l0 128-128 0L224 0 352 0zM0 64l192 0 0 96 192 0 0-96 192 0 0 448L0 512 0 64zM176 448l224 0-32-64-160 0-32 64zm112-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faIdCardAlt = faIdCardClip;
const faMagnifyingGlassPlus = {
  prefix: 'fass',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M376 330.7c25.2-34.4 40-76.8 40-122.7C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416c45.9 0 88.3-14.9 122.7-40L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L376 330.7zM232 104l0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24 0-56-56 0-24 0 0-48 24 0 56 0 0-56 0-24 48 0z"]
};
const faSearchPlus = faMagnifyingGlassPlus;
const faThumbsUp = {
  prefix: 'fass',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M240 67.7L240 32l96 0 0 35.7c0 38.1-9 75.1-25.8 108.3L464 176l48 0 0 96-16 0 0 80-24 0 0 72-24 0 0 56-48 0-120 0-14.5 0-12.1-8.1-72-48L160 409.7l0-25.7 0-64 0-96 0-23.1 18-14.4 7.9-6.4c34.2-27.3 54-68.7 54-112.4zM128 192l0 288L0 480 0 192l128 0z"]
};
const faCloudShowers = {
  prefix: 'fass',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0L96 320zm40 32l0 24 0 80 0 24-48 0 0-24 0-80 0-24 48 0zm192 0l0 24 0 80 0 24-48 0 0-24 0-80 0-24 48 0zm-96 56l0 80 0 24-48 0 0-24 0-80 0-24 48 0 0 24zm192-24l0 24 0 80 0 24-48 0 0-24 0-80 0-24 48 0z"]
};
const faUserClock = {
  prefix: 'fass',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zm96 368c0 59.5 29.5 112.1 74.8 144L0 512 64 304l268 0c-7.7 19.8-12 41.4-12 64zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16z"]
};
const faOnion = {
  prefix: 'fass',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M208 0l16 32L240 0l32 0c0 60.4 39.2 92.3 80.7 126C399 163.7 448 203.5 448 288c0 80-57.5 134.7-130.9 160l9.2 23.1 8.9 22.3-44.6 17.8-8.9-22.3-11.6-29.1c-7.3 1.2-14.7 2.2-22.1 2.9l0 25.3 0 24-48 0 0-24 0-25.3c-7.4-.7-14.8-1.6-22.1-2.9l-11.6 29.1-8.9 22.3-44.6-17.8 8.9-22.3 9.2-23.1C57.5 422.7 0 368 0 288c0-84.5 49-124.3 95.3-162C136.8 92.3 176 60.4 176 0l32 0zM106.4 252.3c4.3-15.3 9.3-28.6 13.3-38.2c2-4.8 3.7-8.6 4.9-11.2c.6-1.3 1.1-2.3 1.4-2.9l.3-.7 .1-.2s0 0 0 0L112 192c-14.3-7.2-14.3-7.2-14.3-7.1s0 0 0 0s0 0 0 0c0 0 0 .1 0 .1l-.1 .3-.5 .9c-.4 .8-.9 1.9-1.6 3.4c-1.3 2.9-3.2 7.1-5.4 12.3c-4.3 10.4-9.8 25-14.5 41.8c-9.2 32.7-16.5 76.9-2.6 114l30-11.2c-10.1-27-5.4-62.7 3.4-94zM207.2 378.9c-14.5-43.5-7.5-103.7 4.4-155.3c5.9-25.4 12.7-47.9 18.1-64c2.7-8.1 5-14.5 6.6-18.9c.8-2.2 1.5-3.9 1.9-5l.5-1.3 .1-.3c0 0 0 0 0-.1c0 0 0 0 0 0L224 128c-14.9-5.9-14.9-5.9-14.9-5.9s0 0 0 0s0 0 0 0l0 .1-.2 .4-.6 1.5c-.5 1.3-1.2 3.1-2.1 5.4c-1.7 4.7-4.2 11.5-7 19.9c-5.6 16.8-12.8 40.3-18.9 67c-12.1 52.3-21.1 120.1-3.6 172.7l30.4-10.1zM318.6 231.1c12.6 37.3 21.2 81.4 11.2 116.5l30.8 8.7c12.7-44.9 1.4-96.8-11.7-135.5c-6.7-19.7-14-36.8-19.8-48.9c-2.9-6.1-5.3-11-7.1-14.3c-.9-1.7-1.6-3-2.1-3.9l-.6-1.1-.2-.3 0-.1c0 0 0 0 0 0s0 0 0 0l-14 7.8c-14 7.8-14 7.8-14 7.8s0 0 0 0c0 0 0 0 0 0l.1 .2 .5 .8c.4 .8 1 1.9 1.8 3.5c1.6 3.1 3.9 7.6 6.5 13.2c5.3 11.4 12.2 27.3 18.4 45.6z"]
};
const faClockTwelveThirty = {
  prefix: 'fass',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-360l0 240 0 24-48 0 0-24 0-240 0-24 48 0 0 24z"]
};
const faArrowDownToDottedLine = {
  prefix: 'fass',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M246.6 342.6L224 365.3l-22.6-22.6-128-128L50.7 192 96 146.7l22.6 22.6L192 242.7l0-66.7 0-112 0-32 64 0 0 32 0 112 0 66.7 73.4-73.4L352 146.7 397.3 192l-22.6 22.6-128 128zM64 416l0 64L0 480l0-64 64 0zm96 0l0 64-64 0 0-64 64 0zm32 64l0-64 64 0 0 64-64 0zm160-64l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64z"]
};
const faHandDots = {
  prefix: 'fass',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M288 32l0-32L224 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6L84.5 299.1l-29-27.6L.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208 0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faAllergies = faHandDots;
const faFileInvoice = {
  prefix: 'fass',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zM80 64l64 0 16 0 0 32-16 0L80 96 64 96l0-32 16 0zm0 64l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm0 96l224 0 16 0 0 16 0 96 0 16-16 0L80 352l-16 0 0-16 0-96 0-16 16 0zm16 96l192 0 0-64L96 256l0 64zm144 96l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0z"]
};
const faWindowMinimize = {
  prefix: 'fass',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M512 416L0 416l0 64 512 0 0-64z"]
};
const faRectangleWide = {
  prefix: 'fass',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M0 64H640V448H0V64z"]
};
const faCommentArrowUp = {
  prefix: 'fass',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM280 328l0-118.1 31 31 17 17L361.9 224l-17-17-72-72-17-17-17 17-72 72-17 17L184 257.9l17-17 31-31L232 328l0 24 48 0 0-24z"]
};
const faGarlic = {
  prefix: 'fass',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M46.6 202.7l73.9-59.1c-.6 2-1.2 4-1.8 5.9c-5.4 17.1-12.7 30.1-20.5 43.3c-.8 1.4-1.6 2.8-2.5 4.2c-7.1 11.9-14.8 24.8-20.7 40.5c-6.7 17.8-11 38.8-11 66.5c0 54.8 26.8 96 65.3 120l-5.1 0C55.6 424 0 368.4 0 299.7c0-37.8 17.2-73.5 46.6-97zM387.7 424l-85.1 0c38.6-24 65.3-65.2 65.3-120c0-52.8-20.4-80.5-39.4-106.3c0 0 0 0 0 0s0 0 0 0c-1.2-1.7-2.4-3.3-3.6-4.9c-9.8-13.4-18.8-26.6-25.5-43.8c-6.7-17-11.4-38.7-11.4-69l0-80 64 0 0 112 113.4 90.7c29.5 23.6 46.6 59.3 46.6 97C512 368.4 456.4 424 387.7 424zM160 0l96 0 0 80c0 33.8 5.3 59.5 13.6 80.7c8.3 21.1 19.3 37 29.5 50.9c1.1 1.6 2.3 3.1 3.4 4.6c0 0 0 0 0 .1c0 0 0 0 0 0C321 241.5 336 261.9 336 304c0 69.3-54.9 112-120 112s-120-42.7-120-112c0-24.2 3.7-41.3 9-55.2c4.9-12.8 11.1-23.3 18.3-35.5l2.5-4.2c8.2-13.8 16.9-29.3 23.5-49.9c4.2-13.2 7.4-28.2 9.2-46L160 112l0-32 0-80zM136 448l48 0 0 40 0 24-48 0 0-24 0-40zm64 0l48 0 0 40 0 24-48 0 0-24 0-40zm64 0l48 0 0 40 0 24-48 0 0-24 0-40zm64 0l48 0 0 40 0 24-48 0 0-24 0-40z"]
};
const faMugSaucer = {
  prefix: 'fass',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M96 32l352 0 32 0 32 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 96L96 384 96 32zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128zM32 416l512 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z"]
};
const faCoffee = faMugSaucer;
const faBrush = {
  prefix: 'fass',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M192 64L160 0 128 0 96 64 64 0 0 0 0 256l384 0L384 0 224 0 192 64zM0 288l0 96 128 0 0 128 128 0 0-128 128 0 0-96L0 288zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faTreeDecorated = {
  prefix: 'fass',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M224 0L56 176l0 32 48 0L24 320l0 32 56 0L0 480l0 32 448 0 0-32L368 352l56 0 0-32L344 208l48 0 0-32L224 0zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faMask = {
  prefix: 'fass',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M288 64C64 64 0 160 0 272S80 448 176 448l48 0 32-96 64 0 32 96 48 0c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faCalendarHeart = {
  prefix: 'fass',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M160 0l0 64 128 0 0-64 64 0 0 64 96 0 0 96L0 160 0 64l96 0L96 0l64 0zM0 192l448 0 0 320L0 512 0 192zM112 315.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 448.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z"]
};
const faMagnifyingGlassMinus = {
  prefix: 'fass',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 232l24 0 0-48-24 0-160 0-24 0 0 48 24 0 160 0z"]
};
const faSearchMinus = faMagnifyingGlassMinus;
const faFlower = {
  prefix: 'fass',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-128l-96-96 96-96 96 96-96 96z"]
};
const faArrowDownFromArc = {
  prefix: 'fass',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M256 66.7c-106 0-192 86-192 192l0 32-64 0 0-32C0 117.4 114.6 2.7 256 2.7s256 114.6 256 256l0 32-64 0 0-32c0-106-86-192-192-192zM121.4 377.4L98.7 354.7 144 309.5l22.6 22.6L224 389.5l0-194.7 0-32 64 0 0 32 0 194.7 57.4-57.4L368 309.5l45.3 45.3-22.6 22.6-112 112L256 512l-22.6-22.6-112-112z"]
};
const faRightLeftLarge = {
  prefix: 'fass',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M154.7 512L0 357.3V314.7L154.7 160H256v64H448v64h10.7l112-112L458.7 64H448v64H288V64h96V0H485.3L640 154.7v42.5L485.3 352H384V288H192V224H181.3L69.3 336l112 112H192V384H352v64H256v64H154.7z"]
};
const faRulerVertical = {
  prefix: 'fass',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M0 0L256 0l0 96-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 96L0 512 0 0z"]
};
const faCirclesOverlap = {
  prefix: 'fass',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160z"]
};
const faUserLarge = {
  prefix: 'fass',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zM512 512L432 320 80 320 0 512l512 0z"]
};
const faUserAlt = faUserLarge;
const faStarshipFreighter = {
  prefix: 'fass',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2L576 144l0 80-130.3 0L416 224l0 64 29.7 0L576 288l0 80-96 37.3 0 74.7-128 0-29.2-14.6c-32 9.7-65.3 14.6-98.8 14.6zm0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faTrainTram = {
  prefix: 'fass',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M72 0L63.3 0 56.6 5.6l-48 40L39.4 82.4 80.7 48 200 48l0 48L64 96l0 352 40 0L40 512l80 0 64-64 80 0 64 64 80 0-64-64 40 0 0-352L248 96l0-48 119.3 0 41.3 34.4 30.7-36.9-48-40L384.7 0 376 0 72 0zm56 160l192 0 0 96-192 0 0-96zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faBridgeSuspension = {
  prefix: 'fass',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M120 8L105.2 8 98.5 21.3c-21.1 42.2-56.8 71.4-96 97.9l26.9 39.8C51.7 143.9 75 126.7 96 105.4L96 256l-80 0L0 256l0 16 0 64 0 16 16 0 80 0 0 144 0 16 16 0 64 0 16 0 0-16 0-144 256 0 0 144 0 16 16 0 64 0 16 0 0-16 0-144 80 0 16 0 0-16 0-64 0-16-16 0-80 0 0-150.6c21 21.3 44.3 38.5 66.6 53.6l26.9-39.8c-39.2-26.5-74.9-55.7-96-97.9L534.8 8 520 8 504 8 490.1 8l-6.9 12.1C447.6 82.4 389.4 120 320 120s-127.6-37.6-163.2-99.9L149.9 8 136 8 120 8zm360 94.4L480 256l-40 0 0-122.1c14.4-9 27.7-19.6 40-31.6zM200 256l-40 0 0-153.6c12.3 12 25.6 22.6 40 31.6L200 256zm96 0l-48 0 0-99.5c15.3 5.1 31.3 8.5 48 10.3l0 89.2zm96 0l-48 0 0-89.2c16.7-1.7 32.7-5.2 48-10.2l0 99.5z"]
};
const faTrashCheck = {
  prefix: 'fass',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0 304 0zM32 128l384 0L392 512 56 512 32 128zM337 249l17-17L320 198.1l-17 17-111 111-47-47-17-17L94.1 296l17 17 64 64 17 17 17-17L337 249z"]
};
const faUserNurse = {
  prefix: 'fass',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 128l0-80L224 0 352 48l0 80-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zM126.1 320L224 424l97.9-104 62.1 0 64 192L0 512 64 320l62.1 0zM208 64l-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0 0 24z"]
};
const faBoombox = {
  prefix: 'fass',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M32 0L56 0 584 0l24 0 0 24 0 136 32 0 0 352L0 512 0 160l32 0L32 24 32 0zM80 160l112 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 112 0 0-112L80 48l0 112zM96 336a80 80 0 1 1 160 0A80 80 0 1 1 96 336zm192 0A112 112 0 1 0 64 336a112 112 0 1 0 224 0zm176-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
const faSyringe = {
  prefix: 'fass',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M452.2 18.2L473 39l20.8 20.8 17 17-33.9 33.9-17-17L456 89.9 417.9 128l55 55 17 17L456 233.9l-17-17-72-72L295 73l-17-17L312 22.1l17 17 55 55L422.1 56l-3.8-3.8-17-17L435.2 1.3l17 17zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .7 .6 1 1L217 441l-7 7-9.9 0L97.9 448 52.2 493.8l-17 17L1.3 476.8l17-17L64 414.1 64 312l0-9.9 7-7 52.7-52.7 57 57L192 310.6 214.6 288l-11.3-11.3-57-57 41.4-41.4 57 57L256 246.6 278.6 224l-11.3-11.3-57-57z"]
};
const faCloudSun = {
  prefix: 'fass',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M121.3 0L104 104 0 121.3 60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96s96 43 96 96l0 1.1c18.4-10.7 39.8-16.8 62.5-17.1L416 121.3 312 104 294.7 0 208 60.7 121.3 0zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM639.9 511.9l0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 242.6 402.8 224 368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0 80 0z"]
};
const faShieldExclamation = {
  prefix: 'fass',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM280 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 320l0 48 48 0 0-48-48 0z"]
};
const faStopwatch20 = {
  prefix: 'fass',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M304 0L144 0l0 64 48 0 0 34.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1L445.3 144 400 98.7l-22.6 22.6L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l48 0 0-64zM288 204c28.7 0 52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-28.7 23.3-52 52-52zm-12 52l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12zM157.4 244c-5.5 0-10.6 3.1-13.1 8.1l-6.4 12.9-35.8-17.9 6.4-12.9c9.3-18.5 28.2-30.2 48.8-30.2c30.3 0 54.6 24.7 54.6 54.7c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9l43.8 0 20 0 0 40-20 0-64 0-20 0 0-20 0-15.7c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.9c0-8.2-6.6-14.7-14.6-14.7z"]
};
const faSquareFull = {
  prefix: 'fass',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
};
const faGripDots = {
  prefix: 'fass',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z"]
};
const faCommentExclamation = {
  prefix: 'fass',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM280 112l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 352l48 0 0-48-48 0 0 48z"]
};
const faPenSwirl = {
  prefix: 'fass',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M347.8 17C319.3 6 288.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512l32 0 0-64-32 0C150 448 64 362 64 256S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17zm96 199.1c2.7 12.9 4.2 26.2 4.2 39.9c0 53-43 96-96 96l-32 0 0 64 32 0c88.4 0 160-71.6 160-160c0-32.2-5.9-63-16.8-91.3l-51.4 51.4zM176 240L160 352l112-16L436.7 171.3l-96-96L176 240zM512 96L416 0 363.3 52.7l96 96L512 96z"]
};
const faFalafel = {
  prefix: 'fass',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M160 144l14.8-30.2-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L272 0l32 8.1L336 0l25.4 21.6 32.3 7 13.8 30.8 26.2 20.6-.6 33.8L448 144l-14.8 30.2 .4 24.5-1.6 .4-40.2-10.2-31.9 27-40.3 8.7L302.4 263 288 274.4 273.6 263 263 239.4l-6.6-14.8-15.8-3.4L216.1 216l-19.3-16.4-9.8-8.3-12.1-17.1L160 144zm73.8 108.5l5.5 12.4 8.2 18.4 22.6 17.9 .1 3.3 .4 26.1-11.4 23.3L252.4 368l6.9 14.1 11.4 23.3-.4 26.1-.1 3.3-22.6 17.9-13.8 30.8-32.3 7L176 512l-32-8.1L112 512 86.5 490.4l-32.3-7L40.4 452.7 14.3 432.1l.6-33.8L0 368l14.8-30.2-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L112 224l32 8.1 32-8.1 25.4 21.6 7.2 1.5 25.1 5.4zM256 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM508.6 412c16.2 4.4 35.2 5.9 52.8 .3l.3 19.8-26.2 20.6-13.8 30.8-32.3 7L464 512l-32-8.1L400 512l-25.4-21.6-32.3-7-13.8-30.8-26.2-20.6 .6-33.8L288 368l14.8-30.2-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L390 232.4c-8.2 19.2-7 40.8-2 58.9c7.1 26 23.3 52.6 45.7 74.9s48.9 38.6 74.9 45.7zM426.6 234.6c1.1-1.1 2.2-2.1 3.4-3c23.3-17.6 69.3-3.8 105.7 32.7c32.6 32.6 47.1 72.8 37.3 97.5c-1.7 4.4-4.2 8.3-7.5 11.6c-21.9 21.9-70.8 8.6-109.1-29.8s-51.7-87.2-29.8-109.1zM368 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faCircle2 = {
  prefix: 'fass',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM193.7 146.5c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 336l83.3 0 24 0 0 48-24 0-144 0-24 0 0-34.4 7.6-7.1L276.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3L206.5 197l-19.1 14.5-29.1-38.2 19.1-14.5 16.2-12.3z"]
};
const faMagnet = {
  prefix: 'fass',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M0 160l0 96C0 379.7 100.3 480 224 480s224-100.3 224-224l0-96-128 0 0 96c0 53-43 96-96 96s-96-43-96-96l0-96L0 160zm0-32l128 0 0-96L0 32l0 96zm320 0l128 0 0-96L320 32l0 96z"]
};
const faJar = {
  prefix: 'fass',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32 0L288 0l0 64L32 64 32 0zM0 96l320 0 0 416L0 512 0 96zM256 224L64 224l0 160 192 0 0-160z"]
};
const faGramophone = {
  prefix: 'fass',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M108.8 2.6l40.6 10.2 1.1 3.2c0 0 0 0 0 .1l.3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4L184 352l-24 0 0-48 24 0 110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-8.7-1.4-19-2.6-30.9-3l-1.3 0c-47.1-1.3-118.2 9.9-201.3 66.9c-2 1.3-3.9 2.7-5.9 4.1L29.2 303.4l3.6-13.5 72-272 4-15.3zM32 448l0-64 320 0 0 64 32 0 0 64-32 0L32 512 0 512l0-64 32 0z"]
};
const faDiceD12 = {
  prefix: 'fass',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M324.6 0L187.4 0 94.8 53.4 256 111 417.2 53.4 324.6 0zM447.9 76.4L272 139.3l0 106.8 108.8 54.4L505.4 176 447.9 76.4zM512 214.6L398.1 328.5 344.3 500.6l99.1-57.2L512 324.6l0-110zM307.2 512l57.4-183.8L256 273.9 147.3 328.2 204.8 512l102.5 0zM167.7 500.6L113.9 328.5 0 214.6l0 110L68.6 443.4l99.1 57.2zM6.6 176L131.2 300.5 240 246.1l0-106.8L64.1 76.4 6.6 176z"]
};
const faNoteSticky = {
  prefix: 'fass',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M448 32L0 32 0 480l288 0 0-128 0-32 32 0 128 0 0-288zm0 320l-45.3 0L352 352l-32 0 0 32 0 50.7 0 45.3 32-32 64-64 32-32z"]
};
const faStickyNote = faNoteSticky;
const faDown = {
  prefix: 'fass',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M192 480L384 288l0-32-128 0 0-224L128 32l0 224L0 256l0 32L192 480z"]
};
const faArrowAltDown = faDown;
const faHundredPoints = {
  prefix: 'fass',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8C168 61.9 201.9 32 242 32zm-15.5 77.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6c-7.9 0-14.5 5.9-15.5 13.7zm258 242l-448 64-9.1-63.4 448-64 9 63.4zm0 96l-224 32-9.1-63.4 224-32 9 63.4zM348.2 104.6C351.9 63.5 386.4 32 427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4zM427.7 96c-8.2 0-15 6.2-15.7 14.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2zM64.3 116.5l-3.7 1.6L31.2 131.2 6 72.8 35.4 59.7l56-24.9L135.7 68 101.2 309.5l-65.9 9.4 1-6.9L64.3 116.5z"]
};
const fa100 = faHundredPoints;
const faPaperclipVertical = {
  prefix: 'fass',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128l0 192c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160 0-32 64 0 0 32 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 208c0 61.9 50.1 112 112 112s112-50.1 112-112l0-176 0-32 64 0 0 32 0 176c0 97.2-78.8 176-176 176s-176-78.8-176-176l0-208z"]
};
const faWindWarning = {
  prefix: 'fass',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208L384 240l-64 0 0 128 64 0 34 0zM248 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zM200 320l0 48 48 0 0-48-48 0zM472 464l0-64 32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152 0-32 0 0-64 32 0 152 0c53 0 96 43 96 96s-43 96-96 96l-32 0-32 0zm72-224l-64.5 0c-1.4-22.2-5.6-43.7-12.3-64l76.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-32 0 0-64 32 0 32 0c53 0 96 43 96 96s-43 96-96 96z"]
};
const faWindCircleExclamation = faWindWarning;
const faLocationPinSlash = {
  prefix: 'fass',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M153.5 96.4L48.4 14.8 29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L457.5 332.4C488.3 282.6 512 231.4 512 192C512 86 426 0 320 0C248.8 0 186.6 38.8 153.5 96.4zM320 512s39.1-42.4 82.1-99.2L128.1 196.9C133.5 310 320 512 320 512z"]
};
const faMapMarkerSlash = faLocationPinSlash;
const faFaceSadSweat = {
  prefix: 'fass',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256l16-21.3 25.6 34.1L112 320c10.4 13.8 16 30.7 16 48c0 24.6-11.1 46.5-28.5 61.2C146.3 480.1 213.4 512 288 512zM79.3 404.4C89.5 395.6 96 382.5 96 368c0-10.4-3.4-20.5-9.6-28.8L68 314.7 48 288 36.4 303.5 9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48c12 0 22.9-4.4 31.3-11.6zm279.5 18.2l-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160l-11.3 11.3zM337.4 160L360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L337.4 160z"]
};
const faBugSlash = {
  prefix: 'fass',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M320 0c53 0 96 43 96 96l0 32-192 0 0-32c0-53 43-96 96-96zM477.6 348L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L235.4 160l199.3 0 54.6-54.6L512 82.7 557.3 128l-22.6 22.6L480 205.3l0 50.7 64 0 32 0 0 64-32 0-64 0c0 9.5-.8 18.9-2.4 28zM160 256l0-33.9L304 335.5l0 143.7c-34.5-3.4-65.8-17.8-90.3-39.6l-47.1 47.1L144 509.3 98.7 464l22.6-22.6L175 387.7c-9.6-20.6-15-43.5-15-67.7l-64 0-32 0 0-64 32 0 64 0zM336 479.2l0-118.5 94.8 74.7c-25.1 24.1-58.2 40.1-94.8 43.8z"]
};
const faCupcake = {
  prefix: 'fass',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M352 128l0 .8c3.3 .5 6.6 1.4 9.9 2.4l20.5 6.8c39.2 13.1 65.6 49.8 65.6 91.1l0 58.8L0 288l0-58.8c0-41.3 26.4-78 65.6-91.1l20.5-6.8c3.2-1.1 6.5-1.9 9.9-2.4l0-.8c0-35.3 28.7-64 64-64l49.3 0c17 0 30.7-13.7 30.7-30.7c0-6.1-1.8-12-5.2-17L224 0c70.7 0 128 57.3 128 128zM291.9 320l-24 192-87.8 0-24-192 135.8 0zM64 320l59.9 0 24 192L96 512 64 320zM300.1 512l24-192 59.9 0L352 512l-51.9 0z"]
};
const faLightSwitchOff = {
  prefix: 'fass',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M384 512L0 512 0 0 384 0l0 512zM96 416l192 0 0-320L96 96l0 320zm96 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 352l-128 0 0-128 128 0 0 128z"]
};
const faToggleLargeOff = {
  prefix: 'fass',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M320 128L64 128l0 256 256 0 0-256zm64 320l-64 0L64 448 0 448l0-64L0 128 0 64l64 0 256 0 64 0 128 0 64 0 0 64 0 256 0 64-64 0-128 0zm0-320l0 256 128 0 0-256-128 0z"]
};
const faPenFancySlash = {
  prefix: 'fass',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M324.2 351.4L288 448 95.7 503l88-88c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3l-88 88L128 288l78.4-29.4 117.8 92.8zm59.7-76.2l237 184 19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1l19 14.7L290.6 202.9 480 0l96 96L383.9 275.3z"]
};
const faTruckContainer = {
  prefix: 'fass',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M400 32l0 256L0 288 0 32l400 0zM96 80L64 80l0 160 32 0L96 80zm128 0l0 160 32 0 0-160-32 0zm-48 0l-32 0 0 160 32 0 0-160zm128 0l0 160 32 0 0-160-32 0zm128 80l24 0 88 0 9.9 0 7 7 72 72 7 7 0 9.9 0 32 0 96-33.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L432 384l-145.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-16 0-32 0-32 32 0 48 0 128 0 224 0 0-32 0-32 0-72 0-24zm48 96l102.1 0-48-48L480 208l0 48zm80 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM208 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faBoot = {
  prefix: 'fass',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M0 0L352 0l0 96L0 96 0 0zM0 480l0-32 512 0 0 32-32 32-64 0-32-32-32 32-64 0-32-32-32 32-64 0-32-32L96 512l-64 0L0 480zm0-64L0 128l320 0 0 32-48 0-16 0 0 32 16 0 48 0 0 32-48 0-16 0 0 32 16 0 48 0 192 48 0 112L0 416z"]
};
const faArrowUpFromWaterPump = {
  prefix: 'fass',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M288 0L64 0l0 256L0 256 0 415c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5l1.1-.8L96 368l18.6 13.4 1.1 .8s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 368l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3l0-159-96 0 0-130.7 25.4 25.4L528 173.3 573.3 128l-22.6-22.6-80-80L448 2.7 425.4 25.4l-80 80L322.7 128 368 173.3l22.6-22.6L416 125.3 416 256l-128 0L288 0zM272.4 493.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z"]
};
const faFileCheck = {
  prefix: 'fass',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M224 0L0 0 0 512l384 0 0-352-160 0L224 0zm32 0l0 128 128 0L256 0zm49 281L177 409l-17 17-17-17L79 345l-17-17L96 294.1l17 17 47 47L271 247l17-17L321.9 264l-17 17z"]
};
const faBone = {
  prefix: 'fass',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M149.3 136C127.2 97.7 78.3 84.6 40 106.7S-11.4 177.7 10.7 216c8.9 15.4 22.1 26.7 37.3 33.3l0 13.3c-15.1 6.6-28.4 17.9-37.3 33.3c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3l23.1-40 231.2 0 23.1 40c22.1 38.3 71 51.4 109.3 29.3s51.4-71 29.3-109.3c-8.9-15.4-22.1-26.7-37.3-33.3l0-13.3c15.1-6.6 28.4-17.9 37.3-33.3c22.1-38.3 9-87.2-29.3-109.3s-87.2-9-109.3 29.3l-23.1 40-231.2 0-23.1-40z"]
};
const faCardsBlank = {
  prefix: 'fass',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M464.9 365.4L210.9 512 0 146.7 254 0 464.9 365.4zM320 512l0-26 160.9-92.9 27.7-16-16-27.7L327.9 64 640 64l0 448-320 0z"]
};
const faCircle3 = {
  prefix: 'fass',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-384l24 0 0 34.6-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2l-25.2 0c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4l25.2 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1 0-34.7 7.8-7.1L250.3 176 184 176l-24 0 0-48 24 0 128 0z"]
};
const faBenchTree = {
  prefix: 'fass',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176l0 80-96 0 0 224 0 32-64 0 0-32 0-224-96 0 0-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM32 192l320 0 0 128L32 320l0-128zm0 160l64 0 192 0 64 0 32 0 0 64-32 0 0 64 0 32-64 0 0-32 0-64L96 416l0 64 0 32-64 0 0-32 0-64L0 416l0-64 32 0z"]
};
const faKeyboardBrightnessLow = {
  prefix: 'fass',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M288 128l0 64 64 0 0-64-64 0zM160 178.7L114.7 224 160 269.3 205.3 224 160 178.7zM128 352l-64 0 0 64 64 0 0-64zm96 0l-32 0 0 64 32 0 192 0 32 0 0-64-32 0-192 0zm352 0l-64 0 0 64 64 0 0-64zM480 178.7L434.7 224 480 269.3 525.3 224 480 178.7z"]
};
const faSkiBootSki = {
  prefix: 'fass',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M113.3 256L80 416l400 0 0-128L366 240l-46 0-16 0 0-32 16 0 52.7 0 10-48L336 160l-16 0 0-32 16 0 53.3 0L416 0 352 0l-6.7 32L288 32c0 1.1-.1 2.2-.3 3.3l-43.3 208L241.7 256l-13 0-115.3 0zm6.7-32l95.7 0 40-192L160 32 120 224zM640 416l0-32-64 0 0 32 0 32L32 448 0 448l0 64 32 0 576 0 32 0 0-32 0-64z"]
};
const faBrainCircuit = {
  prefix: 'fass',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M240 56l0-56L184 0c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1l56 0 0-56 0-184-64 0 0 50.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7 0-16 16 0 80 0 0-80-34.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l34.7 0 0-72zm32 104l0 192 34.7 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L272 384l0 72 0 56 56 0c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0L272 0l0 56 0 72 80 0 16 0 0 16 0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-18.7-64 0zM144 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z"]
};
const faTableCellsRowUnlock = {
  prefix: 'fass',
  iconName: 'table-cells-row-unlock',
  icon: [640, 512, [], "e691", "M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM64 224l0 64 88 0 0-64-88 0zm232 0l-88 0 0 64 88 0 0-64zM152 352l-88 0 0 64 88 0 0-64zm56 0l0 64 88 0 0-64-88 0zm288-80l0 48 32 0 32 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faUserInjured = {
  prefix: 'fass',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M240 80l102.7 0c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80l81.4 0 91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16L97 112c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM448 512L384 304l-227.7 0 48 80L336 384l16 0 0 16 0 112 96 0zm-204.3 0L181.5 408.2 118.9 304 96 304l0 208 147.7 0zm37.3 0l38.9 0 0-96-96.5 0 57.6 96zM0 512l64 0 0-208L0 512z"]
};
const faBlockBrickFire = {
  prefix: 'fass',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M128 32l0 80 256 0 0-80L128 32zM96 112l0-80L32 32l0 80 64 0zM32 144l0 96 208 0 0-96L32 144zm0 224l64 0 0-96-64 0 0 96zm0 32l0 80 208 0 0-80L32 400zm240 0l0 80 65 0c-20.2-22.5-35.1-49.8-42.9-80L272 400zM480 144l-2.6 0 2.6 2.6 0-2.6zm-208 0l0 96 51.2 0c6.2-9.8 12.9-19.1 19.7-27.7c23-28.8 49.5-52.3 71.4-68.3L272 144zM128 272l0 96 160.7 0c-.4-5.3-.7-10.7-.7-16.2c0-28.7 7.1-55.5 18-79.8l-178 0zM480 112l0-80-64 0 0 80 64 0zm-32 48c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-32 32-64-64zm96 240.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-48 64-96 64-96s64 48 64 96z"]
};
const faFirewall = faBlockBrickFire;
const faFaceSadTear = {
  prefix: 'fass',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 64l16 0c45 0 85.6 20.5 115.7 53.1l10.9 11.7-23.5 21.7-10.9-11.8c-25-27.1-57.4-42.9-92.3-42.9l-16 0 0-32zm-80-32l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L160 288zm207.6-80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSadTear = faFaceSadTear;
const faPlane = {
  prefix: 'fass',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L256 512l-96 0 54.9-192L112 320 64 384 0 384 32 256 0 128l64 0 48 64 102.9 0L160 0l96 0L365.7 192l116.6 0z"]
};
const faTentArrowsDown = {
  prefix: 'fass',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M209.9 136L176 102.1l-17 17-23 23L136 24l0-24L88 0l0 24 0 118.1L65 119l-17-17L14.1 136l17 17 64 64 17 17 17-17 64-64 17-17zM96 288L64 512l224 0 0-160 96 160 128 0L480 288 288 160 96 288zM545 153l17-17L528 102.1l-17 17-23 23L488 24l0-24L440 0l0 24 0 118.1-23-23-17-17L366.1 136l17 17 64 64 17 17 17-17 64-64z"]
};
const faExclamation = {
  prefix: 'fass',
  iconName: 'exclamation',
  icon: [128, 512, [10069, 10071, 61738], "21", "M96 64l0-32L32 32l0 32 0 256 0 32 64 0 0-32L96 64zm0 352l-64 0 0 64 64 0 0-64z"]
};
const faArrowsSpin = {
  prefix: 'fass',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M256 96c-11 0-21.7 1.1-32 3.2l0-64.9c10.5-1.5 21.1-2.3 32-2.3c57.8 0 110.5 21.9 150.2 57.8L448 48l16 16 0 128-128 0-16-16 40.9-40.9C332.8 110.8 296.1 96 256 96zM135.1 151.1C110.8 179.2 96 215.9 96 256c0 11 1.1 21.7 3.2 32l-64.9 0c-1.5-10.5-2.3-21.1-2.3-32c0-57.8 21.9-110.5 57.8-150.2L48 64 64 48l128 0 0 128-16 16-40.9-40.9zM477.7 224c1.5 10.5 2.3 21.1 2.3 32c0 57.8-21.9 110.5-57.8 150.2L464 448l-16 16-128 0 0-128 16-16 40.9 40.9C401.2 332.8 416 296.1 416 256c0-11-1.1-21.7-3.2-32l64.9 0zM256 416c11 0 21.7-1.1 32-3.2l0 64.9c-10.5 1.5-21.1 2.3-32 2.3c-57.8 0-110.5-21.9-150.2-57.8L64 464 48 448l0-128 128 0 16 16-40.9 40.9C179.2 401.2 215.9 416 256 416z"]
};
const faFaceSmileRelaxed = {
  prefix: 'fass',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM129.7 327.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zm89.5-89.6c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zm73.6 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z"]
};
const faCommentXmark = {
  prefix: 'fass',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M512 240c0 114.9-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L16 480 56.9 370.8C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208zM353.9 176L320 142.1l-17 17-47 47-47-47-17-17L158.1 176l17 17 47 47-47 47-17 17L192 337.9l17-17 47-47 47 47 17 17L353.9 304l-17-17-47-47 47-47 17-17z"]
};
const faCommentTimes = faCommentXmark;
const faPrint = {
  prefix: 'fass',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M96 0L368 0l13.3 0 9.4 9.4 48 48 9.4 9.4L448 80l0 80-64 0 0-66.7L354.7 64 128 64l0 96-64 0L64 32 64 0 96 0zM64 384L0 384 0 192l512 0 0 192-64 0 0 96 0 32-32 0L96 512l-32 0 0-32 0-96zm64 0l0 64 256 0 0-64 0-32-256 0 0 16 0 16zM408 248l0 48 48 0 0-48-48 0z"]
};
const faTurkishLiraSign = {
  prefix: 'fass',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M128 32l0 32 0 36.6L246.9 65.3l30.7-9.1 18.2 61.4-30.7 9.1L128 167.3l0 29.2 118.9-35.2 30.7-9.1 18.2 61.4-30.7 9.1L128 263.3 128 416l64 0c70.7 0 128-57.3 128-128l0-32 64 0 0 32c0 106-86 192-192 192l-96 0-32 0 0-32 0-165.7-14.9 4.4-30.7 9.1L.2 234.4l30.7-9.1L64 215.5l0-29.2-14.9 4.4-30.7 9.1L.2 138.4l30.7-9.1L64 119.5 64 64l0-32 64 0z"]
};
const faTry = faTurkishLiraSign;
const faTurkishLira = faTurkishLiraSign;
const faFaceNoseSteam = {
  prefix: 'fass',
  iconName: 'face-nose-steam',
  icon: [576, 512, [], "e382", "M530.2 339.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4c23.3-23.3 60.1-24.9 85.3-4.7l56.5-33.9L220 284l38.2 38.2-8.6 14.3L215.8 393c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-33.9-56.5-8.2-13.7 38.4-38.4 13.7 8.2L425 327.3c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-12-12-31.2-12.5-43.8-1.4c-.5 .5-1 .9-1.5 1.4c-3.8 3.8-6.4 8.2-7.9 13c-.2 .8-.5 1.6-.6 2.4l-2.6-1.6-20.9-12.5-4.6-2.8L352 320.9l32.2 53.7 2.8 4.6 14.1 23.5c-5.6 1.3-10.9 4.2-15.3 8.5c-4.7 4.7-7.6 10.4-8.8 16.4c-.5 2.4-.7 4.8-.6 7.2c.2 7.9 3.4 15.7 9.4 21.7c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.5 3.2-2.5 6.7-2.9 10.1c-.2 1.8-.3 3.7-.2 5.6c0 .5 .1 .9 .1 1.4c.7 7.1 3.8 14 9.2 19.4c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5c0 0 0 0 0 0zM174.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c.3-.1 .6-.1 1-.2c4.8-1.1 9.4-3.3 13.4-6.7c.7-.6 1.4-1.2 2-1.8c1.5-1.5 2.8-3.1 4-4.8c8-11.9 7.1-27.9-2.5-38.9l-.1-.1c-.4-.5-.9-1-1.3-1.4c-4.4-4.4-9.7-7.2-15.3-8.5l14.1-23.5 2.8-4.6L222.2 320l-53.7 32.2-4.6 2.8-23.5 14.1c-.1-.4-.2-.7-.3-1c-1.4-5.2-4.2-10.2-8.3-14.3c-.5-.5-1-1-1.5-1.4c-12.6-11.1-31.7-10.6-43.8 1.4c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2c-14.4 18.8-13.1 45.9 4.2 63.1s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM144 224l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm192 0l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm85.1-80.8c-35.5 11.8-64.4 34.8-73.7 44.1L336 198.6l-11.3-11.3s0 0 0 0s0 0 0 0L313.4 176l11.3-11.3c12-12 45-38.1 86.3-51.9l15.2-5.1 5.1 15.2 5.1 15.2-15.2 5.1zm-281.3-5.1l10.1-30.4 15.2 5.1c41.3 13.8 74.2 39.9 86.3 51.9L262.6 176 240 198.6l-11.3-11.3c-9.3-9.3-38.2-32.3-73.7-44.1l-15.2-5.1z"]
};
const faCircleWaveformLines = {
  prefix: 'fass',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368l0 224 0 16-32 0 0-16 0-224 0-16 32 0 0 16zM160 176l0 160 0 16-32 0 0-16 0-160 0-16 32 0 0 16zm192 24l0 112 0 16-32 0 0-16 0-112 0-16 32 0 0 16zM224 216l0 80 0 16-32 0 0-16 0-80 0-16 32 0 0 16zm192 24l0 32 0 16-32 0 0-16 0-32 0-16 32 0 0 16z"]
};
const faWaveformCircle = faCircleWaveformLines;
const faDollarSign = {
  prefix: 'fass',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M192 0l0 32 0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8 31.5 5.8-11.5 63-31.5-5.8-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4 0 32-64 0 0-32 0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3l-29.2-13 26-58.5 29.2 13c20.9 9.3 55.3 18.4 75.2 21.6c10.7 1.6 20.8 2.3 30.2 2.4l.6 0c18.2 0 33.6-2.9 45.3-7.6c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32l0-32 64 0z"]
};
const faDollar = faDollarSign;
const faUsd = faDollarSign;
const faFerrisWheel = {
  prefix: 'fass',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M304 0L208 0l0 37.2c-24.2 5.3-46.9 14.5-67.4 26.8L64 64l0 48 0 28.6C51.6 161.1 42.4 183.8 37.2 208L0 208l0 48c0 22.7 15.7 41.7 36.9 46.7c5.2 24.7 14.5 47.8 27.1 68.7L64 400c0 25.5 19.8 46.3 44.9 47.9L160 352l-32 0c-15.5-20.7-26.2-45.3-30.2-72l81.9 0c-2.4-7.6-3.7-15.6-3.7-24s1.3-16.4 3.7-24l-81.9 0c4-26.3 14.3-50.4 29.4-70.9L185.1 219c7.6-14.5 19.5-26.4 33.9-33.9l-57.9-57.9c20.5-15.1 44.6-25.4 70.9-29.4l0 81.9c7.6-2.4 15.6-3.7 24-3.7s16.4 1.3 24 3.7l0-81.9c26.3 4 50.4 14.3 70.9 29.4L293 185.1c14.5 7.6 26.4 19.5 33.9 33.9l57.9-57.9c15.1 20.5 25.4 44.6 29.4 70.9l-81.9 0c2.4 7.6 3.7 15.6 3.7 24s-1.3 16.4-3.7 24l81.9 0c-4 26.7-14.7 51.3-30.2 72l-32 0 51.1 95.9c25-1.6 44.9-22.4 44.9-47.9l0-28.6c12.6-20.9 21.9-44.1 27.1-68.7c21.1-5 36.9-24 36.9-46.7l0-48-37.2 0c-5.3-24.2-14.5-46.9-26.8-67.4L448 64l-76.6 0C350.9 51.6 328.2 42.4 304 37.2L304 0zm0 256c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.6 7.5 29.5 19 38.3L128 480l0 32 256 0 0-32L285 294.3c11.6-8.8 19-22.7 19-38.3z"]
};
const faComputerSpeaker = {
  prefix: 'fass',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M288 480l0-64-160 0-32 0 0 64 32 0 160 0zM64 32L0 32 0 96 0 320l0 64 64 0 224 0 0-64L64 320 64 96l224 0 0-64L64 32zm576 0L320 32l0 448 320 0 0-448zM544 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm64-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSkullCow = {
  prefix: 'fass',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M0 95.5C0 166.1 57.2 224 128 224l0-96-23 0c-28.7 0-52.7-21.7-55.6-50.3c-1.6-16 5.3-35.5 11.1-51.8C61.8 22.4 63 19.1 64 16L40 0C19 26.2 0 61 0 95.5zM512 224c70.8 0 128-57.9 128-128.5C640 61 621 26.2 600 0L576 16c1 3.1 2.2 6.4 3.4 9.9c0 0 0 0 0 0c5.8 16.4 12.7 35.8 11.1 51.8C587.7 106.3 563.7 128 535 128l-23 0 0 96zM480 96L160 96l0 272 60 0 36 144 128 0 36-144 60 0 0-272zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faX = {
  prefix: 'fass',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M306.2 32l77.5 0-1.4 2L230.7 256 382.3 478l1.4 2-77.5 0L192 312.8 77.8 480 .3 480l1.4-2L153.3 256 1.7 34 .3 32l77.5 0L192 199.2 306.2 32z"]
};
const faMagnifyingGlassDollar = {
  prefix: 'fass',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228.1 112l0-20.1-40.2 0 0 20.1 0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0s0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4 0 20.1 40.2 0 0-20.1 0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.4-3.2-21-4.4l0-6.3z"]
};
const faSearchDollar = faMagnifyingGlassDollar;
const faUsersGear = {
  prefix: 'fass',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM196 192L48 192 0 320l235.3 0c-26.6-23.5-43.3-57.8-43.3-96c0-11 1.4-21.8 4-32zm418.1 59.1L592 192l-148 0c2.6 10.2 4 21 4 32l32 0 64 0 32 0 0 32 0 17.1s0 0 0 0l14.8-8.6 23.3-13.5zM320 128c-53 0-96 43-96 96s43 96 96 96c19.9 0 38.3-6 53.7-16.4l15.8-27.3 16-27.7 6.3 3.7c2.7-8.9 4.2-18.4 4.2-28.2c0-53-43-96-96-96zm25.7 224L176 352 128 512l273.1 0-11.7-20.3-32-55.4-16-27.7 27.7-16L384 384l-14.9-8.6-27.7-16 4.3-7.4zM544 293.5l0-37.5-64 0 0 37.5c-11.2 4-21.5 10-30.4 17.6l-32.5-18.7-32 55.4 32.5 18.7c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-32.5 18.7 32 55.4L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6l0 37.5 64 0 0-37.5c11.2-4 21.5-10 30.4-17.6l32.5 18.7 32-55.4-32.5-18.7c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l32.5-18.7-32-55.4L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faUsersCog = faUsersGear;
const faPersonMilitaryPointing = {
  prefix: 'fass',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M416 1.4l-192 16 0 48 192 0 0-64zm-176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l-156.8 0c-1 5.2-1.6 10.5-1.6 16zM72 225.4l-40 0 0 80 40 0 152 0 0 89.4L393.4 225.4l-153.4 0-168 0zm356.7 9.9L246.6 417.4l169.4 0 0-46.3 53.6 90.6 20.3 34.4 68.9-40.7L538.4 421l-104-176-5.7-9.7zM224 449.4l0 64 192 0 0-64-192 0z"]
};
const faBuildingColumns = {
  prefix: 'fass',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M0 144L256 0 512 144l0 48L0 192l0-48zM0 512l0-48 64-48 0-192 64 0 0 192 40 0 0-192 64 0 0 192 48 0 0-192 64 0 0 192 40 0 0-192 64 0 0 192 64 48 0 48L0 512zM256 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBank = faBuildingColumns;
const faInstitution = faBuildingColumns;
const faMuseum = faBuildingColumns;
const faUniversity = faBuildingColumns;
const faCircleT = {
  prefix: 'fass',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144l104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48 24 0z"]
};
const faSack = {
  prefix: 'fass',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M192 96l128 0L384 0 128 0l64 96zm128 32l-128 0c-3.8 2.5-8.1 5.3-13 8.4c0 0 0 0 0 0s0 0 0 0C122.3 172.7 0 250.9 0 416l0 96 96 0 320 0 96 0 0-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4z"]
};
const faGrid2 = {
  prefix: 'fass',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M224 32L32 32l0 192 192 0 0-192zm0 256L32 288l0 192 192 0 0-192zM288 32l0 192 192 0 0-192L288 32zM480 288l-192 0 0 192 192 0 0-192z"]
};
const faCameraCctv = {
  prefix: 'fass',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M128 0L0 224l177.9 71.2L137.9 400 64 400l0-16 0-32L0 352l0 32 0 48 0 48 0 32 64 0 0-32 0-16 96 0 22.1 0 7.9-20.6 47.4-124.5L320 352l61-41.9 113.3-77.9L576 176 128 0zM387.7 344.3L520 400l56-136-45.7-17.8L387.7 344.3z"]
};
const faCctv = faCameraCctv;
const faUmbrella = {
  prefix: 'fass',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M320 0l0 32 0 17.7C451.8 63.4 557.7 161 573.9 285.9l2.3 18.1L558 304l-6.5 0-7.2 0-4.8-5.3C525 282.3 503.7 272 480 272c-44.2 0-80 35.8-80 80l-16 0-16 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l-16 0-16 0c0-44.2-35.8-80-80-80c-23.7 0-45 10.3-59.6 26.7L31.6 304l-7.2 0L18 304-.2 304l2.3-18.1C18.3 161 124.2 63.4 256 49.7L256 32l0-32 64 0zM256 316.2c8.5-7.6 19.7-12.2 32-12.2s23.5 4.6 32 12.2l0 114.3c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7-14.3-28.6 57.2-28.6 14.3 28.6 2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4l0-114.3z"]
};
const faTrowel = {
  prefix: 'fass',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M376 232l-25.4-25.4-112 112L320 400l-40 40L0 512 72 232l40-40 81.4 81.4 112-112L280 136 416 0l96 96L376 232z"]
};
const faHorizontalRule = {
  prefix: 'fass',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 224l32 0 576 0 32 0 0 64-32 0L32 288 0 288l0-64z"]
};
const faBedFront = {
  prefix: 'fass',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M32 32l448 0 0 160-32 0-16 0 0-64-160 0 0 64-32 0 0-64L80 128l0 64-16 0-32 0L32 32zM0 224l32 0 448 0 32 0 0 32 0 192 0 32-64 0 0-32 0-32L64 416l0 32 0 32L0 480l0-32L0 256l0-32z"]
};
const faBedAlt = faBedFront;
const faD = {
  prefix: 'fass',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M0 32l32 0 128 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L32 480 0 480l0-32L0 64 0 32zM64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L64 96z"]
};
const faStapler = {
  prefix: 'fass',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M640 240l0 64 0 176-96 0-96 0L32 480l0-64 416 0 0-48-320 0-64 0 0-64 0-84.6L0 208l52.1-95.6c27-49.6 79-80.4 135.4-80.4c24 0 47.6 5.6 69 16.3L640 240zm-512-9.1l0 73.1 320 0 0-16L128 230.9z"]
};
const faMasksTheater = {
  prefix: 'fass',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M27.7 286.7C64 426.6 240.9 448 240.9 448s6.1-3.2 15.9-9.1c-28.3-37.1-50.5-85.4-48.7-144.6c-27.7 5.7-51.7 20.3-69.4 40.5c-3.3-43.1 26.6-82.1 69.1-88.6c2.4-.4 4.8-.6 7.2-.8L236.3 99.8l1.1-7.4 4.2-6.1 26.4 18.2L240.1 294.1C234.8 438.6 398.4 512 398.4 512s195.3-34.9 213.8-161.3L640 161.1s-21.7-67.9-176.8-91.5s-195.3 34.9-195.3 34.9c-26.4-18.2-26.3-18.2-26.3-18.2s0 0 0-.1l.1-.1 .2-.2 .4-.5c.3-.4 .6-.8 1-1.3c.8-1 1.7-2.1 2.9-3.5c2.4-2.7 5.7-5.9 10.1-9.5c8.7-7.2 21.5-15.5 39.4-22.6c17.8-7.1 40.3-12.8 68.4-15.2c-16.8-14.9-67.9-46-187.8-27.6C21.7 29.2 0 97.1 0 97.1L27.7 286.7zM171.2 146.9c1.8 3.7 3.1 7.7 3.7 12.1c3.2 21.8-11.5 42.1-32.9 45.4s-41.2-11.8-44.4-33.6c-.6-4.3-.6-8.6 .1-12.6c11.4 6.2 24.8 8.8 38.5 6.7s25.8-8.6 34.9-18zM411.9 244c-9.2-9.3-21.2-15.9-35-18s-27.2 .5-38.6 6.7c-.7-4.1-.8-8.3-.1-12.6c3.2-21.8 23.1-36.9 44.6-33.6s36.2 23.6 33 45.4c-.6 4.3-1.9 8.4-3.7 12.1zm127.8 6.8c-.6 4.3-1.9 8.4-3.7 12.1c-9.2-9.3-21.2-15.9-35-18s-27.2 .5-38.6 6.7c-.7-4.1-.8-8.3-.1-12.6c3.2-21.8 23.1-36.9 44.6-33.6s36.2 23.6 33 45.4zM535.6 331c-12.4 56.8-66 94.9-123.3 86.2s-97.6-61.2-93.2-119.2c25.8 29.2 61.4 49.7 102.5 56s81-2.8 114-23z"]
};
const faTheaterMasks = faMasksTheater;
const faFileGif = {
  prefix: 'fass',
  iconName: 'file-gif',
  icon: [512, 512, [], "e645", "M0 0L224 0l0 160 160 0 0 144-208 0 0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM224 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 16-32 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8-16 0 0-32 16 0 16 0 16 0 0 16 0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm160-24l0 128 0 16-32 0 0-16 0-128 0-16 32 0 0 16zm48-16l48 0 16 0 0 32-16 0-32 0 0 32 32 0 16 0 0 32-16 0-32 0 0 48 0 16-32 0 0-16 0-64 0-64 0-16 16 0z"]
};
const faKipSign = {
  prefix: 'fass',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M128 322.9L128 448l0 32-64 0 0-32 0-160-32 0L0 288l0-64 32 0 32 0L64 64l0-32 64 0 0 32 0 125.1 195.9-158 40.2 49.8L186.7 224 352 224l32 0 0 64-32 0-165.3 0L364.1 431.1l-40.2 49.8L128 322.9z"]
};
const faFaceWoozy = {
  prefix: 'fass',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7-13.3-8.9 17.8-26.6 13.3 8.9 11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3L400 313.4 422.6 336l-11.3 11.3zM214.2 107.6l-8.9 13.3c-28 42-69.6 64.1-88.3 70.3l-15.2 5.1L91.8 165.9l15.2-5.1c13.4-4.5 48.5-22.9 71.7-57.7l8.9-13.3 26.6 17.8zm5.5 97l7.8 31-15.5 3.9-64 16-15.5 3.9-7.8-31 15.5-3.9 64-16 15.5-3.9zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
const faCloudQuestion = {
  prefix: 'fass',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M144 480L0 480 0 336c0-62.7 40.1-116 96-135.8l0-8.2c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96l0 36c55.2 14.2 96 64.3 96 124l0 128-128 0-368 0zm88-264l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L296 268.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L288 160c-30.9 0-56 25.1-56 56zm64 152l0 48 48 0 0-48-48 0z"]
};
const faPineapple = {
  prefix: 'fass',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M512 96l-40 40 24 24-57.1 22.9L448 192l0 128L256 512l-128 0L0 384 0 256 192 64l128 0 9.1 9.1L352 16l24 24L416 0l10 30 70-14L482 86l30 10zM176 201.4L153.4 224l11.3 11.3 32 32L208 278.6l11.3-11.3 32-32L262.6 224 240 201.4l-11.3 11.3L208 233.4l-20.7-20.7L176 201.4zm-80 80L73.4 304l11.3 11.3 32 32L128 358.6l11.3-11.3 32-32L182.6 304 160 281.4l-11.3 11.3L128 313.4l-20.7-20.7L96 281.4zm160 0L233.4 304l11.3 11.3 32 32L288 358.6l11.3-11.3 32-32L342.6 304 320 281.4l-11.3 11.3L288 313.4l-20.7-20.7L256 281.4zm-80 80L153.4 384l11.3 11.3 32 32L208 438.6l11.3-11.3 32-32L262.6 384 240 361.4l-11.3 11.3L208 393.4l-20.7-20.7L176 361.4z"]
};
const faHandPointLeft = {
  prefix: 'fass',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M0 96l0 64 240 0 0-64L0 96zM160 288l0 64 128 0 0-64-128 0zm-32-32l112 0 0-64-112 0 0 64zm64 128l0 64 128 0 0-64-128 0zM363 64l-91 0 0 192 48 0 32 0 0-96 0-16 32 0 0 16 0 112 0 16-16 0-48 0 0 64 32 0 0 96c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64z"]
};
const faGalleryThumbnails = {
  prefix: 'fass',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 64l0 224L64 288 64 64l448 0zM64 0L0 0 0 64 0 288l0 64 64 0 448 0 64 0 0-64 0-224 0-64L512 0 64 0zM0 416l0 96 96 0 0-96L0 416zm256 0l-96 0 0 96 96 0 0-96zm64 0l0 96 96 0 0-96-96 0zm256 0l-96 0 0 96 96 0 0-96z"]
};
const faCircleJ = {
  prefix: 'fass',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360l0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24 48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0 0 24z"]
};
const faEyes = {
  prefix: 'fass',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M96 224c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64zm224-97.3c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zm54.4 224.6c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z"]
};
const faHandshakeSimple = {
  prefix: 'fass',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M298.8 64L224 64l-96 64L0 128 0 352l156.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 44.8-48.9 35.2 32.2 64.9-70.8-35.4-32.4-134.2-123-96.4 75-13 10.1-9.7-13.4-64-88-8.9-12.3 11.8-9.6L298.8 64zm74.1 124.9L550.2 352l89.8 0 0-224-48 0-76 0-4 0-1.4 0-4.3-3.3L426.6 64l-76.9 0L197.9 186.9l45.3 62.3 131-101.9 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2z"]
};
const faHandshakeAlt = faHandshakeSimple;
const faPageCaretUp = {
  prefix: 'fass',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M384 112l0 400L0 512 0 0 272 0 384 112zM96 320l192 0 0-32-96-96L96 288l0 32z"]
};
const faFileCaretUp = faPageCaretUp;
const faJetFighter = {
  prefix: 'fass',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M160 0l24 0L296 0l24 0 0 48-24 0-24 0L384 192l128 0 128 48 0 32L512 320l-128 0L272 464l24 0 24 0 0 48-24 0-112 0-24 0 0-48 24 0 8 0 0-144-32 0L96 384l-64 0 0-96c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-96 64 0 64 64 32 0 0-144-8 0-24 0 0-48zM80 240l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z"]
};
const faFighterJet = faJetFighter;
const faComet = {
  prefix: 'fass',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M512 0L299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L496 208l-59.9 4.6L512 0zM231.6 275.8L320 288.5 256 350l15.1 86.8-79.1-41-79.1 41L128 350 64 288.5l88.4-12.7 39.6-79 39.6 79z"]
};
const faSquareShareNodes = {
  prefix: 'fass',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M448 32L0 32 0 480l448 0 0-448zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"]
};
const faShareAltSquare = faSquareShareNodes;
const faReflectVertical = {
  prefix: 'fass',
  iconName: 'reflect-vertical',
  icon: [512, 512, [], "e665", "M0 232l0 48 24 0 464 0 24 0 0-48-24 0L24 232 0 232zM416 480L256 320 96 480l0 32 320 0 0-32zM256 192L416 32l0-32L96 0l0 32L256 192z"]
};
const faShieldKeyhole = {
  prefix: 'fass',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M256 5.7l11.5 4.4L475 90.2l19.2 7.4 1.2 20.6c2.9 49.7-4.9 125.6-37.3 199.8C425.4 392.8 367 467.1 268.6 509.4L256 514.8l-12.6-5.4C145 467.1 86.6 392.8 53.9 318C21.4 243.7 13.6 167.8 16.6 118.1l1.2-20.6L37 90.2l207.5-80L256 5.7zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4 0 24 48 0 0-24 0-69.4c18.9-9 32-28.3 32-50.6z"]
};
const faFileMp4 = {
  prefix: 'fass',
  iconName: 'file-mp4',
  icon: [512, 512, [], "e649", "M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0zM384 128l-128 0L256 0 384 128zM256 368l0 128 0 16-32 0 0-16 0-74.2-17.9 33.7-13.9 26.2-14.3-26L160 423l0 73 0 16-32 0 0-16 0-128 0-16 16 0 4 0 9.5 0 4.6 8.3 29.7 54 28.5-53.8 4.5-8.5 9.6 0 5.6 0 16 0 0 16zm48-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32 0 16-32 0 0-16 0-48 0-80 0-16 16 0zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm80 16l0-16 0-64 0-16 32 0 0 16 0 48 32 0 0-48 0-16 32 0 0 16 0 64 0 64 0 16-32 0 0-16 0-48-48 0-16 0z"]
};
const faBarcode = {
  prefix: 'fass',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M64 32L0 32 0 480l64 0L64 32zm64 0L96 32l0 448 32 0 0-448zm96 0l-64 0 0 448 64 0 0-448zm96 0l-64 0 0 448 64 0 0-448zm128 0l0 448 64 0 0-448-64 0zm-64 0l0 448 32 0 0-448-32 0z"]
};
const faBulldozer = {
  prefix: 'fass',
  iconName: 'bulldozer',
  icon: [640, 512, [], "e655", "M32 32l32 0 128 0 19.8 0 8.8 17.7L291.8 192l28.2 0 0-64 0-32 64 0 0 32 0 64 64 0 0 96 64 0 0-64 0-11.2 7-8.8 64-80 50 40-57 71.2 0 52.8 0 64 0 50.7 54.6 54.6-45.3 45.3-64-64-9.4-9.4 0-13.3 0-64-42.8 0c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400c0-30.5 12.2-58.2 32-78.4L32 256l0-64L32 64l0-32zm80 320c-26.5 0-48 21.5-48 48s21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0zM172.2 96L96 96l0 96 124.2 0-48-96zM120 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faPlusMinus = {
  prefix: 'fass',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M224 32l0-32L160 0l0 32 0 112L48 144l-32 0 0 64 32 0 112 0 0 112 0 32 64 0 0-32 0-112 112 0 32 0 0-64-32 0-112 0 0-112zM32 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z"]
};
const faSquareSlidersVertical = {
  prefix: 'fass',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M0 32l448 0 0 448L0 480 0 32zM176 96l-64 0 0 32 0 32-16 0-32 0 0 64 32 0 16 0 0 160 0 32 64 0 0-32 0-160 16 0 32 0 0-64-32 0-16 0 0-32 0-32zm160 32l0-32-64 0 0 32 0 160-16 0-32 0 0 64 32 0 16 0 0 32 0 32 64 0 0-32 0-32 16 0 32 0 0-64-32 0-16 0 0-160z"]
};
const faSlidersVSquare = faSquareSlidersVertical;
const faVideo = {
  prefix: 'fass',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M384 64L0 64 0 448l384 0 0-384zM576 448l0-384L416 174.9l0 162.3L576 448z"]
};
const faVideoCamera = faVideo;
const faMessageMiddle = {
  prefix: 'fass',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M338.3 416L512 416 512 0 0 0 0 416l173.7 0L256 512l82.3-96z"]
};
const faCommentMiddleAlt = faMessageMiddle;
const faGraduationCap = {
  prefix: 'fass',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M640 176L320 288 127.8 220.7l198.1-77.8 14.9-5.9L329 107.3l-14.9 5.9-224 88-8.7 3.4L80 204l0 142.8c15.4 25.1 27.8 68.4 0 133.2L0 464s32.5-46.5 48-96.9l0-174.3L0 176l0-32L320 32 640 144l0 32zM143.6 260.2l165.9 58.1 10.6 3.7 10.6-3.7 165.9-58.1L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8z"]
};
const faMortarBoard = faGraduationCap;
const faHandHoldingMedical = {
  prefix: 'fass',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M224 0l0 80-80 0 0 96 80 0 0 80 96 0 0-80 80 0 0-96-80 0 0-80L224 0zM140 327L68.8 384 0 384 0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7z"]
};
const faPersonCircleCheck = {
  prefix: 'fass',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 66.4 104c-15.5 16.3-28 35.7-36.3 57l-2.3 1.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z"]
};
const faSquareZ = {
  prefix: 'fass',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M448 32L0 32 0 480l448 0 0-448zM336 160.8l-5.7 6.7L187.7 336 312 336l24 0 0 48-24 0-176 0-24 0 0-32.8 5.7-6.7L260.3 176 136 176l-24 0 0-48 24 0 176 0 24 0 0 32.8z"]
};
const faMessageText = {
  prefix: 'fass',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM168 112l-24 0 0 48 24 0 64 0 0 136 0 24 48 0 0-24 0-136 64 0 24 0 0-48-24 0-88 0-88 0z"]
};
const faCommentAltText = faMessageText;
const faTurnUp = {
  prefix: 'fass',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M192 0L352 160l0 32-112 0 0 320L0 512l0-96 144 0 0-224L32 192l0-32L192 0z"]
};
const faLevelUpAlt = faTurnUp;
var icons = {
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt
};

export { icons as fass, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashCan, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faBuildingMemo, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faArrowsRotateReverse, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faExcavator, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faReflectBoth, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faTableCellsUnlock, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faFileMp3, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faSignPost, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faTruckUtensils, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faCircleExclamation, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faUserBeardBolt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faGlobePointer, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faUsers, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faTurnRight, faFolderBookmark, faArrowTurnLeftDown, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faFileMov, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFileVector, faFaceFrownOpen, faFrownOpen, faSquareDashed, faBagShoppingPlus, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faRaccoon, faHandPointDown, faArrowUpFromBracket, faHeadSideGear, faTrashPlus, faFileCad, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faRotateReverse, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faArrowLeftToBracket, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faPersonDressFairy, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faSignPosts, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faArrowDownFromBracket, faXRay, faGoalNet, faCoffinCross, faOctopus, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faCannon, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFilePng, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faThumbtackSlash, faThumbTackSlash, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faTableCellsLock, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faArrowUpToArc, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faCaduceus, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faSwapArrows, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faSubtitles, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faImage, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faLocationArrowUp, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faCheckCircle, faSquareDashedCirclePlus, faHandHoldingCircleDollar, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faArrowUpToBracket, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faUpToBracket, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faHydra, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faFileJpg, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faWavesSine, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faMagnifyingGlassArrowsRotate, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faWave, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faTicketPerforated, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faTableCellsColumnLock, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faTicketsSimple, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faDiamonds4, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileXls, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faTickets, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faHammerBrush, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faSignPostsWrench, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faLeftToBracket, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faArrowTurnLeft, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faQuestionCircle, faTicketsPerforated, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faBasketShoppingPlus, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faArrowTurnRight, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faTicketPerforatedPlane, faTicketPlane, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faWebAwesome, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faLeftFromBracket, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faChartKanban, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faFileXml, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faArrowLeftFromBracket, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faBagShoppingMinus, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faTruckFire, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faTruckLadder, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faBottleBaby, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleWifiCircleWifi, faCircleWifiGroup, faCircleNodes, faParachuteBox, faReflectHorizontal, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faFileEps, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faMusicMagnifyingGlass, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faTurnLeftUp, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faSlidersH, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faLightbulbMessage, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faSwap, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faAnglesUpDown, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faCourtSport, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faTableCellsColumnUnlock, faPersonSimple, faArrowTurnLeftUp, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faTurnLeftDown, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faTicketsPerforatedPlane, faTicketsPlane, faTentDoublePeak, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faGlobeWifi, faEnvelopeDot, faEnvelopeBadge, faMagnifyingGlassWaveform, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faPersonFairy, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faFilePpt, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faTRex, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faCircleWifi, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faFileSvg, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faLandmarkMagnifyingGlass, faGrillHot, faBallotCheck, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faTableCellsRowLock, faRupiahSign, faMagnifyingGlass, faSearch, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faUserHoodie, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faMagnifyingGlassPlay, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faXmark, faClose, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faDownFromBracket, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faBuildingMagnifyingGlass, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faArrowLeftFromArc, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faCircleGf, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faFolderCheck, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faArrowLeftToArc, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faAnt, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faSubtitlesSlash, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faMagnifyingGlassMusic, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faLighthouse, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faSpinnerScale, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faBasketShoppingMinus, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faTurnLeft, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faBellRing, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faCircleXmark, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faArrowDownFromArc, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faStickyNote, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faTableCellsRowUnlock, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faFileGif, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faReflectVertical, faShieldKeyhole, faFileMp4, faBarcode, faBulldozer, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt };
